/**
 * This file was auto-generated
 * Do not edit manually
 */

import type { Translations } from './i18n-types'
import {
	Amount,
	DateInput,
	TranslationAmount,
	agoFormatter,
	amountFormatter,
	amountOnlyFormatter,
	amountWithCodeFormatter,
	dateAndTimeFormatter,
	monthAndYearFormatter,
	monthFormatter,
	plural,
	relativeFormatter,
	shortDateAndTimePreciseFormatter,
	shortFormatter,
	shortWithDateFormatter,
	weightFormatter
} from './i18n-util'

export const en = {
	LocaleName: () => 'English',
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('en', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('en', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('en', arg1),
		OnlyAmount: (arg0: TranslationAmount) => amountOnlyFormatter('en', arg0)
	},
	Quantity: {
		Pieces: (arg0: number) => String(arg0) + 'x'
	},
	Weight: (arg0: Amount) => weightFormatter('en', arg0),
	Date: {
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('en', arg0),
		Short: (arg0: DateInput) => shortFormatter('en', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('en', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('en', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('en', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('en', arg0),
		Ago: (arg0: DateInput) => agoFormatter('en', arg0, () => locales['en'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('en', arg0)
	},
	TimeAgo: {
		JustNow: () => 'just now',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'minute', other: 'minutes' }) + ' ago',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'hour', other: 'hours' }) + ' ago',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'day', other: 'days' }) + ' ago',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'month', other: 'months' }) + ' ago',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'year', other: 'years' }) + ' ago'
	},
	Enum: {
		PaymentStatus: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Pending'
					case 'UNPAID':
						return 'Unpaid'
					case 'PAID':
						return 'Paid'
					case 'PARTIALLY_PAID':
						return 'Partially paid'
					case 'REFUNDED':
						return 'Refunded'
					case 'PARTIALLY_REFUNDED':
						return 'Partially refunded'
					case 'OVERPAID':
						return 'Overpaid'
					default:
						return String(v)
				}
			})(arg0),
		OrderStatus: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Completed'
					case 'CANCELED':
						return 'Cancelled'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentStatus: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Not fulfilled'
					case 'FULFILLED':
						return 'Fulfilled'
					case 'NOT_NEEDED':
						return 'Not needed'
					case 'PARTIALLY_FULFILLED':
						return 'Partially fulfilled'
					default:
						return String(v)
				}
			})(arg0),
		TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
			(v => {
				switch (v) {
					case 'FAILED':
						return 'Failed'
					case 'SUCCESS':
						return 'Success'
					case 'PENDING':
						return 'Pending'
					default:
						return String(v)
				}
			})(arg0),
		PaymentProvider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN' | 'VERIFONE' | 'CASH') =>
			(v => {
				switch (v) {
					case 'RAPYD':
						return 'Rapyd'
					case 'MANUAL':
						return 'Manual'
					case 'STRIPE':
						return 'Stripe'
					case 'ADYEN':
						return 'Adyen'
					case 'VERIFONE':
						return 'Verifone'
					case 'CASH':
						return 'Cash'
					default:
						return String(v)
				}
			})(arg0),
		ProductStatus: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Draft'
					case 'PUBLISHED':
						return 'Published'
					case 'ARCHIVED':
						return 'Archived'
					default:
						return String(v)
				}
			})(arg0),
		ThirdPartySource: (arg0: 'STRUCT' | 'LS_RETAIL' | 'BUSINESS_CENTRAL') =>
			(v => {
				switch (v) {
					case 'STRUCT':
						return 'Struct'
					case 'LS_RETAIL':
						return 'LS Retail'
					case 'BUSINESS_CENTRAL':
						return 'Business Central'
					default:
						return String(v)
				}
			})(arg0),
		CardExternalSource: (arg0: 'PASSCREATOR') =>
			(v => {
				switch (v) {
					case 'PASSCREATOR':
						return 'PassCreator'
					default:
						return String(v)
				}
			})(arg0),
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per unit'
					case 'PRICE_EMBEDDED':
						return 'Price embedded'
					case 'PER_WEIGHT':
						return 'Per weight'
					case 'WEIGHT_EMBEDDED':
						return 'Weight embedded'
					default:
						return String(v)
				}
			})(arg0),
		GiftCardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'RESERVED':
						return 'Reserved'
					case 'REDEEMED':
						return 'Redeemed'
					default:
						return String(v)
				}
			})(arg0),
		RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Pending'
					case 'APPLIED':
						return 'Applied'
					default:
						return String(v)
				}
			})(arg0),
		CardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'BLOCKED':
						return 'Blocked'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentProvider: (arg0: 'MERCHANT_APP') =>
			(v => {
				switch (v) {
					case 'MERCHANT_APP':
						return 'Merchant app'
					default:
						return String(v)
				}
			})(arg0),
		UserStatus: (arg0: 'ACTIVE' | 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REJECTED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'PENDING':
						return 'Pending'
					case 'ACCEPTED':
						return 'Accepted'
					case 'EXPIRED':
						return 'Expired'
					case 'REJECTED':
						return 'Rejected'
					default:
						return String(v)
				}
			})(arg0),
		UserRole: (arg0: 'DEVELOPER' | 'ADMIN' | 'USER') =>
			(v => {
				switch (v) {
					case 'DEVELOPER':
						return 'Developer'
					case 'ADMIN':
						return 'Admin'
					case 'USER':
						return 'User'
					default:
						return String(v)
				}
			})(arg0)
	},
	General: {
		AppName: () => 'FastTrack',
		DefaultPageTitle: () => 'FastTrack Dashboard',
		Create: () => 'Create',
		Import: () => 'Import',
		Export: () => 'Export',
		NoResultsTitle: () => 'No results found',
		Loading: () => 'Loading...',
		Selected: () => 'Selected',
		Optional: () => 'Optional',
		Save: () => 'Save',
		Continue: () => 'Continue',
		Cancel: () => 'Cancel',
		Confirm: () => 'Confirm',
		Delete: () => 'Delete',
		Edit: () => 'Edit',
		Add: () => 'Add',
		Required: () => 'Required',
		Close: () => 'Close',
		Update: () => 'Update',
		UnsavedChangesTitle: () => 'Unsaved changes',
		UnsavedChangesDescription: () => 'You have unsaved changes. Are you sure you want to leave?',
		VerificationInstruction: (arg0: string) => 'Please type ' + String(arg0) + ' to confirm:',
		Copy: () => 'Copy',
		Copied: () => 'Copied',
		AreYouSure: () => 'Are you sure?',
		True: () => 'Yes',
		False: () => 'No',
		SearchPlaceholder: () => 'Search...',
		InvalidFileType: (arg0: string, arg1: string) =>
			'Invalid file type: ' + String(arg0) + ' (supported: ' + String(arg1) + ')',
		DropImages: () => 'Drop images to upload',
		Multiple: () => 'Multiple',
		Variable: () => 'Variable',
		Enabled: () => 'Enabled',
		Expired: () => 'Expired',
		Scheduled: () => 'Scheduled',
		Active: () => 'Active',
		Inactive: () => 'Inactive',
		ComingSoon: () => 'Coming Soon',
		ComingSoonDescription: () => 'This feature is currently under development.',
		None: () => 'None',
		NotSet: () => 'Not set',
		Unknown: () => 'Unknown',
		GoBack: () => 'Go back',
		GoHome: () => 'Go home',
		FeatureNotAvailable: () => 'This feature is currently not available',
		FeatureNotAvailableDescription: () => 'Contact support to enable this feature',
		Dismiss: () => 'Dismiss',
		TryAgain: () => 'Try again',
		All: () => 'All',
		AdvancedFilters: () => 'Filters',
		ClearAll: () => 'Clear',
		Apply: () => 'Apply',
		CountSelected: (args: { count: number }) => String(args.count) + ' selected',
		MultiSelectHint: (args: { count: number }) => String(args.count) + ' selected • Hold Ctrl/Cmd to multi-select',
		PickDate: () => 'Pick a date',
		Created: () => 'Created successfully',
		View: () => 'View'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'Failed to load data',
		AnErrorOccurredWhileFetchingData: () => 'An error occurred while fetching data. Please try again.'
	},
	Enums: {
		PaymentProvider: (
			arg0:
				| 'CASH'
				| 'ADYEN_TERMINAL'
				| 'ADYEN_ECOM'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS'
				| 'NETS_TERMINAL'
				| 'VERIFONE_CHECKOUT'
				| 'VERIFONE_ECOM'
				| 'STRAUMUR_ECOM'
				| 'LOYALTY_POINTS'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'VIPPS_MOBILEPAY'
				| 'RAPYD_CLOUDLINK'
				| 'RAPYD_APP_TO_APP'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
		) =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Cash'
					case 'ADYEN_TERMINAL':
						return 'Adyen Terminal'
					case 'ADYEN_ECOM':
						return 'Adyen ECom'
					case 'BLIKK_ECOM':
						return 'Blikk ECom'
					case 'BLIKK_POS':
						return 'Blikk POS'
					case 'VIPPS':
						return 'Vipps'
					case 'NETS_TERMINAL':
						return 'Nets Terminal'
					case 'VERIFONE_CHECKOUT':
						return 'Verifone Checkout'
					case 'VERIFONE_ECOM':
						return 'Verifone ECOM'
					case 'STRAUMUR_ECOM':
						return 'Straumur'
					case 'LOYALTY_POINTS':
						return 'Loyalty Points'
					case 'GIFT_CARD':
						return 'Gift Card'
					case 'BUSINESS_CARD':
						return 'Business Card'
					case 'VIPPS_MOBILEPAY':
						return 'Vipps MobilePay'
					case 'RAPYD_CLOUDLINK':
						return 'Rapyd Cloudlink'
					case 'RAPYD_APP_TO_APP':
						return 'Rapyd App to App'
					case 'TEYA_POSLINK':
						return 'Teya POSLink'
					case 'VERIFONE_POS_CLOUD':
						return 'Verifone POS Cloud'
					default:
						return String(v)
				}
			})(arg0)
	},
	Fields: {
		Name: () => 'Name',
		Status: () => 'Status',
		Type: () => 'Type',
		SalesChannel: () => 'Sales Channel',
		PointOfSale: () => 'Point of Sale',
		PaymentStatus: () => 'Payment Status',
		StartDate: () => 'Start Date',
		EndDate: () => 'End Date',
		TaxRate: () => 'VAT Rate',
		TaxInclusive: () => 'VAT Inclusive',
		Amount: () => 'Amount',
		Price: () => 'Price',
		Description: () => 'Description',
		Groups: () => 'Groups',
		Categories: () => 'Categories',
		Email: () => 'Email',
		Password: () => 'Password',
		ConfirmPassword: () => 'Confirm Password',
		Role: () => 'Role',
		SKU: () => 'SKU',
		Currency: () => 'Currency',
		CreatedAt: () => 'Created',
		ExpiresAt: () => 'Expires at',
		UpdatedAt: () => 'Updated',
		Language: () => 'Language',
		Year: () => 'Year',
		Month: () => 'Month',
		ExternalId: () => 'External ID',
		FirstName: () => 'First Name',
		LastName: () => 'Last Name',
		Phone: () => 'Phone',
		SSN: () => 'SSN',
		CardNumber: () => 'Card Number',
		Company: () => 'Company',
		Customer: () => 'Customer',
		Employee: () => 'Employee',
		FromTime: () => 'From',
		ToTime: () => 'To',
		OrgNumber: () => 'Organization Number',
		Enabled: () => 'Enabled',
		Disabled: () => 'Disabled',
		CurrencyCode: () => 'Currency Code'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'Shortcuts'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'Monday',
		Tuesday: () => 'Tuesday',
		Wednesday: () => 'Wednesday',
		Thursday: () => 'Thursday',
		Friday: () => 'Friday',
		Saturday: () => 'Saturday',
		Sunday: () => 'Sunday'
	},
	Auth: {
		AcceptInvite: () => 'Accept Invite',
		AcceptInviteAndSetPassword: () => 'Accept Invite and Set Password',
		AcceptInviteDescription: () => 'Set your password to accept the invitation.',
		ConfirmPasswordPlaceholder: () => 'Confirm your password',
		InvalidInvite: () => 'Invalid Invite',
		InvalidInviteDescription: () => 'This invitation is invalid or has expired.',
		InviteAccepted: () => 'Invitation accepted successfully',
		InviteExpired: () => 'This invitation has expired or is no longer valid',
		PasswordPlaceholder: () => 'Enter your password',
		PasswordsDoNotMatch: () => 'Passwords do not match',
		SetPassword: () => 'Set Password'
	},
	Error: {
		PageNotFound: () => 'Page Not Found',
		PageNotFoundDescription: () => 'The page you are looking for does not exist.',
		SomethingWentWrong: () => 'Something went wrong',
		AnUnexpectedErrorOccurred: () =>
			'An unexpected error occurred. You can try going back, reloading the page, or contact support if the problem persists.',
		ErrorDetails: () => 'Error Details',
		ReloadPage: () => 'Reload Page',
		ContactSupport: () => 'Contact support'
	},
	Campaigns: {
		Domain: () => 'Campaigns'
	},
	CustomerGroups: {
		Domain: () => 'Customer Groups',
		Title: () => 'Groups',
		CreateTitle: () => 'Create Customer Group',
		CreateSuccess: (args: { name: string }) => 'Customer group ' + String(args.name) + ' was successfully created.',
		EditTitle: () => 'Edit Customer Group',
		UpdateSuccess: () => 'Customer group updated successfully',
		Empty: () => 'No customer groups yet',
		Members: () => 'Members',
		SelectCustomers: () => 'Select customers',
		Delete: {
			Title: () => 'Delete customer group',
			Description: (args: { name: string }) =>
				'Are you sure you want to delete the customer group "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Customer group ' + String(args.name) + ' was deleted.'
		},
		Column: {
			Name: () => 'Name',
			Description: () => 'Description',
			ExternalId: () => 'External ID',
			MemberCount: () => 'Members'
		},
		Field: {
			Name: () => 'Name',
			Description: () => 'Description',
			ExternalId: () => 'External ID',
			NamePlaceholder: () => 'Enter a group name',
			DescriptionPlaceholder: () => 'Describe this group (optional)',
			ExternalIdPlaceholder: () => 'External ID (optional)'
		},
		Detail: {
			Title: () => 'Customer Group'
		}
	},
	DraftOrders: {
		Domain: () => 'Draft Orders'
	},
	PriceLists: {
		Domain: () => 'Price Lists'
	},
	Reservations: {
		Domain: () => 'Reservations'
	},
	Login: {
		PageTitle: () => 'Sign in',
		Title: () => 'Welcome to FastTrack',
		Description: () => 'Sign in to access your dashboard',
		Email: () => 'Email',
		Password: () => 'Password',
		LogIn: () => 'Log in',
		ForgotPassword: () => 'Forgot password?',
		ForgotPasswordButton: () => 'Reset',
		Error: () => 'Unable to log in',
		UnauthorizedError: () => 'Invalid email or password'
	},
	ResetPassword: {
		Title: () => 'Reset password',
		Hint: () => 'Enter your email below, and we will send you instructions on how to reset your password.',
		Email: () => 'Email',
		SendResetInstructions: () => 'Send reset instructions',
		BackToLogin: () => 'Back to login',
		SuccessfulRequestTitle: () => 'Successfully sent you an email',
		SuccessfulRequest: () =>
			"We've sent you an email which you can use to reset your password. Check your spam folder if you haven't received it after a few minutes.",
		NewPassword: () => 'New password',
		NewPasswordHint: () => 'Choose a new password below.',
		RepeatNewPassword: () => 'Repeat new password',
		ResetPassword: () => 'Reset password',
		PasswordMismatch: () => 'Passwords do not match',
		SuccessfulResetTitle: () => 'Password reset successful',
		SuccessfulReset: () => 'Please login in on the login page.',
		InvalidEmail: () => 'Invalid email'
	},
	Sidebar: {
		Logout: () => 'Logout',
		ProfileSettings: () => 'Profile settings',
		BackToApp: () => 'Back to app',
		SearchPlaceholder: () => 'Search or jump…',
		OpenSearch: () => 'Open search',
		StoreScopeHint: () => 'Workspace (switcher coming later)',
		Sections: () => 'Sections',
		Individuals: () => 'Individuals',
		Business: () => 'Business',
		Content: () => 'Content',
		Messaging: () => 'Messaging',
		Automation: () => 'Automation'
	},
	DeveloperFeedback: {
		Entry: () => 'Send feedback',
		Title: () => 'Developer feedback',
		Description: () => 'This becomes an issue for the engineering team.',
		TitleLabel: () => 'Title',
		BodyLabel: () => 'Details',
		TypeLabel: () => 'Type',
		TypeSmallFix: () => 'Small fix',
		TypeBug: () => 'Bug',
		TypeEnhancement: () => 'Enhancement',
		TypeNote: () => 'Note',
		Submit: () => 'Submit',
		Created: () => 'Issue created'
	},
	CommandPalette: {
		GroupQuick: () => 'Quick actions',
		InputHint: () => 'Search orders, products, customers, collections…',
		FooterHint: () => 'Tip: type at least 2 characters to search across the store.',
		NoResults: () => 'No matches. Try another keyword.',
		QuickNewProduct: () => 'Create product',
		QuickNewPromotion: () => 'Create promotion',
		QuickMarketingContent: () => 'Marketing content',
		QuickGoOrders: () => 'Go to orders',
		QuickSettings: () => 'Settings'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			String(args.start) + ' to ' + String(args.end) + ' of ' + String(args.total) + ' results',
		NoResults: () => '0 results',
		Previous: () => 'Previous',
		Next: () => 'Next'
	},
	Orders: {
		Title: () => 'Orders',
		BagChecks: () => 'Bag checks',
		Drafts: () => 'Drafts',
		StatusEnum: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Pending'
					case 'UNPAID':
						return 'Unpaid'
					case 'PAID':
						return 'Paid'
					case 'PARTIALLY_PAID':
						return 'Partially paid'
					case 'REFUNDED':
						return 'Refunded'
					case 'PARTIALLY_REFUNDED':
						return 'Partially refunded'
					case 'OVERPAID':
						return 'Overpaid'
					default:
						return String(v)
				}
			})(arg0),
		OrderCanceled: () => 'Order canceled successfully',
		AdvancedFilters: () => 'Order Filters',
		FulfillmentStatusEnum: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Not fulfilled'
					case 'FULFILLED':
						return 'Fulfilled'
					case 'NOT_NEEDED':
						return 'Not needed'
					case 'PARTIALLY_FULFILLED':
						return 'Partially fulfilled'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Order: () => 'Order',
			Date: () => 'Date',
			SalesChannel: () => 'Sales Channel',
			PaymentStatus: () => 'Payment Status',
			Total: () => 'Order total',
			FulfillmentStatus: () => 'Fulfillment Status',
			PointsEarned: () => 'Points earned',
			PointsUsed: () => 'Points used'
		},
		Totals: {
			Header: () => 'Overview - Today',
			Orders: () => 'Orders',
			Total: () => 'Revenue',
			Average: () => 'Average order',
			UpdatedAt: (arg0: DateInput) => 'Updated at ' + shortDateAndTimePreciseFormatter('en', arg0)
		},
		Filters: {
			MinAmount: () => 'Min Amount',
			MaxAmount: () => 'Max Amount',
			FromDate: () => 'From Date',
			ToDate: () => 'To Date'
		},
		Refund: {
			Title: () => 'Refund',
			Amount: () => 'Amount',
			Note: () => 'Note',
			AmountCannotBeEmpty: () => 'Amount cannot be empty',
			AmountMustBeGreaterThanZero: () => 'Amount must be greater than 0',
			AmountMustBeLessThanRefundableAmount: (arg0: TranslationAmount) =>
				'Amount must be less than the refundable amount (' + amountFormatter('en', arg0) + ')',
			Description: () => 'Select the line items to refund, adjust quantities, and/or enter a custom amount.',
			ItemsSectionTitle: () => 'Line items',
			CustomAmountSectionTitle: () => 'Custom amount',
			CustomAmountLabel: () => 'Additional amount',
			CustomAmountOnlyLabel: () => 'Refund amount',
			CustomAmountHint: () => 'Optionally add a custom amount on top of the selected items.',
			RefundableAmount: () => 'Refundable amount',
			RefundTotal: () => 'Refund total',
			AlreadyRefunded: (args: { quantity: number; total: number }) =>
				'Refunded ' + String(args.quantity) + ' of ' + String(args.total),
			PromotionLocked: () => 'Part of a promotion — refund using a custom amount instead.',
			Restock: () => 'Restock returned units',
			NothingToRefund: () => 'This order has nothing left to refund.',
			NoRefundableItems: () => 'No line items are available for an item-based refund.',
			SelectSomething: () => 'Select at least one item or enter a custom amount.',
			ExceedsRefundable: () => 'The refund total exceeds the refundable amount.',
			RefundEntireOrder: (arg0: TranslationAmount) => 'Refund entire order (' + amountFormatter('en', arg0) + ')',
			SelectAll: () => 'Select all',
			ConfirmTitle: () => 'Refund this order?',
			ConfirmWarning: (args: { total: TranslationAmount }) =>
				'This will refund ' +
				amountFormatter('en', args.total) +
				' to the customer. Refunds are permanent and cannot be undone or cancelled once initiated.',
			Submit: () => 'Refund',
			Success: () => 'Refund initiated',
			Error: () => 'Failed to initiate refund'
		},
		Payment: {
			CreateRefundWrongQuantity: (args: { number: string }) =>
				'Quantity should be a number between 0 and ' + String(args.number)
		}
	},
	OrderDetail: {
		Title: (arg0: string) => 'Order #' + String(arg0),
		OnDateFromSalesChannel: (args: { date: string; salesChannel: string }) =>
			String(args.date) + ' from ' + String(args.salesChannel),
		OnDateFromPointOfSale: (args: { date: string; salesChannel: string; pointOfSale: string }) =>
			String(args.date) + ' from ' + String(args.salesChannel) + ' (' + String(args.pointOfSale) + ')',
		Status: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Completed'
					case 'CANCELED':
						return 'Cancelled'
					default:
						return String(v)
				}
			})(arg0),
		CancelWarning: (args: { id: string }) =>
			'You are about to cancel the order ' + String(args.id) + '. This action cannot be undone.',
		OpenOrderDetails: () => 'Open order details',
		Items: () => 'Items',
		Transactions: () => 'Transactions',
		Summary: {
			Title: () => 'Summary',
			EditOrder: () => 'Edit order',
			OpenReceipt: () => 'Open receipt',
			ItemTotal: () => 'Item total',
			TaxTotal: () => 'VAT total',
			Total: () => 'Total',
			GiftCardTotal: () => 'Gift card total',
			PointsEarned: () => 'Loyalty points earned',
			PaidTotal: () => 'Paid total',
			OutstandingAmount: () => 'Outstanding amount',
			Discount: () => 'Discount',
			Refunded: () => 'Refunded'
		},
		Receipt: {
			FailedToLoad: () => 'Failed to load receipt',
			Redirecting: () => 'Redirecting to receipt...',
			Loading: () => 'Loading receipt...'
		},
		Payment: {
			Title: () => 'Payments',
			Status: (
				arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'OVERPAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'
			) =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Pending'
						case 'UNPAID':
							return 'Unpaid'
						case 'PAID':
							return 'Paid'
						case 'PARTIALLY_PAID':
							return 'Partially paid'
						case 'OVERPAID':
							return 'Overpaid'
						case 'REFUNDED':
							return 'Refunded'
						case 'PARTIALLY_REFUNDED':
							return 'Partially refunded'
						default:
							return String(v)
					}
				})(arg0),
			TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
				(v => {
					switch (v) {
						case 'FAILED':
							return 'Failed'
						case 'SUCCESS':
							return 'Success'
						case 'PENDING':
							return 'Pending'
						default:
							return String(v)
					}
				})(arg0),
			Provider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN') =>
				(v => {
					switch (v) {
						case 'RAPYD':
							return 'Rapyd'
						case 'MANUAL':
							return 'Manual'
						case 'STRIPE':
							return 'Stripe'
						case 'ADYEN':
							return 'Adyen'
						default:
							return String(v)
					}
				})(arg0),
			PaymentWithSequenceNumber: (args: { sequenceNumber: string }) => 'Payment #' + String(args.sequenceNumber),
			RefundWithSequenceNumber: (args: { sequenceNumber: string }) => 'Refund #' + String(args.sequenceNumber),
			TotalPaidByCustomer: () => 'Total paid by customer',
			TotalPending: () => 'Total pending',
			Refund: () => 'Refund'
		},
		SandStar: {
			Title: () => 'SandStar cooler',
			CloudReview: () => 'Cloud review',
			MachineName: () => 'Machine',
			OrderNo: () => 'Order number',
			AbnormalReason: () => 'Abnormal reason',
			Video: () => 'Session video',
			NoVideo: () => 'No video available'
		}
	},
	Products: {
		Title: () => 'Products',
		Library: () => 'Library',
		Status: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Draft'
					case 'PUBLISHED':
						return 'Published'
					case 'ARCHIVED':
						return 'Archived'
					default:
						return String(v)
				}
			})(arg0),
		BarcodeType: () => 'Barcode Type',
		ExportTitle: () => 'Export Products',
		AdvancedFilters: () => 'Product Filters',
		NoAdvancedFiltersYet: () => 'No advanced filters available for products yet.',
		OpenProductDetails: () => 'Open product details',
		LibraryPage: {
			NoAssets: () => 'No product images yet',
			NoAssetsDescription: () => 'Upload product photos here to reuse them across your products.',
			Filename: () => 'Filename',
			TableView: () => 'Table view',
			GalleryView: () => 'Gallery view',
			Upload: () => 'Upload',
			SearchFilename: () => 'Search by filename',
			ViewFullImage: () => 'View full image',
			CopyUrl: () => 'Copy url',
			CopiedUrl: () => 'URL copied',
			DeleteAsset: () => 'Delete asset',
			DeleteAssetConfirm: () => 'Delete this asset? It cannot be undone.',
			UploadAssets: () => 'Upload assets',
			UploadDropzone: () => 'Drag and drop images here, or click to choose files',
			ChooseFiles: () => 'Choose files',
			Tags: () => 'Tags',
			UsedBy: () => 'Used by',
			UsageFilter: () => 'Usage',
			UsageUnused: () => 'Unused',
			UsageProduct: () => 'Product',
			UsageProductGroup: () => 'Product group',
			UsageProductCategory: () => 'Product category',
			UsageMarketingContent: () => 'Marketing content',
			UsageFeedLayout: () => 'Customer app feed',
			ChannelFilter: () => 'Marketing channel',
			ContentFilter: () => 'Used by content',
			ChannelNone: () => 'No channel',
			ContentNone: () => 'No content',
			TagsPlaceholder: () => 'Add a tag and press Enter',
			Uploading: () => 'Uploading',
			EditTags: () => 'Edit tags',
			NoTags: () => 'No tags',
			ManageTags: () => 'Manage tags',
			ManageTagsEmpty: () => 'No tags in the library yet.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' assets',
			CreateTag: () => 'Create tag',
			CreateTagPlaceholder: () => 'Add a tag and press Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Tag "' + String(args.tag) + '" created.',
			RenameTag: () => 'Rename tag',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Merge tag "' +
				String(args.from) +
				'" into "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' assets)? The old tag will be removed.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tag renamed from "' + String(args.from) + '" to "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Remove tag "' + String(args.tag) + '" from all assets? Files are not deleted.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tag removed from ' +
				String(args.count) +
				' ' +
				plural('en', args.count, { one: 'asset', other: 'assets' }) +
				'.'
		},
		Column: {
			Title: () => 'Title',
			Status: () => 'Status',
			PricingMethod: () => 'Pricing Method',
			SalesChannels: () => 'Sales Channels'
		},
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per unit'
					case 'PRICE_EMBEDDED':
						return 'Price embedded'
					case 'PER_WEIGHT':
						return 'Per weight'
					case 'WEIGHT_EMBEDDED':
						return 'Weight embedded'
					default:
						return String(v)
				}
			})(arg0),
		Export: {
			Description: () => 'Export products to a CSV file.',
			Download: () => 'Download',
			Error: () => 'Failed to export products',
			Format: () => 'Format',
			NoDataError: () => 'No data to export',
			ProductCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'product', other: 'products' }),
			Success: () => 'Products exported successfully'
		},
		Import: {
			Header: () => 'Import Product List',
			UploadLabel: () => 'Import Products',
			UploadHint: () => 'Drag and drop a CSV file or click to upload',
			Description: () => 'Import products by providing a CSV file in a pre-defined format',
			Template: {
				Title: () => 'Unsure about how to arrange your list?',
				Description: () => 'Download the template below to ensure you are following the correct format.'
			},
			Upload: {
				Title: () => 'Upload a CSV file',
				Description: () =>
					'Through imports you can add or update products. To update existing products the input will be matched by external ID, SKU or barcode. You will be asked for confirmation before we import products.',
				Preprocessing: () => 'Preprocessing...',
				Importing: () => 'Importing products...',
				ProductsToCreate: () => 'Products will be created',
				ProductsToUpdate: () => 'Products will be updated',
				ProductsCreated: () => 'Products created',
				ProductsUpdated: () => 'Products updated',
				ProductsErrored: () => 'Products errored',
				Errors: {
					Title: () => 'Errors',
					Description: (args: { count: number; rows: number }) =>
						String(args.count) +
						' ' +
						plural('en', args.count, { one: 'error', other: 'errors' }) +
						' in ' +
						String(args.rows) +
						' ' +
						plural('en', args.rows, { one: 'row', other: 'rows' }),
					Row: () => 'Row',
					Column: () => 'Column',
					Message: () => 'Message'
				}
			},
			Success: () => 'Import completed!'
		}
	},
	Product: {
		Header: (arg0: string) => 'Product ' + String(arg0),
		EditHeader: () => 'Edit product',
		EditSuccessToast: (args: { title: string }) => 'Product ' + String(args.title) + ' was successfully updated.',
		CreateTitle: () => 'Create product',
		Title: () => 'Title',
		Subtitle: () => 'Subtitle',
		Description: () => 'Description',
		PricingMethodTitle: () => 'Pricing method',
		Overview: () => 'Overview',
		ExternalId: () => 'External ID',
		ExternalSource: () => 'External Source',
		ManagedExternally: (args: { source: string }) => 'This product is managed by ' + String(args.source),
		Sku: () => 'SKU',
		Variants: () => 'Variants',
		DeleteWarning: (args: { title: string }) =>
			'You are about to delete the product ' + String(args.title) + '. This action cannot be undone.',
		Create: {
			Title: () => 'Create product'
		},
		Media: {
			Title: () => 'Media',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Choose from library',
			LibraryPickerTitle: () => 'Add from library',
			LibraryPickerEmpty: () => 'No product images in the library yet.',
			LibraryPickerAllAttached: () => 'All library images are already on this product.',
			AddImageSuccessToast: () => 'Image added',
			DeleteImageLabel: () => 'Delete image',
			DownloadImageLabel: () => 'Download image',
			SetPrimaryLabel: () => 'Set as primary',
			AlreadyPrimaryLabel: () => 'Primary image',
			PrimaryBadge: () => 'Primary',
			ProcessingBadge: () => 'Processing…',
			UploadingLabel: (args: { percent: number }) => 'Uploading… ' + String(args.percent) + '%',
			UploadSuccessToast: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'image', other: 'images' }) + ' uploaded',
			UploadFailedToast: () => 'Failed to upload image',
			DeleteSuccessToast: () => 'Image deleted',
			SetPrimarySuccessToast: () => 'Primary image updated',
			EmptyState: {
				Header: () => 'No image yet',
				Description: () => 'Drag and drop images here, or add an image to showcase it in your storefront.',
				Action: () => 'Add media'
			}
		},
		Organization: {
			Header: () => 'Organization'
		},
		Pricing: {
			Title: () => 'Pricing',
			VariablePrice: () => 'Variable price',
			Price: () => 'Price',
			PriceWithTax: () => 'Price incl. VAT',
			PriceWithoutTax: () => 'Price excl. VAT',
			Enabled: () => 'Enabled',
			InvalidTaxRate: (args: { taxRate: string }) => 'Invalid VAT rate: ' + String(args.taxRate),
			NoPricesConfigured: () => 'No prices configured',
			Target: () => 'Applies to',
			Group: () => 'Group',
			Channel: () => 'Sales channel',
			GroupDefault: () => 'Group default',
			ChannelOverride: () => 'Channel override',
			AddOverride: () => 'Add channel override',
			SelectOverrideChannel: () => 'Select a sales channel to override',
			NoOverridableChannels: () => 'All grouped channels already have an override',
			RemoveOverride: () => 'Remove override',
			ExpandGroup: () => 'Show channel prices',
			CollapseGroup: () => 'Hide channel prices',
			OverrideCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'override', other: 'overrides' }),
			EmptyState: {
				Header: () => 'No prices configured',
				Description: () => 'Add a price to this product so it can be sold on a sales channel.',
				Action: () => 'Add price'
			}
		},
		Barcode: {
			Title: () => 'Barcodes',
			Barcode: () => 'Barcode',
			AddBarcode: () => 'Add barcode',
			AddBarcodePrompt: {
				Title: () => 'Add barcode',
				Placeholder: () => 'Barcode'
			},
			Delete: {
				Title: () => 'Delete barcode',
				Description: (args: { barcode: string }) =>
					'Are you sure you want to delete the barcode ' + String(args.barcode) + '?'
			},
			AlreadyOnProduct: () => 'This barcode is already on this product',
			AlreadyInUse: () => 'This barcode is already in use by another product'
		},
		UnitsOfMeasure: {
			Title: () => 'Units of Measure',
			Unit: () => 'Unit',
			Base: () => 'Base',
			BaseUnit: () => 'Base unit',
			True: () => 'True',
			False: () => 'False',
			BaseUnitLabel: (args: { code: string }) => String(args.code) + ' (base)',
			BaseUnitsPer: () => 'Qty per Unit',
			Sellable: () => 'Sellable',
			Pos: () => 'POS',
			Ecom: () => 'Ecom',
			Add: () => 'Add unit',
			Edit: () => 'Edit unit',
			Code: () => 'Code',
			Name: () => 'Name',
			InvalidFactor: () => 'Quantity must be greater than zero',
			SelectUnit: () => 'Select a unit',
			QuantityRequired: () => 'This unit has no shared quantity, so a quantity is required',
			Saved: () => 'Unit saved',
			Delete: {
				Title: () => 'Delete unit',
				Description: (args: { code: string }) => 'Are you sure you want to delete ' + String(args.code) + '?'
			}
		}
	},
	ProductEdit: {
		Header: () => 'Edit product'
	},
	ProductCategories: {
		Title: () => 'Categories',
		Breadcrumb: () => 'Categories',
		Search: () => 'Search categories',
		Empty: () => 'No categories yet',
		NoSearchResults: (args: { query: string }) => 'No categories match “' + String(args.query) + '”',
		Column: {
			Name: () => 'Name',
			ProductCount: () => 'Product count'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'No parent',
			SelectParentTitle: () => 'Select parent category',
			SelectParentDescription: () => 'Select a parent category for this category'
		}
	},
	ProductCategory: {
		CreateSuccessToast: (args: { name: string }) => 'Category ' + String(args.name) + ' was successfully created.',
		EditHeader: () => 'Edit category',
		EditSuccessToast: (args: { name: string }) => 'Category ' + String(args.name) + ' was successfully updated.',
		CreateTitle: () => 'Create category',
		ParentCategory: () => 'Parent category',
		ProductsTitle: () => 'Products',
		SelectParent: () => 'Select parent category',
		ClearParent: () => 'Clear parent category',
		Delete: {
			Title: () => 'Delete category',
			Description: (args: { name: string }) =>
				'Are you sure you want to delete the category "' +
				String(args.name) +
				'"? Products in this category will not be deleted.',
			SuccessToast: (args: { name: string }) => 'Category ' + String(args.name) + ' was deleted.'
		},
		Image: {
			Title: () => 'Image',
			EmptyState: () => 'No image yet',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Choose from library',
			Remove: () => 'Remove image',
			LibraryPickerTitle: () => 'Add from library',
			LibraryPickerEmpty: () => 'No product images in the library yet.',
			LibraryPickerAllAttached: () => 'This image is already selected.',
			SetSuccessToast: () => 'Image updated',
			RemoveSuccessToast: () => 'Image removed',
			UploadFailedToast: () => 'Failed to upload image'
		},
		Create: {
			NoParent: () => 'No parent',
			SelectParentTitle: () => 'Select parent category',
			SelectParentDescription: () => 'Select a parent category for this category'
		}
	},
	ProductGroups: {
		Title: () => 'Groups',
		Breadcrumb: () => 'Groups',
		Search: () => 'Search groups',
		Empty: () => 'No groups yet',
		NoSearchResults: (args: { query: string }) => 'No groups match “' + String(args.query) + '”',
		Column: {
			Name: () => 'Name',
			ProductCount: () => 'Product count'
		}
	},
	ProductGroup: {
		Title: (arg0: string) => 'Group ' + String(arg0),
		EditHeader: () => 'Edit group',
		EditSuccessToast: (args: { name: string }) => 'Group ' + String(args.name) + ' was successfully updated.',
		CreateTitle: () => 'Create group',
		CreateSuccessToast: (args: { name: string }) => 'Group ' + String(args.name) + ' was successfully created.',
		Delete: {
			Title: () => 'Delete group',
			Description: (args: { name: string }) =>
				'Are you sure you want to delete the group "' +
				String(args.name) +
				'"? Products in this group will not be deleted.',
			SuccessToast: (args: { name: string }) => 'Group ' + String(args.name) + ' was deleted.'
		},
		Image: {
			Title: () => 'Image',
			EmptyState: () => 'No image yet',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Choose from library',
			Remove: () => 'Remove image',
			LibraryPickerTitle: () => 'Add from library',
			LibraryPickerEmpty: () => 'No product images in the library yet.',
			LibraryPickerAllAttached: () => 'This image is already selected.',
			SetSuccessToast: () => 'Image updated',
			RemoveSuccessToast: () => 'Image removed',
			UploadFailedToast: () => 'Failed to upload image'
		},
		Products: {
			Title: () => 'Products',
			NoProducts: () => 'No products',
			Add: {
				Title: () => 'Add products',
				Label: () => 'Products',
				Placeholder: () => 'Search products',
				SuccessToast: (args: { count: number; name: string }) =>
					String(args.count) + ' product(s) added to ' + String(args.name) + '.',
				NoProducts: () => 'Please select at least one product.'
			}
		},
		Fees: {
			Title: () => 'Fees',
			AddFee: () => 'Add fee',
			NoFees: () => 'No fees',
			Delete: {
				Title: () => 'Delete fee',
				Description: (args: { name: string }) =>
					'Are you sure you want to delete the fee "' + String(args.name) + '"?'
			},
			Create: {
				Title: () => 'Create fee',
				Pricing: () => 'Pricing',
				SuccessToast: (args: { name: string }) => 'Fee ' + String(args.name) + ' was successfully created.',
				NoPrices: () => 'Please add at least one price.'
			},
			Edit: {
				Title: () => 'Edit fee',
				SuccessToast: (args: { name: string }) => 'Fee ' + String(args.name) + ' was successfully updated.'
			}
		}
	},
	GiftCards: {
		Title: () => 'Gift Cards',
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'RESERVED':
						return 'Reserved'
					case 'REDEEMED':
						return 'Redeemed'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Edit Gift Card',
		EditSuccess: () => 'Gift card updated successfully',
		DeleteSuccess: () => 'Gift card deleted successfully',
		Delete: {
			Title: () => 'Delete Gift Card',
			Description: () => 'Are you sure you want to delete this gift card? This action cannot be undone.'
		},
		Column: {
			Name: () => 'Name',
			Code: () => 'Code',
			Amount: () => 'Amount',
			CurrencyCode: () => 'Currency',
			Status: () => 'Status'
		},
		Detail: {
			Title: () => 'Gift Card',
			General: () => 'General',
			CardDetails: () => 'Card Details',
			Redemptions: () => 'Redemptions',
			NoRedemptions: () => 'No redemptions',
			Date: () => 'Date',
			RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Pending'
						case 'APPLIED':
							return 'Applied'
						default:
							return String(v)
					}
				})(arg0)
		}
	},
	GiftCard: {
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'RESERVED':
						return 'Reserved'
					case 'REDEEMED':
						return 'Redeemed'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Edit gift card',
		CreateTitle: () => 'Create gift card',
		Name: () => 'Name',
		Code: () => 'Code',
		Amount: () => 'Amount',
		CurrencyCode: () => 'Currency Code'
	},
	LoyaltyCards: {
		Title: () => 'Loyalty Cards',
		EditTitle: () => 'Edit Loyalty Card',
		EditSuccess: () => 'Loyalty card updated successfully',
		DeleteSuccess: () => 'Loyalty card deleted successfully',
		ManagedExternally: (args: { source: string }) => 'This loyalty card is managed by ' + String(args.source),
		Delete: {
			Title: () => 'Delete Loyalty Card',
			Description: () => 'Are you sure you want to delete this loyalty card? This action cannot be undone.'
		},
		Detail: {
			Title: () => 'Loyalty Card',
			CardDetails: () => 'Card Details',
			Customer: () => 'Customer',
			Redemptions: () => 'Redemptions',
			Date: () => 'Date'
		},
		Column: {
			Name: () => 'Name',
			CardNumber: () => 'Card Number',
			Customer: () => 'Customer',
			Status: () => 'Status',
			AvailablePoints: () => 'Available points',
			TotalPoints: () => 'Total points',
			ExternalId: () => 'External ID',
			ExternalSource: () => 'External Source',
			PointsUsed: () => 'Points used',
			PointsRemaining: () => 'Points remaining',
			Order: () => 'Order'
		}
	},
	Inventory: {
		Title: () => 'Inventory',
		Stock: () => 'Stock',
		Suppliers: () => 'Suppliers',
		Movements: () => 'Stock Movements',
		Receiving: () => 'Receiving',
		Transfers: () => 'Transfers',
		Reports: () => 'Inventory Reports',
		Summary: {
			TotalSkus: () => 'Total SKUs',
			LowStock: () => 'Low Stock',
			OutOfStock: () => 'Out of Stock'
		},
		Column: {
			Product: () => 'Product',
			Variant: () => 'Variant',
			Sku: () => 'SKU',
			SalesChannel: () => 'Sales Channel',
			InventoryLocation: () => 'Location',
			QuantityOnHand: () => 'On Hand',
			QuantityAfter: () => 'On Hand After',
			ReorderPoint: () => 'Reorder Point',
			ReorderQuantity: () => 'Reorder Qty',
			Status: () => 'Status',
			Type: () => 'Type',
			Delta: () => 'Change',
			Reason: () => 'Reason',
			CreatedBy: () => 'By',
			Ordered: () => 'Ordered',
			Received: () => 'Received',
			ReceiveNow: () => 'Receive Now',
			UnitCost: () => 'Unit Cost',
			Quantity: () => 'Quantity',
			Lines: () => 'Items',
			Date: () => 'Date',
			Name: () => 'Name',
			Email: () => 'Email',
			Reference: () => 'Reference',
			From: () => 'From',
			To: () => 'To',
			Supplier: () => 'Supplier',
			Currency: () => 'Currency',
			Margin: () => 'Margin',
			PurchasePrice: () => 'Purchase Price',
			RetailPrice: () => 'Retail Price',
			Tracked: () => 'Tracked'
		},
		Filter: {
			LowStockOnly: () => 'Low stock only',
			SalesChannel: () => 'Sales Channel',
			InventoryLocation: () => 'Location',
			Status: () => 'Status',
			Type: () => 'Type',
			AllChannels: () => 'All sales channels',
			AllLocations: () => 'All locations',
			AllStatuses: () => 'All statuses',
			AllTypes: () => 'All types'
		},
		NotTracked: () => 'Not tracked',
		ReorderSettings: () => 'Reorder Settings',
		ViewMovements: () => 'View history',
		Adjust: () => 'Adjust Stock',
		AdjustSuccess: () => 'Stock adjusted successfully',
		AdjustNoChanges: () => 'No changes to apply',
		AdjustDeltaHint: () => 'Relative change to on-hand stock. Use a negative value to remove stock.',
		EditProduct: () => 'Edit product',
		Settings: {
			Title: () => 'Settings',
			Description: () => 'Control how inventory tracking behaves across your sales channels.',
			Enabled: () => 'Enable inventory tracking',
			EnabledDescription: () => 'Track stock levels and stock movements for your products.',
			DeductOnOrderComplete: () => 'Deduct stock on completed orders',
			DeductOnOrderCompleteDescription: () => 'Automatically reduce on-hand quantity when an order is completed.',
			BlockOversell: () => 'Block overselling',
			BlockOversellDescription: () => 'Prevent selling more units than are available in a channel.',
			RestockOnReturn: () => 'Restock on returns',
			RestockOnReturnDescription: () => 'Add returned items back to on-hand quantity when a refund completes.',
			HideOutOfStock: () => 'Hide out-of-stock products',
			HideOutOfStockDescription: () =>
				'Hide tracked products from the storefront when they have no available stock in the channel.',
			Saved: () => 'Inventory settings updated',
			Locations: {
				Title: () => 'Locations',
				Description: () => 'Manage inventory locations and link sales channels to them.',
				Column: {
					Name: () => 'Name',
					SalesChannels: () => 'Sales channels'
				},
				CreateTitle: () => 'Create location',
				CreateSuccess: () => 'Location created',
				EditTitle: () => 'Edit location',
				EditSuccess: () => 'Location updated',
				NamePlaceholder: () => 'Warehouse, store floor, …',
				LinkedChannels: () => 'Linked sales channels',
				LinkedChannelsHint: () =>
					'Select sales channels that draw stock from this location. Adding a channel linked elsewhere will move it here.',
				NoLinkedChannels: () => 'No sales channels linked to this location.',
				InitializeStock: () => 'Initialize stock records',
				InitializeStockDescription: () =>
					'Create inventory level rows for all tracked variants at this location. Existing records are skipped.',
				InitializeStockSuccess: () => 'Stock records initialized',
				InitializeStockProgress: (args: { created: number; remaining: number }) =>
					'Created ' + String(args.created) + ' records (' + String(args.remaining) + ' remaining)',
				InitializeStockProgressLabel: (args: { created: number; total: number }) =>
					'Created ' + String(args.created) + ' of ' + String(args.total) + ' stock records',
				InitializeStockError: (args: { created: number }) =>
					'Initialization stopped after creating ' +
					String(args.created) +
					' records. Please retry to finish.',
				InitializeStockRetry: () => 'Retry',
				AdminOnly: () => 'Only administrators can manage inventory locations.'
			}
		},
		Status: {
			IN_STOCK: () => 'In Stock',
			LOW_STOCK: () => 'Low Stock',
			OUT_OF_STOCK: () => 'Out of Stock'
		},
		MovementType: {
			ADJUSTMENT: () => 'Adjustment',
			RECEIPT: () => 'Receipt',
			TRANSFER_IN: () => 'Transfer In',
			TRANSFER_OUT: () => 'Transfer Out',
			ORDER_DEDUCTION: () => 'Order Deduction',
			ORDER_RETURN: () => 'Order Return'
		},
		TransferStatus: {
			DRAFT: () => 'Draft',
			IN_TRANSIT: () => 'In Transit',
			RECEIVED: () => 'Received',
			CANCELLED: () => 'Cancelled'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Draft',
			ORDERED: () => 'Ordered',
			PARTIALLY_RECEIVED: () => 'Partially Received',
			RECEIVED: () => 'Received',
			CANCELLED: () => 'Cancelled'
		},
		CreateSupplier: () => 'Create Supplier',
		EditSupplier: () => 'Edit Supplier',
		EditSupplierSuccess: () => 'Supplier updated',
		SuppliersEmptyTitle: () => 'No suppliers yet',
		SuppliersEmptyDescription: () => 'Create your first supplier to track where you purchase stock.',
		CreateTransfer: () => 'Create Transfer',
		CreatePurchaseOrder: () => 'Create Purchase Order',
		PurchaseCurrencyHint: (args: { currency: string }) =>
			'Using ' + String(args.currency) + ' for this order. Change it if this order differs.',
		PurchaseCurrencyDefaultHint: (args: { currency: string }) =>
			'Defaulting to your reporting currency ' + String(args.currency) + '. Confirm or change it.',
		PurchaseCurrencyRequired: () => 'Select a purchase currency.',
		ShipTransfer: () => 'Ship Transfer',
		ReceiveTransfer: () => 'Receive Transfer',
		CancelTransfer: () => 'Cancel Transfer',
		Transfer: () => 'Transfer',
		Actions: () => 'Actions',
		ReceivePurchaseOrder: () => 'Receive Items',
		ManageSuppliers: () => 'Manage',
		Replenish: () => 'Replenish Low Stock',
		ReplenishSuccess: (args: { count: number }) => 'Created ' + String(args.count) + ' replenishment draft(s)',
		ReplenishNone: () => 'No items below reorder point',
		MarkOrdered: () => 'Mark Ordered',
		CancelOrder: () => 'Cancel',
		PurchaseOrder: () => 'Purchase Order',
		AddLine: () => 'Add',
		NoLines: () => 'No items added yet.',
		SelectSalesChannel: () => 'Select sales channel',
		SupplierDialog: {
			Title: () => 'Product Suppliers',
			Preferred: () => 'Preferred',
			SetPreferred: () => 'Set as preferred',
			AddSupplier: () => 'Add supplier',
			SelectSupplier: () => 'Select supplier',
			Empty: () => 'No suppliers linked to this product yet.',
			NoSuppliersYet: () => 'No suppliers exist yet',
			NoSuppliersDescription: () => 'Create a supplier before linking it to this product.',
			CreateSupplierAction: () => 'Create supplier',
			SupplierProductCode: () => 'Supplier product code',
			UpdateSuccess: () => 'Supplier updated',
			AllSuppliersLinked: () => 'All existing suppliers are already linked to this product.',
			EditPrices: () => 'Edit prices',
			MarginUnavailable: () => 'Not available',
			MarginCurrencyMismatch: (args: { retail: string; purchase: string }) =>
				"Margin can't be calculated because the retail price (" +
				String(args.retail) +
				') and supplier price (' +
				String(args.purchase) +
				') use different currencies.',
			MarginTaxNote: () =>
				'Margin is calculated on the retail price excluding VAT. VAT-inclusive retail prices have VAT removed first.',
			PurchasePriceTaxNote: () => 'Enter the supplier purchase price excluding VAT (net).'
		}
	},
	Companies: {
		Title: () => 'Companies',
		Anonymous: () => 'Unnamed',
		CreateTitle: () => 'Create Company',
		CreateSuccess: () => 'Company created successfully',
		EditTitle: () => 'Edit Company',
		EditSuccess: () => 'Company updated successfully',
		UpdateSuccess: () => 'Company updated successfully',
		Delete: {
			Title: () => 'Delete Company',
			Description: (args: { name: string }) =>
				'Are you sure you want to delete the company ' + String(args.name) + '? This action cannot be undone.'
		},
		DeleteSuccess: () => 'Company deleted successfully',
		CardCount: () => 'Company Cards',
		SettlementCount: () => 'Recent Settlements',
		RecentSettlements: () => 'Recent Settlements',
		Cards: {
			Title: () => 'Company Cards'
		},
		Detail: {
			Title: () => 'Company Details',
			General: () => 'General',
			ContactInfo: () => 'Contact Information',
			Cards: () => 'Company Cards',
			Settlements: () => 'Settlements',
			RecentSettlements: () => 'Recent Settlements',
			AssignCard: () => 'Assign Card',
			AssignCardDescription: () =>
				'Search for a business card by name or card number to assign it to this company.',
			AssignCardSuccess: () => 'Card assigned successfully',
			UnassignCard: () => 'Unassign Card',
			UnassignCardConfirm: () => 'Are you sure you want to unassign this card from the company?',
			UnassignCardSuccess: () => 'Card unassigned successfully',
			CardNumberPlaceholder: () => 'Search by name or card number'
		},
		Column: {
			Name: () => 'Name',
			Email: () => 'Email',
			Phone: () => 'Phone',
			ExternalId: () => 'External ID',
			CardCount: () => 'Cards',
			SettlementCount: () => 'Settlements',
			CreatedAt: () => 'Created'
		},
		Field: {
			Name: () => 'Name',
			Email: () => 'Email',
			Phone: () => 'Phone',
			ExternalId: () => 'External ID'
		},
		Create: {
			BasicInfo: () => 'Basic Information',
			Description: () => 'Create a new company',
			NamePlaceholder: () => 'Enter company name',
			ExternalIdPlaceholder: () => 'Enter external ID (optional)'
		},
		Edit: {
			BasicInfo: () => 'Basic Information',
			Description: () => 'Edit company information',
			NamePlaceholder: () => 'Enter company name',
			EmailPlaceholder: () => 'Enter email address',
			PhonePlaceholder: () => 'Enter phone number',
			OrgNumberPlaceholder: () => 'Enter organization number',
			ExternalIdPlaceholder: () => 'Enter external ID (optional)'
		}
	},
	Customers: {
		Title: () => 'Customers',
		UnnamedCustomer: () => 'Unnamed Customer',
		Anonymous: () => 'Anonymous',
		CreateTitle: () => 'Create Customer',
		CreateSuccess: (args: { name: string }) => 'Customer ' + String(args.name) + ' was successfully created.',
		EditTitle: () => 'Edit Customer',
		UpdateSuccess: () => 'Customer updated successfully',
		Detail: {
			Title: () => 'Customer',
			General: () => 'General',
			ContactInfo: () => 'Contact Information',
			Cards: () => 'Cards',
			AssignCard: () => 'Assign Card',
			AssignCardDescription: () =>
				'Search for a business card by name or card number to assign it to this customer.',
			AssignCardSuccess: () => 'Card assigned successfully',
			UnassignCard: () => 'Unassign Card',
			UnassignCardConfirm: () => 'Are you sure you want to unassign this card from the customer?',
			UnassignCardSuccess: () => 'Card unassigned successfully',
			CardNumberPlaceholder: () => 'Search by name or card number'
		},
		Column: {
			Name: () => 'Name',
			Email: () => 'Email',
			Phone: () => 'Phone',
			ExternalId: () => 'External ID',
			Cards: () => 'Cards'
		},
		Field: {
			FirstName: () => 'First Name',
			LastName: () => 'Last Name',
			Phone: () => 'Phone',
			SSN: () => 'SSN'
		},
		Create: {
			BasicInfo: () => 'Basic Information',
			Description: () => 'Create a new customer'
		},
		Edit: {
			BasicInfo: () => 'Basic Information',
			Description: () => 'Edit customer information',
			FirstNamePlaceholder: () => 'Enter first name',
			LastNamePlaceholder: () => 'Enter last name',
			EmailPlaceholder: () => 'Enter email address',
			PhonePlaceholder: () => 'Enter phone number',
			SSNPlaceholder: () => 'Enter SSN (optional)',
			ExternalIdPlaceholder: () => 'Enter external ID (optional)'
		},
		Cards: {
			Title: () => 'Customer Cards',
			Active: () => 'Active Cards'
		}
	},
	BusinessCards: {
		Title: () => 'Business Cards',
		CreateTitle: () => 'Create Business Card',
		CreateSuccess: () => 'Business card created successfully',
		EditTitle: () => 'Edit Business Card',
		EditSuccess: () => 'Business card updated successfully',
		DeleteSuccess: () => 'Business card deleted successfully',
		Create: {
			NamePlaceholder: () => 'Enter card name',
			CardNumberPlaceholder: () => 'Enter card number',
			SelectCompany: () => 'Select a company',
			SelectCustomer: () => 'Select a customer',
			PinTitle: () => 'Business card created',
			PinDescription: () => 'Share this PIN with the cardholder. It can only be viewed once.',
			GoToCard: () => 'Go to card'
		},
		Delete: {
			Title: () => 'Delete Business Card',
			Description: () => 'Are you sure you want to delete this business card? This action cannot be undone.'
		},
		Detail: {
			Title: () => 'Business Card',
			General: () => 'General',
			CardDetails: () => 'Card Details',
			Security: () => 'Security',
			ResetPin: () => 'Reset PIN',
			ResetPinDescription: () => 'Generate a new PIN for this card. The current PIN will be invalidated.',
			ResetPinSuccess: () => 'PIN has been reset successfully',
			NewPin: (args: { pin: string }) => 'New PIN: ' + String(args.pin),
			PinViewOnce: () => 'This PIN can only be viewed once. Please save it before closing this dialog.',
			Customer: () => 'Customer',
			Company: () => 'Company',
			DangerZone: () => 'Danger Zone',
			DeleteCardDescription: () => 'Permanently delete this business card. This action cannot be undone.'
		},
		Column: {
			Name: () => 'Name',
			CardNumber: () => 'Card Number',
			Status: () => 'Status',
			Customer: () => 'Customer',
			ExternalId: () => 'External ID',
			CreatedAt: () => 'Created'
		},
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'BLOCKED':
						return 'Blocked'
					default:
						return String(v)
				}
			})(arg0)
	},
	Promotions: {
		Title: () => 'Promotions',
		Group: () => 'Promotion group',
		Groups: () => 'Groups',
		SelectGroups: () => 'Select promotion groups',
		Column: {
			PromotionCount: () => 'Promotions'
		},
		CreateTitle: () => 'Create Promotion',
		CreateSuccess: () => 'Promotion created successfully',
		EditTitle: () => 'Edit Promotion',
		UpdateSuccess: () => 'Promotion updated successfully',
		NotFound: () => 'Promotion not found',
		AdvancedFilters: () => 'Promotion Filters',
		ManagedExternally: (args: { source: string }) => 'This promotion is managed by ' + String(args.source),
		Create: {
			ApplyToAll: () => 'All products',
			ApplyToGroups: () => 'Specific product groups',
			ApplyToCategories: () => 'Specific categories',
			ApplyToProducts: () => 'Specific products',
			AppliesTo: () => 'Applies to',
			FixedAmount: () => 'Fixed amount',
			Percentage: () => 'Percentage',
			OverridePrice: () => 'Override price',
			OverridePriceHelp: () =>
				'Set a fixed total price for the matched items per sales channel or sales channel group',
			IncludeFeesHelp: () =>
				'When on, the override price is the final total including any item fees. When off, item fees are added on top of the override price.',
			OverridePriceNoChannels: () =>
				'Select at least one sales channel or sales channel group to set override prices',
			BasicInfo: () => 'Basic Info',
			DaysOfWeek: () => 'Days of week',
			Discount: () => 'Effect',
			DiscountAmount: () => 'Discount amount',
			DiscountPercentage: () => 'Discount percentage',
			PercentageHelp: () => 'Enter a percentage between 0 and 100',
			ItemCount: () => 'Item count',
			NamePlaceholder: () => 'Enter promotion name',
			DisplayTitle: () => 'Display title',
			DisplayTitlePlaceholder: () => 'Shown to customers (optional)',
			DisplayTitleHint: () =>
				'Customer-facing title shown in scan & go, self-checkout and storefront. Leave blank to fall back to the internal name.',
			ProductGroup: () => 'Product group',
			ProductGroups: () => 'Product groups',
			SlotKind: () => 'Type',
			SlotKindGroup: () => 'Product group',
			SlotKindCategory: () => 'Category',
			Categories: () => 'Categories',
			Products: () => 'Products',
			CustomerEligibility: () => 'Customer eligibility',
			CustomerEligibilityHint: () =>
				'Leave empty to apply to everyone. Add customers or customer groups to restrict the promotion to them.',
			CustomerGroups: () => 'Customer groups',
			SelectCustomerGroups: () => 'Select customer groups',
			Customers: () => 'Customers',
			SelectCustomers: () => 'Select customers',
			PromotionType: () => 'Promotion type',
			TypeDiscount: () => 'Discount',
			TypeBundle: () => 'Bundle deal',
			TypeBuyXGetY: () => 'Buy X, get Y',
			BundleGroups: () => 'Bundle groups & categories',
			BundleGroupsHelp: () =>
				'The promotion applies once the required quantity from each group or category is in the order',
			QualifyingGroups: () => 'Qualifying products (buy)',
			QualifyingGroupsHelp: () =>
				'The required quantity from each of these groups or categories must be in the order to trigger the offer. These items are not discounted.',
			BenefitGroups: () => 'Benefit products (get)',
			BenefitGroupsHelp: () =>
				'Once the qualifying products are present, the required quantity from each of these groups or categories receives the discount below (100% = free).',
			AddBundleGroup: () => 'Add group or category',
			Schedule: () => 'Schedule',
			AddDay: () => 'Add days',
			SelectDays: () => 'Select days',
			SelectProductGroups: () => 'Select product groups',
			SelectCategories: () => 'Select categories',
			SelectProducts: () => 'Select products',
			SelectSalesChannels: () => 'Select sales channels',
			SalesChannelGroups: () => 'Sales channel groups',
			SelectSalesChannelGroups: () => 'Select sales channel groups',
			ApplicationRule: () => 'Application rule',
			Description: () => 'Description',
			Rank: () => 'Priority',
			RankHint: () => 'Lower numbers are applied first when multiple promotions match the same items',
			RankInUse: (args: { names: string }) =>
				'Another promotion already uses this priority: ' +
				String(args.names) +
				'. Promotions with the same priority apply in no guaranteed order, use a unique number to control which runs first.',
			SellingUnit: () => 'Selling unit',
			SellingUnitHelp: () =>
				'All units applies the promotion to every selling unit of the matched products. Base unit or a named pack restricts it to that unit only.',
			AllUnits: () => 'All units',
			BaseUnit: () => 'Base unit',
			Validation: {
				NameRequired: () => 'Name is required',
				PercentageRange: () => 'Enter a percentage between 0 and 100',
				PercentageRequired: () => 'Enter a discount percentage',
				BundleGroupsRequired: () => 'Add at least one bundle group or category with a quantity',
				BenefitGroupsRequired: () => 'Add at least one benefit group or category with a quantity',
				QualifyingBenefitOverlap: () =>
					'A product group or category cannot be both a qualifying and a benefit target',
				OverridePriceRequired: () => 'Set an override price for at least one sales channel',
				ScopeTargetsRequired: () => 'Select at least one product group, category or product',
				RankRange: () => 'Enter a priority of 0 or higher'
			}
		},
		Detail: {
			SalesChannels: () => 'Sales Channels',
			DisplayTitle: () => 'Display title',
			StartDate: () => 'Start Date',
			EndDate: () => 'End Date',
			OverridePrice: () => 'Override Price',
			IncludeFees: () => 'Include Fees',
			ApplyToAllProducts: () => 'Apply to all products',
			ProductGroups: () => 'Product Groups',
			DiscountDefinition: () => 'Discount Definition',
			ApplicationRule: () => 'Application Rule',
			Prices: () => 'Prices',
			Title: () => 'Promotion Details',
			AppliesTo: () => 'Applies to',
			SellingUnit: () => 'Selling unit',
			CustomerEligibility: () => 'Customer eligibility',
			AppliesToEveryone: () => 'All customers',
			DaysOfWeek: () => 'Days of week',
			Discount: () => 'Discount',
			DiscountType: () => 'Discount type',
			DiscountValue: () => 'Discount value',
			Schedule: () => 'Schedule'
		},
		Edit: {
			Description: () => 'Edit the promotion details'
		},
		Delete: {
			Title: () => 'Delete promotion',
			Description: (args: { name: string }) =>
				'Are you sure you want to delete the promotion "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Promotion ' + String(args.name) + ' was deleted.'
		}
	},
	Promotion: {
		Title: () => 'Promotion',
		CreateTitle: () => 'Create promotion'
	},
	Marketing: {
		Title: () => 'Marketing',
		Library: () => 'Library',
		Campaigns: () => 'Campaigns',
		Channels: () => 'Channels',
		Messaging: () => 'Messaging',
		Journeys: () => 'Journeys',
		ContentNav: () => 'Content',
		LayoutNav: () => 'Layout',
		Channel: {
			Title: () => 'Marketing channels',
			NewChannel: () => 'New channel',
			NoChannels: () => 'No marketing channels yet',
			NoChannelsDescription: () =>
				'Create a marketing channel to publish content and layouts for a marketing surface.',
			CampaignCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'campaign', other: 'campaigns' }),
			SalesChannelsHint: () =>
				'Pick the sales channels that belong to this marketing channel. A sales channel can only belong to one marketing channel.',
			PublishableKeysHint: () =>
				'Pick the publishable keys (apps / clients) that resolve their feed and layout from this channel. A publishable key can only belong to one marketing channel.',
			SurfacesHint: () =>
				'Pick the client surfaces this channel serves. It is only offered for a surface it serves, and nothing is published to a surface left unchecked.',
			DeleteConfirm: () => 'Delete this marketing channel? Its publishable keys will be detached.',
			Field: {
				Name: () => 'Name',
				NamePlaceholder: () => 'e.g. Scan & Go, Self-Checkout, Media Screen',
				Description: () => 'Description',
				DescriptionPlaceholder: () => 'Optional description',
				SalesChannels: () => 'Sales channels',
				Surfaces: () => 'Surfaces',
				SurfacesPlaceholder: () => 'Select surfaces',
				PublishableKeys: () => 'Publishable keys',
				PublishableKeysPlaceholder: () => 'Select publishable keys'
			},
			Action: {
				Create: () => 'Create channel',
				Save: () => 'Save changes',
				Delete: () => 'Delete'
			}
		},
		Campaign: {
			Title: () => 'Campaign',
			NewCampaign: () => 'New campaign',
			NoCampaigns: () => 'No campaigns yet',
			NoCampaignsDescription: () => 'Create a campaign to schedule a group of promotions for the customer app.',
			ActiveNow: () => 'Active now',
			Scheduled: () => 'Scheduled',
			Draft: () => 'Draft',
			Ended: () => 'Ended',
			StatusEnum: (arg0: 'DRAFT' | 'PUBLISHED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Draft'
						case 'PUBLISHED':
							return 'Published'
						default:
							return String(v)
					}
				})(arg0),
			WindowStatusEnum: (arg0: 'DRAFT' | 'SCHEDULED' | 'ACTIVE' | 'ENDED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Draft'
						case 'SCHEDULED':
							return 'Scheduled'
						case 'ACTIVE':
							return 'Active now'
						case 'ENDED':
							return 'Ended'
						default:
							return String(v)
					}
				})(arg0),
			ItemTypeEnum: (arg0: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR' | 'CUSTOM') =>
				(v => {
					switch (v) {
						case 'BANNER':
							return 'Banner'
						case 'LIST':
							return 'List'
						case 'MODAL':
							return 'Modal'
						case 'SEPARATOR':
							return 'Separator'
						case 'CUSTOM':
							return 'Custom'
						default:
							return String(v)
					}
				})(arg0),
			Field: {
				Name: () => 'Name',
				NamePlaceholder: () => 'Campaign name',
				Description: () => 'Description',
				DescriptionPlaceholder: () => 'Optional description',
				Title: () => 'Title',
				ItemTitlePlaceholder: () => 'Opening hours',
				ApiKey: () => 'Publishable key',
				MarketingChannel: () => 'Marketing channel',
				Status: () => 'Status',
				StartsAt: () => 'Starts at',
				EndsAt: () => 'Ends at',
				EndsAtOpenEnded: () => 'No end date',
				Rank: () => 'Rank',
				Items: () => 'Items'
			},
			Action: {
				Publish: () => 'Publish',
				Unpublish: () => 'Unpublish',
				Save: () => 'Save changes',
				Delete: () => 'Delete',
				Duplicate: () => 'Duplicate',
				AddItem: () => 'Add item',
				MoveUp: () => 'Move up',
				MoveDown: () => 'Move down'
			},
			Validation: {
				StartsAtRequired: () => 'Start date is required to publish',
				EndsAtAfterStartsAt: () => 'End date must be after start date'
			},
			Item: {
				NoItems: () => 'No items yet',
				NoItemsDescription: () => 'Add a banner, list, modal or separator to start building this campaign.'
			},
			Link: {
				TypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK' | 'IMAGE') =>
					(v => {
						switch (v) {
							case 'NONE':
								return 'None'
							case 'BROWSER':
								return 'Browser URL'
							case 'DEEP_LINK':
								return 'Deep link'
							case 'IMAGE':
								return 'Image preview'
							default:
								return String(v)
						}
					})(arg0),
				BrowserUrl: () => 'URL',
				DeepLink: () => 'Deep link path',
				ImageUrl: () => 'Image URL',
				ImageSource: () => 'Image to preview',
				ImageSourceHelp: () => 'Enlarge the banner’s own image, or point to a different image.',
				ImageSourceEnum: (arg0: 'BANNER' | 'CUSTOM') =>
					(v => {
						switch (v) {
							case 'BANNER':
								return 'Use the banner image'
							case 'CUSTOM':
								return 'Custom image URL'
							default:
								return String(v)
						}
					})(arg0)
			},
			Help: {
				MarketingChannel: () => 'Which group of sales channels will see this campaign.',
				Status: () =>
					'Draft campaigns are hidden from the app. Published campaigns appear during their schedule.',
				Schedule: () =>
					'Optional. Leave the start empty to show immediately and the end empty to run indefinitely. Expired campaigns are hidden automatically.',
				StartsAt: () => 'Defaults to 00:00 on the day you pick. Leave empty to show immediately.',
				EndsAt: () => 'Defaults to 23:59 on the day you pick. Leave empty to run indefinitely.',
				Rank: () => 'When several campaigns are active at once, higher rank appears first.',
				Items: () => 'Items render top to bottom in the customer app, in exactly this order.'
			},
			Preview: {
				Title: () => 'Preview',
				Empty: () => 'Add items to preview how this campaign looks in the app.',
				Disclaimer: () => 'Approximate preview of the customer app home screen.'
			},
			AdvancedOptions: () => 'Advanced options',
			BannerTypeEnum: (arg0: 'IMAGE' | 'TEXT_WITH_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'IMAGE':
							return 'Image'
						case 'TEXT_WITH_BACKGROUND':
							return 'Text with background'
						default:
							return String(v)
					}
				})(arg0),
			BannerText: () => 'Text',
			ListImages: () => 'List images',
			AddImage: () => 'Add image',
			AddImages: () => 'Add images',
			AddImagesCount: (args: { count: number }) =>
				'Add ' + String(args.count) + ' ' + plural('en', args.count, { one: 'image', other: 'images' }),
			ThumbnailLinkTypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Image preview'
						case 'BROWSER':
							return 'Browser URL'
						case 'DEEP_LINK':
							return 'Deep link'
						default:
							return String(v)
					}
				})(arg0),
			JoinAbove: () => 'Join with block above',
			ShowTitle: () => 'Show title',
			ShowTitleHelp: () => 'Optional heading shown above this item in the app.',
			ListImageShape: () => 'Image shape',
			ListImageShapeEnum: (arg0: 'SQUARE' | 'PORTRAIT' | 'LANDSCAPE') =>
				(v => {
					switch (v) {
						case 'SQUARE':
							return 'Square'
						case 'PORTRAIT':
							return 'Portrait'
						case 'LANDSCAPE':
							return 'Landscape'
						default:
							return String(v)
					}
				})(arg0),
			ListImageSize: () => 'Image size',
			ListImageSizeHelp: () => 'A partial next image stays visible so customers know they can scroll.',
			ListImageSizeEnum: (arg0: 'LARGE' | 'MEDIUM' | 'SMALL') =>
				(v => {
					switch (v) {
						case 'LARGE':
							return 'Large'
						case 'MEDIUM':
							return 'Medium'
						case 'SMALL':
							return 'Small'
						default:
							return String(v)
					}
				})(arg0),
			ModalCover: () => 'Modal cover image',
			ContainerClassName: () => 'Container class name',
			CustomInfo: () => 'Custom items are rendered by the customer app. There are no editable fields here.',
			TapAction: () => 'When tapped',
			TapActionHelp: () =>
				'Where this banner goes when tapped, or a built-in action instead. Built-in actions replace navigation.',
			TapActionNavigate: () => 'Navigate',
			TapActionBuiltIn: () => 'Built-in',
			PromotionAction: () => 'Tap action',
			PromotionActionHelp: () => 'Optional built-in behaviour when the banner is tapped, overriding the link.',
			PromotionActionEnum: (arg0: 'NONE' | 'ADD_LOYALTY_CARD_TO_WALLET' | 'LOYALTY_CARD_INFO') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'None'
						case 'ADD_LOYALTY_CARD_TO_WALLET':
							return 'Add loyalty card to wallet'
						case 'LOYALTY_CARD_INFO':
							return 'Show loyalty card info'
						default:
							return String(v)
					}
				})(arg0)
		},
		Placement: {
			Title: () => 'Placements',
			Help: () =>
				"A placement is this campaign's content on one marketing channel. Add a placement per channel that should show this campaign.",
			Add: () => 'Add placement',
			Empty: () => 'Add a placement to define what this campaign shows on a channel.',
			Count: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'placement', other: 'placements' }),
			Rank: () => 'Rank',
			RankHelp: () => 'When several campaigns are active at once, higher rank appears first in the feed.',
			Delete: () => 'Remove placement',
			DeleteConfirm: () => 'Remove this placement? Its content will be deleted.'
		},
		Layout: {
			Title: () => 'Feed layout',
			Help: () =>
				"The persistent structure of this channel's feed. Static blocks (banners, links, separators) always show, and the campaign zone marks where active campaign content is injected.",
			AddCampaignZone: () => 'Add campaign zone',
			CampaignZone: () => 'Campaign zone',
			CampaignZoneHint: () => 'Active campaigns render here',
			DrawerHint: () => 'Arrange the persistent blocks and campaign zone for this channel',
			UnsavedConfirm: () => 'You have unsaved changes that will be lost. Continue to the feed layout?',
			PreviewModeLayout: () => 'Layout',
			PreviewModeLive: () => 'Live feed',
			LivePreviewHint: () => 'The published feed customers see now, including active campaigns.',
			CheckoutPreviewHint: () =>
				'What this checkout screen shows right now. Scheduled backgrounds only appear during their window.'
		},
		Content: {
			Title: () => 'Content',
			NewContent: () => 'New content',
			NoContent: () => 'No content yet',
			NoContentDescription: () => 'Create a content block, then add it to a channel layout to make it live.',
			NoMatches: () => 'No matching content',
			NoMatchesDescription: () => 'No content matches the current search and filters.',
			ClearFilters: () => 'Clear filters',
			ChannelFilter: () => 'Marketing channel',
			TypeOption: (arg0: 'ALL' | 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'ALL':
							return 'All'
						case 'FEED':
							return 'Customer app feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Checkout screen'
						default:
							return String(v)
					}
				})(arg0),
			BlockCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('en', args.count, { one: 'block', other: 'blocks' }),
			LayoutCount: (args: { count: number }) =>
				'In ' + String(args.count) + ' ' + plural('en', args.count, { one: 'layout', other: 'layouts' }),
			NotInLayout: () => 'Not in any layout',
			DeleteConfirm: () => 'Delete this content? It will be removed from every channel layout.',
			DuplicateSuccess: () => 'Content duplicated',
			Blocks: () => 'Blocks',
			BlocksHelp: () => 'Blocks render top to bottom in the customer app, in exactly this order.',
			SaveDraft: () => 'Save as draft',
			SaveAndPublish: () => 'Save and publish',
			SaveSuccess: () => 'Changes saved',
			PublishSuccess: () => 'Content published',
			UnpublishSuccess: () => 'Content unpublished',
			UnsavedChanges: () => 'Unsaved changes',
			DraftNotice: () => 'This content is a draft and is not shown to customers. Publish it when you are ready.',
			ExpiredTitle: () => 'This content has ended',
			ExpiredNotice: (arg0: DateInput) =>
				'This content ended on ' +
				dateAndTimeFormatter('en', arg0) +
				' and is not shown to customers. Give it a new schedule to run it again.',
			ExpiredSaveConfirm: () =>
				'This content has already ended, so it will stay hidden from customers. Save it with its current schedule anyway?',
			SaveAnyway: () => 'Save anyway',
			ClearEndDate: () => 'Clear end date',
			RunToday: () => 'Run today',
			NewFeedContent: () => 'Customer app feed',
			NewFeedContentHint: () => 'Banners, image lists and more for the customer app feed',
			NewCheckoutBackground: () => 'Checkout screen',
			NewCheckoutBackgroundHint: () => 'One full-screen image for the self-checkout exit screen',
			Format: (arg0: 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'FEED':
							return 'Customer app feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Checkout screen'
						default:
							return String(v)
					}
				})(arg0),
			BackgroundImage: () => 'Background image',
			BackgroundHelp: () =>
				'Fills the whole self-checkout exit screen. On the bag check and cleared screens it replaces the built-in message, so the image itself must tell the customer what to do. Landscape images work best.',
			BackgroundEmpty: () =>
				'No image yet. Pick one from the marketing library, or nothing is shown on the checkout screen.'
		},
		ContentLayout: {
			Title: () => 'Layout',
			Help: () =>
				'Order the published content for a channel. This is the feed customers see, top to bottom. Scheduled content only appears during its window.',
			SelectChannel: () => 'Channel',
			NoChannels: () => 'Create a marketing channel before arranging a layout.',
			GoToChannels: () => 'Go to marketing channels',
			AvailableTitle: () => 'Available content',
			NoAvailable: () => 'All content is already in this layout.',
			InLayoutTitle: () => 'In this layout',
			Empty: () => 'No content in this layout yet. Add content from the list to build the feed.',
			Add: () => 'Add to layout',
			Remove: () => 'Remove from layout',
			Save: () => 'Save layout',
			Saved: () => 'Layout saved',
			PreviewTitle: () => 'Live feed preview',
			SingleContentWarning: () =>
				'This screen shows for only a few seconds, so only the first item is seen. Keep a single item here.',
			CheckoutHelp: () =>
				'Pick the backgrounds shown on this checkout screen. Several backgrounds on the idle screen rotate; the bag check and cleared screens only show the first, in place of their built-in message.',
			AvailableBackgroundsTitle: () => 'Available backgrounds',
			NoBackgrounds: () => 'No checkout backgrounds yet. Create one to show it on this screen.',
			NewBackground: () => 'New background',
			NewBackgroundTitle: () => 'New checkout background',
			NewBackgroundDescription: () =>
				'Pick an image from the marketing library. It is published right away and added to this screen.',
			NewBackgroundCreate: () => 'Create and add',
			NewBackgroundCreated: () => 'Background added. Save the layout to put it live.',
			WrongFormatOnCheckout: () =>
				'Customer app feed content is not shown on the checkout screen. Remove it and add a background instead.',
			WrongFormatOnFeed: () =>
				'Checkout backgrounds are not shown in the customer app feed. Remove it from this layout.',
			RemoveFlaggedToSave: () => 'Remove the flagged items to save this layout.'
		},
		Surface: {
			Label: () => 'Surface',
			CustomerAppFeed: () => 'Customer app feed',
			CheckoutScreen: () => 'Checkout screen'
		},
		ScreenState: {
			Label: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Default'
						case 'CHECKOUT_IDLE':
							return 'Idle'
						case 'CHECKOUT_BAG_CHECK':
							return 'Bag check'
						case 'CHECKOUT_CLEARED':
							return 'Cleared'
						default:
							return String(v)
					}
				})(arg0),
			Hint: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Always shown'
						case 'CHECKOUT_IDLE':
							return 'While waiting for a customer to scan'
						case 'CHECKOUT_BAG_CHECK':
							return 'When a staff bag check is required'
						case 'CHECKOUT_CLEARED':
							return 'When the customer is cleared to exit'
						default:
							return String(v)
					}
				})(arg0)
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Bag check needed',
			BagCheckBody: () => 'A staff member will come check out your cart',
			ClearedTitle: () => 'All good',
			ClearedBody: () => 'You can exit now',
			Disclaimer: () => 'Approximate preview of the checkout screen.',
			FallbackHint: () => 'No background set, so the screen shows its built-in message.'
		},
		LibraryPage: {
			NoAssets: () => 'No marketing assets yet',
			NoAssetsDescription: () => 'Upload images, banners and other marketing visuals here.',
			Filename: () => 'Filename',
			TableView: () => 'Table view',
			GalleryView: () => 'Gallery view',
			Upload: () => 'Upload',
			SearchFilename: () => 'Search by filename',
			ViewFullImage: () => 'View full image',
			CopyUrl: () => 'Copy url',
			CopiedUrl: () => 'URL copied',
			DeleteAsset: () => 'Delete asset',
			DeleteAssetConfirm: () => 'Delete this asset? It cannot be undone.',
			UploadAssets: () => 'Upload assets',
			UploadDropzone: () => 'Drag and drop images here, or click to choose files',
			ChooseFiles: () => 'Choose files',
			Tags: () => 'Tags',
			UsedBy: () => 'Used by',
			UsageFilter: () => 'Usage',
			UsageUnused: () => 'Unused',
			UsageProduct: () => 'Product',
			UsageProductGroup: () => 'Product group',
			UsageProductCategory: () => 'Product category',
			UsageMarketingContent: () => 'Marketing content',
			UsageFeedLayout: () => 'Customer app feed',
			ChannelFilter: () => 'Marketing channel',
			ContentFilter: () => 'Used by content',
			ChannelNone: () => 'No channel',
			ContentNone: () => 'No content',
			TagsPlaceholder: () => 'Add a tag and press Enter',
			Uploading: () => 'Uploading',
			EditTags: () => 'Edit tags',
			NoTags: () => 'No tags',
			ManageTags: () => 'Manage tags',
			ManageTagsEmpty: () => 'No tags in the library yet.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' assets',
			CreateTag: () => 'Create tag',
			CreateTagPlaceholder: () => 'Add a tag and press Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Tag "' + String(args.tag) + '" created.',
			RenameTag: () => 'Rename tag',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Merge tag "' +
				String(args.from) +
				'" into "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' assets)? The old tag will be removed.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tag renamed from "' + String(args.from) + '" to "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Remove tag "' + String(args.tag) + '" from all assets? Files are not deleted.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tag removed from ' +
				String(args.count) +
				' ' +
				plural('en', args.count, { one: 'asset', other: 'assets' }) +
				'.'
		}
	},
	Settings: {
		Title: () => 'Settings',
		Sidebar: {
			Profile: () => 'Profile',
			Store: () => 'Store',
			Users: () => 'Users',
			SalesChannels: () => 'Sales Channels',
			PointOfSale: () => 'Point of Sale',
			ProductGroups: () => 'Product Groups',
			Exports: () => 'Exports',
			Analytics: () => 'Analytics',
			Companies: () => 'Companies',
			CompanyCards: () => 'Company Cards',
			Settlements: () => 'Settlements'
		},
		Profile: {
			Title: () => 'Profile',
			EditTitle: () => 'Edit Profile',
			PersonalInfo: () => 'Personal Information',
			Preferences: () => 'Preferences',
			NamePlaceholder: () => 'Enter your name',
			EmailPlaceholder: () => 'Enter your email',
			UpdateSuccess: () => 'Profile updated successfully',
			Edit: {
				Description: () => 'Edit your profile information'
			}
		},
		Users: {
			Title: () => 'Users',
			InviteUser: () => 'Create invite',
			InviteTitle: () => 'Create invite',
			InviteSuccess: () => 'Invite created',
			InviteSentTo: (args: { email: string }) => 'Invite sent to ' + String(args.email),
			SendInvite: () => 'Create invite',
			CopyInviteLink: () => 'Copy invite link',
			DeleteUserDescription: (args: { email: string }) =>
				'Remove ' + String(args.email) + '? They will no longer be able to sign in.',
			DeleteUserSuccess: () => 'User removed',
			EditTitle: () => 'Edit User',
			EditSuccess: () => 'User updated successfully',
			DeleteInviteDescription: (args: { email: string }) =>
				'Remove the pending invite for ' + String(args.email) + '?',
			DeleteInviteSuccess: () => 'Invite removed',
			Status: {
				Accepted: () => 'Accepted',
				Pending: () => 'Pending',
				Expired: () => 'Expired'
			},
			Type: {
				User: () => 'User',
				Invite: () => 'Invite'
			},
			Column: {
				Type: () => 'Type'
			},
			Role: {
				Admin: () => 'Admin',
				User: () => 'User'
			},
			Invite: {
				Description: () => 'Invite a new user to your store',
				EmailPlaceholder: () => 'Enter email address',
				NamePlaceholder: () => 'Enter name',
				UserInfo: () => 'User Information',
				UserAlreadyExists: (args: { email: string }) =>
					'A user with email ' + String(args.email) + ' already exists'
			},
			Detail: {
				Title: () => 'User Details',
				AdminOnly: () => 'Administrator access is required to view invite details.'
			},
			SignInCredentials: {
				Title: () => 'Sign-in credentials',
				Description: () => 'Set the Sign-in ID and PIN used to sign in at self-checkout and POS terminals.',
				SignInId: () => 'Sign-in ID',
				SignInIdPlaceholder: () => 'e.g. 1042',
				SignInIdHint: () =>
					'Numeric only. Only required for some hardware, such as self-checkout lanes. Leave blank if this user does not sign in on that hardware.',
				Pin: () => 'PIN',
				PinSet: () => 'A PIN is set',
				PinNotSet: () => 'No PIN set',
				NewPin: () => 'New PIN (6 digits)',
				PinPlaceholder: () => 'Leave blank to keep current PIN',
				ClearPin: () => 'Clear PIN',
				Save: () => 'Save',
				SaveSuccess: () => 'Credentials updated',
				SignInIdNumeric: () => 'Sign-in ID must be numeric',
				SignInIdTaken: () => 'Sign-in ID already in use',
				PinInvalid: () => 'PIN must be exactly 6 digits'
			}
		},
		SalesChannels: {
			Title: () => 'Sales Channels',
			CreateTitle: () => 'Create Sales Channel',
			CreateSuccess: () => 'Sales channel created successfully',
			EditTitle: () => 'Edit Sales Channel',
			EditSuccess: () => 'Sales channel updated successfully',
			Column: {
				CountryCode: () => 'Country',
				CurrencyCode: () => 'Currency',
				SalesChannelType: () => 'Type',
				FulfillmentProvider: () => 'Fulfillment Provider',
				AccessKeys: () => 'Access Keys',
				InventoryLocation: () => 'Inventory location',
				Group: () => 'Group'
			},
			InventoryLocationNone: () => 'None',
			InventoryLocationOptionalHint: () =>
				'Optional. Link this channel to an inventory location to track stock. Leave empty if inventory is not used.',
			SalesChannelTypeNone: () => 'None',
			GroupNone: () => 'None',
			GroupOptionalHint: () => 'Optional. Assign this channel to a group to organize related channels together.',
			Advanced: () => 'Advanced settings',
			TypeOptionalHint: () =>
				'Optional. Assign a type only to group channels that share fulfillment or preauthorization settings. Leave as None if unsure.',
			StorefrontUrl: () => 'Storefront URL',
			StorefrontUrlHint: () =>
				'Optional. Base URL of this tenant\\u2019s storefront. Set this to let Terminal POS show a "Get receipt" QR code after checkout; leave empty to hide it.',
			Groups: {
				Title: () => 'Sales Channel Groups',
				NavLabel: () => 'Groups',
				CreateTitle: () => 'Create group',
				CreateSuccess: () => 'Group created successfully',
				EditTitle: () => 'Edit group',
				EditSuccess: () => 'Group updated successfully',
				NamePlaceholder: () => 'Enter group name',
				Column: {
					Name: () => 'Name',
					MemberCount: () => 'Sales channels'
				},
				Members: {
					Title: () => 'Sales channels',
					Label: () => 'Sales channels',
					Placeholder: () => 'Select sales channels',
					Empty: () => 'No sales channels assigned yet.',
					Assigned: () => 'Assigned',
					FilterUnassigned: () => 'Unassigned',
					SaveSuccess: () => 'Sales channels updated',
					MoveWarning: {
						Title: () => 'Move sales channels between groups?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' of the selected sales channels currently belong to another group and will be moved here: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Delete group',
					Description: (args: { name: string }) =>
						'Are you sure you want to delete the group "' +
						String(args.name) +
						'"? Its sales channels will be unassigned but not deleted.',
					SuccessToast: (args: { name: string }) => 'Group ' + String(args.name) + ' was deleted.'
				}
			},
			Create: {
				BasicInfo: () => 'Basic Information',
				Description: () => 'Create a new sales channel',
				NamePlaceholder: () => 'Enter channel name'
			},
			Edit: {
				ApiNotAvailable: () => 'API not available',
				NotImplemented: () => 'Not implemented yet'
			},
			Detail: {
				Title: () => 'Sales Channel Details',
				AccessKeys: () => 'Access Keys',
				CreateAccessKey: () => 'Create Access Key',
				CreateAccessKeySuccess: () => 'Access key created successfully',
				PointOfSales: () => 'Points of Sale',
				PointOfSalesDescription: () => 'Manage point of sale locations for this channel'
			},
			AccessKeyType: {
				Title: () => 'Key Type',
				Publishable: () => 'Publishable Key',
				PublishableDescription: () => 'For client-side use (POS terminals, storefronts)',
				Api: () => 'API Key',
				ApiDescription: () => 'For server-side integrations'
			},
			TokenCreated: {
				Title: () => 'API Key Created',
				Description: () => 'This token can only be viewed once. Please save it before closing this dialog.',
				Token: () => 'API Token'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Key'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Access keys',
			NavLabel: () => 'Access keys',
			Manage: () => 'Manage',
			Create: () => 'Create access key',
			EditTitle: () => 'Edit access key',
			None: () => '—',
			SaveSuccess: () => 'Access key updated',
			DeleteConfirm: () => 'Delete this access key? Apps using it will stop working.',
			DeleteSuccess: () => 'Access key deleted',
			Column: {
				Key: () => 'Key',
				SalesChannels: () => 'Sales channels',
				MarketingChannel: () => 'Marketing channel'
			},
			Empty: {
				Title: () => 'No access keys',
				Description: () => 'Create a publishable key and link it to sales channels and a marketing channel.'
			},
			Field: {
				SalesChannels: () => 'Sales channels',
				SalesChannelsPlaceholder: () => 'Select sales channels',
				SalesChannelsRequired: () => 'Select at least one sales channel',
				MarketingChannel: () => 'Marketing channel',
				MarketingChannelPlaceholder: () => 'Select a marketing channel',
				DevelopmentMode: () => 'Development mode',
				DevelopmentModeHint: () =>
					'Unlocks developer tools (settings screens + OTA update controls) in the merchant app for kiosks paired with this key.'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Sales Channel Types',
			NavLabel: () => 'Types',
			CreateTitle: () => 'Create Sales Channel Type',
			CreateSuccess: () => 'Sales channel type created successfully',
			EditTitle: () => 'Edit Sales Channel Type',
			EditSuccess: () => 'Sales channel type updated successfully',
			Column: {
				FulfillmentProvider: () => 'Fulfillment Provider',
				PreauthorizationAmount: () => 'Preauthorization Amount',
				AllowCompletingUnderpaidOrders: () => 'Allow Completing Underpaid Orders'
			},
			FulfillmentProviderNone: () => 'None',
			InvalidPreauthorizationAmount: () => 'Enter a valid non-negative number',
			AllowCompletingUnderpaidOrdersHint: () =>
				'Complete an order even if the settled amount is short of the total. Only for one-shot-charge flows (e.g. the SandStar cooler) where there is no second chance to charge more.',
			Create: {
				NamePlaceholder: () => 'Enter type name'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Units of Measure',
			NavLabel: () => 'Units of Measure',
			Description: () =>
				'Shared units used across all products. Each product picks from these when adding pack sizes.',
			CreateTitle: () => 'Create Unit of Measure',
			CreateSuccess: () => 'Unit created',
			EditTitle: () => 'Edit Unit of Measure',
			EditSuccess: () => 'Unit updated',
			Column: {
				Code: () => 'Code',
				Name: () => 'Name',
				Quantity: () => 'Default Qty',
				Default: () => 'Default'
			},
			Code: () => 'Code',
			Name: () => 'Name',
			Quantity: () => 'Default quantity',
			QuantityHint: () => 'Shared quantity in base units (e.g. a 6-pack is 6). Leave blank for variable packs.',
			DefaultEach: () => 'Default unit for counted items',
			DefaultWeight: () => 'Default unit for weighed items',
			DefaultEachBadge: () => 'Default · each',
			DefaultWeightBadge: () => 'Default · weight',
			CodePlaceholder: () => 'e.g. PK6',
			NamePlaceholder: () => 'e.g. 6-pack',
			ManagedBySync: () => 'Managed by sync',
			ManagedBySyncHint: () => 'This unit is managed by an external integration and cannot be edited here.',
			InvalidCode: () => 'Code is required',
			InvalidQuantity: () => 'Quantity must be greater than zero',
			InUse: () => 'In use',
			Delete: {
				Title: () => 'Delete unit',
				Description: (args: { code: string }) => 'Delete ' + String(args.code) + '? This cannot be undone.'
			}
		},
		PointOfSale: {
			Title: () => 'Point of Sale',
			CreateTitle: () => 'Create Point of Sale',
			CreateSuccess: () => 'Point of sale created successfully',
			EditTitle: () => 'Edit Point of Sale',
			EditSuccess: () => 'Point of sale updated successfully',
			AllowedOperatingModesLabel: () => 'Allowed operating modes',
			SelectOperatingModes: () => 'Select operating modes',
			OperatingMode: (arg0: 'ADMIN' | 'POS' | 'BAG_CHECK' | 'SCO' | 'INVENTORY' | 'TERMINAL' | 'CHECKOUT') =>
				(v => {
					switch (v) {
						case 'ADMIN':
							return 'Admin'
						case 'POS':
							return 'Point of Sale'
						case 'BAG_CHECK':
							return 'Bag Check'
						case 'SCO':
							return 'Self-Checkout'
						case 'INVENTORY':
							return 'Inventory'
						case 'TERMINAL':
							return 'Terminal'
						case 'CHECKOUT':
							return 'Checkout'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamLevelLabel: () => 'Device log streaming',
			LogStreamLevel: (arg0: 'OFF' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG') =>
				(v => {
					switch (v) {
						case 'OFF':
							return 'Off'
						case 'ERROR':
							return 'Error'
						case 'WARN':
							return 'Warn'
						case 'INFO':
							return 'Info'
						case 'DEBUG':
							return 'Debug'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamIdLabel: () => 'Log stream ID override',
			LogStreamIdPlaceholder: () => 'Defaults to the identifier above',
			LogStreamIdInvalidChars: () => 'Cannot contain ":" or "*"',
			LogStreamIdTooLong: () => 'Too long',
			ForcedOrientationLabel: () => 'Forced orientation',
			ForcedOrientationHint: () => 'Locks the screen of the device. Automatic follows the device.',
			ForcedOrientationAutomatic: () => 'Automatic',
			ForcedOrientation: (
				arg0: 'portrait' | 'portrait-reverse' | 'landscape' | 'landscape-reverse' | 'default'
			) =>
				(v => {
					switch (v) {
						case 'portrait':
							return 'Portrait'
						case 'portrait-reverse':
							return 'Portrait upside down'
						case 'landscape':
							return 'Landscape'
						case 'landscape-reverse':
							return 'Landscape reversed'
						case 'default':
							return 'Unlocked'
						default:
							return String(v)
					}
				})(arg0),
			SafeAreaInsetsLabel: () => 'Safe area inset overrides (px)',
			SafeAreaInsetsHint: () =>
				'For devices whose OS misreports safe area insets (e.g. always 0). Leave a side blank to use the real inset.',
			SafeAreaInsetTop: () => 'Top',
			SafeAreaInsetRight: () => 'Right',
			SafeAreaInsetBottom: () => 'Bottom',
			SafeAreaInsetLeft: () => 'Left',
			Column: {
				Identifier: () => 'Identifier',
				AccessKeys: () => 'Access Keys',
				Group: () => 'Group'
			},
			GroupNone: () => 'None',
			GroupOptionalHint: () =>
				'Optional. Assign this point of sale to a group to organize related terminals together.',
			LinkSalesChannelButton: () => 'Link',
			LinkSalesChannelTitle: () => 'Link a sales channel',
			LinkSalesChannelDescription: () => 'Add a sales channel to this point of sale.',
			LinkSalesChannelSuccess: () => 'Sales channel linked',
			SelectSalesChannel: () => 'Select a sales channel',
			NoUnlinkedSalesChannels: () => 'All sales channels are already linked.',
			Create: {
				BasicInfo: () => 'Basic Information',
				Description: () => 'Create a new point of sale location',
				NamePlaceholder: () => 'Enter location name',
				SelectSalesChannels: () => 'Select sales channels',
				IdentifierPlaceholder: () => 'Enter identifier'
			},
			Groups: {
				Title: () => 'Point of Sale Groups',
				NavLabel: () => 'Groups',
				CreateTitle: () => 'Create group',
				CreateSuccess: () => 'Group created successfully',
				EditTitle: () => 'Edit group',
				EditSuccess: () => 'Group updated successfully',
				NamePlaceholder: () => 'Enter group name',
				Column: {
					Name: () => 'Name',
					MemberCount: () => 'Points of sale'
				},
				Members: {
					Title: () => 'Points of sale',
					Label: () => 'Points of sale',
					Placeholder: () => 'Select points of sale',
					Empty: () => 'No points of sale assigned yet.',
					Assigned: () => 'Assigned',
					FilterUnassigned: () => 'Unassigned',
					SaveSuccess: () => 'Points of sale updated',
					MoveWarning: {
						Title: () => 'Move points of sale between groups?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' of the selected points of sale currently belong to another group and will be moved here: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Delete group',
					Description: (args: { name: string }) =>
						'Are you sure you want to delete the group "' +
						String(args.name) +
						'"? Its points of sale will be unassigned but not deleted.',
					SuccessToast: (args: { name: string }) => 'Group ' + String(args.name) + ' was deleted.'
				}
			},
			Detail: {
				Title: () => 'Point of Sale Details',
				AccessKeys: () => 'Access Keys'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Key'
				}
			},
			ProductMenu: {
				Title: () => 'Product Menu',
				Description: () => 'Product groups shown on this point of sale.',
				EmptyTitle: () => 'No menu groups',
				EmptyDescription: () => 'Add product groups to build the menu on this point of sale.',
				EditHeader: () => 'Product menu',
				EditDescription: () =>
					'Add the product groups shown on this point of sale and choose how each one appears.',
				AddPlaceholder: () => 'Add a product group…',
				NoGroupsSelected: () => 'No product groups added yet.',
				IconLabel: () => 'Icon fallback',
				IconPlaceholder: () => 'Select a fallback icon…',
				IconNone: () => 'None',
				IconUsesImageHint: () =>
					'This group has an image, which is shown on the menu instead of a fallback icon. Edit the image on the product group.',
				IconNotUsedWhenIndividual: () => 'Not used when products are shown individually on the menu.',
				ShowIndividually: () => 'Show products individually',
				ShowIndividuallyHint: () => 'Products appear directly on the menu instead of inside a group.',
				ShownIndividuallyBadge: () => 'Products shown individually',
				SaveSuccess: () => 'Menu updated.',
				Icons: {
					ShoppingBag: () => 'Shopping bag',
					ShoppingCart: () => 'Shopping cart',
					Coffee: () => 'Coffee',
					CupSoda: () => 'Cold drink',
					Utensils: () => 'Prepared food',
					Pizza: () => 'Pizza',
					Sandwich: () => 'Sandwich',
					IceCream: () => 'Ice cream',
					Beer: () => 'Beer',
					Wine: () => 'Wine',
					Bakery: () => 'Bakery',
					Gift: () => 'Gift'
				}
			}
		},
		Devices: {
			Title: () => 'Devices',
			NavLabel: () => 'Devices',
			AccessKeysEmptyTitle: () => 'No access keys',
			AccessKeysEmptyDescription: () => 'Create access keys to allow external systems to access this device.',
			Identifier: () => 'Identifier',
			LinkedPointOfSale: () => 'Point of sale',
			NotLinked: () => 'Not linked',
			MarketingChannel: () => 'Marketing channel',
			NoMarketingChannel: () => 'None',
			MarketingChannelDescription: () =>
				'Promotions on the checkout screen are resolved through this marketing channel. Independent of the point of sale link.',
			OperatingModes: () => 'Operating modes',
			StatusColumn: () => 'Status',
			AccessKeysColumn: () => 'Access keys',
			EmptyTitle: () => 'No devices',
			EmptyDescription: () => 'Create a device to get started.',
			CreateTitle: () => 'Create device',
			CreateSuccess: () => 'Device created',
			EditTitle: () => 'Edit device',
			NamePlaceholder: () => 'e.g. Front register',
			IdentifierPlaceholder: () => 'Leave empty to generate one',
			UpdateSuccess: () => 'Device updated',
			DeleteButton: () => 'Delete device',
			DeleteConfirmTitle: () => 'Delete this device?',
			DeleteConfirmDescription: () =>
				'This removes the device and revokes its access keys. This cannot be undone.',
			DeleteSuccess: () => 'Device deleted',
			LinkButton: () => 'Link point of sale',
			LinkTitle: () => 'Link to a point of sale',
			LinkDescription: () =>
				'A device operating as a point of sale resolves its sales channels and orders through the linked point of sale. Linking replaces any device currently operating as this point of sale.',
			LinkSuccess: () => 'Device linked',
			SelectPointOfSale: () => 'Select a point of sale',
			UnlinkButton: () => 'Unlink',
			UnlinkConfirmTitle: () => 'Unlink this point of sale?',
			UnlinkConfirmDescription: () =>
				'The device will stop resolving sales channels and orders until it is linked again.',
			UnlinkSuccess: () => 'Point of sale unlinked',
			LinkedDevicesTitle: () => 'Devices',
			LinkedDevicesEmpty: () => 'No devices are linked to this point of sale.',
			LinkDeviceButton: () => 'Link device',
			LinkDeviceDisabledHint: () => 'Unlink the current device before linking a new one.',
			PointOfSaleOccupiedOption: (arg0: string) => String(arg0) + ' (device already linked)',
			LinkDeviceTitle: () => 'Link a device',
			LinkDeviceDescription: () => 'Pick an unlinked device to operate as this point of sale.',
			SelectDevice: () => 'Select a device',
			NoUnlinkedDevices: () => 'No unlinked devices available.',
			Config: {
				Default: () => 'Default',
				Enabled: () => 'Enabled',
				Disabled: () => 'Disabled',
				GeneralSection: () => 'General',
				ScoSection: () => 'Self-checkout',
				SoundsSection: () => 'Sounds',
				LoggingSection: () => 'Logging',
				DisplaySection: () => 'Display',
				CheckoutSection: () => 'Checkout mode',
				DefaultPaymentMethod: () => 'Default payment method',
				ForcedOrientation: () => 'Forced orientation',
				ForcedFormFactor: () => 'Forced form factor',
				Language: () => 'Language',
				ShowPrinterDisconnected: () => 'Show printer disconnected warning',
				ProductListColumns: () => 'Product list columns',
				BrowseEnabled: () => 'Browse',
				AdjustQuantity: () => 'Adjust quantity',
				ClearCart: () => 'Clear cart',
				ItemDeletion: () => 'Item deletion',
				OrderRestart: () => 'Order restart',
				Permission: (arg0: 'ENABLED' | 'STAFF_NEEDED' | 'DISABLED') =>
					(v => {
						switch (v) {
							case 'ENABLED':
								return 'Enabled'
							case 'STAFF_NEEDED':
								return 'Staff needed'
							case 'DISABLED':
								return 'Disabled'
							default:
								return String(v)
						}
					})(arg0),
				SplitPercentHorizontal: () => 'Workspace split, horizontal (%)',
				SplitPercentVertical: () => 'Workspace split, vertical (%)',
				ItemAddedSound: () => 'Item added sound',
				ProductNotFoundSound: () => 'Product not found sound',
				AddToCartFailedSound: () => 'Add to cart failed sound',
				PaymentSuccessSound: () => 'Payment success sound',
				PaymentFailedSound: () => 'Payment failed sound',
				InactivityThresholdSeconds: () => 'Inactivity threshold (seconds)',
				AbandonCountdownSeconds: () => 'Abandon countdown (seconds)',
				CoolerReadyTimeoutSeconds: () => 'Cooler ready timeout (seconds)',
				CheckoutModeIdleTimeoutSeconds: () => 'Scanner idle timeout (seconds)',
				CheckoutModeTheme: () => 'Theme override (JSON)',
				CheckoutModeThemeHint: () =>
					'Object with optional "colors" and "fonts" maps. Leave empty for the base theme.',
				InvalidJson: () => 'Must be a valid JSON object'
			}
		},
		DeviceStatus: {
			Title: () => 'Device status',
			Online: () => 'Online',
			Offline: () => 'Offline',
			NeverReported: () => 'This point of sale has never reported its status.',
			ReportedAt: () => 'Last reported',
			AppVersion: () => 'App version',
			DisplayRuntimeVersion: () => 'Runtime version',
			ConfiguredRuntimeVersion: () => 'Configured runtime',
			Platform: () => 'Platform',
			DeviceModel: () => 'Device model',
			NetworkType: () => 'Network',
			UpdateChannel: () => 'Update channel',
			UpdateId: () => 'Update ID',
			UpdateCreatedAt: () => 'Update published',
			UpdatePending: (args: { time: string }) => 'Downloaded, waiting for idle since ' + String(args.time),
			OperatingMode: () => 'Operating mode',
			Health: () => 'Health',
			PrinterConnected: () => 'Printer',
			ScannerConnected: () => 'Scanner',
			PaymentTerminalReachable: () => 'Payment terminal',
			Connected: () => 'Connected',
			Disconnected: () => 'Disconnected',
			Unknown: () => 'Unknown',
			Environment: () => 'Environment (redacted)',
			RefreshButton: () => 'Refresh status',
			RefreshSuccess: () => 'Refresh requested',
			PushUpdateButton: () => 'Push update',
			PushUpdateSuccess: () => 'Update push sent',
			RestartAppButton: () => 'Restart app',
			RestartAppSuccess: () => 'Restart command sent',
			RestartAppConfirmTitle: () => 'Restart this app?',
			RestartAppConfirmDescription: () => 'The app will reload once the terminal is idle.',
			LockKioskButton: () => 'Lock kiosk',
			LockKioskSuccess: () => 'Kiosk lock sent',
			LockKioskOffline: () => 'Device is offline',
			LockKioskConfirmTitle: () => 'Lock this kiosk?',
			LockKioskConfirmDescription: () =>
				'The kiosk locks immediately, the same as if staff tapped Lock on the device.',
			UnlockKioskButton: () => 'Unlock kiosk',
			UnlockKioskSuccess: () => 'Kiosk unlock sent',
			UnlockKioskConfirmTitle: () => 'Unlock this kiosk?',
			UnlockKioskConfirmDescription: () =>
				'The kiosk unlocks immediately without a staff PIN. Only do this if you are sure staff should have access.',
			PushUpdateDrawer: {
				Title: () => 'Push app update',
				Description: () =>
					'Notify this point of sale to check for and download an update. It downloads immediately but only restarts once the terminal is idle.',
				ChannelLabel: () => 'Channel override',
				ChannelPlaceholder: () => 'Leave empty to use the current channel',
				Submit: () => 'Push update'
			},
			Enrollment: {
				Title: () => 'Enrolled device',
				NotEnrolled: () => 'No device is currently enrolled for this point of sale.',
				DeviceModel: () => 'Device model',
				Platform: () => 'Platform',
				AppVersion: () => 'App version',
				EnrolledAt: () => 'Enrolled',
				Key: () => 'Key',
				EnrollButton: () => 'Enroll device',
				RevokeButton: () => 'Revoke',
				RevokeConfirmTitle: () => 'Revoke this device?',
				RevokeConfirmDescription: () =>
					'The device will be signed out immediately and will need to be paired again to regain access.',
				RevokeSuccess: () => 'Device revoked',
				EnrollDrawer: {
					Title: () => 'Enroll device',
					Description: () => 'Enter the 8-digit pairing code shown on the device.',
					CodeLabel: () => 'Pairing code',
					CodePlaceholder: () => '1234 5678',
					LookupButton: () => 'Look up device',
					LookupError: () => 'This code is invalid or has expired.',
					ConfirmTitle: () => 'Enroll this device?',
					ConfirmDescriptionWithCurrent: (args: { device: string; currentDevice: string }) =>
						'This issues a new key to "' +
						String(args.device) +
						'" and immediately signs out the device currently enrolled ("' +
						String(args.currentDevice) +
						'").',
					ConfirmDescription: (args: { device: string }) =>
						'This issues a new key to "' + String(args.device) + '".',
					Submit: () => 'Enroll',
					EnrollSuccess: () => 'Device enrolled'
				}
			},
			Gms: {
				Title: () => 'Android device management (GMS)',
				ProviderEloview: () => 'EloView',
				ProviderGms: () => 'GMS',
				NotEnrolled: () => 'This device is not enrolled in GMS.',
				EnrollButton: () => 'Enroll device',
				EnrollSuccess: () => 'Enrollment started',
				DeviceName: () => 'AMAPI device',
				State: () => 'State',
				AppliedState: () => 'Applied state',
				PolicyCompliant: () => 'Policy compliant',
				NonComplianceReasons: () => 'Non-compliance reasons',
				LastPolicySync: () => 'Last policy sync',
				InstalledVersionCode: () => 'Installed version code',
				MinimumVersionCode: () => 'Minimum version code (pinned)',
				HardwareModel: () => 'Hardware model',
				AndroidVersion: () => 'Android version',
				NoBoundDevice: () => 'Waiting for the device to enroll…',
				Yes: () => 'Yes',
				No: () => 'No',
				VersionUnpinned: () => 'Unpinned (latest available)',
				ApplyVersionButton: () => 'Apply',
				ApplyVersionSuccess: () => 'Minimum version updated',
				WifiNetworks: () => 'Wi-Fi networks',
				WifiAddNetwork: () => 'Add network',
				WifiSsid: () => 'Network name (SSID)',
				WifiPassword: () => 'Password',
				WifiSecurityOpen: () => 'Open (no password)',
				WifiSecurityWpaPsk: () => 'Secured (WPA/WPA2)',
				WifiHidden: () => 'Hidden network',
				WifiRemove: () => 'Remove',
				WifiSaveSuccess: () => 'Wi-Fi networks saved',
				WifiEmpty: () => 'No networks configured',
				WifiPasswordKeepHint: () => 'Leave blank to keep current password',
				PlayTrack: () => 'Play track',
				TrackProduction: () => 'Production (default)',
				ApplyTrackSuccess: () => 'Play track updated',
				PolicyPreset: () => 'Policy preset',
				ApplyPresetSuccess: () => 'Policy preset applied',
				PolicyPresets: {
					ELO: () => 'Elo (kiosk + Elo OEMConfig)',
					ZEBRA: () => 'Zebra (kiosk lockdown)',
					MANAGED_APP: () => 'Managed app (installs merchant app)',
					DEBUGGING: () => 'Debugging (enables ADB, any computer)'
				},
				RebootButton: () => 'Reboot device',
				RebootSuccess: () => 'Reboot command sent',
				RebootConfirmTitle: () => 'Reboot this device?',
				RebootConfirmDescription: () => 'The device will restart immediately.',
				UnenrollButton: () => 'Unenroll device',
				UnenrollSuccess: () => 'Device unenrolled',
				UnenrollConfirmTitle: () => 'Unenroll this device?',
				UnenrollConfirmDescription: () =>
					'This wipes the device from the AMAPI fleet — equivalent to a factory reset. It will need to be re-enrolled from scratch.',
				PolicyOverridesLabel: () => 'Raw policy overrides (JSON)',
				PolicyOverridesHint: () =>
					'Advanced: a raw AMAPI Policy fragment, deep-merged over the hardcoded base template. Developer-only.',
				PolicyOverridesInvalidJson: () => 'Invalid JSON',
				SaveOverridesButton: () => 'Save overrides',
				ResetOverridesButton: () => 'Reset',
				SaveOverridesSuccess: () => 'Policy overrides saved',
				EnrollDrawer: {
					Title: () => 'Enroll in GMS',
					Description: () =>
						'Generates a one-time enrollment QR code. Factory reset the device, tap 6 times on the welcome screen, then scan the code with the camera.',
					WifiSsidLabel: () => 'Wi-Fi network (optional)',
					WifiPasswordLabel: () => 'Wi-Fi password (optional)',
					PolicyPresetLabel: () => 'Policy preset',
					Submit: () => 'Generate QR code',
					QrExpiresAt: (args: { time: string }) => 'Expires at ' + String(args.time),
					Done: () => 'Done'
				}
			}
		},
		Exports: {
			Title: () => 'Exports',
			Description: () => 'Export data to various formats and systems',
			Export: () => 'Export',
			PricerTitle: () => 'Pricer Product Export',
			PricerSuccess: () => 'Pricer export successful',
			SalesChannel: () => 'Sales Channel UUID',
			VismaTitle: () => 'Visma Export',
			VismaSuccess: () => 'Visma export successful',
			DigiScaleTitle: () => 'DigiScale Product Export',
			DigiScaleSuccess: () => 'DigiScale export successful',
			SalesChannelUUIDs: () => 'Sales Channel UUIDs',
			GroupUUIDs: () => 'Product Group UUIDs',
			SAFTTitle: () => 'SAFT Export',
			SAFTSuccess: () => 'SAFT export successful',
			SAFTCashRegister: () => 'Cash Register',
			SAFTFinancial: () => 'Financial'
		},
		Integrations: {
			Title: () => 'Integrations',
			Description: () => 'Connect FastTrack to external services.',
			Teya: {
				Name: () => 'Teya',
				Description: () => 'Connect Teya to take card payments on your terminals.',
				StatusConnected: () => 'Connected',
				StatusDisconnected: () => 'Not connected',
				StatusError: () => 'Reconnection required',
				Connect: () => 'Connect Teya',
				Reconnect: () => 'Reconnect',
				Disconnect: () => 'Disconnect',
				Connecting: () => 'Waiting for connection…',
				ConnectedAt: (args: { date: string }) => 'Connected ' + String(args.date),
				Unavailable: () => 'Teya is not available for this business.',
				ConnectSuccess: () => 'Teya connected',
				DisconnectSuccess: () => 'Teya disconnected',
				DisconnectConfirm: () => 'Payments will stop routing to Teya terminals until you reconnect.',
				ConnectError: () => 'Could not start the Teya connection. Please try again.',
				PopupBlocked: () => 'Allow pop-ups to finish connecting Teya, then try again.',
				ConfigureStoreTerminals: () => 'Configure store & terminals',
				SelectStore: () => 'Select a store',
				SelectTerminal: () => 'Select a terminal',
				SelectStoreFirst: () => 'Select a store first.',
				NoStores: () => 'No stores found for this Teya account.',
				NoTerminals: () => 'No terminals found for this store.',
				ReconnectToConfigure: () => 'Reconnect Teya to configure stores and terminals.'
			},
			Rapyd: {
				SerialPlaceholder: () => 'PAX device serial number',
				Register: () => 'Register',
				Repair: () => 'Pair again',
				WaitingForPairing: () => 'Activate pairing on the terminal, then wait…',
				Paired: () => 'Paired',
				SerialTooShort: () => 'The serial number must be at least 10 characters.',
				RegisterError: () => 'Could not register the device with Rapyd. Please try again.',
				ApiKeyRequiredFirst: () => 'Save the API key in the global configuration before pairing a terminal.'
			},
			Providers: {
				teya: {
					Name: () => 'Teya',
					Description: () => 'Take card payments on your terminals.'
				},
				nets: {
					Name: () => 'NETS',
					Description: () => 'Take card payments through NETS terminals.'
				},
				'verifone-ecom': {
					Name: () => 'Verifone Ecommerce',
					Description: () => 'Accept online card payments through Verifone.'
				},
				'rapyd-cloudlink': {
					Name: () => 'Rapyd CloudLink',
					Description: () => 'Pair PAX card terminals to take payments.'
				},
				'verifone-pos-cloud': {
					Name: () => 'Verifone POS Cloud',
					Description: () => 'Take card payments on Verifone cloud terminals.'
				},
				struct: {
					Name: () => 'Struct',
					Description: () => 'Sync products from the Struct PIM.'
				}
			},
			Fields: {
				storeId: () => 'Store ID',
				terminalId: () => 'Terminal ID',
				eposInstanceId: () => 'ePOS instance ID',
				environment: () => 'Environment',
				merchantId: () => 'Merchant ID',
				username: () => 'Username',
				password: () => 'Password',
				organizationId: () => 'Organization ID',
				entityId: () => 'Entity ID',
				apiKey: () => 'API key',
				apiUrl: () => 'API URL',
				incomingWebhookEnabled: () => 'Incoming webhook enabled',
				incomingWebhookApiKey: () => 'Incoming webhook API key',
				secret: () => 'Secret',
				contractId: () => 'Contract ID',
				serialNumber: () => 'Serial number',
				deviceToken: () => 'Device',
				authMode: () => 'Auth mode',
				clientId: () => 'Client ID',
				clientSecret: () => 'Client secret',
				tokenUrl: () => 'Token URL',
				baseUrl: () => 'Base URL',
				poiId: () => 'POI ID (terminal)',
				saleId: () => 'Sale ID',
				operatorId: () => 'Operator ID',
				scope: () => 'Scope',
				siteEntityId: () => 'Site entity ID',
				terminalSimulator: () => 'Terminal simulator'
			},
			Config: {
				Back: () => 'Back to integrations',
				Global: () => 'Global configuration',
				GlobalDescription: () => 'Base settings applied everywhere unless overridden.',
				Overrides: () => 'Overrides',
				OverridesDescriptionSalesChannel: () => 'Override settings for specific sales channels.',
				OverridesDescriptionPointOfSale: () => 'Override settings for specific points of sale.',
				AddOverride: () => 'Add override',
				NoOverrides: () => 'No overrides',
				OverrideCount: (args: { count: number }) => String(args.count) + ' overrides',
				Configure: () => 'Configure',
				Save: () => 'Save',
				Saved: () => 'Configuration saved',
				SaveError: () => 'Could not save configuration',
				TargetSalesChannel: () => 'Sales channel',
				TargetPointOfSale: () => 'Point of sale',
				SelectTarget: () => 'Select…',
				Edit: () => 'Edit',
				Delete: () => 'Delete',
				DeleteOverride: () => 'Delete override',
				DeleteOverrideConfirm: () =>
					'This override will be removed and its settings will fall back to the global configuration.',
				EditOverride: () => 'Edit override',
				SecretSet: () => 'Configured',
				SecretUnset: () => 'Not configured',
				SecretPlaceholderSet: () => 'Leave blank to keep current',
				SecretPlaceholderUnset: () => 'Enter value'
			}
		},
		Billing: {
			Title: () => 'Billing',
			NavLabel: () => 'Billing',
			Description: () => 'Your FastTrack subscription plan.',
			EmptyTitle: () => 'No plan yet',
			EmptyDescription: () => 'No billing plan has been set up for your account yet.',
			EmptyContactPrefix: () => 'Contact',
			EmptyContactLink: () => 'Support',
			EmptyContactSuffix: () => 'to get started.',
			PlanHeading: () => 'Subscription plan',
			Note: () => 'Note',
			PlanDetails: () => 'Plan details',
			AdditionalFees: () => 'Additional fees',
			Amount: () => 'Amount',
			Interval: () => 'Billing period',
			Monthly: () => 'Monthly',
			Yearly: () => 'Yearly',
			OneTime: () => 'One-time',
			Net: () => 'Net',
			Vat: () => 'VAT',
			VatRate: () => 'VAT rate',
			Total: () => 'Total',
			TotalsHeading: () => 'Totals',
			MonthlyTotal: () => 'Monthly total',
			YearlyTotal: () => 'Yearly total',
			OneTimeTotal: () => 'One-time total',
			AgreementHeading: () => 'Agreement',
			SelfServeIntro: () => 'Your use of FastTrack is governed by the following policies:',
			PolicyPrivacy: () => 'Privacy Policy',
			PolicyTerms: () => 'Terms of Use',
			PolicyServices: () => 'Platform Services Agreement',
			PolicyDpa: () => 'Data Processing Agreement',
			PolicySupport: () => 'Support Policy',
			PolicyEula: () => 'Software License',
			EnterpriseNote: () => 'This plan is governed by your Master Services Agreement with Stack.',
			EnterpriseServicesLink: () => 'View the Platform Services Agreement',
			EnterpriseRefLabel: () => 'Agreement reference',
			StartDate: () => 'Start date',
			Status: () => 'Status',
			StatusAccepted: () => 'Accepted',
			StatusPending: () => 'Awaiting acceptance',
			AcceptedBy: () => 'Accepted by',
			Accept: () => 'Accept plan',
			AcceptConfirmTitle: () => 'Accept plan',
			AcceptConfirmDescription: () =>
				'By accepting, you confirm your agreement to the subscription plan shown above.',
			AcceptConfirmAction: () => 'Accept',
			AcceptSuccess: () => 'Plan accepted',
			AcceptError: () => 'Could not accept the plan. Please try again.',
			LoadError: () => 'Could not load your billing plan.'
		}
	},
	PointOfSale: {
		Title: () => 'Point of Sale'
	},
	Profile: {
		Title: () => 'Profile'
	},
	SalesChannels: {
		Title: () => 'Sales Channels'
	},
	Store: {
		Title: () => 'Store'
	},
	Users: {
		Title: () => 'Users'
	},
	CompanyCards: {
		Title: () => 'Company Cards',
		CreateTitle: () => 'Create Company Card',
		CreateSuccess: () => 'Company card created successfully',
		EditTitle: () => 'Edit Company Card',
		UpdateSuccess: () => 'Company card updated successfully',
		DeleteWarning: (args: { name: string }) =>
			'You are about to delete the company card ' + String(args.name) + '. This action cannot be undone.',
		Status: (arg0: 'ACTIVE' | 'INACTIVE') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Name: () => 'Name',
			CardNumber: () => 'Card Number',
			Status: () => 'Status',
			Company: () => 'Company',
			Customer: () => 'Customer',
			Employee: () => 'Employee',
			ExternalId: () => 'External ID',
			CreatedAt: () => 'Created'
		},
		Detail: {
			Title: () => 'Company Card Details',
			Transactions: () => 'Transactions',
			ResetPin: {
				Title: () => 'Reset PIN',
				Description: () => 'Are you sure you want to reset the PIN for this card?',
				Action: () => 'Reset PIN'
			},
			ResetPinSuccess: () => 'PIN reset successfully'
		},
		Edit: {
			BasicInfo: () => 'Basic Information',
			Description: () => 'Edit company card information',
			NamePlaceholder: () => 'Enter card name',
			SelectCompany: () => 'Select company',
			SelectEmployee: () => 'Select employee',
			ExternalIdPlaceholder: () => 'Enter external ID (optional)'
		}
	},
	Settlements: {
		Title: () => 'Settlements',
		CreateTitle: () => 'Create Settlement',
		CreateSuccess: () => 'Settlement created successfully',
		MarkSettled: () => 'Mark as Settled',
		MarkSettledSuccess: () => 'Settlement marked as settled',
		Column: {
			Company: () => 'Company',
			Period: () => 'Period',
			TotalAmount: () => 'Total Amount',
			TransactionCount: () => 'Transactions',
			SettledAt: () => 'Settled',
			CreatedAt: () => 'Created'
		},
		Detail: {
			Title: () => 'Settlement Details',
			Transactions: () => 'Transactions',
			Period: () => 'Period',
			TotalAmount: () => 'Total Amount',
			Status: () => 'Status',
			Settled: () => 'Settled',
			NotSettled: () => 'Not Settled'
		},
		Create: {
			Title: () => 'Create Settlement',
			Period: () => 'Period',
			Description: () => 'Create a new settlement for the company',
			PeriodStart: () => 'Period Start',
			PeriodEnd: () => 'Period End'
		}
	},
	Analytics: {
		Title: () => 'Analytics',
		Overview: () => 'Overview',
		Insights: () => 'Insights',
		SalesAnalytics: () => 'Sales',
		SalesAnalyticsDescription: () => 'Track revenue, orders, and top-performing products and channels.',
		UserAnalytics: () => 'Users',
		UserAnalyticsDescription: () => 'Track active users, new signups, and account deletion requests.',
		Basket: () => 'Basket',
		ActiveUsers: () => 'Active Users',
		NewSignups: () => 'New Signups',
		ChurnedUsers: () => 'Deletion Requests',
		ActiveUsersOverTime: () => 'Active Users Over Time',
		NewSignupsOverTime: () => 'New Signups Over Time',
		ChurnedUsersOverTime: () => 'Deletion Requests Over Time',
		DeltaNew: () => 'New',
		Revenue: () => 'Revenue',
		Orders: () => 'Orders',
		Growth: () => 'Growth',
		TotalRevenue: () => 'Total Revenue',
		AverageOrderValue: () => 'Average Order Value',
		Refunds: () => 'Refunds',
		RevenueOverTime: () => 'Revenue Over Time',
		TopProducts: () => 'Top Products',
		TopProductsByRevenue: () => 'By revenue',
		TopProductsByQuantity: () => 'By quantity',
		PaymentMethods: () => 'Payment Methods',
		RevenueByCategory: () => 'Revenue by Category',
		SalesByChannel: () => 'Sales by Channel',
		HourlyDistribution: () => 'Hourly Distribution',
		Day: () => 'Day',
		Week: () => 'Week',
		Month: () => 'Month',
		Quarter: () => 'Quarter',
		Year: () => 'Year',
		NoData: () => 'No data available for this period',
		VsDate: (arg0: string) => 'vs ' + String(arg0),
		VsDateRange: (arg0: string, arg1: string) => 'vs ' + String(arg0) + ' – ' + String(arg1),
		InProgress: () => '(in progress)',
		ComparePreviousPeriod: () => 'vs previous period',
		CompareSamePeriodLastYear: () => 'vs same period last year',
		CompareSpecific: {
			Day: () => 'vs a specific day',
			Week: () => 'vs a specific week',
			Month: () => 'vs a specific month',
			Quarter: () => 'vs a specific quarter',
			Year: () => 'vs a specific year'
		},
		CompareNone: () => 'No comparison',
		AllChannels: () => 'All channels',
		ChannelGroupOption: (arg0: string) => String(arg0) + ' (group)',
		CompareToChannel: () => 'Compare to channel',
		CompareToChannelNone: () => 'No channel comparison',
		ComparisonModePeriod: () => 'Period',
		ComparisonModeChannel: () => 'Channel',
		CompareByPeriod: () => 'Compare by period',
		CompareByChannel: () => 'Compare by channel',
		PeriodLabel: (arg0: string) => 'Period: ' + String(arg0),
		CompareBy: () => 'Compare by',
		ChannelsPageOf: (args: { current: number; total: number }) =>
			'Page ' + String(args.current) + ' of ' + String(args.total),
		QuarterLabel: (args: { quarter: number; year: number }) => 'Q' + String(args.quarter) + ' ' + String(args.year),
		JumpToPeriod: () => 'Jump to period',
		CurrentPeriod: () => 'Current period',
		IntervalLabel: (arg0: string) => 'Interval: ' + String(arg0),
		Reports: {
			Title: () => 'Reports',
			Description: () => 'Explore your sales data in detail, compare periods and channels, and export it.',
			SalesGroup: () => 'Sales',
			ViewReport: () => 'View report',
			Export: () => 'Export CSV',
			Rows: () => 'Break down by',
			RowsOption: {
				Hour: () => 'By hour',
				Day: () => 'By day',
				Week: () => 'By week',
				Month: () => 'By month',
				Product: () => 'By product'
			},
			ColumnsPicker: () => 'Columns',
			GroupBy: () => 'Group by',
			GroupByOption: {
				Hour: () => 'Hour',
				Day: () => 'Day',
				Week: () => 'Week',
				Month: () => 'Month'
			},
			Total: () => 'Total',
			Revenue: {
				Title: () => 'Revenue',
				Description: () => 'Revenue, orders, refunds and average order value over time.'
			},
			Products: {
				Title: () => 'Products',
				Description: () => 'Units sold, gross sales and orders per product.',
				FilterProducts: () => 'All products',
				GrossSalesNote: () =>
					'Product sales are gross line-item totals before refunds, so they can differ from net revenue.'
			},
			Columns: {
				Period: () => 'Period',
				Orders: () => 'Orders',
				Revenue: () => 'Revenue',
				Refunds: () => 'Refunds',
				AverageOrderValue: () => 'Avg. order value',
				Product: () => 'Product',
				Quantity: () => 'Quantity',
				GrossSales: () => 'Gross sales',
				Share: () => 'Share'
			}
		},
		ChartLabels: {
			Revenue: () => 'Revenue',
			Orders: () => 'Orders',
			Hour: () => 'Hour',
			Quantity: () => 'Quantity'
		},
		BasketAnalysis: {
			Title: () => 'Basket Analysis',
			Description: () => 'Discover which products and categories are frequently purchased together.',
			AvgItemsPerOrder: () => 'Avg. Items per Order',
			AvgUniqueProductsPerOrder: () => 'Avg. Unique Products per Order',
			OrdersAnalyzed: () => 'Orders Analyzed',
			ProductPairs: () => 'Product Pairs',
			CategoryAffinity: () => 'Category Affinity',
			AnchorProduct: () => 'Anchor Product',
			AnchorProductPlaceholder: () => 'Search for a product…',
			AllProducts: () => 'All products',
			Products: () => 'Products',
			ProductsPlaceholder: () => 'Filter products…',
			ExcludeProductsPlaceholder: () => 'Exclude products…',
			AllProductsFilter: () => 'All products',
			Categories: () => 'Categories',
			CategoriesPlaceholder: () => 'Filter categories…',
			ExcludeCategoriesPlaceholder: () => 'Exclude categories…',
			AllCategoriesFilter: () => 'All categories',
			SalesChannel: () => 'Sales Channel',
			AllSalesChannels: () => 'All sales channels',
			SalesChannelsSelected: (args: { count: number }) => String(args.count) + ' selected',
			SalesChannelSearchPlaceholder: () => 'Search sales channels…',
			PointOfSale: () => 'Point of Sale',
			AllPointsOfSale: () => 'All points of sale',
			MinSupport: () => 'Min. Co-occurrences',
			ProductA: () => 'Product A',
			ProductB: () => 'Product B',
			CategoryA: () => 'Category A',
			CategoryB: () => 'Category B',
			CoOccurrence: () => 'Co-occurrence',
			Support: () => 'Support',
			Confidence: () => 'Confidence',
			Lift: () => 'Lift',
			SupportTooltip: () =>
				'How common the pair is: the share of all orders that contain both A and B. For example, 2% means 2 in every 100 orders included both.',
			ConfidenceTooltip: () =>
				'How often B ends up in the basket when A does: the share of orders containing A that also contain B. For example, 40% means 4 in 10 orders with A also had B.',
			LiftTooltip: () =>
				'How much more often A and B are bought together than you would expect by chance. 1 means no link, 2 means twice as often as expected, and below 1 means they are rarely bought together.',
			NoProductPairs: () => 'No product pairs meet the minimum co-occurrence threshold for this period.',
			NoCategoryPairs: () => 'No category pairs meet the minimum co-occurrence threshold for this period.',
			NoAnchorPairs: () => 'No pairs found for the selected product in this period.',
			MetricPercent: (arg0: string) => String(arg0) + '%'
		}
	}
}

export const da = {
	LocaleName: () => 'Dansk',
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('da', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('da', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('da', arg1),
		OnlyAmount: (arg0: TranslationAmount) => amountOnlyFormatter('da', arg0)
	},
	Quantity: {
		Pieces: (arg0: number) => String(arg0) + 'x'
	},
	Weight: (arg0: Amount) => weightFormatter('da', arg0),
	Date: {
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('da', arg0),
		Short: (arg0: DateInput) => shortFormatter('da', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('da', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('da', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('da', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('da', arg0),
		Ago: (arg0: DateInput) => agoFormatter('da', arg0, () => locales['da'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('da', arg0)
	},
	TimeAgo: {
		JustNow: () => 'lige nu',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('da', args.count, { one: 'minut', other: 'minutter' }) + ' siden',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('da', args.count, { one: 'time', other: 'timer' }) + ' siden',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('da', args.count, { one: 'dag', other: 'dage' }) + ' siden',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('da', args.count, { one: 'måned', other: 'måneder' }) + ' siden',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('da', args.count, { one: 'år', other: 'år' }) + ' siden'
	},
	Enum: {
		PaymentStatus: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Afventer'
					case 'UNPAID':
						return 'Ubetalt'
					case 'PAID':
						return 'Betalt'
					case 'PARTIALLY_PAID':
						return 'Delvist betalt'
					case 'REFUNDED':
						return 'Refunderet'
					case 'PARTIALLY_REFUNDED':
						return 'Delvist refunderet'
					case 'OVERPAID':
						return 'Overbetalt'
					default:
						return String(v)
				}
			})(arg0),
		OrderStatus: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Fuldført'
					case 'CANCELED':
						return 'Annulleret'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentStatus: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Ikke opfyldt'
					case 'FULFILLED':
						return 'Opfyldt'
					case 'NOT_NEEDED':
						return 'Ikke nødvendig'
					case 'PARTIALLY_FULFILLED':
						return 'Delvist opfyldt'
					default:
						return String(v)
				}
			})(arg0),
		TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
			(v => {
				switch (v) {
					case 'FAILED':
						return 'Mislykkedes'
					case 'SUCCESS':
						return 'Gennemført'
					case 'PENDING':
						return 'Afventer'
					default:
						return String(v)
				}
			})(arg0),
		PaymentProvider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN' | 'VERIFONE' | 'CASH') =>
			(v => {
				switch (v) {
					case 'RAPYD':
						return 'Rapyd'
					case 'MANUAL':
						return 'Manuel'
					case 'STRIPE':
						return 'Stripe'
					case 'ADYEN':
						return 'Adyen'
					case 'VERIFONE':
						return 'Verifone'
					case 'CASH':
						return 'Kontant'
					default:
						return String(v)
				}
			})(arg0),
		ProductStatus: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Kladde'
					case 'PUBLISHED':
						return 'Publiceret'
					case 'ARCHIVED':
						return 'Arkiveret'
					default:
						return String(v)
				}
			})(arg0),
		ThirdPartySource: (arg0: 'STRUCT' | 'LS_RETAIL' | 'BUSINESS_CENTRAL') =>
			(v => {
				switch (v) {
					case 'STRUCT':
						return 'Struct'
					case 'LS_RETAIL':
						return 'LS Retail'
					case 'BUSINESS_CENTRAL':
						return 'Business Central'
					default:
						return String(v)
				}
			})(arg0),
		CardExternalSource: (arg0: 'PASSCREATOR') =>
			(v => {
				switch (v) {
					case 'PASSCREATOR':
						return 'PassCreator'
					default:
						return String(v)
				}
			})(arg0),
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Pr. enhed'
					case 'PRICE_EMBEDDED':
						return 'Pris inkluderet'
					case 'PER_WEIGHT':
						return 'Pr. vægt'
					case 'WEIGHT_EMBEDDED':
						return 'Vægt inkluderet'
					default:
						return String(v)
				}
			})(arg0),
		GiftCardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserveret'
					case 'REDEEMED':
						return 'Indløst'
					default:
						return String(v)
				}
			})(arg0),
		RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Afventer'
					case 'APPLIED':
						return 'Anvendt'
					default:
						return String(v)
				}
			})(arg0),
		CardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Blokeret'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentProvider: (arg0: 'MERCHANT_APP') =>
			(v => {
				switch (v) {
					case 'MERCHANT_APP':
						return 'Merchant app'
					default:
						return String(v)
				}
			})(arg0),
		UserStatus: (arg0: 'ACTIVE' | 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REJECTED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'PENDING':
						return 'Afventer'
					case 'ACCEPTED':
						return 'Accepteret'
					case 'EXPIRED':
						return 'Udløbet'
					case 'REJECTED':
						return 'Afvist'
					default:
						return String(v)
				}
			})(arg0),
		UserRole: (arg0: 'DEVELOPER' | 'ADMIN' | 'USER') =>
			(v => {
				switch (v) {
					case 'DEVELOPER':
						return 'Udvikler'
					case 'ADMIN':
						return 'Admin'
					case 'USER':
						return 'Bruger'
					default:
						return String(v)
				}
			})(arg0)
	},
	General: {
		AppName: () => 'FastTrack',
		DefaultPageTitle: () => 'FastTrack Dashboard',
		Create: () => 'Opret',
		Import: () => 'Importer',
		Export: () => 'Eksporter',
		NoResultsTitle: () => 'Ingen resultater fundet',
		Loading: () => 'Indlæser...',
		Selected: () => 'Valgt',
		Optional: () => 'Valgfrit',
		Save: () => 'Gem',
		Continue: () => 'Fortsæt',
		Cancel: () => 'Annuller',
		Confirm: () => 'Bekræft',
		Delete: () => 'Slet',
		Edit: () => 'Rediger',
		Add: () => 'Tilføj',
		Required: () => 'Påkrævet',
		Close: () => 'Luk',
		Update: () => 'Opdater',
		UnsavedChangesTitle: () => 'Ugemte ændringer',
		UnsavedChangesDescription: () => 'Du har ugemte ændringer. Er du sikker på, at du vil forlade siden?',
		VerificationInstruction: (arg0: string) => 'Skriv venligst ' + String(arg0) + ' for at bekræfte:',
		Copy: () => 'Kopier',
		Copied: () => 'Kopieret',
		AreYouSure: () => 'Er du sikker?',
		True: () => 'Ja',
		False: () => 'Nej',
		SearchPlaceholder: () => 'Søg...',
		InvalidFileType: (arg0: string, arg1: string) =>
			'Ugyldig filtype: ' + String(arg0) + ' (understøttet: ' + String(arg1) + ')',
		DropImages: () => 'Slip billeder for at uploade',
		Multiple: () => 'Flere',
		Variable: () => 'Variabel',
		Enabled: () => 'Aktiveret',
		Expired: () => 'Udløbet',
		Scheduled: () => 'Planlagt',
		Active: () => 'Aktiv',
		Inactive: () => 'Inaktiv',
		ComingSoon: () => 'Kommer snart',
		ComingSoonDescription: () => 'Denne funktion er under udvikling.',
		None: () => 'Ingen',
		NotSet: () => 'Ikke angivet',
		Unknown: () => 'Ukendt',
		GoBack: () => 'Gå tilbage',
		GoHome: () => 'Gå til forsiden',
		FeatureNotAvailable: () => 'Denne funktion er i øjeblikket ikke tilgængelig',
		FeatureNotAvailableDescription: () => 'Kontakt support for at aktivere denne funktion',
		Dismiss: () => 'Afvis',
		TryAgain: () => 'Prøv igen',
		All: () => 'Alle',
		AdvancedFilters: () => 'Filtre',
		ClearAll: () => 'Ryd',
		Apply: () => 'Anvend',
		CountSelected: (args: { count: number }) => String(args.count) + ' valgt',
		MultiSelectHint: (args: { count: number }) =>
			String(args.count) + ' valgt • Hold Ctrl/Cmd nede for at vælge flere',
		PickDate: () => 'Vælg en dato',
		Created: () => 'Oprettet',
		View: () => 'Vis'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'Kunne ikke indlæse data',
		AnErrorOccurredWhileFetchingData: () => 'Der opstod en fejl under hentning af data. Prøv venligst igen.'
	},
	Enums: {
		PaymentProvider: (
			arg0:
				| 'CASH'
				| 'ADYEN_TERMINAL'
				| 'ADYEN_ECOM'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS'
				| 'NETS_TERMINAL'
				| 'VERIFONE_CHECKOUT'
				| 'VERIFONE_ECOM'
				| 'STRAUMUR_ECOM'
				| 'LOYALTY_POINTS'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'VIPPS_MOBILEPAY'
				| 'RAPYD_CLOUDLINK'
				| 'RAPYD_APP_TO_APP'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
		) =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Kontant'
					case 'ADYEN_TERMINAL':
						return 'Adyen Terminal'
					case 'ADYEN_ECOM':
						return 'Adyen ECom'
					case 'BLIKK_ECOM':
						return 'Blikk ECom'
					case 'BLIKK_POS':
						return 'Blikk POS'
					case 'VIPPS':
						return 'Vipps'
					case 'NETS_TERMINAL':
						return 'Nets Terminal'
					case 'VERIFONE_CHECKOUT':
						return 'Verifone Checkout'
					case 'VERIFONE_ECOM':
						return 'Verifone ECOM'
					case 'STRAUMUR_ECOM':
						return 'Straumur'
					case 'LOYALTY_POINTS':
						return 'Loyalitetspoint'
					case 'GIFT_CARD':
						return 'Gavekort'
					case 'BUSINESS_CARD':
						return 'Firmakort'
					case 'VIPPS_MOBILEPAY':
						return 'Vipps MobilePay'
					case 'RAPYD_CLOUDLINK':
						return 'Rapyd Cloudlink'
					case 'RAPYD_APP_TO_APP':
						return 'Rapyd App to App'
					case 'TEYA_POSLINK':
						return 'Teya POSLink'
					case 'VERIFONE_POS_CLOUD':
						return 'Verifone POS Cloud'
					default:
						return String(v)
				}
			})(arg0)
	},
	Fields: {
		Name: () => 'Navn',
		Status: () => 'Status',
		Type: () => 'Type',
		SalesChannel: () => 'Salgskanal',
		PointOfSale: () => 'Salgssted',
		PaymentStatus: () => 'Betalingsstatus',
		StartDate: () => 'Startdato',
		EndDate: () => 'Slutdato',
		TaxRate: () => 'Momssats',
		TaxInclusive: () => 'Inkl. moms',
		Amount: () => 'Beløb',
		Price: () => 'Pris',
		Description: () => 'Beskrivelse',
		Groups: () => 'Grupper',
		Categories: () => 'Kategorier',
		Email: () => 'E-mail',
		Password: () => 'Adgangskode',
		ConfirmPassword: () => 'Bekræft adgangskode',
		Role: () => 'Rolle',
		SKU: () => 'SKU',
		Currency: () => 'Valuta',
		CreatedAt: () => 'Oprettet',
		ExpiresAt: () => 'Udløber',
		UpdatedAt: () => 'Opdateret',
		Language: () => 'Sprog',
		Year: () => 'År',
		Month: () => 'Måned',
		ExternalId: () => 'Ekstern ID',
		FirstName: () => 'Fornavn',
		LastName: () => 'Efternavn',
		Phone: () => 'Telefon',
		SSN: () => 'CPR-nr.',
		CardNumber: () => 'Kortnummer',
		Company: () => 'Virksomhed',
		Customer: () => 'Kunde',
		Employee: () => 'Medarbejder',
		FromTime: () => 'Fra',
		ToTime: () => 'Til',
		OrgNumber: () => 'CVR-nr.',
		Enabled: () => 'Aktiveret',
		Disabled: () => 'Deaktiveret',
		CurrencyCode: () => 'Valutakode'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'Genveje'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'Mandag',
		Tuesday: () => 'Tirsdag',
		Wednesday: () => 'Onsdag',
		Thursday: () => 'Torsdag',
		Friday: () => 'Fredag',
		Saturday: () => 'Lørdag',
		Sunday: () => 'Søndag'
	},
	Auth: {
		AcceptInvite: () => 'Accepter invitation',
		AcceptInviteAndSetPassword: () => 'Accepter invitation og angiv adgangskode',
		AcceptInviteDescription: () => 'Angiv din adgangskode for at acceptere invitationen.',
		ConfirmPasswordPlaceholder: () => 'Bekræft din adgangskode',
		InvalidInvite: () => 'Ugyldig invitation',
		InvalidInviteDescription: () => 'Denne invitation er ugyldig eller er udløbet.',
		InviteAccepted: () => 'Invitationen blev accepteret',
		InviteExpired: () => 'Denne invitation er udløbet eller er ikke længere gyldig',
		PasswordPlaceholder: () => 'Indtast din adgangskode',
		PasswordsDoNotMatch: () => 'Adgangskoderne stemmer ikke overens',
		SetPassword: () => 'Angiv adgangskode'
	},
	Error: {
		PageNotFound: () => 'Siden blev ikke fundet',
		PageNotFoundDescription: () => 'Den side, du leder efter, findes ikke.',
		SomethingWentWrong: () => 'Noget gik galt',
		AnUnexpectedErrorOccurred: () =>
			'Der opstod en uventet fejl. Du kan prøve at gå tilbage, genindlæse siden eller kontakte support, hvis problemet fortsætter.',
		ErrorDetails: () => 'Fejldetaljer',
		ReloadPage: () => 'Genindlæs siden',
		ContactSupport: () => 'Kontakt support'
	},
	Campaigns: {
		Domain: () => 'Kampagner'
	},
	CustomerGroups: {
		Domain: () => 'Kundegrupper',
		Title: () => 'Grupper',
		CreateTitle: () => 'Opret kundegruppe',
		CreateSuccess: (args: { name: string }) => 'Kundegruppen ' + String(args.name) + ' blev oprettet.',
		EditTitle: () => 'Rediger kundegruppe',
		UpdateSuccess: () => 'Kundegruppen blev opdateret',
		Empty: () => 'Ingen kundegrupper endnu',
		Members: () => 'Medlemmer',
		SelectCustomers: () => 'Vælg kunder',
		Delete: {
			Title: () => 'Slet kundegruppe',
			Description: (args: { name: string }) =>
				'Er du sikker på, at du vil slette kundegruppen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kundegruppen ' + String(args.name) + ' blev slettet.'
		},
		Column: {
			Name: () => 'Navn',
			Description: () => 'Beskrivelse',
			ExternalId: () => 'Eksternt ID',
			MemberCount: () => 'Medlemmer'
		},
		Field: {
			Name: () => 'Navn',
			Description: () => 'Beskrivelse',
			ExternalId: () => 'Eksternt ID',
			NamePlaceholder: () => 'Indtast et gruppenavn',
			DescriptionPlaceholder: () => 'Beskriv denne gruppe (valgfrit)',
			ExternalIdPlaceholder: () => 'Eksternt ID (valgfrit)'
		},
		Detail: {
			Title: () => 'Kundegruppe'
		}
	},
	DraftOrders: {
		Domain: () => 'Kladdeordrer'
	},
	PriceLists: {
		Domain: () => 'Prislister'
	},
	Reservations: {
		Domain: () => 'Reservationer'
	},
	Login: {
		PageTitle: () => 'Log ind',
		Title: () => 'Velkommen til FastTrack',
		Description: () => 'Log ind for at få adgang til dit dashboard',
		Email: () => 'E-mail',
		Password: () => 'Adgangskode',
		LogIn: () => 'Log ind',
		ForgotPassword: () => 'Glemt adgangskode?',
		ForgotPasswordButton: () => 'Nulstil',
		Error: () => 'Kunne ikke logge ind',
		UnauthorizedError: () => 'Ugyldig e-mail eller adgangskode'
	},
	ResetPassword: {
		Title: () => 'Nulstil adgangskode',
		Hint: () =>
			'Indtast din e-mail nedenfor, så sender vi dig instruktioner om, hvordan du nulstiller din adgangskode.',
		Email: () => 'E-mail',
		SendResetInstructions: () => 'Send nulstillingsinstruktioner',
		BackToLogin: () => 'Tilbage til login',
		SuccessfulRequestTitle: () => 'Vi har sendt dig en e-mail',
		SuccessfulRequest: () =>
			'Vi har sendt dig en e-mail, som du kan bruge til at nulstille din adgangskode. Tjek din spammappe, hvis du ikke har modtaget den efter et par minutter.',
		NewPassword: () => 'Ny adgangskode',
		NewPasswordHint: () => 'Vælg en ny adgangskode nedenfor.',
		RepeatNewPassword: () => 'Gentag ny adgangskode',
		ResetPassword: () => 'Nulstil adgangskode',
		PasswordMismatch: () => 'Adgangskoderne stemmer ikke overens',
		SuccessfulResetTitle: () => 'Adgangskoden blev nulstillet',
		SuccessfulReset: () => 'Log venligst ind på login-siden.',
		InvalidEmail: () => 'Ugyldig e-mail'
	},
	Sidebar: {
		Logout: () => 'Log ud',
		ProfileSettings: () => 'Profilindstillinger',
		BackToApp: () => 'Tilbage til appen',
		SearchPlaceholder: () => 'Søg eller hop…',
		OpenSearch: () => 'Åbn søgning',
		StoreScopeHint: () => 'Arbejdsområde (skifter kommer senere)',
		Sections: () => 'Sektioner',
		Individuals: () => 'Privatpersoner',
		Business: () => 'Erhverv',
		Content: () => 'Indhold',
		Messaging: () => 'Beskeder',
		Automation: () => 'Automatisering'
	},
	DeveloperFeedback: {
		Entry: () => 'Send feedback',
		Title: () => 'Udviklerfeedback',
		Description: () => 'Dette bliver en sag til udviklingsteamet.',
		TitleLabel: () => 'Titel',
		BodyLabel: () => 'Detaljer',
		TypeLabel: () => 'Type',
		TypeSmallFix: () => 'Lille rettelse',
		TypeBug: () => 'Fejl',
		TypeEnhancement: () => 'Forbedring',
		TypeNote: () => 'Note',
		Submit: () => 'Send',
		Created: () => 'Sag oprettet'
	},
	CommandPalette: {
		GroupQuick: () => 'Hurtige handlinger',
		InputHint: () => 'Søg i ordrer, produkter, kunder, samlinger…',
		FooterHint: () => 'Tip: skriv mindst 2 tegn for at søge i hele butikken.',
		NoResults: () => 'Ingen match. Prøv et andet søgeord.',
		QuickNewProduct: () => 'Opret produkt',
		QuickNewPromotion: () => 'Opret kampagne',
		QuickMarketingContent: () => 'Marketingindhold',
		QuickGoOrders: () => 'Gå til ordrer',
		QuickSettings: () => 'Indstillinger'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			String(args.start) + ' til ' + String(args.end) + ' af ' + String(args.total) + ' resultater',
		NoResults: () => '0 resultater',
		Previous: () => 'Forrige',
		Next: () => 'Næste'
	},
	Orders: {
		Title: () => 'Ordrer',
		BagChecks: () => 'Taskekontrol',
		Drafts: () => 'Kladder',
		StatusEnum: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Afventer'
					case 'UNPAID':
						return 'Ubetalt'
					case 'PAID':
						return 'Betalt'
					case 'PARTIALLY_PAID':
						return 'Delvist betalt'
					case 'REFUNDED':
						return 'Refunderet'
					case 'PARTIALLY_REFUNDED':
						return 'Delvist refunderet'
					case 'OVERPAID':
						return 'Overbetalt'
					default:
						return String(v)
				}
			})(arg0),
		OrderCanceled: () => 'Ordren blev annulleret',
		AdvancedFilters: () => 'Ordrefiltre',
		FulfillmentStatusEnum: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Ikke opfyldt'
					case 'FULFILLED':
						return 'Opfyldt'
					case 'NOT_NEEDED':
						return 'Ikke nødvendig'
					case 'PARTIALLY_FULFILLED':
						return 'Delvist opfyldt'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Order: () => 'Ordre',
			Date: () => 'Dato',
			SalesChannel: () => 'Salgskanal',
			PaymentStatus: () => 'Betalingsstatus',
			Total: () => 'Ordretotal',
			FulfillmentStatus: () => 'Opfyldelsesstatus',
			PointsEarned: () => 'Optjente point',
			PointsUsed: () => 'Brugte point'
		},
		Totals: {
			Header: () => 'Oversigt - I dag',
			Orders: () => 'Ordrer',
			Total: () => 'Omsætning',
			Average: () => 'Gennemsnitlig ordre',
			UpdatedAt: (arg0: DateInput) => 'Opdateret ' + shortDateAndTimePreciseFormatter('da', arg0)
		},
		Filters: {
			MinAmount: () => 'Minimumsbeløb',
			MaxAmount: () => 'Maksimumsbeløb',
			FromDate: () => 'Fra dato',
			ToDate: () => 'Til dato'
		},
		Refund: {
			Title: () => 'Refunder',
			Amount: () => 'Beløb',
			Note: () => 'Bemærkning',
			AmountCannotBeEmpty: () => 'Beløb kan ikke være tomt',
			AmountMustBeGreaterThanZero: () => 'Beløb skal være større end 0',
			AmountMustBeLessThanRefundableAmount: (arg0: TranslationAmount) =>
				'Beløb skal være mindre end det refunderbare beløb (' + amountFormatter('da', arg0) + ')',
			Description: () =>
				'Vælg de varelinjer, der skal refunderes, juster antal og/eller indtast et brugerdefineret beløb.',
			ItemsSectionTitle: () => 'Varelinjer',
			CustomAmountSectionTitle: () => 'Brugerdefineret beløb',
			CustomAmountLabel: () => 'Ekstra beløb',
			CustomAmountOnlyLabel: () => 'Refunderingsbeløb',
			CustomAmountHint: () => 'Tilføj eventuelt et brugerdefineret beløb oven i de valgte varer.',
			RefundableAmount: () => 'Refunderbart beløb',
			RefundTotal: () => 'Refundering i alt',
			AlreadyRefunded: (args: { quantity: number; total: number }) =>
				'Refunderet ' + String(args.quantity) + ' af ' + String(args.total),
			PromotionLocked: () => 'Del af en kampagne — refunder med et brugerdefineret beløb i stedet.',
			Restock: () => 'Genopfyld returnerede enheder',
			NothingToRefund: () => 'Denne ordre har intet tilbage at refundere.',
			NoRefundableItems: () => 'Ingen varelinjer er tilgængelige for en varebaseret refundering.',
			SelectSomething: () => 'Vælg mindst én vare, eller indtast et brugerdefineret beløb.',
			ExceedsRefundable: () => 'Refunderingen i alt overstiger det refunderbare beløb.',
			RefundEntireOrder: (arg0: TranslationAmount) =>
				'Refunder hele ordren (' + amountFormatter('da', arg0) + ')',
			SelectAll: () => 'Vælg alle',
			ConfirmTitle: () => 'Refunder denne ordre?',
			ConfirmWarning: (args: { total: TranslationAmount }) =>
				'Dette refunderer ' +
				amountFormatter('da', args.total) +
				' til kunden. Refunderinger er permanente og kan ikke fortrydes eller annulleres, når de først er igangsat.',
			Submit: () => 'Refunder',
			Success: () => 'Refundering igangsat',
			Error: () => 'Kunne ikke igangsætte refundering'
		},
		Payment: {
			CreateRefundWrongQuantity: (args: { number: string }) =>
				'Antal skal være et tal mellem 0 og ' + String(args.number)
		}
	},
	OrderDetail: {
		Title: (arg0: string) => 'Ordre #' + String(arg0),
		OnDateFromSalesChannel: (args: { date: string; salesChannel: string }) =>
			String(args.date) + ' fra ' + String(args.salesChannel),
		OnDateFromPointOfSale: (args: { date: string; salesChannel: string; pointOfSale: string }) =>
			String(args.date) + ' fra ' + String(args.salesChannel) + ' (' + String(args.pointOfSale) + ')',
		Status: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Fuldført'
					case 'CANCELED':
						return 'Annulleret'
					default:
						return String(v)
				}
			})(arg0),
		CancelWarning: (args: { id: string }) =>
			'Du er ved at annullere ordren ' + String(args.id) + '. Denne handling kan ikke fortrydes.',
		OpenOrderDetails: () => 'Åbn ordredetaljer',
		Items: () => 'Varer',
		Transactions: () => 'Transaktioner',
		Summary: {
			Title: () => 'Oversigt',
			EditOrder: () => 'Rediger ordre',
			OpenReceipt: () => 'Åbn kvittering',
			ItemTotal: () => 'Varetotal',
			TaxTotal: () => 'Moms i alt',
			Total: () => 'I alt',
			GiftCardTotal: () => 'Gavekort i alt',
			PointsEarned: () => 'Optjente loyalitetspoint',
			PaidTotal: () => 'Betalt i alt',
			OutstandingAmount: () => 'Udestående beløb',
			Discount: () => 'Rabat',
			Refunded: () => 'Refunderet'
		},
		Receipt: {
			FailedToLoad: () => 'Kunne ikke indlæse kvittering',
			Redirecting: () => 'Omdirigerer til kvittering...',
			Loading: () => 'Indlæser kvittering...'
		},
		Payment: {
			Title: () => 'Betalinger',
			Status: (
				arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'OVERPAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'
			) =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Afventer'
						case 'UNPAID':
							return 'Ubetalt'
						case 'PAID':
							return 'Betalt'
						case 'PARTIALLY_PAID':
							return 'Delvist betalt'
						case 'OVERPAID':
							return 'Overbetalt'
						case 'REFUNDED':
							return 'Refunderet'
						case 'PARTIALLY_REFUNDED':
							return 'Delvist refunderet'
						default:
							return String(v)
					}
				})(arg0),
			TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
				(v => {
					switch (v) {
						case 'FAILED':
							return 'Mislykkedes'
						case 'SUCCESS':
							return 'Gennemført'
						case 'PENDING':
							return 'Afventer'
						default:
							return String(v)
					}
				})(arg0),
			Provider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN') =>
				(v => {
					switch (v) {
						case 'RAPYD':
							return 'Rapyd'
						case 'MANUAL':
							return 'Manuel'
						case 'STRIPE':
							return 'Stripe'
						case 'ADYEN':
							return 'Adyen'
						default:
							return String(v)
					}
				})(arg0),
			PaymentWithSequenceNumber: (args: { sequenceNumber: string }) => 'Betaling #' + String(args.sequenceNumber),
			RefundWithSequenceNumber: (args: { sequenceNumber: string }) =>
				'Refundering #' + String(args.sequenceNumber),
			TotalPaidByCustomer: () => 'Betalt af kunde i alt',
			TotalPending: () => 'Afventende i alt',
			Refund: () => 'Refunder'
		},
		SandStar: {
			Title: () => 'SandStar cooler',
			CloudReview: () => 'Cloud-gennemgang',
			MachineName: () => 'Maskine',
			OrderNo: () => 'Ordrenummer',
			AbnormalReason: () => 'Afvigelsesårsag',
			Video: () => 'Video',
			NoVideo: () => 'Ingen video'
		}
	},
	Products: {
		Title: () => 'Produkter',
		Library: () => 'Bibliotek',
		Status: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Kladde'
					case 'PUBLISHED':
						return 'Publiceret'
					case 'ARCHIVED':
						return 'Arkiveret'
					default:
						return String(v)
				}
			})(arg0),
		BarcodeType: () => 'Stregkodetype',
		ExportTitle: () => 'Eksporter produkter',
		AdvancedFilters: () => 'Produktfiltre',
		NoAdvancedFiltersYet: () => 'Ingen avancerede filtre tilgængelige for produkter endnu.',
		OpenProductDetails: () => 'Åbn produktdetaljer',
		LibraryPage: {
			NoAssets: () => 'Ingen produktbilleder endnu',
			NoAssetsDescription: () => 'Upload produktbilleder her for at genbruge dem på tværs af dine produkter.',
			Filename: () => 'Filnavn',
			TableView: () => 'Tabelvisning',
			GalleryView: () => 'Gallerivisning',
			Upload: () => 'Upload',
			SearchFilename: () => 'Søg på filnavn',
			ViewFullImage: () => 'Vis fuldt billede',
			CopyUrl: () => 'Kopier URL',
			CopiedUrl: () => 'URL kopieret',
			DeleteAsset: () => 'Slet aktiv',
			DeleteAssetConfirm: () => 'Slet dette aktiv? Det kan ikke fortrydes.',
			UploadAssets: () => 'Upload aktiver',
			UploadDropzone: () => 'Træk og slip billeder her, eller klik for at vælge filer',
			ChooseFiles: () => 'Vælg filer',
			Tags: () => 'Tags',
			UsedBy: () => 'Brugt af',
			UsageFilter: () => 'Brug',
			UsageUnused: () => 'Ubrugt',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgruppe',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Marketingindhold',
			UsageFeedLayout: () => 'Kundeapp-feed',
			ChannelFilter: () => 'Marketingkanal',
			ContentFilter: () => 'Brugt af indhold',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Uden indhold',
			TagsPlaceholder: () => 'Tilføj et tag og tryk Enter',
			Uploading: () => 'Uploader',
			EditTags: () => 'Rediger tags',
			NoTags: () => 'Ingen tags',
			ManageTags: () => 'Administrer tags',
			ManageTagsEmpty: () => 'Ingen tags i biblioteket endnu.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' aktiver',
			CreateTag: () => 'Opret tag',
			CreateTagPlaceholder: () => 'Tilføj et tag og tryk Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Tagget "' + String(args.tag) + '" blev oprettet.',
			RenameTag: () => 'Omdøb tag',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Flet tagget "' +
				String(args.from) +
				'" ind i "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' aktiver)? Det gamle tag fjernes.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tag omdøbt fra "' + String(args.from) + '" til "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjern tagget "' + String(args.tag) + '" fra alle aktiver? Filerne slettes ikke.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tag fjernet fra ' +
				String(args.count) +
				' ' +
				plural('da', args.count, { one: 'aktiv', other: 'aktiver' }) +
				'.'
		},
		Column: {
			Title: () => 'Titel',
			Status: () => 'Status',
			PricingMethod: () => 'Prismetode',
			SalesChannels: () => 'Salgskanaler'
		},
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Pr. enhed'
					case 'PRICE_EMBEDDED':
						return 'Pris inkluderet'
					case 'PER_WEIGHT':
						return 'Pr. vægt'
					case 'WEIGHT_EMBEDDED':
						return 'Vægt inkluderet'
					default:
						return String(v)
				}
			})(arg0),
		Export: {
			Description: () => 'Eksporter produkter til en CSV-fil.',
			Download: () => 'Download',
			Error: () => 'Kunne ikke eksportere produkter',
			Format: () => 'Format',
			NoDataError: () => 'Ingen data at eksportere',
			ProductCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('da', args.count, { one: 'produkt', other: 'produkter' }),
			Success: () => 'Produkter eksporteret'
		},
		Import: {
			Header: () => 'Importer produktliste',
			UploadLabel: () => 'Importer produkter',
			UploadHint: () => 'Træk og slip en CSV-fil eller klik for at uploade',
			Description: () => 'Importer produkter ved at angive en CSV-fil i et foruddefineret format',
			Template: {
				Title: () => 'Usikker på, hvordan du skal ordne din liste?',
				Description: () => 'Download skabelonen nedenfor for at sikre, at du følger det korrekte format.'
			},
			Upload: {
				Title: () => 'Upload en CSV-fil',
				Description: () =>
					'Via import kan du tilføje eller opdatere produkter. For at opdatere eksisterende produkter matches inputtet på ekstern ID, SKU eller stregkode. Du bliver bedt om bekræftelse, før vi importerer produkter.',
				Preprocessing: () => 'Forbehandler...',
				Importing: () => 'Importerer produkter...',
				ProductsToCreate: () => 'Produkter vil blive oprettet',
				ProductsToUpdate: () => 'Produkter vil blive opdateret',
				ProductsCreated: () => 'Produkter oprettet',
				ProductsUpdated: () => 'Produkter opdateret',
				ProductsErrored: () => 'Produkter med fejl',
				Errors: {
					Title: () => 'Fejl',
					Description: (args: { count: number; rows: number }) =>
						String(args.count) +
						' ' +
						plural('da', args.count, { one: 'fejl', other: 'fejl' }) +
						' i ' +
						String(args.rows) +
						' ' +
						plural('da', args.rows, { one: 'række', other: 'rækker' }),
					Row: () => 'Række',
					Column: () => 'Kolonne',
					Message: () => 'Besked'
				}
			},
			Success: () => 'Import fuldført!'
		}
	},
	Product: {
		Header: (arg0: string) => 'Produkt ' + String(arg0),
		EditHeader: () => 'Rediger produkt',
		EditSuccessToast: (args: { title: string }) => 'Produktet ' + String(args.title) + ' blev opdateret.',
		CreateTitle: () => 'Opret produkt',
		Title: () => 'Titel',
		Subtitle: () => 'Undertitel',
		Description: () => 'Beskrivelse',
		PricingMethodTitle: () => 'Prismetode',
		Overview: () => 'Oversigt',
		ExternalId: () => 'Ekstern ID',
		ExternalSource: () => 'Ekstern kilde',
		ManagedExternally: (args: { source: string }) => 'Dette produkt administreres af ' + String(args.source),
		Sku: () => 'SKU',
		Variants: () => 'Varianter',
		DeleteWarning: (args: { title: string }) =>
			'Du er ved at slette produktet ' + String(args.title) + '. Denne handling kan ikke fortrydes.',
		Create: {
			Title: () => 'Opret produkt'
		},
		Media: {
			Title: () => 'Medier',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Vælg fra bibliotek',
			LibraryPickerTitle: () => 'Tilføj fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilleder i biblioteket endnu.',
			LibraryPickerAllAttached: () => 'Alle billeder fra biblioteket er allerede på dette produkt.',
			AddImageSuccessToast: () => 'Billede tilføjet',
			DeleteImageLabel: () => 'Slet billede',
			DownloadImageLabel: () => 'Download billede',
			SetPrimaryLabel: () => 'Vælg som primært',
			AlreadyPrimaryLabel: () => 'Primært billede',
			PrimaryBadge: () => 'Primært',
			ProcessingBadge: () => 'Behandler…',
			UploadingLabel: (args: { percent: number }) => 'Uploader… ' + String(args.percent) + '%',
			UploadSuccessToast: (args: { count: number }) =>
				String(args.count) +
				' ' +
				plural('da', args.count, { one: 'billede', other: 'billeder' }) +
				' uploadet',
			UploadFailedToast: () => 'Kunne ikke uploade billede',
			DeleteSuccessToast: () => 'Billede slettet',
			SetPrimarySuccessToast: () => 'Primært billede opdateret',
			EmptyState: {
				Header: () => 'Intet billede endnu',
				Description: () =>
					'Træk og slip billeder her, eller tilføj et billede til produktet for at fremvise det i din butik.',
				Action: () => 'Tilføj medier'
			}
		},
		Organization: {
			Header: () => 'Organisation'
		},
		Pricing: {
			Title: () => 'Prissætning',
			VariablePrice: () => 'Variabel pris',
			Price: () => 'Pris',
			PriceWithTax: () => 'Pris inkl. moms',
			PriceWithoutTax: () => 'Pris ekskl. moms',
			Enabled: () => 'Aktiveret',
			InvalidTaxRate: (args: { taxRate: string }) => 'Ugyldig momssats: ' + String(args.taxRate),
			NoPricesConfigured: () => 'Ingen priser konfigureret',
			Target: () => 'Gælder for',
			Group: () => 'Gruppe',
			Channel: () => 'Salgskanal',
			GroupDefault: () => 'Gruppestandard',
			ChannelOverride: () => 'Kanaltilsidesættelse',
			AddOverride: () => 'Tilføj kanaltilsidesættelse',
			SelectOverrideChannel: () => 'Vælg en salgskanal, der skal tilsidesættes',
			NoOverridableChannels: () => 'Alle grupperede kanaler har allerede en tilsidesættelse',
			RemoveOverride: () => 'Fjern tilsidesættelse',
			ExpandGroup: () => 'Vis kanalpriser',
			CollapseGroup: () => 'Skjul kanalpriser',
			OverrideCount: (args: { count: number }) =>
				String(args.count) +
				' ' +
				plural('da', args.count, { one: 'tilsidesættelse', other: 'tilsidesættelser' }),
			EmptyState: {
				Header: () => 'Ingen priser konfigureret',
				Description: () => 'Tilføj en pris til dette produkt, så det kan sælges på en salgskanal.',
				Action: () => 'Tilføj pris'
			}
		},
		Barcode: {
			Title: () => 'Stregkoder',
			Barcode: () => 'Stregkode',
			AddBarcode: () => 'Tilføj stregkode',
			AddBarcodePrompt: {
				Title: () => 'Tilføj stregkode',
				Placeholder: () => 'Stregkode'
			},
			Delete: {
				Title: () => 'Slet stregkode',
				Description: (args: { barcode: string }) =>
					'Er du sikker på, at du vil slette stregkoden ' + String(args.barcode) + '?'
			},
			AlreadyOnProduct: () => 'Denne stregkode er allerede på dette produkt',
			AlreadyInUse: () => 'Denne stregkode er allerede i brug af et andet produkt'
		},
		UnitsOfMeasure: {
			Title: () => 'Måleenheder',
			Unit: () => 'Enhed',
			Base: () => 'Basis',
			BaseUnit: () => 'Basisenhed',
			True: () => 'Sandt',
			False: () => 'Falsk',
			BaseUnitLabel: (args: { code: string }) => String(args.code) + ' (basis)',
			BaseUnitsPer: () => 'Antal pr. enhed',
			Sellable: () => 'Kan sælges',
			Pos: () => 'POS',
			Ecom: () => 'E-handel',
			Add: () => 'Tilføj enhed',
			Edit: () => 'Rediger enhed',
			Code: () => 'Kode',
			Name: () => 'Navn',
			InvalidFactor: () => 'Antal skal være større end nul',
			SelectUnit: () => 'Vælg en enhed',
			QuantityRequired: () => 'Denne enhed har ikke et fælles antal, så et antal er påkrævet',
			Saved: () => 'Enhed gemt',
			Delete: {
				Title: () => 'Slet enhed',
				Description: (args: { code: string }) => 'Er du sikker på, at du vil slette ' + String(args.code) + '?'
			}
		}
	},
	ProductEdit: {
		Header: () => 'Rediger produkt'
	},
	ProductCategories: {
		Title: () => 'Kategorier',
		Breadcrumb: () => 'Kategorier',
		Search: () => 'Søg i kategorier',
		Empty: () => 'Ingen kategorier endnu',
		NoSearchResults: (args: { query: string }) => 'Ingen kategorier matcher „' + String(args.query) + '“',
		Column: {
			Name: () => 'Navn',
			ProductCount: () => 'Antal produkter'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'Ingen overordnet',
			SelectParentTitle: () => 'Vælg overordnet kategori',
			SelectParentDescription: () => 'Vælg en overordnet kategori for denne kategori'
		}
	},
	ProductCategory: {
		CreateSuccessToast: (args: { name: string }) => 'Kategorien ' + String(args.name) + ' blev oprettet.',
		EditHeader: () => 'Rediger kategori',
		EditSuccessToast: (args: { name: string }) => 'Kategorien ' + String(args.name) + ' blev opdateret.',
		CreateTitle: () => 'Opret kategori',
		ParentCategory: () => 'Overordnet kategori',
		ProductsTitle: () => 'Produkter',
		SelectParent: () => 'Vælg overordnet kategori',
		ClearParent: () => 'Ryd overordnet kategori',
		Delete: {
			Title: () => 'Slet kategori',
			Description: (args: { name: string }) =>
				'Er du sikker på, at du vil slette kategorien "' +
				String(args.name) +
				'"? Produkter i denne kategori bliver ikke slettet.',
			SuccessToast: (args: { name: string }) => 'Kategorien ' + String(args.name) + ' blev slettet.'
		},
		Image: {
			Title: () => 'Billede',
			EmptyState: () => 'Intet billede endnu',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Vælg fra bibliotek',
			Remove: () => 'Fjern billede',
			LibraryPickerTitle: () => 'Tilføj fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilleder i biblioteket endnu.',
			LibraryPickerAllAttached: () => 'Dette billede er allerede valgt.',
			SetSuccessToast: () => 'Billede opdateret',
			RemoveSuccessToast: () => 'Billede fjernet',
			UploadFailedToast: () => 'Kunne ikke uploade billede'
		},
		Create: {
			NoParent: () => 'Ingen overordnet',
			SelectParentTitle: () => 'Vælg overordnet kategori',
			SelectParentDescription: () => 'Vælg en overordnet kategori for denne kategori'
		}
	},
	ProductGroups: {
		Title: () => 'Grupper',
		Breadcrumb: () => 'Grupper',
		Search: () => 'Søg i grupper',
		Empty: () => 'Ingen grupper endnu',
		NoSearchResults: (args: { query: string }) => 'Ingen grupper matcher „' + String(args.query) + '“',
		Column: {
			Name: () => 'Navn',
			ProductCount: () => 'Antal produkter'
		}
	},
	ProductGroup: {
		Title: (arg0: string) => 'Gruppe ' + String(arg0),
		EditHeader: () => 'Rediger gruppe',
		EditSuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' blev opdateret.',
		CreateTitle: () => 'Opret gruppe',
		CreateSuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' blev oprettet.',
		Delete: {
			Title: () => 'Slet gruppe',
			Description: (args: { name: string }) =>
				'Er du sikker på, at du vil slette gruppen "' +
				String(args.name) +
				'"? Produkter i denne gruppe bliver ikke slettet.',
			SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' blev slettet.'
		},
		Image: {
			Title: () => 'Billede',
			EmptyState: () => 'Intet billede endnu',
			Upload: () => 'Upload',
			ChooseFromLibrary: () => 'Vælg fra bibliotek',
			Remove: () => 'Fjern billede',
			LibraryPickerTitle: () => 'Tilføj fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilleder i biblioteket endnu.',
			LibraryPickerAllAttached: () => 'Dette billede er allerede valgt.',
			SetSuccessToast: () => 'Billede opdateret',
			RemoveSuccessToast: () => 'Billede fjernet',
			UploadFailedToast: () => 'Kunne ikke uploade billede'
		},
		Products: {
			Title: () => 'Produkter',
			NoProducts: () => 'Ingen produkter',
			Add: {
				Title: () => 'Tilføj produkter',
				Label: () => 'Produkter',
				Placeholder: () => 'Søg i produkter',
				SuccessToast: (args: { count: number; name: string }) =>
					String(args.count) + ' produkt(er) tilføjet til ' + String(args.name) + '.',
				NoProducts: () => 'Vælg mindst ét produkt.'
			}
		},
		Fees: {
			Title: () => 'Gebyrer',
			AddFee: () => 'Tilføj gebyr',
			NoFees: () => 'Ingen gebyrer',
			Delete: {
				Title: () => 'Slet gebyr',
				Description: (args: { name: string }) =>
					'Er du sikker på, at du vil slette gebyret "' + String(args.name) + '"?'
			},
			Create: {
				Title: () => 'Opret gebyr',
				Pricing: () => 'Prissætning',
				SuccessToast: (args: { name: string }) => 'Gebyret ' + String(args.name) + ' blev oprettet.',
				NoPrices: () => 'Tilføj venligst mindst én pris.'
			},
			Edit: {
				Title: () => 'Rediger gebyr',
				SuccessToast: (args: { name: string }) => 'Gebyret ' + String(args.name) + ' blev opdateret.'
			}
		}
	},
	GiftCards: {
		Title: () => 'Gavekort',
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserveret'
					case 'REDEEMED':
						return 'Indløst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Rediger gavekort',
		EditSuccess: () => 'Gavekort opdateret',
		DeleteSuccess: () => 'Gavekort slettet',
		Delete: {
			Title: () => 'Slet gavekort',
			Description: () => 'Er du sikker på, at du vil slette dette gavekort? Denne handling kan ikke fortrydes.'
		},
		Column: {
			Name: () => 'Navn',
			Code: () => 'Kode',
			Amount: () => 'Beløb',
			CurrencyCode: () => 'Valuta',
			Status: () => 'Status'
		},
		Detail: {
			Title: () => 'Gavekort',
			General: () => 'Generelt',
			CardDetails: () => 'Kortdetaljer',
			Redemptions: () => 'Indløsninger',
			NoRedemptions: () => 'Ingen indløsninger',
			Date: () => 'Dato',
			RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Afventer'
						case 'APPLIED':
							return 'Anvendt'
						default:
							return String(v)
					}
				})(arg0)
		}
	},
	GiftCard: {
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserveret'
					case 'REDEEMED':
						return 'Indløst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Rediger gavekort',
		CreateTitle: () => 'Opret gavekort',
		Name: () => 'Navn',
		Code: () => 'Kode',
		Amount: () => 'Beløb',
		CurrencyCode: () => 'Valutakode'
	},
	LoyaltyCards: {
		Title: () => 'Loyalitetskort',
		EditTitle: () => 'Rediger loyalitetskort',
		EditSuccess: () => 'Loyalitetskort opdateret',
		DeleteSuccess: () => 'Loyalitetskort slettet',
		ManagedExternally: (args: { source: string }) => 'Dette loyalitetskort administreres af ' + String(args.source),
		Delete: {
			Title: () => 'Slet loyalitetskort',
			Description: () =>
				'Er du sikker på, at du vil slette dette loyalitetskort? Denne handling kan ikke fortrydes.'
		},
		Detail: {
			Title: () => 'Loyalitetskort',
			CardDetails: () => 'Kortdetaljer',
			Customer: () => 'Kunde',
			Redemptions: () => 'Indløsninger',
			Date: () => 'Dato'
		},
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Customer: () => 'Kunde',
			Status: () => 'Status',
			AvailablePoints: () => 'Tilgængelige point',
			TotalPoints: () => 'Point i alt',
			ExternalId: () => 'Ekstern ID',
			ExternalSource: () => 'Ekstern kilde',
			PointsUsed: () => 'Brugte point',
			PointsRemaining: () => 'Resterende point',
			Order: () => 'Ordre'
		}
	},
	Inventory: {
		Title: () => 'Lager',
		Stock: () => 'Beholdning',
		Suppliers: () => 'Leverandører',
		Movements: () => 'Lagerbevægelser',
		Receiving: () => 'Varemodtagelse',
		Transfers: () => 'Overførsler',
		Reports: () => 'Lagerrapporter',
		Summary: {
			TotalSkus: () => "SKU'er i alt",
			LowStock: () => 'Lav beholdning',
			OutOfStock: () => 'Udsolgt'
		},
		Column: {
			Product: () => 'Produkt',
			Variant: () => 'Variant',
			Sku: () => 'SKU',
			SalesChannel: () => 'Salgskanal',
			InventoryLocation: () => 'Placering',
			QuantityOnHand: () => 'På lager',
			QuantityAfter: () => 'På lager efter',
			ReorderPoint: () => 'Genbestillingspunkt',
			ReorderQuantity: () => 'Genbestillingsantal',
			Status: () => 'Status',
			Type: () => 'Type',
			Delta: () => 'Ændring',
			Reason: () => 'Årsag',
			CreatedBy: () => 'Af',
			Ordered: () => 'Bestilt',
			Received: () => 'Modtaget',
			ReceiveNow: () => 'Modtag nu',
			UnitCost: () => 'Enhedspris',
			Quantity: () => 'Antal',
			Lines: () => 'Varer',
			Date: () => 'Dato',
			Name: () => 'Navn',
			Email: () => 'Email',
			Reference: () => 'Reference',
			From: () => 'Fra',
			To: () => 'Til',
			Supplier: () => 'Leverandør',
			Currency: () => 'Valuta',
			Margin: () => 'Margin',
			PurchasePrice: () => 'Indkøbspris',
			RetailPrice: () => 'Udsalgspris',
			Tracked: () => 'Sporet'
		},
		Filter: {
			LowStockOnly: () => 'Kun lav beholdning',
			SalesChannel: () => 'Salgskanal',
			InventoryLocation: () => 'Placering',
			Status: () => 'Status',
			Type: () => 'Type',
			AllChannels: () => 'Alle salgskanaler',
			AllLocations: () => 'Alle placeringer',
			AllStatuses: () => 'Alle statusser',
			AllTypes: () => 'Alle typer'
		},
		NotTracked: () => 'Ikke sporet',
		ReorderSettings: () => 'Genbestillingsindstillinger',
		ViewMovements: () => 'Se historik',
		Adjust: () => 'Juster beholdning',
		AdjustSuccess: () => 'Beholdningen blev justeret',
		AdjustNoChanges: () => 'Ingen ændringer at anvende',
		AdjustDeltaHint: () => 'Relativ ændring i beholdningen. Brug en negativ værdi for at fjerne lager.',
		EditProduct: () => 'Rediger produkt',
		Settings: {
			Title: () => 'Indstillinger',
			Description: () => 'Styr, hvordan lagerstyring fungerer på tværs af dine salgskanaler.',
			Enabled: () => 'Aktivér lagerstyring',
			EnabledDescription: () => 'Følg lagerniveauer og lagerbevægelser for dine produkter.',
			DeductOnOrderComplete: () => 'Træk fra lageret ved gennemførte ordrer',
			DeductOnOrderCompleteDescription: () => 'Reducer automatisk beholdningen, når en ordre er gennemført.',
			BlockOversell: () => 'Bloker oversalg',
			BlockOversellDescription: () => 'Forhindr salg af flere enheder, end der er tilgængelige i en kanal.',
			RestockOnReturn: () => 'Genopfyld ved returneringer',
			RestockOnReturnDescription: () =>
				'Tilføj returnerede varer til beholdningen igen, når en refundering gennemføres.',
			HideOutOfStock: () => 'Skjul udsolgte produkter',
			HideOutOfStockDescription: () =>
				'Skjul sporede produkter fra butikken, når de ikke har tilgængeligt lager i kanalen.',
			Saved: () => 'Lagerindstillinger opdateret',
			Locations: {
				Title: () => 'Placeringer',
				Description: () => 'Administrer lagerplaceringer og tilknyt salgskanaler til dem.',
				Column: {
					Name: () => 'Navn',
					SalesChannels: () => 'Salgskanaler'
				},
				CreateTitle: () => 'Opret placering',
				CreateSuccess: () => 'Placering oprettet',
				EditTitle: () => 'Rediger placering',
				EditSuccess: () => 'Placering opdateret',
				NamePlaceholder: () => 'Lager, butiksgulv, …',
				LinkedChannels: () => 'Tilknyttede salgskanaler',
				LinkedChannelsHint: () =>
					'Vælg salgskanaler, der trækker lager fra denne placering. Tilføjelse af en kanal, der er tilknyttet et andet sted, flytter den hertil.',
				NoLinkedChannels: () => 'Ingen salgskanaler tilknyttet denne placering.',
				InitializeStock: () => 'Initialiser lagerposter',
				InitializeStockDescription: () =>
					'Opret lagerpostrækker for alle sporede varianter på denne placering. Eksisterende poster springes over.',
				InitializeStockSuccess: () => 'Lagerposter initialiseret',
				InitializeStockProgress: (args: { created: number; remaining: number }) =>
					'Oprettet ' + String(args.created) + ' poster (' + String(args.remaining) + ' tilbage)',
				InitializeStockProgressLabel: (args: { created: number; total: number }) =>
					'Oprettet ' + String(args.created) + ' af ' + String(args.total) + ' lagerposter',
				InitializeStockError: (args: { created: number }) =>
					'Initialiseringen stoppede efter oprettelse af ' +
					String(args.created) +
					' poster. Prøv igen for at fuldføre.',
				InitializeStockRetry: () => 'Prøv igen',
				AdminOnly: () => 'Kun administratorer kan administrere lagerplaceringer.'
			}
		},
		Status: {
			IN_STOCK: () => 'På lager',
			LOW_STOCK: () => 'Lav beholdning',
			OUT_OF_STOCK: () => 'Udsolgt'
		},
		MovementType: {
			ADJUSTMENT: () => 'Justering',
			RECEIPT: () => 'Modtagelse',
			TRANSFER_IN: () => 'Overførsel ind',
			TRANSFER_OUT: () => 'Overførsel ud',
			ORDER_DEDUCTION: () => 'Ordrefradrag',
			ORDER_RETURN: () => 'Ordrereturnering'
		},
		TransferStatus: {
			DRAFT: () => 'Kladde',
			IN_TRANSIT: () => 'Undervejs',
			RECEIVED: () => 'Modtaget',
			CANCELLED: () => 'Annulleret'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Kladde',
			ORDERED: () => 'Bestilt',
			PARTIALLY_RECEIVED: () => 'Delvist modtaget',
			RECEIVED: () => 'Modtaget',
			CANCELLED: () => 'Annulleret'
		},
		CreateSupplier: () => 'Opret leverandør',
		EditSupplier: () => 'Rediger leverandør',
		EditSupplierSuccess: () => 'Leverandør opdateret',
		SuppliersEmptyTitle: () => 'Ingen leverandører endnu',
		SuppliersEmptyDescription: () => 'Opret din første leverandør for at holde styr på, hvor du køber lager.',
		CreateTransfer: () => 'Opret overførsel',
		CreatePurchaseOrder: () => 'Opret indkøbsordre',
		PurchaseCurrencyHint: (args: { currency: string }) =>
			'Bruger ' + String(args.currency) + ' til denne ordre. Ret den, hvis denne ordre er anderledes.',
		PurchaseCurrencyDefaultHint: (args: { currency: string }) =>
			'Bruger som standard din rapporteringsvaluta ' + String(args.currency) + '. Bekræft eller ret den.',
		PurchaseCurrencyRequired: () => 'Vælg en indkøbsvaluta.',
		ShipTransfer: () => 'Send overførsel',
		ReceiveTransfer: () => 'Modtag overførsel',
		CancelTransfer: () => 'Annuller overførsel',
		Transfer: () => 'Overførsel',
		Actions: () => 'Handlinger',
		ReceivePurchaseOrder: () => 'Modtag varer',
		ManageSuppliers: () => 'Administrer',
		Replenish: () => 'Genopfyld lav beholdning',
		ReplenishSuccess: (args: { count: number }) => 'Oprettede ' + String(args.count) + ' genopfyldningskladde(r)',
		ReplenishNone: () => 'Ingen varer under genbestillingspunktet',
		MarkOrdered: () => 'Markér som bestilt',
		CancelOrder: () => 'Annuller',
		PurchaseOrder: () => 'Indkøbsordre',
		AddLine: () => 'Tilføj',
		NoLines: () => 'Der er endnu ikke tilføjet nogen varer.',
		SelectSalesChannel: () => 'Vælg salgskanal',
		SupplierDialog: {
			Title: () => 'Produktleverandører',
			Preferred: () => 'Foretrukken',
			SetPreferred: () => 'Angiv som foretrukken',
			AddSupplier: () => 'Tilføj leverandør',
			SelectSupplier: () => 'Vælg leverandør',
			Empty: () => 'Der er endnu ingen leverandører tilknyttet dette produkt.',
			NoSuppliersYet: () => 'Der findes endnu ingen leverandører',
			NoSuppliersDescription: () => 'Opret en leverandør, før du tilknytter den til dette produkt.',
			CreateSupplierAction: () => 'Opret leverandør',
			SupplierProductCode: () => 'Leverandørens produktkode',
			UpdateSuccess: () => 'Leverandør opdateret',
			AllSuppliersLinked: () => 'Alle eksisterende leverandører er allerede tilknyttet dette produkt.',
			EditPrices: () => 'Rediger priser',
			MarginUnavailable: () => 'Ikke tilgængelig',
			MarginCurrencyMismatch: (args: { retail: string; purchase: string }) =>
				'Marginen kan ikke beregnes, fordi udsalgsprisen (' +
				String(args.retail) +
				') og leverandørprisen (' +
				String(args.purchase) +
				') bruger forskellige valutaer.',
			MarginTaxNote: () =>
				'Marginen beregnes ud fra detailprisen ekskl. moms. Detailpriser inkl. moms får momsen fratrukket først.',
			PurchasePriceTaxNote: () => 'Angiv leverandørens indkøbspris ekskl. moms (netto).'
		}
	},
	Companies: {
		Title: () => 'Virksomheder',
		Anonymous: () => 'Uden navn',
		CreateTitle: () => 'Opret virksomhed',
		CreateSuccess: () => 'Virksomhed oprettet',
		EditTitle: () => 'Rediger virksomhed',
		EditSuccess: () => 'Virksomhed opdateret',
		UpdateSuccess: () => 'Virksomhed opdateret',
		Delete: {
			Title: () => 'Slet virksomhed',
			Description: (args: { name: string }) =>
				'Er du sikker på, at du vil slette virksomheden ' +
				String(args.name) +
				'? Denne handling kan ikke fortrydes.'
		},
		DeleteSuccess: () => 'Virksomhed slettet',
		CardCount: () => 'Firmakort',
		SettlementCount: () => 'Seneste afregninger',
		RecentSettlements: () => 'Seneste afregninger',
		Cards: {
			Title: () => 'Firmakort'
		},
		Detail: {
			Title: () => 'Virksomhedsdetaljer',
			General: () => 'Generelt',
			ContactInfo: () => 'Kontaktoplysninger',
			Cards: () => 'Firmakort',
			Settlements: () => 'Afregninger',
			RecentSettlements: () => 'Seneste afregninger',
			AssignCard: () => 'Tildel kort',
			AssignCardDescription: () =>
				'Søg efter et firmakort på navn eller kortnummer for at tildele det til denne virksomhed.',
			AssignCardSuccess: () => 'Kort tildelt',
			UnassignCard: () => 'Fjern tildeling af kort',
			UnassignCardConfirm: () => 'Er du sikker på, at du vil fjerne tildelingen af dette kort fra virksomheden?',
			UnassignCardSuccess: () => 'Korttildeling fjernet',
			CardNumberPlaceholder: () => 'Søg på navn eller kortnummer'
		},
		Column: {
			Name: () => 'Navn',
			Email: () => 'E-mail',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID',
			CardCount: () => 'Kort',
			SettlementCount: () => 'Afregninger',
			CreatedAt: () => 'Oprettet'
		},
		Field: {
			Name: () => 'Navn',
			Email: () => 'E-mail',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID'
		},
		Create: {
			BasicInfo: () => 'Grundlæggende oplysninger',
			Description: () => 'Opret en ny virksomhed',
			NamePlaceholder: () => 'Indtast virksomhedsnavn',
			ExternalIdPlaceholder: () => 'Indtast ekstern ID (valgfrit)'
		},
		Edit: {
			BasicInfo: () => 'Grundlæggende oplysninger',
			Description: () => 'Rediger virksomhedsoplysninger',
			NamePlaceholder: () => 'Indtast virksomhedsnavn',
			EmailPlaceholder: () => 'Indtast e-mailadresse',
			PhonePlaceholder: () => 'Indtast telefonnummer',
			OrgNumberPlaceholder: () => 'Indtast CVR-nummer',
			ExternalIdPlaceholder: () => 'Indtast ekstern ID (valgfrit)'
		}
	},
	Customers: {
		Title: () => 'Kunder',
		UnnamedCustomer: () => 'Kunde uden navn',
		Anonymous: () => 'Anonym',
		CreateTitle: () => 'Opret kunde',
		CreateSuccess: (args: { name: string }) => 'Kunden ' + String(args.name) + ' blev oprettet.',
		EditTitle: () => 'Rediger kunde',
		UpdateSuccess: () => 'Kunde opdateret',
		Detail: {
			Title: () => 'Kunde',
			General: () => 'Generelt',
			ContactInfo: () => 'Kontaktoplysninger',
			Cards: () => 'Kort',
			AssignCard: () => 'Tildel kort',
			AssignCardDescription: () =>
				'Søg efter et firmakort på navn eller kortnummer for at tildele det til denne kunde.',
			AssignCardSuccess: () => 'Kort tildelt',
			UnassignCard: () => 'Fjern tildeling af kort',
			UnassignCardConfirm: () => 'Er du sikker på, at du vil fjerne tildelingen af dette kort fra kunden?',
			UnassignCardSuccess: () => 'Korttildeling fjernet',
			CardNumberPlaceholder: () => 'Søg på navn eller kortnummer'
		},
		Column: {
			Name: () => 'Navn',
			Email: () => 'E-mail',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID',
			Cards: () => 'Kort'
		},
		Field: {
			FirstName: () => 'Fornavn',
			LastName: () => 'Efternavn',
			Phone: () => 'Telefon',
			SSN: () => 'CPR-nr.'
		},
		Create: {
			BasicInfo: () => 'Grundlæggende oplysninger',
			Description: () => 'Opret en ny kunde'
		},
		Edit: {
			BasicInfo: () => 'Grundlæggende oplysninger',
			Description: () => 'Rediger kundeoplysninger',
			FirstNamePlaceholder: () => 'Indtast fornavn',
			LastNamePlaceholder: () => 'Indtast efternavn',
			EmailPlaceholder: () => 'Indtast e-mailadresse',
			PhonePlaceholder: () => 'Indtast telefonnummer',
			SSNPlaceholder: () => 'Indtast CPR-nr. (valgfrit)',
			ExternalIdPlaceholder: () => 'Indtast ekstern ID (valgfrit)'
		},
		Cards: {
			Title: () => 'Kundekort',
			Active: () => 'Aktive kort'
		}
	},
	BusinessCards: {
		Title: () => 'Firmakort',
		CreateTitle: () => 'Opret firmakort',
		CreateSuccess: () => 'Firmakort oprettet',
		EditTitle: () => 'Rediger firmakort',
		EditSuccess: () => 'Firmakort opdateret',
		DeleteSuccess: () => 'Firmakort slettet',
		Create: {
			NamePlaceholder: () => 'Indtast kortnavn',
			CardNumberPlaceholder: () => 'Indtast kortnummer',
			SelectCompany: () => 'Vælg en virksomhed',
			SelectCustomer: () => 'Vælg en kunde',
			PinTitle: () => 'Firmakort oprettet',
			PinDescription: () => 'Del denne PIN med kortindehaveren. Den kan kun vises én gang.',
			GoToCard: () => 'Gå til kort'
		},
		Delete: {
			Title: () => 'Slet firmakort',
			Description: () => 'Er du sikker på, at du vil slette dette firmakort? Denne handling kan ikke fortrydes.'
		},
		Detail: {
			Title: () => 'Firmakort',
			General: () => 'Generelt',
			CardDetails: () => 'Kortdetaljer',
			Security: () => 'Sikkerhed',
			ResetPin: () => 'Nulstil PIN',
			ResetPinDescription: () => 'Generer en ny PIN til dette kort. Den nuværende PIN bliver ugyldig.',
			ResetPinSuccess: () => 'PIN blev nulstillet',
			NewPin: (args: { pin: string }) => 'Ny PIN: ' + String(args.pin),
			PinViewOnce: () => 'Denne PIN kan kun vises én gang. Gem den, før du lukker denne dialog.',
			Customer: () => 'Kunde',
			Company: () => 'Virksomhed',
			DangerZone: () => 'Farezone',
			DeleteCardDescription: () => 'Slet dette firmakort permanent. Denne handling kan ikke fortrydes.'
		},
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Customer: () => 'Kunde',
			ExternalId: () => 'Ekstern ID',
			CreatedAt: () => 'Oprettet'
		},
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Blokeret'
					default:
						return String(v)
				}
			})(arg0)
	},
	Promotions: {
		Title: () => 'Kampagner',
		Group: () => 'Kampagnegruppe',
		Groups: () => 'Grupper',
		SelectGroups: () => 'Vælg kampagnegrupper',
		Column: {
			PromotionCount: () => 'Kampagner'
		},
		CreateTitle: () => 'Opret kampagne',
		CreateSuccess: () => 'Kampagne oprettet',
		EditTitle: () => 'Rediger kampagne',
		UpdateSuccess: () => 'Kampagne opdateret',
		NotFound: () => 'Kampagne ikke fundet',
		AdvancedFilters: () => 'Kampagnefiltre',
		ManagedExternally: (args: { source: string }) => 'Denne kampagne administreres af ' + String(args.source),
		Create: {
			ApplyToAll: () => 'Alle produkter',
			ApplyToGroups: () => 'Specifikke produktgrupper',
			ApplyToCategories: () => 'Specifikke kategorier',
			ApplyToProducts: () => 'Specifikke produkter',
			AppliesTo: () => 'Gælder for',
			FixedAmount: () => 'Fast beløb',
			Percentage: () => 'Procent',
			OverridePrice: () => 'Tilsidesæt pris',
			OverridePriceHelp: () =>
				'Angiv en fast totalpris for de matchede varer pr. salgskanal eller salgskanalgruppe',
			IncludeFeesHelp: () =>
				'Når den er slået til, er tilsidesættelsesprisen den endelige totalpris inklusive eventuelle varegebyrer. Når den er slået fra, lægges varegebyrer oven i tilsidesættelsesprisen.',
			OverridePriceNoChannels: () =>
				'Vælg mindst én salgskanal eller salgskanalgruppe for at angive tilsidesatte priser',
			BasicInfo: () => 'Grundlæggende info',
			DaysOfWeek: () => 'Ugedage',
			Discount: () => 'Effekt',
			DiscountAmount: () => 'Rabatbeløb',
			DiscountPercentage: () => 'Rabatprocent',
			PercentageHelp: () => 'Indtast en procent mellem 0 og 100',
			ItemCount: () => 'Antal varer',
			NamePlaceholder: () => 'Indtast kampagnenavn',
			DisplayTitle: () => 'Visningstitel',
			DisplayTitlePlaceholder: () => 'Vises til kunder (valgfrit)',
			DisplayTitleHint: () =>
				'Kundevendt titel vist i scan & go, selvbetjeningskasse og webshop. Lad feltet stå tomt for at bruge det interne navn.',
			ProductGroup: () => 'Produktgruppe',
			ProductGroups: () => 'Produktgrupper',
			SlotKind: () => 'Type',
			SlotKindGroup: () => 'Produktgruppe',
			SlotKindCategory: () => 'Kategori',
			Categories: () => 'Kategorier',
			Products: () => 'Produkter',
			CustomerEligibility: () => 'Kundeberettigelse',
			CustomerEligibilityHint: () =>
				'Lad stå tomt for at gælde for alle. Tilføj kunder eller kundegrupper for at begrænse kampagnen til dem.',
			CustomerGroups: () => 'Kundegrupper',
			SelectCustomerGroups: () => 'Vælg kundegrupper',
			Customers: () => 'Kunder',
			SelectCustomers: () => 'Vælg kunder',
			PromotionType: () => 'Kampagnetype',
			TypeDiscount: () => 'Rabat',
			TypeBundle: () => 'Pakketilbud',
			TypeBuyXGetY: () => 'Køb X, få Y',
			BundleGroups: () => 'Pakkegrupper og kategorier',
			BundleGroupsHelp: () =>
				'Kampagnen gælder, når det påkrævede antal fra hver gruppe eller kategori er i ordren',
			QualifyingGroups: () => 'Kvalificerende produkter (køb)',
			QualifyingGroupsHelp: () =>
				'Det påkrævede antal fra hver af disse grupper eller kategorier skal være i ordren for at udløse tilbuddet. Disse varer får ikke rabat.',
			BenefitGroups: () => 'Fordelsprodukter (få)',
			BenefitGroupsHelp: () =>
				'Når de kvalificerende produkter er til stede, får det påkrævede antal fra hver af disse grupper eller kategorier rabatten nedenfor (100 % = gratis).',
			AddBundleGroup: () => 'Tilføj gruppe eller kategori',
			Schedule: () => 'Tidsplan',
			AddDay: () => 'Tilføj dage',
			SelectDays: () => 'Vælg dage',
			SelectProductGroups: () => 'Vælg produktgrupper',
			SelectCategories: () => 'Vælg kategorier',
			SelectProducts: () => 'Vælg produkter',
			SelectSalesChannels: () => 'Vælg salgskanaler',
			SalesChannelGroups: () => 'Salgskanalgrupper',
			SelectSalesChannelGroups: () => 'Vælg salgskanalgrupper',
			ApplicationRule: () => 'Anvendelsesregel',
			Description: () => 'Beskrivelse',
			Rank: () => 'Prioritet',
			RankHint: () => 'Lavere tal anvendes først, når flere kampagner matcher de samme varer',
			RankInUse: (args: { names: string }) =>
				'En anden kampagne bruger allerede denne prioritet: ' +
				String(args.names) +
				'. Kampagner med samme prioritet anvendes i vilkårlig rækkefølge, brug et unikt nummer for at styre, hvilken der kører først.',
			SellingUnit: () => 'Salgsenhed',
			SellingUnitHelp: () =>
				'Alle enheder anvender kampagnen på alle salgsenheder af de valgte produkter. Basisenhed eller en navngivet pakke begrænser den til den enhed.',
			AllUnits: () => 'Alle enheder',
			BaseUnit: () => 'Basisenhed',
			Validation: {
				NameRequired: () => 'Navn er påkrævet',
				PercentageRange: () => 'Indtast en procent mellem 0 og 100',
				PercentageRequired: () => 'Indtast en rabatprocent',
				BundleGroupsRequired: () => 'Tilføj mindst én pakkegruppe eller kategori med antal',
				BenefitGroupsRequired: () => 'Tilføj mindst én fordelsgruppe eller kategori med et antal',
				QualifyingBenefitOverlap: () =>
					'En produktgruppe eller kategori kan ikke være både et kvalificerende mål og et fordelsmål',
				OverridePriceRequired: () => 'Angiv en tilsidesat pris for mindst én salgskanal',
				ScopeTargetsRequired: () => 'Vælg mindst én produktgruppe, kategori eller ét produkt',
				RankRange: () => 'Indtast en prioritet på 0 eller højere'
			}
		},
		Detail: {
			SalesChannels: () => 'Salgskanaler',
			DisplayTitle: () => 'Visningstitel',
			StartDate: () => 'Startdato',
			EndDate: () => 'Slutdato',
			OverridePrice: () => 'Tilsidesæt pris',
			IncludeFees: () => 'Inkluder gebyrer',
			ApplyToAllProducts: () => 'Anvend på alle produkter',
			ProductGroups: () => 'Produktgrupper',
			DiscountDefinition: () => 'Rabatdefinition',
			ApplicationRule: () => 'Anvendelsesregel',
			Prices: () => 'Priser',
			Title: () => 'Kampagnedetaljer',
			AppliesTo: () => 'Gælder for',
			SellingUnit: () => 'Salgsenhed',
			CustomerEligibility: () => 'Kundeberettigelse',
			AppliesToEveryone: () => 'Alle kunder',
			DaysOfWeek: () => 'Ugedage',
			Discount: () => 'Rabat',
			DiscountType: () => 'Rabattype',
			DiscountValue: () => 'Rabatværdi',
			Schedule: () => 'Tidsplan'
		},
		Edit: {
			Description: () => 'Rediger kampagnedetaljerne'
		},
		Delete: {
			Title: () => 'Slet kampagne',
			Description: (args: { name: string }) =>
				'Er du sikker på, at du vil slette kampagnen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kampagnen ' + String(args.name) + ' blev slettet.'
		}
	},
	Promotion: {
		Title: () => 'Kampagne',
		CreateTitle: () => 'Opret kampagne'
	},
	Marketing: {
		Title: () => 'Markedsføring',
		Library: () => 'Bibliotek',
		Campaigns: () => 'Kampagner',
		Channels: () => 'Kanaler',
		Messaging: () => 'Beskeder',
		Journeys: () => 'Forløb',
		ContentNav: () => 'Indhold',
		LayoutNav: () => 'Layout',
		Channel: {
			Title: () => 'Marketingkanaler',
			NewChannel: () => 'Ny kanal',
			NoChannels: () => 'Ingen marketingkanaler endnu',
			NoChannelsDescription: () =>
				'Opret en marketingkanal for at publicere indhold og layouts til en marketingflade.',
			CampaignCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('da', args.count, { one: 'kampagne', other: 'kampagner' }),
			SalesChannelsHint: () =>
				'Vælg de salgskanaler, der hører til denne marketingkanal. En salgskanal kan kun tilhøre én marketingkanal.',
			PublishableKeysHint: () =>
				'Vælg de publicerbare nøgler (apps / klienter), der henter deres feed og layout fra denne kanal. En publicerbar nøgle kan kun tilhøre én marketingkanal.',
			SurfacesHint: () =>
				'Vælg de klientflader, denne kanal betjener. Den tilbydes kun for en flade, den betjener, og intet publiceres til en flade, der ikke er valgt.',
			DeleteConfirm: () => 'Slet denne marketingkanal? Dens publicerbare nøgler bliver frakoblet.',
			Field: {
				Name: () => 'Navn',
				NamePlaceholder: () => 'f.eks. Scan & Go, Selvbetjening, Skærm',
				Description: () => 'Beskrivelse',
				DescriptionPlaceholder: () => 'Valgfri beskrivelse',
				SalesChannels: () => 'Salgskanaler',
				Surfaces: () => 'Flader',
				SurfacesPlaceholder: () => 'Vælg flader',
				PublishableKeys: () => 'Publicerbare nøgler',
				PublishableKeysPlaceholder: () => 'Vælg publicerbare nøgler'
			},
			Action: {
				Create: () => 'Opret kanal',
				Save: () => 'Gem ændringer',
				Delete: () => 'Slet'
			}
		},
		Campaign: {
			Title: () => 'Kampagne',
			NewCampaign: () => 'Ny kampagne',
			NoCampaigns: () => 'Ingen kampagner endnu',
			NoCampaignsDescription: () => 'Opret en kampagne for at planlægge en gruppe kampagner til kundeappen.',
			ActiveNow: () => 'Aktiv nu',
			Scheduled: () => 'Planlagt',
			Draft: () => 'Kladde',
			Ended: () => 'Afsluttet',
			StatusEnum: (arg0: 'DRAFT' | 'PUBLISHED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Kladde'
						case 'PUBLISHED':
							return 'Publiceret'
						default:
							return String(v)
					}
				})(arg0),
			WindowStatusEnum: (arg0: 'DRAFT' | 'SCHEDULED' | 'ACTIVE' | 'ENDED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Kladde'
						case 'SCHEDULED':
							return 'Planlagt'
						case 'ACTIVE':
							return 'Aktiv nu'
						case 'ENDED':
							return 'Afsluttet'
						default:
							return String(v)
					}
				})(arg0),
			ItemTypeEnum: (arg0: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR' | 'CUSTOM') =>
				(v => {
					switch (v) {
						case 'BANNER':
							return 'Banner'
						case 'LIST':
							return 'Liste'
						case 'MODAL':
							return 'Modal'
						case 'SEPARATOR':
							return 'Skilletegn'
						case 'CUSTOM':
							return 'Brugerdefineret'
						default:
							return String(v)
					}
				})(arg0),
			Field: {
				Name: () => 'Navn',
				NamePlaceholder: () => 'Kampagnenavn',
				Description: () => 'Beskrivelse',
				DescriptionPlaceholder: () => 'Valgfri beskrivelse',
				Title: () => 'Titel',
				ItemTitlePlaceholder: () => 'Åbningstider',
				ApiKey: () => 'Publicerbar nøgle',
				MarketingChannel: () => 'Marketingkanal',
				Status: () => 'Status',
				StartsAt: () => 'Starter',
				EndsAt: () => 'Slutter',
				EndsAtOpenEnded: () => 'Ingen slutdato',
				Rank: () => 'Rangering',
				Items: () => 'Elementer'
			},
			Action: {
				Publish: () => 'Publicer',
				Unpublish: () => 'Afpublicer',
				Save: () => 'Gem ændringer',
				Delete: () => 'Slet',
				Duplicate: () => 'Dupliker',
				AddItem: () => 'Tilføj element',
				MoveUp: () => 'Flyt op',
				MoveDown: () => 'Flyt ned'
			},
			Validation: {
				StartsAtRequired: () => 'Startdato er påkrævet for at publicere',
				EndsAtAfterStartsAt: () => 'Slutdato skal være efter startdato'
			},
			Item: {
				NoItems: () => 'Ingen elementer endnu',
				NoItemsDescription: () =>
					'Tilføj et banner, en liste, en modal eller et skilletegn for at begynde at bygge denne kampagne.'
			},
			Link: {
				TypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK' | 'IMAGE') =>
					(v => {
						switch (v) {
							case 'NONE':
								return 'Ingen'
							case 'BROWSER':
								return 'Browser-URL'
							case 'DEEP_LINK':
								return 'Deeplink'
							case 'IMAGE':
								return 'Billedeksempel'
							default:
								return String(v)
						}
					})(arg0),
				BrowserUrl: () => 'URL',
				DeepLink: () => 'Deeplink-sti',
				ImageUrl: () => 'Billed-URL',
				ImageSource: () => 'Billede til forhåndsvisning',
				ImageSourceHelp: () => 'Forstør bannerets eget billede, eller peg på et andet billede.',
				ImageSourceEnum: (arg0: 'BANNER' | 'CUSTOM') =>
					(v => {
						switch (v) {
							case 'BANNER':
								return 'Brug bannerets billede'
							case 'CUSTOM':
								return 'Brugerdefineret billed-URL'
							default:
								return String(v)
						}
					})(arg0)
			},
			Help: {
				MarketingChannel: () => 'Hvilken gruppe af salgskanaler der ser denne kampagne.',
				Status: () => 'Kladder er skjult i appen. Publicerede kampagner vises i deres planlagte periode.',
				Schedule: () =>
					'Valgfrit. Lad start være tom for at vise med det samme, og slut være tom for at køre uendeligt. Udløbne kampagner skjules automatisk.',
				StartsAt: () => 'Standard er 00:00 på den dag, du vælger. Lad være tom for at vise med det samme.',
				EndsAt: () => 'Standard er 23:59 på den dag, du vælger. Lad være tom for at køre uendeligt.',
				Rank: () => 'Når flere kampagner er aktive samtidigt, vises højere rangering først.',
				Items: () => 'Elementer vises fra top til bund i kundeappen, i præcis denne rækkefølge.'
			},
			Preview: {
				Title: () => 'Forhåndsvisning',
				Empty: () => 'Tilføj elementer for at forhåndsvise, hvordan kampagnen ser ud i appen.',
				Disclaimer: () => 'Omtrentlig forhåndsvisning af kundeappens startskærm.'
			},
			AdvancedOptions: () => 'Avancerede indstillinger',
			BannerTypeEnum: (arg0: 'IMAGE' | 'TEXT_WITH_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'IMAGE':
							return 'Billede'
						case 'TEXT_WITH_BACKGROUND':
							return 'Tekst med baggrund'
						default:
							return String(v)
					}
				})(arg0),
			BannerText: () => 'Tekst',
			ListImages: () => 'Listebilleder',
			AddImage: () => 'Tilføj billede',
			AddImages: () => 'Tilføj billeder',
			AddImagesCount: (args: { count: number }) =>
				'Tilføj ' + String(args.count) + ' ' + plural('da', args.count, { one: 'billede', other: 'billeder' }),
			ThumbnailLinkTypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Billedforhåndsvisning'
						case 'BROWSER':
							return 'Browser-URL'
						case 'DEEP_LINK':
							return 'Deeplink'
						default:
							return String(v)
					}
				})(arg0),
			JoinAbove: () => 'Slå sammen med blokken ovenfor',
			ShowTitle: () => 'Vis titel',
			ShowTitleHelp: () => 'Valgfri overskrift vist over dette element i appen.',
			ListImageShape: () => 'Billedform',
			ListImageShapeEnum: (arg0: 'SQUARE' | 'PORTRAIT' | 'LANDSCAPE') =>
				(v => {
					switch (v) {
						case 'SQUARE':
							return 'Kvadrat'
						case 'PORTRAIT':
							return 'Portræt'
						case 'LANDSCAPE':
							return 'Landskab'
						default:
							return String(v)
					}
				})(arg0),
			ListImageSize: () => 'Billedstørrelse',
			ListImageSizeHelp: () => 'En del af næste billede forbliver synlig, så kunderne ved, at de kan scrolle.',
			ListImageSizeEnum: (arg0: 'LARGE' | 'MEDIUM' | 'SMALL') =>
				(v => {
					switch (v) {
						case 'LARGE':
							return 'Stor'
						case 'MEDIUM':
							return 'Mellem'
						case 'SMALL':
							return 'Lille'
						default:
							return String(v)
					}
				})(arg0),
			ModalCover: () => 'Forsidebillede til modal',
			ContainerClassName: () => 'Container-klassenavn',
			CustomInfo: () => 'Brugerdefinerede elementer gengives af kundeappen. Der er ingen redigerbare felter her.',
			TapAction: () => 'Når der trykkes',
			TapActionHelp: () =>
				'Hvor banneret fører hen, når der trykkes, eller en indbygget handling i stedet. Indbyggede handlinger erstatter navigation.',
			TapActionNavigate: () => 'Naviger',
			TapActionBuiltIn: () => 'Indbygget',
			PromotionAction: () => 'Tryk-handling',
			PromotionActionHelp: () => 'Valgfri indbygget adfærd, når banneret trykkes, som tilsidesætter linket.',
			PromotionActionEnum: (arg0: 'NONE' | 'ADD_LOYALTY_CARD_TO_WALLET' | 'LOYALTY_CARD_INFO') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Ingen'
						case 'ADD_LOYALTY_CARD_TO_WALLET':
							return 'Tilføj loyalitetskort til wallet'
						case 'LOYALTY_CARD_INFO':
							return 'Vis loyalitetskortinfo'
						default:
							return String(v)
					}
				})(arg0)
		},
		Placement: {
			Title: () => 'Placeringer',
			Help: () =>
				'En placering er denne kampagnes indhold på én marketingkanal. Tilføj en placering pr. kanal, der skal vise denne kampagne.',
			Add: () => 'Tilføj placering',
			Empty: () => 'Tilføj en placering for at definere, hvad denne kampagne viser på en kanal.',
			Count: (args: { count: number }) =>
				String(args.count) + ' ' + plural('da', args.count, { one: 'placering', other: 'placeringer' }),
			Rank: () => 'Rangering',
			RankHelp: () => 'Når flere kampagner er aktive samtidigt, vises højere rangering først i feedet.',
			Delete: () => 'Fjern placering',
			DeleteConfirm: () => 'Fjern denne placering? Dens indhold bliver slettet.'
		},
		Layout: {
			Title: () => 'Feed-layout',
			Help: () =>
				'Den faste struktur i denne kanals feed. Statiske blokke (bannere, links, skilletegn) vises altid, og kampagnezonen markerer, hvor aktivt kampagneindhold indsættes.',
			AddCampaignZone: () => 'Tilføj kampagnezone',
			CampaignZone: () => 'Kampagnezone',
			CampaignZoneHint: () => 'Aktive kampagner vises her',
			DrawerHint: () => 'Arrangér de faste blokke og kampagnezonen for denne kanal',
			UnsavedConfirm: () => 'Du har ugemte ændringer, der vil gå tabt. Fortsæt til feed-layoutet?',
			PreviewModeLayout: () => 'Layout',
			PreviewModeLive: () => 'Live-feed',
			LivePreviewHint: () => 'Det publicerede feed, kunderne ser nu, inklusive aktive kampagner.',
			CheckoutPreviewHint: () =>
				'Det, denne udgangsskærm viser lige nu. Planlagte baggrunde vises kun i deres tidsrum.'
		},
		Content: {
			Title: () => 'Indhold',
			NewContent: () => 'Nyt indhold',
			NoContent: () => 'Intet indhold endnu',
			NoContentDescription: () =>
				'Opret en indholdsblok, og føj den derefter til et kanallayout for at gøre den aktiv.',
			NoMatches: () => 'Intet matchende indhold',
			NoMatchesDescription: () => 'Intet indhold matcher den aktuelle søgning og de valgte filtre.',
			ClearFilters: () => 'Ryd filtre',
			ChannelFilter: () => 'Marketingkanal',
			TypeOption: (arg0: 'ALL' | 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'ALL':
							return 'Alle'
						case 'FEED':
							return 'Kundeapp-feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Kasseskærm'
						default:
							return String(v)
					}
				})(arg0),
			BlockCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('da', args.count, { one: 'blok', other: 'blokke' }),
			LayoutCount: (args: { count: number }) =>
				'I ' + String(args.count) + ' ' + plural('da', args.count, { one: 'layout', other: 'layouts' }),
			NotInLayout: () => 'Ikke i noget layout',
			DeleteConfirm: () => 'Slet dette indhold? Det fjernes fra alle kanallayouts.',
			DuplicateSuccess: () => 'Indhold duplikeret',
			Blocks: () => 'Blokke',
			BlocksHelp: () => 'Blokke vises oppefra og ned i kundeappen, i præcis denne rækkefølge.',
			SaveDraft: () => 'Gem som kladde',
			SaveAndPublish: () => 'Gem og udgiv',
			SaveSuccess: () => 'Ændringer gemt',
			PublishSuccess: () => 'Indhold udgivet',
			UnpublishSuccess: () => 'Indhold afpubliceret',
			UnsavedChanges: () => 'Ikke-gemte ændringer',
			DraftNotice: () => 'Dette indhold er en kladde og vises ikke for kunder. Udgiv det, når du er klar.',
			ExpiredTitle: () => 'Dette indhold er udløbet',
			ExpiredNotice: (arg0: DateInput) =>
				'Dette indhold udløb ' +
				dateAndTimeFormatter('da', arg0) +
				' og vises ikke for kunder. Giv det en ny tidsplan for at køre det igen.',
			ExpiredSaveConfirm: () =>
				'Dette indhold er allerede udløbet, så det forbliver skjult for kunder. Gem det med den nuværende tidsplan alligevel?',
			SaveAnyway: () => 'Gem alligevel',
			ClearEndDate: () => 'Ryd slutdato',
			RunToday: () => 'Kør i dag',
			NewFeedContent: () => 'Kundeapp-feed',
			NewFeedContentHint: () => 'Bannere, billedlister og mere til feedet i kundeappen',
			NewCheckoutBackground: () => 'Kasseskærm',
			NewCheckoutBackgroundHint: () => 'Ét fuldskærmsbillede til udgangsskærmen ved selvbetjening',
			Format: (arg0: 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'FEED':
							return 'Kundeapp-feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Kasseskærm'
						default:
							return String(v)
					}
				})(arg0),
			BackgroundImage: () => 'Baggrundsbillede',
			BackgroundHelp: () =>
				'Fylder hele udgangsskærmen ved selvbetjening. På skærmene for posekontrol og udgang erstatter det den indbyggede besked, så billedet selv skal fortælle kunden, hvad de skal gøre. Liggende billeder fungerer bedst.',
			BackgroundEmpty: () =>
				'Intet billede endnu. Vælg et fra marketingbiblioteket, ellers vises intet på udgangsskærmen.'
		},
		ContentLayout: {
			Title: () => 'Layout',
			Help: () =>
				'Sortér det publicerede indhold for en kanal. Dette er feedet, kunderne ser, oppefra og ned. Planlagt indhold vises kun i sit tidsvindue.',
			SelectChannel: () => 'Kanal',
			NoChannels: () => 'Opret en marketingkanal, før du arrangerer et layout.',
			GoToChannels: () => 'Gå til marketingkanaler',
			AvailableTitle: () => 'Tilgængeligt indhold',
			NoAvailable: () => 'Alt indhold er allerede i dette layout.',
			InLayoutTitle: () => 'I dette layout',
			Empty: () => 'Intet indhold i dette layout endnu. Tilføj indhold fra listen for at opbygge feedet.',
			Add: () => 'Føj til layout',
			Remove: () => 'Fjern fra layout',
			Save: () => 'Gem layout',
			Saved: () => 'Layout gemt',
			PreviewTitle: () => 'Live feed-forhåndsvisning',
			SingleContentWarning: () =>
				'Denne skærm vises kun i få sekunder, så kun det første element ses. Behold ét element her.',
			CheckoutHelp: () =>
				'Vælg de baggrunde, der vises på denne udgangsskærm. Flere baggrunde på venteskærmen skifter; skærmene for posekontrol og udgang viser kun den første i stedet for den indbyggede besked.',
			AvailableBackgroundsTitle: () => 'Tilgængelige baggrunde',
			NoBackgrounds: () => 'Ingen baggrunde endnu. Opret en for at vise den på denne skærm.',
			NewBackground: () => 'Ny baggrund',
			NewBackgroundTitle: () => 'Ny baggrund til udgangsskærm',
			NewBackgroundDescription: () =>
				'Vælg et billede fra marketingbiblioteket. Det udgives med det samme og tilføjes denne skærm.',
			NewBackgroundCreate: () => 'Opret og tilføj',
			NewBackgroundCreated: () => 'Baggrund tilføjet. Gem layoutet for at gøre den aktiv.',
			WrongFormatOnCheckout: () =>
				'Indhold til kundeapp-feed vises ikke på udgangsskærmen. Fjern det og tilføj en baggrund i stedet.',
			WrongFormatOnFeed: () =>
				'Baggrunde til udgangsskærm vises ikke i feedet i kundeappen. Fjern den fra dette layout.',
			RemoveFlaggedToSave: () => 'Fjern de markerede elementer for at gemme layoutet.'
		},
		Surface: {
			Label: () => 'Flade',
			CustomerAppFeed: () => 'Kundeapp-feed',
			CheckoutScreen: () => 'Kasseskærm'
		},
		ScreenState: {
			Label: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Standard'
						case 'CHECKOUT_IDLE':
							return 'Inaktiv'
						case 'CHECKOUT_BAG_CHECK':
							return 'Taskekontrol'
						case 'CHECKOUT_CLEARED':
							return 'Godkendt'
						default:
							return String(v)
					}
				})(arg0),
			Hint: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Vises altid'
						case 'CHECKOUT_IDLE':
							return 'Mens der ventes på'
						case 'CHECKOUT_BAG_CHECK':
							return 'Når en taskekontrol af personale kræves'
						case 'CHECKOUT_CLEARED':
							return 'Når kunden må forlade'
						default:
							return String(v)
					}
				})(arg0)
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Taskekontrol påkrævet',
			BagCheckBody: () => 'En medarbejder kommer og tjekker din kurv',
			ClearedTitle: () => 'Alt i orden',
			ClearedBody: () => 'Du kan gå nu',
			Disclaimer: () => 'Omtrentlig forhåndsvisning af udgangsskærmen.',
			FallbackHint: () => 'Ingen baggrund valgt, så skærmen viser den indbyggede besked.'
		},
		LibraryPage: {
			NoAssets: () => 'Ingen marketingaktiver endnu',
			NoAssetsDescription: () => 'Upload billeder, bannere og andet marketingvisuelt materiale her.',
			Filename: () => 'Filnavn',
			TableView: () => 'Tabelvisning',
			GalleryView: () => 'Gallerivisning',
			Upload: () => 'Upload',
			SearchFilename: () => 'Søg på filnavn',
			ViewFullImage: () => 'Vis fuldt billede',
			CopyUrl: () => 'Kopier URL',
			CopiedUrl: () => 'URL kopieret',
			DeleteAsset: () => 'Slet aktiv',
			DeleteAssetConfirm: () => 'Slet dette aktiv? Det kan ikke fortrydes.',
			UploadAssets: () => 'Upload aktiver',
			UploadDropzone: () => 'Træk og slip billeder her, eller klik for at vælge filer',
			ChooseFiles: () => 'Vælg filer',
			Tags: () => 'Tags',
			UsedBy: () => 'Brugt af',
			UsageFilter: () => 'Brug',
			UsageUnused: () => 'Ubrugt',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgruppe',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Marketingindhold',
			UsageFeedLayout: () => 'Kundeapp-feed',
			ChannelFilter: () => 'Marketingkanal',
			ContentFilter: () => 'Brugt af indhold',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Uden indhold',
			TagsPlaceholder: () => 'Tilføj et tag og tryk Enter',
			Uploading: () => 'Uploader',
			EditTags: () => 'Rediger tags',
			NoTags: () => 'Ingen tags',
			ManageTags: () => 'Administrer tags',
			ManageTagsEmpty: () => 'Ingen tags i biblioteket endnu.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' aktiver',
			CreateTag: () => 'Opret tag',
			CreateTagPlaceholder: () => 'Tilføj et tag og tryk Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Tagget "' + String(args.tag) + '" blev oprettet.',
			RenameTag: () => 'Omdøb tag',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Flet tagget "' +
				String(args.from) +
				'" ind i "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' aktiver)? Det gamle tag fjernes.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tag omdøbt fra "' + String(args.from) + '" til "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjern tagget "' + String(args.tag) + '" fra alle aktiver? Filerne slettes ikke.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tag fjernet fra ' +
				String(args.count) +
				' ' +
				plural('da', args.count, { one: 'aktiv', other: 'aktiver' }) +
				'.'
		}
	},
	Settings: {
		Title: () => 'Indstillinger',
		Sidebar: {
			Profile: () => 'Profil',
			Store: () => 'Butik',
			Users: () => 'Brugere',
			SalesChannels: () => 'Salgskanaler',
			PointOfSale: () => 'Salgssted',
			ProductGroups: () => 'Produktgrupper',
			Exports: () => 'Eksporter',
			Analytics: () => 'Analyse',
			Companies: () => 'Virksomheder',
			CompanyCards: () => 'Firmakort',
			Settlements: () => 'Afregninger'
		},
		Profile: {
			Title: () => 'Profil',
			EditTitle: () => 'Rediger profil',
			PersonalInfo: () => 'Personlige oplysninger',
			Preferences: () => 'Præferencer',
			NamePlaceholder: () => 'Indtast dit navn',
			EmailPlaceholder: () => 'Indtast din e-mail',
			UpdateSuccess: () => 'Profil opdateret',
			Edit: {
				Description: () => 'Rediger dine profiloplysninger'
			}
		},
		Users: {
			Title: () => 'Brugere',
			InviteUser: () => 'Opret invitation',
			InviteTitle: () => 'Opret invitation',
			InviteSuccess: () => 'Invitation oprettet',
			InviteSentTo: (args: { email: string }) => 'Invitation sendt til ' + String(args.email),
			SendInvite: () => 'Opret invitation',
			CopyInviteLink: () => 'Kopier invitationslink',
			DeleteUserDescription: (args: { email: string }) =>
				'Fjern ' + String(args.email) + '? De vil ikke længere kunne logge ind.',
			DeleteUserSuccess: () => 'Bruger fjernet',
			EditTitle: () => 'Rediger bruger',
			EditSuccess: () => 'Bruger opdateret',
			DeleteInviteDescription: (args: { email: string }) =>
				'Fjern den afventende invitation til ' + String(args.email) + '?',
			DeleteInviteSuccess: () => 'Invitation fjernet',
			Status: {
				Accepted: () => 'Accepteret',
				Pending: () => 'Afventer',
				Expired: () => 'Udløbet'
			},
			Type: {
				User: () => 'Bruger',
				Invite: () => 'Invitation'
			},
			Column: {
				Type: () => 'Type'
			},
			Role: {
				Admin: () => 'Administrator',
				User: () => 'Bruger'
			},
			Invite: {
				Description: () => 'Inviter en ny bruger til din butik',
				EmailPlaceholder: () => 'Indtast e-mailadresse',
				NamePlaceholder: () => 'Indtast navn',
				UserInfo: () => 'Brugeroplysninger',
				UserAlreadyExists: (args: { email: string }) =>
					'En bruger med e-mailadressen ' + String(args.email) + ' findes allerede'
			},
			Detail: {
				Title: () => 'Brugerdetaljer',
				AdminOnly: () => 'Administratoradgang er påkrævet for at se invitationsdetaljer.'
			},
			SignInCredentials: {
				Title: () => 'Loginoplysninger',
				Description: () =>
					'Angiv det login-ID og den PIN, der bruges til at logge ind ved selvbetjening og POS-terminaler.',
				SignInId: () => 'Login-ID',
				SignInIdPlaceholder: () => 'f.eks. 1042',
				SignInIdHint: () =>
					'Kun tal. Kun påkrævet for noget hardware, som selvbetjeningskasser. Lad stå tomt, hvis denne bruger ikke logger ind på den hardware.',
				Pin: () => 'PIN',
				PinSet: () => 'En PIN er angivet',
				PinNotSet: () => 'Ingen PIN angivet',
				NewPin: () => 'Ny PIN (6 cifre)',
				PinPlaceholder: () => 'Lad stå tomt for at beholde nuværende PIN',
				ClearPin: () => 'Ryd PIN',
				Save: () => 'Gem',
				SaveSuccess: () => 'Oplysninger opdateret',
				SignInIdNumeric: () => 'Login-ID skal være numerisk',
				SignInIdTaken: () => 'Login-ID er allerede i brug',
				PinInvalid: () => 'PIN skal være præcis 6 cifre'
			}
		},
		SalesChannels: {
			Title: () => 'Salgskanaler',
			CreateTitle: () => 'Opret salgskanal',
			CreateSuccess: () => 'Salgskanal oprettet',
			EditTitle: () => 'Rediger salgskanal',
			EditSuccess: () => 'Salgskanal opdateret',
			Column: {
				CountryCode: () => 'Land',
				CurrencyCode: () => 'Valuta',
				SalesChannelType: () => 'Type',
				FulfillmentProvider: () => 'Opfyldelsesudbyder',
				AccessKeys: () => 'Adgangsnøgler',
				InventoryLocation: () => 'Lagerplacering',
				Group: () => 'Gruppe'
			},
			InventoryLocationNone: () => 'Ingen',
			InventoryLocationOptionalHint: () =>
				'Valgfrit. Tilknyt denne kanal til en lagerplacering for at spore lager. Lad stå tom, hvis lager ikke bruges.',
			SalesChannelTypeNone: () => 'Ingen',
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valgfrit. Tildel denne kanal til en gruppe for at organisere relaterede kanaler sammen.',
			Advanced: () => 'Avancerede indstillinger',
			TypeOptionalHint: () =>
				'Valgfrit. Tildel kun en type for at gruppere kanaler, der deler opfyldelses- eller forhåndsgodkendelsesindstillinger. Lad stå som Ingen, hvis du er i tvivl.',
			StorefrontUrl: () => 'Webshop-URL',
			StorefrontUrlHint: () =>
				'Valgfrit. Basis-URL for denne lejers webshop. Angiv dette for at lade Terminal-POS vise en "Få kvittering"-QR-kode efter betaling; lad stå tomt for at skjule den.',
			Groups: {
				Title: () => 'Salgskanalgrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Opret gruppe',
				CreateSuccess: () => 'Gruppe oprettet',
				EditTitle: () => 'Rediger gruppe',
				EditSuccess: () => 'Gruppe opdateret',
				NamePlaceholder: () => 'Indtast gruppenavn',
				Column: {
					Name: () => 'Navn',
					MemberCount: () => 'Salgskanaler'
				},
				Members: {
					Title: () => 'Salgskanaler',
					Label: () => 'Salgskanaler',
					Placeholder: () => 'Vælg salgskanaler',
					Empty: () => 'Ingen salgskanaler tildelt endnu.',
					Assigned: () => 'Tildelt',
					FilterUnassigned: () => 'Uden gruppe',
					SaveSuccess: () => 'Salgskanaler opdateret',
					MoveWarning: {
						Title: () => 'Flyt salgskanaler mellem grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' af de valgte salgskanaler tilhører allerede en anden gruppe og flyttes hertil: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Slet gruppe',
					Description: (args: { name: string }) =>
						'Er du sikker på, at du vil slette gruppen "' +
						String(args.name) +
						'"? Dens salgskanaler fjernes fra gruppen, men slettes ikke.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' blev slettet.'
				}
			},
			Create: {
				BasicInfo: () => 'Grundlæggende oplysninger',
				Description: () => 'Opret en ny salgskanal',
				NamePlaceholder: () => 'Indtast kanalnavn'
			},
			Edit: {
				ApiNotAvailable: () => 'API ikke tilgængelig',
				NotImplemented: () => 'Ikke implementeret endnu'
			},
			Detail: {
				Title: () => 'Salgskanaldetaljer',
				AccessKeys: () => 'Adgangsnøgler',
				CreateAccessKey: () => 'Opret adgangsnøgle',
				CreateAccessKeySuccess: () => 'Adgangsnøgle oprettet',
				PointOfSales: () => 'Salgssteder',
				PointOfSalesDescription: () => 'Administrer salgssteder for denne kanal'
			},
			AccessKeyType: {
				Title: () => 'Nøgletype',
				Publishable: () => 'Publicerbar nøgle',
				PublishableDescription: () => 'Til brug på klientsiden (POS-terminaler, butiksfacader)',
				Api: () => 'API-nøgle',
				ApiDescription: () => 'Til integrationer på serversiden'
			},
			TokenCreated: {
				Title: () => 'API-nøgle oprettet',
				Description: () => 'Dette token kan kun vises én gang. Gem det, før du lukker denne dialog.',
				Token: () => 'API-token'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nøgle'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Adgangsnøgler',
			NavLabel: () => 'Adgangsnøgler',
			Manage: () => 'Administrer',
			Create: () => 'Opret adgangsnøgle',
			EditTitle: () => 'Rediger adgangsnøgle',
			None: () => '—',
			SaveSuccess: () => 'Adgangsnøgle opdateret',
			DeleteConfirm: () => 'Slet denne adgangsnøgle? Apps, der bruger den, holder op med at virke.',
			DeleteSuccess: () => 'Adgangsnøgle slettet',
			Column: {
				Key: () => 'Nøgle',
				SalesChannels: () => 'Salgskanaler',
				MarketingChannel: () => 'Marketingkanal'
			},
			Empty: {
				Title: () => 'Ingen adgangsnøgler',
				Description: () => 'Opret en publicerbar nøgle og knyt den til salgskanaler og en marketingkanal.'
			},
			Field: {
				SalesChannels: () => 'Salgskanaler',
				SalesChannelsPlaceholder: () => 'Vælg salgskanaler',
				SalesChannelsRequired: () => 'Vælg mindst én salgskanal',
				MarketingChannel: () => 'Marketingkanal',
				MarketingChannelPlaceholder: () => 'Vælg en marketingkanal',
				DevelopmentMode: () => 'Udviklertilstand',
				DevelopmentModeHint: () =>
					'Låser udviklerværktøjer (indstillingsskærme + OTA-opdateringsstyring) op i medarbejderappen for kiosker parret med denne nøgle.'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Salgskanaltyper',
			NavLabel: () => 'Typer',
			CreateTitle: () => 'Opret salgskanaltype',
			CreateSuccess: () => 'Salgskanaltype oprettet',
			EditTitle: () => 'Rediger salgskanaltype',
			EditSuccess: () => 'Salgskanaltype opdateret',
			Column: {
				FulfillmentProvider: () => 'Opfyldelsesudbyder',
				PreauthorizationAmount: () => 'Forhåndsgodkendelsesbeløb',
				AllowCompletingUnderpaidOrders: () => 'Tillad afslutning af underbetalte ordrer'
			},
			FulfillmentProviderNone: () => 'Ingen',
			InvalidPreauthorizationAmount: () => 'Indtast et gyldigt ikke-negativt tal',
			AllowCompletingUnderpaidOrdersHint: () =>
				'Afslutter en ordre, selv hvis det opkrævede beløb er lavere end totalbeløbet. Kun til engangsbetalingsflows (f.eks. SandStar-kølemontren), hvor der ikke er en ny chance til at opkræve mere.',
			Create: {
				NamePlaceholder: () => 'Indtast typenavn'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Måleenheder',
			NavLabel: () => 'Måleenheder',
			Description: () =>
				'Fælles enheder, der bruges på tværs af alle produkter. Hvert produkt vælger blandt disse, når der tilføjes pakkestørrelser.',
			CreateTitle: () => 'Opret måleenhed',
			CreateSuccess: () => 'Enhed oprettet',
			EditTitle: () => 'Rediger måleenhed',
			EditSuccess: () => 'Enhed opdateret',
			Column: {
				Code: () => 'Kode',
				Name: () => 'Navn',
				Quantity: () => 'Standardantal',
				Default: () => 'Standard'
			},
			Code: () => 'Kode',
			Name: () => 'Navn',
			Quantity: () => 'Standardantal',
			QuantityHint: () =>
				'Fælles antal i basisenheder (f.eks. er en 6-pak 6). Lad feltet stå tomt for variable pakker.',
			DefaultEach: () => 'Standardenhed for talte varer',
			DefaultWeight: () => 'Standardenhed for vejede varer',
			DefaultEachBadge: () => 'Standard · stk',
			DefaultWeightBadge: () => 'Standard · vægt',
			CodePlaceholder: () => 'f.eks. PK6',
			NamePlaceholder: () => 'f.eks. 6-pak',
			ManagedBySync: () => 'Styres af synkronisering',
			ManagedBySyncHint: () => 'Denne enhed styres af en ekstern integration og kan ikke redigeres her.',
			InvalidCode: () => 'Kode er påkrævet',
			InvalidQuantity: () => 'Antal skal være større end nul',
			InUse: () => 'I brug',
			Delete: {
				Title: () => 'Slet enhed',
				Description: (args: { code: string }) => 'Slet ' + String(args.code) + '? Dette kan ikke fortrydes.'
			}
		},
		PointOfSale: {
			Title: () => 'Salgssted',
			CreateTitle: () => 'Opret salgssted',
			CreateSuccess: () => 'Salgssted oprettet',
			EditTitle: () => 'Rediger salgssted',
			EditSuccess: () => 'Salgssted opdateret',
			AllowedOperatingModesLabel: () => 'Tilladte driftsformer',
			SelectOperatingModes: () => 'Vælg driftsformer',
			OperatingMode: (arg0: 'ADMIN' | 'POS' | 'BAG_CHECK' | 'SCO' | 'INVENTORY' | 'TERMINAL' | 'CHECKOUT') =>
				(v => {
					switch (v) {
						case 'ADMIN':
							return 'Admin'
						case 'POS':
							return 'Salgssted'
						case 'BAG_CHECK':
							return 'Posecheck'
						case 'SCO':
							return 'Selvbetjening'
						case 'INVENTORY':
							return 'Lager'
						case 'TERMINAL':
							return 'Terminal'
						case 'CHECKOUT':
							return 'Checkout'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamLevelLabel: () => 'Streaming af enhedslogfiler',
			LogStreamLevel: (arg0: 'OFF' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG') =>
				(v => {
					switch (v) {
						case 'OFF':
							return 'Fra'
						case 'ERROR':
							return 'Fejl'
						case 'WARN':
							return 'Advarsel'
						case 'INFO':
							return 'Info'
						case 'DEBUG':
							return 'Fejlfinding'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamIdLabel: () => 'Tilsidesæt logstrøm-ID',
			LogStreamIdPlaceholder: () => 'Standard er identifikatoren ovenfor',
			LogStreamIdInvalidChars: () => 'Må ikke indeholde ":" eller "*"',
			LogStreamIdTooLong: () => 'For langt',
			ForcedOrientationLabel: () => 'Tvungen retning',
			ForcedOrientationHint: () => 'Låser enhedens skærm. Automatisk følger enheden.',
			ForcedOrientationAutomatic: () => 'Automatisk',
			ForcedOrientation: (
				arg0: 'portrait' | 'portrait-reverse' | 'landscape' | 'landscape-reverse' | 'default'
			) =>
				(v => {
					switch (v) {
						case 'portrait':
							return 'Stående'
						case 'portrait-reverse':
							return 'Stående på hovedet'
						case 'landscape':
							return 'Liggende'
						case 'landscape-reverse':
							return 'Liggende omvendt'
						case 'default':
							return 'Ulåst'
						default:
							return String(v)
					}
				})(arg0),
			SafeAreaInsetsLabel: () => 'Tilsidesættelse af sikker zone (px)',
			SafeAreaInsetsHint: () =>
				'Til enheder hvis OS rapporterer forkerte sikre zoner (f.eks. altid 0). Lad en side stå tom for at bruge den rigtige værdi.',
			SafeAreaInsetTop: () => 'Top',
			SafeAreaInsetRight: () => 'Højre',
			SafeAreaInsetBottom: () => 'Bund',
			SafeAreaInsetLeft: () => 'Venstre',
			Column: {
				Identifier: () => 'Identifikator',
				AccessKeys: () => 'Adgangsnøgler',
				Group: () => 'Gruppe'
			},
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valgfrit. Tildel dette salgssted til en gruppe for at organisere relaterede terminaler sammen.',
			LinkSalesChannelButton: () => 'Tilknyt',
			LinkSalesChannelTitle: () => 'Tilknyt en salgskanal',
			LinkSalesChannelDescription: () => 'Tilføj en salgskanal til dette salgssted.',
			LinkSalesChannelSuccess: () => 'Salgskanal tilknyttet',
			SelectSalesChannel: () => 'Vælg en salgskanal',
			NoUnlinkedSalesChannels: () => 'Alle salgskanaler er allerede tilknyttet.',
			Create: {
				BasicInfo: () => 'Grundlæggende oplysninger',
				Description: () => 'Opret et nyt salgssted',
				NamePlaceholder: () => 'Indtast lokationsnavn',
				SelectSalesChannels: () => 'Vælg salgskanaler',
				IdentifierPlaceholder: () => 'Indtast identifikator'
			},
			Groups: {
				Title: () => 'Salgsstedgrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Opret gruppe',
				CreateSuccess: () => 'Gruppe oprettet',
				EditTitle: () => 'Rediger gruppe',
				EditSuccess: () => 'Gruppe opdateret',
				NamePlaceholder: () => 'Indtast gruppenavn',
				Column: {
					Name: () => 'Navn',
					MemberCount: () => 'Salgssteder'
				},
				Members: {
					Title: () => 'Salgssteder',
					Label: () => 'Salgssteder',
					Placeholder: () => 'Vælg salgssteder',
					Empty: () => 'Ingen salgssteder tildelt endnu.',
					Assigned: () => 'Tildelt',
					FilterUnassigned: () => 'Uden gruppe',
					SaveSuccess: () => 'Salgssteder opdateret',
					MoveWarning: {
						Title: () => 'Flyt salgssteder mellem grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' af de valgte salgssteder tilhører allerede en anden gruppe og flyttes hertil: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Slet gruppe',
					Description: (args: { name: string }) =>
						'Er du sikker på, at du vil slette gruppen "' +
						String(args.name) +
						'"? Dens salgssteder fjernes fra gruppen, men slettes ikke.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' blev slettet.'
				}
			},
			Detail: {
				Title: () => 'Salgsstedsdetaljer',
				AccessKeys: () => 'Adgangsnøgler'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nøgle'
				}
			},
			ProductMenu: {
				Title: () => 'Produktmenu',
				Description: () => 'Produktgrupper der vises på dette salgssted.',
				EmptyTitle: () => 'Ingen menugrupper',
				EmptyDescription: () => 'Tilføj produktgrupper for at opbygge menuen på dette salgssted.',
				EditHeader: () => 'Produktmenu',
				EditDescription: () =>
					'Tilføj de produktgrupper der vises på dette salgssted, og vælg hvordan hver enkelt vises.',
				AddPlaceholder: () => 'Tilføj en produktgruppe…',
				NoGroupsSelected: () => 'Ingen produktgrupper tilføjet endnu.',
				IconLabel: () => 'Reserveikon',
				IconPlaceholder: () => 'Vælg et reserveikon…',
				IconNone: () => 'Ingen',
				IconUsesImageHint: () =>
					'Denne gruppe har et billede, der vises på menuen i stedet for et reserveikon. Rediger billedet på produktgruppen.',
				IconNotUsedWhenIndividual: () => 'Bruges ikke, når produkter vises enkeltvis på menuen.',
				ShowIndividually: () => 'Vis produkter enkeltvis',
				ShowIndividuallyHint: () => 'Produkter vises direkte på menuen i stedet for inde i en gruppe.',
				ShownIndividuallyBadge: () => 'Produkter vises enkeltvis',
				SaveSuccess: () => 'Menu opdateret.',
				Icons: {
					ShoppingBag: () => 'Indkøbspose',
					ShoppingCart: () => 'Indkøbskurv',
					Coffee: () => 'Kaffe',
					CupSoda: () => 'Kold drik',
					Utensils: () => 'Tilberedt mad',
					Pizza: () => 'Pizza',
					Sandwich: () => 'Sandwich',
					IceCream: () => 'Is',
					Beer: () => 'Øl',
					Wine: () => 'Vin',
					Bakery: () => 'Bageri',
					Gift: () => 'Gave'
				}
			}
		},
		Devices: {
			Title: () => 'Enheder',
			NavLabel: () => 'Enheder',
			AccessKeysEmptyTitle: () => 'Ingen adgangsnøgler',
			AccessKeysEmptyDescription: () =>
				'Opret adgangsnøgler for at give eksterne systemer adgang til denne enhed.',
			Identifier: () => 'Identifikator',
			LinkedPointOfSale: () => 'Salgssted',
			NotLinked: () => 'Ikke tilknyttet',
			MarketingChannel: () => 'Marketingkanal',
			NoMarketingChannel: () => 'Ingen',
			MarketingChannelDescription: () =>
				'Kampagner på kasseskærmen hentes via denne marketingkanal. Uafhængigt af tilknytning til salgssted.',
			OperatingModes: () => 'Driftstilstande',
			StatusColumn: () => 'Status',
			AccessKeysColumn: () => 'Adgangsnøgler',
			EmptyTitle: () => 'Ingen enheder',
			EmptyDescription: () => 'Opret en enhed for at komme i gang.',
			CreateTitle: () => 'Opret enhed',
			CreateSuccess: () => 'Enhed oprettet',
			EditTitle: () => 'Rediger enhed',
			NamePlaceholder: () => 'f.eks. Forreste kasse',
			IdentifierPlaceholder: () => 'Lad stå tom for at generere en',
			UpdateSuccess: () => 'Enhed opdateret',
			DeleteButton: () => 'Slet enhed',
			DeleteConfirmTitle: () => 'Slet denne enhed?',
			DeleteConfirmDescription: () =>
				'Dette fjerner enheden og tilbagekalder dens adgangsnøgler. Dette kan ikke fortrydes.',
			DeleteSuccess: () => 'Enhed slettet',
			LinkButton: () => 'Tilknyt salgssted',
			LinkTitle: () => 'Tilknyt et salgssted',
			LinkDescription: () =>
				'En enhed, der fungerer som et salgssted, henter salgskanaler og ordrer gennem det tilknyttede salgssted. Tilknytning erstatter den enhed, der nu fungerer som dette salgssted.',
			LinkSuccess: () => 'Enhed tilknyttet',
			SelectPointOfSale: () => 'Vælg et salgssted',
			UnlinkButton: () => 'Fjern tilknytning',
			UnlinkConfirmTitle: () => 'Fjern tilknytning til dette salgssted?',
			UnlinkConfirmDescription: () =>
				'Enheden holder op med at hente salgskanaler og ordrer, indtil den tilknyttes igen.',
			UnlinkSuccess: () => 'Salgssted frakoblet',
			LinkedDevicesTitle: () => 'Enheder',
			LinkedDevicesEmpty: () => 'Ingen enheder er tilknyttet dette salgssted.',
			LinkDeviceButton: () => 'Tilknyt enhed',
			LinkDeviceDisabledHint: () => 'Fjern tilknytningen til den nuværende enhed, før du tilknytter en ny.',
			PointOfSaleOccupiedOption: (arg0: string) => String(arg0) + ' (enhed allerede tilknyttet)',
			LinkDeviceTitle: () => 'Tilknyt en enhed',
			LinkDeviceDescription: () => 'Vælg en ikke-tilknyttet enhed, der skal fungere som dette salgssted.',
			SelectDevice: () => 'Vælg en enhed',
			NoUnlinkedDevices: () => 'Ingen ikke-tilknyttede enheder tilgængelige.',
			Config: {
				Default: () => 'Standard',
				Enabled: () => 'Aktiveret',
				Disabled: () => 'Deaktiveret',
				GeneralSection: () => 'Generelt',
				ScoSection: () => 'Selvbetjening',
				SoundsSection: () => 'Lyde',
				LoggingSection: () => 'Logning',
				DisplaySection: () => 'Visning',
				CheckoutSection: () => 'Checkout-tilstand',
				DefaultPaymentMethod: () => 'Standardbetalingsmetode',
				ForcedOrientation: () => 'Tvunget orientering',
				ForcedFormFactor: () => 'Tvunget formfaktor',
				Language: () => 'Sprog',
				ShowPrinterDisconnected: () => 'Vis advarsel om frakoblet printer',
				ProductListColumns: () => 'Kolonner i produktliste',
				BrowseEnabled: () => 'Gennemse',
				AdjustQuantity: () => 'Juster antal',
				ClearCart: () => 'Ryd kurv',
				ItemDeletion: () => 'Slet vare',
				OrderRestart: () => 'Genstart ordre',
				Permission: (arg0: 'ENABLED' | 'STAFF_NEEDED' | 'DISABLED') =>
					(v => {
						switch (v) {
							case 'ENABLED':
								return 'Aktiveret'
							case 'STAFF_NEEDED':
								return 'Personale påkrævet'
							case 'DISABLED':
								return 'Deaktiveret'
							default:
								return String(v)
						}
					})(arg0),
				SplitPercentHorizontal: () => 'Arbejdsområdedeling, vandret (%)',
				SplitPercentVertical: () => 'Arbejdsområdedeling, lodret (%)',
				ItemAddedSound: () => 'Lyd ved tilføjet vare',
				ProductNotFoundSound: () => 'Lyd ved produkt ikke fundet',
				AddToCartFailedSound: () => 'Lyd ved fejl ved tilføjelse til kurv',
				PaymentSuccessSound: () => 'Lyd ved vellykket betaling',
				PaymentFailedSound: () => 'Lyd ved mislykket betaling',
				InactivityThresholdSeconds: () => 'Inaktivitetsgrænse (sekunder)',
				AbandonCountdownSeconds: () => 'Nedtælling ved opgivelse (sekunder)',
				CoolerReadyTimeoutSeconds: () => 'Timeout for klar køler (sekunder)',
				CheckoutModeIdleTimeoutSeconds: () => 'Timeout for inaktiv scanner (sekunder)',
				CheckoutModeTheme: () => 'Temaoverstyring (JSON)',
				CheckoutModeThemeHint: () =>
					'Objekt med valgfrie "colors"- og "fonts"-kort. Lad feltet være tomt for basistemaet.',
				InvalidJson: () => 'Skal være et gyldigt JSON-objekt'
			}
		},
		DeviceStatus: {
			Title: () => 'Enhedsstatus',
			Online: () => 'Online',
			Offline: () => 'Offline',
			NeverReported: () => 'Dette kassepunkt har aldrig rapporteret sin status.',
			ReportedAt: () => 'Sidst rapporteret',
			AppVersion: () => 'App-version',
			DisplayRuntimeVersion: () => 'Runtime-version',
			ConfiguredRuntimeVersion: () => 'Konfigureret runtime',
			Platform: () => 'Platform',
			DeviceModel: () => 'Enhedsmodel',
			NetworkType: () => 'Netværk',
			UpdateChannel: () => 'Opdateringskanal',
			UpdateId: () => 'Opdaterings-ID',
			UpdateCreatedAt: () => 'Opdatering udgivet',
			UpdatePending: (args: { time: string }) => 'Downloadet, venter på inaktivitet siden ' + String(args.time),
			OperatingMode: () => 'Driftstilstand',
			Health: () => 'Sundhed',
			PrinterConnected: () => 'Printer',
			ScannerConnected: () => 'Scanner',
			PaymentTerminalReachable: () => 'Betalingsterminal',
			Connected: () => 'Forbundet',
			Disconnected: () => 'Afbrudt',
			Unknown: () => 'Ukendt',
			Environment: () => 'Miljø (redigeret)',
			RefreshButton: () => 'Opdater status',
			RefreshSuccess: () => 'Opdatering anmodet',
			PushUpdateButton: () => 'Send opdatering',
			PushUpdateSuccess: () => 'Opdatering sendt',
			RestartAppButton: () => 'Genstart app',
			RestartAppSuccess: () => 'Genstart-kommando sendt',
			RestartAppConfirmTitle: () => 'Genstarte denne app?',
			RestartAppConfirmDescription: () => 'Appen genindlæses, når terminalen er inaktiv.',
			LockKioskButton: () => 'Lås kiosk',
			LockKioskSuccess: () => 'Kiosklås sendt',
			LockKioskOffline: () => 'Enheden er offline',
			LockKioskConfirmTitle: () => 'Låse denne kiosk?',
			LockKioskConfirmDescription: () =>
				'Kiosken låses med det samme, præcis som hvis personalet trykkede på Lås på enheden.',
			UnlockKioskButton: () => 'Lås kiosk op',
			UnlockKioskSuccess: () => 'Kiosk-oplåsning sendt',
			UnlockKioskConfirmTitle: () => 'Låse denne kiosk op?',
			UnlockKioskConfirmDescription: () =>
				'Kiosken låses op med det samme uden personale-PIN. Gør kun dette, hvis du er sikker på, at personalet skal have adgang.',
			PushUpdateDrawer: {
				Title: () => 'Send app-opdatering',
				Description: () =>
					'Bed dette kassepunkt om at kontrollere og downloade en opdatering. Den downloades straks, men genstarter først, når terminalen er inaktiv.',
				ChannelLabel: () => 'Tilsidesæt kanal',
				ChannelPlaceholder: () => 'Lad stå tomt for at bruge den nuværende kanal',
				Submit: () => 'Send opdatering'
			},
			Enrollment: {
				Title: () => 'Registreret enhed',
				NotEnrolled: () => 'Ingen enhed er i øjeblikket registreret for dette kassepunkt.',
				DeviceModel: () => 'Enhedsmodel',
				Platform: () => 'Platform',
				AppVersion: () => 'App-version',
				EnrolledAt: () => 'Registreret',
				Key: () => 'Nøgle',
				EnrollButton: () => 'Registrer enhed',
				RevokeButton: () => 'Tilbagekald',
				RevokeConfirmTitle: () => 'Tilbagekalde denne enhed?',
				RevokeConfirmDescription: () => 'Enheden bliver straks logget ud og skal parres igen for at få adgang.',
				RevokeSuccess: () => 'Enhed tilbagekaldt',
				EnrollDrawer: {
					Title: () => 'Registrer enhed',
					Description: () => 'Indtast den 8-cifrede parringskode, der vises på enheden.',
					CodeLabel: () => 'Parringskode',
					CodePlaceholder: () => '1234 5678',
					LookupButton: () => 'Slå enhed op',
					LookupError: () => 'Denne kode er ugyldig eller er udløbet.',
					ConfirmTitle: () => 'Registrere denne enhed?',
					ConfirmDescriptionWithCurrent: (args: { device: string; currentDevice: string }) =>
						'Dette udsteder en ny nøgle til "' +
						String(args.device) +
						'" og logger straks den nuværende registrerede enhed ud ("' +
						String(args.currentDevice) +
						'").',
					ConfirmDescription: (args: { device: string }) =>
						'Dette udsteder en ny nøgle til "' + String(args.device) + '".',
					Submit: () => 'Registrer',
					EnrollSuccess: () => 'Enhed registreret'
				}
			},
			Gms: {
				Title: () => 'Android-enhedsstyring (GMS)',
				ProviderEloview: () => 'EloView',
				ProviderGms: () => 'GMS',
				NotEnrolled: () => 'Denne enhed er ikke registreret i GMS.',
				EnrollButton: () => 'Registrer enhed',
				EnrollSuccess: () => 'Registrering startet',
				DeviceName: () => 'AMAPI-enhed',
				State: () => 'Status',
				AppliedState: () => 'Anvendt status',
				PolicyCompliant: () => 'Overholder politik',
				NonComplianceReasons: () => 'Årsager til afvigelse',
				LastPolicySync: () => 'Sidste politiksynkronisering',
				InstalledVersionCode: () => 'Installeret versionskode',
				MinimumVersionCode: () => 'Minimum versionskode (fastsat)',
				HardwareModel: () => 'Hardwaremodel',
				AndroidVersion: () => 'Android-version',
				NoBoundDevice: () => 'Venter på, at enheden registreres…',
				Yes: () => 'Ja',
				No: () => 'Nej',
				VersionUnpinned: () => 'Ikke fastsat (nyeste tilgængelige)',
				ApplyVersionButton: () => 'Anvend',
				ApplyVersionSuccess: () => 'Minimumsversion opdateret',
				WifiNetworks: () => 'Wi-Fi-netværk',
				WifiAddNetwork: () => 'Tilføj netværk',
				WifiSsid: () => 'Netværksnavn (SSID)',
				WifiPassword: () => 'Adgangskode',
				WifiSecurityOpen: () => 'Åbent (ingen adgangskode)',
				WifiSecurityWpaPsk: () => 'Sikret (WPA/WPA2)',
				WifiHidden: () => 'Skjult netværk',
				WifiRemove: () => 'Fjern',
				WifiSaveSuccess: () => 'Wi-Fi-netværk gemt',
				WifiEmpty: () => 'Ingen netværk konfigureret',
				WifiPasswordKeepHint: () => 'Lad stå tomt for at beholde nuværende adgangskode',
				PlayTrack: () => 'Play-track',
				TrackProduction: () => 'Produktion (standard)',
				ApplyTrackSuccess: () => 'Play-track opdateret',
				PolicyPreset: () => 'Politikforudindstilling',
				ApplyPresetSuccess: () => 'Politikforudindstilling anvendt',
				PolicyPresets: {
					ELO: () => 'Elo (kiosk + Elo OEMConfig)',
					ZEBRA: () => 'Zebra (kiosk-lås)',
					MANAGED_APP: () => 'Administreret app (installerer merchant-appen)',
					DEBUGGING: () => 'Fejlfinding (aktiverer ADB, alle computere)'
				},
				RebootButton: () => 'Genstart enhed',
				RebootSuccess: () => 'Genstart-kommando sendt',
				RebootConfirmTitle: () => 'Genstarte denne enhed?',
				RebootConfirmDescription: () => 'Enheden genstarter øjeblikkeligt.',
				UnenrollButton: () => 'Afregistrer enhed',
				UnenrollSuccess: () => 'Enhed afregistreret',
				UnenrollConfirmTitle: () => 'Afregistrere denne enhed?',
				UnenrollConfirmDescription: () =>
					'Dette fjerner enheden fra AMAPI-flåden — svarer til en fabriksnulstilling. Den skal registreres igen fra bunden.',
				PolicyOverridesLabel: () => 'Rå politik-tilsidesættelser (JSON)',
				PolicyOverridesHint: () =>
					'Avanceret: et råt AMAPI Policy-fragment, dybt sammenlagt over den hardkodede grundskabelon. Kun for udviklere.',
				PolicyOverridesInvalidJson: () => 'Ugyldig JSON',
				SaveOverridesButton: () => 'Gem tilsidesættelser',
				ResetOverridesButton: () => 'Nulstil',
				SaveOverridesSuccess: () => 'Politik-tilsidesættelser gemt',
				EnrollDrawer: {
					Title: () => 'Registrer i GMS',
					Description: () =>
						'Genererer en engangs-QR-kode til registrering. Fabriksnulstil enheden, tryk 6 gange på velkomstskærmen, og scan koden med kameraet.',
					WifiSsidLabel: () => 'Wi-Fi-netværk (valgfrit)',
					WifiPasswordLabel: () => 'Wi-Fi-adgangskode (valgfrit)',
					PolicyPresetLabel: () => 'Politikforudindstilling',
					Submit: () => 'Generer QR-kode',
					QrExpiresAt: (args: { time: string }) => 'Udløber ' + String(args.time),
					Done: () => 'Færdig'
				}
			}
		},
		Exports: {
			Title: () => 'Eksporter',
			Description: () => 'Eksporter data til forskellige formater og systemer',
			Export: () => 'Eksporter',
			PricerTitle: () => 'Pricer-produkteksport',
			PricerSuccess: () => 'Pricer-eksport gennemført',
			SalesChannel: () => 'Salgskanal-UUID',
			VismaTitle: () => 'Visma-eksport',
			VismaSuccess: () => 'Visma-eksport gennemført',
			DigiScaleTitle: () => 'DigiScale-produkteksport',
			DigiScaleSuccess: () => 'DigiScale-eksport gennemført',
			SalesChannelUUIDs: () => "Salgskanal-UUID'er",
			GroupUUIDs: () => "Produktgruppe-UUID'er",
			SAFTTitle: () => 'SAFT-eksport',
			SAFTSuccess: () => 'SAFT-eksport gennemført',
			SAFTCashRegister: () => 'Kasseapparat',
			SAFTFinancial: () => 'Finansiel'
		},
		Integrations: {
			Title: () => 'Integrationer',
			Description: () => 'Forbind FastTrack med eksterne tjenester.',
			Teya: {
				Name: () => 'Teya',
				Description: () => 'Forbind Teya for at tage imod kortbetalinger på dine terminaler.',
				StatusConnected: () => 'Forbundet',
				StatusDisconnected: () => 'Ikke forbundet',
				StatusError: () => 'Skal forbindes igen',
				Connect: () => 'Forbind Teya',
				Reconnect: () => 'Forbind igen',
				Disconnect: () => 'Afbryd',
				Connecting: () => 'Venter på forbindelse…',
				ConnectedAt: (args: { date: string }) => 'Forbundet ' + String(args.date),
				Unavailable: () => 'Teya er ikke tilgængelig for denne virksomhed.',
				ConnectSuccess: () => 'Teya forbundet',
				DisconnectSuccess: () => 'Teya afbrudt',
				DisconnectConfirm: () => 'Betalinger sendes ikke længere til Teya-terminaler, før du forbinder igen.',
				ConnectError: () => 'Kunne ikke starte Teya-forbindelsen. Prøv igen.',
				PopupBlocked: () => 'Tillad pop op-vinduer for at fuldføre Teya-forbindelsen, og prøv igen.',
				ConfigureStoreTerminals: () => 'Konfigurer butik og terminaler',
				SelectStore: () => 'Vælg en butik',
				SelectTerminal: () => 'Vælg en terminal',
				SelectStoreFirst: () => 'Vælg en butik først.',
				NoStores: () => 'Ingen butikker fundet for denne Teya-konto.',
				NoTerminals: () => 'Ingen terminaler fundet for denne butik.',
				ReconnectToConfigure: () => 'Gentilslut Teya for at konfigurere butikker og terminaler.'
			},
			Rapyd: {
				SerialPlaceholder: () => 'PAX-enhedens serienummer',
				Register: () => 'Registrer',
				Repair: () => 'Tilslut igen',
				WaitingForPairing: () => 'Aktiver parring på terminalen, og vent…',
				Paired: () => 'Parret',
				SerialTooShort: () => 'Serienummeret skal være mindst 10 tegn.',
				RegisterError: () => 'Enheden kunne ikke registreres hos Rapyd. Prøv igen.',
				ApiKeyRequiredFirst: () => 'Gem API-nøglen i den globale konfiguration, før du parrer en terminal.'
			},
			Providers: {
				teya: {
					Name: () => 'Teya',
					Description: () => 'Tag imod kortbetalinger på dine terminaler.'
				},
				nets: {
					Name: () => 'NETS',
					Description: () => 'Tag imod kortbetalinger via NETS-terminaler.'
				},
				'verifone-ecom': {
					Name: () => 'Verifone e-handel',
					Description: () => 'Tag imod kortbetalinger online via Verifone.'
				},
				'rapyd-cloudlink': {
					Name: () => 'Rapyd CloudLink',
					Description: () => 'Par PAX-kortterminaler for at tage imod betalinger.'
				},
				'verifone-pos-cloud': {
					Name: () => 'Verifone POS Cloud',
					Description: () => 'Tag imod kortbetalinger på Verifone cloud-terminaler.'
				},
				struct: {
					Name: () => 'Struct',
					Description: () => 'Synkronisér produkter fra Struct PIM.'
				}
			},
			Fields: {
				storeId: () => 'Butiks-ID',
				terminalId: () => 'Terminal-ID',
				eposInstanceId: () => 'ePOS-instans-ID',
				environment: () => 'Miljø',
				merchantId: () => 'Forhandler-ID',
				username: () => 'Brugernavn',
				password: () => 'Adgangskode',
				organizationId: () => 'Organisations-ID',
				entityId: () => 'Enheds-ID',
				apiKey: () => 'API-nøgle',
				apiUrl: () => 'API-URL',
				incomingWebhookEnabled: () => 'Indgående webhook aktiveret',
				incomingWebhookApiKey: () => 'API-nøgle til indgående webhook',
				secret: () => 'Hemmelighed',
				contractId: () => 'Kontrakt-ID',
				serialNumber: () => 'Serienummer',
				deviceToken: () => 'Enhed',
				authMode: () => 'Godkendelsestilstand',
				clientId: () => 'Client ID',
				clientSecret: () => 'Client secret',
				tokenUrl: () => 'Token-URL',
				baseUrl: () => 'Base-URL',
				poiId: () => 'POI-ID (terminal)',
				saleId: () => 'Sale-ID',
				operatorId: () => 'Operatør-ID',
				scope: () => 'Scope',
				siteEntityId: () => 'Site-enheds-ID',
				terminalSimulator: () => 'Terminalsimulator'
			},
			Config: {
				Back: () => 'Tilbage til integrationer',
				Global: () => 'Global konfiguration',
				GlobalDescription: () => 'Basisindstillinger, der gælder overalt, medmindre de tilsidesættes.',
				Overrides: () => 'Tilsidesættelser',
				OverridesDescriptionSalesChannel: () => 'Tilsidesæt indstillinger for bestemte salgskanaler.',
				OverridesDescriptionPointOfSale: () => 'Tilsidesæt indstillinger for bestemte salgssteder.',
				AddOverride: () => 'Tilføj tilsidesættelse',
				NoOverrides: () => 'Ingen tilsidesættelser',
				OverrideCount: (args: { count: number }) => String(args.count) + ' tilsidesættelser',
				Configure: () => 'Konfigurer',
				Save: () => 'Gem',
				Saved: () => 'Konfiguration gemt',
				SaveError: () => 'Kunne ikke gemme konfigurationen',
				TargetSalesChannel: () => 'Salgskanal',
				TargetPointOfSale: () => 'Salgssted',
				SelectTarget: () => 'Vælg…',
				Edit: () => 'Rediger',
				Delete: () => 'Slet',
				DeleteOverride: () => 'Slet tilsidesættelse',
				DeleteOverrideConfirm: () =>
					'Denne tilsidesættelse fjernes, og dens indstillinger falder tilbage til den globale konfiguration.',
				EditOverride: () => 'Rediger tilsidesættelse',
				SecretSet: () => 'Konfigureret',
				SecretUnset: () => 'Ikke konfigureret',
				SecretPlaceholderSet: () => 'Lad stå tomt for at beholde nuværende',
				SecretPlaceholderUnset: () => 'Indtast værdi'
			}
		},
		Billing: {
			Title: () => 'Fakturering',
			NavLabel: () => 'Fakturering',
			Description: () => 'Dit FastTrack-abonnement.',
			EmptyTitle: () => 'Ingen plan endnu',
			EmptyDescription: () => 'Der er endnu ikke oprettet en abonnementsplan for din konto.',
			EmptyContactPrefix: () => 'Kontakt',
			EmptyContactLink: () => 'support',
			EmptyContactSuffix: () => 'for at komme i gang.',
			PlanHeading: () => 'Abonnementsplan',
			Note: () => 'Bemærkning',
			PlanDetails: () => 'Plandetaljer',
			AdditionalFees: () => 'Yderligere gebyrer',
			Amount: () => 'Beløb',
			Interval: () => 'Faktureringsperiode',
			Monthly: () => 'Månedligt',
			Yearly: () => 'Årligt',
			OneTime: () => 'Engangsbeløb',
			Net: () => 'Netto',
			Vat: () => 'Moms',
			VatRate: () => 'Momssats',
			Total: () => 'I alt',
			TotalsHeading: () => 'Totaler',
			MonthlyTotal: () => 'Månedligt i alt',
			YearlyTotal: () => 'Årligt i alt',
			OneTimeTotal: () => 'Engangsbeløb i alt',
			AgreementHeading: () => 'Aftale',
			SelfServeIntro: () => 'Din brug af FastTrack er underlagt følgende politikker:',
			PolicyPrivacy: () => 'Privatlivspolitik',
			PolicyTerms: () => 'Brugsvilkår',
			PolicyServices: () => 'Platformsserviceaftale',
			PolicyDpa: () => 'Databehandleraftale',
			PolicySupport: () => 'Supportpolitik',
			PolicyEula: () => 'Softwarelicens',
			EnterpriseNote: () => 'Denne plan er underlagt din Master Services Agreement med Stack.',
			EnterpriseServicesLink: () => 'Se platformsserviceaftalen',
			EnterpriseRefLabel: () => 'Aftalereference',
			StartDate: () => 'Startdato',
			Status: () => 'Status',
			StatusAccepted: () => 'Accepteret',
			StatusPending: () => 'Afventer accept',
			AcceptedBy: () => 'Accepteret af',
			Accept: () => 'Accepter plan',
			AcceptConfirmTitle: () => 'Accepter plan',
			AcceptConfirmDescription: () =>
				'Ved at acceptere bekræfter du din accept af abonnementsplanen vist ovenfor.',
			AcceptConfirmAction: () => 'Accepter',
			AcceptSuccess: () => 'Plan accepteret',
			AcceptError: () => 'Kunne ikke acceptere planen. Prøv igen.',
			LoadError: () => 'Kunne ikke indlæse din abonnementsplan.'
		}
	},
	PointOfSale: {
		Title: () => 'Salgssted'
	},
	Profile: {
		Title: () => 'Profil'
	},
	SalesChannels: {
		Title: () => 'Salgskanaler'
	},
	Store: {
		Title: () => 'Butik'
	},
	Users: {
		Title: () => 'Brugere'
	},
	CompanyCards: {
		Title: () => 'Firmakort',
		CreateTitle: () => 'Opret firmakort',
		CreateSuccess: () => 'Firmakort oprettet',
		EditTitle: () => 'Rediger firmakort',
		UpdateSuccess: () => 'Firmakort opdateret',
		DeleteWarning: (args: { name: string }) =>
			'Du er ved at slette firmakortet ' + String(args.name) + '. Denne handling kan ikke fortrydes.',
		Status: (arg0: 'ACTIVE' | 'INACTIVE') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Company: () => 'Virksomhed',
			Customer: () => 'Kunde',
			Employee: () => 'Medarbejder',
			ExternalId: () => 'Ekstern ID',
			CreatedAt: () => 'Oprettet'
		},
		Detail: {
			Title: () => 'Firmakortdetaljer',
			Transactions: () => 'Transaktioner',
			ResetPin: {
				Title: () => 'Nulstil PIN',
				Description: () => 'Er du sikker på, at du vil nulstille PIN for dette kort?',
				Action: () => 'Nulstil PIN'
			},
			ResetPinSuccess: () => 'PIN blev nulstillet'
		},
		Edit: {
			BasicInfo: () => 'Grundlæggende oplysninger',
			Description: () => 'Rediger firmakortoplysninger',
			NamePlaceholder: () => 'Indtast kortnavn',
			SelectCompany: () => 'Vælg virksomhed',
			SelectEmployee: () => 'Vælg medarbejder',
			ExternalIdPlaceholder: () => 'Indtast ekstern ID (valgfrit)'
		}
	},
	Settlements: {
		Title: () => 'Afregninger',
		CreateTitle: () => 'Opret afregning',
		CreateSuccess: () => 'Afregning oprettet',
		MarkSettled: () => 'Marker som afregnet',
		MarkSettledSuccess: () => 'Afregning markeret som afregnet',
		Column: {
			Company: () => 'Virksomhed',
			Period: () => 'Periode',
			TotalAmount: () => 'Samlet beløb',
			TransactionCount: () => 'Transaktioner',
			SettledAt: () => 'Afregnet',
			CreatedAt: () => 'Oprettet'
		},
		Detail: {
			Title: () => 'Afregningsdetaljer',
			Transactions: () => 'Transaktioner',
			Period: () => 'Periode',
			TotalAmount: () => 'Samlet beløb',
			Status: () => 'Status',
			Settled: () => 'Afregnet',
			NotSettled: () => 'Ikke afregnet'
		},
		Create: {
			Title: () => 'Opret afregning',
			Period: () => 'Periode',
			Description: () => 'Opret en ny afregning for virksomheden',
			PeriodStart: () => 'Periodestart',
			PeriodEnd: () => 'Periodeslut'
		}
	},
	Analytics: {
		Title: () => 'Analyse',
		Overview: () => 'Oversigt',
		Insights: () => 'Indsigt',
		SalesAnalytics: () => 'Salg',
		SalesAnalyticsDescription: () => 'Følg omsætning, ordrer og de bedst sælgende produkter og kanaler.',
		UserAnalytics: () => 'Brugere',
		UserAnalyticsDescription: () => 'Følg aktive brugere, nye tilmeldinger og anmodninger om kontosletning.',
		Basket: () => 'Kurv',
		ActiveUsers: () => 'Aktive brugere',
		NewSignups: () => 'Nye tilmeldinger',
		ChurnedUsers: () => 'Sletteanmodninger',
		ActiveUsersOverTime: () => 'Aktive brugere over tid',
		NewSignupsOverTime: () => 'Nye tilmeldinger over tid',
		ChurnedUsersOverTime: () => 'Sletteanmodninger over tid',
		DeltaNew: () => 'Ny',
		Revenue: () => 'Omsætning',
		Orders: () => 'Ordrer',
		Growth: () => 'Vækst',
		TotalRevenue: () => 'Samlet omsætning',
		AverageOrderValue: () => 'Gennemsnitlig ordreværdi',
		Refunds: () => 'Refunderinger',
		RevenueOverTime: () => 'Omsætning over tid',
		TopProducts: () => 'Topprodukter',
		TopProductsByRevenue: () => 'Efter omsætning',
		TopProductsByQuantity: () => 'Efter antal',
		PaymentMethods: () => 'Betalingsmetoder',
		RevenueByCategory: () => 'Omsætning efter kategori',
		SalesByChannel: () => 'Salg efter kanal',
		HourlyDistribution: () => 'Timefordeling',
		Day: () => 'Dag',
		Week: () => 'Uge',
		Month: () => 'Måned',
		Quarter: () => 'Kvartal',
		Year: () => 'År',
		NoData: () => 'Ingen data tilgængelige for denne periode',
		VsDate: (arg0: string) => 'vs. ' + String(arg0),
		VsDateRange: (arg0: string, arg1: string) => 'vs. ' + String(arg0) + ' – ' + String(arg1),
		InProgress: () => '(i gang)',
		ComparePreviousPeriod: () => 'vs. forrige periode',
		CompareSamePeriodLastYear: () => 'vs. samme periode sidste år',
		CompareSpecific: {
			Day: () => 'vs. en bestemt dag',
			Week: () => 'vs. en bestemt uge',
			Month: () => 'vs. en bestemt måned',
			Quarter: () => 'vs. et bestemt kvartal',
			Year: () => 'vs. et bestemt år'
		},
		CompareNone: () => 'Ingen sammenligning',
		AllChannels: () => 'Alle kanaler',
		ChannelGroupOption: (arg0: string) => String(arg0) + ' (gruppe)',
		CompareToChannel: () => 'Sammenlign med kanal',
		CompareToChannelNone: () => 'Ingen kanalsammenligning',
		ComparisonModePeriod: () => 'Periode',
		ComparisonModeChannel: () => 'Kanal',
		CompareByPeriod: () => 'Sammenlign efter periode',
		CompareByChannel: () => 'Sammenlign efter kanal',
		PeriodLabel: (arg0: string) => 'Periode: ' + String(arg0),
		CompareBy: () => 'Sammenlign efter',
		ChannelsPageOf: (args: { current: number; total: number }) =>
			'Side ' + String(args.current) + ' af ' + String(args.total),
		QuarterLabel: (args: { quarter: number; year: number }) => 'K' + String(args.quarter) + ' ' + String(args.year),
		JumpToPeriod: () => 'Gå til periode',
		CurrentPeriod: () => 'Nuværende periode',
		IntervalLabel: (arg0: string) => 'Interval: ' + String(arg0),
		Reports: {
			Title: () => 'Rapporter',
			Description: () => 'Udforsk salgsdataene i detaljer, sammenlign perioder og kanaler, og eksportér dem.',
			SalesGroup: () => 'Salg',
			ViewReport: () => 'Vis rapport',
			Export: () => 'Eksportér CSV',
			Rows: () => 'Opdel efter',
			RowsOption: {
				Hour: () => 'Pr. time',
				Day: () => 'Pr. dag',
				Week: () => 'Pr. uge',
				Month: () => 'Pr. måned',
				Product: () => 'Pr. produkt'
			},
			ColumnsPicker: () => 'Kolonner',
			GroupBy: () => 'Gruppér efter',
			GroupByOption: {
				Hour: () => 'Time',
				Day: () => 'Dag',
				Week: () => 'Uge',
				Month: () => 'Måned'
			},
			Total: () => 'I alt',
			Revenue: {
				Title: () => 'Omsætning',
				Description: () => 'Omsætning, ordrer, refusioner og gennemsnitlig ordreværdi over tid.'
			},
			Products: {
				Title: () => 'Produkter',
				Description: () => 'Solgte enheder, bruttosalg og ordrer pr. produkt.',
				FilterProducts: () => 'Alle produkter',
				GrossSalesNote: () =>
					'Produktsalg er brutto linjebeløb før refusioner og kan derfor afvige fra nettoomsætningen.'
			},
			Columns: {
				Period: () => 'Periode',
				Orders: () => 'Ordrer',
				Revenue: () => 'Omsætning',
				Refunds: () => 'Refusioner',
				AverageOrderValue: () => 'Gns. ordreværdi',
				Product: () => 'Produkt',
				Quantity: () => 'Antal',
				GrossSales: () => 'Bruttosalg',
				Share: () => 'Andel'
			}
		},
		ChartLabels: {
			Revenue: () => 'Omsætning',
			Orders: () => 'Ordrer',
			Hour: () => 'Time',
			Quantity: () => 'Antal'
		},
		BasketAnalysis: {
			Title: () => 'Kurvanalyse',
			Description: () => 'Find ud af hvilke produkter og kategorier der ofte købes sammen.',
			AvgItemsPerOrder: () => 'Gns. varer pr. ordre',
			AvgUniqueProductsPerOrder: () => 'Gns. unikke produkter pr. ordre',
			OrdersAnalyzed: () => 'Analyserede ordrer',
			ProductPairs: () => 'Produktpar',
			CategoryAffinity: () => 'Kategoriaffinitet',
			AnchorProduct: () => 'Ankerprodukt',
			AnchorProductPlaceholder: () => 'Søg efter et produkt…',
			AllProducts: () => 'Alle produkter',
			Products: () => 'Produkter',
			ProductsPlaceholder: () => 'Filtrér produkter…',
			ExcludeProductsPlaceholder: () => 'Udeluk produkter…',
			AllProductsFilter: () => 'Alle produkter',
			Categories: () => 'Kategorier',
			CategoriesPlaceholder: () => 'Filtrér kategorier…',
			ExcludeCategoriesPlaceholder: () => 'Udeluk kategorier…',
			AllCategoriesFilter: () => 'Alle kategorier',
			SalesChannel: () => 'Salgskanal',
			AllSalesChannels: () => 'Alle salgskanaler',
			SalesChannelsSelected: (args: { count: number }) => String(args.count) + ' valgt',
			SalesChannelSearchPlaceholder: () => 'Søg i salgskanaler…',
			PointOfSale: () => 'Salgssted',
			AllPointsOfSale: () => 'Alle salgssteder',
			MinSupport: () => 'Min. samforekomster',
			ProductA: () => 'Produkt A',
			ProductB: () => 'Produkt B',
			CategoryA: () => 'Kategori A',
			CategoryB: () => 'Kategori B',
			CoOccurrence: () => 'Samforekomst',
			Support: () => 'Support',
			Confidence: () => 'Confidence',
			Lift: () => 'Lift',
			SupportTooltip: () =>
				'Hvor almindeligt parret er: andelen af alle ordrer, der indeholder både A og B. For eksempel betyder 2 %, at 2 ud af 100 ordrer indeholdt begge.',
			ConfidenceTooltip: () =>
				'Hvor ofte B havner i kurven, når A gør: andelen af ordrer med A, der også indeholder B. For eksempel betyder 40 %, at 4 ud af 10 ordrer med A også havde B.',
			LiftTooltip: () =>
				'Hvor meget oftere A og B købes sammen, end man ville forvente ved en tilfældighed. 1 betyder ingen sammenhæng, 2 betyder dobbelt så ofte som forventet, og under 1 betyder, at de sjældent købes sammen.',
			NoProductPairs: () => 'Ingen produktpar opfylder minimumsgrænsen for samforekomst i denne periode.',
			NoCategoryPairs: () => 'Ingen kategoripar opfylder minimumsgrænsen for samforekomst i denne periode.',
			NoAnchorPairs: () => 'Ingen par fundet for det valgte produkt i denne periode.',
			MetricPercent: (arg0: string) => String(arg0) + '%'
		}
	}
}

export const is = {
	LocaleName: () => 'Íslenska',
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('is', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('is', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('is', arg1),
		OnlyAmount: (arg0: TranslationAmount) => amountOnlyFormatter('is', arg0)
	},
	Quantity: {
		Pieces: (arg0: number) => String(arg0) + 'x'
	},
	Weight: (arg0: Amount) => weightFormatter('is', arg0),
	Date: {
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('is', arg0),
		Short: (arg0: DateInput) => shortFormatter('is', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('is', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('is', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('is', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('is', arg0),
		Ago: (arg0: DateInput) => agoFormatter('is', arg0, () => locales['is'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('is', arg0)
	},
	TimeAgo: {
		JustNow: () => 'núna',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'mínútu', other: 'mínútum' }) + ' síðan',
		HoursAgo: (args: { count: number }) =>
			String(args.count) +
			' ' +
			plural('is', args.count, { one: 'klukkustund', other: 'klukkustundum' }) +
			' síðan',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'degi', other: 'dögum' }) + ' síðan',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'mánuði', other: 'mánuðum' }) + ' síðan',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'ári', other: 'árum' }) + ' síðan'
	},
	Enum: {
		PaymentStatus: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Í bið'
					case 'UNPAID':
						return 'Ógreitt'
					case 'PAID':
						return 'Greitt'
					case 'PARTIALLY_PAID':
						return 'Greitt að hluta'
					case 'REFUNDED':
						return 'Endurgreitt'
					case 'PARTIALLY_REFUNDED':
						return 'Endurgreitt að hluta'
					case 'OVERPAID':
						return 'Ofgreitt'
					default:
						return String(v)
				}
			})(arg0),
		OrderStatus: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Lokið'
					case 'CANCELED':
						return 'Afturkallað'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentStatus: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Óafgreitt'
					case 'FULFILLED':
						return 'Afgreitt'
					case 'NOT_NEEDED':
						return 'Ekki þörf'
					case 'PARTIALLY_FULFILLED':
						return 'Afgreitt að hluta'
					default:
						return String(v)
				}
			})(arg0),
		TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
			(v => {
				switch (v) {
					case 'FAILED':
						return 'Mistókst'
					case 'SUCCESS':
						return 'Tókst'
					case 'PENDING':
						return 'Í bið'
					default:
						return String(v)
				}
			})(arg0),
		PaymentProvider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN' | 'VERIFONE' | 'CASH') =>
			(v => {
				switch (v) {
					case 'RAPYD':
						return 'Rapyd'
					case 'MANUAL':
						return 'Handvirkt'
					case 'STRIPE':
						return 'Stripe'
					case 'ADYEN':
						return 'Adyen'
					case 'VERIFONE':
						return 'Verifone'
					case 'CASH':
						return 'Reiðufé'
					default:
						return String(v)
				}
			})(arg0),
		ProductStatus: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Drög'
					case 'PUBLISHED':
						return 'Birt'
					case 'ARCHIVED':
						return 'Safnvistað'
					default:
						return String(v)
				}
			})(arg0),
		ThirdPartySource: (arg0: 'STRUCT' | 'LS_RETAIL' | 'BUSINESS_CENTRAL') =>
			(v => {
				switch (v) {
					case 'STRUCT':
						return 'Struct'
					case 'LS_RETAIL':
						return 'LS Retail'
					case 'BUSINESS_CENTRAL':
						return 'Business Central'
					default:
						return String(v)
				}
			})(arg0),
		CardExternalSource: (arg0: 'PASSCREATOR') =>
			(v => {
				switch (v) {
					case 'PASSCREATOR':
						return 'PassCreator'
					default:
						return String(v)
				}
			})(arg0),
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per einingu'
					case 'PRICE_EMBEDDED':
						return 'Verð innbyggt'
					case 'PER_WEIGHT':
						return 'Per þyngd'
					case 'WEIGHT_EMBEDDED':
						return 'Þyngd innbyggð'
					default:
						return String(v)
				}
			})(arg0),
		GiftCardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Virkt'
					case 'INACTIVE':
						return 'Óvirkt'
					case 'RESERVED':
						return 'Frátekið'
					case 'REDEEMED':
						return 'Innleyst'
					default:
						return String(v)
				}
			})(arg0),
		RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Í bið'
					case 'APPLIED':
						return 'Notað'
					default:
						return String(v)
				}
			})(arg0),
		CardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Virkt'
					case 'INACTIVE':
						return 'Óvirkt'
					case 'BLOCKED':
						return 'Lokað'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentProvider: (arg0: 'MERCHANT_APP') =>
			(v => {
				switch (v) {
					case 'MERCHANT_APP':
						return 'Merchant app'
					default:
						return String(v)
				}
			})(arg0),
		UserStatus: (arg0: 'ACTIVE' | 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REJECTED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Virkt'
					case 'PENDING':
						return 'Í bið'
					case 'ACCEPTED':
						return 'Samþykkt'
					case 'EXPIRED':
						return 'Útrunnið'
					case 'REJECTED':
						return 'Hafnað'
					default:
						return String(v)
				}
			})(arg0),
		UserRole: (arg0: 'DEVELOPER' | 'ADMIN' | 'USER') =>
			(v => {
				switch (v) {
					case 'DEVELOPER':
						return 'Forritari'
					case 'ADMIN':
						return 'Stjórnandi'
					case 'USER':
						return 'Notandi'
					default:
						return String(v)
				}
			})(arg0)
	},
	General: {
		AppName: () => 'FastTrack',
		DefaultPageTitle: () => 'FastTrack stjórnborð',
		Create: () => 'Búa til',
		Import: () => 'Flytja inn',
		Export: () => 'Flytja út',
		NoResultsTitle: () => 'Engar niðurstöður fundust',
		Loading: () => 'Hleð...',
		Selected: () => 'Valið',
		Optional: () => 'Valfrjálst',
		Save: () => 'Vista',
		Continue: () => 'Halda áfram',
		Cancel: () => 'Hætta við',
		Confirm: () => 'Staðfesta',
		Delete: () => 'Eyða',
		Edit: () => 'Breyta',
		Add: () => 'Bæta við',
		Required: () => 'Nauðsynlegt',
		Close: () => 'Loka',
		Update: () => 'Uppfæra',
		UnsavedChangesTitle: () => 'Óvistaðar breytingar',
		UnsavedChangesDescription: () => 'Þú ert með óvistaðar breytingar. Ertu viss um að þú viljir fara?',
		VerificationInstruction: (arg0: string) => 'Vinsamlegast sláðu inn ' + String(arg0) + ' til að staðfesta:',
		Copy: () => 'Afrita',
		Copied: () => 'Afritað',
		AreYouSure: () => 'Ertu viss?',
		True: () => 'Já',
		False: () => 'Nei',
		SearchPlaceholder: () => 'Leita...',
		InvalidFileType: (arg0: string, arg1: string) =>
			'Ógild skráartegund: ' + String(arg0) + ' (stutt: ' + String(arg1) + ')',
		DropImages: () => 'Slepptu myndum til að hlaða upp',
		Multiple: () => 'Mörg',
		Variable: () => 'Breytilegur',
		Enabled: () => 'Virkt',
		Expired: () => 'Útrunnið',
		Scheduled: () => 'Planað',
		Active: () => 'Virkt',
		Inactive: () => 'Óvirkt',
		ComingSoon: () => 'Væntanlegt',
		ComingSoonDescription: () => 'Þessi eiginleiki er í þróun.',
		None: () => 'Ekkert',
		NotSet: () => 'Ekki stillt',
		Unknown: () => 'Óþekkt',
		GoBack: () => 'Til baka',
		GoHome: () => 'Fara heim',
		FeatureNotAvailable: () => 'Þessi eiginleiki er ekki í boði',
		FeatureNotAvailableDescription: () => 'Hafðu samband við þjónustuver til að virkja þennan eiginleika',
		Dismiss: () => 'Loka',
		TryAgain: () => 'Reyndu aftur',
		All: () => 'Allt',
		AdvancedFilters: () => 'Síur',
		ClearAll: () => 'Hreinsa',
		Apply: () => 'Nota',
		CountSelected: (args: { count: number }) => String(args.count) + ' valdar',
		MultiSelectHint: (args: { count: number }) =>
			String(args.count) + ' valin • Haltu Ctrl/Cmd til að velja fleiri',
		PickDate: () => 'Veldu dagsetningu',
		Created: () => 'Búið til',
		View: () => 'Skoða'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'Mistókst að hlaða gögnum',
		AnErrorOccurredWhileFetchingData: () => 'Villa kom upp við að sækja gögn. Reyndu aftur.'
	},
	Enums: {
		PaymentProvider: (
			arg0:
				| 'CASH'
				| 'ADYEN_TERMINAL'
				| 'ADYEN_ECOM'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS'
				| 'NETS_TERMINAL'
				| 'VERIFONE_CHECKOUT'
				| 'VERIFONE_ECOM'
				| 'STRAUMUR_ECOM'
				| 'LOYALTY_POINTS'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'VIPPS_MOBILEPAY'
				| 'RAPYD_CLOUDLINK'
				| 'RAPYD_APP_TO_APP'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
		) =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Reiðufé'
					case 'ADYEN_TERMINAL':
						return 'Adyen Terminal'
					case 'ADYEN_ECOM':
						return 'Adyen ECom'
					case 'BLIKK_ECOM':
						return 'Blikk ECom'
					case 'BLIKK_POS':
						return 'Blikk POS'
					case 'VIPPS':
						return 'Vipps'
					case 'NETS_TERMINAL':
						return 'Nets Terminal'
					case 'VERIFONE_CHECKOUT':
						return 'Verifone (checkout)'
					case 'VERIFONE_ECOM':
						return 'Verifone (Ecom)'
					case 'STRAUMUR_ECOM':
						return 'Straumur'
					case 'LOYALTY_POINTS':
						return 'Vildarkort'
					case 'GIFT_CARD':
						return 'Gjafakort'
					case 'BUSINESS_CARD':
						return 'Viðskiptakort'
					case 'VIPPS_MOBILEPAY':
						return 'Vipps MobilePay'
					case 'RAPYD_CLOUDLINK':
						return 'Rapyd Cloudlink'
					case 'RAPYD_APP_TO_APP':
						return 'Rapyd App to App'
					case 'TEYA_POSLINK':
						return 'Teya POSLink'
					case 'VERIFONE_POS_CLOUD':
						return 'Verifone POS Cloud'
					default:
						return String(v)
				}
			})(arg0)
	},
	Fields: {
		Name: () => 'Nafn',
		Status: () => 'Staða',
		Type: () => 'Tegund',
		SalesChannel: () => 'Sölurásin',
		PointOfSale: () => 'Sölustaður',
		PaymentStatus: () => 'Greiðslustaða',
		StartDate: () => 'Upphafsdagur',
		EndDate: () => 'Lokadagur',
		TaxRate: () => 'VSK-hlutfall',
		TaxInclusive: () => 'VSK innifalinn',
		Amount: () => 'Upphæð',
		Price: () => 'Verð',
		Description: () => 'Lýsing',
		Groups: () => 'Hópar',
		Categories: () => 'Flokkar',
		Email: () => 'Netfang',
		Password: () => 'Lykilorð',
		ConfirmPassword: () => 'Staðfesta lykilorð',
		Role: () => 'Hlutverk',
		SKU: () => 'SKU',
		Currency: () => 'Gjaldmiðill',
		CreatedAt: () => 'Búið til',
		ExpiresAt: () => 'Rennur út',
		UpdatedAt: () => 'Uppfært',
		Language: () => 'Tungumál',
		Year: () => 'Ár',
		Month: () => 'Mánuður',
		ExternalId: () => 'Ytra auðkenni',
		FirstName: () => 'Fornafn',
		LastName: () => 'Eftirnafn',
		Phone: () => 'Sími',
		SSN: () => 'Kennitala',
		CardNumber: () => 'Kortnúmer',
		Company: () => 'Fyrirtæki',
		Customer: () => 'Viðskiptavinur',
		Employee: () => 'Starfsmaður',
		FromTime: () => 'Frá',
		ToTime: () => 'Til',
		OrgNumber: () => 'Kennitala',
		Enabled: () => 'Virkt',
		Disabled: () => 'Óvirkt',
		CurrencyCode: () => 'Gjaldmiðilskóði'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'Flýtileiðir'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'Mánudagur',
		Tuesday: () => 'Þriðjudagur',
		Wednesday: () => 'Miðvikudagur',
		Thursday: () => 'Fimmtudagur',
		Friday: () => 'Föstudagur',
		Saturday: () => 'Laugardagur',
		Sunday: () => 'Sunnudagur'
	},
	Auth: {
		AcceptInvite: () => 'Samþykkja boð',
		AcceptInviteAndSetPassword: () => 'Samþykkja boð og setja lykilorð',
		AcceptInviteDescription: () => 'Settu lykilorð til að samþykkja boðið.',
		ConfirmPasswordPlaceholder: () => 'Staðfestu lykilorðið þitt',
		InvalidInvite: () => 'Ógilt boð',
		InvalidInviteDescription: () => 'Þetta boð er ógilt eða er útrunnið.',
		InviteAccepted: () => 'Boð samþykkt',
		InviteExpired: () => 'Þetta boð er útrunnið eða ekki lengur gilt',
		PasswordPlaceholder: () => 'Sláðu inn lykilorð',
		PasswordsDoNotMatch: () => 'Lykilorð passa ekki',
		SetPassword: () => 'Setja lykilorð'
	},
	Error: {
		PageNotFound: () => 'Síða fannst ekki',
		PageNotFoundDescription: () => 'Síðan sem þú ert að leita að er ekki til.',
		SomethingWentWrong: () => 'Eitthvað fór úrskeiðis',
		AnUnexpectedErrorOccurred: () =>
			'Óvænt villa kom upp. Þú getur reynt að fara til baka, endurhlaða síðuna eða haft samband við þjónustuver ef vandamálið er viðvarandi.',
		ErrorDetails: () => 'Villuupplýsingar',
		ReloadPage: () => 'Endurhlaða síðu',
		ContactSupport: () => 'Hafa samband við þjónustuver'
	},
	Campaigns: {
		Domain: () => 'Herferðir'
	},
	CustomerGroups: {
		Domain: () => 'Viðskiptavinahópar',
		Title: () => 'Hópar',
		CreateTitle: () => 'Stofna viðskiptavinahóp',
		CreateSuccess: (args: { name: string }) => 'Viðskiptavinahópurinn ' + String(args.name) + ' var stofnaður.',
		EditTitle: () => 'Breyta viðskiptavinahóp',
		UpdateSuccess: () => 'Viðskiptavinahópur uppfærður',
		Empty: () => 'Engir viðskiptavinahópar enn',
		Members: () => 'Meðlimir',
		SelectCustomers: () => 'Veldu viðskiptavini',
		Delete: {
			Title: () => 'Eyða viðskiptavinahóp',
			Description: (args: { name: string }) =>
				'Ertu viss um að þú viljir eyða viðskiptavinahópnum "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Viðskiptavinahópnum ' + String(args.name) + ' var eytt.'
		},
		Column: {
			Name: () => 'Nafn',
			Description: () => 'Lýsing',
			ExternalId: () => 'Ytra auðkenni',
			MemberCount: () => 'Meðlimir'
		},
		Field: {
			Name: () => 'Nafn',
			Description: () => 'Lýsing',
			ExternalId: () => 'Ytra auðkenni',
			NamePlaceholder: () => 'Sláðu inn heiti hóps',
			DescriptionPlaceholder: () => 'Lýstu þessum hóp (valfrjálst)',
			ExternalIdPlaceholder: () => 'Ytra auðkenni (valfrjálst)'
		},
		Detail: {
			Title: () => 'Viðskiptavinahópur'
		}
	},
	DraftOrders: {
		Domain: () => 'Pöntunardræg'
	},
	PriceLists: {
		Domain: () => 'Verðlistar'
	},
	Reservations: {
		Domain: () => 'Bókanir'
	},
	Login: {
		PageTitle: () => 'Skrá inn',
		Title: () => 'Velkomin í FastTrack',
		Description: () => 'Skráðu þig inn til að fá aðgang að stjórnborðinu',
		Email: () => 'Netfang',
		Password: () => 'Lykilorð',
		LogIn: () => 'Skrá inn',
		ForgotPassword: () => 'Gleymt lykilorð?',
		ForgotPasswordButton: () => 'Endurstilla',
		Error: () => 'Gat ekki skráð inn',
		UnauthorizedError: () => 'Ógilt netfang eða lykilorð'
	},
	ResetPassword: {
		Title: () => 'Endurstilla lykilorð',
		Hint: () =>
			'Sláðu inn netfangið þitt hér að neðan og við munum senda þér leiðbeiningar um hvernig á að endurstilla lykilorðið þitt.',
		Email: () => 'Netfang',
		SendResetInstructions: () => 'Senda endurstillingarleiðbeiningar',
		BackToLogin: () => 'Til baka í innskráningu',
		SuccessfulRequestTitle: () => 'Tölvupóstur sendur',
		SuccessfulRequest: () =>
			'Við höfum sent þér tölvupóst sem þú getur notað til að endurstilla lykilorðið þitt. Athugaðu ruslpóstmöppuna ef þú hefur ekki fengið hann eftir nokkrar mínútur.',
		NewPassword: () => 'Nýtt lykilorð',
		NewPasswordHint: () => 'Veldu nýtt lykilorð hér að neðan.',
		RepeatNewPassword: () => 'Endurtaktu nýja lykilorðið',
		ResetPassword: () => 'Endurstilla lykilorð',
		PasswordMismatch: () => 'Lykilorð passa ekki',
		SuccessfulResetTitle: () => 'Lykilorði breytt',
		SuccessfulReset: () => 'Vinsamlegast skráðu þig inn á innskráningarsíðunni.',
		InvalidEmail: () => 'Ógilt netfang'
	},
	Sidebar: {
		Logout: () => 'Skrá út',
		ProfileSettings: () => 'Notandastillingar',
		BackToApp: () => 'Til baka í forritið',
		SearchPlaceholder: () => 'Leita eða fara…',
		OpenSearch: () => 'Opna leit',
		StoreScopeHint: () => 'Vinnusvæði (rofari kemur síðar)',
		Sections: () => 'Hlutar',
		Individuals: () => 'Einstaklingar',
		Business: () => 'Fyrirtæki',
		Content: () => 'Efni',
		Messaging: () => 'Skilaboð',
		Automation: () => 'Sjálfvirkni'
	},
	DeveloperFeedback: {
		Entry: () => 'Senda athugasemd',
		Title: () => 'Athugasemd þróunaraðila',
		Description: () => 'Þetta verður mál hjá verkfræðiteyminu.',
		TitleLabel: () => 'Titill',
		BodyLabel: () => 'Lýsing',
		TypeLabel: () => 'Tegund',
		TypeSmallFix: () => 'Lítil lagfæring',
		TypeBug: () => 'Villa',
		TypeEnhancement: () => 'Endurbót',
		TypeNote: () => 'Athugasemd',
		Submit: () => 'Senda',
		Created: () => 'Mál búið til'
	},
	CommandPalette: {
		GroupQuick: () => 'Flýtiaðgerðir',
		InputHint: () => 'Leita í pöntunum, vörum, viðskiptamönnum, söfnunum…',
		FooterHint: () => 'Ábending: sláðu inn að minnsta kosti 2 stafi til að leita.',
		NoResults: () => 'Engar niðurstöður. Prófaðu annað leitarorð.',
		QuickNewProduct: () => 'Búa til vöru',
		QuickNewPromotion: () => 'Búa til kynningu',
		QuickMarketingContent: () => 'Markaðsefni',
		QuickGoOrders: () => 'Fara í pantanir',
		QuickSettings: () => 'Stillingar'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			String(args.start) + ' til ' + String(args.end) + ' af ' + String(args.total) + ' niðurstöður',
		NoResults: () => '0 niðurstöður',
		Previous: () => 'Fyrri',
		Next: () => 'Næsta'
	},
	Orders: {
		Title: () => 'Pantanir',
		BagChecks: () => 'Pokaeftirlit',
		Drafts: () => 'Drög',
		StatusEnum: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Pending'
					case 'UNPAID':
						return 'Unpaid'
					case 'PAID':
						return 'Paid'
					case 'PARTIALLY_PAID':
						return 'Partially paid'
					case 'REFUNDED':
						return 'Refunded'
					case 'PARTIALLY_REFUNDED':
						return 'Partially refunded'
					case 'OVERPAID':
						return 'Overpaid'
					default:
						return String(v)
				}
			})(arg0),
		OrderCanceled: () => 'Pöntun afturkölluð',
		AdvancedFilters: () => 'Pöntunarsíur',
		FulfillmentStatusEnum: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Not fulfilled'
					case 'FULFILLED':
						return 'Fulfilled'
					case 'NOT_NEEDED':
						return 'Not needed'
					case 'PARTIALLY_FULFILLED':
						return 'Partially fulfilled'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Order: () => 'Pöntun',
			Date: () => 'Dagsetning',
			SalesChannel: () => 'Sölurásin',
			PaymentStatus: () => 'Greiðslustaða',
			Total: () => 'Heildarupphæð',
			FulfillmentStatus: () => 'Staða afgreiðslu',
			PointsEarned: () => 'Áunnir punktar',
			PointsUsed: () => 'Notaðir punktar'
		},
		Totals: {
			Header: () => 'Yfirlit - Í dag',
			Orders: () => 'Pantanir',
			Total: () => 'Tekjur',
			Average: () => 'Meðalpöntun',
			UpdatedAt: (arg0: DateInput) => 'Uppfært ' + shortDateAndTimePreciseFormatter('is', arg0)
		},
		Filters: {
			MinAmount: () => 'Lágmarksupphæð',
			MaxAmount: () => 'Hámarksupphæð',
			FromDate: () => 'Frá dagsetningu',
			ToDate: () => 'Til dagsetningar'
		},
		Refund: {
			Title: () => 'Endurgreiðsla',
			Amount: () => 'Upphæð',
			Note: () => 'Athugasemd',
			AmountCannotBeEmpty: () => 'Upphæð má ekki vera tóm',
			AmountMustBeGreaterThanZero: () => 'Upphæð verður að vera stærri en 0',
			AmountMustBeLessThanRefundableAmount: (arg0: TranslationAmount) =>
				'Upphæð verður að vera minni en endurgreiðanleg upphæð (' + amountFormatter('is', arg0) + ')',
			Description: () => 'Veldu vörulínur til að endurgreiða, breyttu magni og/eða sláðu inn sérstaka upphæð.',
			ItemsSectionTitle: () => 'Vörulínur',
			CustomAmountSectionTitle: () => 'Sérstök upphæð',
			CustomAmountLabel: () => 'Viðbótarupphæð',
			CustomAmountOnlyLabel: () => 'Endurgreiðsluupphæð',
			CustomAmountHint: () => 'Bættu valfrjálst við sérstakri upphæð ofan á valdar vörur.',
			RefundableAmount: () => 'Endurgreiðanleg upphæð',
			RefundTotal: () => 'Heildarendurgreiðsla',
			AlreadyRefunded: (args: { quantity: number; total: number }) =>
				'Endurgreitt ' + String(args.quantity) + ' af ' + String(args.total),
			PromotionLocked: () => 'Hluti af tilboði — notaðu sérstaka upphæð í staðinn.',
			Restock: () => 'Setja skilaðar einingar aftur í birgðir',
			NothingToRefund: () => 'Ekkert er eftir til að endurgreiða á þessari pöntun.',
			NoRefundableItems: () => 'Engar vörulínur eru í boði fyrir endurgreiðslu á vörum.',
			SelectSomething: () => 'Veldu að minnsta kosti eina vöru eða sláðu inn sérstaka upphæð.',
			ExceedsRefundable: () => 'Heildarendurgreiðslan fer yfir endurgreiðanlega upphæð.',
			RefundEntireOrder: (arg0: TranslationAmount) =>
				'Endurgreiða alla pöntunina (' + amountFormatter('is', arg0) + ')',
			SelectAll: () => 'Velja allt',
			ConfirmTitle: () => 'Endurgreiða þessa pöntun?',
			ConfirmWarning: (args: { total: TranslationAmount }) =>
				'Þetta endurgreiðir ' +
				amountFormatter('is', args.total) +
				' til viðskiptavinarins. Endurgreiðslur eru endanlegar og ekki er hægt að afturkalla eða hætta við þær eftir að þær hefjast.',
			Submit: () => 'Endurgreiða',
			Success: () => 'Endurgreiðsla hafin',
			Error: () => 'Mistókst að hefja endurgreiðslu'
		},
		Payment: {
			CreateRefundWrongQuantity: (args: { number: string }) =>
				'Magn ætti að vera tala á milli 0 og ' + String(args.number)
		}
	},
	OrderDetail: {
		Title: (arg0: string) => 'Pöntun #' + String(arg0),
		OnDateFromSalesChannel: (args: { date: string; salesChannel: string }) =>
			String(args.date) + ' frá ' + String(args.salesChannel),
		OnDateFromPointOfSale: (args: { date: string; salesChannel: string; pointOfSale: string }) =>
			String(args.date) + ' frá ' + String(args.salesChannel) + ' (' + String(args.pointOfSale) + ')',
		Status: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Lokið'
					case 'CANCELED':
						return 'Hætt við'
					default:
						return String(v)
				}
			})(arg0),
		CancelWarning: (args: { id: string }) =>
			'Þú ert að fara að hætta við pöntunina ' + String(args.id) + '. Ekki er hægt að afturkalla þessa aðgerð.',
		OpenOrderDetails: () => 'Opna pöntunarsíðu',
		Items: () => 'Vörur',
		Transactions: () => 'Greiðslur',
		Summary: {
			Title: () => 'Samantekt',
			EditOrder: () => 'Breyta pöntun',
			OpenReceipt: () => 'Opna kvittun',
			ItemTotal: () => 'Samtals vörur',
			TaxTotal: () => 'VSK samtals',
			Total: () => 'Samtals',
			GiftCardTotal: () => 'Gjafakort samtals',
			PointsEarned: () => 'Áunnir vildarpunktar',
			PaidTotal: () => 'Greitt samtals',
			OutstandingAmount: () => 'Eftirstöðvar',
			Discount: () => 'Afsláttur',
			Refunded: () => 'Endurgreitt'
		},
		Receipt: {
			FailedToLoad: () => 'Ekki tókst að hlaða kvittun',
			Redirecting: () => 'Áframsending á kvittun...',
			Loading: () => 'Hleð kvittun...'
		},
		Payment: {
			Title: () => 'Greiðslur',
			Status: (
				arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'OVERPAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'
			) =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Í bið'
						case 'UNPAID':
							return 'Ógreitt'
						case 'PAID':
							return 'Greitt'
						case 'PARTIALLY_PAID':
							return 'Að hluta greitt'
						case 'OVERPAID':
							return 'Ofgreitt'
						case 'REFUNDED':
							return 'Endurgreitt'
						case 'PARTIALLY_REFUNDED':
							return 'Að hluta endurgreitt'
						default:
							return String(v)
					}
				})(arg0),
			TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
				(v => {
					switch (v) {
						case 'FAILED':
							return 'Mistókst'
						case 'SUCCESS':
							return 'Tókst'
						case 'PENDING':
							return 'Í bið'
						default:
							return String(v)
					}
				})(arg0),
			Provider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN') =>
				(v => {
					switch (v) {
						case 'RAPYD':
							return 'Rapyd'
						case 'MANUAL':
							return 'Handvirkt'
						case 'STRIPE':
							return 'Stripe'
						case 'ADYEN':
							return 'Adyen'
						default:
							return String(v)
					}
				})(arg0),
			PaymentWithSequenceNumber: (args: { sequenceNumber: string }) => 'Greiðsla #' + String(args.sequenceNumber),
			RefundWithSequenceNumber: (args: { sequenceNumber: string }) =>
				'Endurgreiðsla #' + String(args.sequenceNumber),
			TotalPaidByCustomer: () => 'Greitt af viðskiptavini',
			TotalPending: () => 'Í bið samtals',
			Refund: () => 'Endurgreiða'
		},
		SandStar: {
			Title: () => 'SandStar cooler',
			CloudReview: () => 'Skýjayfirferð',
			MachineName: () => 'Vél',
			OrderNo: () => 'Pöntunarnúmer',
			AbnormalReason: () => 'Frávik',
			Video: () => 'Myndband',
			NoVideo: () => 'Ekkert myndband'
		}
	},
	Products: {
		Title: () => 'Vörur',
		Library: () => 'Safn',
		Status: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Drög'
					case 'PUBLISHED':
						return 'Birt'
					case 'ARCHIVED':
						return 'Geymt'
					default:
						return String(v)
				}
			})(arg0),
		BarcodeType: () => 'Tegund strikamerkis',
		ExportTitle: () => 'Flytja út vörur',
		AdvancedFilters: () => 'Vörusíur',
		NoAdvancedFiltersYet: () => 'Engar ítarlegar síur eru enn í boði fyrir vörur.',
		OpenProductDetails: () => 'Opna vöruupplýsingar',
		LibraryPage: {
			NoAssets: () => 'Engar vörumyndir enn',
			NoAssetsDescription: () => 'Hladdu upp vörumyndum hér til að endurnýta þær á vörunum þínum.',
			Filename: () => 'Skráarnafn',
			TableView: () => 'Töfluyfirlit',
			GalleryView: () => 'Myndayfirlit',
			Upload: () => 'Hlaða upp',
			SearchFilename: () => 'Leita eftir skráarnafni',
			ViewFullImage: () => 'Skoða alla myndina',
			CopyUrl: () => 'Afrita slóð',
			CopiedUrl: () => 'Slóð afrituð',
			DeleteAsset: () => 'Eyða eign',
			DeleteAssetConfirm: () => 'Eyða þessari eign? Því er ekki hægt að breyta til baka.',
			UploadAssets: () => 'Hlaða upp eignum',
			UploadDropzone: () => 'Dragðu og slepptu myndum hér, eða smelltu til að velja skrár',
			ChooseFiles: () => 'Velja skrár',
			Tags: () => 'Merki',
			UsedBy: () => 'Notað af',
			UsageFilter: () => 'Notkun',
			UsageUnused: () => 'Ónotað',
			UsageProduct: () => 'Vara',
			UsageProductGroup: () => 'Vöruhópur',
			UsageProductCategory: () => 'Vöruflokkur',
			UsageMarketingContent: () => 'Markaðsefni',
			UsageFeedLayout: () => 'Straumur í appi',
			ChannelFilter: () => 'Markaðsrás',
			ContentFilter: () => 'Notað af efni',
			ChannelNone: () => 'Engin rás',
			ContentNone: () => 'Ekkert efni',
			TagsPlaceholder: () => 'Sláðu inn merki og ýttu á Enter',
			Uploading: () => 'Hleður upp',
			EditTags: () => 'Breyta merkjum',
			NoTags: () => 'Engin merki',
			ManageTags: () => 'Stjórna merkjum',
			ManageTagsEmpty: () => 'Engin merki í safninu enn.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' eignir',
			CreateTag: () => 'Búa til merki',
			CreateTagPlaceholder: () => 'Sláðu inn merki og ýttu á Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Merkið „' + String(args.tag) + '“ búið til.',
			RenameTag: () => 'Endurnefna merki',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Sameina merkið „' +
				String(args.from) +
				'“ við „' +
				String(args.to) +
				'“ (' +
				String(args.count) +
				' eignir)? Gamla merkið verður fjarlægt.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Merki endurnefnt úr „' + String(args.from) + '“ í „' + String(args.to) + '“.',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjarlægja merkið „' + String(args.tag) + '“ af öllum eignum? Skrárnar eru ekki eyddar.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Merki fjarlægt af ' +
				String(args.count) +
				' ' +
				plural('is', args.count, { one: 'eign', other: 'eignum' }) +
				'.'
		},
		Column: {
			Title: () => 'Titill',
			Status: () => 'Staða',
			PricingMethod: () => 'Verðlagningaraðferð',
			SalesChannels: () => 'Sölurásir'
		},
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Á einingu'
					case 'PRICE_EMBEDDED':
						return 'Verð innbyggt'
					case 'PER_WEIGHT':
						return 'Á þyngd'
					case 'WEIGHT_EMBEDDED':
						return 'Þyngd innbyggð'
					default:
						return String(v)
				}
			})(arg0),
		Export: {
			Description: () => 'Flytja út vörur í CSV skrá.',
			Download: () => 'Sækja',
			Error: () => 'Mistókst að flytja út vörur',
			Format: () => 'Snið',
			NoDataError: () => 'Engin gögn til að flytja út',
			ProductCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'vara', other: 'varar' }),
			Success: () => 'Vörur fluttar út'
		},
		Import: {
			Header: () => 'Flytja inn vörulista',
			UploadLabel: () => 'Flytja inn vörur',
			UploadHint: () => 'Dragðu og slepptu CSV skrá eða smelltu til að hlaða upp',
			Description: () => 'Flyttu inn vörur með því að veita CSV skrá í fyrirfram skilgreindu sniði',
			Template: {
				Title: () => 'Óviss um hvernig á að raða listanum þínum?',
				Description: () => 'Sæktu sniðmátið hér að neðan til að tryggja að þú fylgir réttu sniði.'
			},
			Upload: {
				Title: () => 'Hlaða upp CSV skrá',
				Description: () =>
					'Með innflutningi geturðu bætt við eða uppfært vörur. Til að uppfæra núverandi vörur verður inntak samsvara með utanaðkomandi auðkenni, SKU eða strikamerki. Þú verður beðin(n) um staðfestingu áður en við flytjum inn vörur.',
				Preprocessing: () => 'Undirbúningur...',
				Importing: () => 'Les inn vörur...',
				ProductsToCreate: () => 'Vörur verða búnar til',
				ProductsToUpdate: () => 'Vörur verða uppfærðar',
				ProductsCreated: () => 'Vörur stofnaðar',
				ProductsUpdated: () => 'Vörur uppfærðar',
				ProductsErrored: () => 'Vörur með villu',
				Errors: {
					Title: () => 'Villur',
					Description: (args: { count: number; rows: number }) =>
						String(args.count) +
						' ' +
						plural('is', args.count, { one: 'villa', other: 'villar' }) +
						' í ' +
						String(args.rows) +
						' ' +
						plural('is', args.rows, { one: 'röð', other: 'röðum' }),
					Row: () => 'Röð',
					Column: () => 'Dálkur',
					Message: () => 'Skilaboð'
				}
			},
			Success: () => 'Innflutningur tókst!'
		}
	},
	Product: {
		Header: (arg0: string) => 'Vara ' + String(arg0),
		EditHeader: () => 'Breyta vöru',
		EditSuccessToast: (args: { title: string }) => 'Vara ' + String(args.title) + ' var uppfærð.',
		CreateTitle: () => 'Búa til vöru',
		Title: () => 'Titill',
		Subtitle: () => 'Undirtitill',
		Description: () => 'Lýsing',
		PricingMethodTitle: () => 'Verðlagningaraðferð',
		Overview: () => 'Yfirlit',
		ExternalId: () => 'Utanaðkomandi auðkenni',
		ExternalSource: () => 'Ytri uppruni',
		ManagedExternally: (args: { source: string }) => 'Þessari vöru er stýrt af ' + String(args.source),
		Sku: () => 'SKU',
		Variants: () => 'Afbrigði',
		DeleteWarning: (args: { title: string }) =>
			'Þú ert að fara að eyða vörunni ' + String(args.title) + '. Ekki er hægt að afturkalla þessa aðgerð.',
		Create: {
			Title: () => 'Búa til vöru'
		},
		Media: {
			Title: () => 'Miðlar',
			Upload: () => 'Hlaða upp',
			ChooseFromLibrary: () => 'Velja úr safni',
			LibraryPickerTitle: () => 'Bæta við úr safni',
			LibraryPickerEmpty: () => 'Engar vörumyndir í safninu enn.',
			LibraryPickerAllAttached: () => 'Allar myndir úr safninu eru þegar á þessari vöru.',
			AddImageSuccessToast: () => 'Mynd bætt við',
			DeleteImageLabel: () => 'Eyða mynd',
			DownloadImageLabel: () => 'Sækja mynd',
			SetPrimaryLabel: () => 'Setja sem aðalmynd',
			AlreadyPrimaryLabel: () => 'Aðalmynd',
			PrimaryBadge: () => 'Aðalmynd',
			ProcessingBadge: () => 'Vinnsla…',
			UploadingLabel: (args: { percent: number }) => 'Hleð upp… ' + String(args.percent) + '%',
			UploadSuccessToast: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'mynd', other: 'myndir' }) + ' hlaðnar upp',
			UploadFailedToast: () => 'Tókst ekki að hlaða upp mynd',
			DeleteSuccessToast: () => 'Mynd eytt',
			SetPrimarySuccessToast: () => 'Aðalmynd uppfærð',
			EmptyState: {
				Header: () => 'Engin mynd enn',
				Description: () =>
					'Dragðu og slepptu myndum hér, eða bættu mynd við vöruna til að sýna hana í verslun þinni.',
				Action: () => 'Bæta við miðli'
			}
		},
		Organization: {
			Header: () => 'Skipulag'
		},
		Pricing: {
			Title: () => 'Verðlagning',
			VariablePrice: () => 'Breytilegt verð',
			Price: () => 'Verð',
			PriceWithTax: () => 'Verð með vsk',
			PriceWithoutTax: () => 'Verð án vsk',
			Enabled: () => 'Virkt',
			InvalidTaxRate: (args: { taxRate: string }) => 'Ógilt VSK-hlutfall: ' + String(args.taxRate),
			NoPricesConfigured: () => 'Engin verð stillt',
			Target: () => 'Á við um',
			Group: () => 'Hópur',
			Channel: () => 'Sölurás',
			GroupDefault: () => 'Sjálfgefið fyrir hóp',
			ChannelOverride: () => 'Yfirskrift rásar',
			AddOverride: () => 'Bæta við yfirskrift rásar',
			SelectOverrideChannel: () => 'Veldu sölurás til að yfirskrifa',
			NoOverridableChannels: () => 'Allar rásir í hópnum hafa þegar yfirskrift',
			RemoveOverride: () => 'Fjarlægja yfirskrift',
			ExpandGroup: () => 'Sýna rásaverð',
			CollapseGroup: () => 'Fela rásaverð',
			OverrideCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'yfirskrift', other: 'yfirskriftir' }),
			EmptyState: {
				Header: () => 'Ekkert verð stillt',
				Description: () => 'Bættu við verði fyrir þessa vöru svo hana megi selja í sölurás.',
				Action: () => 'Bæta við verði'
			}
		},
		Barcode: {
			Title: () => 'Strikamerki',
			Barcode: () => 'Strikamerki',
			AddBarcode: () => 'Bæta við strikamerki',
			AddBarcodePrompt: {
				Title: () => 'Bæta við strikamerki',
				Placeholder: () => 'Strikamerki'
			},
			Delete: {
				Title: () => 'Eyða strikamerki',
				Description: (args: { barcode: string }) =>
					'Ertu viss um að þú viljir eyða strikamerkinu ' + String(args.barcode) + '?'
			},
			AlreadyOnProduct: () => 'Þetta strikamerki er þegar á þessum vöru',
			AlreadyInUse: () => 'Þetta strikamerki er þegar í notkun á annarri vöru'
		},
		UnitsOfMeasure: {
			Title: () => 'Mælieiningar',
			Unit: () => 'Eining',
			Base: () => 'Grunn',
			BaseUnit: () => 'Grunneining',
			True: () => 'Satt',
			False: () => 'Ósatt',
			BaseUnitLabel: (args: { code: string }) => String(args.code) + ' (grunneining)',
			BaseUnitsPer: () => 'Magn á einingu',
			Sellable: () => 'Seljanlegt',
			Pos: () => 'POS',
			Ecom: () => 'Netverslun',
			Add: () => 'Bæta við einingu',
			Edit: () => 'Breyta einingu',
			Code: () => 'Kóði',
			Name: () => 'Heiti',
			InvalidFactor: () => 'Magn verður að vera stærra en núll',
			SelectUnit: () => 'Veldu einingu',
			QuantityRequired: () => 'Þessi eining hefur ekkert sameiginlegt magn, svo magn er áskilið',
			Saved: () => 'Eining vistuð',
			Delete: {
				Title: () => 'Eyða einingu',
				Description: (args: { code: string }) => 'Ertu viss um að þú viljir eyða ' + String(args.code) + '?'
			}
		}
	},
	ProductEdit: {
		Header: () => 'Breyta vöru'
	},
	ProductCategories: {
		Title: () => 'Flokkar',
		Breadcrumb: () => 'Flokkar',
		Search: () => 'Leita í flokkum',
		Empty: () => 'Engir flokkar enn',
		NoSearchResults: (args: { query: string }) => 'Engir flokkar passa við „' + String(args.query) + '“',
		Column: {
			Name: () => 'Nafn',
			ProductCount: () => 'Fjöldi vara'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'Enginn yfirflokkur',
			SelectParentTitle: () => 'Velja yfirflokk',
			SelectParentDescription: () => 'Veldu yfirflokk fyrir þennan flokk'
		}
	},
	ProductCategory: {
		CreateSuccessToast: (args: { name: string }) => 'Flokkur ' + String(args.name) + ' var búinn til.',
		EditHeader: () => 'Breyta flokki',
		EditSuccessToast: (args: { name: string }) => 'Flokkur ' + String(args.name) + ' var uppfærður.',
		CreateTitle: () => 'Búa til flokk',
		ParentCategory: () => 'Yfirflokkur',
		ProductsTitle: () => 'Vörur',
		SelectParent: () => 'Velja yfirflokk',
		ClearParent: () => 'Hreinsa yfirflokk',
		Delete: {
			Title: () => 'Eyða flokki',
			Description: (args: { name: string }) =>
				'Ertu viss um að þú viljir eyða flokknum "' +
				String(args.name) +
				'"? Vörum í þessum flokki verður ekki eytt.',
			SuccessToast: (args: { name: string }) => 'Flokknum ' + String(args.name) + ' var eytt.'
		},
		Image: {
			Title: () => 'Mynd',
			EmptyState: () => 'Engin mynd enn',
			Upload: () => 'Hlaða upp',
			ChooseFromLibrary: () => 'Velja úr safni',
			Remove: () => 'Fjarlægja mynd',
			LibraryPickerTitle: () => 'Bæta við úr safni',
			LibraryPickerEmpty: () => 'Engar vörumyndir í safninu enn.',
			LibraryPickerAllAttached: () => 'Þessi mynd er þegar valin.',
			SetSuccessToast: () => 'Mynd uppfærð',
			RemoveSuccessToast: () => 'Mynd fjarlægð',
			UploadFailedToast: () => 'Ekki tókst að hlaða upp mynd'
		},
		Create: {
			NoParent: () => 'Enginn yfirflokkur',
			SelectParentTitle: () => 'Velja yfirflokk',
			SelectParentDescription: () => 'Veldu yfirflokk fyrir þennan flokk'
		}
	},
	ProductGroups: {
		Title: () => 'Hópar',
		Breadcrumb: () => 'Hópar',
		Search: () => 'Leita í hópum',
		Empty: () => 'Engir hópar enn',
		NoSearchResults: (args: { query: string }) => 'Engir hópar passa við „' + String(args.query) + '“',
		Column: {
			Name: () => 'Nafn',
			ProductCount: () => 'Fjöldi vara'
		}
	},
	ProductGroup: {
		Title: (arg0: string) => 'Hópur ' + String(arg0),
		EditHeader: () => 'Breyta hóp',
		EditSuccessToast: (args: { name: string }) => 'Hópur ' + String(args.name) + ' var uppfærður.',
		CreateTitle: () => 'Búa til hóp',
		CreateSuccessToast: (args: { name: string }) => 'Hópur ' + String(args.name) + ' var búinn til.',
		Delete: {
			Title: () => 'Eyða hóp',
			Description: (args: { name: string }) =>
				'Ertu viss um að þú viljir eyða hópnum "' +
				String(args.name) +
				'"? Vörum í þessum hóp verður ekki eytt.',
			SuccessToast: (args: { name: string }) => 'Hópnum ' + String(args.name) + ' var eytt.'
		},
		Image: {
			Title: () => 'Mynd',
			EmptyState: () => 'Engin mynd enn',
			Upload: () => 'Hlaða upp',
			ChooseFromLibrary: () => 'Velja úr safni',
			Remove: () => 'Fjarlægja mynd',
			LibraryPickerTitle: () => 'Bæta við úr safni',
			LibraryPickerEmpty: () => 'Engar vörumyndir í safninu enn.',
			LibraryPickerAllAttached: () => 'Þessi mynd er þegar valin.',
			SetSuccessToast: () => 'Mynd uppfærð',
			RemoveSuccessToast: () => 'Mynd fjarlægð',
			UploadFailedToast: () => 'Ekki tókst að hlaða upp mynd'
		},
		Products: {
			Title: () => 'Vörur',
			NoProducts: () => 'Engar vörur',
			Add: {
				Title: () => 'Bæta við vörum',
				Label: () => 'Vörur',
				Placeholder: () => 'Leita í vörum',
				SuccessToast: (args: { count: number; name: string }) =>
					String(args.count) + ' vörum bætt í ' + String(args.name) + '.',
				NoProducts: () => 'Vinsamlegast veldu að minnsta kosti eina vöru.'
			}
		},
		Fees: {
			Title: () => 'Gjöld',
			AddFee: () => 'Bæta við gjaldi',
			NoFees: () => 'Engin gjöld',
			Delete: {
				Title: () => 'Eyða gjaldi',
				Description: (args: { name: string }) =>
					'Ertu viss um að þú viljir eyða gjaldinu "' + String(args.name) + '"?'
			},
			Create: {
				Title: () => 'Búa til gjald',
				Pricing: () => 'Verðlagning',
				SuccessToast: (args: { name: string }) => 'Gjald ' + String(args.name) + ' var búið til.',
				NoPrices: () => 'Vinsamlegast bættu við að minnsta kosti einu verði.'
			},
			Edit: {
				Title: () => 'Breyta gjaldi',
				SuccessToast: (args: { name: string }) => 'Gjaldið ' + String(args.name) + ' var uppfært.'
			}
		}
	},
	GiftCards: {
		Title: () => 'Gjafakort',
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Virkt'
					case 'INACTIVE':
						return 'Óvirkt'
					case 'RESERVED':
						return 'Frátekið'
					case 'REDEEMED':
						return 'Innleyst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Breyta gjafakorti',
		EditSuccess: () => 'Gjafakort uppfært',
		DeleteSuccess: () => 'Gjafakorti eytt',
		Delete: {
			Title: () => 'Eyða gjafakorti',
			Description: () =>
				'Ertu viss um að þú viljir eyða þessu gjafakorti? Ekki er hægt að afturkalla þessa aðgerð.'
		},
		Column: {
			Name: () => 'Nafn',
			Code: () => 'Kóði',
			Amount: () => 'Upphæð',
			CurrencyCode: () => 'Gjaldmiðill',
			Status: () => 'Staða'
		},
		Detail: {
			Title: () => 'Gjafakort',
			General: () => 'Almennt',
			CardDetails: () => 'Kortaupplýsingar',
			Redemptions: () => 'Innlausnir',
			NoRedemptions: () => 'Engar innlausnir',
			Date: () => 'Dagsetning',
			RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Í bið'
						case 'APPLIED':
							return 'Notuð'
						default:
							return String(v)
					}
				})(arg0)
		}
	},
	GiftCard: {
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'RESERVED':
						return 'Reserved'
					case 'REDEEMED':
						return 'Redeemed'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Breyta gjafakorti',
		CreateTitle: () => 'Búa til gjafakort',
		Name: () => 'Nafn',
		Code: () => 'Kóði',
		Amount: () => 'Upphæð',
		CurrencyCode: () => 'Gjaldmiðilskóði'
	},
	LoyaltyCards: {
		Title: () => 'Vildarkort',
		EditTitle: () => 'Breyta vildarkorti',
		EditSuccess: () => 'Vildarkort uppfært',
		DeleteSuccess: () => 'Vildarkorti eytt',
		ManagedExternally: (args: { source: string }) => 'Þessu vildarkorti er stýrt af ' + String(args.source),
		Delete: {
			Title: () => 'Eyða vildarkorti',
			Description: () =>
				'Ertu viss um að þú viljir eyða þessu vildarkorti? Ekki er hægt að afturkalla þessa aðgerð.'
		},
		Detail: {
			Title: () => 'Vildarkort',
			CardDetails: () => 'Kortupplýsingar',
			Customer: () => 'Viðskiptavinur',
			Redemptions: () => 'Innlausnir',
			Date: () => 'Dagsetning'
		},
		Column: {
			Name: () => 'Nafn',
			CardNumber: () => 'Kortnúmer',
			Customer: () => 'Viðskiptavinur',
			Status: () => 'Staða',
			AvailablePoints: () => 'Aðgengileg stig',
			TotalPoints: () => 'Heildarstig',
			ExternalId: () => 'Ytra auðkenni',
			ExternalSource: () => 'Ytri uppspretta',
			PointsUsed: () => 'Notuð stig',
			PointsRemaining: () => 'Eftirstandandi stig',
			Order: () => 'Pöntun'
		}
	},
	Inventory: {
		Title: () => 'Lager',
		Stock: () => 'Birgðir',
		Suppliers: () => 'Birgjar',
		Movements: () => 'Birgðahreyfingar',
		Receiving: () => 'Móttaka',
		Transfers: () => 'Flutningar',
		Reports: () => 'Birgðaskýrslur',
		Summary: {
			TotalSkus: () => 'Heildarfjöldi SKU',
			LowStock: () => 'Lág birgð',
			OutOfStock: () => 'Uppselt'
		},
		Column: {
			Product: () => 'Vara',
			Variant: () => 'Afbrigði',
			Sku: () => 'SKU',
			SalesChannel: () => 'Sölurás',
			InventoryLocation: () => 'Staðsetning',
			QuantityOnHand: () => 'Á lager',
			QuantityAfter: () => 'Á lager eftir',
			ReorderPoint: () => 'Endurpöntunarmörk',
			ReorderQuantity: () => 'Endurpöntunarmagn',
			Status: () => 'Staða',
			Type: () => 'Tegund',
			Delta: () => 'Breyting',
			Reason: () => 'Ástæða',
			CreatedBy: () => 'Af',
			Ordered: () => 'Pantað',
			Received: () => 'Móttekið',
			ReceiveNow: () => 'Taka á móti núna',
			UnitCost: () => 'Einingarverð',
			Quantity: () => 'Magn',
			Lines: () => 'Vörur',
			Date: () => 'Dagsetning',
			Name: () => 'Nafn',
			Email: () => 'Netfang',
			Reference: () => 'Tilvísun',
			From: () => 'Frá',
			To: () => 'Til',
			Supplier: () => 'Birgir',
			Currency: () => 'Gjaldmiðill',
			Margin: () => 'Framlegð',
			PurchasePrice: () => 'Innkaupsverð',
			RetailPrice: () => 'Söluverð',
			Tracked: () => 'Fylgst með'
		},
		Filter: {
			LowStockOnly: () => 'Aðeins lág birgð',
			SalesChannel: () => 'Sölurás',
			InventoryLocation: () => 'Staðsetning',
			Status: () => 'Staða',
			Type: () => 'Tegund',
			AllChannels: () => 'Allar sölurásir',
			AllLocations: () => 'Allar staðsetningar',
			AllStatuses: () => 'Allar stöður',
			AllTypes: () => 'Allar tegundir'
		},
		NotTracked: () => 'Ekki fylgst með',
		ReorderSettings: () => 'Endurpöntunarstillingar',
		ViewMovements: () => 'Skoða sögu',
		Adjust: () => 'Leiðrétta birgð',
		AdjustSuccess: () => 'Birgð leiðrétt',
		AdjustNoChanges: () => 'Engar breytingar til að vista',
		AdjustDeltaHint: () => 'Hlutfallsleg breyting á birgðastöðu. Notaðu neikvætt gildi til að fjarlægja birgðir.',
		EditProduct: () => 'Breyta vöru',
		Settings: {
			Title: () => 'Stillingar',
			Description: () => 'Stýrðu hvernig birgðaeftirlit virkar á milli sölurása.',
			Enabled: () => 'Virkja birgðaeftirlit',
			EnabledDescription: () => 'Fylgstu með birgðastöðu og birgðahreyfingum fyrir vörurnar þínar.',
			DeductOnOrderComplete: () => 'Draga frá birgðir við frágengnar pantanir',
			DeductOnOrderCompleteDescription: () => 'Minnka tiltækt magn sjálfkrafa þegar pöntun er kláruð.',
			BlockOversell: () => 'Hindra ofsölu',
			BlockOversellDescription: () => 'Koma í veg fyrir sölu á fleiri einingum en eru tiltækar í rás.',
			RestockOnReturn: () => 'Endurbirgja við skil',
			RestockOnReturnDescription: () => 'Bæta skiluðum vörum aftur í birgðir þegar endurgreiðsla klárast.',
			HideOutOfStock: () => 'Fela uppseldar vörur',
			HideOutOfStockDescription: () =>
				'Fela vörur með birgðavöktun úr vefverslun þegar engar birgðir eru til í rásinni.',
			Saved: () => 'Birgðastillingar uppfærðar',
			Locations: {
				Title: () => 'Staðsetningar',
				Description: () => 'Stjórna birgðastaðsetningum og tengja sölurásir við þær.',
				Column: {
					Name: () => 'Heiti',
					SalesChannels: () => 'Sölurásir'
				},
				CreateTitle: () => 'Búa til staðsetningu',
				CreateSuccess: () => 'Staðsetning búin til',
				EditTitle: () => 'Breyta staðsetningu',
				EditSuccess: () => 'Staðsetning uppfærð',
				NamePlaceholder: () => 'Vöruhús, sölusalur, …',
				LinkedChannels: () => 'Tengdar sölurásir',
				LinkedChannelsHint: () =>
					'Veldu sölurásir sem draga birgðir frá þessari staðsetningu. Ef sölurás er þegar tengd annars staðar verður hún flutt hingað.',
				NoLinkedChannels: () => 'Engar sölurásir tengdar þessari staðsetningu.',
				InitializeStock: () => 'Frumstilla birgðafærslur',
				InitializeStockDescription: () =>
					'Búa til birgðafærslur fyrir allar vörur með birgðavöktun á þessari staðsetningu. Núverandi færslur eru slepptar.',
				InitializeStockSuccess: () => 'Birgðafærslur frumstilltar',
				InitializeStockProgress: (args: { created: number; remaining: number }) =>
					'Búið til ' + String(args.created) + ' færslur (' + String(args.remaining) + ' eftir)',
				InitializeStockProgressLabel: (args: { created: number; total: number }) =>
					'Búið til ' + String(args.created) + ' af ' + String(args.total) + ' birgðafærslum',
				InitializeStockError: (args: { created: number }) =>
					'Frumstilling stöðvaðist eftir að hafa búið til ' +
					String(args.created) +
					' færslur. Reyndu aftur til að ljúka.',
				InitializeStockRetry: () => 'Reyna aftur',
				AdminOnly: () => 'Aðeins stjórnendur geta stjórnað birgðastaðsetningum.'
			}
		},
		Status: {
			IN_STOCK: () => 'Á lager',
			LOW_STOCK: () => 'Lág birgð',
			OUT_OF_STOCK: () => 'Uppselt'
		},
		MovementType: {
			ADJUSTMENT: () => 'Leiðrétting',
			RECEIPT: () => 'Móttaka',
			TRANSFER_IN: () => 'Flutningur inn',
			TRANSFER_OUT: () => 'Flutningur út',
			ORDER_DEDUCTION: () => 'Pöntunardrag',
			ORDER_RETURN: () => 'Pöntunar skil'
		},
		TransferStatus: {
			DRAFT: () => 'Drög',
			IN_TRANSIT: () => 'Í flutningi',
			RECEIVED: () => 'Móttekið',
			CANCELLED: () => 'Hætt við'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Drög',
			ORDERED: () => 'Pantað',
			PARTIALLY_RECEIVED: () => 'Að hluta móttekið',
			RECEIVED: () => 'Móttekið',
			CANCELLED: () => 'Hætt við'
		},
		CreateSupplier: () => 'Búa til birgja',
		EditSupplier: () => 'Breyta birgja',
		EditSupplierSuccess: () => 'Birgi uppfærður',
		SuppliersEmptyTitle: () => 'Engir birgjar enn',
		SuppliersEmptyDescription: () => 'Búðu til fyrsta birgjann til að fylgjast með hvaðan þú kaupir birgðir.',
		CreateTransfer: () => 'Búa til flutning',
		CreatePurchaseOrder: () => 'Búa til innkaupapöntun',
		PurchaseCurrencyHint: (args: { currency: string }) =>
			'Notar ' + String(args.currency) + ' fyrir þessa pöntun. Breyttu ef pöntunin er önnur.',
		PurchaseCurrencyDefaultHint: (args: { currency: string }) =>
			'Notar uppgjörsgjaldmiðilinn þinn ' + String(args.currency) + '. Staðfestu eða breyttu.',
		PurchaseCurrencyRequired: () => 'Veldu gjaldmiðil innkaupapöntunar.',
		ShipTransfer: () => 'Senda flutning',
		ReceiveTransfer: () => 'Taka á móti flutningi',
		CancelTransfer: () => 'Hætta við flutning',
		Transfer: () => 'Flutningur',
		Actions: () => 'Aðgerðir',
		ReceivePurchaseOrder: () => 'Taka á móti vörum',
		ManageSuppliers: () => 'Stjórna',
		Replenish: () => 'Endurnýja lága birgði',
		ReplenishSuccess: (args: { count: number }) => 'Bjó til ' + String(args.count) + ' endurpöntunardrög',
		ReplenishNone: () => 'Engar vörur undir endurpöntunarmörkum',
		MarkOrdered: () => 'Merkja sem pantað',
		CancelOrder: () => 'Hætta við',
		PurchaseOrder: () => 'Innkaupapöntun',
		AddLine: () => 'Bæta við',
		NoLines: () => 'Engar vörur bætt við enn.',
		SelectSalesChannel: () => 'Veldu sölurás',
		SupplierDialog: {
			Title: () => 'Birgjar vöru',
			Preferred: () => 'Valinn',
			SetPreferred: () => 'Velja sem aðalbirgja',
			AddSupplier: () => 'Bæta við birgja',
			SelectSupplier: () => 'Veldu birgja',
			Empty: () => 'Engir birgjar tengdir þessari vöru enn.',
			NoSuppliersYet: () => 'Engir birgjar eru til enn',
			NoSuppliersDescription: () => 'Búðu til birgja áður en þú tengir hann við þessa vöru.',
			CreateSupplierAction: () => 'Búa til birgja',
			SupplierProductCode: () => 'Vörunúmer birgja',
			UpdateSuccess: () => 'Birgir uppfærður',
			AllSuppliersLinked: () => 'Allir birgjar eru þegar tengdir þessari vöru.',
			EditPrices: () => 'Breyta verðum',
			MarginUnavailable: () => 'Ekki í boði',
			MarginCurrencyMismatch: (args: { retail: string; purchase: string }) =>
				'Ekki er hægt að reikna framlegð því smásöluverð (' +
				String(args.retail) +
				') og birgjaverð (' +
				String(args.purchase) +
				') eru í ólíkum gjaldmiðlum.',
			MarginTaxNote: () =>
				'Framlegð er reiknuð af söluverði án vsk. Ef söluverð er með vsk er vsk dreginn frá fyrst.',
			PurchasePriceTaxNote: () => 'Sláðu inn innkaupsverð frá birgja án vsk (nettó).'
		}
	},
	Companies: {
		Title: () => 'Fyrirtæki',
		Anonymous: () => 'Ónefnt',
		CreateTitle: () => 'Stofna fyrirtæki',
		CreateSuccess: () => 'Fyrirtæki stofnað.',
		EditTitle: () => 'Breyta fyrirtæki',
		EditSuccess: () => 'Fyrirtæki uppfært.',
		UpdateSuccess: () => 'Fyrirtækið var uppfært',
		Delete: {
			Title: () => 'Eyða fyrirtæki',
			Description: (args: { name: string }) =>
				'Ertu viss um að þú viljir eyða fyrirtækinu ' +
				String(args.name) +
				'? Þessa aðgerð er ekki hægt að afturkalla.'
		},
		DeleteSuccess: () => 'Fyrirtækinu var eytt',
		CardCount: () => 'Fyrirtækjakort',
		SettlementCount: () => 'Nýleg uppgjör',
		RecentSettlements: () => 'Nýleg uppgjör',
		Cards: {
			Title: () => 'Fyrirtækjakort'
		},
		Detail: {
			Title: () => 'Fyrirtæki',
			General: () => 'Almennt',
			ContactInfo: () => 'Tengiliðaupplýsingar',
			Cards: () => 'Fyrirtækjakort',
			Settlements: () => 'Uppgjör',
			RecentSettlements: () => 'Nýleg uppgjör',
			AssignCard: () => 'Úthluta korti',
			AssignCardDescription: () =>
				'Leitaðu að fyrirtækjakorti eftir nafni eða kortnúmeri til að úthluta því á þetta fyrirtæki.',
			AssignCardSuccess: () => 'Kortinu var úthlutað',
			UnassignCard: () => 'Aftengja kort',
			UnassignCardConfirm: () => 'Ertu viss um að þú viljir aftengja þetta kort frá fyrirtækinu?',
			UnassignCardSuccess: () => 'Úthlutun korts var fjarlægð',
			CardNumberPlaceholder: () => 'Leita eftir nafni eða kortnúmeri'
		},
		Column: {
			Name: () => 'Nafn',
			Email: () => 'Netfang',
			Phone: () => 'Sími',
			ExternalId: () => 'Ytra auðkenni',
			CardCount: () => 'Kort',
			SettlementCount: () => 'Uppgjör',
			CreatedAt: () => 'Stofnað'
		},
		Field: {
			Name: () => 'Nafn',
			Email: () => 'Netfang',
			Phone: () => 'Sími',
			ExternalId: () => 'Ytra auðkenni'
		},
		Create: {
			BasicInfo: () => 'Grunnupplýsingar',
			Description: () => 'Stofna nýtt fyrirtæki',
			NamePlaceholder: () => 'Sláðu inn heiti fyrirtækis',
			ExternalIdPlaceholder: () => 'Sláðu inn ytra auðkenni (valfrjálst)'
		},
		Edit: {
			BasicInfo: () => 'Grunnupplýsingar',
			Description: () => 'Breyta upplýsingum um fyrirtæki',
			NamePlaceholder: () => 'Sláðu inn heiti fyrirtækis',
			EmailPlaceholder: () => 'Sláðu inn netfang',
			PhonePlaceholder: () => 'Sláðu inn símanúmer',
			OrgNumberPlaceholder: () => 'Sláðu inn kennitölu',
			ExternalIdPlaceholder: () => 'Sláðu inn ytra auðkenni (valfrjálst)'
		}
	},
	Customers: {
		Title: () => 'Viðskiptavinir',
		UnnamedCustomer: () => 'Nafnlaus viðskiptavinur',
		Anonymous: () => 'Nafnlaus',
		CreateTitle: () => 'Stofna viðskiptavin',
		CreateSuccess: (args: { name: string }) => 'Viðskiptavinur ' + String(args.name) + ' var stofnaður',
		EditTitle: () => 'Breyta viðskiptavini',
		UpdateSuccess: () => 'Viðskiptavinur var uppfærður',
		Detail: {
			Title: () => 'Viðskiptavinur',
			General: () => 'Almennt',
			ContactInfo: () => 'Tengiliðaupplýsingar',
			Cards: () => 'Kort',
			AssignCard: () => 'Tengja kort',
			AssignCardDescription: () =>
				'Leitaðu að viðskiptakorti eftir nafni eða kortanúmeri til að tengja það þessum viðskiptavini.',
			AssignCardSuccess: () => 'Korti var tengt',
			UnassignCard: () => 'Aftengja kort',
			UnassignCardConfirm: () => 'Ertu viss um að þú viljir aftengja þetta kort frá viðskiptavininum?',
			UnassignCardSuccess: () => 'Úthlutun korts var fjarlægð',
			CardNumberPlaceholder: () => 'Leita eftir nafni eða kortanúmeri'
		},
		Column: {
			Name: () => 'Nafn',
			Email: () => 'Netfang',
			Phone: () => 'Sími',
			ExternalId: () => 'Ytra auðkenni',
			Cards: () => 'Kort'
		},
		Field: {
			FirstName: () => 'Fornafn',
			LastName: () => 'Eftirnafn',
			Phone: () => 'Sími',
			SSN: () => 'Kennitala'
		},
		Create: {
			BasicInfo: () => 'Grunnupplýsingar',
			Description: () => 'Stofna nýjan viðskiptavin'
		},
		Edit: {
			BasicInfo: () => 'Grunnupplýsingar',
			Description: () => 'Breyta upplýsingum um viðskiptavin',
			FirstNamePlaceholder: () => 'Sláðu inn fornafn',
			LastNamePlaceholder: () => 'Sláðu inn eftirnafn',
			EmailPlaceholder: () => 'Sláðu inn netfang',
			PhonePlaceholder: () => 'Sláðu inn símanúmer',
			SSNPlaceholder: () => 'Sláðu inn kennitölu (valfrjálst)',
			ExternalIdPlaceholder: () => 'Sláðu inn ytra auðkenni (valfrjálst)'
		},
		Cards: {
			Title: () => 'Viðskiptavinakort',
			Active: () => 'Virk kort'
		}
	},
	BusinessCards: {
		Title: () => 'Viðskiptakort',
		CreateTitle: () => 'Stofna viðskiptakort',
		CreateSuccess: () => 'Viðskiptakort stofnað',
		EditTitle: () => 'Breyta viðskiptakorti',
		EditSuccess: () => 'Viðskiptakorti breytt',
		DeleteSuccess: () => 'Viðskiptakorti eytt',
		Create: {
			NamePlaceholder: () => 'Sláðu inn heiti korts',
			CardNumberPlaceholder: () => 'Sláðu inn kortanúmer',
			SelectCompany: () => 'Veldu fyrirtæki',
			SelectCustomer: () => 'Veldu viðskiptavin',
			PinTitle: () => 'Viðskiptakort stofnað',
			PinDescription: () => 'Deildu þessu PIN með korthafanum. Það er aðeins hægt að skoða það einu sinni.',
			GoToCard: () => 'Fara á kort'
		},
		Delete: {
			Title: () => 'Eyða viðskiptakorti',
			Description: () =>
				'Ertu viss um að þú viljir eyða þessu viðskiptakorti? Þessa aðgerð er ekki hægt að afturkalla.'
		},
		Detail: {
			Title: () => 'Viðskiptakort',
			General: () => 'Almennt',
			CardDetails: () => 'Kortaupplýsingar',
			Security: () => 'Öryggi',
			ResetPin: () => 'Endurstilla PIN',
			ResetPinDescription: () => 'Búa til nýtt PIN fyrir þetta kort. Núverandi PIN verður ógilt.',
			ResetPinSuccess: () => 'PIN hefur verið endurstillt',
			NewPin: (args: { pin: string }) => 'Nýtt PIN: ' + String(args.pin),
			PinViewOnce: () =>
				'Þetta PIN er aðeins hægt að skoða einu sinni. Vinsamlegast vistaðu það áður en þú lokar þessum glugga.',
			Customer: () => 'Viðskiptavinur',
			Company: () => 'Fyrirtæki',
			DangerZone: () => 'Hættusvæði',
			DeleteCardDescription: () => 'Eyða þessu viðskiptakorti varanlega. Þessa aðgerð er ekki hægt að afturkalla.'
		},
		Column: {
			Name: () => 'Nafn',
			CardNumber: () => 'Kortanúmer',
			Status: () => 'Staða',
			Customer: () => 'Viðskiptavinur',
			ExternalId: () => 'Ytra auðkenni',
			CreatedAt: () => 'Stofnað'
		},
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Virkt'
					case 'INACTIVE':
						return 'Óvirkt'
					case 'BLOCKED':
						return 'Lokað'
					default:
						return String(v)
				}
			})(arg0)
	},
	Promotions: {
		Title: () => 'Tilboð',
		Group: () => 'Tilboðshópur',
		Groups: () => 'Hópar',
		SelectGroups: () => 'Velja tilboðshópa',
		Column: {
			PromotionCount: () => 'Tilboð'
		},
		CreateTitle: () => 'Búa til tilboð',
		CreateSuccess: () => 'Tilboð búið til',
		EditTitle: () => 'Breyta tilboði',
		UpdateSuccess: () => 'Tilboð uppfært',
		NotFound: () => 'Tilboð fannst ekki',
		AdvancedFilters: () => 'Tilboðsfilter',
		ManagedExternally: (args: { source: string }) => 'Þessu tilboði er stýrt af ' + String(args.source),
		Create: {
			ApplyToAll: () => 'Allar vörur',
			ApplyToGroups: () => 'Tilteknir vöruhópar',
			ApplyToCategories: () => 'Tilteknir flokkar',
			ApplyToProducts: () => 'Tilteknar vörur',
			AppliesTo: () => 'Gildir um',
			FixedAmount: () => 'Föst upphæð',
			Percentage: () => 'Prósenta',
			OverridePrice: () => 'Yfirskrifa verð',
			OverridePriceHelp: () =>
				'Stilltu fast heildarverð fyrir vörurnar sem passa, fyrir hverja sölurás eða sölurásarhóp',
			IncludeFeesHelp: () =>
				'Þegar kveikt er á er yfirvörðið endanlegt heildarverð að meðtöldum vörugjöldum. Þegar slökkt er á bætast vörugjöld ofan á yfirvörðið.',
			OverridePriceNoChannels: () =>
				'Veldu að minnsta kosti eina sölurás eða sölurásarhóp til að stilla yfirskrifað verð',
			BasicInfo: () => 'Grunnupplýsingar',
			DaysOfWeek: () => 'Dagar vikunnar',
			Discount: () => 'Áhrif',
			DiscountAmount: () => 'Afsláttarupphæð',
			DiscountPercentage: () => 'Afsláttarprósenta',
			PercentageHelp: () => 'Sláðu inn prósentu á milli 0 og 100',
			ItemCount: () => 'Fjöldi vara',
			NamePlaceholder: () => 'Sláðu inn heiti tilboðs',
			DisplayTitle: () => 'Birtingarheiti',
			DisplayTitlePlaceholder: () => 'Sýnt viðskiptavinum (valfrjálst)',
			DisplayTitleHint: () =>
				'Heiti sem viðskiptavinir sjá í skanna og fara, sjálfsafgreiðslu og vefverslun. Skildu eftir autt til að nota innra heiti.',
			ProductGroup: () => 'Vöruhópur',
			ProductGroups: () => 'Vöruhópar',
			SlotKind: () => 'Tegund',
			SlotKindGroup: () => 'Vöruhópur',
			SlotKindCategory: () => 'Flokkur',
			Categories: () => 'Flokkar',
			Products: () => 'Vörur',
			CustomerEligibility: () => 'Hæfi viðskiptavina',
			CustomerEligibilityHint: () =>
				'Skildu eftir autt til að gilda fyrir alla. Bættu við viðskiptavinum eða viðskiptavinahópum til að takmarka tilboðið við þá.',
			CustomerGroups: () => 'Viðskiptavinahópar',
			SelectCustomerGroups: () => 'Veldu viðskiptavinahópa',
			Customers: () => 'Viðskiptavinir',
			SelectCustomers: () => 'Veldu viðskiptavini',
			PromotionType: () => 'Tegund tilboðs',
			TypeDiscount: () => 'Afsláttur',
			TypeBundle: () => 'Pakkatilboð',
			TypeBuyXGetY: () => 'Kauptu X, fáðu Y',
			BundleGroups: () => 'Pakkahópar og flokkar',
			BundleGroupsHelp: () =>
				'Tilboðið gildir þegar tilskilinn fjöldi úr hverjum hópi eða flokki er í pöntuninni',
			QualifyingGroups: () => 'Skilyrðisvörur (kaupa)',
			QualifyingGroupsHelp: () =>
				'Tilskilinn fjöldi úr hverjum þessara hópa eða flokka þarf að vera í pöntuninni til að virkja tilboðið. Þessar vörur fá ekki afslátt.',
			BenefitGroups: () => 'Ávinningsvörur (fá)',
			BenefitGroupsHelp: () =>
				'Þegar skilyrðisvörurnar eru til staðar fær tilskilinn fjöldi úr hverjum þessara hópa eða flokka afsláttinn hér að neðan (100% = frítt).',
			AddBundleGroup: () => 'Bæta við hópi eða flokki',
			Schedule: () => 'Tímasetning',
			AddDay: () => 'Bæta við dögum',
			SelectDays: () => 'Velja daga',
			SelectProductGroups: () => 'Velja vöruhópa',
			SelectCategories: () => 'Velja flokka',
			SelectProducts: () => 'Velja vörur',
			SelectSalesChannels: () => 'Velja sölurásir',
			SalesChannelGroups: () => 'Sölurásarhópar',
			SelectSalesChannelGroups: () => 'Velja sölurásarhópa',
			ApplicationRule: () => 'Notkunarregla',
			Description: () => 'Lýsing',
			Rank: () => 'Forgangur',
			RankHint: () => 'Lægri tölur eru beittar fyrst þegar fleiri en ein tilboð eiga við sömu vörur',
			RankInUse: (args: { names: string }) =>
				'Annað tilboð notar nú þegar þennan forgang: ' +
				String(args.names) +
				'. Tilboð með sama forgang eru beitt í óskilgreindri röð, notaðu einstakt númer til að stjórna hvaða tilboð keyrir fyrst.',
			SellingUnit: () => 'Sölueining',
			SellingUnitHelp: () =>
				'Allar einingar beitir tilboðinu á allar sölueiningar vörunnar. Grunneining eða nefndur pakki takmarkar það við þá einingu.',
			AllUnits: () => 'Allar einingar',
			BaseUnit: () => 'Grunneining',
			Validation: {
				NameRequired: () => 'Heiti er nauðsynlegt',
				PercentageRange: () => 'Sláðu inn prósentu á milli 0 og 100',
				PercentageRequired: () => 'Sláðu inn afsláttarprósentu',
				BundleGroupsRequired: () => 'Bættu við að minnsta kosti einum pakkahópi eða flokki með fjölda',
				BenefitGroupsRequired: () => 'Bættu við að minnsta kosti einum ávinningshópi eða flokki með fjölda',
				QualifyingBenefitOverlap: () => 'Vöruhópur eða flokkur getur ekki verið bæði skilyrði og ávinningur',
				OverridePriceRequired: () => 'Stilltu yfirskrifað verð fyrir að minnsta kosti eina sölurás',
				ScopeTargetsRequired: () => 'Veldu að minnsta kosti einn vöruhóp, flokk eða vöru',
				RankRange: () => 'Sláðu inn forgang sem er 0 eða hærri'
			}
		},
		Detail: {
			SalesChannels: () => 'Sölurásir',
			DisplayTitle: () => 'Birtingarheiti',
			StartDate: () => 'Upphafsdagur',
			EndDate: () => 'Lokadagur',
			OverridePrice: () => 'Hneka verði',
			IncludeFees: () => 'Innihalda gjöld',
			ApplyToAllProducts: () => 'Nota á allar vörur',
			ProductGroups: () => 'Vöruhópar',
			DiscountDefinition: () => 'Afsláttarskilgreining',
			ApplicationRule: () => 'Notkunarregla',
			Prices: () => 'Verð',
			Title: () => 'Tilboðsupplýsingar',
			AppliesTo: () => 'Gildir fyrir',
			SellingUnit: () => 'Sölueining',
			CustomerEligibility: () => 'Hæfi viðskiptavina',
			AppliesToEveryone: () => 'Allir viðskiptavinir',
			DaysOfWeek: () => 'Dagar vikunnar',
			Discount: () => 'Afsláttur',
			DiscountType: () => 'Tegund afsláttar',
			DiscountValue: () => 'Gildi afsláttar',
			Schedule: () => 'Tímasetning'
		},
		Edit: {
			Description: () => 'Breyta tilboðsupplýsingum'
		},
		Delete: {
			Title: () => 'Eyða tilboði',
			Description: (args: { name: string }) =>
				'Ertu viss um að þú viljir eyða tilboðinu "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Tilboðinu ' + String(args.name) + ' var eytt.'
		}
	},
	Promotion: {
		Title: () => 'Tilboð',
		CreateTitle: () => 'Búa til tilboð'
	},
	Marketing: {
		Title: () => 'Markaðssetning',
		Library: () => 'Safn',
		Campaigns: () => 'Herferðir',
		Channels: () => 'Rásir',
		Messaging: () => 'Skilaboð',
		Journeys: () => 'Ferðir',
		ContentNav: () => 'Efni',
		LayoutNav: () => 'Skipulag',
		Channel: {
			Title: () => 'Markaðsrásir',
			NewChannel: () => 'Ný rás',
			NoChannels: () => 'Engar markaðsrásir enn',
			NoChannelsDescription: () => 'Búðu til markaðsrás til að birta efni.',
			CampaignCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'herferð', other: 'herferðir' }),
			SalesChannelsHint: () =>
				'Veldu sölurásirnar sem tilheyra þessari markaðsrás. Sölurás getur aðeins tilheyrt einni markaðsrás.',
			PublishableKeysHint: () =>
				'Veldu birtingarlyklana (forrit / biðlara) sem sækja feed og útlit sitt frá þessari rás. Birtingarlykill getur aðeins tilheyrt einni markaðsrás.',
			SurfacesHint: () =>
				'Veldu birtingarfletina sem þessi rás þjónar. Hún birtist aðeins fyrir flöt sem hún þjónar og ekkert er birt á flöt sem er ekki valinn.',
			DeleteConfirm: () => 'Eyða þessari markaðsrás? Birtingarlyklar hennar verða aftengdir.',
			Field: {
				Name: () => 'Heiti',
				NamePlaceholder: () => 't.d. Scan & Go, Sjálfsafgreiðsla, Skjár',
				Description: () => 'Lýsing',
				DescriptionPlaceholder: () => 'Valfrjáls lýsing',
				SalesChannels: () => 'Sölurásir',
				Surfaces: () => 'Birtingarfletir',
				SurfacesPlaceholder: () => 'Veldu birtingarfleti',
				PublishableKeys: () => 'Birtingarlyklar',
				PublishableKeysPlaceholder: () => 'Veldu birtingarlykla'
			},
			Action: {
				Create: () => 'Búa til rás',
				Save: () => 'Vista breytingar',
				Delete: () => 'Eyða'
			}
		},
		Campaign: {
			Title: () => 'Herferð',
			NewCampaign: () => 'Ný herferð',
			NoCampaigns: () => 'Engar herferðir enn',
			NoCampaignsDescription: () =>
				'Búðu til herferð til að skipuleggja hóp af kynningum fyrir viðskiptavinaforritið.',
			ActiveNow: () => 'Virk núna',
			Scheduled: () => 'Áætluð',
			Draft: () => 'Drög',
			Ended: () => 'Lokið',
			StatusEnum: (arg0: 'DRAFT' | 'PUBLISHED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Drög'
						case 'PUBLISHED':
							return 'Birt'
						default:
							return String(v)
					}
				})(arg0),
			WindowStatusEnum: (arg0: 'DRAFT' | 'SCHEDULED' | 'ACTIVE' | 'ENDED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Drög'
						case 'SCHEDULED':
							return 'Áætluð'
						case 'ACTIVE':
							return 'Virk núna'
						case 'ENDED':
							return 'Lokið'
						default:
							return String(v)
					}
				})(arg0),
			ItemTypeEnum: (arg0: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR' | 'CUSTOM') =>
				(v => {
					switch (v) {
						case 'BANNER':
							return 'Borði'
						case 'LIST':
							return 'Listi'
						case 'MODAL':
							return 'Gluggi'
						case 'SEPARATOR':
							return 'Aðskilnaður'
						case 'CUSTOM':
							return 'Sérsniðið'
						default:
							return String(v)
					}
				})(arg0),
			Field: {
				Name: () => 'Heiti',
				NamePlaceholder: () => 'Heiti herferðar',
				Description: () => 'Lýsing',
				DescriptionPlaceholder: () => 'Valfrjáls lýsing',
				Title: () => 'Fyrirsögn',
				ItemTitlePlaceholder: () => 'Opnunartími',
				ApiKey: () => 'Birtingarlykill',
				MarketingChannel: () => 'Markaðsrás',
				Status: () => 'Staða',
				StartsAt: () => 'Hefst',
				EndsAt: () => 'Lýkur',
				EndsAtOpenEnded: () => 'Enginn lokadagur',
				Rank: () => 'Röð',
				Items: () => 'Atriði'
			},
			Action: {
				Publish: () => 'Birta',
				Unpublish: () => 'Afbirta',
				Save: () => 'Vista breytingar',
				Delete: () => 'Eyða',
				Duplicate: () => 'Afrita',
				AddItem: () => 'Bæta við atriði',
				MoveUp: () => 'Færa upp',
				MoveDown: () => 'Færa niður'
			},
			Validation: {
				StartsAtRequired: () => 'Upphafsdagur er nauðsynlegur til að birta',
				EndsAtAfterStartsAt: () => 'Lokadagur verður að vera eftir upphafsdag'
			},
			Item: {
				NoItems: () => 'Engin atriði enn',
				NoItemsDescription: () =>
					'Bættu við borða, lista, glugga eða aðskilnaði til að byggja upp þessa herferð.'
			},
			Link: {
				TypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK' | 'IMAGE') =>
					(v => {
						switch (v) {
							case 'NONE':
								return 'Enginn'
							case 'BROWSER':
								return 'Vefslóð'
							case 'DEEP_LINK':
								return 'Djúptengsl'
							case 'IMAGE':
								return 'Myndaforskoðun'
							default:
								return String(v)
						}
					})(arg0),
				BrowserUrl: () => 'Vefslóð',
				DeepLink: () => 'Djúptenglaslóð',
				ImageUrl: () => 'Slóð myndar',
				ImageSource: () => 'Mynd til að forskoða',
				ImageSourceHelp: () => 'Stækkaðu mynd borðans, eða vísaðu á aðra mynd.',
				ImageSourceEnum: (arg0: 'BANNER' | 'CUSTOM') =>
					(v => {
						switch (v) {
							case 'BANNER':
								return 'Nota mynd borðans'
							case 'CUSTOM':
								return 'Sérsniðin myndslóð'
							default:
								return String(v)
						}
					})(arg0)
			},
			Help: {
				MarketingChannel: () => 'Hvaða hópur sölurása sér þessa herferð.',
				Status: () => 'Drög eru falin í forritinu. Birtar herferðir birtast á áætluðum tíma.',
				Schedule: () =>
					'Valfrjálst. Skildu upphaf eftir autt til að birta strax og lok autt til að keyra endalaust. Útrunnar herferðir eru sjálfkrafa faldar.',
				StartsAt: () => 'Sjálfgefið er 00:00 á deginum sem þú velur. Skildu eftir autt til að birta strax.',
				EndsAt: () => 'Sjálfgefið er 23:59 á deginum sem þú velur. Skildu eftir autt til að keyra endalaust.',
				Rank: () => 'Þegar margar herferðir eru virkar í einu birtist hærri röð fyrst.',
				Items: () => 'Atriði birtast ofan frá og niður í forritinu, nákvæmlega í þessari röð.'
			},
			Preview: {
				Title: () => 'Forskoðun',
				Empty: () => 'Bættu við atriðum til að forskoða hvernig herferðin lítur út í forritinu.',
				Disclaimer: () => 'Nálgun á heimaskjá viðskiptavinaforritsins.'
			},
			AdvancedOptions: () => 'Ítarlegri valkostir',
			BannerTypeEnum: (arg0: 'IMAGE' | 'TEXT_WITH_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'IMAGE':
							return 'Mynd'
						case 'TEXT_WITH_BACKGROUND':
							return 'Texti með bakgrunni'
						default:
							return String(v)
					}
				})(arg0),
			BannerText: () => 'Texti',
			ListImages: () => 'Listamyndir',
			AddImage: () => 'Bæta við mynd',
			AddImages: () => 'Bæta við myndum',
			AddImagesCount: (args: { count: number }) =>
				'Bæta við ' + String(args.count) + ' ' + plural('is', args.count, { one: 'mynd', other: 'myndum' }),
			ThumbnailLinkTypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Forskoðun myndar'
						case 'BROWSER':
							return 'Vafraslóð'
						case 'DEEP_LINK':
							return 'Djúptengill'
						default:
							return String(v)
					}
				})(arg0),
			JoinAbove: () => 'Sameina við blokk fyrir ofan',
			ShowTitle: () => 'Sýna fyrirsögn',
			ShowTitleHelp: () => 'Valfrjáls fyrirsögn sýnd fyrir ofan atriðið í forritinu.',
			ListImageShape: () => 'Lögun myndar',
			ListImageShapeEnum: (arg0: 'SQUARE' | 'PORTRAIT' | 'LANDSCAPE') =>
				(v => {
					switch (v) {
						case 'SQUARE':
							return 'Ferningur'
						case 'PORTRAIT':
							return 'Lóðrétt'
						case 'LANDSCAPE':
							return 'Lárétt'
						default:
							return String(v)
					}
				})(arg0),
			ListImageSize: () => 'Stærð myndar',
			ListImageSizeHelp: () => 'Hluti næstu myndar sést áfram svo viðskiptavinir viti að hægt sé að fletta.',
			ListImageSizeEnum: (arg0: 'LARGE' | 'MEDIUM' | 'SMALL') =>
				(v => {
					switch (v) {
						case 'LARGE':
							return 'Stór'
						case 'MEDIUM':
							return 'Miðlungs'
						case 'SMALL':
							return 'Lítil'
						default:
							return String(v)
					}
				})(arg0),
			ModalCover: () => 'Forsíðumynd glugga',
			ContainerClassName: () => 'Nafn á container-klasa',
			CustomInfo: () => 'Sérsniðin atriði eru birt af viðskiptavinaforritinu. Það eru engin breytanleg svið hér.',
			TapAction: () => 'Þegar smellt er',
			TapActionHelp: () =>
				'Hvert borðinn fer þegar smellt er, eða innbyggð aðgerð í staðinn. Innbyggðar aðgerðir koma í stað flakks.',
			TapActionNavigate: () => 'Flakk',
			TapActionBuiltIn: () => 'Innbyggt',
			PromotionAction: () => 'Snertiaðgerð',
			PromotionActionHelp: () => 'Valfrjáls innbyggð hegðun þegar borðinn er snertur, sem hnekkir tenglinum.',
			PromotionActionEnum: (arg0: 'NONE' | 'ADD_LOYALTY_CARD_TO_WALLET' | 'LOYALTY_CARD_INFO') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Engin'
						case 'ADD_LOYALTY_CARD_TO_WALLET':
							return 'Bæta vildarkorti í veski'
						case 'LOYALTY_CARD_INFO':
							return 'Sýna upplýsingar um vildarkort'
						default:
							return String(v)
					}
				})(arg0)
		},
		Placement: {
			Title: () => 'Staðsetningar',
			Help: () =>
				'Staðsetning er efni þessarar herferðar á einni markaðsrás. Bættu við staðsetningu fyrir hverja rás sem á að sýna þessa herferð.',
			Add: () => 'Bæta við staðsetningu',
			Empty: () => 'Bættu við staðsetningu til að skilgreina hvað þessi herferð sýnir á rás.',
			Count: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'staðsetning', other: 'staðsetningar' }),
			Rank: () => 'Röð',
			RankHelp: () => 'Þegar margar herferðir eru virkar í einu birtist hærri röð fyrst í feedinu.',
			Delete: () => 'Fjarlægja staðsetningu',
			DeleteConfirm: () => 'Fjarlægja þessa staðsetningu? Efni hennar verður eytt.'
		},
		Layout: {
			Title: () => 'Feed-útlit',
			Help: () =>
				'Fasta uppbygging feeds þessarar rásar. Fastir blokkir (borðar, tenglar, aðskilnaðir) birtast alltaf og herferðarsvæðið markar hvar virku herferðarefni er skotið inn.',
			AddCampaignZone: () => 'Bæta við herferðarsvæði',
			CampaignZone: () => 'Herferðarsvæði',
			CampaignZoneHint: () => 'Virkar herferðir birtast hér',
			DrawerHint: () => 'Raðaðu föstu blokkunum og herferðarsvæðinu fyrir þessa rás',
			UnsavedConfirm: () => 'Þú ert með óvistaðar breytingar sem munu tapast. Halda áfram í feed-útlitið?',
			PreviewModeLayout: () => 'Útlit',
			PreviewModeLive: () => 'Lifandi feed',
			LivePreviewHint: () => 'Birta feedið sem viðskiptavinir sjá núna, þar á meðal virkar herferðir.',
			CheckoutPreviewHint: () =>
				'Það sem þessi útgönguskjár sýnir núna. Tímasettir bakgrunnar birtast aðeins á sínum tíma.'
		},
		Content: {
			Title: () => 'Efni',
			NewContent: () => 'Nýtt efni',
			NoContent: () => 'Ekkert efni enn',
			NoContentDescription: () => 'Búðu til efnisblokk, bættu henni svo við rásaskipulag til að virkja hana.',
			NoMatches: () => 'Ekkert efni passar',
			NoMatchesDescription: () => 'Ekkert efni passar við núverandi leit og síur.',
			ClearFilters: () => 'Hreinsa síur',
			ChannelFilter: () => 'Markaðsrás',
			TypeOption: (arg0: 'ALL' | 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'ALL':
							return 'Allt'
						case 'FEED':
							return 'Streymi í viðskiptavinaforriti'
						case 'CHECKOUT_BACKGROUND':
							return 'Greiðsluskjár'
						default:
							return String(v)
					}
				})(arg0),
			BlockCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('is', args.count, { one: 'blokk', other: 'blokkir' }),
			LayoutCount: (args: { count: number }) =>
				'Í ' + String(args.count) + ' ' + plural('is', args.count, { one: 'skipulagi', other: 'skipulögum' }),
			NotInLayout: () => 'Ekki í neinu skipulagi',
			DeleteConfirm: () => 'Eyða þessu efni? Það verður fjarlægt úr öllum rásaskipulögum.',
			DuplicateSuccess: () => 'Efni afritað',
			Blocks: () => 'Blokkir',
			BlocksHelp: () => 'Blokkir birtast ofan frá og niður í viðskiptaappinu, nákvæmlega í þessari röð.',
			SaveDraft: () => 'Vista sem drög',
			SaveAndPublish: () => 'Vista og birta',
			SaveSuccess: () => 'Breytingar vistaðar',
			PublishSuccess: () => 'Efni birt',
			UnpublishSuccess: () => 'Efni tekið úr birtingu',
			UnsavedChanges: () => 'Óvistaðar breytingar',
			DraftNotice: () => 'Þetta efni er drög og birtist ekki viðskiptavinum. Birtu það þegar þú ert tilbúin(n).',
			ExpiredTitle: () => 'Þetta efni er útrunnið',
			ExpiredNotice: (arg0: DateInput) =>
				'Þetta efni rann út ' +
				dateAndTimeFormatter('is', arg0) +
				' og birtist ekki viðskiptavinum. Gefðu því nýja tímasetningu til að keyra það aftur.',
			ExpiredSaveConfirm: () =>
				'Þetta efni er þegar útrunnið og helst því falið viðskiptavinum. Viltu samt vista það með núverandi tímasetningu?',
			SaveAnyway: () => 'Vista samt',
			ClearEndDate: () => 'Hreinsa lokadagsetningu',
			RunToday: () => 'Keyra í dag',
			NewFeedContent: () => 'Streymi í viðskiptavinaforriti',
			NewFeedContentHint: () => 'Borðar, myndalistar og fleira fyrir streymið í appinu',
			NewCheckoutBackground: () => 'Greiðsluskjár',
			NewCheckoutBackgroundHint: () => 'Ein mynd á öllum skjánum fyrir útgönguskjá sjálfsafgreiðslu',
			Format: (arg0: 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'FEED':
							return 'Streymi í viðskiptavinaforriti'
						case 'CHECKOUT_BACKGROUND':
							return 'Greiðsluskjár'
						default:
							return String(v)
					}
				})(arg0),
			BackgroundImage: () => 'Bakgrunnsmynd',
			BackgroundHelp: () =>
				'Fyllir allan útgönguskjá sjálfsafgreiðslu. Á skjánum fyrir pokaskoðun og útgöngu kemur hún í stað innbyggðu skilaboðanna, svo myndin sjálf þarf að segja viðskiptavininum hvað hann á að gera. Myndir á breiddina henta best.',
			BackgroundEmpty: () =>
				'Engin mynd enn. Veldu mynd úr markaðssafninu, annars birtist ekkert á útgönguskjánum.'
		},
		ContentLayout: {
			Title: () => 'Skipulag',
			Help: () =>
				'Raðaðu birtu efni fyrir rás. Þetta er streymið sem viðskiptavinir sjá, ofan frá og niður. Áætlað efni birtist aðeins á tímabili sínu.',
			SelectChannel: () => 'Rás',
			NoChannels: () => 'Búðu til markaðsrás áður en þú raðar skipulagi.',
			GoToChannels: () => 'Fara í markaðsrásir',
			AvailableTitle: () => 'Tiltækt efni',
			NoAvailable: () => 'Allt efni er þegar í þessu skipulagi.',
			InLayoutTitle: () => 'Í þessu skipulagi',
			Empty: () => 'Ekkert efni í þessu skipulagi enn. Bættu efni við af listanum til að byggja streymið.',
			Add: () => 'Bæta við skipulag',
			Remove: () => 'Fjarlægja úr skipulagi',
			Save: () => 'Vista skipulag',
			Saved: () => 'Skipulag vistað',
			PreviewTitle: () => 'Forskoðun á beinu streymi',
			SingleContentWarning: () =>
				'Þessi skjár birtist aðeins í fáeinar sekúndur svo aðeins fyrsta atriðið sést. Hafðu eitt atriði hér.',
			CheckoutHelp: () =>
				'Veldu bakgrunnana sem birtast á þessum útgönguskjá. Ef biðskjárinn hefur fleiri en einn skiptast þeir á; skjáirnir fyrir pokaskoðun og útgöngu sýna aðeins þann fyrsta, í stað innbyggðu skilaboðanna.',
			AvailableBackgroundsTitle: () => 'Tiltækir bakgrunnar',
			NoBackgrounds: () => 'Engir bakgrunnar enn. Búðu til einn til að birta hann á þessum skjá.',
			NewBackground: () => 'Nýr bakgrunnur',
			NewBackgroundTitle: () => 'Nýr bakgrunnur útgönguskjás',
			NewBackgroundDescription: () => 'Veldu mynd úr markaðssafninu. Hún er birt strax og bætt við þennan skjá.',
			NewBackgroundCreate: () => 'Búa til og bæta við',
			NewBackgroundCreated: () => 'Bakgrunni bætt við. Vistaðu skipulagið til að gera hann virkan.',
			WrongFormatOnCheckout: () =>
				'Efni fyrir streymi í viðskiptavinaforriti birtist ekki á útgönguskjánum. Fjarlægðu það og bættu við bakgrunni.',
			WrongFormatOnFeed: () =>
				'Bakgrunnar útgönguskjás birtast ekki í streyminu í appinu. Fjarlægðu hann úr þessu skipulagi.',
			RemoveFlaggedToSave: () => 'Fjarlægðu merktu atriðin til að vista skipulagið.'
		},
		Surface: {
			Label: () => 'Birtingarflötur',
			CustomerAppFeed: () => 'Streymi í viðskiptavinaforriti',
			CheckoutScreen: () => 'Greiðsluskjár'
		},
		ScreenState: {
			Label: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Sjálfgefið'
						case 'CHECKOUT_IDLE':
							return 'Bið'
						case 'CHECKOUT_BAG_CHECK':
							return 'Pokaeftirlit'
						case 'CHECKOUT_CLEARED':
							return 'Heimilt að fara'
						default:
							return String(v)
					}
				})(arg0),
			Hint: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Alltaf sýnt'
						case 'CHECKOUT_IDLE':
							return 'Á meðan beðið er eftir að viðskiptavinur skanni'
						case 'CHECKOUT_BAG_CHECK':
							return 'Þegar pokaeftirlit starfsmanns er nauðsynlegt'
						case 'CHECKOUT_CLEARED':
							return 'Þegar viðskiptavini er heimilt að fara'
						default:
							return String(v)
					}
				})(arg0)
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Pokaeftirlit nauðsynlegt',
			BagCheckBody: () => 'Starfsmaður kemur og klárar úttektina',
			ClearedTitle: () => 'Allt í lagi',
			ClearedBody: () => 'Þú mátt fara núna',
			Disclaimer: () => 'Áætluð forskoðun á útgönguskjánum.',
			FallbackHint: () => 'Enginn bakgrunnur valinn, svo skjárinn sýnir innbyggðu skilaboðin.'
		},
		LibraryPage: {
			NoAssets: () => 'Engar markaðseignir enn',
			NoAssetsDescription: () => 'Hladdu upp myndum, borðum og öðrum markaðsmyndum hér.',
			Filename: () => 'Skráarnafn',
			TableView: () => 'Töfluyfirlit',
			GalleryView: () => 'Myndayfirlit',
			Upload: () => 'Hlaða upp',
			SearchFilename: () => 'Leita eftir skráarnafni',
			ViewFullImage: () => 'Skoða alla myndina',
			CopyUrl: () => 'Afrita slóð',
			CopiedUrl: () => 'Slóð afrituð',
			DeleteAsset: () => 'Eyða eign',
			DeleteAssetConfirm: () => 'Eyða þessari eign? Því er ekki hægt að breyta til baka.',
			UploadAssets: () => 'Hlaða upp eignum',
			UploadDropzone: () => 'Dragðu og slepptu myndum hér, eða smelltu til að velja skrár',
			ChooseFiles: () => 'Velja skrár',
			Tags: () => 'Merki',
			UsedBy: () => 'Notað af',
			UsageFilter: () => 'Notkun',
			UsageUnused: () => 'Ónotað',
			UsageProduct: () => 'Vara',
			UsageProductGroup: () => 'Vöruhópur',
			UsageProductCategory: () => 'Vöruflokkur',
			UsageMarketingContent: () => 'Markaðsefni',
			UsageFeedLayout: () => 'Straumur í appi',
			ChannelFilter: () => 'Markaðsrás',
			ContentFilter: () => 'Notað af efni',
			ChannelNone: () => 'Engin rás',
			ContentNone: () => 'Ekkert efni',
			TagsPlaceholder: () => 'Sláðu inn merki og ýttu á Enter',
			Uploading: () => 'Hleður upp',
			EditTags: () => 'Breyta merkjum',
			NoTags: () => 'Engin merki',
			ManageTags: () => 'Stjórna merkjum',
			ManageTagsEmpty: () => 'Engin merki í safninu enn.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' eignir',
			CreateTag: () => 'Búa til merki',
			CreateTagPlaceholder: () => 'Sláðu inn merki og ýttu á Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Merkið „' + String(args.tag) + '“ búið til.',
			RenameTag: () => 'Endurnefna merki',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Sameina merkið „' +
				String(args.from) +
				'“ við „' +
				String(args.to) +
				'“ (' +
				String(args.count) +
				' eignir)? Gamla merkið verður fjarlægt.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Merki endurnefnt úr „' + String(args.from) + '“ í „' + String(args.to) + '“.',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjarlægja merkið „' + String(args.tag) + '“ af öllum eignum? Skrárnar eru ekki eyddar.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Merki fjarlægt af ' +
				String(args.count) +
				' ' +
				plural('is', args.count, { one: 'eign', other: 'eignum' }) +
				'.'
		}
	},
	Settings: {
		Title: () => 'Stillingar',
		Sidebar: {
			Profile: () => 'Notandi',
			Store: () => 'Verslun',
			Users: () => 'Notendur',
			SalesChannels: () => 'Sölurásir',
			PointOfSale: () => 'Sölustaður',
			ProductGroups: () => 'Vöruhópar',
			Exports: () => 'Útflutningar',
			Analytics: () => 'Greiningar',
			Companies: () => 'Fyrirtæki',
			CompanyCards: () => 'Fyrirtækjakort',
			Settlements: () => 'Uppgjör'
		},
		Profile: {
			Title: () => 'Notandi',
			EditTitle: () => 'Breyta notanda',
			PersonalInfo: () => 'Persónuupplýsingar',
			Preferences: () => 'Kjörstillingar',
			NamePlaceholder: () => 'Sláðu inn nafn',
			EmailPlaceholder: () => 'Sláðu inn netfang',
			UpdateSuccess: () => 'Notandi uppfærður',
			Edit: {
				Description: () => 'Breyta notandaupplýsingum'
			}
		},
		Users: {
			Title: () => 'Notendur',
			InviteUser: () => 'Búa til boð',
			InviteTitle: () => 'Búa til boð',
			InviteSuccess: () => 'Boðið var búið til',
			InviteSentTo: (args: { email: string }) => 'Boð sent til ' + String(args.email),
			SendInvite: () => 'Búa til boð',
			CopyInviteLink: () => 'Afrita boðstengil',
			DeleteUserDescription: (args: { email: string }) =>
				'Fjarlægja ' + String(args.email) + '? Viðkomandi getur ekki skráð sig inn á ný.',
			DeleteUserSuccess: () => 'Notanda fjarlægt',
			EditTitle: () => 'Breyta notanda',
			EditSuccess: () => 'Notandi uppfærður',
			DeleteInviteDescription: (args: { email: string }) => 'Fjarlægja boðið fyrir ' + String(args.email) + '?',
			DeleteInviteSuccess: () => 'Boði fjarlægt',
			Status: {
				Accepted: () => 'Samþykkt',
				Pending: () => 'Í bið',
				Expired: () => 'Útrunnið'
			},
			Type: {
				User: () => 'Notandi',
				Invite: () => 'Boð'
			},
			Column: {
				Type: () => 'Tegund'
			},
			Role: {
				Admin: () => 'Stjórnandi',
				User: () => 'Notandi'
			},
			Invite: {
				Description: () => 'Bjóða nýjum notanda í verslunina þína',
				EmailPlaceholder: () => 'Sláðu inn netfang',
				NamePlaceholder: () => 'Sláðu inn nafn',
				UserInfo: () => 'Notandaupplýsingar',
				UserAlreadyExists: (args: { email: string }) =>
					'Notandi með netfangið ' + String(args.email) + ' er þegar til'
			},
			Detail: {
				Title: () => 'Upplýsingar um notanda',
				AdminOnly: () => 'Aðeins stjórnendur geta skoðað boðsítu.'
			},
			SignInCredentials: {
				Title: () => 'Innskráningarauðkenni',
				Description: () =>
					'Stilltu innskráningarauðkenni og PIN sem notað er til að skrá sig inn á sjálfsafgreiðslu- og POS-stöðvar.',
				SignInId: () => 'Innskráningarauðkenni',
				SignInIdPlaceholder: () => 't.d. 1042',
				SignInIdHint: () =>
					'Aðeins tölur. Aðeins krafist fyrir suman búnað, svo sem sjálfsafgreiðslukassa. Skildu eftir autt ef þessi notandi skráir sig ekki inn á þann búnað.',
				Pin: () => 'PIN',
				PinSet: () => 'PIN er stillt',
				PinNotSet: () => 'Ekkert PIN stillt',
				NewPin: () => 'Nýtt PIN (6 tölustafir)',
				PinPlaceholder: () => 'Skildu eftir autt til að halda núverandi PIN',
				ClearPin: () => 'Hreinsa PIN',
				Save: () => 'Vista',
				SaveSuccess: () => 'Auðkenni uppfærð',
				SignInIdNumeric: () => 'Innskráningarauðkenni verður að vera tölulegt',
				SignInIdTaken: () => 'Innskráningarauðkenni er þegar í notkun',
				PinInvalid: () => 'PIN verður að vera nákvæmlega 6 tölustafir'
			}
		},
		SalesChannels: {
			Title: () => 'Sölurásir',
			CreateTitle: () => 'Búa til sölurásin',
			CreateSuccess: () => 'Sölurásin búin til',
			EditTitle: () => 'Breyta sölurásin',
			EditSuccess: () => 'Sölurásin uppfærð',
			Column: {
				CountryCode: () => 'Land',
				CurrencyCode: () => 'Gjaldmiðill',
				SalesChannelType: () => 'Tegund',
				FulfillmentProvider: () => 'Afhendingaraðili',
				AccessKeys: () => 'Aðgangslyklar',
				InventoryLocation: () => 'Birgðastaðsetning',
				Group: () => 'Hópur'
			},
			InventoryLocationNone: () => 'Engin',
			InventoryLocationOptionalHint: () =>
				'Valfrjálst. Tengdu rás við birgðastaðsetningu til að fylgjast með birgðum. Skildu eftir autt ef birgðir eru ekki notaðar.',
			SalesChannelTypeNone: () => 'Engin',
			GroupNone: () => 'Enginn',
			GroupOptionalHint: () => 'Valfrjálst. Úthlutaðu þessari rás í hóp til að flokka tengdar rásir saman.',
			Advanced: () => 'Ítarlegar stillingar',
			TypeOptionalHint: () =>
				'Valfrjálst. Úthlutaðu tegund aðeins til að flokka rásir sem deila afhendingar- eða forheimildastillingum. Skildu eftir sem Engin ef þú ert ekki viss.',
			StorefrontUrl: () => 'Vefslóð vefverslunar',
			StorefrontUrlHint: () =>
				'Valfrjálst. Grunnslóð vefverslunar þessarar sölurásar. Stilltu þetta til að Terminal posi birti QR kóða fyrir "Fá kvittun" eftir greiðslu; skildu eftir autt til að fela hann.',
			Groups: {
				Title: () => 'Sölurásarhópar',
				NavLabel: () => 'Hópar',
				CreateTitle: () => 'Búa til hóp',
				CreateSuccess: () => 'Hópur búinn til',
				EditTitle: () => 'Breyta hóp',
				EditSuccess: () => 'Hópur uppfærður',
				NamePlaceholder: () => 'Sláðu inn heiti hóps',
				Column: {
					Name: () => 'Heiti',
					MemberCount: () => 'Sölurásir'
				},
				Members: {
					Title: () => 'Sölurásir',
					Label: () => 'Sölurásir',
					Placeholder: () => 'Velja sölurásir',
					Empty: () => 'Engar sölurásir tengdar enn.',
					Assigned: () => 'Tengt',
					FilterUnassigned: () => 'Án hóps',
					SaveSuccess: () => 'Sölurásir uppfærðar',
					MoveWarning: {
						Title: () => 'Færa sölurásir milli hópa?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' af völdum sölurásum tilheyra öðrum hópi og verða færðar hingað: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Eyða hóp',
					Description: (args: { name: string }) =>
						'Ertu viss um að þú viljir eyða hópnum "' +
						String(args.name) +
						'"? Sölurásir hans verða aftengdar en ekki eytt.',
					SuccessToast: (args: { name: string }) => 'Hópnum ' + String(args.name) + ' var eytt.'
				}
			},
			Create: {
				BasicInfo: () => 'Grunnupplýsingar',
				Description: () => 'Búa til nýja sölurásin',
				NamePlaceholder: () => 'Sláðu inn heiti rásarinnar'
			},
			Edit: {
				ApiNotAvailable: () => 'API ekki tiltækt',
				NotImplemented: () => 'Ekki útfært ennþá'
			},
			Detail: {
				Title: () => 'Upplýsingar um sölurásin',
				AccessKeys: () => 'Aðgangslyklar',
				CreateAccessKey: () => 'Búa til aðgangslykil',
				CreateAccessKeySuccess: () => 'Aðgangslykill búinn til',
				PointOfSales: () => 'Sölustaðir',
				PointOfSalesDescription: () => 'Stjórna sölustöðum fyrir þessa rásin'
			},
			AccessKeyType: {
				Title: () => 'Tegund lykils',
				Publishable: () => 'Birtingarlykill',
				PublishableDescription: () => 'Fyrir notkun á biðlarahlið (posa, vefverslanir)',
				Api: () => 'API lykill',
				ApiDescription: () => 'Fyrir samþættingar á vefþjónahlið'
			},
			TokenCreated: {
				Title: () => 'API lykill búinn til',
				Description: () =>
					'Þennan tóka er aðeins hægt að skoða einu sinni. Vinsamlegast vistaðu hann áður en þessum glugga er lokað.',
				Token: () => 'API tóki'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Lykill'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Aðgangslyklar',
			NavLabel: () => 'Aðgangslyklar',
			Manage: () => 'Stjórna',
			Create: () => 'Búa til aðgangslykil',
			EditTitle: () => 'Breyta aðgangslykli',
			None: () => '—',
			SaveSuccess: () => 'Aðgangslykill uppfærður',
			DeleteConfirm: () => 'Eyða þessum aðgangslykli? Öpp sem nota hann hætta að virka.',
			DeleteSuccess: () => 'Aðgangslykli eytt',
			Column: {
				Key: () => 'Lykill',
				SalesChannels: () => 'Sölurásir',
				MarketingChannel: () => 'Markaðsrás'
			},
			Empty: {
				Title: () => 'Engir aðgangslyklar',
				Description: () => 'Búðu til birtanlegan lykil og tengdu hann við sölurásir og markaðsrás.'
			},
			Field: {
				SalesChannels: () => 'Sölurásir',
				SalesChannelsPlaceholder: () => 'Veldu sölurásir',
				SalesChannelsRequired: () => 'Veldu að minnsta kosti eina sölurás',
				MarketingChannel: () => 'Markaðsrás',
				MarketingChannelPlaceholder: () => 'Veldu markaðsrás',
				DevelopmentMode: () => 'Þróunarstilling',
				DevelopmentModeHint: () =>
					'Opnar þróunarverkfæri (stillingaskjái + stýringar á uppfærslum) í starfsmannaappinu fyrir posa sem eru paraðir við þennan lykil.'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Tegundir sölurása',
			NavLabel: () => 'Tegundir',
			CreateTitle: () => 'Búa til tegund sölurásar',
			CreateSuccess: () => 'Tegund sölurásar búin til',
			EditTitle: () => 'Breyta tegund sölurásar',
			EditSuccess: () => 'Tegund sölurásar uppfærð',
			Column: {
				FulfillmentProvider: () => 'Afhendingaraðili',
				PreauthorizationAmount: () => 'Forskráningarfjárhæð',
				AllowCompletingUnderpaidOrders: () => 'Leyfa lokun vangreiddra pantana'
			},
			FulfillmentProviderNone: () => 'Enginn',
			InvalidPreauthorizationAmount: () => 'Sláðu inn gilda fjárhæð sem er ekki neikvæð',
			AllowCompletingUnderpaidOrdersHint: () =>
				'Lokar pöntun jafnvel þótt greidd fjárhæð sé lægri en heildarupphæð. Aðeins fyrir flæði þar sem aðeins er hægt að reyna að taka greiðslu einu sinni (t.d. SandStar kælinn) og önnur tilraun er ekki möguleg.',
			Create: {
				NamePlaceholder: () => 'Sláðu inn heiti tegundar'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Mælieiningar',
			NavLabel: () => 'Mælieiningar',
			Description: () =>
				'Sameiginlegar einingar sem notaðar eru fyrir allar vörur. Hver vara velur úr þessum þegar pakkastærðum er bætt við.',
			CreateTitle: () => 'Stofna mælieiningu',
			CreateSuccess: () => 'Eining stofnuð',
			EditTitle: () => 'Breyta mælieiningu',
			EditSuccess: () => 'Eining uppfærð',
			Column: {
				Code: () => 'Kóði',
				Name: () => 'Heiti',
				Quantity: () => 'Sjálfgefið magn',
				Default: () => 'Sjálfgefið'
			},
			Code: () => 'Kóði',
			Name: () => 'Heiti',
			Quantity: () => 'Sjálfgefið magn',
			QuantityHint: () =>
				'Sameiginlegt magn í grunneiningum (t.d. er 6-pakki 6). Skildu eftir autt fyrir breytilega pakka.',
			DefaultEach: () => 'Sjálfgefin eining fyrir taldar vörur',
			DefaultWeight: () => 'Sjálfgefin eining fyrir vigtaðar vörur',
			DefaultEachBadge: () => 'Sjálfgefið · stk',
			DefaultWeightBadge: () => 'Sjálfgefið · vigt',
			CodePlaceholder: () => 't.d. PK6',
			NamePlaceholder: () => 't.d. 6-pakki',
			ManagedBySync: () => 'Stýrt af samstillingu',
			ManagedBySyncHint: () =>
				'Þessari einingu er stýrt af utanaðkomandi samþættingu og er ekki hægt að breyta hér.',
			InvalidCode: () => 'Kóði er áskilinn',
			InvalidQuantity: () => 'Magn verður að vera stærra en núll',
			InUse: () => 'Í notkun',
			Delete: {
				Title: () => 'Eyða einingu',
				Description: (args: { code: string }) =>
					'Eyða ' + String(args.code) + '? Þetta er ekki hægt að afturkalla.'
			}
		},
		PointOfSale: {
			Title: () => 'Sölustaður',
			CreateTitle: () => 'Búa til sölustað',
			CreateSuccess: () => 'Sölustaður búinn til',
			EditTitle: () => 'Breyta sölustað',
			EditSuccess: () => 'Sölustaður uppfærður',
			AllowedOperatingModesLabel: () => 'Leyfðir rekstrarhamir',
			SelectOperatingModes: () => 'Veldu rekstrarhami',
			OperatingMode: (arg0: 'ADMIN' | 'POS' | 'BAG_CHECK' | 'SCO' | 'INVENTORY' | 'TERMINAL' | 'CHECKOUT') =>
				(v => {
					switch (v) {
						case 'ADMIN':
							return 'Kerfisstjórn'
						case 'POS':
							return 'Sölustaður'
						case 'BAG_CHECK':
							return 'Pokaeftirlit'
						case 'SCO':
							return 'Sjálfsafgreiðsla'
						case 'INVENTORY':
							return 'Birgðir'
						case 'TERMINAL':
							return 'Sjálfsali'
						case 'CHECKOUT':
							return 'Útgöng'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamLevelLabel: () => 'Streymi tækjaloga',
			LogStreamLevel: (arg0: 'OFF' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG') =>
				(v => {
					switch (v) {
						case 'OFF':
							return 'Slökkt'
						case 'ERROR':
							return 'Villa'
						case 'WARN':
							return 'Viðvörun'
						case 'INFO':
							return 'Upplýsingar'
						case 'DEBUG':
							return 'Villuleit'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamIdLabel: () => 'Yfirskrifa ID streymis',
			LogStreamIdPlaceholder: () => 'Sjálfgefið auðkennið hér að ofan',
			LogStreamIdInvalidChars: () => 'Má ekki innihalda ":" eða "*"',
			LogStreamIdTooLong: () => 'Of langt',
			ForcedOrientationLabel: () => 'Þvinguð stefna',
			ForcedOrientationHint: () => 'Læsir skjá tækisins. Sjálfvirkt fylgir tækinu.',
			ForcedOrientationAutomatic: () => 'Sjálfvirkt',
			ForcedOrientation: (
				arg0: 'portrait' | 'portrait-reverse' | 'landscape' | 'landscape-reverse' | 'default'
			) =>
				(v => {
					switch (v) {
						case 'portrait':
							return 'Skammsnið'
						case 'portrait-reverse':
							return 'Skammsnið á hvolfi'
						case 'landscape':
							return 'Langsnið'
						case 'landscape-reverse':
							return 'Langsnið öfugt'
						case 'default':
							return 'Ólæst'
						default:
							return String(v)
					}
				})(arg0),
			SafeAreaInsetsLabel: () => 'Yfirskrifun á öruggu svæði (px)',
			SafeAreaInsetsHint: () =>
				'Fyrir tæki þar sem stýrikerfið skilar rangri stærð á öruggu svæði (t.d. alltaf 0). Skildu hlið eftir auða til að nota raunverulegt gildi.',
			SafeAreaInsetTop: () => 'Efst',
			SafeAreaInsetRight: () => 'Hægri',
			SafeAreaInsetBottom: () => 'Neðst',
			SafeAreaInsetLeft: () => 'Vinstri',
			Column: {
				Identifier: () => 'Auðkenni',
				AccessKeys: () => 'Aðgangslyklar',
				Group: () => 'Hópur'
			},
			GroupNone: () => 'Enginn',
			GroupOptionalHint: () =>
				'Valfrjálst. Úthlutaðu þessum sölustað í hóp til að flokka tengda sölustaði saman.',
			LinkSalesChannelButton: () => 'Tengja',
			LinkSalesChannelTitle: () => 'Tengja sölurás',
			LinkSalesChannelDescription: () => 'Bættu sölurás við þennan sölustað.',
			LinkSalesChannelSuccess: () => 'Sölurás tengd',
			SelectSalesChannel: () => 'Veldu sölurás',
			NoUnlinkedSalesChannels: () => 'Allar sölurásir eru þegar tengdar.',
			Create: {
				BasicInfo: () => 'Grunnupplýsingar',
				Description: () => 'Búa til nýjan sölustað',
				NamePlaceholder: () => 'Sláðu inn heiti staðarins',
				SelectSalesChannels: () => 'Velja sölurásir',
				IdentifierPlaceholder: () => 'Sláðu inn auðkenni'
			},
			Groups: {
				Title: () => 'Sölustaðahópar',
				NavLabel: () => 'Hópar',
				CreateTitle: () => 'Búa til hóp',
				CreateSuccess: () => 'Hópur búinn til',
				EditTitle: () => 'Breyta hóp',
				EditSuccess: () => 'Hópur uppfærður',
				NamePlaceholder: () => 'Sláðu inn heiti hóps',
				Column: {
					Name: () => 'Heiti',
					MemberCount: () => 'Sölustaðir'
				},
				Members: {
					Title: () => 'Sölustaðir',
					Label: () => 'Sölustaðir',
					Placeholder: () => 'Velja sölustaði',
					Empty: () => 'Engir sölustaðir tengdir enn.',
					Assigned: () => 'Tengt',
					FilterUnassigned: () => 'Án hóps',
					SaveSuccess: () => 'Sölustaðir uppfærðir',
					MoveWarning: {
						Title: () => 'Færa sölustaði milli hópa?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' af völdum sölustöðum tilheyra öðrum hópi og verða færðir hingað: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Eyða hóp',
					Description: (args: { name: string }) =>
						'Ertu viss um að þú viljir eyða hópnum "' +
						String(args.name) +
						'"? Sölustaðir hans verða aftengdir en ekki eytt.',
					SuccessToast: (args: { name: string }) => 'Hópnum ' + String(args.name) + ' var eytt.'
				}
			},
			Detail: {
				Title: () => 'Upplýsingar um sölustað',
				AccessKeys: () => 'Aðgangslyklar'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Lykill'
				}
			},
			ProductMenu: {
				Title: () => 'Vöruvalmynd',
				Description: () => 'Vöruhópar sem birtast á þessum sölustað.',
				EmptyTitle: () => 'Engir valmyndarhópar',
				EmptyDescription: () => 'Bættu við vöruhópum til að byggja valmyndina á þessum sölustað.',
				EditHeader: () => 'Vöruvalmynd',
				EditDescription: () =>
					'Bættu við vöruhópunum sem birtast á þessum sölustað og veldu hvernig hver þeirra birtist.',
				AddPlaceholder: () => 'Bæta við vöruhópi…',
				NoGroupsSelected: () => 'Engum vöruhópum bætt við enn.',
				IconLabel: () => 'Tákn',
				IconPlaceholder: () => 'Veldu tákn…',
				IconNone: () => 'Ekkert',
				IconUsesImageHint: () =>
					'Þessi hópur er með mynd sem birtist á valmyndinni í stað tákns. Breyttu myndinni á vöruhópnum.',
				IconNotUsedWhenIndividual: () => 'Ekki notað þegar vörur eru sýndar stakar á valmyndinni.',
				ShowIndividually: () => 'Sýna vörur stakar',
				ShowIndividuallyHint: () => 'Vörur birtast beint í valmyndinni í stað þess að vera inni í hópi.',
				ShownIndividuallyBadge: () => 'Vörur sýndar stakar',
				SaveSuccess: () => 'Valmynd uppfærð.',
				Icons: {
					ShoppingBag: () => 'Innkaupapoki',
					ShoppingCart: () => 'Innkaupakarfa',
					Coffee: () => 'Kaffi',
					CupSoda: () => 'Kaldur drykkur',
					Utensils: () => 'Tilbúinn matur',
					Pizza: () => 'Pítsa',
					Sandwich: () => 'Samloka',
					IceCream: () => 'Ís',
					Beer: () => 'Bjór',
					Wine: () => 'Vín',
					Bakery: () => 'Bakarí',
					Gift: () => 'Gjöf'
				}
			}
		},
		Devices: {
			Title: () => 'Tæki',
			NavLabel: () => 'Tæki',
			AccessKeysEmptyTitle: () => 'Engir aðgangslyklar',
			AccessKeysEmptyDescription: () =>
				'Búðu til aðgangslykla til að leyfa utanaðkomandi kerfum aðgang að þessu tæki.',
			Identifier: () => 'Auðkenni',
			LinkedPointOfSale: () => 'Sölustaður',
			NotLinked: () => 'Ekki tengt',
			MarketingChannel: () => 'Markaðsrás',
			NoMarketingChannel: () => 'Engin',
			MarketingChannelDescription: () =>
				'Kynningar á afgreiðsluskjá eru sóttar í gegnum þessa markaðsrás. Óháð tengingu við sölustað.',
			OperatingModes: () => 'Keyrsluhamir',
			StatusColumn: () => 'Staða',
			AccessKeysColumn: () => 'Aðgangslyklar',
			EmptyTitle: () => 'Engin tæki',
			EmptyDescription: () => 'Búðu til tæki til að byrja.',
			CreateTitle: () => 'Búa til tæki',
			CreateSuccess: () => 'Tæki búið til',
			EditTitle: () => 'Breyta tæki',
			NamePlaceholder: () => 't.d. Fremri kassi',
			IdentifierPlaceholder: () => 'Skildu eftir autt til að búa til sjálfkrafa',
			UpdateSuccess: () => 'Tæki uppfært',
			DeleteButton: () => 'Eyða tæki',
			DeleteConfirmTitle: () => 'Eyða þessu tæki?',
			DeleteConfirmDescription: () =>
				'Þetta fjarlægir tækið og afturkallar aðgangslykla þess. Þessu er ekki hægt að snúa við.',
			DeleteSuccess: () => 'Tæki eytt',
			LinkButton: () => 'Tengja sölustað',
			LinkTitle: () => 'Tengja við sölustað',
			LinkDescription: () =>
				'Tæki sem starfar sem sölustaður sækir sölurásir og pantanir í gegnum tengda sölustaðinn. Tenging kemur í stað tækis sem nú starfar sem þessi sölustaður.',
			LinkSuccess: () => 'Tæki tengt',
			SelectPointOfSale: () => 'Veldu sölustað',
			UnlinkButton: () => 'Aftengja',
			UnlinkConfirmTitle: () => 'Aftengja þennan sölustað?',
			UnlinkConfirmDescription: () => 'Tækið hættir að sækja sölurásir og pantanir þar til það er tengt aftur.',
			UnlinkSuccess: () => 'Sölustaður aftengdur',
			LinkedDevicesTitle: () => 'Tæki',
			LinkedDevicesEmpty: () => 'Engin tæki eru tengd við þennan sölustað.',
			LinkDeviceButton: () => 'Tengja tæki',
			LinkDeviceDisabledHint: () => 'Aftengdu núverandi tæki áður en þú tengir nýtt.',
			PointOfSaleOccupiedOption: (arg0: string) => String(arg0) + ' (tæki þegar tengt)',
			LinkDeviceTitle: () => 'Tengja tæki',
			LinkDeviceDescription: () => 'Veldu ótengt tæki til að starfa sem þessi sölustaður.',
			SelectDevice: () => 'Veldu tæki',
			NoUnlinkedDevices: () => 'Engin ótengd tæki í boði.',
			Config: {
				Default: () => 'Sjálfgefið',
				Enabled: () => 'Virkt',
				Disabled: () => 'Óvirkt',
				GeneralSection: () => 'Almennt',
				ScoSection: () => 'Sjálfsafgreiðsla',
				SoundsSection: () => 'Hljóð',
				LoggingSection: () => 'Skráning',
				DisplaySection: () => 'Skjár',
				CheckoutSection: () => 'Greiðsluhamur',
				DefaultPaymentMethod: () => 'Sjálfgefin greiðsluleið',
				ForcedOrientation: () => 'Þvinguð stefna',
				ForcedFormFactor: () => 'Þvinguð formgerð',
				Language: () => 'Tungumál',
				ShowPrinterDisconnected: () => 'Sýna viðvörun um aftengdan prentara',
				ProductListColumns: () => 'Dálkar í vörulista',
				BrowseEnabled: () => 'Vafra',
				AdjustQuantity: () => 'Breyta magni',
				ClearCart: () => 'Tæma körfu',
				ItemDeletion: () => 'Eyða vöru',
				OrderRestart: () => 'Endurræsa pöntun',
				Permission: (arg0: 'ENABLED' | 'STAFF_NEEDED' | 'DISABLED') =>
					(v => {
						switch (v) {
							case 'ENABLED':
								return 'Virkt'
							case 'STAFF_NEEDED':
								return 'Starfsmaður þarf'
							case 'DISABLED':
								return 'Óvirkt'
							default:
								return String(v)
						}
					})(arg0),
				SplitPercentHorizontal: () => 'Skipting vinnusvæðis, lárétt (%)',
				SplitPercentVertical: () => 'Skipting vinnusvæðis, lóðrétt (%)',
				ItemAddedSound: () => 'Hljóð þegar vöru er bætt við',
				ProductNotFoundSound: () => 'Hljóð þegar vara finnst ekki',
				AddToCartFailedSound: () => 'Hljóð þegar ekki tekst að bæta í körfu',
				PaymentSuccessSound: () => 'Hljóð við árangursríka greiðslu',
				PaymentFailedSound: () => 'Hljóð við misheppnaða greiðslu',
				InactivityThresholdSeconds: () => 'Þröskuldur aðgerðaleysis (sekúndur)',
				AbandonCountdownSeconds: () => 'Niðurtalning við yfirgefna körfu (sekúndur)',
				CoolerReadyTimeoutSeconds: () => 'Tímamörk tilbúins kælis (sekúndur)',
				CheckoutModeIdleTimeoutSeconds: () => 'Tímamörk aðgerðalauss skanna (sekúndur)',
				CheckoutModeTheme: () => 'Þemayfirskrift (JSON)',
				CheckoutModeThemeHint: () =>
					'Hlutur með valfrjálsum "colors" og "fonts". Skildu eftir autt fyrir grunnþemað.',
				InvalidJson: () => 'Verður að vera gilt JSON-hlutur'
			}
		},
		DeviceStatus: {
			Title: () => 'Staða tækis',
			Online: () => 'Á netinu',
			Offline: () => 'Ótengt',
			NeverReported: () => 'Þessi sölustaður hefur aldrei sent stöðu.',
			ReportedAt: () => 'Síðast tilkynnt',
			AppVersion: () => 'Útgáfa forrits',
			DisplayRuntimeVersion: () => 'Keyrsluútgáfa',
			ConfiguredRuntimeVersion: () => 'Stillt keyrsluútgáfa',
			Platform: () => 'Vettvangur',
			DeviceModel: () => 'Tegund tækis',
			NetworkType: () => 'Net',
			UpdateChannel: () => 'Uppfærslurás',
			UpdateId: () => 'Auðkenni uppfærslu',
			UpdateCreatedAt: () => 'Uppfærsla útgefin',
			UpdatePending: (args: { time: string }) => 'Sótt, bíður eftir aðgerðaleysi frá ' + String(args.time),
			OperatingMode: () => 'Rekstrarhamur',
			Health: () => 'Heilsa',
			PrinterConnected: () => 'Prentari',
			ScannerConnected: () => 'Skanni',
			PaymentTerminalReachable: () => 'Posavél',
			Connected: () => 'Tengt',
			Disconnected: () => 'Ótengt',
			Unknown: () => 'Óþekkt',
			Environment: () => 'Umhverfi (afmáð)',
			RefreshButton: () => 'Endurnýja stöðu',
			RefreshSuccess: () => 'Endurnýjun umbeðin',
			PushUpdateButton: () => 'Senda uppfærslu',
			PushUpdateSuccess: () => 'Uppfærsla send',
			RestartAppButton: () => 'Endurræsa app',
			RestartAppSuccess: () => 'Endurræsingarskipun send',
			RestartAppConfirmTitle: () => 'Endurræsa þetta app?',
			RestartAppConfirmDescription: () => 'Appið endurhleðst þegar posinn er í aðgerðaleysi.',
			LockKioskButton: () => 'Læsa kiosk',
			LockKioskSuccess: () => 'Læsing send',
			LockKioskOffline: () => 'Tækið er ótengt',
			LockKioskConfirmTitle: () => 'Læsa þessum kiosk?',
			LockKioskConfirmDescription: () => 'Kioskinn læsist strax, eins og starfsmaður hefði ýtt á Læsa á tækinu.',
			UnlockKioskButton: () => 'Aflæsa kiosk',
			UnlockKioskSuccess: () => 'Aflæsing kiosks send',
			UnlockKioskConfirmTitle: () => 'Aflæsa þennan kiosk?',
			UnlockKioskConfirmDescription: () =>
				'Kioskinn aflæsist strax án PIN starfsmanns. Gerðu þetta aðeins ef þú ert viss um að starfsfólk eigi að hafa aðgang.',
			PushUpdateDrawer: {
				Title: () => 'Senda forritsuppfærslu',
				Description: () =>
					'Láta þennan sölustað athuga og sækja uppfærslu. Hún sækist samstundis en endurræsist ekki fyrr en posinn er í aðgerðaleysi.',
				ChannelLabel: () => 'Yfirskrifa rás',
				ChannelPlaceholder: () => 'Skildu eftir autt til að nota núverandi rás',
				Submit: () => 'Senda uppfærslu'
			},
			Enrollment: {
				Title: () => 'Skráð tæki',
				NotEnrolled: () => 'Engin tæki er skráð fyrir þennan sölustað.',
				DeviceModel: () => 'Tegund tækis',
				Platform: () => 'Vettvangur',
				AppVersion: () => 'Útgáfa forrits',
				EnrolledAt: () => 'Skráð',
				Key: () => 'Lykill',
				EnrollButton: () => 'Skrá tæki',
				RevokeButton: () => 'Afturkalla',
				RevokeConfirmTitle: () => 'Afturkalla þetta tæki?',
				RevokeConfirmDescription: () =>
					'Tækið verður samstundis skráð út og þarf að para aftur til að fá aðgang.',
				RevokeSuccess: () => 'Tæki afturkallað',
				EnrollDrawer: {
					Title: () => 'Skrá tæki',
					Description: () => 'Sláðu inn 8 stafa pörunarkóðann sem birtist á tækinu.',
					CodeLabel: () => 'Pörunarkóði',
					CodePlaceholder: () => '1234 5678',
					LookupButton: () => 'Fletta upp tæki',
					LookupError: () => 'Þessi kóði er ógildur eða útrunninn.',
					ConfirmTitle: () => 'Skrá þetta tæki?',
					ConfirmDescriptionWithCurrent: (args: { device: string; currentDevice: string }) =>
						'Þetta gefur út nýjan lykil til "' +
						String(args.device) +
						'" og skráir samstundis út tækið sem er núna skráð ("' +
						String(args.currentDevice) +
						'").',
					ConfirmDescription: (args: { device: string }) =>
						'Þetta gefur út nýjan lykil til "' + String(args.device) + '".',
					Submit: () => 'Skrá',
					EnrollSuccess: () => 'Tæki skráð'
				}
			},
			Gms: {
				Title: () => 'Android tækjastjórnun (GMS)',
				ProviderEloview: () => 'EloView',
				ProviderGms: () => 'GMS',
				NotEnrolled: () => 'Þetta tæki er ekki skráð í GMS.',
				EnrollButton: () => 'Skrá tæki',
				EnrollSuccess: () => 'Skráning hafin',
				DeviceName: () => 'AMAPI tæki',
				State: () => 'Staða',
				AppliedState: () => 'Beitt staða',
				PolicyCompliant: () => 'Í samræmi við stefnu',
				NonComplianceReasons: () => 'Ástæður frávika',
				LastPolicySync: () => 'Síðasta stefnusamstilling',
				InstalledVersionCode: () => 'Uppsett útgáfunúmer',
				MinimumVersionCode: () => 'Lágmarks útgáfunúmer (fest)',
				HardwareModel: () => 'Vélbúnaðargerð',
				AndroidVersion: () => 'Android útgáfa',
				NoBoundDevice: () => 'Bíður eftir að tæki skrái sig…',
				Yes: () => 'Já',
				No: () => 'Nei',
				VersionUnpinned: () => 'Ekki fest (nýjasta tiltæka)',
				ApplyVersionButton: () => 'Beita',
				ApplyVersionSuccess: () => 'Lágmarksútgáfa uppfærð',
				WifiNetworks: () => 'Wi-Fi net',
				WifiAddNetwork: () => 'Bæta við neti',
				WifiSsid: () => 'Heiti nets (SSID)',
				WifiPassword: () => 'Lykilorð',
				WifiSecurityOpen: () => 'Opið (ekkert lykilorð)',
				WifiSecurityWpaPsk: () => 'Varið (WPA/WPA2)',
				WifiHidden: () => 'Falið net',
				WifiRemove: () => 'Fjarlægja',
				WifiSaveSuccess: () => 'Wi-Fi net vistuð',
				WifiEmpty: () => 'Engin net stillt',
				WifiPasswordKeepHint: () => 'Skildu eftir autt til að halda núverandi lykilorði',
				PlayTrack: () => 'Play-rás',
				TrackProduction: () => 'Framleiðsla (sjálfgefið)',
				ApplyTrackSuccess: () => 'Play-rás uppfærð',
				PolicyPreset: () => 'Stefnusnið',
				ApplyPresetSuccess: () => 'Stefnusnið virkjað',
				PolicyPresets: {
					ELO: () => 'Elo (söluturn + Elo OEMConfig)',
					ZEBRA: () => 'Zebra (söluturnslæsing)',
					MANAGED_APP: () => 'Stýrt app (setur upp merchant-appið)',
					DEBUGGING: () => 'Villuleit (virkjar ADB, hvaða tölva sem er)'
				},
				RebootButton: () => 'Endurræsa tæki',
				RebootSuccess: () => 'Endurræsingarskipun send',
				RebootConfirmTitle: () => 'Endurræsa þetta tæki?',
				RebootConfirmDescription: () => 'Tækið endurræsist samstundis.',
				UnenrollButton: () => 'Afskrá tæki',
				UnenrollSuccess: () => 'Tæki afskráð',
				UnenrollConfirmTitle: () => 'Afskrá þetta tæki?',
				UnenrollConfirmDescription: () =>
					'Þetta hreinsar tækið úr AMAPI flotanum — jafngildir verksmiðjustillingu. Það þarf að skrá það aftur frá grunni.',
				PolicyOverridesLabel: () => 'Hráar stefnu-yfirskriftir (JSON)',
				PolicyOverridesHint: () =>
					'Ítarlegt: hrá AMAPI stefnubrot, sameinað ofan á grunnsniðmátið. Aðeins fyrir forritara.',
				PolicyOverridesInvalidJson: () => 'Ógilt JSON',
				SaveOverridesButton: () => 'Vista yfirskriftir',
				ResetOverridesButton: () => 'Endurstilla',
				SaveOverridesSuccess: () => 'Stefnu-yfirskriftir vistaðar',
				EnrollDrawer: {
					Title: () => 'Skrá í GMS',
					Description: () =>
						'Býr til einnota skráningar-QR kóða. Verksmiðjustilla tækið, ýta 6 sinnum á velkomnaskjáinn og skanna kóðann með myndavélinni.',
					WifiSsidLabel: () => 'Wi-Fi net (valkvætt)',
					WifiPasswordLabel: () => 'Wi-Fi lykilorð (valkvætt)',
					PolicyPresetLabel: () => 'Stefnusnið',
					Submit: () => 'Búa til QR kóða',
					QrExpiresAt: (args: { time: string }) => 'Rennur út ' + String(args.time),
					Done: () => 'Lokið'
				}
			}
		},
		Exports: {
			Title: () => 'Útflutningar',
			Description: () => 'Flyttu gögn út í ýmis snið og kerfi',
			Export: () => 'Flytja út',
			PricerTitle: () => 'Pricer-vöruútflutningur',
			PricerSuccess: () => 'Pricer-útflutningur tókst',
			SalesChannel: () => 'UUID sölurásar',
			VismaTitle: () => 'Visma-útflutningur',
			VismaSuccess: () => 'Visma-útflutningur tókst',
			DigiScaleTitle: () => 'DigiScale-vöruútflutningur',
			DigiScaleSuccess: () => 'DigiScale-útflutningur tókst',
			SalesChannelUUIDs: () => 'UUID sölurása',
			GroupUUIDs: () => 'UUID vöruhópa',
			SAFTTitle: () => 'SAFT-útflutningur',
			SAFTSuccess: () => 'SAFT-útflutningur tókst',
			SAFTCashRegister: () => 'Peningakassi',
			SAFTFinancial: () => 'Fjármál'
		},
		Integrations: {
			Title: () => 'Tengingar',
			Description: () => 'Tengdu FastTrack við utanaðkomandi þjónustur.',
			Teya: {
				Name: () => 'Teya',
				Description: () => 'Tengdu Teya til að taka við kortagreiðslum á posum.',
				StatusConnected: () => 'Tengt',
				StatusDisconnected: () => 'Ekki tengt',
				StatusError: () => 'Þarf að tengja aftur',
				Connect: () => 'Tengja Teya',
				Reconnect: () => 'Tengja aftur',
				Disconnect: () => 'Aftengja',
				Connecting: () => 'Bíð eftir tengingu…',
				ConnectedAt: (args: { date: string }) => 'Tengt ' + String(args.date),
				Unavailable: () => 'Teya er ekki í boði fyrir þetta fyrirtæki.',
				ConnectSuccess: () => 'Teya tengt',
				DisconnectSuccess: () => 'Teya aftengt',
				DisconnectConfirm: () => 'Greiðslur hætta að fara á Teya posa þar til þú tengir aftur.',
				ConnectError: () => 'Ekki tókst að hefja Teya tengingu. Reyndu aftur.',
				PopupBlocked: () => 'Leyfðu sprettiglugga til að klára Teya tenginguna og reyndu aftur.',
				ConfigureStoreTerminals: () => 'Stilla verslun og posa',
				SelectStore: () => 'Veldu verslun',
				SelectTerminal: () => 'Veldu posa',
				SelectStoreFirst: () => 'Veldu verslun fyrst.',
				NoStores: () => 'Engar verslanir fundust fyrir þennan Teya reikning.',
				NoTerminals: () => 'Engir posar fundust fyrir þessa verslun.',
				ReconnectToConfigure: () => 'Tengdu Teya aftur til að stilla verslanir og posa.'
			},
			Rapyd: {
				SerialPlaceholder: () => 'Raðnúmer PAX tækis',
				Register: () => 'Skrá',
				Repair: () => 'Para aftur',
				WaitingForPairing: () => 'Virkjaðu pörun á posanum og bíddu…',
				Paired: () => 'Parað',
				SerialTooShort: () => 'Raðnúmerið verður að vera að minnsta kosti 10 stafir.',
				RegisterError: () => 'Ekki tókst að skrá tækið hjá Rapyd. Reyndu aftur.',
				ApiKeyRequiredFirst: () => 'Vistaðu API lykilinn í almennum stillingum áður en þú parar posa.'
			},
			Providers: {
				teya: {
					Name: () => 'Teya',
					Description: () => 'Taktu við kortagreiðslum á posunum þínum.'
				},
				nets: {
					Name: () => 'NETS',
					Description: () => 'Taktu við kortagreiðslum í gegnum NETS posa.'
				},
				'verifone-ecom': {
					Name: () => 'Verifone netverslun',
					Description: () => 'Taktu við kortagreiðslum á netinu í gegnum Verifone.'
				},
				'rapyd-cloudlink': {
					Name: () => 'Rapyd CloudLink',
					Description: () => 'Paraðu PAX kortaposa til að taka við greiðslum.'
				},
				'verifone-pos-cloud': {
					Name: () => 'Verifone POS Cloud',
					Description: () => 'Taktu við kortagreiðslum á Verifone skýjaposum.'
				},
				struct: {
					Name: () => 'Struct',
					Description: () => 'Samstilltu vörur úr Struct PIM.'
				}
			},
			Fields: {
				storeId: () => 'Auðkenni verslunar',
				terminalId: () => 'Auðkenni posa',
				eposInstanceId: () => 'ePOS auðkenni',
				environment: () => 'Umhverfi',
				merchantId: () => 'Auðkenni söluaðila',
				username: () => 'Notandanafn',
				password: () => 'Lykilorð',
				organizationId: () => 'Auðkenni fyrirtækis',
				entityId: () => 'Auðkenni einingar',
				apiKey: () => 'API lykill',
				apiUrl: () => 'API slóð',
				incomingWebhookEnabled: () => 'Móttökuvefkrókur virkur',
				incomingWebhookApiKey: () => 'API lykill móttökuvefkróks',
				secret: () => 'Leyndarmál',
				contractId: () => 'Samningsauðkenni',
				serialNumber: () => 'Raðnúmer',
				deviceToken: () => 'Tæki',
				authMode: () => 'Auðkenningarmáti',
				clientId: () => 'Client ID',
				clientSecret: () => 'Client secret',
				tokenUrl: () => 'Token slóð',
				baseUrl: () => 'Grunnslóð',
				poiId: () => 'POI auðkenni (posi)',
				saleId: () => 'Sale auðkenni',
				operatorId: () => 'Auðkenni starfsmanns',
				scope: () => 'Umfang',
				siteEntityId: () => 'Auðkenni einingar (site)',
				terminalSimulator: () => 'Posahermir'
			},
			Config: {
				Back: () => 'Til baka í tengingar',
				Global: () => 'Almennar stillingar',
				GlobalDescription: () => 'Grunnstillingar sem gilda alls staðar nema þeim sé breytt.',
				Overrides: () => 'Undantekningar',
				OverridesDescriptionSalesChannel: () => 'Breyttu stillingum fyrir tilteknar sölurásir.',
				OverridesDescriptionPointOfSale: () => 'Breyttu stillingum fyrir tiltekna posa.',
				AddOverride: () => 'Bæta við undantekningu',
				NoOverrides: () => 'Engar undantekningar',
				OverrideCount: (args: { count: number }) => String(args.count) + ' undantekningar',
				Configure: () => 'Stilla',
				Save: () => 'Vista',
				Saved: () => 'Stillingar vistaðar',
				SaveError: () => 'Ekki tókst að vista stillingar',
				TargetSalesChannel: () => 'Sölurás',
				TargetPointOfSale: () => 'Posi',
				SelectTarget: () => 'Veldu…',
				Edit: () => 'Breyta',
				Delete: () => 'Eyða',
				DeleteOverride: () => 'Eyða undantekningu',
				DeleteOverrideConfirm: () =>
					'Þessari undantekningu verður eytt og stillingar hennar fara aftur í almennar stillingar.',
				EditOverride: () => 'Breyta undantekningu',
				SecretSet: () => 'Stillt',
				SecretUnset: () => 'Ekki stillt',
				SecretPlaceholderSet: () => 'Skildu eftir autt til að halda núverandi',
				SecretPlaceholderUnset: () => 'Sláðu inn gildi'
			}
		},
		Billing: {
			Title: () => 'Reikningar',
			NavLabel: () => 'Reikningar',
			Description: () => 'Áskriftaráætlun þín hjá FastTrack.',
			EmptyTitle: () => 'Engin áætlun enn',
			EmptyDescription: () => 'Engin áskriftaráætlun hefur verið sett upp fyrir reikninginn þinn.',
			EmptyContactPrefix: () => 'Hafðu samband við',
			EmptyContactLink: () => 'þjónustuver',
			EmptyContactSuffix: () => 'til að byrja.',
			PlanHeading: () => 'Áskriftaráætlun',
			Note: () => 'Athugasemd',
			PlanDetails: () => 'Nánar um áætlun',
			AdditionalFees: () => 'Aukagjöld',
			Amount: () => 'Upphæð',
			Interval: () => 'Reikningstímabil',
			Monthly: () => 'Mánaðarlega',
			Yearly: () => 'Árlega',
			OneTime: () => 'Eitt skipti',
			Net: () => 'Nettó',
			Vat: () => 'VSK',
			VatRate: () => 'VSK-hlutfall',
			Total: () => 'Samtals',
			TotalsHeading: () => 'Samtölur',
			MonthlyTotal: () => 'Mánaðarlega samtals',
			YearlyTotal: () => 'Árlega samtals',
			OneTimeTotal: () => 'Eitt skipti samtals',
			AgreementHeading: () => 'Samningur',
			SelfServeIntro: () => 'Notkun þín á FastTrack lýtur eftirfarandi stefnum:',
			PolicyPrivacy: () => 'Persónuverndarstefna',
			PolicyTerms: () => 'Notkunarskilmálar',
			PolicyServices: () => 'Þjónustusamningur um vettvang',
			PolicyDpa: () => 'Vinnslusamningur um persónuupplýsingar',
			PolicySupport: () => 'Þjónustustefna',
			PolicyEula: () => 'Hugbúnaðarleyfi',
			EnterpriseNote: () => 'Þessi áætlun lýtur Master Services Agreement þínum við Stack.',
			EnterpriseServicesLink: () => 'Skoða þjónustusamning um vettvang',
			EnterpriseRefLabel: () => 'Tilvísun samnings',
			StartDate: () => 'Upphafsdagur',
			Status: () => 'Staða',
			StatusAccepted: () => 'Samþykkt',
			StatusPending: () => 'Bíður samþykkis',
			AcceptedBy: () => 'Samþykkt af',
			Accept: () => 'Samþykkja áætlun',
			AcceptConfirmTitle: () => 'Samþykkja áætlun',
			AcceptConfirmDescription: () =>
				'Með því að samþykkja staðfestir þú samþykki þitt á áskriftaráætluninni hér að ofan.',
			AcceptConfirmAction: () => 'Samþykkja',
			AcceptSuccess: () => 'Áætlun samþykkt',
			AcceptError: () => 'Ekki tókst að samþykkja áætlunina. Reyndu aftur.',
			LoadError: () => 'Ekki tókst að hlaða áskriftaráætlun.'
		}
	},
	PointOfSale: {
		Title: () => 'Sölustaður'
	},
	Profile: {
		Title: () => 'Notandi'
	},
	SalesChannels: {
		Title: () => 'Sölurásir'
	},
	Store: {
		Title: () => 'Verslun'
	},
	Users: {
		Title: () => 'Notendur'
	},
	CompanyCards: {
		Title: () => 'Fyrirtækjakort',
		CreateTitle: () => 'Stofna fyrirtækjakort',
		CreateSuccess: () => 'Fyrirtækjakort var stofnað',
		EditTitle: () => 'Breyta fyrirtækjakorti',
		UpdateSuccess: () => 'Fyrirtækjakort var uppfært',
		DeleteWarning: (args: { name: string }) =>
			'Þú ert að fara að eyða fyrirtækjakortinu ' +
			String(args.name) +
			'. Þessa aðgerð er ekki hægt að afturkalla.',
		Status: (arg0: 'ACTIVE' | 'INACTIVE') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Name: () => 'Nafn',
			CardNumber: () => 'Kortnúmer',
			Status: () => 'Status',
			Company: () => 'Fyrirtæki',
			Customer: () => 'Viðskiptavinur',
			Employee: () => 'Starfsmaður',
			ExternalId: () => 'Ytra auðkenni',
			CreatedAt: () => 'Stofnað'
		},
		Detail: {
			Title: () => 'Upplýsingar um fyrirtækjakort',
			Transactions: () => 'Færslur',
			ResetPin: {
				Title: () => 'Endurstilla PIN',
				Description: () => 'Ertu viss um að þú viljir endurstilla PIN-númer þessa korts?',
				Action: () => 'Endurstilla PIN'
			},
			ResetPinSuccess: () => 'PIN-númer var endurstillt'
		},
		Edit: {
			BasicInfo: () => 'Grunnupplýsingar',
			Description: () => 'Breyta upplýsingum um fyrirtækjakort',
			NamePlaceholder: () => 'Sláðu inn heiti korts',
			SelectCompany: () => 'Veldu fyrirtæki',
			SelectEmployee: () => 'Veldu starfsmann',
			ExternalIdPlaceholder: () => 'Sláðu inn ytra auðkenni (valfrjálst)'
		}
	},
	Settlements: {
		Title: () => 'Uppgjör',
		CreateTitle: () => 'Stofna uppgjör',
		CreateSuccess: () => 'Uppgjör var stofnað',
		MarkSettled: () => 'Merkja sem uppgert',
		MarkSettledSuccess: () => 'Uppgjör merkt sem uppgert',
		Column: {
			Company: () => 'Fyrirtæki',
			Period: () => 'Tímabil',
			TotalAmount: () => 'Heildarupphæð',
			TransactionCount: () => 'Færslur',
			SettledAt: () => 'Uppgert',
			CreatedAt: () => 'Stofnað'
		},
		Detail: {
			Title: () => 'Upplýsingar um uppgjör',
			Transactions: () => 'Færslur',
			Period: () => 'Tímabil',
			TotalAmount: () => 'Heildarupphæð',
			Status: () => 'Status',
			Settled: () => 'Uppgert',
			NotSettled: () => 'Ekki uppgert'
		},
		Create: {
			Title: () => 'Stofna uppgjör',
			Period: () => 'Tímabil',
			Description: () => 'Stofna nýtt uppgjör fyrir fyrirtækið',
			PeriodStart: () => 'Upphaf tímabils',
			PeriodEnd: () => 'Lok tímabils'
		}
	},
	Analytics: {
		Title: () => 'Greining',
		Overview: () => 'Yfirlit',
		Insights: () => 'Innsýn',
		SalesAnalytics: () => 'Sala',
		SalesAnalyticsDescription: () => 'Fylgstu með tekjum, pöntunum og söluhæstu vörum og rásum.',
		UserAnalytics: () => 'Notendur',
		UserAnalyticsDescription: () => 'Fylgstu með virkum notendum, nýskráningum og beiðnum um reikningseyðingu.',
		Basket: () => 'Karfa',
		ActiveUsers: () => 'Virkir notendur',
		NewSignups: () => 'Nýskráningar',
		ChurnedUsers: () => 'Eyðingarbeiðnir',
		ActiveUsersOverTime: () => 'Virkir notendur yfir tíma',
		NewSignupsOverTime: () => 'Nýskráningar yfir tíma',
		ChurnedUsersOverTime: () => 'Eyðingarbeiðnir yfir tíma',
		DeltaNew: () => 'Nýtt',
		Revenue: () => 'Tekjur',
		Orders: () => 'Pantanir',
		Growth: () => 'Vöxtur',
		TotalRevenue: () => 'Heildartekjur',
		AverageOrderValue: () => 'Meðalverðmæti pöntunar',
		Refunds: () => 'Endurgreiðslur',
		RevenueOverTime: () => 'Tekjur yfir tíma',
		TopProducts: () => 'Vinsælustu vörur',
		TopProductsByRevenue: () => 'Eftir tekjum',
		TopProductsByQuantity: () => 'Eftir fjölda',
		PaymentMethods: () => 'Greiðslumátar',
		RevenueByCategory: () => 'Tekjur eftir flokki',
		SalesByChannel: () => 'Sala eftir rásum',
		HourlyDistribution: () => 'Klukkutímadreifing',
		Day: () => 'Dagur',
		Week: () => 'Vika',
		Month: () => 'Mánuður',
		Quarter: () => 'Ársfj.',
		Year: () => 'Ár',
		NoData: () => 'Engin gögn tiltæk fyrir þetta tímabil',
		VsDate: (arg0: string) => 'm.v. ' + String(arg0),
		VsDateRange: (arg0: string, arg1: string) => 'm.v. ' + String(arg0) + ' – ' + String(arg1),
		InProgress: () => '(í gangi)',
		ComparePreviousPeriod: () => 'm.v. fyrra tímabil',
		CompareSamePeriodLastYear: () => 'm.v. sama tímabil í fyrra',
		CompareSpecific: {
			Day: () => 'm.v. tiltekinn dag',
			Week: () => 'm.v. tiltekna viku',
			Month: () => 'm.v. tiltekinn mánuð',
			Quarter: () => 'm.v. tiltekinn ársfjórðung',
			Year: () => 'm.v. tiltekið ár'
		},
		CompareNone: () => 'Enginn samanburður',
		AllChannels: () => 'Allar sölurásir',
		ChannelGroupOption: (arg0: string) => String(arg0) + ' (hópur)',
		CompareToChannel: () => 'Bera saman við rás',
		CompareToChannelNone: () => 'Enginn rásasamanburður',
		ComparisonModePeriod: () => 'Tímabil',
		ComparisonModeChannel: () => 'Rás',
		CompareByPeriod: () => 'Bera saman eftir tímabili',
		CompareByChannel: () => 'Bera saman eftir rás',
		PeriodLabel: (arg0: string) => 'Tímabil: ' + String(arg0),
		CompareBy: () => 'Bera saman eftir',
		ChannelsPageOf: (args: { current: number; total: number }) =>
			'Síða ' + String(args.current) + ' af ' + String(args.total),
		QuarterLabel: (args: { quarter: number; year: number }) => 'F' + String(args.quarter) + ' ' + String(args.year),
		JumpToPeriod: () => 'Fara á tímabil',
		CurrentPeriod: () => 'Núverandi tímabil',
		IntervalLabel: (arg0: string) => 'Bil: ' + String(arg0),
		Reports: {
			Title: () => 'Skýrslur',
			Description: () => 'Skoðaðu sölugögnin nánar, berðu saman tímabil og söluleiðir og fluttu þau út.',
			SalesGroup: () => 'Sala',
			ViewReport: () => 'Skoða skýrslu',
			Export: () => 'Flytja út CSV',
			Rows: () => 'Sundurliða eftir',
			RowsOption: {
				Hour: () => 'Eftir klukkustund',
				Day: () => 'Eftir degi',
				Week: () => 'Eftir viku',
				Month: () => 'Eftir mánuði',
				Product: () => 'Eftir vöru'
			},
			ColumnsPicker: () => 'Dálkar',
			GroupBy: () => 'Flokka eftir',
			GroupByOption: {
				Hour: () => 'Klukkustund',
				Day: () => 'Degi',
				Week: () => 'Viku',
				Month: () => 'Mánuði'
			},
			Total: () => 'Samtals',
			Revenue: {
				Title: () => 'Tekjur',
				Description: () => 'Tekjur, pantanir, endurgreiðslur og meðalvirði pantana yfir tíma.'
			},
			Products: {
				Title: () => 'Vörur',
				Description: () => 'Seldar einingar, heildarsala og pantanir eftir vöru.',
				FilterProducts: () => 'Allar vörur',
				GrossSalesNote: () =>
					'Vörusala er heildarupphæð lína fyrir endurgreiðslur og getur því vikið frá nettótekjum.'
			},
			Columns: {
				Period: () => 'Tímabil',
				Orders: () => 'Pantanir',
				Revenue: () => 'Tekjur',
				Refunds: () => 'Endurgreiðslur',
				AverageOrderValue: () => 'Meðalvirði pöntunar',
				Product: () => 'Vara',
				Quantity: () => 'Magn',
				GrossSales: () => 'Heildarsala',
				Share: () => 'Hlutfall'
			}
		},
		ChartLabels: {
			Revenue: () => 'Tekjur',
			Orders: () => 'Pantanir',
			Hour: () => 'Klukkutími',
			Quantity: () => 'Fjöldi'
		},
		BasketAnalysis: {
			Title: () => 'Körfugreining',
			Description: () => 'Sjáðu hvaða vörur og flokkar eru oft keypt saman.',
			AvgItemsPerOrder: () => 'Meðalfjöldi vara á pöntun',
			AvgUniqueProductsPerOrder: () => 'Meðalfjöldi einstakra vara á pöntun',
			OrdersAnalyzed: () => 'Greindar pantanir',
			ProductPairs: () => 'Vörupör',
			CategoryAffinity: () => 'Flokkatengsl',
			AnchorProduct: () => 'Grunnvara',
			AnchorProductPlaceholder: () => 'Leitaðu að vöru…',
			AllProducts: () => 'Allar vörur',
			Products: () => 'Vörur',
			ProductsPlaceholder: () => 'Sía vörur…',
			ExcludeProductsPlaceholder: () => 'Útiloka vörur…',
			AllProductsFilter: () => 'Allar vörur',
			Categories: () => 'Flokkar',
			CategoriesPlaceholder: () => 'Sía flokka…',
			ExcludeCategoriesPlaceholder: () => 'Útiloka flokka…',
			AllCategoriesFilter: () => 'Allir flokkar',
			SalesChannel: () => 'Sölurás',
			AllSalesChannels: () => 'Allar sölurásir',
			SalesChannelsSelected: (args: { count: number }) => String(args.count) + ' valdar',
			SalesChannelSearchPlaceholder: () => 'Leita í sölurásum…',
			PointOfSale: () => 'Sölustaður',
			AllPointsOfSale: () => 'Allir sölustaðir',
			MinSupport: () => 'Lágm. samtíðni',
			ProductA: () => 'Vara A',
			ProductB: () => 'Vara B',
			CategoryA: () => 'Flokkur A',
			CategoryB: () => 'Flokkur B',
			CoOccurrence: () => 'Samtíðni',
			Support: () => 'Support',
			Confidence: () => 'Confidence',
			Lift: () => 'Lift',
			SupportTooltip: () =>
				'Hversu algengt parið er: hlutfall allra pantana sem innihalda bæði A og B. Til dæmis þýðir 2% að 2 af hverjum 100 pöntunum innihéldu bæði.',
			ConfidenceTooltip: () =>
				'Hversu oft B lendir í körfunni þegar A er þar: hlutfall pantana með A sem innihalda einnig B. Til dæmis þýðir 40% að 4 af hverjum 10 pöntunum með A innihéldu líka B.',
			LiftTooltip: () =>
				'Hversu miklu oftar A og B eru keypt saman en búast mætti við af tilviljun. 1 þýðir engin tengsl, 2 þýðir tvöfalt oftar en búist var við og undir 1 þýðir að þau eru sjaldan keypt saman.',
			NoProductPairs: () => 'Engin vörupör ná lágmarks samtíðnimörkum á þessu tímabili.',
			NoCategoryPairs: () => 'Engin flokkapör ná lágmarks samtíðnimörkum á þessu tímabili.',
			NoAnchorPairs: () => 'Engin pör fundust fyrir valda vöru á þessu tímabili.',
			MetricPercent: (arg0: string) => String(arg0) + '%'
		}
	}
}

export const nb = {
	LocaleName: () => 'Norsk Bokmål',
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('nb', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('nb', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('nb', arg1),
		OnlyAmount: (arg0: TranslationAmount) => amountOnlyFormatter('nb', arg0)
	},
	Quantity: {
		Pieces: (arg0: number) => String(arg0) + 'x'
	},
	Weight: (arg0: Amount) => weightFormatter('nb', arg0),
	Date: {
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('nb', arg0),
		Short: (arg0: DateInput) => shortFormatter('nb', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('nb', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('nb', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('nb', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('nb', arg0),
		Ago: (arg0: DateInput) => agoFormatter('nb', arg0, () => locales['nb'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('nb', arg0)
	},
	TimeAgo: {
		JustNow: () => 'akkurat nå',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'minutt', other: 'minutter' }) + ' siden',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'time', other: 'timer' }) + ' siden',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'dag', other: 'dager' }) + ' siden',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'måned', other: 'måneder' }) + ' siden',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'år', other: 'år' }) + ' siden'
	},
	Enum: {
		PaymentStatus: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Venter'
					case 'UNPAID':
						return 'Ubetalt'
					case 'PAID':
						return 'Betalt'
					case 'PARTIALLY_PAID':
						return 'Delvis betalt'
					case 'REFUNDED':
						return 'Refundert'
					case 'PARTIALLY_REFUNDED':
						return 'Delvis refundert'
					case 'OVERPAID':
						return 'Overbetalt'
					default:
						return String(v)
				}
			})(arg0),
		OrderStatus: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Fullført'
					case 'CANCELED':
						return 'Kansellert'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentStatus: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Ikke oppfylt'
					case 'FULFILLED':
						return 'Oppfylt'
					case 'NOT_NEEDED':
						return 'Ikke nødvendig'
					case 'PARTIALLY_FULFILLED':
						return 'Delvis oppfylt'
					default:
						return String(v)
				}
			})(arg0),
		TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
			(v => {
				switch (v) {
					case 'FAILED':
						return 'Mislykket'
					case 'SUCCESS':
						return 'Vellykket'
					case 'PENDING':
						return 'Venter'
					default:
						return String(v)
				}
			})(arg0),
		PaymentProvider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN' | 'VERIFONE' | 'CASH') =>
			(v => {
				switch (v) {
					case 'RAPYD':
						return 'Rapyd'
					case 'MANUAL':
						return 'Manuell'
					case 'STRIPE':
						return 'Stripe'
					case 'ADYEN':
						return 'Adyen'
					case 'VERIFONE':
						return 'Verifone'
					case 'CASH':
						return 'Kontant'
					default:
						return String(v)
				}
			})(arg0),
		ProductStatus: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Utkast'
					case 'PUBLISHED':
						return 'Publisert'
					case 'ARCHIVED':
						return 'Arkivert'
					default:
						return String(v)
				}
			})(arg0),
		ThirdPartySource: (arg0: 'STRUCT' | 'LS_RETAIL' | 'BUSINESS_CENTRAL') =>
			(v => {
				switch (v) {
					case 'STRUCT':
						return 'Struct'
					case 'LS_RETAIL':
						return 'LS Retail'
					case 'BUSINESS_CENTRAL':
						return 'Business Central'
					default:
						return String(v)
				}
			})(arg0),
		CardExternalSource: (arg0: 'PASSCREATOR') =>
			(v => {
				switch (v) {
					case 'PASSCREATOR':
						return 'PassCreator'
					default:
						return String(v)
				}
			})(arg0),
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per enhet'
					case 'PRICE_EMBEDDED':
						return 'Pris innebygd'
					case 'PER_WEIGHT':
						return 'Per vekt'
					case 'WEIGHT_EMBEDDED':
						return 'Vekt innebygd'
					default:
						return String(v)
				}
			})(arg0),
		GiftCardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reservert'
					case 'REDEEMED':
						return 'Innløst'
					default:
						return String(v)
				}
			})(arg0),
		RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Venter'
					case 'APPLIED':
						return 'Brukt'
					default:
						return String(v)
				}
			})(arg0),
		CardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Blokkert'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentProvider: (arg0: 'MERCHANT_APP') =>
			(v => {
				switch (v) {
					case 'MERCHANT_APP':
						return 'Merchant app'
					default:
						return String(v)
				}
			})(arg0),
		UserStatus: (arg0: 'ACTIVE' | 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REJECTED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'PENDING':
						return 'Venter'
					case 'ACCEPTED':
						return 'Akseptert'
					case 'EXPIRED':
						return 'Utløpt'
					case 'REJECTED':
						return 'Avvist'
					default:
						return String(v)
				}
			})(arg0),
		UserRole: (arg0: 'DEVELOPER' | 'ADMIN' | 'USER') =>
			(v => {
				switch (v) {
					case 'DEVELOPER':
						return 'Utvikler'
					case 'ADMIN':
						return 'Admin'
					case 'USER':
						return 'Bruker'
					default:
						return String(v)
				}
			})(arg0)
	},
	General: {
		AppName: () => 'FastTrack',
		DefaultPageTitle: () => 'FastTrack-dashbord',
		Create: () => 'Opprett',
		Import: () => 'Importer',
		Export: () => 'Eksporter',
		NoResultsTitle: () => 'Ingen resultater funnet',
		Loading: () => 'Laster...',
		Selected: () => 'Valgt',
		Optional: () => 'Valgfritt',
		Save: () => 'Lagre',
		Continue: () => 'Fortsett',
		Cancel: () => 'Avbryt',
		Confirm: () => 'Bekreft',
		Delete: () => 'Slett',
		Edit: () => 'Rediger',
		Add: () => 'Legg til',
		Required: () => 'Påkrevd',
		Close: () => 'Lukk',
		Update: () => 'Oppdater',
		UnsavedChangesTitle: () => 'Ulagrede endringer',
		UnsavedChangesDescription: () => 'Du har ulagrede endringer. Er du sikker på at du vil forlate?',
		VerificationInstruction: (arg0: string) => 'Vennligst skriv inn ' + String(arg0) + ' for å bekrefte:',
		Copy: () => 'Kopier',
		Copied: () => 'Kopiert',
		AreYouSure: () => 'Er du sikker?',
		True: () => 'Ja',
		False: () => 'Nei',
		SearchPlaceholder: () => 'Søk...',
		InvalidFileType: (arg0: string, arg1: string) =>
			'Ugyldig filtype: ' + String(arg0) + ' (støttet: ' + String(arg1) + ')',
		DropImages: () => 'Slipp bilder for å laste opp',
		Multiple: () => 'Flere',
		Variable: () => 'Variabel',
		Enabled: () => 'Aktivert',
		Expired: () => 'Utgått',
		Scheduled: () => 'Planlagt',
		Active: () => 'Aktiv',
		Inactive: () => 'Inaktiv',
		ComingSoon: () => 'Kommer snart',
		ComingSoonDescription: () => 'Denne funksjonen er under utvikling.',
		None: () => 'Ingen',
		NotSet: () => 'Ikke satt',
		Unknown: () => 'Ukjent',
		GoBack: () => 'Gå tilbake',
		GoHome: () => 'Gå hjem',
		FeatureNotAvailable: () => 'Denne funksjonen er for øyeblikket ikke tilgjengelig',
		FeatureNotAvailableDescription: () => 'Kontakt brukerstøtte for å aktivere denne funksjonen',
		Dismiss: () => 'Lukk',
		TryAgain: () => 'Prøv igjen',
		All: () => 'Alle',
		AdvancedFilters: () => 'Filtre',
		ClearAll: () => 'Tøm',
		Apply: () => 'Bruk',
		CountSelected: (args: { count: number }) => String(args.count) + ' valgt',
		MultiSelectHint: (args: { count: number }) => String(args.count) + ' valgt • Hold Ctrl/Cmd for å velge flere',
		PickDate: () => 'Velg en dato',
		Created: () => 'Opprettet',
		View: () => 'Vis'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'Kunne ikke laste data',
		AnErrorOccurredWhileFetchingData: () => 'Det oppstod en feil under henting av data. Prøv igjen.'
	},
	Enums: {
		PaymentProvider: (
			arg0:
				| 'CASH'
				| 'ADYEN_TERMINAL'
				| 'ADYEN_ECOM'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS'
				| 'NETS_TERMINAL'
				| 'VERIFONE_CHECKOUT'
				| 'VERIFONE_ECOM'
				| 'STRAUMUR_ECOM'
				| 'LOYALTY_POINTS'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'VIPPS_MOBILEPAY'
				| 'RAPYD_CLOUDLINK'
				| 'RAPYD_APP_TO_APP'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
		) =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Kontant'
					case 'ADYEN_TERMINAL':
						return 'Adyen Terminal'
					case 'ADYEN_ECOM':
						return 'Adyen ECom'
					case 'BLIKK_ECOM':
						return 'Blikk ECom'
					case 'BLIKK_POS':
						return 'Blikk POS'
					case 'VIPPS':
						return 'Vipps'
					case 'NETS_TERMINAL':
						return 'Nets Terminal'
					case 'VERIFONE_CHECKOUT':
						return 'Verifone (checkout)'
					case 'VERIFONE_ECOM':
						return 'Verifone (Ecom)'
					case 'STRAUMUR_ECOM':
						return 'Straumur'
					case 'LOYALTY_POINTS':
						return 'Kundekort'
					case 'GIFT_CARD':
						return 'Gavekort'
					case 'BUSINESS_CARD':
						return 'Bedriftskort'
					case 'VIPPS_MOBILEPAY':
						return 'Vipps MobilePay'
					case 'RAPYD_CLOUDLINK':
						return 'Rapyd Cloudlink'
					case 'RAPYD_APP_TO_APP':
						return 'Rapyd App to App'
					case 'TEYA_POSLINK':
						return 'Teya POSLink'
					case 'VERIFONE_POS_CLOUD':
						return 'Verifone POS Cloud'
					default:
						return String(v)
				}
			})(arg0)
	},
	Fields: {
		Name: () => 'Navn',
		Status: () => 'Status',
		Type: () => 'Type',
		SalesChannel: () => 'Salgskanal',
		PointOfSale: () => 'Utsalgssted',
		PaymentStatus: () => 'Betalingsstatus',
		StartDate: () => 'Startdato',
		EndDate: () => 'Sluttdato',
		TaxRate: () => 'MVA-sats',
		TaxInclusive: () => 'Inkludert mva',
		Amount: () => 'Beløp',
		Price: () => 'Pris',
		Description: () => 'Beskrivelse',
		Groups: () => 'Grupper',
		Categories: () => 'Kategorier',
		Email: () => 'E-post',
		Password: () => 'Passord',
		ConfirmPassword: () => 'Bekreft passord',
		Role: () => 'Rolle',
		SKU: () => 'SKU',
		Currency: () => 'Valuta',
		CreatedAt: () => 'Opprettet',
		ExpiresAt: () => 'Utløper',
		UpdatedAt: () => 'Oppdatert',
		Language: () => 'Språk',
		Year: () => 'År',
		Month: () => 'Måned',
		ExternalId: () => 'Ekstern ID',
		FirstName: () => 'Fornavn',
		LastName: () => 'Etternavn',
		Phone: () => 'Telefon',
		SSN: () => 'Fødselsnummer',
		CardNumber: () => 'Kortnummer',
		Company: () => 'Bedrift',
		Customer: () => 'Kunde',
		Employee: () => 'Ansatt',
		FromTime: () => 'Fra',
		ToTime: () => 'Til',
		OrgNumber: () => 'Organisasjonsnummer',
		Enabled: () => 'Aktivert',
		Disabled: () => 'Deaktivert',
		CurrencyCode: () => 'Valutakode'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'Snarveier'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'Mandag',
		Tuesday: () => 'Tirsdag',
		Wednesday: () => 'Onsdag',
		Thursday: () => 'Torsdag',
		Friday: () => 'Fredag',
		Saturday: () => 'Lørdag',
		Sunday: () => 'Søndag'
	},
	Auth: {
		AcceptInvite: () => 'Godta invitasjon',
		AcceptInviteAndSetPassword: () => 'Godta invitasjon og sett passord',
		AcceptInviteDescription: () => 'Sett et passord for å godta invitasjonen.',
		ConfirmPasswordPlaceholder: () => 'Bekreft passordet ditt',
		InvalidInvite: () => 'Ugyldig invitasjon',
		InvalidInviteDescription: () => 'Denne invitasjonen er ugyldig eller har utløpt.',
		InviteAccepted: () => 'Invitasjon godtatt',
		InviteExpired: () => 'Denne invitasjonen er utløpt eller ikke lenger gyldig',
		PasswordPlaceholder: () => 'Skriv inn passord',
		PasswordsDoNotMatch: () => 'Passordene samsvarer ikke',
		SetPassword: () => 'Sett passord'
	},
	Error: {
		PageNotFound: () => 'Side ikke funnet',
		PageNotFoundDescription: () => 'Siden du leter etter finnes ikke.',
		SomethingWentWrong: () => 'Noe gikk galt',
		AnUnexpectedErrorOccurred: () =>
			'Det oppstod en uventet feil. Du kan prøve å gå tilbake, laste inn siden på nytt eller kontakte kundestøtte hvis problemet vedvarer.',
		ErrorDetails: () => 'Feildetaljer',
		ReloadPage: () => 'Last inn siden på nytt',
		ContactSupport: () => 'Kontakt support'
	},
	Campaigns: {
		Domain: () => 'Kampanjer'
	},
	CustomerGroups: {
		Domain: () => 'Kundegrupper',
		Title: () => 'Grupper',
		CreateTitle: () => 'Opprett kundegruppe',
		CreateSuccess: (args: { name: string }) => 'Kundegruppen ' + String(args.name) + ' ble opprettet.',
		EditTitle: () => 'Rediger kundegruppe',
		UpdateSuccess: () => 'Kundegruppen ble oppdatert',
		Empty: () => 'Ingen kundegrupper ennå',
		Members: () => 'Medlemmer',
		SelectCustomers: () => 'Velg kunder',
		Delete: {
			Title: () => 'Slett kundegruppe',
			Description: (args: { name: string }) =>
				'Er du sikker på at du vil slette kundegruppen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kundegruppen ' + String(args.name) + ' ble slettet.'
		},
		Column: {
			Name: () => 'Navn',
			Description: () => 'Beskrivelse',
			ExternalId: () => 'Ekstern ID',
			MemberCount: () => 'Medlemmer'
		},
		Field: {
			Name: () => 'Navn',
			Description: () => 'Beskrivelse',
			ExternalId: () => 'Ekstern ID',
			NamePlaceholder: () => 'Skriv inn et gruppenavn',
			DescriptionPlaceholder: () => 'Beskriv denne gruppen (valgfritt)',
			ExternalIdPlaceholder: () => 'Ekstern ID (valgfritt)'
		},
		Detail: {
			Title: () => 'Kundegruppe'
		}
	},
	DraftOrders: {
		Domain: () => 'Utkastbestillinger'
	},
	PriceLists: {
		Domain: () => 'Prislister'
	},
	Reservations: {
		Domain: () => 'Reservasjoner'
	},
	Login: {
		PageTitle: () => 'Logg inn',
		Title: () => 'Velkommen til FastTrack',
		Description: () => 'Logg inn for å få tilgang til dashbordet',
		Email: () => 'E-post',
		Password: () => 'Passord',
		LogIn: () => 'Logg inn',
		ForgotPassword: () => 'Glemt passord?',
		ForgotPasswordButton: () => 'Tilbakestill',
		Error: () => 'Kunne ikke logge inn',
		UnauthorizedError: () => 'Ugyldig e-post eller passord'
	},
	ResetPassword: {
		Title: () => 'Tilbakestill passord',
		Hint: () =>
			'Skriv inn e-postadressen din nedenfor, så sender vi deg instruksjoner om hvordan du tilbakestiller passordet ditt.',
		Email: () => 'E-post',
		SendResetInstructions: () => 'Send tilbakestillingsinstruksjoner',
		BackToLogin: () => 'Tilbake til innlogging',
		SuccessfulRequestTitle: () => 'E-post sendt',
		SuccessfulRequest: () =>
			'Vi har sendt deg en e-post som du kan bruke til å tilbakestille passordet ditt. Sjekk spam-mappen hvis du ikke har mottatt den etter noen minutter.',
		NewPassword: () => 'Nytt passord',
		NewPasswordHint: () => 'Velg et nytt passord nedenfor.',
		RepeatNewPassword: () => 'Gjenta nytt passord',
		ResetPassword: () => 'Tilbakestill passord',
		PasswordMismatch: () => 'Passordene samsvarer ikke',
		SuccessfulResetTitle: () => 'Passord tilbakestilt',
		SuccessfulReset: () => 'Vennligst logg inn på innloggingssiden.',
		InvalidEmail: () => 'Ugyldig e-post'
	},
	Sidebar: {
		Logout: () => 'Logg ut',
		ProfileSettings: () => 'Profilinnstillinger',
		BackToApp: () => 'Tilbake til appen',
		SearchPlaceholder: () => 'Søk eller hopp…',
		OpenSearch: () => 'Åpne søk',
		StoreScopeHint: () => 'Arbeidsområde (velger kommer senere)',
		Sections: () => 'Seksjoner',
		Individuals: () => 'Privatpersoner',
		Business: () => 'Bedrift',
		Content: () => 'Innhold',
		Messaging: () => 'Meldinger',
		Automation: () => 'Automatisering'
	},
	DeveloperFeedback: {
		Entry: () => 'Send tilbakemelding',
		Title: () => 'Tilbakemelding fra utvikler',
		Description: () => 'Dette blir en sak for utviklingsteamet.',
		TitleLabel: () => 'Tittel',
		BodyLabel: () => 'Detaljer',
		TypeLabel: () => 'Type',
		TypeSmallFix: () => 'Liten fiks',
		TypeBug: () => 'Feil',
		TypeEnhancement: () => 'Forbedring',
		TypeNote: () => 'Notat',
		Submit: () => 'Send',
		Created: () => 'Sak opprettet'
	},
	CommandPalette: {
		GroupQuick: () => 'Hurtighandlinger',
		InputHint: () => 'Søk i ordrer, produkter, kunder, samlinger…',
		FooterHint: () => 'Tips: skriv minst 2 tegn for å søke i butikken.',
		NoResults: () => 'Ingen treff. Prøv et annet søkeord.',
		QuickNewProduct: () => 'Opprett produkt',
		QuickNewPromotion: () => 'Opprett kampanje',
		QuickMarketingContent: () => 'Markedsføringsinnhold',
		QuickGoOrders: () => 'Gå til ordrer',
		QuickSettings: () => 'Innstillinger'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			String(args.start) + ' til ' + String(args.end) + ' av ' + String(args.total) + ' resultater',
		NoResults: () => '0 resultater',
		Previous: () => 'Forrige',
		Next: () => 'Neste'
	},
	Orders: {
		Title: () => 'Bestillinger',
		BagChecks: () => 'Vesketilsyn',
		Drafts: () => 'Utkast',
		StatusEnum: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Pending'
					case 'UNPAID':
						return 'Unpaid'
					case 'PAID':
						return 'Paid'
					case 'PARTIALLY_PAID':
						return 'Partially paid'
					case 'REFUNDED':
						return 'Refunded'
					case 'PARTIALLY_REFUNDED':
						return 'Partially refunded'
					case 'OVERPAID':
						return 'Overpaid'
					default:
						return String(v)
				}
			})(arg0),
		OrderCanceled: () => 'Bestilling kansellert',
		AdvancedFilters: () => 'Ordrefiltre',
		FulfillmentStatusEnum: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Not fulfilled'
					case 'FULFILLED':
						return 'Fulfilled'
					case 'NOT_NEEDED':
						return 'Not needed'
					case 'PARTIALLY_FULFILLED':
						return 'Partially fulfilled'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Order: () => 'Bestilling',
			Date: () => 'Dato',
			SalesChannel: () => 'Salgskanal',
			PaymentStatus: () => 'Betalingsstatus',
			Total: () => 'Totalbeløp',
			FulfillmentStatus: () => 'Oppfyllingsstatus',
			PointsEarned: () => 'Opptjente poeng',
			PointsUsed: () => 'Brukte poeng'
		},
		Totals: {
			Header: () => 'Oversikt - I dag',
			Orders: () => 'Bestillinger',
			Total: () => 'Inntekt',
			Average: () => 'Gjennomsnittlig bestilling',
			UpdatedAt: (arg0: DateInput) => 'Oppdatert ' + shortDateAndTimePreciseFormatter('nb', arg0)
		},
		Filters: {
			MinAmount: () => 'Min. beløp',
			MaxAmount: () => 'Maks. beløp',
			FromDate: () => 'Fra dato',
			ToDate: () => 'Til dato'
		},
		Refund: {
			Title: () => 'Refunder',
			Amount: () => 'Beløp',
			Note: () => 'Notat',
			AmountCannotBeEmpty: () => 'Beløp kan ikke være tomt',
			AmountMustBeGreaterThanZero: () => 'Beløp må være større enn 0',
			AmountMustBeLessThanRefundableAmount: (arg0: TranslationAmount) =>
				'Beløp må være mindre enn refunderbart beløp (' + amountFormatter('nb', arg0) + ')',
			Description: () =>
				'Velg varelinjene som skal refunderes, juster antall og/eller angi et egendefinert beløp.',
			ItemsSectionTitle: () => 'Varelinjer',
			CustomAmountSectionTitle: () => 'Egendefinert beløp',
			CustomAmountLabel: () => 'Tilleggsbeløp',
			CustomAmountOnlyLabel: () => 'Refusjonsbeløp',
			CustomAmountHint: () => 'Legg eventuelt til et egendefinert beløp i tillegg til de valgte varene.',
			RefundableAmount: () => 'Refunderbart beløp',
			RefundTotal: () => 'Total refusjon',
			AlreadyRefunded: (args: { quantity: number; total: number }) =>
				'Refundert ' + String(args.quantity) + ' av ' + String(args.total),
			PromotionLocked: () => 'Del av en kampanje — bruk et egendefinert beløp i stedet.',
			Restock: () => 'Legg returnerte enheter tilbake i lager',
			NothingToRefund: () => 'Denne ordren har ingenting igjen å refundere.',
			NoRefundableItems: () => 'Ingen varelinjer er tilgjengelige for varebasert refusjon.',
			SelectSomething: () => 'Velg minst én vare eller angi et egendefinert beløp.',
			ExceedsRefundable: () => 'Total refusjon overstiger refunderbart beløp.',
			RefundEntireOrder: (arg0: TranslationAmount) =>
				'Refunder hele ordren (' + amountFormatter('nb', arg0) + ')',
			SelectAll: () => 'Velg alle',
			ConfirmTitle: () => 'Refundere denne ordren?',
			ConfirmWarning: (args: { total: TranslationAmount }) =>
				'Dette refunderer ' +
				amountFormatter('nb', args.total) +
				' til kunden. Refusjoner er permanente og kan ikke angres eller avbrytes når de først er startet.',
			Submit: () => 'Refunder',
			Success: () => 'Refusjon startet',
			Error: () => 'Kunne ikke starte refusjon'
		},
		Payment: {
			CreateRefundWrongQuantity: (args: { number: string }) =>
				'Antall bør være et tall mellom 0 og ' + String(args.number)
		}
	},
	OrderDetail: {
		Title: (arg0: string) => 'Bestilling #' + String(arg0),
		OnDateFromSalesChannel: (args: { date: string; salesChannel: string }) =>
			String(args.date) + ' fra ' + String(args.salesChannel),
		OnDateFromPointOfSale: (args: { date: string; salesChannel: string; pointOfSale: string }) =>
			String(args.date) + ' fra ' + String(args.salesChannel) + ' (' + String(args.pointOfSale) + ')',
		Status: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Fullført'
					case 'CANCELED':
						return 'Kansellert'
					default:
						return String(v)
				}
			})(arg0),
		CancelWarning: (args: { id: string }) =>
			'Du er i ferd med å kansellere bestillingen ' + String(args.id) + '. Denne handlingen kan ikke angres.',
		OpenOrderDetails: () => 'Åpne bestillingsdetaljer',
		Items: () => 'Varer',
		Transactions: () => 'Transaksjoner',
		Summary: {
			Title: () => 'Sammendrag',
			EditOrder: () => 'Rediger bestilling',
			OpenReceipt: () => 'Åpne kvittering',
			ItemTotal: () => 'Totalt varer',
			TaxTotal: () => 'Totalt mva',
			Total: () => 'Totalt',
			GiftCardTotal: () => 'Totalt gavekort',
			PointsEarned: () => 'Opptjente lojalitetspoeng',
			PaidTotal: () => 'Totalt betalt',
			OutstandingAmount: () => 'Utestående beløp',
			Discount: () => 'Rabatt',
			Refunded: () => 'Refundert'
		},
		Receipt: {
			FailedToLoad: () => 'Kunne ikke laste kvittering',
			Redirecting: () => 'Videresender til kvittering...',
			Loading: () => 'Laster kvittering...'
		},
		Payment: {
			Title: () => 'Betalinger',
			Status: (
				arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'OVERPAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'
			) =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Venter'
						case 'UNPAID':
							return 'Ubetalt'
						case 'PAID':
							return 'Betalt'
						case 'PARTIALLY_PAID':
							return 'Delvis betalt'
						case 'OVERPAID':
							return 'Overbetalt'
						case 'REFUNDED':
							return 'Refundert'
						case 'PARTIALLY_REFUNDED':
							return 'Delvis refundert'
						default:
							return String(v)
					}
				})(arg0),
			TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
				(v => {
					switch (v) {
						case 'FAILED':
							return 'Mislyktes'
						case 'SUCCESS':
							return 'Vellykket'
						case 'PENDING':
							return 'Venter'
						default:
							return String(v)
					}
				})(arg0),
			Provider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN') =>
				(v => {
					switch (v) {
						case 'RAPYD':
							return 'Rapyd'
						case 'MANUAL':
							return 'Manual'
						case 'STRIPE':
							return 'Stripe'
						case 'ADYEN':
							return 'Adyen'
						default:
							return String(v)
					}
				})(arg0),
			PaymentWithSequenceNumber: (args: { sequenceNumber: string }) => 'Betaling #' + String(args.sequenceNumber),
			RefundWithSequenceNumber: (args: { sequenceNumber: string }) =>
				'Refundering #' + String(args.sequenceNumber),
			TotalPaidByCustomer: () => 'Totalt betalt av kunde',
			TotalPending: () => 'Totalt ventende',
			Refund: () => 'Refunder'
		},
		SandStar: {
			Title: () => 'SandStar cooler',
			CloudReview: () => 'Skygjennomgang',
			MachineName: () => 'Maskin',
			OrderNo: () => 'Ordrenummer',
			AbnormalReason: () => 'Avviksårsak',
			Video: () => 'Video',
			NoVideo: () => 'Ingen video'
		}
	},
	Products: {
		Title: () => 'Produkter',
		Library: () => 'Bibliotek',
		Status: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Utkast'
					case 'PUBLISHED':
						return 'Publisert'
					case 'ARCHIVED':
						return 'Arkivert'
					default:
						return String(v)
				}
			})(arg0),
		BarcodeType: () => 'Strekkodetype',
		ExportTitle: () => 'Eksporter produkter',
		AdvancedFilters: () => 'Produktfiltre',
		NoAdvancedFiltersYet: () => 'Ingen avanserte filtre er tilgjengelige for produkter ennå.',
		OpenProductDetails: () => 'Åpne produktdetaljer',
		LibraryPage: {
			NoAssets: () => 'Ingen produktbilder ennå',
			NoAssetsDescription: () => 'Last opp produktbilder her for å gjenbruke dem på tvers av produktene dine.',
			Filename: () => 'Filnavn',
			TableView: () => 'Tabellvisning',
			GalleryView: () => 'Gallerivisning',
			Upload: () => 'Last opp',
			SearchFilename: () => 'Søk etter filnavn',
			ViewFullImage: () => 'Vis hele bildet',
			CopyUrl: () => 'Kopier URL',
			CopiedUrl: () => 'URL kopiert',
			DeleteAsset: () => 'Slett ressurs',
			DeleteAssetConfirm: () => 'Slett denne ressursen? Det kan ikke angres.',
			UploadAssets: () => 'Last opp ressurser',
			UploadDropzone: () => 'Dra og slipp bilder her, eller klikk for å velge filer',
			ChooseFiles: () => 'Velg filer',
			Tags: () => 'Etiketter',
			UsedBy: () => 'Brukt av',
			UsageFilter: () => 'Bruk',
			UsageUnused: () => 'Ubrukt',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgruppe',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Markedsføringsinnhold',
			UsageFeedLayout: () => 'Kundeapp-feed',
			ChannelFilter: () => 'Markedsføringskanal',
			ContentFilter: () => 'Brukt av innhold',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Uten innhold',
			TagsPlaceholder: () => 'Skriv en etikett og trykk Enter',
			Uploading: () => 'Laster opp',
			EditTags: () => 'Rediger etiketter',
			NoTags: () => 'Ingen etiketter',
			ManageTags: () => 'Administrer etiketter',
			ManageTagsEmpty: () => 'Ingen etiketter i biblioteket ennå.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' ressurser',
			CreateTag: () => 'Opprett etikett',
			CreateTagPlaceholder: () => 'Skriv en etikett og trykk Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Etiketten «' + String(args.tag) + '» ble opprettet.',
			RenameTag: () => 'Gi etikett nytt navn',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Slå sammen etiketten «' +
				String(args.from) +
				'» med «' +
				String(args.to) +
				'» (' +
				String(args.count) +
				' ressurser)? Den gamle etiketten fjernes.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Etikett omdøpt fra «' + String(args.from) + '» til «' + String(args.to) + '».',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjerne etiketten «' + String(args.tag) + '» fra alle ressurser? Filene slettes ikke.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Etikett fjernet fra ' +
				String(args.count) +
				' ' +
				plural('nb', args.count, { one: 'ressurs', other: 'ressurser' }) +
				'.'
		},
		Column: {
			Title: () => 'Tittel',
			Status: () => 'Status',
			PricingMethod: () => 'Prismetode',
			SalesChannels: () => 'Salgskanaler'
		},
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per enhet'
					case 'PRICE_EMBEDDED':
						return 'Pris innebygd'
					case 'PER_WEIGHT':
						return 'Per vekt'
					case 'WEIGHT_EMBEDDED':
						return 'Vekt innebygd'
					default:
						return String(v)
				}
			})(arg0),
		Export: {
			Description: () => 'Eksporter produkter til en CSV-fil.',
			Download: () => 'Last ned',
			Error: () => 'Kunne ikke eksportere produkter',
			Format: () => 'Format',
			NoDataError: () => 'Ingen data å eksportere',
			ProductCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'produkt', other: 'produkter' }),
			Success: () => 'Produkter eksportert'
		},
		Import: {
			Header: () => 'Importer produktliste',
			UploadLabel: () => 'Importer produkter',
			UploadHint: () => 'Dra og slipp en CSV-fil eller klikk for å laste opp',
			Description: () => 'Importer produkter ved å oppgi en CSV-fil i et forhåndsdefinert format',
			Template: {
				Title: () => 'Usikker på hvordan du ordner listen din?',
				Description: () => 'Last ned malen nedenfor for å sikre at du følger riktig format.'
			},
			Upload: {
				Title: () => 'Last opp en CSV-fil',
				Description: () =>
					'Gjennom import kan du legge til eller oppdatere produkter. For å oppdatere eksisterende produkter vil inndataene matches med ekstern ID, SKU eller strekkode. Du vil bli bedt om bekreftelse før vi importerer produkter.',
				Preprocessing: () => 'Forbehandler...',
				Importing: () => 'Importerer produkter...',
				ProductsToCreate: () => 'Produkter vil bli opprettet',
				ProductsToUpdate: () => 'Produkter vil bli oppdatert',
				ProductsCreated: () => 'Produkter opprettet',
				ProductsUpdated: () => 'Produkter oppdatert',
				ProductsErrored: () => 'Produkter med feil',
				Errors: {
					Title: () => 'Feil',
					Description: (args: { count: number; rows: number }) =>
						String(args.count) +
						' ' +
						plural('nb', args.count, { one: 'feil', other: 'feil' }) +
						' i ' +
						String(args.rows) +
						' ' +
						plural('nb', args.rows, { one: 'rad', other: 'rader' }),
					Row: () => 'Rad',
					Column: () => 'Kolonne',
					Message: () => 'Melding'
				}
			},
			Success: () => 'Import fullført!'
		}
	},
	Product: {
		Header: (arg0: string) => 'Produkt ' + String(arg0),
		EditHeader: () => 'Rediger produkt',
		EditSuccessToast: (args: { title: string }) => 'Produkt ' + String(args.title) + ' ble oppdatert.',
		CreateTitle: () => 'Opprett produkt',
		Title: () => 'Tittel',
		Subtitle: () => 'Undertittel',
		Description: () => 'Beskrivelse',
		PricingMethodTitle: () => 'Prismetode',
		Overview: () => 'Oversikt',
		ExternalId: () => 'Ekstern ID',
		ExternalSource: () => 'Ekstern kilde',
		ManagedExternally: (args: { source: string }) => 'Dette produktet administreres av ' + String(args.source),
		Sku: () => 'SKU',
		Variants: () => 'Varianter',
		DeleteWarning: (args: { title: string }) =>
			'Du er i ferd med å slette produktet ' + String(args.title) + '. Denne handlingen kan ikke angres.',
		Create: {
			Title: () => 'Opprett produkt'
		},
		Media: {
			Title: () => 'Medier',
			Upload: () => 'Last opp',
			ChooseFromLibrary: () => 'Velg fra bibliotek',
			LibraryPickerTitle: () => 'Legg til fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilder i biblioteket ennå.',
			LibraryPickerAllAttached: () => 'Alle bilder fra biblioteket er allerede på dette produktet.',
			AddImageSuccessToast: () => 'Bilde lagt til',
			DeleteImageLabel: () => 'Slett bilde',
			DownloadImageLabel: () => 'Last ned bilde',
			SetPrimaryLabel: () => 'Velg som hovedbilde',
			AlreadyPrimaryLabel: () => 'Hovedbilde',
			PrimaryBadge: () => 'Hovedbilde',
			ProcessingBadge: () => 'Behandler…',
			UploadingLabel: (args: { percent: number }) => 'Laster opp… ' + String(args.percent) + '%',
			UploadSuccessToast: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'bilde', other: 'bilder' }) + ' lastet opp',
			UploadFailedToast: () => 'Kunne ikke laste opp bilde',
			DeleteSuccessToast: () => 'Bilde slettet',
			SetPrimarySuccessToast: () => 'Hovedbilde oppdatert',
			EmptyState: {
				Header: () => 'Ingen bilde ennå',
				Description: () =>
					'Dra og slipp bilder her, eller legg til et bilde på produktet for å vise det i nettbutikken.',
				Action: () => 'Legg til media'
			}
		},
		Organization: {
			Header: () => 'Organisasjon'
		},
		Pricing: {
			Title: () => 'Prising',
			VariablePrice: () => 'Variabel pris',
			Price: () => 'Pris',
			PriceWithTax: () => 'Pris inkl. mva',
			PriceWithoutTax: () => 'Pris ekskl. mva',
			Enabled: () => 'Aktivert',
			InvalidTaxRate: (args: { taxRate: string }) => 'Ugyldig MVA-sats: ' + String(args.taxRate),
			NoPricesConfigured: () => 'Ingen priser konfigurert',
			Target: () => 'Gjelder for',
			Group: () => 'Gruppe',
			Channel: () => 'Salgskanal',
			GroupDefault: () => 'Gruppestandard',
			ChannelOverride: () => 'Kanaloverstyring',
			AddOverride: () => 'Legg til kanaloverstyring',
			SelectOverrideChannel: () => 'Velg en salgskanal å overstyre',
			NoOverridableChannels: () => 'Alle grupperte kanaler har allerede en overstyring',
			RemoveOverride: () => 'Fjern overstyring',
			ExpandGroup: () => 'Vis kanalpriser',
			CollapseGroup: () => 'Skjul kanalpriser',
			OverrideCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'overstyring', other: 'overstyringer' }),
			EmptyState: {
				Header: () => 'Ingen priser konfigurert',
				Description: () => 'Legg til en pris på dette produktet slik at det kan selges i en salgskanal.',
				Action: () => 'Legg til pris'
			}
		},
		Barcode: {
			Title: () => 'Strekkoder',
			Barcode: () => 'Strekkode',
			AddBarcode: () => 'Legg til strekkode',
			AddBarcodePrompt: {
				Title: () => 'Legg til strekkode',
				Placeholder: () => 'Strekkode'
			},
			Delete: {
				Title: () => 'Slett strekkode',
				Description: (args: { barcode: string }) =>
					'Er du sikker på at du vil slette strekkoden ' + String(args.barcode) + '?'
			},
			AlreadyOnProduct: () => 'Denne strekkoden er allerede på dette produktet',
			AlreadyInUse: () => 'Denne strekkoden er allerede i bruk av et annet produkt'
		},
		UnitsOfMeasure: {
			Title: () => 'Måleenheter',
			Unit: () => 'Enhet',
			Base: () => 'Basis',
			BaseUnit: () => 'Basisenhet',
			True: () => 'Sant',
			False: () => 'Usant',
			BaseUnitLabel: (args: { code: string }) => String(args.code) + ' (basis)',
			BaseUnitsPer: () => 'Antall per enhet',
			Sellable: () => 'Salgbar',
			Pos: () => 'POS',
			Ecom: () => 'E-handel',
			Add: () => 'Legg til enhet',
			Edit: () => 'Rediger enhet',
			Code: () => 'Kode',
			Name: () => 'Navn',
			InvalidFactor: () => 'Antall må være større enn null',
			SelectUnit: () => 'Velg en enhet',
			QuantityRequired: () => 'Denne enheten har ingen felles mengde, så et antall er påkrevd',
			Saved: () => 'Enhet lagret',
			Delete: {
				Title: () => 'Slett enhet',
				Description: (args: { code: string }) => 'Er du sikker på at du vil slette ' + String(args.code) + '?'
			}
		}
	},
	ProductEdit: {
		Header: () => 'Rediger produkt'
	},
	ProductCategories: {
		Title: () => 'Kategorier',
		Breadcrumb: () => 'Kategorier',
		Search: () => 'Søk i kategorier',
		Empty: () => 'Ingen kategorier ennå',
		NoSearchResults: (args: { query: string }) => 'Ingen kategorier matcher «' + String(args.query) + '»',
		Column: {
			Name: () => 'Navn',
			ProductCount: () => 'Antall produkter'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'Ingen overordnet',
			SelectParentTitle: () => 'Velg overordnet kategori',
			SelectParentDescription: () => 'Velg en overordnet kategori for denne kategorien'
		}
	},
	ProductCategory: {
		CreateSuccessToast: (args: { name: string }) => 'Kategori ' + String(args.name) + ' ble opprettet.',
		EditHeader: () => 'Rediger kategori',
		EditSuccessToast: (args: { name: string }) => 'Kategori ' + String(args.name) + ' ble oppdatert.',
		CreateTitle: () => 'Opprett kategori',
		ParentCategory: () => 'Overordnet kategori',
		ProductsTitle: () => 'Produkter',
		SelectParent: () => 'Velg overordnet kategori',
		ClearParent: () => 'Fjern overordnet kategori',
		Delete: {
			Title: () => 'Slett kategori',
			Description: (args: { name: string }) =>
				'Er du sikker på at du vil slette kategorien "' +
				String(args.name) +
				'"? Produkter i denne kategorien blir ikke slettet.',
			SuccessToast: (args: { name: string }) => 'Kategorien ' + String(args.name) + ' ble slettet.'
		},
		Image: {
			Title: () => 'Bilde',
			EmptyState: () => 'Ingen bilde ennå',
			Upload: () => 'Last opp',
			ChooseFromLibrary: () => 'Velg fra bibliotek',
			Remove: () => 'Fjern bilde',
			LibraryPickerTitle: () => 'Legg til fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilder i biblioteket ennå.',
			LibraryPickerAllAttached: () => 'Dette bildet er allerede valgt.',
			SetSuccessToast: () => 'Bilde oppdatert',
			RemoveSuccessToast: () => 'Bilde fjernet',
			UploadFailedToast: () => 'Kunne ikke laste opp bilde'
		},
		Create: {
			NoParent: () => 'Ingen overordnet',
			SelectParentTitle: () => 'Velg overordnet kategori',
			SelectParentDescription: () => 'Velg en overordnet kategori for denne kategorien'
		}
	},
	ProductGroups: {
		Title: () => 'Grupper',
		Breadcrumb: () => 'Grupper',
		Search: () => 'Søk i grupper',
		Empty: () => 'Ingen grupper ennå',
		NoSearchResults: (args: { query: string }) => 'Ingen grupper matcher «' + String(args.query) + '»',
		Column: {
			Name: () => 'Navn',
			ProductCount: () => 'Antall produkter'
		}
	},
	ProductGroup: {
		Title: (arg0: string) => 'Gruppe ' + String(arg0),
		EditHeader: () => 'Rediger gruppe',
		EditSuccessToast: (args: { name: string }) => 'Gruppe ' + String(args.name) + ' ble oppdatert.',
		CreateTitle: () => 'Opprett gruppe',
		CreateSuccessToast: (args: { name: string }) => 'Gruppe ' + String(args.name) + ' ble opprettet.',
		Delete: {
			Title: () => 'Slett gruppe',
			Description: (args: { name: string }) =>
				'Er du sikker på at du vil slette gruppen "' +
				String(args.name) +
				'"? Produkter i denne gruppen blir ikke slettet.',
			SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' ble slettet.'
		},
		Image: {
			Title: () => 'Bilde',
			EmptyState: () => 'Ingen bilde ennå',
			Upload: () => 'Last opp',
			ChooseFromLibrary: () => 'Velg fra bibliotek',
			Remove: () => 'Fjern bilde',
			LibraryPickerTitle: () => 'Legg til fra bibliotek',
			LibraryPickerEmpty: () => 'Ingen produktbilder i biblioteket ennå.',
			LibraryPickerAllAttached: () => 'Dette bildet er allerede valgt.',
			SetSuccessToast: () => 'Bilde oppdatert',
			RemoveSuccessToast: () => 'Bilde fjernet',
			UploadFailedToast: () => 'Kunne ikke laste opp bilde'
		},
		Products: {
			Title: () => 'Produkter',
			NoProducts: () => 'Ingen produkter',
			Add: {
				Title: () => 'Legg til produkter',
				Label: () => 'Produkter',
				Placeholder: () => 'Søk i produkter',
				SuccessToast: (args: { count: number; name: string }) =>
					String(args.count) + ' produkt(er) lagt til i ' + String(args.name) + '.',
				NoProducts: () => 'Velg minst ett produkt.'
			}
		},
		Fees: {
			Title: () => 'Gebyrer',
			AddFee: () => 'Legg til gebyr',
			NoFees: () => 'Ingen gebyrer',
			Delete: {
				Title: () => 'Slett gebyr',
				Description: (args: { name: string }) =>
					'Er du sikker på at du vil slette gebyret "' + String(args.name) + '"?'
			},
			Create: {
				Title: () => 'Opprett gebyr',
				Pricing: () => 'Prising',
				SuccessToast: (args: { name: string }) => 'Gebyr ' + String(args.name) + ' ble opprettet.',
				NoPrices: () => 'Vennligst legg til minst én pris.'
			},
			Edit: {
				Title: () => 'Rediger gebyr',
				SuccessToast: (args: { name: string }) => 'Gebyret ' + String(args.name) + ' ble oppdatert.'
			}
		}
	},
	GiftCards: {
		Title: () => 'Gavekort',
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reservert'
					case 'REDEEMED':
						return 'Innløst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Rediger gavekort',
		EditSuccess: () => 'Gavekort oppdatert',
		DeleteSuccess: () => 'Gavekort slettet',
		Delete: {
			Title: () => 'Slett gavekort',
			Description: () => 'Er du sikker på at du vil slette dette gavekortet? Denne handlingen kan ikke angres.'
		},
		Column: {
			Name: () => 'Navn',
			Code: () => 'Kode',
			Amount: () => 'Beløp',
			CurrencyCode: () => 'Valuta',
			Status: () => 'Status'
		},
		Detail: {
			Title: () => 'Gavekort',
			General: () => 'Generelt',
			CardDetails: () => 'Kortdetaljer',
			Redemptions: () => 'Innløsninger',
			NoRedemptions: () => 'Ingen innløsninger',
			Date: () => 'Dato',
			RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Venter'
						case 'APPLIED':
							return 'Brukt'
						default:
							return String(v)
					}
				})(arg0)
		}
	},
	GiftCard: {
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					case 'RESERVED':
						return 'Reserved'
					case 'REDEEMED':
						return 'Redeemed'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Rediger gavekort',
		CreateTitle: () => 'Opprett gavekort',
		Name: () => 'Navn',
		Code: () => 'Kode',
		Amount: () => 'Beløp',
		CurrencyCode: () => 'Valutakode'
	},
	LoyaltyCards: {
		Title: () => 'Lojalitetskort',
		EditTitle: () => 'Rediger lojalitetskort',
		EditSuccess: () => 'Lojalitetskort oppdatert',
		DeleteSuccess: () => 'Lojalitetskort slettet',
		ManagedExternally: (args: { source: string }) =>
			'Dette lojalitetskortet administreres av ' + String(args.source),
		Delete: {
			Title: () => 'Slett lojalitetskort',
			Description: () =>
				'Er du sikker på at du vil slette dette lojalitetskortet? Denne handlingen kan ikke angres.'
		},
		Detail: {
			Title: () => 'Lojalitetskort',
			CardDetails: () => 'Kortdetaljer',
			Customer: () => 'Kunde',
			Redemptions: () => 'Innløsninger',
			Date: () => 'Dato'
		},
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Customer: () => 'Kunde',
			Status: () => 'Status',
			AvailablePoints: () => 'Tilgjengelige poeng',
			TotalPoints: () => 'Totale poeng',
			ExternalId: () => 'Ekstern ID',
			ExternalSource: () => 'Ekstern kilde',
			PointsUsed: () => 'Brukte poeng',
			PointsRemaining: () => 'Gjenværende poeng',
			Order: () => 'Bestilling'
		}
	},
	Inventory: {
		Title: () => 'Lager',
		Stock: () => 'Beholdning',
		Suppliers: () => 'Leverandører',
		Movements: () => 'Lagerbevegelser',
		Receiving: () => 'Mottak',
		Transfers: () => 'Overføringer',
		Reports: () => 'Lagerrapporter',
		Summary: {
			TotalSkus: () => 'Totalt antall SKU',
			LowStock: () => 'Lav beholdning',
			OutOfStock: () => 'Utsolgt'
		},
		Column: {
			Product: () => 'Produkt',
			Variant: () => 'Variant',
			Sku: () => 'SKU',
			SalesChannel: () => 'Salgskanal',
			InventoryLocation: () => 'Plassering',
			QuantityOnHand: () => 'På lager',
			QuantityAfter: () => 'På lager etter',
			ReorderPoint: () => 'Bestillingspunkt',
			ReorderQuantity: () => 'Bestillingsantall',
			Status: () => 'Status',
			Type: () => 'Type',
			Delta: () => 'Endring',
			Reason: () => 'Årsak',
			CreatedBy: () => 'Av',
			Ordered: () => 'Bestilt',
			Received: () => 'Mottatt',
			ReceiveNow: () => 'Motta nå',
			UnitCost: () => 'Enhetskostnad',
			Quantity: () => 'Antall',
			Lines: () => 'Varer',
			Date: () => 'Dato',
			Name: () => 'Navn',
			Email: () => 'E-post',
			Reference: () => 'Referanse',
			From: () => 'Fra',
			To: () => 'Til',
			Supplier: () => 'Leverandør',
			Currency: () => 'Valuta',
			Margin: () => 'Margin',
			PurchasePrice: () => 'Innkjøpspris',
			RetailPrice: () => 'Salgspris',
			Tracked: () => 'Spores'
		},
		Filter: {
			LowStockOnly: () => 'Kun lav beholdning',
			SalesChannel: () => 'Salgskanal',
			InventoryLocation: () => 'Plassering',
			Status: () => 'Status',
			Type: () => 'Type',
			AllChannels: () => 'Alle salgskanaler',
			AllLocations: () => 'Alle plasseringer',
			AllStatuses: () => 'Alle statuser',
			AllTypes: () => 'Alle typer'
		},
		NotTracked: () => 'Spores ikke',
		ReorderSettings: () => 'Bestillingsinnstillinger',
		ViewMovements: () => 'Vis historikk',
		Adjust: () => 'Juster beholdning',
		AdjustSuccess: () => 'Beholdning justert',
		AdjustNoChanges: () => 'Ingen endringer å lagre',
		AdjustDeltaHint: () => 'Relativ endring av beholdning. Bruk en negativ verdi for å fjerne lager.',
		EditProduct: () => 'Rediger produkt',
		Settings: {
			Title: () => 'Innstillinger',
			Description: () => 'Styr hvordan lagersporing fungerer på tvers av salgskanalene dine.',
			Enabled: () => 'Aktiver lagersporing',
			EnabledDescription: () => 'Spor lagernivåer og lagerbevegelser for produktene dine.',
			DeductOnOrderComplete: () => 'Trekk fra lager ved fullførte ordrer',
			DeductOnOrderCompleteDescription: () => 'Reduser tilgjengelig antall automatisk når en ordre fullføres.',
			BlockOversell: () => 'Blokker oversalg',
			BlockOversellDescription: () => 'Hindre salg av flere enheter enn det som er tilgjengelig i en kanal.',
			RestockOnReturn: () => 'Legg tilbake ved retur',
			RestockOnReturnDescription: () => 'Legg returnerte varer tilbake i lager når en refusjon fullføres.',
			HideOutOfStock: () => 'Skjul utsolgte produkter',
			HideOutOfStockDescription: () =>
				'Skjul sporede produkter fra nettbutikken når de ikke har tilgjengelig lager i kanalen.',
			Saved: () => 'Lagerinnstillinger oppdatert',
			Locations: {
				Title: () => 'Plasseringer',
				Description: () => 'Administrer lagerplasseringer og koble salgskanaler til dem.',
				Column: {
					Name: () => 'Navn',
					SalesChannels: () => 'Salgskanaler'
				},
				CreateTitle: () => 'Opprett plassering',
				CreateSuccess: () => 'Plassering opprettet',
				EditTitle: () => 'Rediger plassering',
				EditSuccess: () => 'Plassering oppdatert',
				NamePlaceholder: () => 'Lager, butikkgulv, …',
				LinkedChannels: () => 'Koblede salgskanaler',
				LinkedChannelsHint: () =>
					'Velg salgskanaler som henter lager fra denne plasseringen. Å legge til en kanal som er knyttet et annet sted vil flytte den hit.',
				NoLinkedChannels: () => 'Ingen salgskanaler koblet til denne plasseringen.',
				InitializeStock: () => 'Initialiser lagerposter',
				InitializeStockDescription: () =>
					'Opprett lagerpostrader for alle sporede varianter på denne plasseringen. Eksisterende poster hoppes over.',
				InitializeStockSuccess: () => 'Lagerposter initialisert',
				InitializeStockProgress: (args: { created: number; remaining: number }) =>
					'Opprettet ' + String(args.created) + ' poster (' + String(args.remaining) + ' gjenstår)',
				InitializeStockProgressLabel: (args: { created: number; total: number }) =>
					'Opprettet ' + String(args.created) + ' av ' + String(args.total) + ' lagerposter',
				InitializeStockError: (args: { created: number }) =>
					'Initialiseringen stoppet etter å ha opprettet ' +
					String(args.created) +
					' poster. Prøv igjen for å fullføre.',
				InitializeStockRetry: () => 'Prøv igjen',
				AdminOnly: () => 'Kun administratorer kan administrere lagerplasseringer.'
			}
		},
		Status: {
			IN_STOCK: () => 'På lager',
			LOW_STOCK: () => 'Lav beholdning',
			OUT_OF_STOCK: () => 'Utsolgt'
		},
		MovementType: {
			ADJUSTMENT: () => 'Justering',
			RECEIPT: () => 'Mottak',
			TRANSFER_IN: () => 'Overføring inn',
			TRANSFER_OUT: () => 'Overføring ut',
			ORDER_DEDUCTION: () => 'Ordrefradrag',
			ORDER_RETURN: () => 'Ordre retur'
		},
		TransferStatus: {
			DRAFT: () => 'Utkast',
			IN_TRANSIT: () => 'Under transport',
			RECEIVED: () => 'Mottatt',
			CANCELLED: () => 'Kansellert'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Utkast',
			ORDERED: () => 'Bestilt',
			PARTIALLY_RECEIVED: () => 'Delvis mottatt',
			RECEIVED: () => 'Mottatt',
			CANCELLED: () => 'Kansellert'
		},
		CreateSupplier: () => 'Opprett leverandør',
		EditSupplier: () => 'Rediger leverandør',
		EditSupplierSuccess: () => 'Leverandør oppdatert',
		SuppliersEmptyTitle: () => 'Ingen leverandører ennå',
		SuppliersEmptyDescription: () => 'Opprett din første leverandør for å spore hvor du kjøper varer.',
		CreateTransfer: () => 'Opprett overføring',
		CreatePurchaseOrder: () => 'Opprett innkjøpsordre',
		PurchaseCurrencyHint: (args: { currency: string }) =>
			'Bruker ' + String(args.currency) + ' for denne ordren. Endre hvis ordren er annerledes.',
		PurchaseCurrencyDefaultHint: (args: { currency: string }) =>
			'Bruker rapporteringsvalutaen din ' + String(args.currency) + '. Bekreft eller endre.',
		PurchaseCurrencyRequired: () => 'Velg en valuta for innkjøpsordren.',
		ShipTransfer: () => 'Send overføring',
		ReceiveTransfer: () => 'Motta overføring',
		CancelTransfer: () => 'Kanseller overføring',
		Transfer: () => 'Overføring',
		Actions: () => 'Handlinger',
		ReceivePurchaseOrder: () => 'Motta varer',
		ManageSuppliers: () => 'Administrer',
		Replenish: () => 'Fyll på lav beholdning',
		ReplenishSuccess: (args: { count: number }) => 'Opprettet ' + String(args.count) + ' påfyllingsutkast',
		ReplenishNone: () => 'Ingen varer under bestillingspunkt',
		MarkOrdered: () => 'Merk bestilt',
		CancelOrder: () => 'Kanseller',
		PurchaseOrder: () => 'Innkjøpsordre',
		AddLine: () => 'Legg til',
		NoLines: () => 'Ingen varer lagt til ennå.',
		SelectSalesChannel: () => 'Velg salgskanal',
		SupplierDialog: {
			Title: () => 'Produktleverandører',
			Preferred: () => 'Foretrukket',
			SetPreferred: () => 'Sett som foretrukket',
			AddSupplier: () => 'Legg til leverandør',
			SelectSupplier: () => 'Velg leverandør',
			Empty: () => 'Ingen leverandører knyttet til dette produktet ennå.',
			NoSuppliersYet: () => 'Ingen leverandører finnes ennå',
			NoSuppliersDescription: () => 'Opprett en leverandør før du knytter den til dette produktet.',
			CreateSupplierAction: () => 'Opprett leverandør',
			SupplierProductCode: () => 'Leverandørens produktkode',
			UpdateSuccess: () => 'Leverandør oppdatert',
			AllSuppliersLinked: () => 'Alle eksisterende leverandører er allerede knyttet til dette produktet.',
			EditPrices: () => 'Rediger priser',
			MarginUnavailable: () => 'Ikke tilgjengelig',
			MarginCurrencyMismatch: (args: { retail: string; purchase: string }) =>
				'Marginen kan ikke beregnes fordi utsalgsprisen (' +
				String(args.retail) +
				') og leverandørprisen (' +
				String(args.purchase) +
				') bruker ulike valutaer.',
			MarginTaxNote: () =>
				'Marginen beregnes ut fra salgsprisen ekskl. mva. Salgspriser inkl. mva får mva trukket fra først.',
			PurchasePriceTaxNote: () => 'Angi leverandørens innkjøpspris ekskl. mva (netto).'
		}
	},
	Companies: {
		Title: () => 'Bedrifter',
		Anonymous: () => 'Uten navn',
		CreateTitle: () => 'Opprett bedrift',
		CreateSuccess: () => 'Bedrift opprettet.',
		EditTitle: () => 'Rediger bedrift',
		EditSuccess: () => 'Bedrift oppdatert.',
		UpdateSuccess: () => 'Bedriften ble oppdatert',
		Delete: {
			Title: () => 'Slett bedrift',
			Description: (args: { name: string }) =>
				'Er du sikker på at du vil slette bedriften ' +
				String(args.name) +
				'? Denne handlingen kan ikke angres.'
		},
		DeleteSuccess: () => 'Bedriften ble slettet',
		CardCount: () => 'Bedriftskort',
		SettlementCount: () => 'Nylige oppgjør',
		RecentSettlements: () => 'Nylige oppgjør',
		Cards: {
			Title: () => 'Bedriftskort'
		},
		Detail: {
			Title: () => 'Bedrift',
			General: () => 'Generelt',
			ContactInfo: () => 'Kontaktinformasjon',
			Cards: () => 'Bedriftskort',
			Settlements: () => 'Oppgjør',
			RecentSettlements: () => 'Nylige oppgjør',
			AssignCard: () => 'Tildel kort',
			AssignCardDescription: () =>
				'Søk etter et bedriftskort med navn eller kortnummer for å tildele det til denne bedriften.',
			AssignCardSuccess: () => 'Kortet ble tildelt',
			UnassignCard: () => 'Opphev korttildeling',
			UnassignCardConfirm: () => 'Er du sikker på at du vil oppheve tildelingen av dette kortet fra bedriften?',
			UnassignCardSuccess: () => 'Kortets tildeling ble opphevet',
			CardNumberPlaceholder: () => 'Søk etter navn eller kortnummer'
		},
		Column: {
			Name: () => 'Navn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID',
			CardCount: () => 'Kort',
			SettlementCount: () => 'Oppgjør',
			CreatedAt: () => 'Opprettet'
		},
		Field: {
			Name: () => 'Navn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID'
		},
		Create: {
			BasicInfo: () => 'Grunnleggende informasjon',
			Description: () => 'Opprett en ny bedrift',
			NamePlaceholder: () => 'Skriv inn bedriftsnavn',
			ExternalIdPlaceholder: () => 'Skriv inn ekstern ID (valgfritt)'
		},
		Edit: {
			BasicInfo: () => 'Grunnleggende informasjon',
			Description: () => 'Rediger bedriftsinformasjon',
			NamePlaceholder: () => 'Skriv inn bedriftsnavn',
			EmailPlaceholder: () => 'Skriv inn e-postadresse',
			PhonePlaceholder: () => 'Skriv inn telefonnummer',
			OrgNumberPlaceholder: () => 'Skriv inn organisasjonsnummer',
			ExternalIdPlaceholder: () => 'Skriv inn ekstern ID (valgfritt)'
		}
	},
	Customers: {
		Title: () => 'Kunder',
		UnnamedCustomer: () => 'Kunde uten navn',
		Anonymous: () => 'Anonym',
		CreateTitle: () => 'Opprett kunde',
		CreateSuccess: (args: { name: string }) => 'Kunde ' + String(args.name) + ' ble opprettet.',
		EditTitle: () => 'Rediger kunde',
		UpdateSuccess: () => 'Kunden ble oppdatert',
		Detail: {
			Title: () => 'Kunde',
			General: () => 'Generelt',
			ContactInfo: () => 'Kontaktinformasjon',
			Cards: () => 'Kort',
			AssignCard: () => 'Tilordne kort',
			AssignCardDescription: () =>
				'Søk etter et bedriftskort med navn eller kortnummer for å tilordne det til denne kunden.',
			AssignCardSuccess: () => 'Kort ble tilordnet',
			UnassignCard: () => 'Opphev korttildeling',
			UnassignCardConfirm: () => 'Er du sikker på at du vil oppheve tildelingen av dette kortet fra kunden?',
			UnassignCardSuccess: () => 'Kortets tildeling ble opphevet',
			CardNumberPlaceholder: () => 'Søk etter navn eller kortnummer'
		},
		Column: {
			Name: () => 'Navn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Ekstern ID',
			Cards: () => 'Kort'
		},
		Field: {
			FirstName: () => 'Fornavn',
			LastName: () => 'Etternavn',
			Phone: () => 'Telefon',
			SSN: () => 'Fødselsnummer'
		},
		Create: {
			BasicInfo: () => 'Grunnleggende informasjon',
			Description: () => 'Opprett en ny kunde'
		},
		Edit: {
			BasicInfo: () => 'Grunnleggende informasjon',
			Description: () => 'Rediger kundeinformasjon',
			FirstNamePlaceholder: () => 'Skriv inn fornavn',
			LastNamePlaceholder: () => 'Skriv inn etternavn',
			EmailPlaceholder: () => 'Skriv inn e-postadresse',
			PhonePlaceholder: () => 'Skriv inn telefonnummer',
			SSNPlaceholder: () => 'Skriv inn fødselsnummer (valgfritt)',
			ExternalIdPlaceholder: () => 'Skriv inn ekstern ID (valgfritt)'
		},
		Cards: {
			Title: () => 'Kundekort',
			Active: () => 'Aktive kort'
		}
	},
	BusinessCards: {
		Title: () => 'Bedriftskort',
		CreateTitle: () => 'Opprett bedriftskort',
		CreateSuccess: () => 'Bedriftskort opprettet',
		EditTitle: () => 'Rediger bedriftskort',
		EditSuccess: () => 'Bedriftskort oppdatert',
		DeleteSuccess: () => 'Bedriftskort slettet',
		Create: {
			NamePlaceholder: () => 'Skriv inn kortnavn',
			CardNumberPlaceholder: () => 'Skriv inn kortnummer',
			SelectCompany: () => 'Velg en bedrift',
			SelectCustomer: () => 'Velg en kunde',
			PinTitle: () => 'Bedriftskort opprettet',
			PinDescription: () => 'Del denne PIN-koden med kortinnehaveren. Den kan bare vises én gang.',
			GoToCard: () => 'Gå til kort'
		},
		Delete: {
			Title: () => 'Slett bedriftskort',
			Description: () =>
				'Er du sikker på at du vil slette dette bedriftskortet? Denne handlingen kan ikke angres.'
		},
		Detail: {
			Title: () => 'Bedriftskort',
			General: () => 'Generelt',
			CardDetails: () => 'Kortdetaljer',
			Security: () => 'Sikkerhet',
			ResetPin: () => 'Tilbakestill PIN',
			ResetPinDescription: () => 'Generer en ny PIN for dette kortet. Gjeldende PIN blir ugyldig.',
			ResetPinSuccess: () => 'PIN er tilbakestilt',
			NewPin: (args: { pin: string }) => 'Ny PIN: ' + String(args.pin),
			PinViewOnce: () =>
				'Denne PIN-koden kan bare vises én gang. Vennligst lagre den før du lukker denne dialogen.',
			Customer: () => 'Kunde',
			Company: () => 'Bedrift',
			DangerZone: () => 'Faresone',
			DeleteCardDescription: () => 'Slett dette bedriftskortet permanent. Denne handlingen kan ikke angres.'
		},
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Customer: () => 'Kunde',
			ExternalId: () => 'Ekstern ID',
			CreatedAt: () => 'Opprettet'
		},
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Blokkert'
					default:
						return String(v)
				}
			})(arg0)
	},
	Promotions: {
		Title: () => 'Kampanjer',
		Group: () => 'Kampanjegruppe',
		Groups: () => 'Grupper',
		SelectGroups: () => 'Velg kampanjegrupper',
		Column: {
			PromotionCount: () => 'Kampanjer'
		},
		CreateTitle: () => 'Opprett kampanje',
		CreateSuccess: () => 'Kampanje opprettet',
		EditTitle: () => 'Rediger kampanje',
		UpdateSuccess: () => 'Kampanje oppdatert',
		NotFound: () => 'Kampanje ikke funnet',
		AdvancedFilters: () => 'Kampanjefiltre',
		ManagedExternally: (args: { source: string }) => 'Denne kampanjen administreres av ' + String(args.source),
		Create: {
			ApplyToAll: () => 'Alle produkter',
			ApplyToGroups: () => 'Spesifikke produktgrupper',
			ApplyToCategories: () => 'Spesifikke kategorier',
			ApplyToProducts: () => 'Spesifikke produkter',
			AppliesTo: () => 'Gjelder for',
			FixedAmount: () => 'Fast beløp',
			Percentage: () => 'Prosent',
			OverridePrice: () => 'Overstyr pris',
			OverridePriceHelp: () =>
				'Sett en fast totalpris for de matchede varene per salgskanal eller salgskanalgruppe',
			IncludeFeesHelp: () =>
				'Når det er på, er overstyringsprisen den endelige totalprisen inkludert eventuelle varegebyrer. Når det er av, legges varegebyrer til på toppen av overstyringsprisen.',
			OverridePriceNoChannels: () =>
				'Velg minst én salgskanal eller salgskanalgruppe for å sette overstyrte priser',
			BasicInfo: () => 'Grunnleggende informasjon',
			DaysOfWeek: () => 'Ukedager',
			Discount: () => 'Effekt',
			DiscountAmount: () => 'Rabattbeløp',
			DiscountPercentage: () => 'Rabattprosent',
			PercentageHelp: () => 'Skriv inn en prosent mellom 0 og 100',
			ItemCount: () => 'Antall varer',
			NamePlaceholder: () => 'Skriv inn kampanjenavn',
			DisplayTitle: () => 'Visningstittel',
			DisplayTitlePlaceholder: () => 'Vises for kunder (valgfritt)',
			DisplayTitleHint: () =>
				'Kundevendt tittel som vises i scan & go, selvbetjeningskasse og nettbutikk. La stå tom for å bruke det interne navnet.',
			ProductGroup: () => 'Produktgruppe',
			ProductGroups: () => 'Produktgrupper',
			SlotKind: () => 'Type',
			SlotKindGroup: () => 'Produktgruppe',
			SlotKindCategory: () => 'Kategori',
			Categories: () => 'Kategorier',
			Products: () => 'Produkter',
			CustomerEligibility: () => 'Kundeberettigelse',
			CustomerEligibilityHint: () =>
				'La stå tomt for å gjelde for alle. Legg til kunder eller kundegrupper for å begrense kampanjen til dem.',
			CustomerGroups: () => 'Kundegrupper',
			SelectCustomerGroups: () => 'Velg kundegrupper',
			Customers: () => 'Kunder',
			SelectCustomers: () => 'Velg kunder',
			PromotionType: () => 'Kampanjetype',
			TypeDiscount: () => 'Rabatt',
			TypeBundle: () => 'Pakketilbud',
			TypeBuyXGetY: () => 'Kjøp X, få Y',
			BundleGroups: () => 'Pakkegrupper og kategorier',
			BundleGroupsHelp: () => 'Kampanjen gjelder når nødvendig antall fra hver gruppe eller kategori er i ordren',
			QualifyingGroups: () => 'Kvalifiserende produkter (kjøp)',
			QualifyingGroupsHelp: () =>
				'Nødvendig antall fra hver av disse gruppene eller kategoriene må være i ordren for å utløse tilbudet. Disse varene får ikke rabatt.',
			BenefitGroups: () => 'Fordelsprodukter (få)',
			BenefitGroupsHelp: () =>
				'Når de kvalifiserende produktene er til stede, får nødvendig antall fra hver av disse gruppene eller kategoriene rabatten nedenfor (100 % = gratis).',
			AddBundleGroup: () => 'Legg til gruppe eller kategori',
			Schedule: () => 'Tidsplan',
			AddDay: () => 'Legg til dager',
			SelectDays: () => 'Velg dager',
			SelectProductGroups: () => 'Velg produktgrupper',
			SelectCategories: () => 'Velg kategorier',
			SelectProducts: () => 'Velg produkter',
			SelectSalesChannels: () => 'Velg salgskanaler',
			SalesChannelGroups: () => 'Salgskanalgrupper',
			SelectSalesChannelGroups: () => 'Velg salgskanalgrupper',
			ApplicationRule: () => 'Bruksregel',
			Description: () => 'Beskrivelse',
			Rank: () => 'Prioritet',
			RankHint: () => 'Lavere tall brukes først når flere kampanjer treffer de samme varene',
			RankInUse: (args: { names: string }) =>
				'En annen kampanje bruker allerede denne prioriteten: ' +
				String(args.names) +
				'. Kampanjer med samme prioritet brukes i ubestemt rekkefølge, bruk et unikt tall for å styre hvilken som kjører først.',
			SellingUnit: () => 'Salgsenhet',
			SellingUnitHelp: () =>
				'Alle enheter gjelder kampanjen for alle salgsenheter av de valgte produktene. Basisenhet eller en navngitt pakke begrenser den til den enheten.',
			AllUnits: () => 'Alle enheter',
			BaseUnit: () => 'Basisenhet',
			Validation: {
				NameRequired: () => 'Navn er påkrevd',
				PercentageRange: () => 'Skriv inn en prosent mellom 0 og 100',
				PercentageRequired: () => 'Skriv inn en rabattprosent',
				BundleGroupsRequired: () => 'Legg til minst én pakkegruppe eller kategori med antall',
				BenefitGroupsRequired: () => 'Legg til minst én fordelsgruppe eller kategori med antall',
				QualifyingBenefitOverlap: () =>
					'En produktgruppe eller kategori kan ikke være både en kvalifiserende gruppe og en fordelsgruppe',
				OverridePriceRequired: () => 'Sett en overstyrt pris for minst én salgskanal',
				ScopeTargetsRequired: () => 'Velg minst én produktgruppe, kategori eller ett produkt',
				RankRange: () => 'Skriv inn en prioritet på 0 eller høyere'
			}
		},
		Detail: {
			SalesChannels: () => 'Salgskanaler',
			DisplayTitle: () => 'Visningstittel',
			StartDate: () => 'Startdato',
			EndDate: () => 'Sluttdato',
			OverridePrice: () => 'Overstyr pris',
			IncludeFees: () => 'Inkluder gebyrer',
			ApplyToAllProducts: () => 'Bruk på alle produkter',
			ProductGroups: () => 'Produktgrupper',
			DiscountDefinition: () => 'Rabattdefinisjon',
			ApplicationRule: () => 'Bruksregel',
			Prices: () => 'Priser',
			Title: () => 'Kampanjedetaljer',
			AppliesTo: () => 'Gjelder for',
			SellingUnit: () => 'Salgsenhet',
			CustomerEligibility: () => 'Kundeberettigelse',
			AppliesToEveryone: () => 'Alle kunder',
			DaysOfWeek: () => 'Ukedager',
			Discount: () => 'Rabatt',
			DiscountType: () => 'Rabatttype',
			DiscountValue: () => 'Rabattverdi',
			Schedule: () => 'Tidsplan'
		},
		Edit: {
			Description: () => 'Rediger kampanjedetaljene'
		},
		Delete: {
			Title: () => 'Slett kampanje',
			Description: (args: { name: string }) =>
				'Er du sikker på at du vil slette kampanjen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kampanjen ' + String(args.name) + ' ble slettet.'
		}
	},
	Promotion: {
		Title: () => 'Kampanje',
		CreateTitle: () => 'Opprett kampanje'
	},
	Marketing: {
		Title: () => 'Markedsføring',
		Library: () => 'Bibliotek',
		Campaigns: () => 'Kampanjer',
		Channels: () => 'Kanaler',
		Messaging: () => 'Meldinger',
		Journeys: () => 'Forløp',
		ContentNav: () => 'Innhold',
		LayoutNav: () => 'Oppsett',
		Channel: {
			Title: () => 'Markedsføringskanaler',
			NewChannel: () => 'Ny kanal',
			NoChannels: () => 'Ingen markedsføringskanaler ennå',
			NoChannelsDescription: () =>
				'Opprett en markedsføringskanal for å publisere innhold og oppsett for en markedsflate.',
			CampaignCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'kampanje', other: 'kampanjer' }),
			SalesChannelsHint: () =>
				'Velg salgskanalene som hører til denne markedsføringskanalen. En salgskanal kan bare tilhøre én markedsføringskanal.',
			PublishableKeysHint: () =>
				'Velg de publiserbare nøklene (apper / klienter) som henter feed og oppsett fra denne kanalen. En publiserbar nøkkel kan bare tilhøre én markedsføringskanal.',
			SurfacesHint: () =>
				'Velg klientflatene denne kanalen betjener. Den tilbys bare for en flate den betjener, og ingenting publiseres til en flate som ikke er valgt.',
			DeleteConfirm: () => 'Slette denne markedsføringskanalen? De publiserbare nøklene blir frakoblet.',
			Field: {
				Name: () => 'Navn',
				NamePlaceholder: () => 'f.eks. Scan & Go, Selvbetjening, Skjerm',
				Description: () => 'Beskrivelse',
				DescriptionPlaceholder: () => 'Valgfri beskrivelse',
				SalesChannels: () => 'Salgskanaler',
				Surfaces: () => 'Flater',
				SurfacesPlaceholder: () => 'Velg flater',
				PublishableKeys: () => 'Publiserbare nøkler',
				PublishableKeysPlaceholder: () => 'Velg publiserbare nøkler'
			},
			Action: {
				Create: () => 'Opprett kanal',
				Save: () => 'Lagre endringer',
				Delete: () => 'Slett'
			}
		},
		Campaign: {
			Title: () => 'Kampanje',
			NewCampaign: () => 'Ny kampanje',
			NoCampaigns: () => 'Ingen kampanjer ennå',
			NoCampaignsDescription: () => 'Opprett en kampanje for å planlegge en gruppe kampanjer for kundeappen.',
			ActiveNow: () => 'Aktiv nå',
			Scheduled: () => 'Planlagt',
			Draft: () => 'Utkast',
			Ended: () => 'Avsluttet',
			StatusEnum: (arg0: 'DRAFT' | 'PUBLISHED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Utkast'
						case 'PUBLISHED':
							return 'Publisert'
						default:
							return String(v)
					}
				})(arg0),
			WindowStatusEnum: (arg0: 'DRAFT' | 'SCHEDULED' | 'ACTIVE' | 'ENDED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Utkast'
						case 'SCHEDULED':
							return 'Planlagt'
						case 'ACTIVE':
							return 'Aktiv nå'
						case 'ENDED':
							return 'Avsluttet'
						default:
							return String(v)
					}
				})(arg0),
			ItemTypeEnum: (arg0: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR' | 'CUSTOM') =>
				(v => {
					switch (v) {
						case 'BANNER':
							return 'Banner'
						case 'LIST':
							return 'Liste'
						case 'MODAL':
							return 'Modal'
						case 'SEPARATOR':
							return 'Skille'
						case 'CUSTOM':
							return 'Tilpasset'
						default:
							return String(v)
					}
				})(arg0),
			Field: {
				Name: () => 'Navn',
				NamePlaceholder: () => 'Kampanjenavn',
				Description: () => 'Beskrivelse',
				DescriptionPlaceholder: () => 'Valgfri beskrivelse',
				Title: () => 'Tittel',
				ItemTitlePlaceholder: () => 'Åpningstider',
				ApiKey: () => 'Publiserbar nøkkel',
				MarketingChannel: () => 'Markedsføringskanal',
				Status: () => 'Status',
				StartsAt: () => 'Starter',
				EndsAt: () => 'Avsluttes',
				EndsAtOpenEnded: () => 'Ingen sluttdato',
				Rank: () => 'Rangering',
				Items: () => 'Elementer'
			},
			Action: {
				Publish: () => 'Publiser',
				Unpublish: () => 'Avpubliser',
				Save: () => 'Lagre endringer',
				Delete: () => 'Slett',
				Duplicate: () => 'Dupliser',
				AddItem: () => 'Legg til element',
				MoveUp: () => 'Flytt opp',
				MoveDown: () => 'Flytt ned'
			},
			Validation: {
				StartsAtRequired: () => 'Startdato kreves for å publisere',
				EndsAtAfterStartsAt: () => 'Sluttdato må være etter startdato'
			},
			Item: {
				NoItems: () => 'Ingen elementer ennå',
				NoItemsDescription: () =>
					'Legg til en banner, liste, modal eller skille for å begynne å bygge denne kampanjen.'
			},
			Link: {
				TypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK' | 'IMAGE') =>
					(v => {
						switch (v) {
							case 'NONE':
								return 'Ingen'
							case 'BROWSER':
								return 'Nettadresse'
							case 'DEEP_LINK':
								return 'Dypkobling'
							case 'IMAGE':
								return 'Bildeforhåndsvisning'
							default:
								return String(v)
						}
					})(arg0),
				BrowserUrl: () => 'URL',
				DeepLink: () => 'Dypkoblingssti',
				ImageUrl: () => 'Bilde-URL',
				ImageSource: () => 'Bilde å forhåndsvise',
				ImageSourceHelp: () => 'Forstørr bannerets eget bilde, eller pek på et annet bilde.',
				ImageSourceEnum: (arg0: 'BANNER' | 'CUSTOM') =>
					(v => {
						switch (v) {
							case 'BANNER':
								return 'Bruk bannerets bilde'
							case 'CUSTOM':
								return 'Egendefinert bilde-URL'
							default:
								return String(v)
						}
					})(arg0)
			},
			Help: {
				MarketingChannel: () => 'Hvilken gruppe salgskanaler som ser denne kampanjen.',
				Status: () => 'Utkast er skjult i appen. Publiserte kampanjer vises i planlagt periode.',
				Schedule: () =>
					'Valgfritt. La start stå tom for å vise umiddelbart, og slutt tom for å kjøre uendelig. Utløpte kampanjer skjules automatisk.',
				StartsAt: () => 'Standard er 00:00 på dagen du velger. La stå tom for å vise umiddelbart.',
				EndsAt: () => 'Standard er 23:59 på dagen du velger. La stå tom for å kjøre uendelig.',
				Rank: () => 'Når flere kampanjer er aktive samtidig, vises høyere rangering først.',
				Items: () => 'Elementer vises ovenfra og ned i kundeappen, i nøyaktig denne rekkefølgen.'
			},
			Preview: {
				Title: () => 'Forhåndsvisning',
				Empty: () => 'Legg til elementer for å forhåndsvise hvordan kampanjen ser ut i appen.',
				Disclaimer: () => 'Omtrentlig forhåndsvisning av kundeappens startskjerm.'
			},
			AdvancedOptions: () => 'Avanserte alternativer',
			BannerTypeEnum: (arg0: 'IMAGE' | 'TEXT_WITH_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'IMAGE':
							return 'Bilde'
						case 'TEXT_WITH_BACKGROUND':
							return 'Tekst med bakgrunn'
						default:
							return String(v)
					}
				})(arg0),
			BannerText: () => 'Tekst',
			ListImages: () => 'Listebilder',
			AddImage: () => 'Legg til bilde',
			AddImages: () => 'Legg til bilder',
			AddImagesCount: (args: { count: number }) =>
				'Legg til ' + String(args.count) + ' ' + plural('nb', args.count, { one: 'bilde', other: 'bilder' }),
			ThumbnailLinkTypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Forhåndsvisning av bilde'
						case 'BROWSER':
							return 'Nettleser-URL'
						case 'DEEP_LINK':
							return 'Dyplenke'
						default:
							return String(v)
					}
				})(arg0),
			JoinAbove: () => 'Slå sammen med blokken over',
			ShowTitle: () => 'Vis tittel',
			ShowTitleHelp: () => 'Valgfri overskrift som vises over dette elementet i appen.',
			ListImageShape: () => 'Bildeform',
			ListImageShapeEnum: (arg0: 'SQUARE' | 'PORTRAIT' | 'LANDSCAPE') =>
				(v => {
					switch (v) {
						case 'SQUARE':
							return 'Kvadrat'
						case 'PORTRAIT':
							return 'Portrett'
						case 'LANDSCAPE':
							return 'Landskap'
						default:
							return String(v)
					}
				})(arg0),
			ListImageSize: () => 'Bildestørrelse',
			ListImageSizeHelp: () => 'En del av neste bilde forblir synlig, så kundene vet at de kan bla.',
			ListImageSizeEnum: (arg0: 'LARGE' | 'MEDIUM' | 'SMALL') =>
				(v => {
					switch (v) {
						case 'LARGE':
							return 'Stor'
						case 'MEDIUM':
							return 'Middels'
						case 'SMALL':
							return 'Liten'
						default:
							return String(v)
					}
				})(arg0),
			ModalCover: () => 'Forsidebilde for modal',
			ContainerClassName: () => 'Container-klassenavn',
			CustomInfo: () => 'Tilpassede elementer gjengis av kundeappen. Det finnes ingen redigerbare felter her.',
			TapAction: () => 'Når trykket',
			TapActionHelp: () =>
				'Hvor banneret går når det trykkes, eller en innebygd handling i stedet. Innebygde handlinger erstatter navigering.',
			TapActionNavigate: () => 'Naviger',
			TapActionBuiltIn: () => 'Innebygd',
			PromotionAction: () => 'Trykkhandling',
			PromotionActionHelp: () => 'Valgfri innebygd oppførsel når banneret trykkes, som overstyrer lenken.',
			PromotionActionEnum: (arg0: 'NONE' | 'ADD_LOYALTY_CARD_TO_WALLET' | 'LOYALTY_CARD_INFO') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Ingen'
						case 'ADD_LOYALTY_CARD_TO_WALLET':
							return 'Legg lojalitetskort i lommebok'
						case 'LOYALTY_CARD_INFO':
							return 'Vis lojalitetskortinfo'
						default:
							return String(v)
					}
				})(arg0)
		},
		Placement: {
			Title: () => 'Plasseringer',
			Help: () =>
				'En plassering er denne kampanjens innhold på én markedsføringskanal. Legg til en plassering per kanal som skal vise denne kampanjen.',
			Add: () => 'Legg til plassering',
			Empty: () => 'Legg til en plassering for å definere hva denne kampanjen viser på en kanal.',
			Count: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'plassering', other: 'plasseringer' }),
			Rank: () => 'Rangering',
			RankHelp: () => 'Når flere kampanjer er aktive samtidig, vises høyere rangering først i feeden.',
			Delete: () => 'Fjern plassering',
			DeleteConfirm: () => 'Fjerne denne plasseringen? Innholdet blir slettet.'
		},
		Layout: {
			Title: () => 'Feed-oppsett',
			Help: () =>
				'Den faste strukturen i denne kanalens feed. Statiske blokker (bannere, lenker, skiller) vises alltid, og kampanjesonen markerer hvor aktivt kampanjeinnhold settes inn.',
			AddCampaignZone: () => 'Legg til kampanjesone',
			CampaignZone: () => 'Kampanjesone',
			CampaignZoneHint: () => 'Aktive kampanjer vises her',
			DrawerHint: () => 'Ordne de faste blokkene og kampanjesonen for denne kanalen',
			UnsavedConfirm: () => 'Du har ulagrede endringer som vil gå tapt. Fortsette til feed-oppsettet?',
			PreviewModeLayout: () => 'Oppsett',
			PreviewModeLive: () => 'Direkte-feed',
			LivePreviewHint: () => 'Den publiserte feeden kundene ser nå, inkludert aktive kampanjer.',
			CheckoutPreviewHint: () =>
				'Det denne utgangsskjermen viser akkurat nå. Planlagte bakgrunner vises bare i sitt tidsvindu.'
		},
		Content: {
			Title: () => 'Innhold',
			NewContent: () => 'Nytt innhold',
			NoContent: () => 'Ingen innhold ennå',
			NoContentDescription: () =>
				'Opprett en innholdsblokk, og legg den deretter til i et kanaloppsett for å gjøre den aktiv.',
			NoMatches: () => 'Ingen innhold samsvarer',
			NoMatchesDescription: () => 'Ingen innhold samsvarer med gjeldende søk og filtre.',
			ClearFilters: () => 'Fjern filtre',
			ChannelFilter: () => 'Markedsføringskanal',
			TypeOption: (arg0: 'ALL' | 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'ALL':
							return 'Alle'
						case 'FEED':
							return 'Kundeapp-feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Kasseskjerm'
						default:
							return String(v)
					}
				})(arg0),
			BlockCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('nb', args.count, { one: 'blokk', other: 'blokker' }),
			LayoutCount: (args: { count: number }) =>
				'I ' + String(args.count) + ' ' + plural('nb', args.count, { one: 'oppsett', other: 'oppsett' }),
			NotInLayout: () => 'Ikke i noe oppsett',
			DeleteConfirm: () => 'Slette dette innholdet? Det fjernes fra alle kanaloppsett.',
			DuplicateSuccess: () => 'Innhold duplisert',
			Blocks: () => 'Blokker',
			BlocksHelp: () => 'Blokker vises ovenfra og ned i kundeappen, i nøyaktig denne rekkefølgen.',
			SaveDraft: () => 'Lagre som utkast',
			SaveAndPublish: () => 'Lagre og publiser',
			SaveSuccess: () => 'Endringer lagret',
			PublishSuccess: () => 'Innhold publisert',
			UnpublishSuccess: () => 'Innhold avpublisert',
			UnsavedChanges: () => 'Ulagrede endringer',
			DraftNotice: () => 'Dette innholdet er et utkast og vises ikke for kunder. Publiser det når du er klar.',
			ExpiredTitle: () => 'Dette innholdet er utløpt',
			ExpiredNotice: (arg0: DateInput) =>
				'Dette innholdet utløp ' +
				dateAndTimeFormatter('nb', arg0) +
				' og vises ikke for kunder. Gi det en ny tidsplan for å kjøre det igjen.',
			ExpiredSaveConfirm: () =>
				'Dette innholdet er allerede utløpt, så det forblir skjult for kunder. Lagre det med nåværende tidsplan likevel?',
			SaveAnyway: () => 'Lagre likevel',
			ClearEndDate: () => 'Fjern sluttdato',
			RunToday: () => 'Kjør i dag',
			NewFeedContent: () => 'Kundeapp-feed',
			NewFeedContentHint: () => 'Bannere, bildelister og mer for feeden i kundeappen',
			NewCheckoutBackground: () => 'Kasseskjerm',
			NewCheckoutBackgroundHint: () => 'Ett fullskjermbilde for utgangsskjermen ved selvbetjening',
			Format: (arg0: 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'FEED':
							return 'Kundeapp-feed'
						case 'CHECKOUT_BACKGROUND':
							return 'Kasseskjerm'
						default:
							return String(v)
					}
				})(arg0),
			BackgroundImage: () => 'Bakgrunnsbilde',
			BackgroundHelp: () =>
				'Fyller hele utgangsskjermen ved selvbetjening. På skjermene for posekontroll og utgang erstatter det den innebygde meldingen, så bildet selv må fortelle kunden hva de skal gjøre. Liggende bilder fungerer best.',
			BackgroundEmpty: () =>
				'Ingen bilde ennå. Velg et fra markedsføringsbiblioteket, ellers vises ingenting på utgangsskjermen.'
		},
		ContentLayout: {
			Title: () => 'Oppsett',
			Help: () =>
				'Sorter det publiserte innholdet for en kanal. Dette er feeden kundene ser, ovenfra og ned. Planlagt innhold vises kun i sitt tidsvindu.',
			SelectChannel: () => 'Kanal',
			NoChannels: () => 'Opprett en markedsføringskanal før du setter opp et oppsett.',
			GoToChannels: () => 'Gå til markedsføringskanaler',
			AvailableTitle: () => 'Tilgjengelig innhold',
			NoAvailable: () => 'Alt innhold er allerede i dette oppsettet.',
			InLayoutTitle: () => 'I dette oppsettet',
			Empty: () => 'Ingen innhold i dette oppsettet ennå. Legg til innhold fra listen for å bygge feeden.',
			Add: () => 'Legg til i oppsett',
			Remove: () => 'Fjern fra oppsett',
			Save: () => 'Lagre oppsett',
			Saved: () => 'Oppsett lagret',
			PreviewTitle: () => 'Forhåndsvisning av live feed',
			SingleContentWarning: () =>
				'Denne skjermen vises bare i noen sekunder, så bare det første elementet vises. Behold ett element her.',
			CheckoutHelp: () =>
				'Velg bakgrunnene som vises på denne utgangsskjermen. Flere bakgrunner på venteskjermen roterer; skjermene for posekontroll og utgang viser bare den første, i stedet for den innebygde meldingen.',
			AvailableBackgroundsTitle: () => 'Tilgjengelige bakgrunner',
			NoBackgrounds: () => 'Ingen bakgrunner ennå. Lag en for å vise den på denne skjermen.',
			NewBackground: () => 'Ny bakgrunn',
			NewBackgroundTitle: () => 'Ny bakgrunn for utgangsskjerm',
			NewBackgroundDescription: () =>
				'Velg et bilde fra markedsføringsbiblioteket. Det publiseres med en gang og legges til denne skjermen.',
			NewBackgroundCreate: () => 'Opprett og legg til',
			NewBackgroundCreated: () => 'Bakgrunn lagt til. Lagre oppsettet for å gjøre den aktiv.',
			WrongFormatOnCheckout: () =>
				'Innhold for kundeapp-feed vises ikke på utgangsskjermen. Fjern det og legg til en bakgrunn i stedet.',
			WrongFormatOnFeed: () =>
				'Bakgrunner for utgangsskjerm vises ikke i feeden i kundeappen. Fjern den fra dette oppsettet.',
			RemoveFlaggedToSave: () => 'Fjern de merkede elementene for å lagre oppsettet.'
		},
		Surface: {
			Label: () => 'Flate',
			CustomerAppFeed: () => 'Kundeapp-feed',
			CheckoutScreen: () => 'Kasseskjerm'
		},
		ScreenState: {
			Label: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Standard'
						case 'CHECKOUT_IDLE':
							return 'Inaktiv'
						case 'CHECKOUT_BAG_CHECK':
							return 'Veskekontroll'
						case 'CHECKOUT_CLEARED':
							return 'Klarert'
						default:
							return String(v)
					}
				})(arg0),
			Hint: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Vises alltid'
						case 'CHECKOUT_IDLE':
							return 'Mens man venter på at en kunde skal skanne'
						case 'CHECKOUT_BAG_CHECK':
							return 'Når en veskekontroll av ansatt kreves'
						case 'CHECKOUT_CLEARED':
							return 'Når kunden kan forlate'
						default:
							return String(v)
					}
				})(arg0)
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Veskekontroll kreves',
			BagCheckBody: () => 'En ansatt kommer og sjekker ut handlekurven din',
			ClearedTitle: () => 'Alt i orden',
			ClearedBody: () => 'Du kan gå nå',
			Disclaimer: () => 'Omtrentlig forhåndsvisning av utgangsskjermen.',
			FallbackHint: () => 'Ingen bakgrunn er valgt, så skjermen viser den innebygde meldingen.'
		},
		LibraryPage: {
			NoAssets: () => 'Ingen markedsføringsressurser ennå',
			NoAssetsDescription: () => 'Last opp bilder, bannere og andre markedsføringsvisuelle her.',
			Filename: () => 'Filnavn',
			TableView: () => 'Tabellvisning',
			GalleryView: () => 'Gallerivisning',
			Upload: () => 'Last opp',
			SearchFilename: () => 'Søk etter filnavn',
			ViewFullImage: () => 'Vis hele bildet',
			CopyUrl: () => 'Kopier URL',
			CopiedUrl: () => 'URL kopiert',
			DeleteAsset: () => 'Slett ressurs',
			DeleteAssetConfirm: () => 'Slett denne ressursen? Det kan ikke angres.',
			UploadAssets: () => 'Last opp ressurser',
			UploadDropzone: () => 'Dra og slipp bilder her, eller klikk for å velge filer',
			ChooseFiles: () => 'Velg filer',
			Tags: () => 'Etiketter',
			UsedBy: () => 'Brukt av',
			UsageFilter: () => 'Bruk',
			UsageUnused: () => 'Ubrukt',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgruppe',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Markedsføringsinnhold',
			UsageFeedLayout: () => 'Kundeapp-feed',
			ChannelFilter: () => 'Markedsføringskanal',
			ContentFilter: () => 'Brukt av innhold',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Uten innhold',
			TagsPlaceholder: () => 'Skriv en etikett og trykk Enter',
			Uploading: () => 'Laster opp',
			EditTags: () => 'Rediger etiketter',
			NoTags: () => 'Ingen etiketter',
			ManageTags: () => 'Administrer etiketter',
			ManageTagsEmpty: () => 'Ingen etiketter i biblioteket ennå.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' ressurser',
			CreateTag: () => 'Opprett etikett',
			CreateTagPlaceholder: () => 'Skriv en etikett og trykk Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Etiketten «' + String(args.tag) + '» ble opprettet.',
			RenameTag: () => 'Gi etikett nytt navn',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Slå sammen etiketten «' +
				String(args.from) +
				'» med «' +
				String(args.to) +
				'» (' +
				String(args.count) +
				' ressurser)? Den gamle etiketten fjernes.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Etikett omdøpt fra «' + String(args.from) + '» til «' + String(args.to) + '».',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Fjerne etiketten «' + String(args.tag) + '» fra alle ressurser? Filene slettes ikke.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Etikett fjernet fra ' +
				String(args.count) +
				' ' +
				plural('nb', args.count, { one: 'ressurs', other: 'ressurser' }) +
				'.'
		}
	},
	Settings: {
		Title: () => 'Innstillinger',
		Sidebar: {
			Profile: () => 'Profil',
			Store: () => 'Butikk',
			Users: () => 'Brukere',
			SalesChannels: () => 'Salgskanaler',
			PointOfSale: () => 'Salgssted',
			ProductGroups: () => 'Produktgrupper',
			Exports: () => 'Eksporter',
			Analytics: () => 'Analyser',
			Companies: () => 'Bedrifter',
			CompanyCards: () => 'Bedriftskort',
			Settlements: () => 'Oppgjør'
		},
		Profile: {
			Title: () => 'Profil',
			EditTitle: () => 'Rediger profil',
			PersonalInfo: () => 'Personlig informasjon',
			Preferences: () => 'Preferanser',
			NamePlaceholder: () => 'Skriv inn navn',
			EmailPlaceholder: () => 'Skriv inn e-post',
			UpdateSuccess: () => 'Profil oppdatert',
			Edit: {
				Description: () => 'Rediger profilinformasjonen din'
			}
		},
		Users: {
			Title: () => 'Brukere',
			InviteUser: () => 'Opprett invitasjon',
			InviteTitle: () => 'Opprett invitasjon',
			InviteSuccess: () => 'Invitasjon opprettet',
			InviteSentTo: (args: { email: string }) => 'Invitasjon sendt til ' + String(args.email),
			SendInvite: () => 'Opprett invitasjon',
			CopyInviteLink: () => 'Kopier invitasjonslenke',
			DeleteUserDescription: (args: { email: string }) =>
				'Fjerne ' + String(args.email) + '? Brukeren kan ikke logge inn lenger.',
			DeleteUserSuccess: () => 'Bruker fjernet',
			EditTitle: () => 'Rediger bruker',
			EditSuccess: () => 'Bruker oppdatert',
			DeleteInviteDescription: (args: { email: string }) => 'Fjerne invitasjonen for ' + String(args.email) + '?',
			DeleteInviteSuccess: () => 'Invitasjon fjernet',
			Status: {
				Accepted: () => 'Godtatt',
				Pending: () => 'Venter',
				Expired: () => 'Utløpt'
			},
			Type: {
				User: () => 'Bruker',
				Invite: () => 'Invitasjon'
			},
			Column: {
				Type: () => 'Type'
			},
			Role: {
				Admin: () => 'Administrator',
				User: () => 'Bruker'
			},
			Invite: {
				Description: () => 'Inviter en ny bruker til butikken din',
				EmailPlaceholder: () => 'Skriv inn e-postadresse',
				NamePlaceholder: () => 'Skriv inn navn',
				UserInfo: () => 'Brukerinformasjon',
				UserAlreadyExists: (args: { email: string }) =>
					'En bruker med e-postadressen ' + String(args.email) + ' finnes allerede'
			},
			Detail: {
				Title: () => 'Brukerdetaljer',
				AdminOnly: () => 'Kun administratorer kan se invitasjonsdetaljer.'
			},
			SignInCredentials: {
				Title: () => 'Påloggingslegitimasjon',
				Description: () =>
					'Angi pålogging-ID og PIN som brukes for å logge inn på selvbetjenings- og POS-terminaler.',
				SignInId: () => 'Pålogging-ID',
				SignInIdPlaceholder: () => 'f.eks. 1042',
				SignInIdHint: () =>
					'Kun tall. Kreves kun for noe maskinvare, som selvbetjeningskasser. La stå tomt hvis denne brukeren ikke logger på slik maskinvare.',
				Pin: () => 'PIN',
				PinSet: () => 'En PIN er angitt',
				PinNotSet: () => 'Ingen PIN angitt',
				NewPin: () => 'Ny PIN (6 sifre)',
				PinPlaceholder: () => 'La stå tom for å beholde nåværende PIN',
				ClearPin: () => 'Fjern PIN',
				Save: () => 'Lagre',
				SaveSuccess: () => 'Legitimasjon oppdatert',
				SignInIdNumeric: () => 'Pålogging-ID må være numerisk',
				SignInIdTaken: () => 'Pålogging-ID er allerede i bruk',
				PinInvalid: () => 'PIN må være nøyaktig 6 sifre'
			}
		},
		SalesChannels: {
			Title: () => 'Salgskanaler',
			CreateTitle: () => 'Opprett salgskanal',
			CreateSuccess: () => 'Salgskanal opprettet',
			EditTitle: () => 'Rediger salgskanal',
			EditSuccess: () => 'Salgskanal oppdatert',
			Column: {
				CountryCode: () => 'Land',
				CurrencyCode: () => 'Valuta',
				SalesChannelType: () => 'Type',
				FulfillmentProvider: () => 'Leveringsleverandør',
				AccessKeys: () => 'Tilgangsnøkler',
				InventoryLocation: () => 'Lagerplassering',
				Group: () => 'Gruppe'
			},
			InventoryLocationNone: () => 'Ingen',
			InventoryLocationOptionalHint: () =>
				'Valgfritt. Koble denne kanalen til en lagerplassering for å spore lager. La stå tom hvis lager ikke brukes.',
			SalesChannelTypeNone: () => 'Ingen',
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valgfritt. Tildel denne kanalen til en gruppe for å organisere relaterte kanaler sammen.',
			Advanced: () => 'Avanserte innstillinger',
			TypeOptionalHint: () =>
				'Valgfritt. Tildel en type kun for å gruppere kanaler som deler leverings- eller forhåndsautoriseringsinnstillinger. La stå som Ingen hvis du er usikker.',
			StorefrontUrl: () => 'Nettbutikk-URL',
			StorefrontUrlHint: () =>
				'Valgfritt. Grunn-URL for denne leietakerens nettbutikk. Angi dette for at Terminal-POS skal vise en "Få kvittering"-QR-kode etter betaling; la stå tomt for å skjule den.',
			Groups: {
				Title: () => 'Salgskanalgrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Opprett gruppe',
				CreateSuccess: () => 'Gruppe opprettet',
				EditTitle: () => 'Rediger gruppe',
				EditSuccess: () => 'Gruppe oppdatert',
				NamePlaceholder: () => 'Skriv inn gruppenavn',
				Column: {
					Name: () => 'Navn',
					MemberCount: () => 'Salgskanaler'
				},
				Members: {
					Title: () => 'Salgskanaler',
					Label: () => 'Salgskanaler',
					Placeholder: () => 'Velg salgskanaler',
					Empty: () => 'Ingen salgskanaler tildelt ennå.',
					Assigned: () => 'Tildelt',
					FilterUnassigned: () => 'Uten gruppe',
					SaveSuccess: () => 'Salgskanaler oppdatert',
					MoveWarning: {
						Title: () => 'Flytte salgskanaler mellom grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' av de valgte salgskanalene tilhører allerede en annen gruppe og flyttes hit: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Slett gruppe',
					Description: (args: { name: string }) =>
						'Er du sikker på at du vil slette gruppen "' +
						String(args.name) +
						'"? Salgskanalene blir fjernet fra gruppen, men ikke slettet.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' ble slettet.'
				}
			},
			Create: {
				BasicInfo: () => 'Grunnleggende informasjon',
				Description: () => 'Opprett en ny salgskanal',
				NamePlaceholder: () => 'Skriv inn kanalnavn'
			},
			Edit: {
				ApiNotAvailable: () => 'API ikke tilgjengelig',
				NotImplemented: () => 'Ikke implementert ennå'
			},
			Detail: {
				Title: () => 'Salgskanaldetaljer',
				AccessKeys: () => 'Tilgangsnøkler',
				CreateAccessKey: () => 'Opprett tilgangsnøkkel',
				CreateAccessKeySuccess: () => 'Tilgangsnøkkel opprettet',
				PointOfSales: () => 'Salgssteder',
				PointOfSalesDescription: () => 'Administrer salgssteder for denne kanalen'
			},
			AccessKeyType: {
				Title: () => 'Nøkkeltype',
				Publishable: () => 'Publiserbar nøkkel',
				PublishableDescription: () => 'For klientsidebruk (POS-terminaler, nettbutikker)',
				Api: () => 'API-nøkkel',
				ApiDescription: () => 'For serversideintegrasjoner'
			},
			TokenCreated: {
				Title: () => 'API-nøkkel opprettet',
				Description: () =>
					'Denne tokenen kan bare vises én gang. Vennligst lagre den før du lukker denne dialogen.',
				Token: () => 'API-token'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nøkkel'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Tilgangsnøkler',
			NavLabel: () => 'Tilgangsnøkler',
			Manage: () => 'Administrer',
			Create: () => 'Opprett tilgangsnøkkel',
			EditTitle: () => 'Rediger tilgangsnøkkel',
			None: () => '—',
			SaveSuccess: () => 'Tilgangsnøkkel oppdatert',
			DeleteConfirm: () => 'Slette denne tilgangsnøkkelen? Apper som bruker den slutter å virke.',
			DeleteSuccess: () => 'Tilgangsnøkkel slettet',
			Column: {
				Key: () => 'Nøkkel',
				SalesChannels: () => 'Salgskanaler',
				MarketingChannel: () => 'Markedskanal'
			},
			Empty: {
				Title: () => 'Ingen tilgangsnøkler',
				Description: () => 'Opprett en publiserbar nøkkel og knytt den til salgskanaler og en markedskanal.'
			},
			Field: {
				SalesChannels: () => 'Salgskanaler',
				SalesChannelsPlaceholder: () => 'Velg salgskanaler',
				SalesChannelsRequired: () => 'Velg minst én salgskanal',
				MarketingChannel: () => 'Markedskanal',
				MarketingChannelPlaceholder: () => 'Velg en markedskanal',
				DevelopmentMode: () => 'Utviklermodus',
				DevelopmentModeHint: () =>
					'Låser opp utviklerverktøy (innstillingsskjermer + OTA-oppdateringskontroller) i medarbeiderappen for kiosker paret med denne nøkkelen.'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Salgskanaltyper',
			NavLabel: () => 'Typer',
			CreateTitle: () => 'Opprett salgskanaltype',
			CreateSuccess: () => 'Salgskanaltype opprettet',
			EditTitle: () => 'Rediger salgskanaltype',
			EditSuccess: () => 'Salgskanaltype oppdatert',
			Column: {
				FulfillmentProvider: () => 'Leveringsleverandør',
				PreauthorizationAmount: () => 'Forhåndsautorisert beløp',
				AllowCompletingUnderpaidOrders: () => 'Tillat fullføring av underbetalte bestillinger'
			},
			FulfillmentProviderNone: () => 'Ingen',
			InvalidPreauthorizationAmount: () => 'Skriv inn et gyldig ikke-negativt tall',
			AllowCompletingUnderpaidOrdersHint: () =>
				'Fullfør en bestilling selv om det innkrevde beløpet er lavere enn totalbeløpet. Kun for engangsbetalingsflyter (f.eks. SandStar-kjøleskapet) der det ikke finnes en ny sjanse til å belaste mer.',
			Create: {
				NamePlaceholder: () => 'Skriv inn typenavn'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Måleenheter',
			NavLabel: () => 'Måleenheter',
			Description: () =>
				'Felles enheter som brukes på tvers av alle produkter. Hvert produkt velger blant disse når pakkestørrelser legges til.',
			CreateTitle: () => 'Opprett måleenhet',
			CreateSuccess: () => 'Enhet opprettet',
			EditTitle: () => 'Rediger måleenhet',
			EditSuccess: () => 'Enhet oppdatert',
			Column: {
				Code: () => 'Kode',
				Name: () => 'Navn',
				Quantity: () => 'Standardantall',
				Default: () => 'Standard'
			},
			Code: () => 'Kode',
			Name: () => 'Navn',
			Quantity: () => 'Standardantall',
			QuantityHint: () =>
				'Felles antall i basisenheter (f.eks. er en 6-pakning 6). La stå tomt for variable pakker.',
			DefaultEach: () => 'Standardenhet for talte varer',
			DefaultWeight: () => 'Standardenhet for veide varer',
			DefaultEachBadge: () => 'Standard · stk',
			DefaultWeightBadge: () => 'Standard · vekt',
			CodePlaceholder: () => 'f.eks. PK6',
			NamePlaceholder: () => 'f.eks. 6-pakning',
			ManagedBySync: () => 'Styres av synkronisering',
			ManagedBySyncHint: () => 'Denne enheten styres av en ekstern integrasjon og kan ikke redigeres her.',
			InvalidCode: () => 'Kode er påkrevd',
			InvalidQuantity: () => 'Antall må være større enn null',
			InUse: () => 'I bruk',
			Delete: {
				Title: () => 'Slett enhet',
				Description: (args: { code: string }) => 'Slette ' + String(args.code) + '? Dette kan ikke angres.'
			}
		},
		PointOfSale: {
			Title: () => 'Salgssted',
			CreateTitle: () => 'Opprett salgssted',
			CreateSuccess: () => 'Salgssted opprettet',
			EditTitle: () => 'Rediger salgssted',
			EditSuccess: () => 'Salgssted oppdatert',
			AllowedOperatingModesLabel: () => 'Tillatte driftsmoduser',
			SelectOperatingModes: () => 'Velg driftsmoduser',
			OperatingMode: (arg0: 'ADMIN' | 'POS' | 'BAG_CHECK' | 'SCO' | 'INVENTORY' | 'TERMINAL' | 'CHECKOUT') =>
				(v => {
					switch (v) {
						case 'ADMIN':
							return 'Admin'
						case 'POS':
							return 'Salgssted'
						case 'BAG_CHECK':
							return 'Posekontroll'
						case 'SCO':
							return 'Selvbetjening'
						case 'INVENTORY':
							return 'Lager'
						case 'TERMINAL':
							return 'Terminal'
						case 'CHECKOUT':
							return 'Utsjekk'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamLevelLabel: () => 'Streaming av enhetslogger',
			LogStreamLevel: (arg0: 'OFF' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG') =>
				(v => {
					switch (v) {
						case 'OFF':
							return 'Av'
						case 'ERROR':
							return 'Feil'
						case 'WARN':
							return 'Advarsel'
						case 'INFO':
							return 'Info'
						case 'DEBUG':
							return 'Feilsøking'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamIdLabel: () => 'Overstyr loggstrøm-ID',
			LogStreamIdPlaceholder: () => 'Standard er identifikatoren over',
			LogStreamIdInvalidChars: () => 'Kan ikke inneholde ":" eller "*"',
			LogStreamIdTooLong: () => 'For langt',
			ForcedOrientationLabel: () => 'Tvungen retning',
			ForcedOrientationHint: () => 'Låser skjermen på enheten. Automatisk følger enheten.',
			ForcedOrientationAutomatic: () => 'Automatisk',
			ForcedOrientation: (
				arg0: 'portrait' | 'portrait-reverse' | 'landscape' | 'landscape-reverse' | 'default'
			) =>
				(v => {
					switch (v) {
						case 'portrait':
							return 'Stående'
						case 'portrait-reverse':
							return 'Stående opp-ned'
						case 'landscape':
							return 'Liggende'
						case 'landscape-reverse':
							return 'Liggende omvendt'
						case 'default':
							return 'Ulåst'
						default:
							return String(v)
					}
				})(arg0),
			SafeAreaInsetsLabel: () => 'Overstyring av sikker sone (px)',
			SafeAreaInsetsHint: () =>
				'For enheter der OS-et rapporterer feil sikker sone (f.eks. alltid 0). La en side stå tom for å bruke den reelle verdien.',
			SafeAreaInsetTop: () => 'Topp',
			SafeAreaInsetRight: () => 'Høyre',
			SafeAreaInsetBottom: () => 'Bunn',
			SafeAreaInsetLeft: () => 'Venstre',
			Column: {
				Identifier: () => 'Identifikator',
				AccessKeys: () => 'Tilgangsnøkler',
				Group: () => 'Gruppe'
			},
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valgfritt. Tildel dette salgsstedet til en gruppe for å organisere relaterte terminaler sammen.',
			LinkSalesChannelButton: () => 'Koble til',
			LinkSalesChannelTitle: () => 'Koble til en salgskanal',
			LinkSalesChannelDescription: () => 'Legg til en salgskanal på dette salgsstedet.',
			LinkSalesChannelSuccess: () => 'Salgskanal koblet til',
			SelectSalesChannel: () => 'Velg en salgskanal',
			NoUnlinkedSalesChannels: () => 'Alle salgskanaler er allerede koblet til.',
			Create: {
				BasicInfo: () => 'Grunnleggende informasjon',
				Description: () => 'Opprett et nytt salgssted',
				NamePlaceholder: () => 'Skriv inn stedsnavn',
				SelectSalesChannels: () => 'Velg salgskanaler',
				IdentifierPlaceholder: () => 'Skriv inn identifikator'
			},
			Groups: {
				Title: () => 'Salgsstedgrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Opprett gruppe',
				CreateSuccess: () => 'Gruppe opprettet',
				EditTitle: () => 'Rediger gruppe',
				EditSuccess: () => 'Gruppe oppdatert',
				NamePlaceholder: () => 'Skriv inn gruppenavn',
				Column: {
					Name: () => 'Navn',
					MemberCount: () => 'Salgssteder'
				},
				Members: {
					Title: () => 'Salgssteder',
					Label: () => 'Salgssteder',
					Placeholder: () => 'Velg salgssteder',
					Empty: () => 'Ingen salgssteder tildelt ennå.',
					Assigned: () => 'Tildelt',
					FilterUnassigned: () => 'Uten gruppe',
					SaveSuccess: () => 'Salgssteder oppdatert',
					MoveWarning: {
						Title: () => 'Flytte salgssteder mellom grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' av de valgte salgsstedene tilhører allerede en annen gruppe og flyttes hit: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Slett gruppe',
					Description: (args: { name: string }) =>
						'Er du sikker på at du vil slette gruppen "' +
						String(args.name) +
						'"? Salgsstedene blir fjernet fra gruppen, men ikke slettet.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' ble slettet.'
				}
			},
			Detail: {
				Title: () => 'Salgsstedsdetaljer',
				AccessKeys: () => 'Tilgangsnøkler'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nøkkel'
				}
			},
			ProductMenu: {
				Title: () => 'Produktmeny',
				Description: () => 'Produktgrupper som vises på dette salgsstedet.',
				EmptyTitle: () => 'Ingen menygrupper',
				EmptyDescription: () => 'Legg til produktgrupper for å bygge menyen på dette salgsstedet.',
				EditHeader: () => 'Produktmeny',
				EditDescription: () =>
					'Legg til produktgruppene som vises på dette salgsstedet og velg hvordan hver enkelt vises.',
				AddPlaceholder: () => 'Legg til en produktgruppe…',
				NoGroupsSelected: () => 'Ingen produktgrupper lagt til ennå.',
				IconLabel: () => 'Reserveikon',
				IconPlaceholder: () => 'Velg et reserveikon…',
				IconNone: () => 'Ingen',
				IconUsesImageHint: () =>
					'Denne gruppen har et bilde som vises på menyen i stedet for et reserveikon. Rediger bildet på produktgruppen.',
				IconNotUsedWhenIndividual: () => 'Brukes ikke når produkter vises enkeltvis på menyen.',
				ShowIndividually: () => 'Vis produkter enkeltvis',
				ShowIndividuallyHint: () => 'Produkter vises direkte på menyen i stedet for inne i en gruppe.',
				ShownIndividuallyBadge: () => 'Produkter vises enkeltvis',
				SaveSuccess: () => 'Meny oppdatert.',
				Icons: {
					ShoppingBag: () => 'Handlepose',
					ShoppingCart: () => 'Handlekurv',
					Coffee: () => 'Kaffe',
					CupSoda: () => 'Kald drikke',
					Utensils: () => 'Tilberedt mat',
					Pizza: () => 'Pizza',
					Sandwich: () => 'Sandwich',
					IceCream: () => 'Iskrem',
					Beer: () => 'Øl',
					Wine: () => 'Vin',
					Bakery: () => 'Bakeri',
					Gift: () => 'Gave'
				}
			}
		},
		Devices: {
			Title: () => 'Enheter',
			NavLabel: () => 'Enheter',
			AccessKeysEmptyTitle: () => 'Ingen tilgangsnøkler',
			AccessKeysEmptyDescription: () =>
				'Opprett tilgangsnøkler for å la eksterne systemer få tilgang til denne enheten.',
			Identifier: () => 'Identifikator',
			LinkedPointOfSale: () => 'Salgssted',
			NotLinked: () => 'Ikke koblet',
			MarketingChannel: () => 'Markedsføringskanal',
			NoMarketingChannel: () => 'Ingen',
			MarketingChannelDescription: () =>
				'Kampanjer på kasseskjermen hentes via denne markedsføringskanalen. Uavhengig av kobling til salgssted.',
			OperatingModes: () => 'Driftsmoduser',
			StatusColumn: () => 'Status',
			AccessKeysColumn: () => 'Tilgangsnøkler',
			EmptyTitle: () => 'Ingen enheter',
			EmptyDescription: () => 'Opprett en enhet for å komme i gang.',
			CreateTitle: () => 'Opprett enhet',
			CreateSuccess: () => 'Enhet opprettet',
			EditTitle: () => 'Rediger enhet',
			NamePlaceholder: () => 'f.eks. Fremre kasse',
			IdentifierPlaceholder: () => 'La stå tom for å generere en',
			UpdateSuccess: () => 'Enhet oppdatert',
			DeleteButton: () => 'Slett enhet',
			DeleteConfirmTitle: () => 'Slette denne enheten?',
			DeleteConfirmDescription: () =>
				'Dette fjerner enheten og tilbakekaller tilgangsnøklene. Dette kan ikke angres.',
			DeleteSuccess: () => 'Enhet slettet',
			LinkButton: () => 'Koble til salgssted',
			LinkTitle: () => 'Koble til et salgssted',
			LinkDescription: () =>
				'En enhet som fungerer som et salgssted henter salgskanaler og ordrer gjennom det tilkoblede salgsstedet. Tilkobling erstatter enheten som nå fungerer som dette salgsstedet.',
			LinkSuccess: () => 'Enhet tilkoblet',
			SelectPointOfSale: () => 'Velg et salgssted',
			UnlinkButton: () => 'Koble fra',
			UnlinkConfirmTitle: () => 'Koble fra dette salgsstedet?',
			UnlinkConfirmDescription: () => 'Enheten slutter å hente salgskanaler og ordrer til den kobles til igjen.',
			UnlinkSuccess: () => 'Salgssted frakoblet',
			LinkedDevicesTitle: () => 'Enheter',
			LinkedDevicesEmpty: () => 'Ingen enheter er koblet til dette salgsstedet.',
			LinkDeviceButton: () => 'Koble til enhet',
			LinkDeviceDisabledHint: () => 'Fjern koblingen til den nåværende enheten før du kobler til en ny.',
			PointOfSaleOccupiedOption: (arg0: string) => String(arg0) + ' (enhet allerede koblet til)',
			LinkDeviceTitle: () => 'Koble til en enhet',
			LinkDeviceDescription: () => 'Velg en frakoblet enhet som skal fungere som dette salgsstedet.',
			SelectDevice: () => 'Velg en enhet',
			NoUnlinkedDevices: () => 'Ingen frakoblede enheter tilgjengelig.',
			Config: {
				Default: () => 'Standard',
				Enabled: () => 'Aktivert',
				Disabled: () => 'Deaktivert',
				GeneralSection: () => 'Generelt',
				ScoSection: () => 'Selvbetjening',
				SoundsSection: () => 'Lyder',
				LoggingSection: () => 'Logging',
				DisplaySection: () => 'Visning',
				CheckoutSection: () => 'Checkout-modus',
				DefaultPaymentMethod: () => 'Standard betalingsmetode',
				ForcedOrientation: () => 'Tvunget orientering',
				ForcedFormFactor: () => 'Tvunget formfaktor',
				Language: () => 'Språk',
				ShowPrinterDisconnected: () => 'Vis advarsel om frakoblet skriver',
				ProductListColumns: () => 'Kolonner i produktliste',
				BrowseEnabled: () => 'Bla',
				AdjustQuantity: () => 'Juster antall',
				ClearCart: () => 'Tøm handlekurv',
				ItemDeletion: () => 'Slett vare',
				OrderRestart: () => 'Start ordre på nytt',
				Permission: (arg0: 'ENABLED' | 'STAFF_NEEDED' | 'DISABLED') =>
					(v => {
						switch (v) {
							case 'ENABLED':
								return 'Aktivert'
							case 'STAFF_NEEDED':
								return 'Ansatt kreves'
							case 'DISABLED':
								return 'Deaktivert'
							default:
								return String(v)
						}
					})(arg0),
				SplitPercentHorizontal: () => 'Arbeidsområdedeling, horisontal (%)',
				SplitPercentVertical: () => 'Arbeidsområdedeling, vertikal (%)',
				ItemAddedSound: () => 'Lyd ved lagt til vare',
				ProductNotFoundSound: () => 'Lyd ved produkt ikke funnet',
				AddToCartFailedSound: () => 'Lyd ved feil ved tillegging i handlekurv',
				PaymentSuccessSound: () => 'Lyd ved vellykket betaling',
				PaymentFailedSound: () => 'Lyd ved mislykket betaling',
				InactivityThresholdSeconds: () => 'Inaktivitetsgrense (sekunder)',
				AbandonCountdownSeconds: () => 'Nedtelling ved forlatt handlekurv (sekunder)',
				CoolerReadyTimeoutSeconds: () => 'Tidsavbrudd for klar kjøler (sekunder)',
				CheckoutModeIdleTimeoutSeconds: () => 'Tidsavbrudd for inaktiv skanner (sekunder)',
				CheckoutModeTheme: () => 'Temaoverstyring (JSON)',
				CheckoutModeThemeHint: () =>
					'Objekt med valgfrie "colors"- og "fonts"-kart. La stå tomt for grunntemaet.',
				InvalidJson: () => 'Må være et gyldig JSON-objekt'
			}
		},
		DeviceStatus: {
			Title: () => 'Enhetsstatus',
			Online: () => 'Pålogget',
			Offline: () => 'Frakoblet',
			NeverReported: () => 'Dette kassepunktet har aldri rapportert sin status.',
			ReportedAt: () => 'Sist rapportert',
			AppVersion: () => 'Appversjon',
			DisplayRuntimeVersion: () => 'Kjøretidsversjon',
			ConfiguredRuntimeVersion: () => 'Konfigurert kjøretid',
			Platform: () => 'Plattform',
			DeviceModel: () => 'Enhetsmodell',
			NetworkType: () => 'Nettverk',
			UpdateChannel: () => 'Oppdateringskanal',
			UpdateId: () => 'Oppdaterings-ID',
			UpdateCreatedAt: () => 'Oppdatering publisert',
			UpdatePending: (args: { time: string }) => 'Nedlastet, venter på inaktivitet siden ' + String(args.time),
			OperatingMode: () => 'Driftsmodus',
			Health: () => 'Helse',
			PrinterConnected: () => 'Skriver',
			ScannerConnected: () => 'Skanner',
			PaymentTerminalReachable: () => 'Betalingsterminal',
			Connected: () => 'Tilkoblet',
			Disconnected: () => 'Frakoblet',
			Unknown: () => 'Ukjent',
			Environment: () => 'Miljø (redigert)',
			RefreshButton: () => 'Oppdater status',
			RefreshSuccess: () => 'Oppdatering forespurt',
			PushUpdateButton: () => 'Send oppdatering',
			PushUpdateSuccess: () => 'Oppdatering sendt',
			RestartAppButton: () => 'Start appen på nytt',
			RestartAppSuccess: () => 'Restart-kommando sendt',
			RestartAppConfirmTitle: () => 'Starte appen på nytt?',
			RestartAppConfirmDescription: () => 'Appen lastes inn på nytt når terminalen er inaktiv.',
			LockKioskButton: () => 'Lås kiosk',
			LockKioskSuccess: () => 'Kiosklås sendt',
			LockKioskOffline: () => 'Enheten er frakoblet',
			LockKioskConfirmTitle: () => 'Låse denne kiosken?',
			LockKioskConfirmDescription: () =>
				'Kiosken låses med en gang, akkurat som om personalet trykket Lås på enheten.',
			UnlockKioskButton: () => 'Lås opp kiosk',
			UnlockKioskSuccess: () => 'Kiosk-opplåsing sendt',
			UnlockKioskConfirmTitle: () => 'Låse opp denne kiosken?',
			UnlockKioskConfirmDescription: () =>
				'Kiosken låses opp med en gang uten PIN fra personalet. Gjør dette bare hvis du er sikker på at personalet skal ha tilgang.',
			PushUpdateDrawer: {
				Title: () => 'Send appoppdatering',
				Description: () =>
					'Be dette kassepunktet om å se etter og laste ned en oppdatering. Den lastes ned umiddelbart, men starter kun på nytt når terminalen er inaktiv.',
				ChannelLabel: () => 'Overstyr kanal',
				ChannelPlaceholder: () => 'La stå tom for å bruke gjeldende kanal',
				Submit: () => 'Send oppdatering'
			},
			Enrollment: {
				Title: () => 'Registrert enhet',
				NotEnrolled: () => 'Ingen enhet er for øyeblikket registrert for dette kassepunktet.',
				DeviceModel: () => 'Enhetsmodell',
				Platform: () => 'Plattform',
				AppVersion: () => 'Appversjon',
				EnrolledAt: () => 'Registrert',
				Key: () => 'Nøkkel',
				EnrollButton: () => 'Registrer enhet',
				RevokeButton: () => 'Tilbakekall',
				RevokeConfirmTitle: () => 'Tilbakekalle denne enheten?',
				RevokeConfirmDescription: () =>
					'Enheten blir umiddelbart logget ut og må paires på nytt for å få tilgang igjen.',
				RevokeSuccess: () => 'Enhet tilbakekalt',
				EnrollDrawer: {
					Title: () => 'Registrer enhet',
					Description: () => 'Skriv inn den 8-sifrede paringskoden som vises på enheten.',
					CodeLabel: () => 'Paringskode',
					CodePlaceholder: () => '1234 5678',
					LookupButton: () => 'Slå opp enhet',
					LookupError: () => 'Denne koden er ugyldig eller har utløpt.',
					ConfirmTitle: () => 'Registrere denne enheten?',
					ConfirmDescriptionWithCurrent: (args: { device: string; currentDevice: string }) =>
						'Dette utsteder en ny nøkkel til "' +
						String(args.device) +
						'" og logger umiddelbart ut enheten som for øyeblikket er registrert ("' +
						String(args.currentDevice) +
						'").',
					ConfirmDescription: (args: { device: string }) =>
						'Dette utsteder en ny nøkkel til "' + String(args.device) + '".',
					Submit: () => 'Registrer',
					EnrollSuccess: () => 'Enhet registrert'
				}
			},
			Gms: {
				Title: () => 'Android enhetsadministrasjon (GMS)',
				ProviderEloview: () => 'EloView',
				ProviderGms: () => 'GMS',
				NotEnrolled: () => 'Denne enheten er ikke registrert i GMS.',
				EnrollButton: () => 'Registrer enhet',
				EnrollSuccess: () => 'Registrering startet',
				DeviceName: () => 'AMAPI-enhet',
				State: () => 'Status',
				AppliedState: () => 'Anvendt status',
				PolicyCompliant: () => 'Samsvarer med policy',
				NonComplianceReasons: () => 'Årsaker til avvik',
				LastPolicySync: () => 'Siste policysynkronisering',
				InstalledVersionCode: () => 'Installert versjonskode',
				MinimumVersionCode: () => 'Minimum versjonskode (fastsatt)',
				HardwareModel: () => 'Maskinvaremodell',
				AndroidVersion: () => 'Android-versjon',
				NoBoundDevice: () => 'Venter på at enheten skal registreres…',
				Yes: () => 'Ja',
				No: () => 'Nei',
				VersionUnpinned: () => 'Ikke fastsatt (nyeste tilgjengelige)',
				ApplyVersionButton: () => 'Bruk',
				ApplyVersionSuccess: () => 'Minimumsversjon oppdatert',
				WifiNetworks: () => 'Wi-Fi-nettverk',
				WifiAddNetwork: () => 'Legg til nettverk',
				WifiSsid: () => 'Nettverksnavn (SSID)',
				WifiPassword: () => 'Passord',
				WifiSecurityOpen: () => 'Åpent (uten passord)',
				WifiSecurityWpaPsk: () => 'Sikret (WPA/WPA2)',
				WifiHidden: () => 'Skjult nettverk',
				WifiRemove: () => 'Fjern',
				WifiSaveSuccess: () => 'Wi-Fi-nettverk lagret',
				WifiEmpty: () => 'Ingen nettverk konfigurert',
				WifiPasswordKeepHint: () => 'La stå tomt for å beholde nåværende passord',
				PlayTrack: () => 'Play-spor',
				TrackProduction: () => 'Produksjon (standard)',
				ApplyTrackSuccess: () => 'Play-spor oppdatert',
				PolicyPreset: () => 'Policy-forhåndsvalg',
				ApplyPresetSuccess: () => 'Policy-forhåndsvalg tatt i bruk',
				PolicyPresets: {
					ELO: () => 'Elo (kiosk + Elo OEMConfig)',
					ZEBRA: () => 'Zebra (kiosk-lås)',
					MANAGED_APP: () => 'Administrert app (installerer merchant-appen)',
					DEBUGGING: () => 'Feilsøking (aktiverer ADB, alle datamaskiner)'
				},
				RebootButton: () => 'Restart enhet',
				RebootSuccess: () => 'Restart-kommando sendt',
				RebootConfirmTitle: () => 'Restarte denne enheten?',
				RebootConfirmDescription: () => 'Enheten starter umiddelbart på nytt.',
				UnenrollButton: () => 'Avregistrer enhet',
				UnenrollSuccess: () => 'Enhet avregistrert',
				UnenrollConfirmTitle: () => 'Avregistrere denne enheten?',
				UnenrollConfirmDescription: () =>
					'Dette fjerner enheten fra AMAPI-flåten — tilsvarer en fabrikknullstilling. Den må registreres på nytt fra grunnen av.',
				PolicyOverridesLabel: () => 'Rå policy-overstyringer (JSON)',
				PolicyOverridesHint: () =>
					'Avansert: et rått AMAPI Policy-fragment, dypt sammenslått med den hardkodede grunnmalen. Kun for utviklere.',
				PolicyOverridesInvalidJson: () => 'Ugyldig JSON',
				SaveOverridesButton: () => 'Lagre overstyringer',
				ResetOverridesButton: () => 'Nullstill',
				SaveOverridesSuccess: () => 'Policy-overstyringer lagret',
				EnrollDrawer: {
					Title: () => 'Registrer i GMS',
					Description: () =>
						'Genererer en engangs QR-kode for registrering. Fabrikknullstill enheten, trykk 6 ganger på velkomstskjermen, og skann koden med kameraet.',
					WifiSsidLabel: () => 'Wi-Fi-nettverk (valgfritt)',
					WifiPasswordLabel: () => 'Wi-Fi-passord (valgfritt)',
					PolicyPresetLabel: () => 'Policy-forhåndsvalg',
					Submit: () => 'Generer QR-kode',
					QrExpiresAt: (args: { time: string }) => 'Utløper ' + String(args.time),
					Done: () => 'Ferdig'
				}
			}
		},
		Exports: {
			Title: () => 'Eksporter',
			Description: () => 'Eksporter data til ulike formater og systemer',
			Export: () => 'Eksporter',
			PricerTitle: () => 'Pricer-produkteksport',
			PricerSuccess: () => 'Pricer-eksport vellykket',
			SalesChannel: () => 'Salgskanal-UUID',
			VismaTitle: () => 'Visma-eksport',
			VismaSuccess: () => 'Visma-eksport vellykket',
			DigiScaleTitle: () => 'DigiScale-produkteksport',
			DigiScaleSuccess: () => 'DigiScale-eksport vellykket',
			SalesChannelUUIDs: () => 'Salgskanal-UUID-er',
			GroupUUIDs: () => 'Produktgruppe-UUID-er',
			SAFTTitle: () => 'SAFT-eksport',
			SAFTSuccess: () => 'SAFT-eksport vellykket',
			SAFTCashRegister: () => 'Kasseapparat',
			SAFTFinancial: () => 'Økonomi'
		},
		Integrations: {
			Title: () => 'Integrasjoner',
			Description: () => 'Koble FastTrack til eksterne tjenester.',
			Teya: {
				Name: () => 'Teya',
				Description: () => 'Koble til Teya for å ta imot kortbetalinger på terminalene dine.',
				StatusConnected: () => 'Tilkoblet',
				StatusDisconnected: () => 'Ikke tilkoblet',
				StatusError: () => 'Må kobles til på nytt',
				Connect: () => 'Koble til Teya',
				Reconnect: () => 'Koble til på nytt',
				Disconnect: () => 'Koble fra',
				Connecting: () => 'Venter på tilkobling…',
				ConnectedAt: (args: { date: string }) => 'Tilkoblet ' + String(args.date),
				Unavailable: () => 'Teya er ikke tilgjengelig for denne virksomheten.',
				ConnectSuccess: () => 'Teya tilkoblet',
				DisconnectSuccess: () => 'Teya frakoblet',
				DisconnectConfirm: () =>
					'Betalinger vil ikke lenger sendes til Teya-terminaler før du kobler til på nytt.',
				ConnectError: () => 'Kunne ikke starte Teya-tilkoblingen. Prøv igjen.',
				PopupBlocked: () => 'Tillat pop-up-vinduer for å fullføre Teya-tilkoblingen, og prøv igjen.',
				ConfigureStoreTerminals: () => 'Konfigurer butikk og terminaler',
				SelectStore: () => 'Velg en butikk',
				SelectTerminal: () => 'Velg en terminal',
				SelectStoreFirst: () => 'Velg en butikk først.',
				NoStores: () => 'Ingen butikker funnet for denne Teya-kontoen.',
				NoTerminals: () => 'Ingen terminaler funnet for denne butikken.',
				ReconnectToConfigure: () => 'Koble til Teya på nytt for å konfigurere butikker og terminaler.'
			},
			Rapyd: {
				SerialPlaceholder: () => 'Serienummer for PAX-enhet',
				Register: () => 'Registrer',
				Repair: () => 'Koble til på nytt',
				WaitingForPairing: () => 'Aktiver sammenkobling på terminalen, og vent…',
				Paired: () => 'Tilkoblet',
				SerialTooShort: () => 'Serienummeret må være minst 10 tegn.',
				RegisterError: () => 'Kunne ikke registrere enheten hos Rapyd. Prøv igjen.',
				ApiKeyRequiredFirst: () =>
					'Lagre API-nøkkelen i den globale konfigurasjonen før du kobler til en terminal.'
			},
			Providers: {
				teya: {
					Name: () => 'Teya',
					Description: () => 'Ta imot kortbetalinger på terminalene dine.'
				},
				nets: {
					Name: () => 'NETS',
					Description: () => 'Ta imot kortbetalinger via NETS-terminaler.'
				},
				'verifone-ecom': {
					Name: () => 'Verifone netthandel',
					Description: () => 'Ta imot kortbetalinger på nett via Verifone.'
				},
				'rapyd-cloudlink': {
					Name: () => 'Rapyd CloudLink',
					Description: () => 'Koble til PAX-kortterminaler for å ta imot betalinger.'
				},
				'verifone-pos-cloud': {
					Name: () => 'Verifone POS Cloud',
					Description: () => 'Ta imot kortbetalinger på Verifone cloud-terminaler.'
				},
				struct: {
					Name: () => 'Struct',
					Description: () => 'Synkroniser produkter fra Struct PIM.'
				}
			},
			Fields: {
				storeId: () => 'Butikk-ID',
				terminalId: () => 'Terminal-ID',
				eposInstanceId: () => 'ePOS-instans-ID',
				environment: () => 'Miljø',
				merchantId: () => 'Selger-ID',
				username: () => 'Brukernavn',
				password: () => 'Passord',
				organizationId: () => 'Organisasjons-ID',
				entityId: () => 'Enhets-ID',
				apiKey: () => 'API-nøkkel',
				apiUrl: () => 'API-URL',
				incomingWebhookEnabled: () => 'Innkommende webhook aktivert',
				incomingWebhookApiKey: () => 'API-nøkkel for innkommende webhook',
				secret: () => 'Hemmelighet',
				contractId: () => 'Kontrakts-ID',
				serialNumber: () => 'Serienummer',
				deviceToken: () => 'Enhet',
				authMode: () => 'Autentiseringsmodus',
				clientId: () => 'Client ID',
				clientSecret: () => 'Client secret',
				tokenUrl: () => 'Token-URL',
				baseUrl: () => 'Base-URL',
				poiId: () => 'POI-ID (terminal)',
				saleId: () => 'Sale-ID',
				operatorId: () => 'Operatør-ID',
				scope: () => 'Scope',
				siteEntityId: () => 'Site-enhets-ID',
				terminalSimulator: () => 'Terminalsimulator'
			},
			Config: {
				Back: () => 'Tilbake til integrasjoner',
				Global: () => 'Global konfigurasjon',
				GlobalDescription: () => 'Grunninnstillinger som gjelder overalt med mindre de overstyres.',
				Overrides: () => 'Overstyringer',
				OverridesDescriptionSalesChannel: () => 'Overstyr innstillinger for bestemte salgskanaler.',
				OverridesDescriptionPointOfSale: () => 'Overstyr innstillinger for bestemte salgssteder.',
				AddOverride: () => 'Legg til overstyring',
				NoOverrides: () => 'Ingen overstyringer',
				OverrideCount: (args: { count: number }) => String(args.count) + ' overstyringer',
				Configure: () => 'Konfigurer',
				Save: () => 'Lagre',
				Saved: () => 'Konfigurasjon lagret',
				SaveError: () => 'Kunne ikke lagre konfigurasjonen',
				TargetSalesChannel: () => 'Salgskanal',
				TargetPointOfSale: () => 'Salgssted',
				SelectTarget: () => 'Velg…',
				Edit: () => 'Rediger',
				Delete: () => 'Slett',
				DeleteOverride: () => 'Slett overstyring',
				DeleteOverrideConfirm: () =>
					'Denne overstyringen fjernes, og innstillingene faller tilbake til den globale konfigurasjonen.',
				EditOverride: () => 'Rediger overstyring',
				SecretSet: () => 'Konfigurert',
				SecretUnset: () => 'Ikke konfigurert',
				SecretPlaceholderSet: () => 'La stå tomt for å beholde nåværende',
				SecretPlaceholderUnset: () => 'Skriv inn verdi'
			}
		},
		Billing: {
			Title: () => 'Fakturering',
			NavLabel: () => 'Fakturering',
			Description: () => 'Ditt FastTrack-abonnement.',
			EmptyTitle: () => 'Ingen plan ennå',
			EmptyDescription: () => 'Ingen abonnementsplan er satt opp for kontoen din ennå.',
			EmptyContactPrefix: () => 'Ta kontakt med',
			EmptyContactLink: () => 'kundestøtte',
			EmptyContactSuffix: () => 'for å komme i gang.',
			PlanHeading: () => 'Abonnementsplan',
			Note: () => 'Notat',
			PlanDetails: () => 'Plandetaljer',
			AdditionalFees: () => 'Tilleggsgebyrer',
			Amount: () => 'Beløp',
			Interval: () => 'Faktureringsperiode',
			Monthly: () => 'Månedlig',
			Yearly: () => 'Årlig',
			OneTime: () => 'Engangs',
			Net: () => 'Netto',
			Vat: () => 'Mva',
			VatRate: () => 'Mva-sats',
			Total: () => 'Totalt',
			TotalsHeading: () => 'Totaler',
			MonthlyTotal: () => 'Månedlig totalt',
			YearlyTotal: () => 'Årlig totalt',
			OneTimeTotal: () => 'Engangs totalt',
			AgreementHeading: () => 'Avtale',
			SelfServeIntro: () => 'Din bruk av FastTrack er underlagt følgende retningslinjer:',
			PolicyPrivacy: () => 'Personvernerklæring',
			PolicyTerms: () => 'Bruksvilkår',
			PolicyServices: () => 'Plattformtjenesteavtale',
			PolicyDpa: () => 'Databehandleravtale',
			PolicySupport: () => 'Støtteretningslinjer',
			PolicyEula: () => 'Programvarelisens',
			EnterpriseNote: () => 'Denne planen er underlagt din Master Services Agreement med Stack.',
			EnterpriseServicesLink: () => 'Se plattformtjenesteavtalen',
			EnterpriseRefLabel: () => 'Avtalereferanse',
			StartDate: () => 'Startdato',
			Status: () => 'Status',
			StatusAccepted: () => 'Godtatt',
			StatusPending: () => 'Venter på godkjenning',
			AcceptedBy: () => 'Godtatt av',
			Accept: () => 'Godta plan',
			AcceptConfirmTitle: () => 'Godta plan',
			AcceptConfirmDescription: () => 'Ved å godta bekrefter du at du godtar abonnementsplanen vist over.',
			AcceptConfirmAction: () => 'Godta',
			AcceptSuccess: () => 'Plan godtatt',
			AcceptError: () => 'Kunne ikke godta planen. Prøv igjen.',
			LoadError: () => 'Kunne ikke laste abonnementsplanen.'
		}
	},
	PointOfSale: {
		Title: () => 'Salgssted'
	},
	Profile: {
		Title: () => 'Profil'
	},
	SalesChannels: {
		Title: () => 'Salgskanaler'
	},
	Store: {
		Title: () => 'Butikk'
	},
	Users: {
		Title: () => 'Brukere'
	},
	CompanyCards: {
		Title: () => 'Bedriftskort',
		CreateTitle: () => 'Opprett bedriftskort',
		CreateSuccess: () => 'Bedriftskortet ble opprettet',
		EditTitle: () => 'Rediger bedriftskort',
		UpdateSuccess: () => 'Bedriftskortet ble oppdatert',
		DeleteWarning: (args: { name: string }) =>
			'Du er i ferd med å slette bedriftskortet ' + String(args.name) + '. Denne handlingen kan ikke angres.',
		Status: (arg0: 'ACTIVE' | 'INACTIVE') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Active'
					case 'INACTIVE':
						return 'Inactive'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Name: () => 'Navn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Company: () => 'Bedrift',
			Customer: () => 'Kunde',
			Employee: () => 'Ansatt',
			ExternalId: () => 'Ekstern ID',
			CreatedAt: () => 'Opprettet'
		},
		Detail: {
			Title: () => 'Detaljer om bedriftskort',
			Transactions: () => 'Transaksjoner',
			ResetPin: {
				Title: () => 'Tilbakestill PIN',
				Description: () => 'Er du sikker på at du vil tilbakestille PIN-koden for dette kortet?',
				Action: () => 'Tilbakestill PIN'
			},
			ResetPinSuccess: () => 'PIN-koden ble tilbakestilt'
		},
		Edit: {
			BasicInfo: () => 'Grunnleggende informasjon',
			Description: () => 'Rediger informasjon om bedriftskort',
			NamePlaceholder: () => 'Skriv inn kortnavn',
			SelectCompany: () => 'Velg bedrift',
			SelectEmployee: () => 'Velg ansatt',
			ExternalIdPlaceholder: () => 'Skriv inn ekstern ID (valgfritt)'
		}
	},
	Settlements: {
		Title: () => 'Oppgjør',
		CreateTitle: () => 'Opprett oppgjør',
		CreateSuccess: () => 'Oppgjøret ble opprettet',
		MarkSettled: () => 'Merk som gjort opp',
		MarkSettledSuccess: () => 'Oppgjør merket som gjort opp',
		Column: {
			Company: () => 'Bedrift',
			Period: () => 'Periode',
			TotalAmount: () => 'Totalbeløp',
			TransactionCount: () => 'Transaksjoner',
			SettledAt: () => 'Gjort opp',
			CreatedAt: () => 'Opprettet'
		},
		Detail: {
			Title: () => 'Oppgjørsdetaljer',
			Transactions: () => 'Transaksjoner',
			Period: () => 'Periode',
			TotalAmount: () => 'Totalbeløp',
			Status: () => 'Status',
			Settled: () => 'Gjort opp',
			NotSettled: () => 'Ikke gjort opp'
		},
		Create: {
			Title: () => 'Opprett oppgjør',
			Period: () => 'Periode',
			Description: () => 'Opprett et nytt oppgjør for bedriften',
			PeriodStart: () => 'Periodestart',
			PeriodEnd: () => 'Periodeslutt'
		}
	},
	Analytics: {
		Title: () => 'Analyse',
		Overview: () => 'Oversikt',
		Insights: () => 'Innsikt',
		SalesAnalytics: () => 'Salg',
		SalesAnalyticsDescription: () => 'Følg inntekter, ordrer og de mest solgte produktene og kanalene.',
		UserAnalytics: () => 'Brukere',
		UserAnalyticsDescription: () => 'Følg aktive brukere, nye registreringer og forespørsler om kontosletting.',
		Basket: () => 'Handlekurv',
		ActiveUsers: () => 'Aktive brukere',
		NewSignups: () => 'Nye registreringer',
		ChurnedUsers: () => 'Slettingsforespørsler',
		ActiveUsersOverTime: () => 'Aktive brukere over tid',
		NewSignupsOverTime: () => 'Nye registreringer over tid',
		ChurnedUsersOverTime: () => 'Slettingsforespørsler over tid',
		DeltaNew: () => 'Ny',
		Revenue: () => 'Omsetning',
		Orders: () => 'Bestillinger',
		Growth: () => 'Vekst',
		TotalRevenue: () => 'Total omsetning',
		AverageOrderValue: () => 'Gjennomsnittlig bestillingsverdi',
		Refunds: () => 'Refusjoner',
		RevenueOverTime: () => 'Omsetning over tid',
		TopProducts: () => 'Topprodukter',
		TopProductsByRevenue: () => 'Etter omsetning',
		TopProductsByQuantity: () => 'Etter antall',
		PaymentMethods: () => 'Betalingsmetoder',
		RevenueByCategory: () => 'Omsetning etter kategori',
		SalesByChannel: () => 'Salg etter kanal',
		HourlyDistribution: () => 'Timedistribusjon',
		Day: () => 'Dag',
		Week: () => 'Uke',
		Month: () => 'Måned',
		Quarter: () => 'Kvartal',
		Year: () => 'År',
		NoData: () => 'Ingen data tilgjengelig for denne perioden',
		VsDate: (arg0: string) => 'vs. ' + String(arg0),
		VsDateRange: (arg0: string, arg1: string) => 'vs. ' + String(arg0) + ' – ' + String(arg1),
		InProgress: () => '(pågår)',
		ComparePreviousPeriod: () => 'vs. forrige periode',
		CompareSamePeriodLastYear: () => 'vs. samme periode i fjor',
		CompareSpecific: {
			Day: () => 'vs. en bestemt dag',
			Week: () => 'vs. en bestemt uke',
			Month: () => 'vs. en bestemt måned',
			Quarter: () => 'vs. et bestemt kvartal',
			Year: () => 'vs. et bestemt år'
		},
		CompareNone: () => 'Ingen sammenligning',
		AllChannels: () => 'Alle kanaler',
		ChannelGroupOption: (arg0: string) => String(arg0) + ' (gruppe)',
		CompareToChannel: () => 'Sammenlign med kanal',
		CompareToChannelNone: () => 'Ingen kanalsammenligning',
		ComparisonModePeriod: () => 'Periode',
		ComparisonModeChannel: () => 'Kanal',
		CompareByPeriod: () => 'Sammenlign etter periode',
		CompareByChannel: () => 'Sammenlign etter kanal',
		PeriodLabel: (arg0: string) => 'Periode: ' + String(arg0),
		CompareBy: () => 'Sammenlign etter',
		ChannelsPageOf: (args: { current: number; total: number }) =>
			'Side ' + String(args.current) + ' av ' + String(args.total),
		QuarterLabel: (args: { quarter: number; year: number }) => 'K' + String(args.quarter) + ' ' + String(args.year),
		JumpToPeriod: () => 'Gå til periode',
		CurrentPeriod: () => 'Nåværende periode',
		IntervalLabel: (arg0: string) => 'Intervall: ' + String(arg0),
		Reports: {
			Title: () => 'Rapporter',
			Description: () => 'Utforsk salgsdataene i detalj, sammenlign perioder og kanaler, og eksporter dem.',
			SalesGroup: () => 'Salg',
			ViewReport: () => 'Vis rapport',
			Export: () => 'Eksporter CSV',
			Rows: () => 'Fordel etter',
			RowsOption: {
				Hour: () => 'Per time',
				Day: () => 'Per dag',
				Week: () => 'Per uke',
				Month: () => 'Per måned',
				Product: () => 'Per produkt'
			},
			ColumnsPicker: () => 'Kolonner',
			GroupBy: () => 'Grupper etter',
			GroupByOption: {
				Hour: () => 'Time',
				Day: () => 'Dag',
				Week: () => 'Uke',
				Month: () => 'Måned'
			},
			Total: () => 'Totalt',
			Revenue: {
				Title: () => 'Omsetning',
				Description: () => 'Omsetning, ordrer, refusjoner og gjennomsnittlig ordreverdi over tid.'
			},
			Products: {
				Title: () => 'Produkter',
				Description: () => 'Solgte enheter, bruttosalg og ordrer per produkt.',
				FilterProducts: () => 'Alle produkter',
				GrossSalesNote: () =>
					'Produktsalg er brutto linjebeløp før refusjoner, og kan derfor avvike fra nettoomsetningen.'
			},
			Columns: {
				Period: () => 'Periode',
				Orders: () => 'Ordrer',
				Revenue: () => 'Omsetning',
				Refunds: () => 'Refusjoner',
				AverageOrderValue: () => 'Snitt ordreverdi',
				Product: () => 'Produkt',
				Quantity: () => 'Antall',
				GrossSales: () => 'Bruttosalg',
				Share: () => 'Andel'
			}
		},
		ChartLabels: {
			Revenue: () => 'Omsetning',
			Orders: () => 'Bestillinger',
			Hour: () => 'Time',
			Quantity: () => 'Antall'
		},
		BasketAnalysis: {
			Title: () => 'Kurvanalyse',
			Description: () => 'Finn ut hvilke produkter og kategorier som ofte kjøpes sammen.',
			AvgItemsPerOrder: () => 'Gj.sn. varer per ordre',
			AvgUniqueProductsPerOrder: () => 'Gj.sn. unike produkter per ordre',
			OrdersAnalyzed: () => 'Analyserte ordrer',
			ProductPairs: () => 'Produktpar',
			CategoryAffinity: () => 'Kategoriaffinitet',
			AnchorProduct: () => 'Ankerprodukt',
			AnchorProductPlaceholder: () => 'Søk etter et produkt…',
			AllProducts: () => 'Alle produkter',
			Products: () => 'Produkter',
			ProductsPlaceholder: () => 'Filtrer produkter…',
			ExcludeProductsPlaceholder: () => 'Ekskluder produkter…',
			AllProductsFilter: () => 'Alle produkter',
			Categories: () => 'Kategorier',
			CategoriesPlaceholder: () => 'Filtrer kategorier…',
			ExcludeCategoriesPlaceholder: () => 'Ekskluder kategorier…',
			AllCategoriesFilter: () => 'Alle kategorier',
			SalesChannel: () => 'Salgskanal',
			AllSalesChannels: () => 'Alle salgskanaler',
			SalesChannelsSelected: (args: { count: number }) => String(args.count) + ' valgt',
			SalesChannelSearchPlaceholder: () => 'Søk i salgskanaler…',
			PointOfSale: () => 'Utsalgssted',
			AllPointsOfSale: () => 'Alle utsalgssteder',
			MinSupport: () => 'Min. samforekomster',
			ProductA: () => 'Produkt A',
			ProductB: () => 'Produkt B',
			CategoryA: () => 'Kategori A',
			CategoryB: () => 'Kategori B',
			CoOccurrence: () => 'Samforekomst',
			Support: () => 'Support',
			Confidence: () => 'Confidence',
			Lift: () => 'Lift',
			SupportTooltip: () =>
				'Hvor vanlig paret er: andelen av alle ordrer som inneholder både A og B. For eksempel betyr 2 % at 2 av 100 ordrer inneholdt begge.',
			ConfidenceTooltip: () =>
				'Hvor ofte B havner i kurven når A gjør det: andelen av ordrer med A som også inneholder B. For eksempel betyr 40 % at 4 av 10 ordrer med A også hadde B.',
			LiftTooltip: () =>
				'Hvor mye oftere A og B kjøpes sammen enn man ville forvente ved en tilfeldighet. 1 betyr ingen sammenheng, 2 betyr dobbelt så ofte som forventet, og under 1 betyr at de sjelden kjøpes sammen.',
			NoProductPairs: () => 'Ingen produktpar oppfyller minimumsgrensen for samforekomst i denne perioden.',
			NoCategoryPairs: () => 'Ingen kategoripar oppfyller minimumsgrensen for samforekomst i denne perioden.',
			NoAnchorPairs: () => 'Ingen par funnet for det valgte produktet i denne perioden.',
			MetricPercent: (arg0: string) => String(arg0) + '%'
		}
	}
}

export const sv = {
	LocaleName: () => 'Svenska',
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('sv', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('sv', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('sv', arg1),
		OnlyAmount: (arg0: TranslationAmount) => amountOnlyFormatter('sv', arg0)
	},
	Quantity: {
		Pieces: (arg0: number) => String(arg0) + 'x'
	},
	Weight: (arg0: Amount) => weightFormatter('sv', arg0),
	Date: {
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('sv', arg0),
		Short: (arg0: DateInput) => shortFormatter('sv', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('sv', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('sv', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('sv', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('sv', arg0),
		Ago: (arg0: DateInput) => agoFormatter('sv', arg0, () => locales['sv'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('sv', arg0)
	},
	TimeAgo: {
		JustNow: () => 'just nu',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('sv', args.count, { one: 'minut', other: 'minuter' }) + ' sedan',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('sv', args.count, { one: 'timme', other: 'timmar' }) + ' sedan',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('sv', args.count, { one: 'dag', other: 'dagar' }) + ' sedan',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('sv', args.count, { one: 'månad', other: 'månader' }) + ' sedan',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('sv', args.count, { one: 'år', other: 'år' }) + ' sedan'
	},
	Enum: {
		PaymentStatus: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Väntar'
					case 'UNPAID':
						return 'Obetald'
					case 'PAID':
						return 'Betald'
					case 'PARTIALLY_PAID':
						return 'Delvis betald'
					case 'REFUNDED':
						return 'Återbetald'
					case 'PARTIALLY_REFUNDED':
						return 'Delvis återbetald'
					case 'OVERPAID':
						return 'Överbetald'
					default:
						return String(v)
				}
			})(arg0),
		OrderStatus: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Slutförd'
					case 'CANCELED':
						return 'Avbruten'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentStatus: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Ej uppfylld'
					case 'FULFILLED':
						return 'Uppfylld'
					case 'NOT_NEEDED':
						return 'Behövs inte'
					case 'PARTIALLY_FULFILLED':
						return 'Delvis uppfylld'
					default:
						return String(v)
				}
			})(arg0),
		TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
			(v => {
				switch (v) {
					case 'FAILED':
						return 'Misslyckades'
					case 'SUCCESS':
						return 'Lyckades'
					case 'PENDING':
						return 'Väntar'
					default:
						return String(v)
				}
			})(arg0),
		PaymentProvider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN' | 'VERIFONE' | 'CASH') =>
			(v => {
				switch (v) {
					case 'RAPYD':
						return 'Rapyd'
					case 'MANUAL':
						return 'Manuell'
					case 'STRIPE':
						return 'Stripe'
					case 'ADYEN':
						return 'Adyen'
					case 'VERIFONE':
						return 'Verifone'
					case 'CASH':
						return 'Kontant'
					default:
						return String(v)
				}
			})(arg0),
		ProductStatus: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Utkast'
					case 'PUBLISHED':
						return 'Publicerad'
					case 'ARCHIVED':
						return 'Arkiverad'
					default:
						return String(v)
				}
			})(arg0),
		ThirdPartySource: (arg0: 'STRUCT' | 'LS_RETAIL' | 'BUSINESS_CENTRAL') =>
			(v => {
				switch (v) {
					case 'STRUCT':
						return 'Struct'
					case 'LS_RETAIL':
						return 'LS Retail'
					case 'BUSINESS_CENTRAL':
						return 'Business Central'
					default:
						return String(v)
				}
			})(arg0),
		CardExternalSource: (arg0: 'PASSCREATOR') =>
			(v => {
				switch (v) {
					case 'PASSCREATOR':
						return 'PassCreator'
					default:
						return String(v)
				}
			})(arg0),
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per enhet'
					case 'PRICE_EMBEDDED':
						return 'Pris inkluderat'
					case 'PER_WEIGHT':
						return 'Per vikt'
					case 'WEIGHT_EMBEDDED':
						return 'Vikt inkluderad'
					default:
						return String(v)
				}
			})(arg0),
		GiftCardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserverad'
					case 'REDEEMED':
						return 'Inlöst'
					default:
						return String(v)
				}
			})(arg0),
		RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Väntar'
					case 'APPLIED':
						return 'Använd'
					default:
						return String(v)
				}
			})(arg0),
		CardStatus: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Spärrad'
					default:
						return String(v)
				}
			})(arg0),
		FulfillmentProvider: (arg0: 'MERCHANT_APP') =>
			(v => {
				switch (v) {
					case 'MERCHANT_APP':
						return 'Merchant app'
					default:
						return String(v)
				}
			})(arg0),
		UserStatus: (arg0: 'ACTIVE' | 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REJECTED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'PENDING':
						return 'Väntar'
					case 'ACCEPTED':
						return 'Accepterad'
					case 'EXPIRED':
						return 'Utgången'
					case 'REJECTED':
						return 'Avvisad'
					default:
						return String(v)
				}
			})(arg0),
		UserRole: (arg0: 'DEVELOPER' | 'ADMIN' | 'USER') =>
			(v => {
				switch (v) {
					case 'DEVELOPER':
						return 'Utvecklare'
					case 'ADMIN':
						return 'Admin'
					case 'USER':
						return 'Användare'
					default:
						return String(v)
				}
			})(arg0)
	},
	General: {
		AppName: () => 'FastTrack',
		DefaultPageTitle: () => 'FastTrack Dashboard',
		Create: () => 'Skapa',
		Import: () => 'Importera',
		Export: () => 'Exportera',
		NoResultsTitle: () => 'Inga resultat hittades',
		Loading: () => 'Läser in...',
		Selected: () => 'Vald',
		Optional: () => 'Valfritt',
		Save: () => 'Spara',
		Continue: () => 'Fortsätt',
		Cancel: () => 'Avbryt',
		Confirm: () => 'Bekräfta',
		Delete: () => 'Ta bort',
		Edit: () => 'Redigera',
		Add: () => 'Lägg till',
		Required: () => 'Obligatorisk',
		Close: () => 'Stäng',
		Update: () => 'Uppdatera',
		UnsavedChangesTitle: () => 'Osparade ändringar',
		UnsavedChangesDescription: () => 'Du har osparade ändringar. Är du säker på att du vill lämna?',
		VerificationInstruction: (arg0: string) => 'Skriv ' + String(arg0) + ' för att bekräfta:',
		Copy: () => 'Kopiera',
		Copied: () => 'Kopierad',
		AreYouSure: () => 'Är du säker?',
		True: () => 'Ja',
		False: () => 'Nej',
		SearchPlaceholder: () => 'Sök...',
		InvalidFileType: (arg0: string, arg1: string) =>
			'Ogiltig filtyp: ' + String(arg0) + ' (stöds: ' + String(arg1) + ')',
		DropImages: () => 'Släpp bilder för att ladda upp',
		Multiple: () => 'Flera',
		Variable: () => 'Variabel',
		Enabled: () => 'Aktiverad',
		Expired: () => 'Utgången',
		Scheduled: () => 'Schemalagd',
		Active: () => 'Aktiv',
		Inactive: () => 'Inaktiv',
		ComingSoon: () => 'Kommer snart',
		ComingSoonDescription: () => 'Den här funktionen är under utveckling.',
		None: () => 'Ingen',
		NotSet: () => 'Ej angivet',
		Unknown: () => 'Okänd',
		GoBack: () => 'Gå tillbaka',
		GoHome: () => 'Gå till startsidan',
		FeatureNotAvailable: () => 'Den här funktionen är för närvarande inte tillgänglig',
		FeatureNotAvailableDescription: () => 'Kontakta support för att aktivera den här funktionen',
		Dismiss: () => 'Avfärda',
		TryAgain: () => 'Försök igen',
		All: () => 'Alla',
		AdvancedFilters: () => 'Filter',
		ClearAll: () => 'Rensa',
		Apply: () => 'Tillämpa',
		CountSelected: (args: { count: number }) => String(args.count) + ' valda',
		MultiSelectHint: (args: { count: number }) =>
			String(args.count) + ' valda • Håll ned Ctrl/Cmd för att välja flera',
		PickDate: () => 'Välj ett datum',
		Created: () => 'Skapad',
		View: () => 'Visa'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'Kunde inte läsa in data',
		AnErrorOccurredWhileFetchingData: () => 'Ett fel uppstod vid hämtning av data. Försök igen.'
	},
	Enums: {
		PaymentProvider: (
			arg0:
				| 'CASH'
				| 'ADYEN_TERMINAL'
				| 'ADYEN_ECOM'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'VIPPS'
				| 'NETS_TERMINAL'
				| 'VERIFONE_CHECKOUT'
				| 'VERIFONE_ECOM'
				| 'STRAUMUR_ECOM'
				| 'LOYALTY_POINTS'
				| 'GIFT_CARD'
				| 'BUSINESS_CARD'
				| 'VIPPS_MOBILEPAY'
				| 'RAPYD_CLOUDLINK'
				| 'RAPYD_APP_TO_APP'
				| 'TEYA_POSLINK'
				| 'VERIFONE_POS_CLOUD'
		) =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Kontant'
					case 'ADYEN_TERMINAL':
						return 'Adyen Terminal'
					case 'ADYEN_ECOM':
						return 'Adyen ECom'
					case 'BLIKK_ECOM':
						return 'Blikk ECom'
					case 'BLIKK_POS':
						return 'Blikk POS'
					case 'VIPPS':
						return 'Vipps'
					case 'NETS_TERMINAL':
						return 'Nets Terminal'
					case 'VERIFONE_CHECKOUT':
						return 'Verifone Checkout'
					case 'VERIFONE_ECOM':
						return 'Verifone ECOM'
					case 'STRAUMUR_ECOM':
						return 'Straumur'
					case 'LOYALTY_POINTS':
						return 'Lojalitetspoäng'
					case 'GIFT_CARD':
						return 'Presentkort'
					case 'BUSINESS_CARD':
						return 'Företagskort'
					case 'VIPPS_MOBILEPAY':
						return 'Vipps MobilePay'
					case 'RAPYD_CLOUDLINK':
						return 'Rapyd Cloudlink'
					case 'RAPYD_APP_TO_APP':
						return 'Rapyd App to App'
					case 'TEYA_POSLINK':
						return 'Teya POSLink'
					case 'VERIFONE_POS_CLOUD':
						return 'Verifone POS Cloud'
					default:
						return String(v)
				}
			})(arg0)
	},
	Fields: {
		Name: () => 'Namn',
		Status: () => 'Status',
		Type: () => 'Typ',
		SalesChannel: () => 'Försäljningskanal',
		PointOfSale: () => 'Försäljningsställe',
		PaymentStatus: () => 'Betalningsstatus',
		StartDate: () => 'Startdatum',
		EndDate: () => 'Slutdatum',
		TaxRate: () => 'Momssats',
		TaxInclusive: () => 'Inkl. moms',
		Amount: () => 'Belopp',
		Price: () => 'Pris',
		Description: () => 'Beskrivning',
		Groups: () => 'Grupper',
		Categories: () => 'Kategorier',
		Email: () => 'E-post',
		Password: () => 'Lösenord',
		ConfirmPassword: () => 'Bekräfta lösenord',
		Role: () => 'Roll',
		SKU: () => 'SKU',
		Currency: () => 'Valuta',
		CreatedAt: () => 'Skapad',
		ExpiresAt: () => 'Upphör',
		UpdatedAt: () => 'Uppdaterad',
		Language: () => 'Språk',
		Year: () => 'År',
		Month: () => 'Månad',
		ExternalId: () => 'Externt ID',
		FirstName: () => 'Förnamn',
		LastName: () => 'Efternamn',
		Phone: () => 'Telefon',
		SSN: () => 'Personnummer',
		CardNumber: () => 'Kortnummer',
		Company: () => 'Företag',
		Customer: () => 'Kund',
		Employee: () => 'Anställd',
		FromTime: () => 'Från',
		ToTime: () => 'Till',
		OrgNumber: () => 'Org.nr',
		Enabled: () => 'Aktiverad',
		Disabled: () => 'Inaktiverad',
		CurrencyCode: () => 'Valutakod'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'Genvägar'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'Måndag',
		Tuesday: () => 'Tisdag',
		Wednesday: () => 'Onsdag',
		Thursday: () => 'Torsdag',
		Friday: () => 'Fredag',
		Saturday: () => 'Lördag',
		Sunday: () => 'Söndag'
	},
	Auth: {
		AcceptInvite: () => 'Acceptera inbjudan',
		AcceptInviteAndSetPassword: () => 'Acceptera inbjudan och ange lösenord',
		AcceptInviteDescription: () => 'Ange ditt lösenord för att acceptera inbjudan.',
		ConfirmPasswordPlaceholder: () => 'Bekräfta ditt lösenord',
		InvalidInvite: () => 'Ogiltig inbjudan',
		InvalidInviteDescription: () => 'Den här inbjudan är ogiltig eller har upphört att gälla.',
		InviteAccepted: () => 'Inbjudan accepterades',
		InviteExpired: () => 'Den här inbjudan har upphört att gälla eller är inte längre giltig',
		PasswordPlaceholder: () => 'Ange ditt lösenord',
		PasswordsDoNotMatch: () => 'Lösenorden matchar inte',
		SetPassword: () => 'Ange lösenord'
	},
	Error: {
		PageNotFound: () => 'Sidan hittades inte',
		PageNotFoundDescription: () => 'Sidan du letar efter finns inte.',
		SomethingWentWrong: () => 'Något gick fel',
		AnUnexpectedErrorOccurred: () =>
			'Ett oväntat fel uppstod. Du kan försöka gå tillbaka, ladda om sidan eller kontakta support om problemet kvarstår.',
		ErrorDetails: () => 'Feldetaljer',
		ReloadPage: () => 'Ladda om sidan',
		ContactSupport: () => 'Kontakta support'
	},
	Campaigns: {
		Domain: () => 'Kampanjer'
	},
	CustomerGroups: {
		Domain: () => 'Kundgrupper',
		Title: () => 'Grupper',
		CreateTitle: () => 'Skapa kundgrupp',
		CreateSuccess: (args: { name: string }) => 'Kundgruppen ' + String(args.name) + ' skapades.',
		EditTitle: () => 'Redigera kundgrupp',
		UpdateSuccess: () => 'Kundgruppen uppdaterades',
		Empty: () => 'Inga kundgrupper än',
		Members: () => 'Medlemmar',
		SelectCustomers: () => 'Välj kunder',
		Delete: {
			Title: () => 'Ta bort kundgrupp',
			Description: (args: { name: string }) =>
				'Är du säker på att du vill ta bort kundgruppen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kundgruppen ' + String(args.name) + ' togs bort.'
		},
		Column: {
			Name: () => 'Namn',
			Description: () => 'Beskrivning',
			ExternalId: () => 'Externt ID',
			MemberCount: () => 'Medlemmar'
		},
		Field: {
			Name: () => 'Namn',
			Description: () => 'Beskrivning',
			ExternalId: () => 'Externt ID',
			NamePlaceholder: () => 'Ange ett gruppnamn',
			DescriptionPlaceholder: () => 'Beskriv den här gruppen (valfritt)',
			ExternalIdPlaceholder: () => 'Externt ID (valfritt)'
		},
		Detail: {
			Title: () => 'Kundgrupp'
		}
	},
	DraftOrders: {
		Domain: () => 'Utkastorder'
	},
	PriceLists: {
		Domain: () => 'Prislistor'
	},
	Reservations: {
		Domain: () => 'Reservationer'
	},
	Login: {
		PageTitle: () => 'Logga in',
		Title: () => 'Välkommen till FastTrack',
		Description: () => 'Logga in för att komma åt din instrumentpanel',
		Email: () => 'E-post',
		Password: () => 'Lösenord',
		LogIn: () => 'Logga in',
		ForgotPassword: () => 'Glömt lösenord?',
		ForgotPasswordButton: () => 'Återställ',
		Error: () => 'Det gick inte att logga in',
		UnauthorizedError: () => 'Ogiltig e-post eller lösenord'
	},
	ResetPassword: {
		Title: () => 'Återställ lösenord',
		Hint: () => 'Ange din e-post nedan så skickar vi instruktioner om hur du återställer ditt lösenord.',
		Email: () => 'E-post',
		SendResetInstructions: () => 'Skicka återställningsinstruktioner',
		BackToLogin: () => 'Tillbaka till inloggning',
		SuccessfulRequestTitle: () => 'Vi har skickat ett e-postmeddelande till dig',
		SuccessfulRequest: () =>
			'Vi har skickat ett e-postmeddelande som du kan använda för att återställa ditt lösenord. Kontrollera skräppostmappen om du inte har fått det efter några minuter.',
		NewPassword: () => 'Nytt lösenord',
		NewPasswordHint: () => 'Välj ett nytt lösenord nedan.',
		RepeatNewPassword: () => 'Upprepa nytt lösenord',
		ResetPassword: () => 'Återställ lösenord',
		PasswordMismatch: () => 'Lösenorden matchar inte',
		SuccessfulResetTitle: () => 'Lösenordet återställdes',
		SuccessfulReset: () => 'Logga in på inloggningssidan.',
		InvalidEmail: () => 'Ogiltig e-post'
	},
	Sidebar: {
		Logout: () => 'Logga ut',
		ProfileSettings: () => 'Profilinställningar',
		BackToApp: () => 'Tillbaka till appen',
		SearchPlaceholder: () => 'Sök eller hoppa…',
		OpenSearch: () => 'Öppna sök',
		StoreScopeHint: () => 'Arbetsyta (växlare kommer senare)',
		Sections: () => 'Sektioner',
		Individuals: () => 'Privatpersoner',
		Business: () => 'Företag',
		Content: () => 'Innehåll',
		Messaging: () => 'Meddelanden',
		Automation: () => 'Automatisering'
	},
	DeveloperFeedback: {
		Entry: () => 'Skicka feedback',
		Title: () => 'Feedback från utvecklare',
		Description: () => 'Det här blir ett ärende för utvecklingsteamet.',
		TitleLabel: () => 'Titel',
		BodyLabel: () => 'Detaljer',
		TypeLabel: () => 'Typ',
		TypeSmallFix: () => 'Liten åtgärd',
		TypeBug: () => 'Bugg',
		TypeEnhancement: () => 'Förbättring',
		TypeNote: () => 'Anteckning',
		Submit: () => 'Skicka',
		Created: () => 'Ärende skapat'
	},
	CommandPalette: {
		GroupQuick: () => 'Snabbåtgärder',
		InputHint: () => 'Sök order, produkter, kunder, samlingar…',
		FooterHint: () => 'Tips: skriv minst 2 tecken för att söka i hela butiken.',
		NoResults: () => 'Inga träffar. Prova ett annat sökord.',
		QuickNewProduct: () => 'Skapa produkt',
		QuickNewPromotion: () => 'Skapa kampanj',
		QuickMarketingContent: () => 'Marknadsföringsinnehåll',
		QuickGoOrders: () => 'Gå till order',
		QuickSettings: () => 'Inställningar'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			String(args.start) + ' till ' + String(args.end) + ' av ' + String(args.total) + ' resultat',
		NoResults: () => '0 resultat',
		Previous: () => 'Föregående',
		Next: () => 'Nästa'
	},
	Orders: {
		Title: () => 'Order',
		BagChecks: () => 'Väskkontroller',
		Drafts: () => 'Utkast',
		StatusEnum: (
			arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'OVERPAID'
		) =>
			(v => {
				switch (v) {
					case 'PENDING':
						return 'Väntar'
					case 'UNPAID':
						return 'Obetald'
					case 'PAID':
						return 'Betald'
					case 'PARTIALLY_PAID':
						return 'Delvis betald'
					case 'REFUNDED':
						return 'Återbetald'
					case 'PARTIALLY_REFUNDED':
						return 'Delvis återbetald'
					case 'OVERPAID':
						return 'Överbetald'
					default:
						return String(v)
				}
			})(arg0),
		OrderCanceled: () => 'Ordern avbröts',
		AdvancedFilters: () => 'Orderfilter',
		FulfillmentStatusEnum: (arg0: 'NOT_FULFILLED' | 'FULFILLED' | 'NOT_NEEDED' | 'PARTIALLY_FULFILLED') =>
			(v => {
				switch (v) {
					case 'NOT_FULFILLED':
						return 'Ej uppfylld'
					case 'FULFILLED':
						return 'Uppfylld'
					case 'NOT_NEEDED':
						return 'Behövs inte'
					case 'PARTIALLY_FULFILLED':
						return 'Delvis uppfylld'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Order: () => 'Order',
			Date: () => 'Datum',
			SalesChannel: () => 'Försäljningskanal',
			PaymentStatus: () => 'Betalningsstatus',
			Total: () => 'Ordertotal',
			FulfillmentStatus: () => 'Uppfyllnadsstatus',
			PointsEarned: () => 'Intjänade poäng',
			PointsUsed: () => 'Använda poäng'
		},
		Totals: {
			Header: () => 'Översikt - Idag',
			Orders: () => 'Order',
			Total: () => 'Intäkter',
			Average: () => 'Genomsnittlig order',
			UpdatedAt: (arg0: DateInput) => 'Uppdaterad ' + shortDateAndTimePreciseFormatter('sv', arg0)
		},
		Filters: {
			MinAmount: () => 'Minsta belopp',
			MaxAmount: () => 'Högsta belopp',
			FromDate: () => 'Från datum',
			ToDate: () => 'Till datum'
		},
		Refund: {
			Title: () => 'Återbetala',
			Amount: () => 'Belopp',
			Note: () => 'Anteckning',
			AmountCannotBeEmpty: () => 'Belopp kan inte vara tomt',
			AmountMustBeGreaterThanZero: () => 'Belopp måste vara större än 0',
			AmountMustBeLessThanRefundableAmount: (arg0: TranslationAmount) =>
				'Belopp måste vara mindre än det återbetalningsbara beloppet (' + amountFormatter('sv', arg0) + ')',
			Description: () =>
				'Välj de orderrader som ska återbetalas, justera antal och/eller ange ett anpassat belopp.',
			ItemsSectionTitle: () => 'Orderrader',
			CustomAmountSectionTitle: () => 'Anpassat belopp',
			CustomAmountLabel: () => 'Ytterligare belopp',
			CustomAmountOnlyLabel: () => 'Återbetalningsbelopp',
			CustomAmountHint: () => 'Lägg eventuellt till ett anpassat belopp utöver de valda varorna.',
			RefundableAmount: () => 'Återbetalningsbart belopp',
			RefundTotal: () => 'Total återbetalning',
			AlreadyRefunded: (args: { quantity: number; total: number }) =>
				'Återbetalat ' + String(args.quantity) + ' av ' + String(args.total),
			PromotionLocked: () => 'Del av en kampanj — återbetala med ett anpassat belopp i stället.',
			Restock: () => 'Fyll på returnerade enheter',
			NothingToRefund: () => 'Den här ordern har inget kvar att återbetala.',
			NoRefundableItems: () => 'Inga orderrader är tillgängliga för en varubaserad återbetalning.',
			SelectSomething: () => 'Välj minst en vara eller ange ett anpassat belopp.',
			ExceedsRefundable: () => 'Den totala återbetalningen överstiger det återbetalningsbara beloppet.',
			RefundEntireOrder: (arg0: TranslationAmount) =>
				'Återbetala hela ordern (' + amountFormatter('sv', arg0) + ')',
			SelectAll: () => 'Välj alla',
			ConfirmTitle: () => 'Återbetala den här ordern?',
			ConfirmWarning: (args: { total: TranslationAmount }) =>
				'Detta återbetalar ' +
				amountFormatter('sv', args.total) +
				' till kunden. Återbetalningar är permanenta och kan inte ångras eller avbrytas när de väl har inletts.',
			Submit: () => 'Återbetala',
			Success: () => 'Återbetalning inledd',
			Error: () => 'Det gick inte att inleda återbetalning'
		},
		Payment: {
			CreateRefundWrongQuantity: (args: { number: string }) =>
				'Antal ska vara ett tal mellan 0 och ' + String(args.number)
		}
	},
	OrderDetail: {
		Title: (arg0: string) => 'Order #' + String(arg0),
		OnDateFromSalesChannel: (args: { date: string; salesChannel: string }) =>
			String(args.date) + ' från ' + String(args.salesChannel),
		OnDateFromPointOfSale: (args: { date: string; salesChannel: string; pointOfSale: string }) =>
			String(args.date) + ' från ' + String(args.salesChannel) + ' (' + String(args.pointOfSale) + ')',
		Status: (arg0: 'COMPLETED' | 'CANCELED') =>
			(v => {
				switch (v) {
					case 'COMPLETED':
						return 'Slutförd'
					case 'CANCELED':
						return 'Avbruten'
					default:
						return String(v)
				}
			})(arg0),
		CancelWarning: (args: { id: string }) =>
			'Du är på väg att avbryta ordern ' + String(args.id) + '. Denna åtgärd kan inte ångras.',
		OpenOrderDetails: () => 'Öppna orderdetaljer',
		Items: () => 'Varor',
		Transactions: () => 'Transaktioner',
		Summary: {
			Title: () => 'Sammanfattning',
			EditOrder: () => 'Redigera order',
			OpenReceipt: () => 'Öppna kvitto',
			ItemTotal: () => 'Varutotal',
			TaxTotal: () => 'Moms totalt',
			Total: () => 'Totalt',
			GiftCardTotal: () => 'Presentkort totalt',
			PointsEarned: () => 'Intjänade lojalitetspoäng',
			PaidTotal: () => 'Betalt totalt',
			OutstandingAmount: () => 'Utestående belopp',
			Discount: () => 'Rabatt',
			Refunded: () => 'Återbetalat'
		},
		Receipt: {
			FailedToLoad: () => 'Kunde inte läsa in kvitto',
			Redirecting: () => 'Omdirigerar till kvitto...',
			Loading: () => 'Läser in kvitto...'
		},
		Payment: {
			Title: () => 'Betalningar',
			Status: (
				arg0: 'PENDING' | 'UNPAID' | 'PAID' | 'PARTIALLY_PAID' | 'OVERPAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'
			) =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Väntar'
						case 'UNPAID':
							return 'Obetald'
						case 'PAID':
							return 'Betald'
						case 'PARTIALLY_PAID':
							return 'Delvis betald'
						case 'OVERPAID':
							return 'Överbetald'
						case 'REFUNDED':
							return 'Återbetald'
						case 'PARTIALLY_REFUNDED':
							return 'Delvis återbetald'
						default:
							return String(v)
					}
				})(arg0),
			TransactionStatus: (arg0: 'FAILED' | 'SUCCESS' | 'PENDING') =>
				(v => {
					switch (v) {
						case 'FAILED':
							return 'Misslyckades'
						case 'SUCCESS':
							return 'Lyckades'
						case 'PENDING':
							return 'Väntar'
						default:
							return String(v)
					}
				})(arg0),
			Provider: (arg0: 'RAPYD' | 'MANUAL' | 'STRIPE' | 'ADYEN') =>
				(v => {
					switch (v) {
						case 'RAPYD':
							return 'Rapyd'
						case 'MANUAL':
							return 'Manuell'
						case 'STRIPE':
							return 'Stripe'
						case 'ADYEN':
							return 'Adyen'
						default:
							return String(v)
					}
				})(arg0),
			PaymentWithSequenceNumber: (args: { sequenceNumber: string }) =>
				'Betalning #' + String(args.sequenceNumber),
			RefundWithSequenceNumber: (args: { sequenceNumber: string }) =>
				'Återbetalning #' + String(args.sequenceNumber),
			TotalPaidByCustomer: () => 'Totalt betalt av kund',
			TotalPending: () => 'Totalt väntande',
			Refund: () => 'Återbetala'
		},
		SandStar: {
			Title: () => 'SandStar cooler',
			CloudReview: () => 'Molngranskning',
			MachineName: () => 'Maskin',
			OrderNo: () => 'Ordernummer',
			AbnormalReason: () => 'Avvikelseorsak',
			Video: () => 'Video',
			NoVideo: () => 'Ingen video'
		}
	},
	Products: {
		Title: () => 'Produkter',
		Library: () => 'Bibliotek',
		Status: (arg0: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED') =>
			(v => {
				switch (v) {
					case 'DRAFT':
						return 'Utkast'
					case 'PUBLISHED':
						return 'Publicerad'
					case 'ARCHIVED':
						return 'Arkiverad'
					default:
						return String(v)
				}
			})(arg0),
		BarcodeType: () => 'Streckkodstyp',
		ExportTitle: () => 'Exportera produkter',
		AdvancedFilters: () => 'Produktfilter',
		NoAdvancedFiltersYet: () => 'Inga avancerade filter tillgängliga för produkter ännu.',
		OpenProductDetails: () => 'Öppna produktdetaljer',
		LibraryPage: {
			NoAssets: () => 'Inga produktbilder ännu',
			NoAssetsDescription: () => 'Ladda upp produktbilder här för att återanvända dem på dina produkter.',
			Filename: () => 'Filnamn',
			TableView: () => 'Tabellvy',
			GalleryView: () => 'Gallerivy',
			Upload: () => 'Ladda upp',
			SearchFilename: () => 'Sök på filnamn',
			ViewFullImage: () => 'Visa hela bilden',
			CopyUrl: () => 'Kopiera URL',
			CopiedUrl: () => 'URL kopierad',
			DeleteAsset: () => 'Ta bort tillgång',
			DeleteAssetConfirm: () => 'Ta bort den här tillgången? Det kan inte ångras.',
			UploadAssets: () => 'Ladda upp tillgångar',
			UploadDropzone: () => 'Dra och släpp bilder här, eller klicka för att välja filer',
			ChooseFiles: () => 'Välj filer',
			Tags: () => 'Taggar',
			UsedBy: () => 'Används av',
			UsageFilter: () => 'Användning',
			UsageUnused: () => 'Oanvänd',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgrupp',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Marknadsföringsinnehåll',
			UsageFeedLayout: () => 'Kundapp-flöde',
			ChannelFilter: () => 'Marknadsföringskanal',
			ContentFilter: () => 'Används av innehåll',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Utan innehåll',
			TagsPlaceholder: () => 'Lägg till en tagg och tryck Enter',
			Uploading: () => 'Laddar upp',
			EditTags: () => 'Redigera taggar',
			NoTags: () => 'Inga taggar',
			ManageTags: () => 'Hantera taggar',
			ManageTagsEmpty: () => 'Inga taggar i biblioteket ännu.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' tillgångar',
			CreateTag: () => 'Skapa tagg',
			CreateTagPlaceholder: () => 'Lägg till en tagg och tryck Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Taggen "' + String(args.tag) + '" skapades.',
			RenameTag: () => 'Byt namn på tagg',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Slå samman taggen "' +
				String(args.from) +
				'" med "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' tillgångar)? Den gamla taggen tas bort.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tagg omdöpt från "' + String(args.from) + '" till "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Ta bort taggen "' + String(args.tag) + '" från alla tillgångar? Filerna tas inte bort.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tagg borttagen från ' +
				String(args.count) +
				' ' +
				plural('sv', args.count, { one: 'tillgång', other: 'tillgångar' }) +
				'.'
		},
		Column: {
			Title: () => 'Titel',
			Status: () => 'Status',
			PricingMethod: () => 'Prismetod',
			SalesChannels: () => 'Försäljningskanaler'
		},
		PricingMethod: (arg0: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'PER_WEIGHT' | 'WEIGHT_EMBEDDED') =>
			(v => {
				switch (v) {
					case 'PER_UNIT':
						return 'Per enhet'
					case 'PRICE_EMBEDDED':
						return 'Pris inkluderat'
					case 'PER_WEIGHT':
						return 'Per vikt'
					case 'WEIGHT_EMBEDDED':
						return 'Vikt inkluderad'
					default:
						return String(v)
				}
			})(arg0),
		Export: {
			Description: () => 'Exportera produkter till en CSV-fil.',
			Download: () => 'Ladda ner',
			Error: () => 'Det gick inte att exportera produkter',
			Format: () => 'Format',
			NoDataError: () => 'Inga data att exportera',
			ProductCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'produkt', other: 'produkter' }),
			Success: () => 'Produkter exporterade'
		},
		Import: {
			Header: () => 'Importera produktlista',
			UploadLabel: () => 'Importera produkter',
			UploadHint: () => 'Dra och släpp en CSV-fil eller klicka för att ladda upp',
			Description: () => 'Importera produkter genom att ange en CSV-fil i ett fördefinierat format',
			Template: {
				Title: () => 'Osäker på hur du ska ordna din lista?',
				Description: () => 'Ladda ner mallen nedan för att säkerställa att du följer rätt format.'
			},
			Upload: {
				Title: () => 'Ladda upp en CSV-fil',
				Description: () =>
					'Genom import kan du lägga till eller uppdatera produkter. För att uppdatera befintliga produkter matchas indata mot externt ID, SKU eller streckkod. Du ombeds bekräfta innan vi importerar produkter.',
				Preprocessing: () => 'Förbehandlar...',
				Importing: () => 'Importerar produkter...',
				ProductsToCreate: () => 'Produkter kommer att skapas',
				ProductsToUpdate: () => 'Produkter kommer att uppdateras',
				ProductsCreated: () => 'Produkter skapade',
				ProductsUpdated: () => 'Produkter uppdaterade',
				ProductsErrored: () => 'Produkter med fel',
				Errors: {
					Title: () => 'Fel',
					Description: (args: { count: number; rows: number }) =>
						String(args.count) +
						' ' +
						plural('sv', args.count, { one: 'fel', other: 'fel' }) +
						' i ' +
						String(args.rows) +
						' ' +
						plural('sv', args.rows, { one: 'rad', other: 'rader' }),
					Row: () => 'Rad',
					Column: () => 'Kolumn',
					Message: () => 'Meddelande'
				}
			},
			Success: () => 'Import slutförd!'
		}
	},
	Product: {
		Header: (arg0: string) => 'Produkt ' + String(arg0),
		EditHeader: () => 'Redigera produkt',
		EditSuccessToast: (args: { title: string }) => 'Produkten ' + String(args.title) + ' uppdaterades.',
		CreateTitle: () => 'Skapa produkt',
		Title: () => 'Titel',
		Subtitle: () => 'Undertitel',
		Description: () => 'Beskrivning',
		PricingMethodTitle: () => 'Prismetod',
		Overview: () => 'Översikt',
		ExternalId: () => 'Externt ID',
		ExternalSource: () => 'Extern källa',
		ManagedExternally: (args: { source: string }) => 'Den här produkten hanteras av ' + String(args.source),
		Sku: () => 'SKU',
		Variants: () => 'Varianter',
		DeleteWarning: (args: { title: string }) =>
			'Du är på väg att ta bort produkten ' + String(args.title) + '. Denna åtgärd kan inte ångras.',
		Create: {
			Title: () => 'Skapa produkt'
		},
		Media: {
			Title: () => 'Media',
			Upload: () => 'Ladda upp',
			ChooseFromLibrary: () => 'Välj från bibliotek',
			LibraryPickerTitle: () => 'Lägg till från bibliotek',
			LibraryPickerEmpty: () => 'Inga produktbilder i biblioteket ännu.',
			LibraryPickerAllAttached: () => 'Alla bilder från biblioteket finns redan på den här produkten.',
			AddImageSuccessToast: () => 'Bild tillagd',
			DeleteImageLabel: () => 'Ta bort bild',
			DownloadImageLabel: () => 'Ladda ner bild',
			SetPrimaryLabel: () => 'Ange som primär',
			AlreadyPrimaryLabel: () => 'Primär bild',
			PrimaryBadge: () => 'Primär',
			ProcessingBadge: () => 'Bearbetar…',
			UploadingLabel: (args: { percent: number }) => 'Laddar upp… ' + String(args.percent) + '%',
			UploadSuccessToast: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'bild', other: 'bilder' }) + ' uppladdade',
			UploadFailedToast: () => 'Det gick inte att ladda upp bild',
			DeleteSuccessToast: () => 'Bild borttagen',
			SetPrimarySuccessToast: () => 'Primär bild uppdaterad',
			EmptyState: {
				Header: () => 'Ingen bild ännu',
				Description: () =>
					'Dra och släpp bilder här, eller lägg till en bild på produkten för att visa upp den i din butik.',
				Action: () => 'Lägg till media'
			}
		},
		Organization: {
			Header: () => 'Organisation'
		},
		Pricing: {
			Title: () => 'Prissättning',
			VariablePrice: () => 'Variabelt pris',
			Price: () => 'Pris',
			PriceWithTax: () => 'Pris inkl. moms',
			PriceWithoutTax: () => 'Pris exkl. moms',
			Enabled: () => 'Aktiverad',
			InvalidTaxRate: (args: { taxRate: string }) => 'Ogiltig momssats: ' + String(args.taxRate),
			NoPricesConfigured: () => 'Inga priser konfigurerade',
			Target: () => 'Gäller för',
			Group: () => 'Grupp',
			Channel: () => 'Försäljningskanal',
			GroupDefault: () => 'Gruppstandard',
			ChannelOverride: () => 'Kanalåsidosättning',
			AddOverride: () => 'Lägg till kanalåsidosättning',
			SelectOverrideChannel: () => 'Välj en försäljningskanal att åsidosätta',
			NoOverridableChannels: () => 'Alla grupperade kanaler har redan en åsidosättning',
			RemoveOverride: () => 'Ta bort åsidosättning',
			ExpandGroup: () => 'Visa kanalpriser',
			CollapseGroup: () => 'Dölj kanalpriser',
			OverrideCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'åsidosättning', other: 'åsidosättningar' }),
			EmptyState: {
				Header: () => 'Inga priser konfigurerade',
				Description: () => 'Lägg till ett pris för denna produkt så att den kan säljas i en försäljningskanal.',
				Action: () => 'Lägg till pris'
			}
		},
		Barcode: {
			Title: () => 'Streckkoder',
			Barcode: () => 'Streckkod',
			AddBarcode: () => 'Lägg till streckkod',
			AddBarcodePrompt: {
				Title: () => 'Lägg till streckkod',
				Placeholder: () => 'Streckkod'
			},
			Delete: {
				Title: () => 'Ta bort streckkod',
				Description: (args: { barcode: string }) =>
					'Är du säker på att du vill ta bort streckkoden ' + String(args.barcode) + '?'
			},
			AlreadyOnProduct: () => 'Den här streckkoden finns redan på den här produkten',
			AlreadyInUse: () => 'Den här streckkoden används redan av en annan produkt'
		},
		UnitsOfMeasure: {
			Title: () => 'Måttenheter',
			Unit: () => 'Enhet',
			Base: () => 'Bas',
			BaseUnit: () => 'Basenhet',
			True: () => 'Sant',
			False: () => 'Falskt',
			BaseUnitLabel: (args: { code: string }) => String(args.code) + ' (bas)',
			BaseUnitsPer: () => 'Antal per enhet',
			Sellable: () => 'Säljbar',
			Pos: () => 'POS',
			Ecom: () => 'E-handel',
			Add: () => 'Lägg till enhet',
			Edit: () => 'Redigera enhet',
			Code: () => 'Kod',
			Name: () => 'Namn',
			InvalidFactor: () => 'Antal måste vara större än noll',
			SelectUnit: () => 'Välj en enhet',
			QuantityRequired: () => 'Den här enheten har ingen gemensam mängd, så ett antal krävs',
			Saved: () => 'Enhet sparad',
			Delete: {
				Title: () => 'Ta bort enhet',
				Description: (args: { code: string }) => 'Är du säker på att du vill ta bort ' + String(args.code) + '?'
			}
		}
	},
	ProductEdit: {
		Header: () => 'Redigera produkt'
	},
	ProductCategories: {
		Title: () => 'Kategorier',
		Breadcrumb: () => 'Kategorier',
		Search: () => 'Sök kategorier',
		Empty: () => 'Inga kategorier ännu',
		NoSearchResults: (args: { query: string }) => 'Inga kategorier matchar ”' + String(args.query) + '”',
		Column: {
			Name: () => 'Namn',
			ProductCount: () => 'Antal produkter'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'Ingen överordnad',
			SelectParentTitle: () => 'Välj överordnad kategori',
			SelectParentDescription: () => 'Välj en överordnad kategori för den här kategorin'
		}
	},
	ProductCategory: {
		CreateSuccessToast: (args: { name: string }) => 'Kategorin ' + String(args.name) + ' skapades.',
		EditHeader: () => 'Redigera kategori',
		EditSuccessToast: (args: { name: string }) => 'Kategorin ' + String(args.name) + ' uppdaterades.',
		CreateTitle: () => 'Skapa kategori',
		ParentCategory: () => 'Överordnad kategori',
		ProductsTitle: () => 'Produkter',
		SelectParent: () => 'Välj överordnad kategori',
		ClearParent: () => 'Rensa överordnad kategori',
		Delete: {
			Title: () => 'Ta bort kategori',
			Description: (args: { name: string }) =>
				'Är du säker på att du vill ta bort kategorin "' +
				String(args.name) +
				'"? Produkter i denna kategori tas inte bort.',
			SuccessToast: (args: { name: string }) => 'Kategorin ' + String(args.name) + ' togs bort.'
		},
		Image: {
			Title: () => 'Bild',
			EmptyState: () => 'Ingen bild än',
			Upload: () => 'Ladda upp',
			ChooseFromLibrary: () => 'Välj från bibliotek',
			Remove: () => 'Ta bort bild',
			LibraryPickerTitle: () => 'Lägg till från bibliotek',
			LibraryPickerEmpty: () => 'Inga produktbilder i biblioteket än.',
			LibraryPickerAllAttached: () => 'Den här bilden är redan vald.',
			SetSuccessToast: () => 'Bild uppdaterad',
			RemoveSuccessToast: () => 'Bild borttagen',
			UploadFailedToast: () => 'Det gick inte att ladda upp bilden'
		},
		Create: {
			NoParent: () => 'Ingen överordnad',
			SelectParentTitle: () => 'Välj överordnad kategori',
			SelectParentDescription: () => 'Välj en överordnad kategori för den här kategorin'
		}
	},
	ProductGroups: {
		Title: () => 'Grupper',
		Breadcrumb: () => 'Grupper',
		Search: () => 'Sök grupper',
		Empty: () => 'Inga grupper ännu',
		NoSearchResults: (args: { query: string }) => 'Inga grupper matchar ”' + String(args.query) + '”',
		Column: {
			Name: () => 'Namn',
			ProductCount: () => 'Antal produkter'
		}
	},
	ProductGroup: {
		Title: (arg0: string) => 'Grupp ' + String(arg0),
		EditHeader: () => 'Redigera grupp',
		EditSuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' uppdaterades.',
		CreateTitle: () => 'Skapa grupp',
		CreateSuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' skapades.',
		Delete: {
			Title: () => 'Ta bort grupp',
			Description: (args: { name: string }) =>
				'Är du säker på att du vill ta bort gruppen "' +
				String(args.name) +
				'"? Produkter i denna grupp tas inte bort.',
			SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' togs bort.'
		},
		Image: {
			Title: () => 'Bild',
			EmptyState: () => 'Ingen bild än',
			Upload: () => 'Ladda upp',
			ChooseFromLibrary: () => 'Välj från bibliotek',
			Remove: () => 'Ta bort bild',
			LibraryPickerTitle: () => 'Lägg till från bibliotek',
			LibraryPickerEmpty: () => 'Inga produktbilder i biblioteket än.',
			LibraryPickerAllAttached: () => 'Den här bilden är redan vald.',
			SetSuccessToast: () => 'Bild uppdaterad',
			RemoveSuccessToast: () => 'Bild borttagen',
			UploadFailedToast: () => 'Det gick inte att ladda upp bilden'
		},
		Products: {
			Title: () => 'Produkter',
			NoProducts: () => 'Inga produkter',
			Add: {
				Title: () => 'Lägg till produkter',
				Label: () => 'Produkter',
				Placeholder: () => 'Sök produkter',
				SuccessToast: (args: { count: number; name: string }) =>
					String(args.count) + ' produkt(er) tillagda i ' + String(args.name) + '.',
				NoProducts: () => 'Välj minst en produkt.'
			}
		},
		Fees: {
			Title: () => 'Avgifter',
			AddFee: () => 'Lägg till avgift',
			NoFees: () => 'Inga avgifter',
			Delete: {
				Title: () => 'Ta bort avgift',
				Description: (args: { name: string }) =>
					'Är du säker på att du vill ta bort avgiften "' + String(args.name) + '"?'
			},
			Create: {
				Title: () => 'Skapa avgift',
				Pricing: () => 'Prissättning',
				SuccessToast: (args: { name: string }) => 'Avgiften ' + String(args.name) + ' skapades.',
				NoPrices: () => 'Lägg till minst ett pris.'
			},
			Edit: {
				Title: () => 'Redigera avgift',
				SuccessToast: (args: { name: string }) => 'Avgiften ' + String(args.name) + ' uppdaterades.'
			}
		}
	},
	GiftCards: {
		Title: () => 'Presentkort',
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserverad'
					case 'REDEEMED':
						return 'Inlöst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Redigera presentkort',
		EditSuccess: () => 'Presentkort uppdaterat',
		DeleteSuccess: () => 'Presentkort borttaget',
		Delete: {
			Title: () => 'Ta bort presentkort',
			Description: () => 'Är du säker på att du vill ta bort detta presentkort? Denna åtgärd kan inte ångras.'
		},
		Column: {
			Name: () => 'Namn',
			Code: () => 'Kod',
			Amount: () => 'Belopp',
			CurrencyCode: () => 'Valuta',
			Status: () => 'Status'
		},
		Detail: {
			Title: () => 'Presentkort',
			General: () => 'Allmänt',
			CardDetails: () => 'Kortdetaljer',
			Redemptions: () => 'Inlösningar',
			NoRedemptions: () => 'Inga inlösningar',
			Date: () => 'Datum',
			RedemptionStatus: (arg0: 'PENDING' | 'APPLIED') =>
				(v => {
					switch (v) {
						case 'PENDING':
							return 'Väntar'
						case 'APPLIED':
							return 'Använd'
						default:
							return String(v)
					}
				})(arg0)
		}
	},
	GiftCard: {
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'RESERVED' | 'REDEEMED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'RESERVED':
						return 'Reserverad'
					case 'REDEEMED':
						return 'Inlöst'
					default:
						return String(v)
				}
			})(arg0),
		EditTitle: () => 'Redigera presentkort',
		CreateTitle: () => 'Skapa presentkort',
		Name: () => 'Namn',
		Code: () => 'Kod',
		Amount: () => 'Belopp',
		CurrencyCode: () => 'Valutakod'
	},
	LoyaltyCards: {
		Title: () => 'Lojalitetskort',
		EditTitle: () => 'Redigera lojalitetskort',
		EditSuccess: () => 'Lojalitetskort uppdaterat',
		DeleteSuccess: () => 'Lojalitetskort borttaget',
		ManagedExternally: (args: { source: string }) => 'Detta lojalitetskort hanteras av ' + String(args.source),
		Delete: {
			Title: () => 'Ta bort lojalitetskort',
			Description: () => 'Är du säker på att du vill ta bort detta lojalitetskort? Denna åtgärd kan inte ångras.'
		},
		Detail: {
			Title: () => 'Lojalitetskort',
			CardDetails: () => 'Kortdetaljer',
			Customer: () => 'Kund',
			Redemptions: () => 'Inlösningar',
			Date: () => 'Datum'
		},
		Column: {
			Name: () => 'Namn',
			CardNumber: () => 'Kortnummer',
			Customer: () => 'Kund',
			Status: () => 'Status',
			AvailablePoints: () => 'Tillgängliga poäng',
			TotalPoints: () => 'Totala poäng',
			ExternalId: () => 'Externt ID',
			ExternalSource: () => 'Extern källa',
			PointsUsed: () => 'Använda poäng',
			PointsRemaining: () => 'Återstående poäng',
			Order: () => 'Order'
		}
	},
	Inventory: {
		Title: () => 'Lager',
		Stock: () => 'Lagersaldo',
		Suppliers: () => 'Leverantörer',
		Movements: () => 'Lagerrörelser',
		Receiving: () => 'Inleverans',
		Transfers: () => 'Överföringar',
		Reports: () => 'Lagerrapporter',
		Summary: {
			TotalSkus: () => 'Totalt antal SKU:er',
			LowStock: () => 'Lågt lager',
			OutOfStock: () => 'Slutsåld'
		},
		Column: {
			Product: () => 'Produkt',
			Variant: () => 'Variant',
			Sku: () => 'SKU',
			SalesChannel: () => 'Försäljningskanal',
			InventoryLocation: () => 'Plats',
			QuantityOnHand: () => 'I lager',
			QuantityAfter: () => 'I lager efter',
			ReorderPoint: () => 'Beställningspunkt',
			ReorderQuantity: () => 'Beställningsantal',
			Status: () => 'Status',
			Type: () => 'Typ',
			Delta: () => 'Ändring',
			Reason: () => 'Anledning',
			CreatedBy: () => 'Av',
			Ordered: () => 'Beställd',
			Received: () => 'Mottagen',
			ReceiveNow: () => 'Ta emot nu',
			UnitCost: () => 'Enhetskostnad',
			Quantity: () => 'Antal',
			Lines: () => 'Varor',
			Date: () => 'Datum',
			Name: () => 'Namn',
			Email: () => 'Email',
			Reference: () => 'Referens',
			From: () => 'Från',
			To: () => 'Till',
			Supplier: () => 'Leverantör',
			Currency: () => 'Valuta',
			Margin: () => 'Marginal',
			PurchasePrice: () => 'Inköpspris',
			RetailPrice: () => 'Butikspris',
			Tracked: () => 'Spårad'
		},
		Filter: {
			LowStockOnly: () => 'Endast lågt lager',
			SalesChannel: () => 'Försäljningskanal',
			InventoryLocation: () => 'Plats',
			Status: () => 'Status',
			Type: () => 'Typ',
			AllChannels: () => 'Alla försäljningskanaler',
			AllLocations: () => 'Alla platser',
			AllStatuses: () => 'Alla statusar',
			AllTypes: () => 'Alla typer'
		},
		NotTracked: () => 'Inte spårad',
		ReorderSettings: () => 'Beställningsinställningar',
		ViewMovements: () => 'Visa historik',
		Adjust: () => 'Justera lager',
		AdjustSuccess: () => 'Lagret justerades',
		AdjustNoChanges: () => 'Inga ändringar att tillämpa',
		AdjustDeltaHint: () => 'Relativ ändring av lagersaldot. Använd ett negativt värde för att ta bort lager.',
		EditProduct: () => 'Redigera produkt',
		Settings: {
			Title: () => 'Inställningar',
			Description: () => 'Styr hur lagerspårning fungerar över dina försäljningskanaler.',
			Enabled: () => 'Aktivera lagerspårning',
			EnabledDescription: () => 'Följ lagernivåer och lagerrörelser för dina produkter.',
			DeductOnOrderComplete: () => 'Dra av lager vid slutförda order',
			DeductOnOrderCompleteDescription: () => 'Minska lagersaldot automatiskt när en order slutförs.',
			BlockOversell: () => 'Blockera översäljning',
			BlockOversellDescription: () =>
				'Förhindra försäljning av fler enheter än vad som finns tillgängligt i en kanal.',
			RestockOnReturn: () => 'Fyll på vid returer',
			RestockOnReturnDescription: () => 'Lägg tillbaka returnerade varor i lagret när en återbetalning slutförs.',
			HideOutOfStock: () => 'Dölj slutsålda produkter',
			HideOutOfStockDescription: () =>
				'Dölj spårade produkter från butiken när de saknar tillgängligt lager i kanalen.',
			Saved: () => 'Lagerinställningar uppdaterade',
			Locations: {
				Title: () => 'Platser',
				Description: () => 'Hantera lagerplatser och koppla försäljningskanaler till dem.',
				Column: {
					Name: () => 'Namn',
					SalesChannels: () => 'Försäljningskanaler'
				},
				CreateTitle: () => 'Skapa plats',
				CreateSuccess: () => 'Plats skapad',
				EditTitle: () => 'Redigera plats',
				EditSuccess: () => 'Plats uppdaterad',
				NamePlaceholder: () => 'Lager, butiksgolv, …',
				LinkedChannels: () => 'Kopplade försäljningskanaler',
				LinkedChannelsHint: () =>
					'Välj försäljningskanaler som hämtar lager från den här platsen. Att lägga till en kanal som är kopplad någon annanstans flyttar den hit.',
				NoLinkedChannels: () => 'Inga försäljningskanaler kopplade till den här platsen.',
				InitializeStock: () => 'Initiera lagerposter',
				InitializeStockDescription: () =>
					'Skapa lagerpostrader för alla spårade varianter på den här platsen. Befintliga poster hoppas över.',
				InitializeStockSuccess: () => 'Lagerposter initierade',
				InitializeStockProgress: (args: { created: number; remaining: number }) =>
					'Skapade ' + String(args.created) + ' poster (' + String(args.remaining) + ' kvar)',
				InitializeStockProgressLabel: (args: { created: number; total: number }) =>
					'Skapade ' + String(args.created) + ' av ' + String(args.total) + ' lagerposter',
				InitializeStockError: (args: { created: number }) =>
					'Initieringen stoppade efter att ha skapat ' +
					String(args.created) +
					' poster. Försök igen för att slutföra.',
				InitializeStockRetry: () => 'Försök igen',
				AdminOnly: () => 'Endast administratörer kan hantera lagerplatser.'
			}
		},
		Status: {
			IN_STOCK: () => 'I lager',
			LOW_STOCK: () => 'Lågt lager',
			OUT_OF_STOCK: () => 'Slutsåld'
		},
		MovementType: {
			ADJUSTMENT: () => 'Justering',
			RECEIPT: () => 'Mottagning',
			TRANSFER_IN: () => 'Överföring in',
			TRANSFER_OUT: () => 'Överföring ut',
			ORDER_DEDUCTION: () => 'Orderavdrag',
			ORDER_RETURN: () => 'Orderretur'
		},
		TransferStatus: {
			DRAFT: () => 'Utkast',
			IN_TRANSIT: () => 'Under transport',
			RECEIVED: () => 'Mottagen',
			CANCELLED: () => 'Avbruten'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Utkast',
			ORDERED: () => 'Beställd',
			PARTIALLY_RECEIVED: () => 'Delvis mottagen',
			RECEIVED: () => 'Mottagen',
			CANCELLED: () => 'Avbruten'
		},
		CreateSupplier: () => 'Skapa leverantör',
		EditSupplier: () => 'Redigera leverantör',
		EditSupplierSuccess: () => 'Leverantör uppdaterad',
		SuppliersEmptyTitle: () => 'Inga leverantörer ännu',
		SuppliersEmptyDescription: () => 'Skapa din första leverantör för att hålla koll på var du köper lager.',
		CreateTransfer: () => 'Skapa överföring',
		CreatePurchaseOrder: () => 'Skapa inköpsorder',
		PurchaseCurrencyHint: (args: { currency: string }) =>
			'Använder ' + String(args.currency) + ' för denna order. Ändra om denna order skiljer sig.',
		PurchaseCurrencyDefaultHint: (args: { currency: string }) =>
			'Använder som standard din rapporteringsvaluta ' + String(args.currency) + '. Bekräfta eller ändra den.',
		PurchaseCurrencyRequired: () => 'Välj en inköpsvaluta.',
		ShipTransfer: () => 'Skicka överföring',
		ReceiveTransfer: () => 'Ta emot överföring',
		CancelTransfer: () => 'Avbryt överföring',
		Transfer: () => 'Överföring',
		Actions: () => 'Åtgärder',
		ReceivePurchaseOrder: () => 'Ta emot varor',
		ManageSuppliers: () => 'Hantera',
		Replenish: () => 'Fyll på lågt lager',
		ReplenishSuccess: (args: { count: number }) => 'Skapade ' + String(args.count) + ' påfyllningsutkast',
		ReplenishNone: () => 'Inga varor under beställningspunkten',
		MarkOrdered: () => 'Markera som beställd',
		CancelOrder: () => 'Avbryt',
		PurchaseOrder: () => 'Inköpsorder',
		AddLine: () => 'Lägg till',
		NoLines: () => 'Inga varor har lagts till ännu.',
		SelectSalesChannel: () => 'Välj försäljningskanal',
		SupplierDialog: {
			Title: () => 'Produktleverantörer',
			Preferred: () => 'Föredragen',
			SetPreferred: () => 'Ange som föredragen',
			AddSupplier: () => 'Lägg till leverantör',
			SelectSupplier: () => 'Välj leverantör',
			Empty: () => 'Inga leverantörer är kopplade till denna produkt ännu.',
			NoSuppliersYet: () => 'Inga leverantörer finns ännu',
			NoSuppliersDescription: () => 'Skapa en leverantör innan du kopplar den till denna produkt.',
			CreateSupplierAction: () => 'Skapa leverantör',
			SupplierProductCode: () => 'Leverantörens produktkod',
			UpdateSuccess: () => 'Leverantör uppdaterad',
			AllSuppliersLinked: () => 'Alla befintliga leverantörer är redan kopplade till denna produkt.',
			EditPrices: () => 'Redigera priser',
			MarginUnavailable: () => 'Inte tillgänglig',
			MarginCurrencyMismatch: (args: { retail: string; purchase: string }) =>
				'Marginalen kan inte beräknas eftersom butikspriset (' +
				String(args.retail) +
				') och leverantörspriset (' +
				String(args.purchase) +
				') använder olika valutor.',
			MarginTaxNote: () =>
				'Marginalen beräknas på detaljhandelspriset exkl. moms. Detaljhandelspriser inkl. moms får momsen avdragen först.',
			PurchasePriceTaxNote: () => 'Ange leverantörens inköpspris exkl. moms (netto).'
		}
	},
	Companies: {
		Title: () => 'Företag',
		Anonymous: () => 'Namnlöst',
		CreateTitle: () => 'Skapa företag',
		CreateSuccess: () => 'Företag skapat',
		EditTitle: () => 'Redigera företag',
		EditSuccess: () => 'Företag uppdaterat',
		UpdateSuccess: () => 'Företag uppdaterat',
		Delete: {
			Title: () => 'Ta bort företag',
			Description: (args: { name: string }) =>
				'Är du säker på att du vill ta bort företaget ' + String(args.name) + '? Denna åtgärd kan inte ångras.'
		},
		DeleteSuccess: () => 'Företag borttaget',
		CardCount: () => 'Företagskort',
		SettlementCount: () => 'Senaste avräkningar',
		RecentSettlements: () => 'Senaste avräkningar',
		Cards: {
			Title: () => 'Företagskort'
		},
		Detail: {
			Title: () => 'Företagsdetaljer',
			General: () => 'Allmänt',
			ContactInfo: () => 'Kontaktuppgifter',
			Cards: () => 'Företagskort',
			Settlements: () => 'Avräkningar',
			RecentSettlements: () => 'Senaste avräkningar',
			AssignCard: () => 'Tilldela kort',
			AssignCardDescription: () =>
				'Sök efter ett företagskort på namn eller kortnummer för att tilldela det till det här företaget.',
			AssignCardSuccess: () => 'Kort tilldelat',
			UnassignCard: () => 'Ta bort korttilldelning',
			UnassignCardConfirm: () =>
				'Är du säker på att du vill ta bort tilldelningen av det här kortet från företaget?',
			UnassignCardSuccess: () => 'Korttilldelning borttagen',
			CardNumberPlaceholder: () => 'Sök på namn eller kortnummer'
		},
		Column: {
			Name: () => 'Namn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Externt ID',
			CardCount: () => 'Kort',
			SettlementCount: () => 'Avräkningar',
			CreatedAt: () => 'Skapad'
		},
		Field: {
			Name: () => 'Namn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Externt ID'
		},
		Create: {
			BasicInfo: () => 'Grundläggande information',
			Description: () => 'Skapa ett nytt företag',
			NamePlaceholder: () => 'Ange företagsnamn',
			ExternalIdPlaceholder: () => 'Ange externt ID (valfritt)'
		},
		Edit: {
			BasicInfo: () => 'Grundläggande information',
			Description: () => 'Redigera företagsinformation',
			NamePlaceholder: () => 'Ange företagsnamn',
			EmailPlaceholder: () => 'Ange e-postadress',
			PhonePlaceholder: () => 'Ange telefonnummer',
			OrgNumberPlaceholder: () => 'Ange organisationsnummer',
			ExternalIdPlaceholder: () => 'Ange externt ID (valfritt)'
		}
	},
	Customers: {
		Title: () => 'Kunder',
		UnnamedCustomer: () => 'Namnlös kund',
		Anonymous: () => 'Anonym',
		CreateTitle: () => 'Skapa kund',
		CreateSuccess: (args: { name: string }) => 'Kunden ' + String(args.name) + ' skapades.',
		EditTitle: () => 'Redigera kund',
		UpdateSuccess: () => 'Kund uppdaterad',
		Detail: {
			Title: () => 'Kund',
			General: () => 'Allmänt',
			ContactInfo: () => 'Kontaktuppgifter',
			Cards: () => 'Kort',
			AssignCard: () => 'Tilldela kort',
			AssignCardDescription: () =>
				'Sök efter ett företagskort på namn eller kortnummer för att tilldela det till den här kunden.',
			AssignCardSuccess: () => 'Kort tilldelat',
			UnassignCard: () => 'Ta bort korttilldelning',
			UnassignCardConfirm: () =>
				'Är du säker på att du vill ta bort tilldelningen av det här kortet från kunden?',
			UnassignCardSuccess: () => 'Korttilldelning borttagen',
			CardNumberPlaceholder: () => 'Sök på namn eller kortnummer'
		},
		Column: {
			Name: () => 'Namn',
			Email: () => 'E-post',
			Phone: () => 'Telefon',
			ExternalId: () => 'Externt ID',
			Cards: () => 'Kort'
		},
		Field: {
			FirstName: () => 'Förnamn',
			LastName: () => 'Efternamn',
			Phone: () => 'Telefon',
			SSN: () => 'Personnummer'
		},
		Create: {
			BasicInfo: () => 'Grundläggande information',
			Description: () => 'Skapa en ny kund'
		},
		Edit: {
			BasicInfo: () => 'Grundläggande information',
			Description: () => 'Redigera kundinformation',
			FirstNamePlaceholder: () => 'Ange förnamn',
			LastNamePlaceholder: () => 'Ange efternamn',
			EmailPlaceholder: () => 'Ange e-postadress',
			PhonePlaceholder: () => 'Ange telefonnummer',
			SSNPlaceholder: () => 'Ange personnummer (valfritt)',
			ExternalIdPlaceholder: () => 'Ange externt ID (valfritt)'
		},
		Cards: {
			Title: () => 'Kundkort',
			Active: () => 'Aktiva kort'
		}
	},
	BusinessCards: {
		Title: () => 'Företagskort',
		CreateTitle: () => 'Skapa företagskort',
		CreateSuccess: () => 'Företagskort skapat',
		EditTitle: () => 'Redigera företagskort',
		EditSuccess: () => 'Företagskort uppdaterat',
		DeleteSuccess: () => 'Företagskort borttaget',
		Create: {
			NamePlaceholder: () => 'Ange kortnamn',
			CardNumberPlaceholder: () => 'Ange kortnummer',
			SelectCompany: () => 'Välj ett företag',
			SelectCustomer: () => 'Välj en kund',
			PinTitle: () => 'Företagskort skapat',
			PinDescription: () => 'Dela den här PIN-koden med kortinnehavaren. Den kan endast visas en gång.',
			GoToCard: () => 'Gå till kort'
		},
		Delete: {
			Title: () => 'Ta bort företagskort',
			Description: () => 'Är du säker på att du vill ta bort det här företagskortet? Åtgärden kan inte ångras.'
		},
		Detail: {
			Title: () => 'Företagskort',
			General: () => 'Allmänt',
			CardDetails: () => 'Kortdetaljer',
			Security: () => 'Säkerhet',
			ResetPin: () => 'Återställ PIN',
			ResetPinDescription: () => 'Generera en ny PIN för det här kortet. Den nuvarande PIN-koden blir ogiltig.',
			ResetPinSuccess: () => 'PIN återställdes',
			NewPin: (args: { pin: string }) => 'Ny PIN: ' + String(args.pin),
			PinViewOnce: () =>
				'Den här PIN-koden kan endast visas en gång. Spara den innan du stänger den här dialogen.',
			Customer: () => 'Kund',
			Company: () => 'Företag',
			DangerZone: () => 'Farozon',
			DeleteCardDescription: () => 'Ta bort det här företagskortet permanent. Åtgärden kan inte ångras.'
		},
		Column: {
			Name: () => 'Namn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Customer: () => 'Kund',
			ExternalId: () => 'Externt ID',
			CreatedAt: () => 'Skapad'
		},
		Status: (arg0: 'ACTIVE' | 'INACTIVE' | 'BLOCKED') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					case 'BLOCKED':
						return 'Spärrad'
					default:
						return String(v)
				}
			})(arg0)
	},
	Promotions: {
		Title: () => 'Kampanjer',
		Group: () => 'Kampanjgrupp',
		Groups: () => 'Grupper',
		SelectGroups: () => 'Välj kampanjgrupper',
		Column: {
			PromotionCount: () => 'Kampanjer'
		},
		CreateTitle: () => 'Skapa kampanj',
		CreateSuccess: () => 'Kampanj skapad',
		EditTitle: () => 'Redigera kampanj',
		UpdateSuccess: () => 'Kampanj uppdaterad',
		NotFound: () => 'Kampanj hittades inte',
		AdvancedFilters: () => 'Kampanjfilter',
		ManagedExternally: (args: { source: string }) => 'Den här kampanjen hanteras av ' + String(args.source),
		Create: {
			ApplyToAll: () => 'Alla produkter',
			ApplyToGroups: () => 'Specifika produktgrupper',
			ApplyToCategories: () => 'Specifika kategorier',
			ApplyToProducts: () => 'Specifika produkter',
			AppliesTo: () => 'Gäller för',
			FixedAmount: () => 'Fast belopp',
			Percentage: () => 'Procent',
			OverridePrice: () => 'Åsidosätt pris',
			OverridePriceHelp: () =>
				'Ange ett fast totalpris för de matchade varorna per försäljningskanal eller försäljningskanalgrupp',
			IncludeFeesHelp: () =>
				'När det är på är åsidosättningspriset det slutliga totalpriset inklusive eventuella varuavgifter. När det är av läggs varuavgifter till ovanpå åsidosättningspriset.',
			OverridePriceNoChannels: () =>
				'Välj minst en försäljningskanal eller försäljningskanalgrupp för att ange åsidosatta priser',
			BasicInfo: () => 'Grundläggande info',
			DaysOfWeek: () => 'Veckodagar',
			Discount: () => 'Effekt',
			DiscountAmount: () => 'Rabattbelopp',
			DiscountPercentage: () => 'Rabattprocent',
			PercentageHelp: () => 'Ange en procent mellan 0 och 100',
			ItemCount: () => 'Antal varor',
			NamePlaceholder: () => 'Ange kampanjnamn',
			DisplayTitle: () => 'Visningstitel',
			DisplayTitlePlaceholder: () => 'Visas för kunder (valfritt)',
			DisplayTitleHint: () =>
				'Kundvänd titel som visas i scan & go, självutcheckning och webbutik. Lämna tomt för att använda det interna namnet.',
			ProductGroup: () => 'Produktgrupp',
			ProductGroups: () => 'Produktgrupper',
			SlotKind: () => 'Typ',
			SlotKindGroup: () => 'Produktgrupp',
			SlotKindCategory: () => 'Kategori',
			Categories: () => 'Kategorier',
			Products: () => 'Produkter',
			CustomerEligibility: () => 'Kundbehörighet',
			CustomerEligibilityHint: () =>
				'Lämna tomt för att gälla alla. Lägg till kunder eller kundgrupper för att begränsa kampanjen till dem.',
			CustomerGroups: () => 'Kundgrupper',
			SelectCustomerGroups: () => 'Välj kundgrupper',
			Customers: () => 'Kunder',
			SelectCustomers: () => 'Välj kunder',
			PromotionType: () => 'Kampanjtyp',
			TypeDiscount: () => 'Rabatt',
			TypeBundle: () => 'Paketerbjudande',
			TypeBuyXGetY: () => 'Köp X, få Y',
			BundleGroups: () => 'Paketgrupper och kategorier',
			BundleGroupsHelp: () =>
				'Kampanjen gäller när det nödvändiga antalet från varje grupp eller kategori finns i ordern',
			QualifyingGroups: () => 'Kvalificerande produkter (köp)',
			QualifyingGroupsHelp: () =>
				'Det antal som krävs från var och en av dessa grupper eller kategorier måste finnas i ordern för att utlösa erbjudandet. Dessa varor rabatteras inte.',
			BenefitGroups: () => 'Förmånsprodukter (få)',
			BenefitGroupsHelp: () =>
				'När de kvalificerande produkterna finns med får det antal som krävs från var och en av dessa grupper eller kategorier rabatten nedan (100 % = gratis).',
			AddBundleGroup: () => 'Lägg till grupp eller kategori',
			Schedule: () => 'Schema',
			AddDay: () => 'Lägg till dagar',
			SelectDays: () => 'Välj dagar',
			SelectProductGroups: () => 'Välj produktgrupper',
			SelectCategories: () => 'Välj kategorier',
			SelectProducts: () => 'Välj produkter',
			SelectSalesChannels: () => 'Välj försäljningskanaler',
			SalesChannelGroups: () => 'Försäljningskanalgrupper',
			SelectSalesChannelGroups: () => 'Välj försäljningskanalgrupper',
			ApplicationRule: () => 'Tillämpningsregel',
			Description: () => 'Beskrivning',
			Rank: () => 'Prioritet',
			RankHint: () => 'Lägre nummer tillämpas först när flera kampanjer matchar samma varor',
			RankInUse: (args: { names: string }) =>
				'En annan kampanj använder redan denna prioritet: ' +
				String(args.names) +
				'. Kampanjer med samma prioritet tillämpas i obestämd ordning, använd ett unikt nummer för att styra vilken som körs först.',
			SellingUnit: () => 'Försäljningsenhet',
			SellingUnitHelp: () =>
				'Alla enheter tillämpar kampanjen på alla försäljningsenheter för de valda produkterna. Basenhet eller ett namngivet paket begränsar den till den enheten.',
			AllUnits: () => 'Alla enheter',
			BaseUnit: () => 'Basenhet',
			Validation: {
				NameRequired: () => 'Namn krävs',
				PercentageRange: () => 'Ange en procent mellan 0 och 100',
				PercentageRequired: () => 'Ange en rabattprocent',
				BundleGroupsRequired: () => 'Lägg till minst en paketgrupp eller kategori med antal',
				BenefitGroupsRequired: () => 'Lägg till minst en förmånsgrupp eller kategori med ett antal',
				QualifyingBenefitOverlap: () =>
					'En produktgrupp eller kategori kan inte vara både en kvalificerande grupp och en förmånsgrupp',
				OverridePriceRequired: () => 'Ange ett åsidosatt pris för minst en försäljningskanal',
				ScopeTargetsRequired: () => 'Välj minst en produktgrupp, kategori eller produkt',
				RankRange: () => 'Ange en prioritet på 0 eller högre'
			}
		},
		Detail: {
			SalesChannels: () => 'Försäljningskanaler',
			DisplayTitle: () => 'Visningstitel',
			StartDate: () => 'Startdatum',
			EndDate: () => 'Slutdatum',
			OverridePrice: () => 'Åsidosätt pris',
			IncludeFees: () => 'Inkludera avgifter',
			ApplyToAllProducts: () => 'Tillämpa på alla produkter',
			ProductGroups: () => 'Produktgrupper',
			DiscountDefinition: () => 'Rabattdefinition',
			ApplicationRule: () => 'Tillämpningsregel',
			Prices: () => 'Priser',
			Title: () => 'Kampanjdetaljer',
			AppliesTo: () => 'Gäller för',
			SellingUnit: () => 'Försäljningsenhet',
			CustomerEligibility: () => 'Kundbehörighet',
			AppliesToEveryone: () => 'Alla kunder',
			DaysOfWeek: () => 'Veckodagar',
			Discount: () => 'Rabatt',
			DiscountType: () => 'Rabattyp',
			DiscountValue: () => 'Rabattvärde',
			Schedule: () => 'Schema'
		},
		Edit: {
			Description: () => 'Redigera kampanjdetaljerna'
		},
		Delete: {
			Title: () => 'Ta bort kampanj',
			Description: (args: { name: string }) =>
				'Är du säker på att du vill ta bort kampanjen "' + String(args.name) + '"?',
			SuccessToast: (args: { name: string }) => 'Kampanjen ' + String(args.name) + ' togs bort.'
		}
	},
	Promotion: {
		Title: () => 'Kampanj',
		CreateTitle: () => 'Skapa kampanj'
	},
	Marketing: {
		Title: () => 'Marknadsföring',
		Library: () => 'Bibliotek',
		Campaigns: () => 'Kampanjer',
		Channels: () => 'Kanaler',
		Messaging: () => 'Meddelanden',
		Journeys: () => 'Resor',
		ContentNav: () => 'Innehåll',
		LayoutNav: () => 'Layout',
		Channel: {
			Title: () => 'Marknadsföringskanaler',
			NewChannel: () => 'Ny kanal',
			NoChannels: () => 'Inga marknadsföringskanaler ännu',
			NoChannelsDescription: () =>
				'Skapa en marknadsföringskanal för att publicera innehåll och layouter för en marknadsyta.',
			CampaignCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'kampanj', other: 'kampanjer' }),
			SalesChannelsHint: () =>
				'Välj de försäljningskanaler som hör till denna marknadsföringskanal. En försäljningskanal kan bara tillhöra en marknadsföringskanal.',
			PublishableKeysHint: () =>
				'Välj de publicerbara nycklar (appar / klienter) som hämtar sitt feed och sin layout från denna kanal. En publicerbar nyckel kan bara tillhöra en marknadsföringskanal.',
			SurfacesHint: () =>
				'Välj de klientytor den här kanalen betjänar. Den erbjuds bara för en yta den betjänar, och inget publiceras till en yta som inte är vald.',
			DeleteConfirm: () => 'Ta bort denna marknadsföringskanal? Dess publicerbara nycklar kopplas bort.',
			Field: {
				Name: () => 'Namn',
				NamePlaceholder: () => 't.ex. Scan & Go, Självutcheckning, Skärm',
				Description: () => 'Beskrivning',
				DescriptionPlaceholder: () => 'Valfri beskrivning',
				SalesChannels: () => 'Försäljningskanaler',
				Surfaces: () => 'Ytor',
				SurfacesPlaceholder: () => 'Välj ytor',
				PublishableKeys: () => 'Publicerbara nycklar',
				PublishableKeysPlaceholder: () => 'Välj publicerbara nycklar'
			},
			Action: {
				Create: () => 'Skapa kanal',
				Save: () => 'Spara ändringar',
				Delete: () => 'Ta bort'
			}
		},
		Campaign: {
			Title: () => 'Kampanj',
			NewCampaign: () => 'Ny kampanj',
			NoCampaigns: () => 'Inga kampanjer ännu',
			NoCampaignsDescription: () => 'Skapa en kampanj för att schemalägga en grupp kampanjer för kundappen.',
			ActiveNow: () => 'Aktiv nu',
			Scheduled: () => 'Schemalagd',
			Draft: () => 'Utkast',
			Ended: () => 'Avslutad',
			StatusEnum: (arg0: 'DRAFT' | 'PUBLISHED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Utkast'
						case 'PUBLISHED':
							return 'Publicerad'
						default:
							return String(v)
					}
				})(arg0),
			WindowStatusEnum: (arg0: 'DRAFT' | 'SCHEDULED' | 'ACTIVE' | 'ENDED') =>
				(v => {
					switch (v) {
						case 'DRAFT':
							return 'Utkast'
						case 'SCHEDULED':
							return 'Schemalagd'
						case 'ACTIVE':
							return 'Aktiv nu'
						case 'ENDED':
							return 'Avslutad'
						default:
							return String(v)
					}
				})(arg0),
			ItemTypeEnum: (arg0: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR' | 'CUSTOM') =>
				(v => {
					switch (v) {
						case 'BANNER':
							return 'Banner'
						case 'LIST':
							return 'Lista'
						case 'MODAL':
							return 'Modal'
						case 'SEPARATOR':
							return 'Avgränsare'
						case 'CUSTOM':
							return 'Anpassad'
						default:
							return String(v)
					}
				})(arg0),
			Field: {
				Name: () => 'Namn',
				NamePlaceholder: () => 'Kampanjnamn',
				Description: () => 'Beskrivning',
				DescriptionPlaceholder: () => 'Valfri beskrivning',
				Title: () => 'Titel',
				ItemTitlePlaceholder: () => 'Öppettider',
				ApiKey: () => 'Publicerbar nyckel',
				MarketingChannel: () => 'Marknadsföringskanal',
				Status: () => 'Status',
				StartsAt: () => 'Startar',
				EndsAt: () => 'Slutar',
				EndsAtOpenEnded: () => 'Inget slutdatum',
				Rank: () => 'Rang',
				Items: () => 'Element'
			},
			Action: {
				Publish: () => 'Publicera',
				Unpublish: () => 'Avpublicera',
				Save: () => 'Spara ändringar',
				Delete: () => 'Ta bort',
				Duplicate: () => 'Duplicera',
				AddItem: () => 'Lägg till element',
				MoveUp: () => 'Flytta upp',
				MoveDown: () => 'Flytta ner'
			},
			Validation: {
				StartsAtRequired: () => 'Startdatum krävs för att publicera',
				EndsAtAfterStartsAt: () => 'Slutdatum måste vara efter startdatum'
			},
			Item: {
				NoItems: () => 'Inga element ännu',
				NoItemsDescription: () =>
					'Lägg till en banner, lista, modal eller avgränsare för att börja bygga den här kampanjen.'
			},
			Link: {
				TypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK' | 'IMAGE') =>
					(v => {
						switch (v) {
							case 'NONE':
								return 'Ingen'
							case 'BROWSER':
								return 'Webbadress'
							case 'DEEP_LINK':
								return 'Djuplänk'
							case 'IMAGE':
								return 'Bildförhandsvisning'
							default:
								return String(v)
						}
					})(arg0),
				BrowserUrl: () => 'URL',
				DeepLink: () => 'Djuplänksökväg',
				ImageUrl: () => 'Bild-URL',
				ImageSource: () => 'Bild att förhandsvisa',
				ImageSourceHelp: () => 'Förstora bannerns egen bild, eller peka på en annan bild.',
				ImageSourceEnum: (arg0: 'BANNER' | 'CUSTOM') =>
					(v => {
						switch (v) {
							case 'BANNER':
								return 'Använd bannerns bild'
							case 'CUSTOM':
								return 'Anpassad bild-URL'
							default:
								return String(v)
						}
					})(arg0)
			},
			Help: {
				MarketingChannel: () => 'Vilken grupp av försäljningskanaler som ser denna kampanj.',
				Status: () => 'Utkast är dolda i appen. Publicerade kampanjer visas under sin schemalagda period.',
				Schedule: () =>
					'Valfritt. Lämna start tom för att visa direkt och slut tom för att köra obegränsat. Utgångna kampanjer döljs automatiskt.',
				StartsAt: () => 'Standard är 00:00 den dag du väljer. Lämna tomt för att visa direkt.',
				EndsAt: () => 'Standard är 23:59 den dag du väljer. Lämna tomt för att köra obegränsat.',
				Rank: () => 'När flera kampanjer är aktiva samtidigt visas högre rang först.',
				Items: () => 'Element visas uppifrån och ner i kundappen, i exakt denna ordning.'
			},
			Preview: {
				Title: () => 'Förhandsvisning',
				Empty: () => 'Lägg till element för att förhandsvisa hur kampanjen ser ut i appen.',
				Disclaimer: () => 'Ungefärlig förhandsvisning av kundappens startskärm.'
			},
			AdvancedOptions: () => 'Avancerade alternativ',
			BannerTypeEnum: (arg0: 'IMAGE' | 'TEXT_WITH_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'IMAGE':
							return 'Bild'
						case 'TEXT_WITH_BACKGROUND':
							return 'Text med bakgrund'
						default:
							return String(v)
					}
				})(arg0),
			BannerText: () => 'Text',
			ListImages: () => 'Listbilder',
			AddImage: () => 'Lägg till bild',
			AddImages: () => 'Lägg till bilder',
			AddImagesCount: (args: { count: number }) =>
				'Lägg till ' + String(args.count) + ' ' + plural('sv', args.count, { one: 'bild', other: 'bilder' }),
			ThumbnailLinkTypeEnum: (arg0: 'NONE' | 'BROWSER' | 'DEEP_LINK') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Bildförhandsvisning'
						case 'BROWSER':
							return 'Webbläsar-URL'
						case 'DEEP_LINK':
							return 'Djuplänk'
						default:
							return String(v)
					}
				})(arg0),
			JoinAbove: () => 'Slå ihop med blocket ovanför',
			ShowTitle: () => 'Visa titel',
			ShowTitleHelp: () => 'Valfri rubrik som visas ovanför det här objektet i appen.',
			ListImageShape: () => 'Bildform',
			ListImageShapeEnum: (arg0: 'SQUARE' | 'PORTRAIT' | 'LANDSCAPE') =>
				(v => {
					switch (v) {
						case 'SQUARE':
							return 'Kvadrat'
						case 'PORTRAIT':
							return 'Porträtt'
						case 'LANDSCAPE':
							return 'Landskap'
						default:
							return String(v)
					}
				})(arg0),
			ListImageSize: () => 'Bildstorlek',
			ListImageSizeHelp: () => 'En del av nästa bild förblir synlig så att kunderna vet att de kan scrolla.',
			ListImageSizeEnum: (arg0: 'LARGE' | 'MEDIUM' | 'SMALL') =>
				(v => {
					switch (v) {
						case 'LARGE':
							return 'Stor'
						case 'MEDIUM':
							return 'Mellan'
						case 'SMALL':
							return 'Liten'
						default:
							return String(v)
					}
				})(arg0),
			ModalCover: () => 'Omslagsbild för modal',
			ContainerClassName: () => 'Container-klassnamn',
			CustomInfo: () => 'Anpassade element renderas av kundappen. Det finns inga redigerbara fält här.',
			TapAction: () => 'När den trycks',
			TapActionHelp: () =>
				'Vart bannern leder när den trycks, eller en inbyggd åtgärd i stället. Inbyggda åtgärder ersätter navigering.',
			TapActionNavigate: () => 'Navigera',
			TapActionBuiltIn: () => 'Inbyggd',
			PromotionAction: () => 'Tryckåtgärd',
			PromotionActionHelp: () => 'Valfritt inbyggt beteende när bannern trycks, som åsidosätter länken.',
			PromotionActionEnum: (arg0: 'NONE' | 'ADD_LOYALTY_CARD_TO_WALLET' | 'LOYALTY_CARD_INFO') =>
				(v => {
					switch (v) {
						case 'NONE':
							return 'Ingen'
						case 'ADD_LOYALTY_CARD_TO_WALLET':
							return 'Lägg till lojalitetskort i plånbok'
						case 'LOYALTY_CARD_INFO':
							return 'Visa lojalitetskortsinfo'
						default:
							return String(v)
					}
				})(arg0)
		},
		Placement: {
			Title: () => 'Placeringar',
			Help: () =>
				'En placering är denna kampanjs innehåll på en marknadsföringskanal. Lägg till en placering per kanal som ska visa denna kampanj.',
			Add: () => 'Lägg till placering',
			Empty: () => 'Lägg till en placering för att definiera vad denna kampanj visar på en kanal.',
			Count: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'placering', other: 'placeringar' }),
			Rank: () => 'Rang',
			RankHelp: () => 'När flera kampanjer är aktiva samtidigt visas högre rang först i feedet.',
			Delete: () => 'Ta bort placering',
			DeleteConfirm: () => 'Ta bort denna placering? Dess innehåll raderas.'
		},
		Layout: {
			Title: () => 'Feed-layout',
			Help: () =>
				'Den bestående strukturen för denna kanals feed. Statiska block (banners, länkar, avgränsare) visas alltid, och kampanjzonen markerar var aktivt kampanjinnehåll infogas.',
			AddCampaignZone: () => 'Lägg till kampanjzon',
			CampaignZone: () => 'Kampanjzon',
			CampaignZoneHint: () => 'Aktiva kampanjer visas här',
			DrawerHint: () => 'Ordna de bestående blocken och kampanjzonen för denna kanal',
			UnsavedConfirm: () => 'Du har osparade ändringar som går förlorade. Fortsätta till feed-layouten?',
			PreviewModeLayout: () => 'Layout',
			PreviewModeLive: () => 'Live-feed',
			LivePreviewHint: () => 'Det publicerade feedet som kunderna ser nu, inklusive aktiva kampanjer.',
			CheckoutPreviewHint: () =>
				'Det som den här utgångsskärmen visar just nu. Schemalagda bakgrunder visas bara under sitt tidsfönster.'
		},
		Content: {
			Title: () => 'Innehåll',
			NewContent: () => 'Nytt innehåll',
			NoContent: () => 'Inget innehåll ännu',
			NoContentDescription: () =>
				'Skapa ett innehållsblock och lägg sedan till det i en kanallayout för att göra det aktivt.',
			NoMatches: () => 'Inget matchande innehåll',
			NoMatchesDescription: () => 'Inget innehåll matchar den aktuella sökningen och filtren.',
			ClearFilters: () => 'Rensa filter',
			ChannelFilter: () => 'Marknadsföringskanal',
			TypeOption: (arg0: 'ALL' | 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'ALL':
							return 'Alla'
						case 'FEED':
							return 'Kundappens flöde'
						case 'CHECKOUT_BACKGROUND':
							return 'Kassaskärm'
						default:
							return String(v)
					}
				})(arg0),
			BlockCount: (args: { count: number }) =>
				String(args.count) + ' ' + plural('sv', args.count, { one: 'block', other: 'block' }),
			LayoutCount: (args: { count: number }) =>
				'I ' + String(args.count) + ' ' + plural('sv', args.count, { one: 'layout', other: 'layouter' }),
			NotInLayout: () => 'Inte i någon layout',
			DeleteConfirm: () => 'Ta bort detta innehåll? Det tas bort från alla kanallayouter.',
			DuplicateSuccess: () => 'Innehåll duplicerat',
			Blocks: () => 'Block',
			BlocksHelp: () => 'Block visas uppifrån och ner i kundappen, i exakt denna ordning.',
			SaveDraft: () => 'Spara som utkast',
			SaveAndPublish: () => 'Spara och publicera',
			SaveSuccess: () => 'Ändringar sparade',
			PublishSuccess: () => 'Innehåll publicerat',
			UnpublishSuccess: () => 'Innehåll avpublicerat',
			UnsavedChanges: () => 'Osparade ändringar',
			DraftNotice: () => 'Detta innehåll är ett utkast och visas inte för kunder. Publicera det när du är redo.',
			ExpiredTitle: () => 'Detta innehåll har löpt ut',
			ExpiredNotice: (arg0: DateInput) =>
				'Detta innehåll löpte ut ' +
				dateAndTimeFormatter('sv', arg0) +
				' och visas inte för kunder. Ge det ett nytt schema för att köra det igen.',
			ExpiredSaveConfirm: () =>
				'Detta innehåll har redan löpt ut, så det förblir dolt för kunder. Spara det med nuvarande schema ändå?',
			SaveAnyway: () => 'Spara ändå',
			ClearEndDate: () => 'Rensa slutdatum',
			RunToday: () => 'Kör idag',
			NewFeedContent: () => 'Kundappens flöde',
			NewFeedContentHint: () => 'Banners, bildlistor och mer för flödet i kundappen',
			NewCheckoutBackground: () => 'Kassaskärm',
			NewCheckoutBackgroundHint: () => 'En helskärmsbild för utgångsskärmen vid självutcheckning',
			Format: (arg0: 'FEED' | 'CHECKOUT_BACKGROUND') =>
				(v => {
					switch (v) {
						case 'FEED':
							return 'Kundappens flöde'
						case 'CHECKOUT_BACKGROUND':
							return 'Kassaskärm'
						default:
							return String(v)
					}
				})(arg0),
			BackgroundImage: () => 'Bakgrundsbild',
			BackgroundHelp: () =>
				'Fyller hela utgångsskärmen vid självutcheckning. På skärmarna för påskontroll och utgång ersätter den det inbyggda meddelandet, så bilden själv måste berätta för kunden vad den ska göra. Liggande bilder fungerar bäst.',
			BackgroundEmpty: () =>
				'Ingen bild ännu. Välj en från marknadsföringsbiblioteket, annars visas ingenting på utgångsskärmen.'
		},
		ContentLayout: {
			Title: () => 'Layout',
			Help: () =>
				'Sortera det publicerade innehållet för en kanal. Detta är flödet kunderna ser, uppifrån och ner. Schemalagt innehåll visas endast under sitt tidsfönster.',
			SelectChannel: () => 'Kanal',
			NoChannels: () => 'Skapa en marknadsföringskanal innan du ordnar en layout.',
			GoToChannels: () => 'Gå till marknadsföringskanaler',
			AvailableTitle: () => 'Tillgängligt innehåll',
			NoAvailable: () => 'Allt innehåll finns redan i denna layout.',
			InLayoutTitle: () => 'I denna layout',
			Empty: () => 'Inget innehåll i denna layout ännu. Lägg till innehåll från listan för att bygga flödet.',
			Add: () => 'Lägg till i layout',
			Remove: () => 'Ta bort från layout',
			Save: () => 'Spara layout',
			Saved: () => 'Layout sparad',
			PreviewTitle: () => 'Förhandsvisning av live-flöde',
			SingleContentWarning: () =>
				'Den här skärmen visas bara i några sekunder, så endast det första objektet syns. Behåll ett objekt här.',
			CheckoutHelp: () =>
				'Välj bakgrunderna som visas på den här utgångsskärmen. Flera bakgrunder på vänteskärmen roterar; skärmarna för påskontroll och utgång visar bara den första, i stället för det inbyggda meddelandet.',
			AvailableBackgroundsTitle: () => 'Tillgängliga bakgrunder',
			NoBackgrounds: () => 'Inga bakgrunder ännu. Skapa en för att visa den på den här skärmen.',
			NewBackground: () => 'Ny bakgrund',
			NewBackgroundTitle: () => 'Ny bakgrund för utgångsskärm',
			NewBackgroundDescription: () =>
				'Välj en bild från marknadsföringsbiblioteket. Den publiceras direkt och läggs till på den här skärmen.',
			NewBackgroundCreate: () => 'Skapa och lägg till',
			NewBackgroundCreated: () => 'Bakgrund tillagd. Spara layouten för att göra den aktiv.',
			WrongFormatOnCheckout: () =>
				'Innehåll för kundappens flöde visas inte på utgångsskärmen. Ta bort det och lägg till en bakgrund i stället.',
			WrongFormatOnFeed: () =>
				'Bakgrunder för utgångsskärm visas inte i flödet i kundappen. Ta bort den från den här layouten.',
			RemoveFlaggedToSave: () => 'Ta bort de markerade objekten för att spara layouten.'
		},
		Surface: {
			Label: () => 'Yta',
			CustomerAppFeed: () => 'Kundappens flöde',
			CheckoutScreen: () => 'Kassaskärm'
		},
		ScreenState: {
			Label: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Standard'
						case 'CHECKOUT_IDLE':
							return 'Inaktiv'
						case 'CHECKOUT_BAG_CHECK':
							return 'Väskkontroll'
						case 'CHECKOUT_CLEARED':
							return 'Klar'
						default:
							return String(v)
					}
				})(arg0),
			Hint: (arg0: 'DEFAULT' | 'CHECKOUT_IDLE' | 'CHECKOUT_BAG_CHECK' | 'CHECKOUT_CLEARED') =>
				(v => {
					switch (v) {
						case 'DEFAULT':
							return 'Visas alltid'
						case 'CHECKOUT_IDLE':
							return 'Medan man väntar på att en kund ska skanna'
						case 'CHECKOUT_BAG_CHECK':
							return 'När en väskkontroll av personal krävs'
						case 'CHECKOUT_CLEARED':
							return 'När kunden får lämna'
						default:
							return String(v)
					}
				})(arg0)
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Väskkontroll krävs',
			BagCheckBody: () => 'En medarbetare kommer och checkar ut din kundvagn',
			ClearedTitle: () => 'Allt klart',
			ClearedBody: () => 'Du kan gå nu',
			Disclaimer: () => 'Ungefärlig förhandsvisning av utgångsskärmen.',
			FallbackHint: () => 'Ingen bakgrund vald, så skärmen visar sitt inbyggda meddelande.'
		},
		LibraryPage: {
			NoAssets: () => 'Inga marknadsföringstillgångar ännu',
			NoAssetsDescription: () => 'Ladda upp bilder, banners och annat marknadsföringsmaterial här.',
			Filename: () => 'Filnamn',
			TableView: () => 'Tabellvy',
			GalleryView: () => 'Gallerivy',
			Upload: () => 'Ladda upp',
			SearchFilename: () => 'Sök på filnamn',
			ViewFullImage: () => 'Visa hela bilden',
			CopyUrl: () => 'Kopiera URL',
			CopiedUrl: () => 'URL kopierad',
			DeleteAsset: () => 'Ta bort tillgång',
			DeleteAssetConfirm: () => 'Ta bort den här tillgången? Det kan inte ångras.',
			UploadAssets: () => 'Ladda upp tillgångar',
			UploadDropzone: () => 'Dra och släpp bilder här, eller klicka för att välja filer',
			ChooseFiles: () => 'Välj filer',
			Tags: () => 'Taggar',
			UsedBy: () => 'Används av',
			UsageFilter: () => 'Användning',
			UsageUnused: () => 'Oanvänd',
			UsageProduct: () => 'Produkt',
			UsageProductGroup: () => 'Produktgrupp',
			UsageProductCategory: () => 'Produktkategori',
			UsageMarketingContent: () => 'Marknadsföringsinnehåll',
			UsageFeedLayout: () => 'Kundapp-flöde',
			ChannelFilter: () => 'Marknadsföringskanal',
			ContentFilter: () => 'Används av innehåll',
			ChannelNone: () => 'Ingen kanal',
			ContentNone: () => 'Utan innehåll',
			TagsPlaceholder: () => 'Lägg till en tagg och tryck Enter',
			Uploading: () => 'Laddar upp',
			EditTags: () => 'Redigera taggar',
			NoTags: () => 'Inga taggar',
			ManageTags: () => 'Hantera taggar',
			ManageTagsEmpty: () => 'Inga taggar i biblioteket ännu.',
			ManageTagsAssetCount: (args: { count: number }) => String(args.count) + ' tillgångar',
			CreateTag: () => 'Skapa tagg',
			CreateTagPlaceholder: () => 'Lägg till en tagg och tryck Enter',
			CreateTagSuccess: (args: { tag: string }) => 'Taggen "' + String(args.tag) + '" skapades.',
			RenameTag: () => 'Byt namn på tagg',
			RenameTagMergeConfirm: (args: { from: string; to: string; count: number }) =>
				'Slå samman taggen "' +
				String(args.from) +
				'" med "' +
				String(args.to) +
				'" (' +
				String(args.count) +
				' tillgångar)? Den gamla taggen tas bort.',
			RenameTagSuccess: (args: { from: string; to: string }) =>
				'Tagg omdöpt från "' + String(args.from) + '" till "' + String(args.to) + '".',
			RemoveTagConfirm: (args: { tag: string }) =>
				'Ta bort taggen "' + String(args.tag) + '" från alla tillgångar? Filerna tas inte bort.',
			RemoveTagSuccess: (args: { count: number }) =>
				'Tagg borttagen från ' +
				String(args.count) +
				' ' +
				plural('sv', args.count, { one: 'tillgång', other: 'tillgångar' }) +
				'.'
		}
	},
	Settings: {
		Title: () => 'Inställningar',
		Sidebar: {
			Profile: () => 'Profil',
			Store: () => 'Butik',
			Users: () => 'Användare',
			SalesChannels: () => 'Försäljningskanaler',
			PointOfSale: () => 'Försäljningsställe',
			ProductGroups: () => 'Produktgrupper',
			Exports: () => 'Exporter',
			Analytics: () => 'Analys',
			Companies: () => 'Företag',
			CompanyCards: () => 'Företagskort',
			Settlements: () => 'Avräkningar'
		},
		Profile: {
			Title: () => 'Profil',
			EditTitle: () => 'Redigera profil',
			PersonalInfo: () => 'Personlig information',
			Preferences: () => 'Inställningar',
			NamePlaceholder: () => 'Ange ditt namn',
			EmailPlaceholder: () => 'Ange din e-post',
			UpdateSuccess: () => 'Profil uppdaterad',
			Edit: {
				Description: () => 'Redigera din profilinformation'
			}
		},
		Users: {
			Title: () => 'Användare',
			InviteUser: () => 'Skapa inbjudan',
			InviteTitle: () => 'Skapa inbjudan',
			InviteSuccess: () => 'Inbjudan skapad',
			InviteSentTo: (args: { email: string }) => 'Inbjudan skickad till ' + String(args.email),
			SendInvite: () => 'Skapa inbjudan',
			CopyInviteLink: () => 'Kopiera inbjudningslänk',
			DeleteUserDescription: (args: { email: string }) =>
				'Ta bort ' + String(args.email) + '? De kommer inte längre att kunna logga in.',
			DeleteUserSuccess: () => 'Användare borttagen',
			EditTitle: () => 'Redigera användare',
			EditSuccess: () => 'Användare uppdaterad',
			DeleteInviteDescription: (args: { email: string }) =>
				'Ta bort den väntande inbjudan för ' + String(args.email) + '?',
			DeleteInviteSuccess: () => 'Inbjudan borttagen',
			Status: {
				Accepted: () => 'Accepterad',
				Pending: () => 'Väntar',
				Expired: () => 'Utgången'
			},
			Type: {
				User: () => 'Användare',
				Invite: () => 'Inbjudan'
			},
			Column: {
				Type: () => 'Typ'
			},
			Role: {
				Admin: () => 'Administratör',
				User: () => 'Användare'
			},
			Invite: {
				Description: () => 'Bjud in en ny användare till din butik',
				EmailPlaceholder: () => 'Ange e-postadress',
				NamePlaceholder: () => 'Ange namn',
				UserInfo: () => 'Användarinformation',
				UserAlreadyExists: (args: { email: string }) =>
					'En användare med e-postadressen ' + String(args.email) + ' finns redan'
			},
			Detail: {
				Title: () => 'Användardetaljer',
				AdminOnly: () => 'Administratörsbehörighet krävs för att se inbjudningsdetaljer.'
			},
			SignInCredentials: {
				Title: () => 'Inloggningsuppgifter',
				Description: () =>
					'Ange det inloggnings-ID och den PIN som används för att logga in vid självbetjäning och POS-terminaler.',
				SignInId: () => 'Inloggnings-ID',
				SignInIdPlaceholder: () => 't.ex. 1042',
				SignInIdHint: () =>
					'Endast siffror. Krävs endast för viss hårdvara, som självbetjäningskassor. Lämna tomt om den här användaren inte loggar in på sådan hårdvara.',
				Pin: () => 'PIN',
				PinSet: () => 'En PIN är angiven',
				PinNotSet: () => 'Ingen PIN angiven',
				NewPin: () => 'Ny PIN (6 siffror)',
				PinPlaceholder: () => 'Lämna tomt för att behålla nuvarande PIN',
				ClearPin: () => 'Rensa PIN',
				Save: () => 'Spara',
				SaveSuccess: () => 'Uppgifter uppdaterade',
				SignInIdNumeric: () => 'Inloggnings-ID måste vara numeriskt',
				SignInIdTaken: () => 'Inloggnings-ID används redan',
				PinInvalid: () => 'PIN måste vara exakt 6 siffror'
			}
		},
		SalesChannels: {
			Title: () => 'Försäljningskanaler',
			CreateTitle: () => 'Skapa försäljningskanal',
			CreateSuccess: () => 'Försäljningskanal skapad',
			EditTitle: () => 'Redigera försäljningskanal',
			EditSuccess: () => 'Försäljningskanal uppdaterad',
			Column: {
				CountryCode: () => 'Land',
				CurrencyCode: () => 'Valuta',
				SalesChannelType: () => 'Typ',
				FulfillmentProvider: () => 'Uppfyllnadsleverantör',
				AccessKeys: () => 'Åtkomstnycklar',
				InventoryLocation: () => 'Lagerplats',
				Group: () => 'Grupp'
			},
			InventoryLocationNone: () => 'Ingen',
			InventoryLocationOptionalHint: () =>
				'Valfritt. Koppla den här kanalen till en lagerplats för att spåra lager. Lämna tom om lager inte används.',
			SalesChannelTypeNone: () => 'Ingen',
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valfritt. Tilldela den här kanalen till en grupp för att organisera relaterade kanaler tillsammans.',
			Advanced: () => 'Avancerade inställningar',
			TypeOptionalHint: () =>
				'Valfritt. Tilldela endast en typ för att gruppera kanaler som delar uppfyllnads- eller förhandsgodkännandeinställningar. Lämna som Ingen om du är osäker.',
			StorefrontUrl: () => 'Butiks-URL',
			StorefrontUrlHint: () =>
				'Valfritt. Bas-URL för den här klientens webbutik. Ange detta för att låta Terminal-POS visa en "Hämta kvitto"-QR-kod efter betalning; lämna tomt för att dölja den.',
			Groups: {
				Title: () => 'Försäljningskanalgrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Skapa grupp',
				CreateSuccess: () => 'Grupp skapad',
				EditTitle: () => 'Redigera grupp',
				EditSuccess: () => 'Grupp uppdaterad',
				NamePlaceholder: () => 'Ange gruppnamn',
				Column: {
					Name: () => 'Namn',
					MemberCount: () => 'Försäljningskanaler'
				},
				Members: {
					Title: () => 'Försäljningskanaler',
					Label: () => 'Försäljningskanaler',
					Placeholder: () => 'Välj försäljningskanaler',
					Empty: () => 'Inga försäljningskanaler tilldelade ännu.',
					Assigned: () => 'Tilldelad',
					FilterUnassigned: () => 'Utan grupp',
					SaveSuccess: () => 'Försäljningskanaler uppdaterade',
					MoveWarning: {
						Title: () => 'Flytta försäljningskanaler mellan grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' av de valda försäljningskanalerna tillhör redan en annan grupp och flyttas hit: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Ta bort grupp',
					Description: (args: { name: string }) =>
						'Är du säker på att du vill ta bort gruppen "' +
						String(args.name) +
						'"? Dess försäljningskanaler tas bort från gruppen men raderas inte.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' togs bort.'
				}
			},
			Create: {
				BasicInfo: () => 'Grundläggande information',
				Description: () => 'Skapa en ny försäljningskanal',
				NamePlaceholder: () => 'Ange kanalnamn'
			},
			Edit: {
				ApiNotAvailable: () => 'API inte tillgängligt',
				NotImplemented: () => 'Inte implementerat ännu'
			},
			Detail: {
				Title: () => 'Försäljningskanaldetaljer',
				AccessKeys: () => 'Åtkomstnycklar',
				CreateAccessKey: () => 'Skapa åtkomstnyckel',
				CreateAccessKeySuccess: () => 'Åtkomstnyckel skapad',
				PointOfSales: () => 'Försäljningsställen',
				PointOfSalesDescription: () => 'Hantera försäljningsställen för den här kanalen'
			},
			AccessKeyType: {
				Title: () => 'Nyckeltyp',
				Publishable: () => 'Publicerbar nyckel',
				PublishableDescription: () => 'För klientsidan (POS-terminaler, butiker)',
				Api: () => 'API-nyckel',
				ApiDescription: () => 'För serverintegrationer'
			},
			TokenCreated: {
				Title: () => 'API-nyckel skapad',
				Description: () =>
					'Det här tokenet kan endast visas en gång. Spara det innan du stänger den här dialogen.',
				Token: () => 'API-token'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nyckel'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Åtkomstnycklar',
			NavLabel: () => 'Åtkomstnycklar',
			Manage: () => 'Hantera',
			Create: () => 'Skapa åtkomstnyckel',
			EditTitle: () => 'Redigera åtkomstnyckel',
			None: () => '—',
			SaveSuccess: () => 'Åtkomstnyckel uppdaterad',
			DeleteConfirm: () => 'Ta bort denna åtkomstnyckel? Appar som använder den slutar fungera.',
			DeleteSuccess: () => 'Åtkomstnyckel borttagen',
			Column: {
				Key: () => 'Nyckel',
				SalesChannels: () => 'Försäljningskanaler',
				MarketingChannel: () => 'Marknadsföringskanal'
			},
			Empty: {
				Title: () => 'Inga åtkomstnycklar',
				Description: () =>
					'Skapa en publicerbar nyckel och koppla den till försäljningskanaler och en marknadsföringskanal.'
			},
			Field: {
				SalesChannels: () => 'Försäljningskanaler',
				SalesChannelsPlaceholder: () => 'Välj försäljningskanaler',
				SalesChannelsRequired: () => 'Välj minst en försäljningskanal',
				MarketingChannel: () => 'Marknadsföringskanal',
				MarketingChannelPlaceholder: () => 'Välj en marknadsföringskanal',
				DevelopmentMode: () => 'Utvecklarläge',
				DevelopmentModeHint: () =>
					'Låser upp utvecklarverktyg (inställningsskärmar + OTA-uppdateringskontroller) i handlarappen för kiosker parkopplade med denna nyckel.'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Försäljningskanaltyper',
			NavLabel: () => 'Typer',
			CreateTitle: () => 'Skapa försäljningskanaltyp',
			CreateSuccess: () => 'Försäljningskanaltyp skapad',
			EditTitle: () => 'Redigera försäljningskanaltyp',
			EditSuccess: () => 'Försäljningskanaltyp uppdaterad',
			Column: {
				FulfillmentProvider: () => 'Uppfyllnadsleverantör',
				PreauthorizationAmount: () => 'Förhandsgodkännandebelopp',
				AllowCompletingUnderpaidOrders: () => 'Tillåt att slutföra underbetalda ordrar'
			},
			FulfillmentProviderNone: () => 'Ingen',
			InvalidPreauthorizationAmount: () => 'Ange ett giltigt icke-negativt tal',
			AllowCompletingUnderpaidOrdersHint: () =>
				'Slutför en order även om det inbetalda beloppet är lägre än totalbeloppet. Endast för engångsdebiteringsflöden (t.ex. SandStar-kylskåpet) där det inte finns någon ny chans att ta betalt mer.',
			Create: {
				NamePlaceholder: () => 'Ange typnamn'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Måttenheter',
			NavLabel: () => 'Måttenheter',
			Description: () =>
				'Gemensamma enheter som används för alla produkter. Varje produkt väljer bland dessa när förpackningsstorlekar läggs till.',
			CreateTitle: () => 'Skapa måttenhet',
			CreateSuccess: () => 'Enhet skapad',
			EditTitle: () => 'Redigera måttenhet',
			EditSuccess: () => 'Enhet uppdaterad',
			Column: {
				Code: () => 'Kod',
				Name: () => 'Namn',
				Quantity: () => 'Standardantal',
				Default: () => 'Standard'
			},
			Code: () => 'Kod',
			Name: () => 'Namn',
			Quantity: () => 'Standardantal',
			QuantityHint: () =>
				'Gemensamt antal i basenheter (t.ex. är en 6-pack 6). Lämna tomt för variabla förpackningar.',
			DefaultEach: () => 'Standardenhet för räknade varor',
			DefaultWeight: () => 'Standardenhet för vägda varor',
			DefaultEachBadge: () => 'Standard · st',
			DefaultWeightBadge: () => 'Standard · vikt',
			CodePlaceholder: () => 't.ex. PK6',
			NamePlaceholder: () => 't.ex. 6-pack',
			ManagedBySync: () => 'Hanteras av synkronisering',
			ManagedBySyncHint: () => 'Den här enheten hanteras av en extern integration och kan inte redigeras här.',
			InvalidCode: () => 'Kod krävs',
			InvalidQuantity: () => 'Antal måste vara större än noll',
			InUse: () => 'Används',
			Delete: {
				Title: () => 'Ta bort enhet',
				Description: (args: { code: string }) => 'Ta bort ' + String(args.code) + '? Detta kan inte ångras.'
			}
		},
		PointOfSale: {
			Title: () => 'Försäljningsställe',
			CreateTitle: () => 'Skapa försäljningsställe',
			CreateSuccess: () => 'Försäljningsställe skapat',
			EditTitle: () => 'Redigera försäljningsställe',
			EditSuccess: () => 'Försäljningsställe uppdaterat',
			AllowedOperatingModesLabel: () => 'Tillåtna driftslägen',
			SelectOperatingModes: () => 'Välj driftslägen',
			OperatingMode: (arg0: 'ADMIN' | 'POS' | 'BAG_CHECK' | 'SCO' | 'INVENTORY' | 'TERMINAL' | 'CHECKOUT') =>
				(v => {
					switch (v) {
						case 'ADMIN':
							return 'Admin'
						case 'POS':
							return 'Försäljningsställe'
						case 'BAG_CHECK':
							return 'Påskontroll'
						case 'SCO':
							return 'Självutcheckning'
						case 'INVENTORY':
							return 'Lager'
						case 'TERMINAL':
							return 'Terminal'
						case 'CHECKOUT':
							return 'Utcheckning'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamLevelLabel: () => 'Streaming av enhetsloggar',
			LogStreamLevel: (arg0: 'OFF' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG') =>
				(v => {
					switch (v) {
						case 'OFF':
							return 'Av'
						case 'ERROR':
							return 'Fel'
						case 'WARN':
							return 'Varning'
						case 'INFO':
							return 'Info'
						case 'DEBUG':
							return 'Felsökning'
						default:
							return String(v)
					}
				})(arg0),
			LogStreamIdLabel: () => 'Åsidosätt loggström-ID',
			LogStreamIdPlaceholder: () => 'Standard är identifieraren ovan',
			LogStreamIdInvalidChars: () => 'Får inte innehålla ":" eller "*"',
			LogStreamIdTooLong: () => 'För långt',
			ForcedOrientationLabel: () => 'Tvingad orientering',
			ForcedOrientationHint: () => 'Låser enhetens skärm. Automatiskt följer enheten.',
			ForcedOrientationAutomatic: () => 'Automatiskt',
			ForcedOrientation: (
				arg0: 'portrait' | 'portrait-reverse' | 'landscape' | 'landscape-reverse' | 'default'
			) =>
				(v => {
					switch (v) {
						case 'portrait':
							return 'Stående'
						case 'portrait-reverse':
							return 'Stående upp och ner'
						case 'landscape':
							return 'Liggande'
						case 'landscape-reverse':
							return 'Liggande omvänd'
						case 'default':
							return 'Olåst'
						default:
							return String(v)
					}
				})(arg0),
			SafeAreaInsetsLabel: () => 'Åsidosättning av säkert område (px)',
			SafeAreaInsetsHint: () =>
				'För enheter vars OS rapporterar fel säkert område (t.ex. alltid 0). Lämna en sida tom för att använda det riktiga värdet.',
			SafeAreaInsetTop: () => 'Topp',
			SafeAreaInsetRight: () => 'Höger',
			SafeAreaInsetBottom: () => 'Botten',
			SafeAreaInsetLeft: () => 'Vänster',
			Column: {
				Identifier: () => 'Identifierare',
				AccessKeys: () => 'Åtkomstnycklar',
				Group: () => 'Grupp'
			},
			GroupNone: () => 'Ingen',
			GroupOptionalHint: () =>
				'Valfritt. Tilldela det här försäljningsstället till en grupp för att organisera relaterade terminaler tillsammans.',
			LinkSalesChannelButton: () => 'Länka',
			LinkSalesChannelTitle: () => 'Länka en försäljningskanal',
			LinkSalesChannelDescription: () => 'Lägg till en försäljningskanal till det här försäljningsstället.',
			LinkSalesChannelSuccess: () => 'Försäljningskanal länkad',
			SelectSalesChannel: () => 'Välj en försäljningskanal',
			NoUnlinkedSalesChannels: () => 'Alla försäljningskanaler är redan länkade.',
			Create: {
				BasicInfo: () => 'Grundläggande information',
				Description: () => 'Skapa ett nytt försäljningsställe',
				NamePlaceholder: () => 'Ange platsnamn',
				SelectSalesChannels: () => 'Välj försäljningskanaler',
				IdentifierPlaceholder: () => 'Ange identifierare'
			},
			Groups: {
				Title: () => 'Försäljningsställegrupper',
				NavLabel: () => 'Grupper',
				CreateTitle: () => 'Skapa grupp',
				CreateSuccess: () => 'Grupp skapad',
				EditTitle: () => 'Redigera grupp',
				EditSuccess: () => 'Grupp uppdaterad',
				NamePlaceholder: () => 'Ange gruppnamn',
				Column: {
					Name: () => 'Namn',
					MemberCount: () => 'Försäljningsställen'
				},
				Members: {
					Title: () => 'Försäljningsställen',
					Label: () => 'Försäljningsställen',
					Placeholder: () => 'Välj försäljningsställen',
					Empty: () => 'Inga försäljningsställen tilldelade ännu.',
					Assigned: () => 'Tilldelad',
					FilterUnassigned: () => 'Utan grupp',
					SaveSuccess: () => 'Försäljningsställen uppdaterade',
					MoveWarning: {
						Title: () => 'Flytta försäljningsställen mellan grupper?',
						Description: (args: { count: number; items: string }) =>
							String(args.count) +
							' av de valda försäljningsställena tillhör redan en annan grupp och flyttas hit: ' +
							String(args.items) +
							'.'
					}
				},
				Delete: {
					Title: () => 'Ta bort grupp',
					Description: (args: { name: string }) =>
						'Är du säker på att du vill ta bort gruppen "' +
						String(args.name) +
						'"? Dess försäljningsställen tas bort från gruppen men raderas inte.',
					SuccessToast: (args: { name: string }) => 'Gruppen ' + String(args.name) + ' togs bort.'
				}
			},
			Detail: {
				Title: () => 'Försäljningsställedetaljer',
				AccessKeys: () => 'Åtkomstnycklar'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Nyckel'
				}
			},
			ProductMenu: {
				Title: () => 'Produktmeny',
				Description: () => 'Produktgrupper som visas på det här försäljningsstället.',
				EmptyTitle: () => 'Inga menygrupper',
				EmptyDescription: () => 'Lägg till produktgrupper för att bygga menyn på det här försäljningsstället.',
				EditHeader: () => 'Produktmeny',
				EditDescription: () =>
					'Lägg till produktgrupperna som visas på det här försäljningsstället och välj hur var och en visas.',
				AddPlaceholder: () => 'Lägg till en produktgrupp…',
				NoGroupsSelected: () => 'Inga produktgrupper tillagda ännu.',
				IconLabel: () => 'Reservikon',
				IconPlaceholder: () => 'Välj en reservikon…',
				IconNone: () => 'Ingen',
				IconUsesImageHint: () =>
					'Den här gruppen har en bild som visas på menyn i stället för en reservikon. Redigera bilden på produktgruppen.',
				IconNotUsedWhenIndividual: () => 'Används inte när produkter visas enskilt på menyn.',
				ShowIndividually: () => 'Visa produkter enskilt',
				ShowIndividuallyHint: () => 'Produkter visas direkt på menyn i stället för inuti en grupp.',
				ShownIndividuallyBadge: () => 'Produkter visas enskilt',
				SaveSuccess: () => 'Meny uppdaterad.',
				Icons: {
					ShoppingBag: () => 'Kasse',
					ShoppingCart: () => 'Kundvagn',
					Coffee: () => 'Kaffe',
					CupSoda: () => 'Kall dryck',
					Utensils: () => 'Tillagad mat',
					Pizza: () => 'Pizza',
					Sandwich: () => 'Smörgås',
					IceCream: () => 'Glass',
					Beer: () => 'Öl',
					Wine: () => 'Vin',
					Bakery: () => 'Bageri',
					Gift: () => 'Present'
				}
			}
		},
		Devices: {
			Title: () => 'Enheter',
			NavLabel: () => 'Enheter',
			AccessKeysEmptyTitle: () => 'Inga åtkomstnycklar',
			AccessKeysEmptyDescription: () =>
				'Skapa åtkomstnycklar för att låta externa system få åtkomst till den här enheten.',
			Identifier: () => 'Identifierare',
			LinkedPointOfSale: () => 'Försäljningsställe',
			NotLinked: () => 'Inte länkad',
			MarketingChannel: () => 'Marknadsföringskanal',
			NoMarketingChannel: () => 'Ingen',
			MarketingChannelDescription: () =>
				'Kampanjer på kassaskärmen hämtas via denna marknadsföringskanal. Oberoende av länk till försäljningsställe.',
			OperatingModes: () => 'Driftlägen',
			StatusColumn: () => 'Status',
			AccessKeysColumn: () => 'Åtkomstnycklar',
			EmptyTitle: () => 'Inga enheter',
			EmptyDescription: () => 'Skapa en enhet för att komma igång.',
			CreateTitle: () => 'Skapa enhet',
			CreateSuccess: () => 'Enhet skapad',
			EditTitle: () => 'Redigera enhet',
			NamePlaceholder: () => 't.ex. Främre kassa',
			IdentifierPlaceholder: () => 'Lämna tomt för att generera en',
			UpdateSuccess: () => 'Enhet uppdaterad',
			DeleteButton: () => 'Ta bort enhet',
			DeleteConfirmTitle: () => 'Ta bort den här enheten?',
			DeleteConfirmDescription: () =>
				'Detta tar bort enheten och återkallar dess åtkomstnycklar. Detta kan inte ångras.',
			DeleteSuccess: () => 'Enhet borttagen',
			LinkButton: () => 'Länka försäljningsställe',
			LinkTitle: () => 'Länka till ett försäljningsställe',
			LinkDescription: () =>
				'En enhet som fungerar som ett försäljningsställe hämtar försäljningskanaler och ordrar via det länkade försäljningsstället. Länkning ersätter enheten som nu fungerar som detta försäljningsställe.',
			LinkSuccess: () => 'Enhet länkad',
			SelectPointOfSale: () => 'Välj ett försäljningsställe',
			UnlinkButton: () => 'Avlänka',
			UnlinkConfirmTitle: () => 'Avlänka detta försäljningsställe?',
			UnlinkConfirmDescription: () =>
				'Enheten slutar hämta försäljningskanaler och ordrar tills den länkas igen.',
			UnlinkSuccess: () => 'Försäljningsställe avlänkat',
			LinkedDevicesTitle: () => 'Enheter',
			LinkedDevicesEmpty: () => 'Inga enheter är länkade till detta försäljningsställe.',
			LinkDeviceButton: () => 'Länka enhet',
			LinkDeviceDisabledHint: () => 'Koppla bort den nuvarande enheten innan du kopplar en ny.',
			PointOfSaleOccupiedOption: (arg0: string) => String(arg0) + ' (enhet redan länkad)',
			LinkDeviceTitle: () => 'Länka en enhet',
			LinkDeviceDescription: () => 'Välj en olänkad enhet som ska fungera som detta försäljningsställe.',
			SelectDevice: () => 'Välj en enhet',
			NoUnlinkedDevices: () => 'Inga olänkade enheter tillgängliga.',
			Config: {
				Default: () => 'Standard',
				Enabled: () => 'Aktiverad',
				Disabled: () => 'Inaktiverad',
				GeneralSection: () => 'Allmänt',
				ScoSection: () => 'Självbetjäning',
				SoundsSection: () => 'Ljud',
				LoggingSection: () => 'Loggning',
				DisplaySection: () => 'Visning',
				CheckoutSection: () => 'Checkout-läge',
				DefaultPaymentMethod: () => 'Standardbetalningsmetod',
				ForcedOrientation: () => 'Tvingad orientering',
				ForcedFormFactor: () => 'Tvingad formfaktor',
				Language: () => 'Språk',
				ShowPrinterDisconnected: () => 'Visa varning för frånkopplad skrivare',
				ProductListColumns: () => 'Kolumner i produktlista',
				BrowseEnabled: () => 'Bläddra',
				AdjustQuantity: () => 'Justera antal',
				ClearCart: () => 'Töm varukorg',
				ItemDeletion: () => 'Ta bort artikel',
				OrderRestart: () => 'Starta om order',
				Permission: (arg0: 'ENABLED' | 'STAFF_NEEDED' | 'DISABLED') =>
					(v => {
						switch (v) {
							case 'ENABLED':
								return 'Aktiverad'
							case 'STAFF_NEEDED':
								return 'Personal krävs'
							case 'DISABLED':
								return 'Inaktiverad'
							default:
								return String(v)
						}
					})(arg0),
				SplitPercentHorizontal: () => 'Arbetsytedelning, horisontell (%)',
				SplitPercentVertical: () => 'Arbetsytedelning, vertikal (%)',
				ItemAddedSound: () => 'Ljud när artikel läggs till',
				ProductNotFoundSound: () => 'Ljud när produkt inte hittas',
				AddToCartFailedSound: () => 'Ljud när det inte går att lägga i varukorg',
				PaymentSuccessSound: () => 'Ljud vid lyckad betalning',
				PaymentFailedSound: () => 'Ljud vid misslyckad betalning',
				InactivityThresholdSeconds: () => 'Inaktivitetsgräns (sekunder)',
				AbandonCountdownSeconds: () => 'Nedräkning vid övergiven varukorg (sekunder)',
				CoolerReadyTimeoutSeconds: () => 'Timeout för redo kylare (sekunder)',
				CheckoutModeIdleTimeoutSeconds: () => 'Timeout för inaktiv skanner (sekunder)',
				CheckoutModeTheme: () => 'Temaöverstyrning (JSON)',
				CheckoutModeThemeHint: () =>
					'Objekt med valfria "colors"- och "fonts"-kartor. Lämna tomt för bastemat.',
				InvalidJson: () => 'Måste vara ett giltigt JSON-objekt'
			}
		},
		DeviceStatus: {
			Title: () => 'Enhetsstatus',
			Online: () => 'Online',
			Offline: () => 'Offline',
			NeverReported: () => 'Denna kassaplats har aldrig rapporterat sin status.',
			ReportedAt: () => 'Senast rapporterad',
			AppVersion: () => 'Appversion',
			DisplayRuntimeVersion: () => 'Körtidsversion',
			ConfiguredRuntimeVersion: () => 'Konfigurerad körtid',
			Platform: () => 'Plattform',
			DeviceModel: () => 'Enhetsmodell',
			NetworkType: () => 'Nätverk',
			UpdateChannel: () => 'Uppdateringskanal',
			UpdateId: () => 'Uppdaterings-ID',
			UpdateCreatedAt: () => 'Uppdatering publicerad',
			UpdatePending: (args: { time: string }) => 'Nedladdad, väntar på inaktivitet sedan ' + String(args.time),
			OperatingMode: () => 'Driftläge',
			Health: () => 'Hälsa',
			PrinterConnected: () => 'Skrivare',
			ScannerConnected: () => 'Skanner',
			PaymentTerminalReachable: () => 'Betalterminal',
			Connected: () => 'Ansluten',
			Disconnected: () => 'Frånkopplad',
			Unknown: () => 'Okänd',
			Environment: () => 'Miljö (redigerad)',
			RefreshButton: () => 'Uppdatera status',
			RefreshSuccess: () => 'Uppdatering begärd',
			PushUpdateButton: () => 'Skicka uppdatering',
			PushUpdateSuccess: () => 'Uppdatering skickad',
			RestartAppButton: () => 'Starta om appen',
			RestartAppSuccess: () => 'Omstartskommando skickat',
			RestartAppConfirmTitle: () => 'Starta om denna app?',
			RestartAppConfirmDescription: () => 'Appen laddas om när terminalen är inaktiv.',
			LockKioskButton: () => 'Lås kiosk',
			LockKioskSuccess: () => 'Kiosklås skickat',
			LockKioskOffline: () => 'Enheten är offline',
			LockKioskConfirmTitle: () => 'Låsa denna kiosk?',
			LockKioskConfirmDescription: () =>
				'Kiosken låses direkt, precis som om personalen tryckte på Lås på enheten.',
			UnlockKioskButton: () => 'Lås upp kiosk',
			UnlockKioskSuccess: () => 'Kioskupplåsning skickad',
			UnlockKioskConfirmTitle: () => 'Låsa upp den här kiosken?',
			UnlockKioskConfirmDescription: () =>
				'Kiosken låses upp direkt utan personalens PIN. Gör detta bara om du är säker på att personalen ska ha åtkomst.',
			PushUpdateDrawer: {
				Title: () => 'Skicka appuppdatering',
				Description: () =>
					'Be denna kassaplats att söka efter och ladda ner en uppdatering. Den laddas ner omedelbart men startar om först när terminalen är inaktiv.',
				ChannelLabel: () => 'Åsidosätt kanal',
				ChannelPlaceholder: () => 'Lämna tomt för att använda den aktuella kanalen',
				Submit: () => 'Skicka uppdatering'
			},
			Enrollment: {
				Title: () => 'Registrerad enhet',
				NotEnrolled: () => 'Ingen enhet är för närvarande registrerad för denna kassaplats.',
				DeviceModel: () => 'Enhetsmodell',
				Platform: () => 'Plattform',
				AppVersion: () => 'Appversion',
				EnrolledAt: () => 'Registrerad',
				Key: () => 'Nyckel',
				EnrollButton: () => 'Registrera enhet',
				RevokeButton: () => 'Återkalla',
				RevokeConfirmTitle: () => 'Återkalla denna enhet?',
				RevokeConfirmDescription: () =>
					'Enheten loggas ut omedelbart och måste parkopplas igen för att återfå åtkomst.',
				RevokeSuccess: () => 'Enhet återkallad',
				EnrollDrawer: {
					Title: () => 'Registrera enhet',
					Description: () => 'Ange den 8-siffriga parkopplingskoden som visas på enheten.',
					CodeLabel: () => 'Parkopplingskod',
					CodePlaceholder: () => '1234 5678',
					LookupButton: () => 'Slå upp enhet',
					LookupError: () => 'Denna kod är ogiltig eller har gått ut.',
					ConfirmTitle: () => 'Registrera denna enhet?',
					ConfirmDescriptionWithCurrent: (args: { device: string; currentDevice: string }) =>
						'Detta utfärdar en ny nyckel till "' +
						String(args.device) +
						'" och loggar omedelbart ut enheten som för närvarande är registrerad ("' +
						String(args.currentDevice) +
						'").',
					ConfirmDescription: (args: { device: string }) =>
						'Detta utfärdar en ny nyckel till "' + String(args.device) + '".',
					Submit: () => 'Registrera',
					EnrollSuccess: () => 'Enhet registrerad'
				}
			},
			Gms: {
				Title: () => 'Android-enhetshantering (GMS)',
				ProviderEloview: () => 'EloView',
				ProviderGms: () => 'GMS',
				NotEnrolled: () => 'Denna enhet är inte registrerad i GMS.',
				EnrollButton: () => 'Registrera enhet',
				EnrollSuccess: () => 'Registrering påbörjad',
				DeviceName: () => 'AMAPI-enhet',
				State: () => 'Status',
				AppliedState: () => 'Tillämpad status',
				PolicyCompliant: () => 'Följer policy',
				NonComplianceReasons: () => 'Orsaker till avvikelse',
				LastPolicySync: () => 'Senaste policysynkronisering',
				InstalledVersionCode: () => 'Installerad versionskod',
				MinimumVersionCode: () => 'Minsta versionskod (fastställd)',
				HardwareModel: () => 'Hårdvarumodell',
				AndroidVersion: () => 'Android-version',
				NoBoundDevice: () => 'Väntar på att enheten ska registreras…',
				Yes: () => 'Ja',
				No: () => 'Nej',
				VersionUnpinned: () => 'Inte fastställd (senaste tillgängliga)',
				ApplyVersionButton: () => 'Tillämpa',
				ApplyVersionSuccess: () => 'Minimiversion uppdaterad',
				WifiNetworks: () => 'Wi-Fi-nätverk',
				WifiAddNetwork: () => 'Lägg till nätverk',
				WifiSsid: () => 'Nätverksnamn (SSID)',
				WifiPassword: () => 'Lösenord',
				WifiSecurityOpen: () => 'Öppet (inget lösenord)',
				WifiSecurityWpaPsk: () => 'Säkrat (WPA/WPA2)',
				WifiHidden: () => 'Dolt nätverk',
				WifiRemove: () => 'Ta bort',
				WifiSaveSuccess: () => 'Wi-Fi-nätverk sparade',
				WifiEmpty: () => 'Inga nätverk konfigurerade',
				WifiPasswordKeepHint: () => 'Lämna tomt för att behålla nuvarande lösenord',
				PlayTrack: () => 'Play-spår',
				TrackProduction: () => 'Produktion (standard)',
				ApplyTrackSuccess: () => 'Play-spår uppdaterat',
				PolicyPreset: () => 'Policyförval',
				ApplyPresetSuccess: () => 'Policyförval tillämpat',
				PolicyPresets: {
					ELO: () => 'Elo (kiosk + Elo OEMConfig)',
					ZEBRA: () => 'Zebra (kiosklås)',
					MANAGED_APP: () => 'Hanterad app (installerar merchant-appen)',
					DEBUGGING: () => 'Felsökning (aktiverar ADB, alla datorer)'
				},
				RebootButton: () => 'Starta om enhet',
				RebootSuccess: () => 'Omstartskommando skickat',
				RebootConfirmTitle: () => 'Starta om denna enhet?',
				RebootConfirmDescription: () => 'Enheten startar om omedelbart.',
				UnenrollButton: () => 'Avregistrera enhet',
				UnenrollSuccess: () => 'Enhet avregistrerad',
				UnenrollConfirmTitle: () => 'Avregistrera denna enhet?',
				UnenrollConfirmDescription: () =>
					'Detta rensar enheten från AMAPI-flottan — motsvarar en fabriksåterställning. Den måste registreras om från grunden.',
				PolicyOverridesLabel: () => 'Råa policyåsidosättanden (JSON)',
				PolicyOverridesHint: () =>
					'Avancerat: ett rått AMAPI Policy-fragment, djupt sammanslaget med den hårdkodade grundmallen. Endast för utvecklare.',
				PolicyOverridesInvalidJson: () => 'Ogiltig JSON',
				SaveOverridesButton: () => 'Spara åsidosättanden',
				ResetOverridesButton: () => 'Återställ',
				SaveOverridesSuccess: () => 'Policyåsidosättanden sparade',
				EnrollDrawer: {
					Title: () => 'Registrera i GMS',
					Description: () =>
						'Genererar en QR-kod för engångsregistrering. Fabriksåterställ enheten, tryck 6 gånger på välkomstskärmen och skanna koden med kameran.',
					WifiSsidLabel: () => 'Wi-Fi-nätverk (valfritt)',
					WifiPasswordLabel: () => 'Wi-Fi-lösenord (valfritt)',
					PolicyPresetLabel: () => 'Policyförval',
					Submit: () => 'Generera QR-kod',
					QrExpiresAt: (args: { time: string }) => 'Går ut ' + String(args.time),
					Done: () => 'Klart'
				}
			}
		},
		Exports: {
			Title: () => 'Exporter',
			Description: () => 'Exportera data till olika format och system',
			Export: () => 'Exportera',
			PricerTitle: () => 'Pricer-produktexport',
			PricerSuccess: () => 'Pricer-export lyckades',
			SalesChannel: () => 'Försäljningskanal-UUID',
			VismaTitle: () => 'Visma-export',
			VismaSuccess: () => 'Visma-export lyckades',
			DigiScaleTitle: () => 'DigiScale-produktexport',
			DigiScaleSuccess: () => 'DigiScale-export lyckades',
			SalesChannelUUIDs: () => 'Försäljningskanal-UUID:n',
			GroupUUIDs: () => 'Produktgrupp-UUID:n',
			SAFTTitle: () => 'SAFT-export',
			SAFTSuccess: () => 'SAFT-export lyckades',
			SAFTCashRegister: () => 'Kassaregister',
			SAFTFinancial: () => 'Ekonomisk'
		},
		Integrations: {
			Title: () => 'Integrationer',
			Description: () => 'Anslut FastTrack till externa tjänster.',
			Teya: {
				Name: () => 'Teya',
				Description: () => 'Anslut Teya för att ta emot kortbetalningar på dina terminaler.',
				StatusConnected: () => 'Ansluten',
				StatusDisconnected: () => 'Inte ansluten',
				StatusError: () => 'Måste anslutas igen',
				Connect: () => 'Anslut Teya',
				Reconnect: () => 'Anslut igen',
				Disconnect: () => 'Koppla från',
				Connecting: () => 'Väntar på anslutning…',
				ConnectedAt: (args: { date: string }) => 'Ansluten ' + String(args.date),
				Unavailable: () => 'Teya är inte tillgängligt för detta företag.',
				ConnectSuccess: () => 'Teya anslutet',
				DisconnectSuccess: () => 'Teya frånkopplat',
				DisconnectConfirm: () =>
					'Betalningar skickas inte längre till Teya-terminaler förrän du ansluter igen.',
				ConnectError: () => 'Det gick inte att starta Teya-anslutningen. Försök igen.',
				PopupBlocked: () => 'Tillåt popup-fönster för att slutföra Teya-anslutningen och försök igen.',
				ConfigureStoreTerminals: () => 'Konfigurera butik och terminaler',
				SelectStore: () => 'Välj en butik',
				SelectTerminal: () => 'Välj en terminal',
				SelectStoreFirst: () => 'Välj en butik först.',
				NoStores: () => 'Inga butiker hittades för detta Teya-konto.',
				NoTerminals: () => 'Inga terminaler hittades för denna butik.',
				ReconnectToConfigure: () => 'Återanslut Teya för att konfigurera butiker och terminaler.'
			},
			Rapyd: {
				SerialPlaceholder: () => 'PAX-enhetens serienummer',
				Register: () => 'Registrera',
				Repair: () => 'Anslut igen',
				WaitingForPairing: () => 'Aktivera parkoppling på terminalen och vänta…',
				Paired: () => 'Parkopplad',
				SerialTooShort: () => 'Serienumret måste vara minst 10 tecken.',
				RegisterError: () => 'Det gick inte att registrera enheten hos Rapyd. Försök igen.',
				ApiKeyRequiredFirst: () =>
					'Spara API-nyckeln i den globala konfigurationen innan du parkopplar en terminal.'
			},
			Providers: {
				teya: {
					Name: () => 'Teya',
					Description: () => 'Ta emot kortbetalningar på dina terminaler.'
				},
				nets: {
					Name: () => 'NETS',
					Description: () => 'Ta emot kortbetalningar via NETS-terminaler.'
				},
				'verifone-ecom': {
					Name: () => 'Verifone e-handel',
					Description: () => 'Ta emot kortbetalningar online via Verifone.'
				},
				'rapyd-cloudlink': {
					Name: () => 'Rapyd CloudLink',
					Description: () => 'Parkoppla PAX-kortterminaler för att ta emot betalningar.'
				},
				'verifone-pos-cloud': {
					Name: () => 'Verifone POS Cloud',
					Description: () => 'Ta emot kortbetalningar på Verifone cloud-terminaler.'
				},
				struct: {
					Name: () => 'Struct',
					Description: () => 'Synkronisera produkter från Struct PIM.'
				}
			},
			Fields: {
				storeId: () => 'Butiks-ID',
				terminalId: () => 'Terminal-ID',
				eposInstanceId: () => 'ePOS-instans-ID',
				environment: () => 'Miljö',
				merchantId: () => 'Handlar-ID',
				username: () => 'Användarnamn',
				password: () => 'Lösenord',
				organizationId: () => 'Organisations-ID',
				entityId: () => 'Enhets-ID',
				apiKey: () => 'API-nyckel',
				apiUrl: () => 'API-URL',
				incomingWebhookEnabled: () => 'Inkommande webhook aktiverad',
				incomingWebhookApiKey: () => 'API-nyckel för inkommande webhook',
				secret: () => 'Hemlighet',
				contractId: () => 'Kontrakts-ID',
				serialNumber: () => 'Serienummer',
				deviceToken: () => 'Enhet',
				authMode: () => 'Autentiseringsläge',
				clientId: () => 'Client ID',
				clientSecret: () => 'Client secret',
				tokenUrl: () => 'Token-URL',
				baseUrl: () => 'Bas-URL',
				poiId: () => 'POI-ID (terminal)',
				saleId: () => 'Sale-ID',
				operatorId: () => 'Operatör-ID',
				scope: () => 'Scope',
				siteEntityId: () => 'Site-enhets-ID',
				terminalSimulator: () => 'Terminalsimulator'
			},
			Config: {
				Back: () => 'Tillbaka till integrationer',
				Global: () => 'Global konfiguration',
				GlobalDescription: () => 'Basinställningar som gäller överallt om de inte åsidosätts.',
				Overrides: () => 'Åsidosättningar',
				OverridesDescriptionSalesChannel: () => 'Åsidosätt inställningar för specifika försäljningskanaler.',
				OverridesDescriptionPointOfSale: () => 'Åsidosätt inställningar för specifika försäljningsställen.',
				AddOverride: () => 'Lägg till åsidosättning',
				NoOverrides: () => 'Inga åsidosättningar',
				OverrideCount: (args: { count: number }) => String(args.count) + ' åsidosättningar',
				Configure: () => 'Konfigurera',
				Save: () => 'Spara',
				Saved: () => 'Konfiguration sparad',
				SaveError: () => 'Det gick inte att spara konfigurationen',
				TargetSalesChannel: () => 'Försäljningskanal',
				TargetPointOfSale: () => 'Försäljningsställe',
				SelectTarget: () => 'Välj…',
				Edit: () => 'Redigera',
				Delete: () => 'Ta bort',
				DeleteOverride: () => 'Ta bort åsidosättning',
				DeleteOverrideConfirm: () =>
					'Den här åsidosättningen tas bort och dess inställningar återgår till den globala konfigurationen.',
				EditOverride: () => 'Redigera åsidosättning',
				SecretSet: () => 'Konfigurerad',
				SecretUnset: () => 'Inte konfigurerad',
				SecretPlaceholderSet: () => 'Lämna tomt för att behålla nuvarande',
				SecretPlaceholderUnset: () => 'Ange värde'
			}
		},
		Billing: {
			Title: () => 'Fakturering',
			NavLabel: () => 'Fakturering',
			Description: () => 'Ditt FastTrack-abonnemang.',
			EmptyTitle: () => 'Ingen plan ännu',
			EmptyDescription: () => 'Ingen abonnemangsplan har konfigurerats för ditt konto ännu.',
			EmptyContactPrefix: () => 'Kontakta',
			EmptyContactLink: () => 'support',
			EmptyContactSuffix: () => 'för att komma igång.',
			PlanHeading: () => 'Abonnemangsplan',
			Note: () => 'Anteckning',
			PlanDetails: () => 'Plandetaljer',
			AdditionalFees: () => 'Ytterligare avgifter',
			Amount: () => 'Belopp',
			Interval: () => 'Faktureringsperiod',
			Monthly: () => 'Månadsvis',
			Yearly: () => 'Årsvis',
			OneTime: () => 'Engångs',
			Net: () => 'Netto',
			Vat: () => 'Moms',
			VatRate: () => 'Momssats',
			Total: () => 'Totalt',
			TotalsHeading: () => 'Totaler',
			MonthlyTotal: () => 'Månadsvis totalt',
			YearlyTotal: () => 'Årsvis totalt',
			OneTimeTotal: () => 'Engångs totalt',
			AgreementHeading: () => 'Avtal',
			SelfServeIntro: () => 'Din användning av FastTrack omfattas av följande policyer:',
			PolicyPrivacy: () => 'Integritetspolicy',
			PolicyTerms: () => 'Användarvillkor',
			PolicyServices: () => 'Plattformstjänstavtal',
			PolicyDpa: () => 'Personuppgiftsbiträdesavtal',
			PolicySupport: () => 'Supportpolicy',
			PolicyEula: () => 'Programvarulicens',
			EnterpriseNote: () => 'Denna plan omfattas av ditt Master Services Agreement med Stack.',
			EnterpriseServicesLink: () => 'Visa plattformstjänstavtalet',
			EnterpriseRefLabel: () => 'Avtalsreferens',
			StartDate: () => 'Startdatum',
			Status: () => 'Status',
			StatusAccepted: () => 'Godkänd',
			StatusPending: () => 'Väntar på godkännande',
			AcceptedBy: () => 'Godkänd av',
			Accept: () => 'Godkänn plan',
			AcceptConfirmTitle: () => 'Godkänn plan',
			AcceptConfirmDescription: () => 'Genom att godkänna bekräftar du att du godtar abonnemangsplanen ovan.',
			AcceptConfirmAction: () => 'Godkänn',
			AcceptSuccess: () => 'Plan godkänd',
			AcceptError: () => 'Kunde inte godkänna planen. Försök igen.',
			LoadError: () => 'Kunde inte ladda din abonnemangsplan.'
		}
	},
	PointOfSale: {
		Title: () => 'Försäljningsställe'
	},
	Profile: {
		Title: () => 'Profil'
	},
	SalesChannels: {
		Title: () => 'Försäljningskanaler'
	},
	Store: {
		Title: () => 'Butik'
	},
	Users: {
		Title: () => 'Användare'
	},
	CompanyCards: {
		Title: () => 'Företagskort',
		CreateTitle: () => 'Skapa företagskort',
		CreateSuccess: () => 'Företagskort skapat',
		EditTitle: () => 'Redigera företagskort',
		UpdateSuccess: () => 'Företagskort uppdaterat',
		DeleteWarning: (args: { name: string }) =>
			'Du är på väg att ta bort företagskortet ' + String(args.name) + '. Denna åtgärd kan inte ångras.',
		Status: (arg0: 'ACTIVE' | 'INACTIVE') =>
			(v => {
				switch (v) {
					case 'ACTIVE':
						return 'Aktiv'
					case 'INACTIVE':
						return 'Inaktiv'
					default:
						return String(v)
				}
			})(arg0),
		Column: {
			Name: () => 'Namn',
			CardNumber: () => 'Kortnummer',
			Status: () => 'Status',
			Company: () => 'Företag',
			Customer: () => 'Kund',
			Employee: () => 'Anställd',
			ExternalId: () => 'Externt ID',
			CreatedAt: () => 'Skapad'
		},
		Detail: {
			Title: () => 'Företagskortdetaljer',
			Transactions: () => 'Transaktioner',
			ResetPin: {
				Title: () => 'Återställ PIN',
				Description: () => 'Är du säker på att du vill återställa PIN för det här kortet?',
				Action: () => 'Återställ PIN'
			},
			ResetPinSuccess: () => 'PIN återställdes'
		},
		Edit: {
			BasicInfo: () => 'Grundläggande information',
			Description: () => 'Redigera företagskortinformation',
			NamePlaceholder: () => 'Ange kortnamn',
			SelectCompany: () => 'Välj företag',
			SelectEmployee: () => 'Välj anställd',
			ExternalIdPlaceholder: () => 'Ange externt ID (valfritt)'
		}
	},
	Settlements: {
		Title: () => 'Avräkningar',
		CreateTitle: () => 'Skapa avräkning',
		CreateSuccess: () => 'Avräkning skapad',
		MarkSettled: () => 'Markera som avräknad',
		MarkSettledSuccess: () => 'Avräkning markerad som avräknad',
		Column: {
			Company: () => 'Företag',
			Period: () => 'Period',
			TotalAmount: () => 'Totalbelopp',
			TransactionCount: () => 'Transaktioner',
			SettledAt: () => 'Avräknad',
			CreatedAt: () => 'Skapad'
		},
		Detail: {
			Title: () => 'Avräkningsdetaljer',
			Transactions: () => 'Transaktioner',
			Period: () => 'Period',
			TotalAmount: () => 'Totalbelopp',
			Status: () => 'Status',
			Settled: () => 'Avräknad',
			NotSettled: () => 'Ej avräknad'
		},
		Create: {
			Title: () => 'Skapa avräkning',
			Period: () => 'Period',
			Description: () => 'Skapa en ny avräkning för företaget',
			PeriodStart: () => 'Periodstart',
			PeriodEnd: () => 'Periodslut'
		}
	},
	Analytics: {
		Title: () => 'Analys',
		Overview: () => 'Översikt',
		Insights: () => 'Insikter',
		SalesAnalytics: () => 'Försäljning',
		SalesAnalyticsDescription: () => 'Följ intäkter, ordrar och de mest sålda produkterna och kanalerna.',
		UserAnalytics: () => 'Användare',
		UserAnalyticsDescription: () => 'Följ aktiva användare, nya registreringar och begäranden om kontoradering.',
		Basket: () => 'Varukorg',
		ActiveUsers: () => 'Aktiva användare',
		NewSignups: () => 'Nya registreringar',
		ChurnedUsers: () => 'Borttagningsförfrågningar',
		ActiveUsersOverTime: () => 'Aktiva användare över tid',
		NewSignupsOverTime: () => 'Nya registreringar över tid',
		ChurnedUsersOverTime: () => 'Borttagningsförfrågningar över tid',
		DeltaNew: () => 'Ny',
		Revenue: () => 'Intäkter',
		Orders: () => 'Order',
		Growth: () => 'Tillväxt',
		TotalRevenue: () => 'Totala intäkter',
		AverageOrderValue: () => 'Genomsnittligt ordervärde',
		Refunds: () => 'Återbetalningar',
		RevenueOverTime: () => 'Intäkter över tid',
		TopProducts: () => 'Toppprodukter',
		TopProductsByRevenue: () => 'Efter intäkter',
		TopProductsByQuantity: () => 'Efter antal',
		PaymentMethods: () => 'Betalningsmetoder',
		RevenueByCategory: () => 'Intäkter per kategori',
		SalesByChannel: () => 'Försäljning per kanal',
		HourlyDistribution: () => 'Timfördelning',
		Day: () => 'Dag',
		Week: () => 'Vecka',
		Month: () => 'Månad',
		Quarter: () => 'Kvartal',
		Year: () => 'År',
		NoData: () => 'Inga data tillgängliga för den här perioden',
		VsDate: (arg0: string) => 'vs. ' + String(arg0),
		VsDateRange: (arg0: string, arg1: string) => 'vs. ' + String(arg0) + ' – ' + String(arg1),
		InProgress: () => '(pågår)',
		ComparePreviousPeriod: () => 'vs. föregående period',
		CompareSamePeriodLastYear: () => 'vs. samma period förra året',
		CompareSpecific: {
			Day: () => 'vs. en viss dag',
			Week: () => 'vs. en viss vecka',
			Month: () => 'vs. en viss månad',
			Quarter: () => 'vs. ett visst kvartal',
			Year: () => 'vs. ett visst år'
		},
		CompareNone: () => 'Ingen jämförelse',
		AllChannels: () => 'Alla kanaler',
		ChannelGroupOption: (arg0: string) => String(arg0) + ' (grupp)',
		CompareToChannel: () => 'Jämför med kanal',
		CompareToChannelNone: () => 'Ingen kanaljämförelse',
		ComparisonModePeriod: () => 'Period',
		ComparisonModeChannel: () => 'Kanal',
		CompareByPeriod: () => 'Jämför efter period',
		CompareByChannel: () => 'Jämför efter kanal',
		PeriodLabel: (arg0: string) => 'Period: ' + String(arg0),
		CompareBy: () => 'Jämför efter',
		ChannelsPageOf: (args: { current: number; total: number }) =>
			'Sida ' + String(args.current) + ' av ' + String(args.total),
		QuarterLabel: (args: { quarter: number; year: number }) => 'K' + String(args.quarter) + ' ' + String(args.year),
		JumpToPeriod: () => 'Gå till period',
		CurrentPeriod: () => 'Nuvarande period',
		IntervalLabel: (arg0: string) => 'Intervall: ' + String(arg0),
		Reports: {
			Title: () => 'Rapporter',
			Description: () => 'Utforska försäljningsdatan i detalj, jämför perioder och kanaler och exportera den.',
			SalesGroup: () => 'Försäljning',
			ViewReport: () => 'Visa rapport',
			Export: () => 'Exportera CSV',
			Rows: () => 'Dela upp efter',
			RowsOption: {
				Hour: () => 'Per timme',
				Day: () => 'Per dag',
				Week: () => 'Per vecka',
				Month: () => 'Per månad',
				Product: () => 'Per produkt'
			},
			ColumnsPicker: () => 'Kolumner',
			GroupBy: () => 'Gruppera efter',
			GroupByOption: {
				Hour: () => 'Timme',
				Day: () => 'Dag',
				Week: () => 'Vecka',
				Month: () => 'Månad'
			},
			Total: () => 'Totalt',
			Revenue: {
				Title: () => 'Intäkter',
				Description: () => 'Intäkter, ordrar, återbetalningar och genomsnittligt ordervärde över tid.'
			},
			Products: {
				Title: () => 'Produkter',
				Description: () => 'Sålda enheter, bruttoförsäljning och ordrar per produkt.',
				FilterProducts: () => 'Alla produkter',
				GrossSalesNote: () =>
					'Produktförsäljning är brutto radbelopp före återbetalningar och kan därför skilja sig från nettointäkterna.'
			},
			Columns: {
				Period: () => 'Period',
				Orders: () => 'Ordrar',
				Revenue: () => 'Intäkter',
				Refunds: () => 'Återbetalningar',
				AverageOrderValue: () => 'Snitt ordervärde',
				Product: () => 'Produkt',
				Quantity: () => 'Antal',
				GrossSales: () => 'Bruttoförsäljning',
				Share: () => 'Andel'
			}
		},
		ChartLabels: {
			Revenue: () => 'Intäkter',
			Orders: () => 'Order',
			Hour: () => 'Timme',
			Quantity: () => 'Antal'
		},
		BasketAnalysis: {
			Title: () => 'Varukorgsanalys',
			Description: () => 'Ta reda på vilka produkter och kategorier som ofta köps tillsammans.',
			AvgItemsPerOrder: () => 'Gen. varor per order',
			AvgUniqueProductsPerOrder: () => 'Gen. unika produkter per order',
			OrdersAnalyzed: () => 'Analyserade order',
			ProductPairs: () => 'Produktpar',
			CategoryAffinity: () => 'Kategoriaffinitet',
			AnchorProduct: () => 'Ankarprodukt',
			AnchorProductPlaceholder: () => 'Sök efter en produkt…',
			AllProducts: () => 'Alla produkter',
			Products: () => 'Produkter',
			ProductsPlaceholder: () => 'Filtrera produkter…',
			ExcludeProductsPlaceholder: () => 'Uteslut produkter…',
			AllProductsFilter: () => 'Alla produkter',
			Categories: () => 'Kategorier',
			CategoriesPlaceholder: () => 'Filtrera kategorier…',
			ExcludeCategoriesPlaceholder: () => 'Uteslut kategorier…',
			AllCategoriesFilter: () => 'Alla kategorier',
			SalesChannel: () => 'Försäljningskanal',
			AllSalesChannels: () => 'Alla försäljningskanaler',
			SalesChannelsSelected: (args: { count: number }) => String(args.count) + ' valda',
			SalesChannelSearchPlaceholder: () => 'Sök bland försäljningskanaler…',
			PointOfSale: () => 'Försäljningsställe',
			AllPointsOfSale: () => 'Alla försäljningsställen',
			MinSupport: () => 'Min. samförekomster',
			ProductA: () => 'Produkt A',
			ProductB: () => 'Produkt B',
			CategoryA: () => 'Kategori A',
			CategoryB: () => 'Kategori B',
			CoOccurrence: () => 'Samförekomst',
			Support: () => 'Support',
			Confidence: () => 'Confidence',
			Lift: () => 'Lift',
			SupportTooltip: () =>
				'Hur vanligt paret är: andelen av alla order som innehåller både A och B. Till exempel betyder 2 % att 2 av 100 order innehöll båda.',
			ConfidenceTooltip: () =>
				'Hur ofta B hamnar i korgen när A gör det: andelen av order med A som även innehåller B. Till exempel betyder 40 % att 4 av 10 order med A också hade B.',
			LiftTooltip: () =>
				'Hur mycket oftare A och B köps tillsammans än man skulle förvänta sig av en slump. 1 betyder inget samband, 2 betyder dubbelt så ofta som förväntat och under 1 betyder att de sällan köps tillsammans.',
			NoProductPairs: () => 'Inga produktpar uppfyller minimigränsen för samförekomst under denna period.',
			NoCategoryPairs: () => 'Inga kategoripar uppfyller minimigränsen för samförekomst under denna period.',
			NoAnchorPairs: () => 'Inga par hittades för den valda produkten under denna period.',
			MetricPercent: (arg0: string) => String(arg0) + '%'
		}
	}
}

/** Each string is its dotted key. Not a user locale — opt in with I18nProvider showTranslationKeys. */
export const keys: Translations = {
	LocaleName: () => 'LocaleName',
	Amount: {
		Default: () => 'Amount.Default',
		WithCode: () => 'Amount.WithCode',
		QuantityTimesPrice: () => 'Amount.QuantityTimesPrice',
		OnlyAmount: () => 'Amount.OnlyAmount'
	},
	Quantity: {
		Pieces: () => 'Quantity.Pieces'
	},
	Weight: () => 'Weight',
	Date: {
		MonthAndYear: () => 'Date.MonthAndYear',
		Short: () => 'Date.Short',
		ShortWithDate: () => 'Date.ShortWithDate',
		DateAndTime: () => 'Date.DateAndTime',
		ShortDateAndTimePrecise: () => 'Date.ShortDateAndTimePrecise',
		Relative: () => 'Date.Relative',
		Ago: () => 'Date.Ago',
		Month: () => 'Date.Month'
	},
	TimeAgo: {
		JustNow: () => 'TimeAgo.JustNow',
		MinutesAgo: () => 'TimeAgo.MinutesAgo',
		HoursAgo: () => 'TimeAgo.HoursAgo',
		DaysAgo: () => 'TimeAgo.DaysAgo',
		MonthsAgo: () => 'TimeAgo.MonthsAgo',
		YearsAgo: () => 'TimeAgo.YearsAgo'
	},
	Enum: {
		PaymentStatus: () => 'Enum.PaymentStatus',
		OrderStatus: () => 'Enum.OrderStatus',
		FulfillmentStatus: () => 'Enum.FulfillmentStatus',
		TransactionStatus: () => 'Enum.TransactionStatus',
		PaymentProvider: () => 'Enum.PaymentProvider',
		ProductStatus: () => 'Enum.ProductStatus',
		ThirdPartySource: () => 'Enum.ThirdPartySource',
		CardExternalSource: () => 'Enum.CardExternalSource',
		PricingMethod: () => 'Enum.PricingMethod',
		GiftCardStatus: () => 'Enum.GiftCardStatus',
		RedemptionStatus: () => 'Enum.RedemptionStatus',
		CardStatus: () => 'Enum.CardStatus',
		FulfillmentProvider: () => 'Enum.FulfillmentProvider',
		UserStatus: () => 'Enum.UserStatus',
		UserRole: () => 'Enum.UserRole'
	},
	General: {
		AppName: () => 'General.AppName',
		DefaultPageTitle: () => 'General.DefaultPageTitle',
		Create: () => 'General.Create',
		Import: () => 'General.Import',
		Export: () => 'General.Export',
		NoResultsTitle: () => 'General.NoResultsTitle',
		Loading: () => 'General.Loading',
		Selected: () => 'General.Selected',
		Optional: () => 'General.Optional',
		Save: () => 'General.Save',
		Continue: () => 'General.Continue',
		Cancel: () => 'General.Cancel',
		Confirm: () => 'General.Confirm',
		Delete: () => 'General.Delete',
		Edit: () => 'General.Edit',
		Add: () => 'General.Add',
		Required: () => 'General.Required',
		Close: () => 'General.Close',
		Update: () => 'General.Update',
		UnsavedChangesTitle: () => 'General.UnsavedChangesTitle',
		UnsavedChangesDescription: () => 'General.UnsavedChangesDescription',
		VerificationInstruction: () => 'General.VerificationInstruction',
		Copy: () => 'General.Copy',
		Copied: () => 'General.Copied',
		AreYouSure: () => 'General.AreYouSure',
		True: () => 'General.True',
		False: () => 'General.False',
		SearchPlaceholder: () => 'General.SearchPlaceholder',
		InvalidFileType: () => 'General.InvalidFileType',
		DropImages: () => 'General.DropImages',
		Multiple: () => 'General.Multiple',
		Variable: () => 'General.Variable',
		Enabled: () => 'General.Enabled',
		Expired: () => 'General.Expired',
		Scheduled: () => 'General.Scheduled',
		Active: () => 'General.Active',
		Inactive: () => 'General.Inactive',
		ComingSoon: () => 'General.ComingSoon',
		ComingSoonDescription: () => 'General.ComingSoonDescription',
		None: () => 'General.None',
		NotSet: () => 'General.NotSet',
		Unknown: () => 'General.Unknown',
		GoBack: () => 'General.GoBack',
		GoHome: () => 'General.GoHome',
		FeatureNotAvailable: () => 'General.FeatureNotAvailable',
		FeatureNotAvailableDescription: () => 'General.FeatureNotAvailableDescription',
		Dismiss: () => 'General.Dismiss',
		TryAgain: () => 'General.TryAgain',
		All: () => 'General.All',
		AdvancedFilters: () => 'General.AdvancedFilters',
		ClearAll: () => 'General.ClearAll',
		Apply: () => 'General.Apply',
		CountSelected: () => 'General.CountSelected',
		MultiSelectHint: () => 'General.MultiSelectHint',
		PickDate: () => 'General.PickDate',
		Created: () => 'General.Created',
		View: () => 'General.View'
	},
	ApiErrorAlert: {
		FailedToLoadData: () => 'ApiErrorAlert.FailedToLoadData',
		AnErrorOccurredWhileFetchingData: () => 'ApiErrorAlert.AnErrorOccurredWhileFetchingData'
	},
	Enums: {
		PaymentProvider: () => 'Enums.PaymentProvider'
	},
	Fields: {
		Name: () => 'Fields.Name',
		Status: () => 'Fields.Status',
		Type: () => 'Fields.Type',
		SalesChannel: () => 'Fields.SalesChannel',
		PointOfSale: () => 'Fields.PointOfSale',
		PaymentStatus: () => 'Fields.PaymentStatus',
		StartDate: () => 'Fields.StartDate',
		EndDate: () => 'Fields.EndDate',
		TaxRate: () => 'Fields.TaxRate',
		TaxInclusive: () => 'Fields.TaxInclusive',
		Amount: () => 'Fields.Amount',
		Price: () => 'Fields.Price',
		Description: () => 'Fields.Description',
		Groups: () => 'Fields.Groups',
		Categories: () => 'Fields.Categories',
		Email: () => 'Fields.Email',
		Password: () => 'Fields.Password',
		ConfirmPassword: () => 'Fields.ConfirmPassword',
		Role: () => 'Fields.Role',
		SKU: () => 'Fields.SKU',
		Currency: () => 'Fields.Currency',
		CreatedAt: () => 'Fields.CreatedAt',
		ExpiresAt: () => 'Fields.ExpiresAt',
		UpdatedAt: () => 'Fields.UpdatedAt',
		Language: () => 'Fields.Language',
		Year: () => 'Fields.Year',
		Month: () => 'Fields.Month',
		ExternalId: () => 'Fields.ExternalId',
		FirstName: () => 'Fields.FirstName',
		LastName: () => 'Fields.LastName',
		Phone: () => 'Fields.Phone',
		SSN: () => 'Fields.SSN',
		CardNumber: () => 'Fields.CardNumber',
		Company: () => 'Fields.Company',
		Customer: () => 'Fields.Customer',
		Employee: () => 'Fields.Employee',
		FromTime: () => 'Fields.FromTime',
		ToTime: () => 'Fields.ToTime',
		OrgNumber: () => 'Fields.OrgNumber',
		Enabled: () => 'Fields.Enabled',
		Disabled: () => 'Fields.Disabled',
		CurrencyCode: () => 'Fields.CurrencyCode'
	},
	App: {
		Menus: {
			User: {
				Shortcuts: () => 'App.Menus.User.Shortcuts'
			}
		}
	},
	DaysOfWeek: {
		Monday: () => 'DaysOfWeek.Monday',
		Tuesday: () => 'DaysOfWeek.Tuesday',
		Wednesday: () => 'DaysOfWeek.Wednesday',
		Thursday: () => 'DaysOfWeek.Thursday',
		Friday: () => 'DaysOfWeek.Friday',
		Saturday: () => 'DaysOfWeek.Saturday',
		Sunday: () => 'DaysOfWeek.Sunday'
	},
	Auth: {
		AcceptInvite: () => 'Auth.AcceptInvite',
		AcceptInviteAndSetPassword: () => 'Auth.AcceptInviteAndSetPassword',
		AcceptInviteDescription: () => 'Auth.AcceptInviteDescription',
		ConfirmPasswordPlaceholder: () => 'Auth.ConfirmPasswordPlaceholder',
		InvalidInvite: () => 'Auth.InvalidInvite',
		InvalidInviteDescription: () => 'Auth.InvalidInviteDescription',
		InviteAccepted: () => 'Auth.InviteAccepted',
		InviteExpired: () => 'Auth.InviteExpired',
		PasswordPlaceholder: () => 'Auth.PasswordPlaceholder',
		PasswordsDoNotMatch: () => 'Auth.PasswordsDoNotMatch',
		SetPassword: () => 'Auth.SetPassword'
	},
	Error: {
		PageNotFound: () => 'Error.PageNotFound',
		PageNotFoundDescription: () => 'Error.PageNotFoundDescription',
		SomethingWentWrong: () => 'Error.SomethingWentWrong',
		AnUnexpectedErrorOccurred: () => 'Error.AnUnexpectedErrorOccurred',
		ErrorDetails: () => 'Error.ErrorDetails',
		ReloadPage: () => 'Error.ReloadPage',
		ContactSupport: () => 'Error.ContactSupport'
	},
	Campaigns: {
		Domain: () => 'Campaigns.Domain'
	},
	CustomerGroups: {
		Domain: () => 'CustomerGroups.Domain',
		Title: () => 'CustomerGroups.Title',
		CreateTitle: () => 'CustomerGroups.CreateTitle',
		CreateSuccess: () => 'CustomerGroups.CreateSuccess',
		EditTitle: () => 'CustomerGroups.EditTitle',
		UpdateSuccess: () => 'CustomerGroups.UpdateSuccess',
		Empty: () => 'CustomerGroups.Empty',
		Members: () => 'CustomerGroups.Members',
		SelectCustomers: () => 'CustomerGroups.SelectCustomers',
		Delete: {
			Title: () => 'CustomerGroups.Delete.Title',
			Description: () => 'CustomerGroups.Delete.Description',
			SuccessToast: () => 'CustomerGroups.Delete.SuccessToast'
		},
		Column: {
			Name: () => 'CustomerGroups.Column.Name',
			Description: () => 'CustomerGroups.Column.Description',
			ExternalId: () => 'CustomerGroups.Column.ExternalId',
			MemberCount: () => 'CustomerGroups.Column.MemberCount'
		},
		Field: {
			Name: () => 'CustomerGroups.Field.Name',
			Description: () => 'CustomerGroups.Field.Description',
			ExternalId: () => 'CustomerGroups.Field.ExternalId',
			NamePlaceholder: () => 'CustomerGroups.Field.NamePlaceholder',
			DescriptionPlaceholder: () => 'CustomerGroups.Field.DescriptionPlaceholder',
			ExternalIdPlaceholder: () => 'CustomerGroups.Field.ExternalIdPlaceholder'
		},
		Detail: {
			Title: () => 'CustomerGroups.Detail.Title'
		}
	},
	DraftOrders: {
		Domain: () => 'DraftOrders.Domain'
	},
	PriceLists: {
		Domain: () => 'PriceLists.Domain'
	},
	Reservations: {
		Domain: () => 'Reservations.Domain'
	},
	Login: {
		PageTitle: () => 'Login.PageTitle',
		Title: () => 'Login.Title',
		Description: () => 'Login.Description',
		Email: () => 'Login.Email',
		Password: () => 'Login.Password',
		LogIn: () => 'Login.LogIn',
		ForgotPassword: () => 'Login.ForgotPassword',
		ForgotPasswordButton: () => 'Login.ForgotPasswordButton',
		Error: () => 'Login.Error',
		UnauthorizedError: () => 'Login.UnauthorizedError'
	},
	ResetPassword: {
		Title: () => 'ResetPassword.Title',
		Hint: () => 'ResetPassword.Hint',
		Email: () => 'ResetPassword.Email',
		SendResetInstructions: () => 'ResetPassword.SendResetInstructions',
		BackToLogin: () => 'ResetPassword.BackToLogin',
		SuccessfulRequestTitle: () => 'ResetPassword.SuccessfulRequestTitle',
		SuccessfulRequest: () => 'ResetPassword.SuccessfulRequest',
		NewPassword: () => 'ResetPassword.NewPassword',
		NewPasswordHint: () => 'ResetPassword.NewPasswordHint',
		RepeatNewPassword: () => 'ResetPassword.RepeatNewPassword',
		ResetPassword: () => 'ResetPassword.ResetPassword',
		PasswordMismatch: () => 'ResetPassword.PasswordMismatch',
		SuccessfulResetTitle: () => 'ResetPassword.SuccessfulResetTitle',
		SuccessfulReset: () => 'ResetPassword.SuccessfulReset',
		InvalidEmail: () => 'ResetPassword.InvalidEmail'
	},
	Sidebar: {
		Logout: () => 'Sidebar.Logout',
		ProfileSettings: () => 'Sidebar.ProfileSettings',
		BackToApp: () => 'Sidebar.BackToApp',
		SearchPlaceholder: () => 'Sidebar.SearchPlaceholder',
		OpenSearch: () => 'Sidebar.OpenSearch',
		StoreScopeHint: () => 'Sidebar.StoreScopeHint',
		Sections: () => 'Sidebar.Sections',
		Individuals: () => 'Sidebar.Individuals',
		Business: () => 'Sidebar.Business',
		Content: () => 'Sidebar.Content',
		Messaging: () => 'Sidebar.Messaging',
		Automation: () => 'Sidebar.Automation'
	},
	DeveloperFeedback: {
		Entry: () => 'DeveloperFeedback.Entry',
		Title: () => 'DeveloperFeedback.Title',
		Description: () => 'DeveloperFeedback.Description',
		TitleLabel: () => 'DeveloperFeedback.TitleLabel',
		BodyLabel: () => 'DeveloperFeedback.BodyLabel',
		TypeLabel: () => 'DeveloperFeedback.TypeLabel',
		TypeSmallFix: () => 'DeveloperFeedback.TypeSmallFix',
		TypeBug: () => 'DeveloperFeedback.TypeBug',
		TypeEnhancement: () => 'DeveloperFeedback.TypeEnhancement',
		TypeNote: () => 'DeveloperFeedback.TypeNote',
		Submit: () => 'DeveloperFeedback.Submit',
		Created: () => 'DeveloperFeedback.Created'
	},
	CommandPalette: {
		GroupQuick: () => 'CommandPalette.GroupQuick',
		InputHint: () => 'CommandPalette.InputHint',
		FooterHint: () => 'CommandPalette.FooterHint',
		NoResults: () => 'CommandPalette.NoResults',
		QuickNewProduct: () => 'CommandPalette.QuickNewProduct',
		QuickNewPromotion: () => 'CommandPalette.QuickNewPromotion',
		QuickMarketingContent: () => 'CommandPalette.QuickMarketingContent',
		QuickGoOrders: () => 'CommandPalette.QuickGoOrders',
		QuickSettings: () => 'CommandPalette.QuickSettings'
	},
	Pagination: {
		Showing: () => 'Pagination.Showing',
		NoResults: () => 'Pagination.NoResults',
		Previous: () => 'Pagination.Previous',
		Next: () => 'Pagination.Next'
	},
	Orders: {
		Title: () => 'Orders.Title',
		BagChecks: () => 'Orders.BagChecks',
		Drafts: () => 'Orders.Drafts',
		StatusEnum: () => 'Orders.StatusEnum',
		OrderCanceled: () => 'Orders.OrderCanceled',
		AdvancedFilters: () => 'Orders.AdvancedFilters',
		FulfillmentStatusEnum: () => 'Orders.FulfillmentStatusEnum',
		Column: {
			Order: () => 'Orders.Column.Order',
			Date: () => 'Orders.Column.Date',
			SalesChannel: () => 'Orders.Column.SalesChannel',
			PaymentStatus: () => 'Orders.Column.PaymentStatus',
			Total: () => 'Orders.Column.Total',
			FulfillmentStatus: () => 'Orders.Column.FulfillmentStatus',
			PointsEarned: () => 'Orders.Column.PointsEarned',
			PointsUsed: () => 'Orders.Column.PointsUsed'
		},
		Totals: {
			Header: () => 'Orders.Totals.Header',
			Orders: () => 'Orders.Totals.Orders',
			Total: () => 'Orders.Totals.Total',
			Average: () => 'Orders.Totals.Average',
			UpdatedAt: () => 'Orders.Totals.UpdatedAt'
		},
		Filters: {
			MinAmount: () => 'Orders.Filters.MinAmount',
			MaxAmount: () => 'Orders.Filters.MaxAmount',
			FromDate: () => 'Orders.Filters.FromDate',
			ToDate: () => 'Orders.Filters.ToDate'
		},
		Refund: {
			Title: () => 'Orders.Refund.Title',
			Amount: () => 'Orders.Refund.Amount',
			Note: () => 'Orders.Refund.Note',
			AmountCannotBeEmpty: () => 'Orders.Refund.AmountCannotBeEmpty',
			AmountMustBeGreaterThanZero: () => 'Orders.Refund.AmountMustBeGreaterThanZero',
			AmountMustBeLessThanRefundableAmount: () => 'Orders.Refund.AmountMustBeLessThanRefundableAmount',
			Description: () => 'Orders.Refund.Description',
			ItemsSectionTitle: () => 'Orders.Refund.ItemsSectionTitle',
			CustomAmountSectionTitle: () => 'Orders.Refund.CustomAmountSectionTitle',
			CustomAmountLabel: () => 'Orders.Refund.CustomAmountLabel',
			CustomAmountOnlyLabel: () => 'Orders.Refund.CustomAmountOnlyLabel',
			CustomAmountHint: () => 'Orders.Refund.CustomAmountHint',
			RefundableAmount: () => 'Orders.Refund.RefundableAmount',
			RefundTotal: () => 'Orders.Refund.RefundTotal',
			AlreadyRefunded: () => 'Orders.Refund.AlreadyRefunded',
			PromotionLocked: () => 'Orders.Refund.PromotionLocked',
			Restock: () => 'Orders.Refund.Restock',
			NothingToRefund: () => 'Orders.Refund.NothingToRefund',
			NoRefundableItems: () => 'Orders.Refund.NoRefundableItems',
			SelectSomething: () => 'Orders.Refund.SelectSomething',
			ExceedsRefundable: () => 'Orders.Refund.ExceedsRefundable',
			RefundEntireOrder: () => 'Orders.Refund.RefundEntireOrder',
			SelectAll: () => 'Orders.Refund.SelectAll',
			ConfirmTitle: () => 'Orders.Refund.ConfirmTitle',
			ConfirmWarning: () => 'Orders.Refund.ConfirmWarning',
			Submit: () => 'Orders.Refund.Submit',
			Success: () => 'Orders.Refund.Success',
			Error: () => 'Orders.Refund.Error'
		},
		Payment: {
			CreateRefundWrongQuantity: () => 'Orders.Payment.CreateRefundWrongQuantity'
		}
	},
	OrderDetail: {
		Title: () => 'OrderDetail.Title',
		OnDateFromSalesChannel: () => 'OrderDetail.OnDateFromSalesChannel',
		OnDateFromPointOfSale: () => 'OrderDetail.OnDateFromPointOfSale',
		Status: () => 'OrderDetail.Status',
		CancelWarning: () => 'OrderDetail.CancelWarning',
		OpenOrderDetails: () => 'OrderDetail.OpenOrderDetails',
		Items: () => 'OrderDetail.Items',
		Transactions: () => 'OrderDetail.Transactions',
		Summary: {
			Title: () => 'OrderDetail.Summary.Title',
			EditOrder: () => 'OrderDetail.Summary.EditOrder',
			OpenReceipt: () => 'OrderDetail.Summary.OpenReceipt',
			ItemTotal: () => 'OrderDetail.Summary.ItemTotal',
			TaxTotal: () => 'OrderDetail.Summary.TaxTotal',
			Total: () => 'OrderDetail.Summary.Total',
			GiftCardTotal: () => 'OrderDetail.Summary.GiftCardTotal',
			PointsEarned: () => 'OrderDetail.Summary.PointsEarned',
			PaidTotal: () => 'OrderDetail.Summary.PaidTotal',
			OutstandingAmount: () => 'OrderDetail.Summary.OutstandingAmount',
			Discount: () => 'OrderDetail.Summary.Discount',
			Refunded: () => 'OrderDetail.Summary.Refunded'
		},
		Receipt: {
			FailedToLoad: () => 'OrderDetail.Receipt.FailedToLoad',
			Redirecting: () => 'OrderDetail.Receipt.Redirecting',
			Loading: () => 'OrderDetail.Receipt.Loading'
		},
		Payment: {
			Title: () => 'OrderDetail.Payment.Title',
			Status: () => 'OrderDetail.Payment.Status',
			TransactionStatus: () => 'OrderDetail.Payment.TransactionStatus',
			Provider: () => 'OrderDetail.Payment.Provider',
			PaymentWithSequenceNumber: () => 'OrderDetail.Payment.PaymentWithSequenceNumber',
			RefundWithSequenceNumber: () => 'OrderDetail.Payment.RefundWithSequenceNumber',
			TotalPaidByCustomer: () => 'OrderDetail.Payment.TotalPaidByCustomer',
			TotalPending: () => 'OrderDetail.Payment.TotalPending',
			Refund: () => 'OrderDetail.Payment.Refund'
		},
		SandStar: {
			Title: () => 'OrderDetail.SandStar.Title',
			CloudReview: () => 'OrderDetail.SandStar.CloudReview',
			MachineName: () => 'OrderDetail.SandStar.MachineName',
			OrderNo: () => 'OrderDetail.SandStar.OrderNo',
			AbnormalReason: () => 'OrderDetail.SandStar.AbnormalReason',
			Video: () => 'OrderDetail.SandStar.Video',
			NoVideo: () => 'OrderDetail.SandStar.NoVideo'
		}
	},
	Products: {
		Title: () => 'Products.Title',
		Library: () => 'Products.Library',
		Status: () => 'Products.Status',
		BarcodeType: () => 'Products.BarcodeType',
		ExportTitle: () => 'Products.ExportTitle',
		AdvancedFilters: () => 'Products.AdvancedFilters',
		NoAdvancedFiltersYet: () => 'Products.NoAdvancedFiltersYet',
		OpenProductDetails: () => 'Products.OpenProductDetails',
		LibraryPage: {
			NoAssets: () => 'Products.LibraryPage.NoAssets',
			NoAssetsDescription: () => 'Products.LibraryPage.NoAssetsDescription',
			Filename: () => 'Products.LibraryPage.Filename',
			TableView: () => 'Products.LibraryPage.TableView',
			GalleryView: () => 'Products.LibraryPage.GalleryView',
			Upload: () => 'Products.LibraryPage.Upload',
			SearchFilename: () => 'Products.LibraryPage.SearchFilename',
			ViewFullImage: () => 'Products.LibraryPage.ViewFullImage',
			CopyUrl: () => 'Products.LibraryPage.CopyUrl',
			CopiedUrl: () => 'Products.LibraryPage.CopiedUrl',
			DeleteAsset: () => 'Products.LibraryPage.DeleteAsset',
			DeleteAssetConfirm: () => 'Products.LibraryPage.DeleteAssetConfirm',
			UploadAssets: () => 'Products.LibraryPage.UploadAssets',
			UploadDropzone: () => 'Products.LibraryPage.UploadDropzone',
			ChooseFiles: () => 'Products.LibraryPage.ChooseFiles',
			Tags: () => 'Products.LibraryPage.Tags',
			UsedBy: () => 'Products.LibraryPage.UsedBy',
			UsageFilter: () => 'Products.LibraryPage.UsageFilter',
			UsageUnused: () => 'Products.LibraryPage.UsageUnused',
			UsageProduct: () => 'Products.LibraryPage.UsageProduct',
			UsageProductGroup: () => 'Products.LibraryPage.UsageProductGroup',
			UsageProductCategory: () => 'Products.LibraryPage.UsageProductCategory',
			UsageMarketingContent: () => 'Products.LibraryPage.UsageMarketingContent',
			UsageFeedLayout: () => 'Products.LibraryPage.UsageFeedLayout',
			ChannelFilter: () => 'Products.LibraryPage.ChannelFilter',
			ContentFilter: () => 'Products.LibraryPage.ContentFilter',
			ChannelNone: () => 'Products.LibraryPage.ChannelNone',
			ContentNone: () => 'Products.LibraryPage.ContentNone',
			TagsPlaceholder: () => 'Products.LibraryPage.TagsPlaceholder',
			Uploading: () => 'Products.LibraryPage.Uploading',
			EditTags: () => 'Products.LibraryPage.EditTags',
			NoTags: () => 'Products.LibraryPage.NoTags',
			ManageTags: () => 'Products.LibraryPage.ManageTags',
			ManageTagsEmpty: () => 'Products.LibraryPage.ManageTagsEmpty',
			ManageTagsAssetCount: () => 'Products.LibraryPage.ManageTagsAssetCount',
			CreateTag: () => 'Products.LibraryPage.CreateTag',
			CreateTagPlaceholder: () => 'Products.LibraryPage.CreateTagPlaceholder',
			CreateTagSuccess: () => 'Products.LibraryPage.CreateTagSuccess',
			RenameTag: () => 'Products.LibraryPage.RenameTag',
			RenameTagMergeConfirm: () => 'Products.LibraryPage.RenameTagMergeConfirm',
			RenameTagSuccess: () => 'Products.LibraryPage.RenameTagSuccess',
			RemoveTagConfirm: () => 'Products.LibraryPage.RemoveTagConfirm',
			RemoveTagSuccess: () => 'Products.LibraryPage.RemoveTagSuccess'
		},
		Column: {
			Title: () => 'Products.Column.Title',
			Status: () => 'Products.Column.Status',
			PricingMethod: () => 'Products.Column.PricingMethod',
			SalesChannels: () => 'Products.Column.SalesChannels'
		},
		PricingMethod: () => 'Products.PricingMethod',
		Export: {
			Description: () => 'Products.Export.Description',
			Download: () => 'Products.Export.Download',
			Error: () => 'Products.Export.Error',
			Format: () => 'Products.Export.Format',
			NoDataError: () => 'Products.Export.NoDataError',
			ProductCount: () => 'Products.Export.ProductCount',
			Success: () => 'Products.Export.Success'
		},
		Import: {
			Header: () => 'Products.Import.Header',
			UploadLabel: () => 'Products.Import.UploadLabel',
			UploadHint: () => 'Products.Import.UploadHint',
			Description: () => 'Products.Import.Description',
			Template: {
				Title: () => 'Products.Import.Template.Title',
				Description: () => 'Products.Import.Template.Description'
			},
			Upload: {
				Title: () => 'Products.Import.Upload.Title',
				Description: () => 'Products.Import.Upload.Description',
				Preprocessing: () => 'Products.Import.Upload.Preprocessing',
				Importing: () => 'Products.Import.Upload.Importing',
				ProductsToCreate: () => 'Products.Import.Upload.ProductsToCreate',
				ProductsToUpdate: () => 'Products.Import.Upload.ProductsToUpdate',
				ProductsCreated: () => 'Products.Import.Upload.ProductsCreated',
				ProductsUpdated: () => 'Products.Import.Upload.ProductsUpdated',
				ProductsErrored: () => 'Products.Import.Upload.ProductsErrored',
				Errors: {
					Title: () => 'Products.Import.Upload.Errors.Title',
					Description: () => 'Products.Import.Upload.Errors.Description',
					Row: () => 'Products.Import.Upload.Errors.Row',
					Column: () => 'Products.Import.Upload.Errors.Column',
					Message: () => 'Products.Import.Upload.Errors.Message'
				}
			},
			Success: () => 'Products.Import.Success'
		}
	},
	Product: {
		Header: () => 'Product.Header',
		EditHeader: () => 'Product.EditHeader',
		EditSuccessToast: () => 'Product.EditSuccessToast',
		CreateTitle: () => 'Product.CreateTitle',
		Title: () => 'Product.Title',
		Subtitle: () => 'Product.Subtitle',
		Description: () => 'Product.Description',
		PricingMethodTitle: () => 'Product.PricingMethodTitle',
		Overview: () => 'Product.Overview',
		ExternalId: () => 'Product.ExternalId',
		ExternalSource: () => 'Product.ExternalSource',
		ManagedExternally: () => 'Product.ManagedExternally',
		Sku: () => 'Product.Sku',
		Variants: () => 'Product.Variants',
		DeleteWarning: () => 'Product.DeleteWarning',
		Create: {
			Title: () => 'Product.Create.Title'
		},
		Media: {
			Title: () => 'Product.Media.Title',
			Upload: () => 'Product.Media.Upload',
			ChooseFromLibrary: () => 'Product.Media.ChooseFromLibrary',
			LibraryPickerTitle: () => 'Product.Media.LibraryPickerTitle',
			LibraryPickerEmpty: () => 'Product.Media.LibraryPickerEmpty',
			LibraryPickerAllAttached: () => 'Product.Media.LibraryPickerAllAttached',
			AddImageSuccessToast: () => 'Product.Media.AddImageSuccessToast',
			DeleteImageLabel: () => 'Product.Media.DeleteImageLabel',
			DownloadImageLabel: () => 'Product.Media.DownloadImageLabel',
			SetPrimaryLabel: () => 'Product.Media.SetPrimaryLabel',
			AlreadyPrimaryLabel: () => 'Product.Media.AlreadyPrimaryLabel',
			PrimaryBadge: () => 'Product.Media.PrimaryBadge',
			ProcessingBadge: () => 'Product.Media.ProcessingBadge',
			UploadingLabel: () => 'Product.Media.UploadingLabel',
			UploadSuccessToast: () => 'Product.Media.UploadSuccessToast',
			UploadFailedToast: () => 'Product.Media.UploadFailedToast',
			DeleteSuccessToast: () => 'Product.Media.DeleteSuccessToast',
			SetPrimarySuccessToast: () => 'Product.Media.SetPrimarySuccessToast',
			EmptyState: {
				Header: () => 'Product.Media.EmptyState.Header',
				Description: () => 'Product.Media.EmptyState.Description',
				Action: () => 'Product.Media.EmptyState.Action'
			}
		},
		Organization: {
			Header: () => 'Product.Organization.Header'
		},
		Pricing: {
			Title: () => 'Product.Pricing.Title',
			VariablePrice: () => 'Product.Pricing.VariablePrice',
			Price: () => 'Product.Pricing.Price',
			PriceWithTax: () => 'Product.Pricing.PriceWithTax',
			PriceWithoutTax: () => 'Product.Pricing.PriceWithoutTax',
			Enabled: () => 'Product.Pricing.Enabled',
			InvalidTaxRate: () => 'Product.Pricing.InvalidTaxRate',
			NoPricesConfigured: () => 'Product.Pricing.NoPricesConfigured',
			Target: () => 'Product.Pricing.Target',
			Group: () => 'Product.Pricing.Group',
			Channel: () => 'Product.Pricing.Channel',
			GroupDefault: () => 'Product.Pricing.GroupDefault',
			ChannelOverride: () => 'Product.Pricing.ChannelOverride',
			AddOverride: () => 'Product.Pricing.AddOverride',
			SelectOverrideChannel: () => 'Product.Pricing.SelectOverrideChannel',
			NoOverridableChannels: () => 'Product.Pricing.NoOverridableChannels',
			RemoveOverride: () => 'Product.Pricing.RemoveOverride',
			ExpandGroup: () => 'Product.Pricing.ExpandGroup',
			CollapseGroup: () => 'Product.Pricing.CollapseGroup',
			OverrideCount: () => 'Product.Pricing.OverrideCount',
			EmptyState: {
				Header: () => 'Product.Pricing.EmptyState.Header',
				Description: () => 'Product.Pricing.EmptyState.Description',
				Action: () => 'Product.Pricing.EmptyState.Action'
			}
		},
		Barcode: {
			Title: () => 'Product.Barcode.Title',
			Barcode: () => 'Product.Barcode.Barcode',
			AddBarcode: () => 'Product.Barcode.AddBarcode',
			AddBarcodePrompt: {
				Title: () => 'Product.Barcode.AddBarcodePrompt.Title',
				Placeholder: () => 'Product.Barcode.AddBarcodePrompt.Placeholder'
			},
			Delete: {
				Title: () => 'Product.Barcode.Delete.Title',
				Description: () => 'Product.Barcode.Delete.Description'
			},
			AlreadyOnProduct: () => 'Product.Barcode.AlreadyOnProduct',
			AlreadyInUse: () => 'Product.Barcode.AlreadyInUse'
		},
		UnitsOfMeasure: {
			Title: () => 'Product.UnitsOfMeasure.Title',
			Unit: () => 'Product.UnitsOfMeasure.Unit',
			Base: () => 'Product.UnitsOfMeasure.Base',
			BaseUnit: () => 'Product.UnitsOfMeasure.BaseUnit',
			True: () => 'Product.UnitsOfMeasure.True',
			False: () => 'Product.UnitsOfMeasure.False',
			BaseUnitLabel: () => 'Product.UnitsOfMeasure.BaseUnitLabel',
			BaseUnitsPer: () => 'Product.UnitsOfMeasure.BaseUnitsPer',
			Sellable: () => 'Product.UnitsOfMeasure.Sellable',
			Pos: () => 'Product.UnitsOfMeasure.Pos',
			Ecom: () => 'Product.UnitsOfMeasure.Ecom',
			Add: () => 'Product.UnitsOfMeasure.Add',
			Edit: () => 'Product.UnitsOfMeasure.Edit',
			Code: () => 'Product.UnitsOfMeasure.Code',
			Name: () => 'Product.UnitsOfMeasure.Name',
			InvalidFactor: () => 'Product.UnitsOfMeasure.InvalidFactor',
			SelectUnit: () => 'Product.UnitsOfMeasure.SelectUnit',
			QuantityRequired: () => 'Product.UnitsOfMeasure.QuantityRequired',
			Saved: () => 'Product.UnitsOfMeasure.Saved',
			Delete: {
				Title: () => 'Product.UnitsOfMeasure.Delete.Title',
				Description: () => 'Product.UnitsOfMeasure.Delete.Description'
			}
		}
	},
	ProductEdit: {
		Header: () => 'ProductEdit.Header'
	},
	ProductCategories: {
		Title: () => 'ProductCategories.Title',
		Breadcrumb: () => 'ProductCategories.Breadcrumb',
		Search: () => 'ProductCategories.Search',
		Empty: () => 'ProductCategories.Empty',
		NoSearchResults: () => 'ProductCategories.NoSearchResults',
		Column: {
			Name: () => 'ProductCategories.Column.Name',
			ProductCount: () => 'ProductCategories.Column.ProductCount'
		}
	},
	Categories: {
		Create: {
			NoParent: () => 'Categories.Create.NoParent',
			SelectParentTitle: () => 'Categories.Create.SelectParentTitle',
			SelectParentDescription: () => 'Categories.Create.SelectParentDescription'
		}
	},
	ProductCategory: {
		CreateSuccessToast: () => 'ProductCategory.CreateSuccessToast',
		EditHeader: () => 'ProductCategory.EditHeader',
		EditSuccessToast: () => 'ProductCategory.EditSuccessToast',
		CreateTitle: () => 'ProductCategory.CreateTitle',
		ParentCategory: () => 'ProductCategory.ParentCategory',
		ProductsTitle: () => 'ProductCategory.ProductsTitle',
		SelectParent: () => 'ProductCategory.SelectParent',
		ClearParent: () => 'ProductCategory.ClearParent',
		Delete: {
			Title: () => 'ProductCategory.Delete.Title',
			Description: () => 'ProductCategory.Delete.Description',
			SuccessToast: () => 'ProductCategory.Delete.SuccessToast'
		},
		Image: {
			Title: () => 'ProductCategory.Image.Title',
			EmptyState: () => 'ProductCategory.Image.EmptyState',
			Upload: () => 'ProductCategory.Image.Upload',
			ChooseFromLibrary: () => 'ProductCategory.Image.ChooseFromLibrary',
			Remove: () => 'ProductCategory.Image.Remove',
			LibraryPickerTitle: () => 'ProductCategory.Image.LibraryPickerTitle',
			LibraryPickerEmpty: () => 'ProductCategory.Image.LibraryPickerEmpty',
			LibraryPickerAllAttached: () => 'ProductCategory.Image.LibraryPickerAllAttached',
			SetSuccessToast: () => 'ProductCategory.Image.SetSuccessToast',
			RemoveSuccessToast: () => 'ProductCategory.Image.RemoveSuccessToast',
			UploadFailedToast: () => 'ProductCategory.Image.UploadFailedToast'
		},
		Create: {
			NoParent: () => 'ProductCategory.Create.NoParent',
			SelectParentTitle: () => 'ProductCategory.Create.SelectParentTitle',
			SelectParentDescription: () => 'ProductCategory.Create.SelectParentDescription'
		}
	},
	ProductGroups: {
		Title: () => 'ProductGroups.Title',
		Breadcrumb: () => 'ProductGroups.Breadcrumb',
		Search: () => 'ProductGroups.Search',
		Empty: () => 'ProductGroups.Empty',
		NoSearchResults: () => 'ProductGroups.NoSearchResults',
		Column: {
			Name: () => 'ProductGroups.Column.Name',
			ProductCount: () => 'ProductGroups.Column.ProductCount'
		}
	},
	ProductGroup: {
		Title: () => 'ProductGroup.Title',
		EditHeader: () => 'ProductGroup.EditHeader',
		EditSuccessToast: () => 'ProductGroup.EditSuccessToast',
		CreateTitle: () => 'ProductGroup.CreateTitle',
		CreateSuccessToast: () => 'ProductGroup.CreateSuccessToast',
		Delete: {
			Title: () => 'ProductGroup.Delete.Title',
			Description: () => 'ProductGroup.Delete.Description',
			SuccessToast: () => 'ProductGroup.Delete.SuccessToast'
		},
		Image: {
			Title: () => 'ProductGroup.Image.Title',
			EmptyState: () => 'ProductGroup.Image.EmptyState',
			Upload: () => 'ProductGroup.Image.Upload',
			ChooseFromLibrary: () => 'ProductGroup.Image.ChooseFromLibrary',
			Remove: () => 'ProductGroup.Image.Remove',
			LibraryPickerTitle: () => 'ProductGroup.Image.LibraryPickerTitle',
			LibraryPickerEmpty: () => 'ProductGroup.Image.LibraryPickerEmpty',
			LibraryPickerAllAttached: () => 'ProductGroup.Image.LibraryPickerAllAttached',
			SetSuccessToast: () => 'ProductGroup.Image.SetSuccessToast',
			RemoveSuccessToast: () => 'ProductGroup.Image.RemoveSuccessToast',
			UploadFailedToast: () => 'ProductGroup.Image.UploadFailedToast'
		},
		Products: {
			Title: () => 'ProductGroup.Products.Title',
			NoProducts: () => 'ProductGroup.Products.NoProducts',
			Add: {
				Title: () => 'ProductGroup.Products.Add.Title',
				Label: () => 'ProductGroup.Products.Add.Label',
				Placeholder: () => 'ProductGroup.Products.Add.Placeholder',
				SuccessToast: () => 'ProductGroup.Products.Add.SuccessToast',
				NoProducts: () => 'ProductGroup.Products.Add.NoProducts'
			}
		},
		Fees: {
			Title: () => 'ProductGroup.Fees.Title',
			AddFee: () => 'ProductGroup.Fees.AddFee',
			NoFees: () => 'ProductGroup.Fees.NoFees',
			Delete: {
				Title: () => 'ProductGroup.Fees.Delete.Title',
				Description: () => 'ProductGroup.Fees.Delete.Description'
			},
			Create: {
				Title: () => 'ProductGroup.Fees.Create.Title',
				Pricing: () => 'ProductGroup.Fees.Create.Pricing',
				SuccessToast: () => 'ProductGroup.Fees.Create.SuccessToast',
				NoPrices: () => 'ProductGroup.Fees.Create.NoPrices'
			},
			Edit: {
				Title: () => 'ProductGroup.Fees.Edit.Title',
				SuccessToast: () => 'ProductGroup.Fees.Edit.SuccessToast'
			}
		}
	},
	GiftCards: {
		Title: () => 'GiftCards.Title',
		Status: () => 'GiftCards.Status',
		EditTitle: () => 'GiftCards.EditTitle',
		EditSuccess: () => 'GiftCards.EditSuccess',
		DeleteSuccess: () => 'GiftCards.DeleteSuccess',
		Delete: {
			Title: () => 'GiftCards.Delete.Title',
			Description: () => 'GiftCards.Delete.Description'
		},
		Column: {
			Name: () => 'GiftCards.Column.Name',
			Code: () => 'GiftCards.Column.Code',
			Amount: () => 'GiftCards.Column.Amount',
			CurrencyCode: () => 'GiftCards.Column.CurrencyCode',
			Status: () => 'GiftCards.Column.Status'
		},
		Detail: {
			Title: () => 'GiftCards.Detail.Title',
			General: () => 'GiftCards.Detail.General',
			CardDetails: () => 'GiftCards.Detail.CardDetails',
			Redemptions: () => 'GiftCards.Detail.Redemptions',
			NoRedemptions: () => 'GiftCards.Detail.NoRedemptions',
			Date: () => 'GiftCards.Detail.Date',
			RedemptionStatus: () => 'GiftCards.Detail.RedemptionStatus'
		}
	},
	GiftCard: {
		Status: () => 'GiftCard.Status',
		EditTitle: () => 'GiftCard.EditTitle',
		CreateTitle: () => 'GiftCard.CreateTitle',
		Name: () => 'GiftCard.Name',
		Code: () => 'GiftCard.Code',
		Amount: () => 'GiftCard.Amount',
		CurrencyCode: () => 'GiftCard.CurrencyCode'
	},
	LoyaltyCards: {
		Title: () => 'LoyaltyCards.Title',
		EditTitle: () => 'LoyaltyCards.EditTitle',
		EditSuccess: () => 'LoyaltyCards.EditSuccess',
		DeleteSuccess: () => 'LoyaltyCards.DeleteSuccess',
		ManagedExternally: () => 'LoyaltyCards.ManagedExternally',
		Delete: {
			Title: () => 'LoyaltyCards.Delete.Title',
			Description: () => 'LoyaltyCards.Delete.Description'
		},
		Detail: {
			Title: () => 'LoyaltyCards.Detail.Title',
			CardDetails: () => 'LoyaltyCards.Detail.CardDetails',
			Customer: () => 'LoyaltyCards.Detail.Customer',
			Redemptions: () => 'LoyaltyCards.Detail.Redemptions',
			Date: () => 'LoyaltyCards.Detail.Date'
		},
		Column: {
			Name: () => 'LoyaltyCards.Column.Name',
			CardNumber: () => 'LoyaltyCards.Column.CardNumber',
			Customer: () => 'LoyaltyCards.Column.Customer',
			Status: () => 'LoyaltyCards.Column.Status',
			AvailablePoints: () => 'LoyaltyCards.Column.AvailablePoints',
			TotalPoints: () => 'LoyaltyCards.Column.TotalPoints',
			ExternalId: () => 'LoyaltyCards.Column.ExternalId',
			ExternalSource: () => 'LoyaltyCards.Column.ExternalSource',
			PointsUsed: () => 'LoyaltyCards.Column.PointsUsed',
			PointsRemaining: () => 'LoyaltyCards.Column.PointsRemaining',
			Order: () => 'LoyaltyCards.Column.Order'
		}
	},
	Inventory: {
		Title: () => 'Inventory.Title',
		Stock: () => 'Inventory.Stock',
		Suppliers: () => 'Inventory.Suppliers',
		Movements: () => 'Inventory.Movements',
		Receiving: () => 'Inventory.Receiving',
		Transfers: () => 'Inventory.Transfers',
		Reports: () => 'Inventory.Reports',
		Summary: {
			TotalSkus: () => 'Inventory.Summary.TotalSkus',
			LowStock: () => 'Inventory.Summary.LowStock',
			OutOfStock: () => 'Inventory.Summary.OutOfStock'
		},
		Column: {
			Product: () => 'Inventory.Column.Product',
			Variant: () => 'Inventory.Column.Variant',
			Sku: () => 'Inventory.Column.Sku',
			SalesChannel: () => 'Inventory.Column.SalesChannel',
			InventoryLocation: () => 'Inventory.Column.InventoryLocation',
			QuantityOnHand: () => 'Inventory.Column.QuantityOnHand',
			QuantityAfter: () => 'Inventory.Column.QuantityAfter',
			ReorderPoint: () => 'Inventory.Column.ReorderPoint',
			ReorderQuantity: () => 'Inventory.Column.ReorderQuantity',
			Status: () => 'Inventory.Column.Status',
			Type: () => 'Inventory.Column.Type',
			Delta: () => 'Inventory.Column.Delta',
			Reason: () => 'Inventory.Column.Reason',
			CreatedBy: () => 'Inventory.Column.CreatedBy',
			Ordered: () => 'Inventory.Column.Ordered',
			Received: () => 'Inventory.Column.Received',
			ReceiveNow: () => 'Inventory.Column.ReceiveNow',
			UnitCost: () => 'Inventory.Column.UnitCost',
			Quantity: () => 'Inventory.Column.Quantity',
			Lines: () => 'Inventory.Column.Lines',
			Date: () => 'Inventory.Column.Date',
			Name: () => 'Inventory.Column.Name',
			Email: () => 'Inventory.Column.Email',
			Reference: () => 'Inventory.Column.Reference',
			From: () => 'Inventory.Column.From',
			To: () => 'Inventory.Column.To',
			Supplier: () => 'Inventory.Column.Supplier',
			Currency: () => 'Inventory.Column.Currency',
			Margin: () => 'Inventory.Column.Margin',
			PurchasePrice: () => 'Inventory.Column.PurchasePrice',
			RetailPrice: () => 'Inventory.Column.RetailPrice',
			Tracked: () => 'Inventory.Column.Tracked'
		},
		Filter: {
			LowStockOnly: () => 'Inventory.Filter.LowStockOnly',
			SalesChannel: () => 'Inventory.Filter.SalesChannel',
			InventoryLocation: () => 'Inventory.Filter.InventoryLocation',
			Status: () => 'Inventory.Filter.Status',
			Type: () => 'Inventory.Filter.Type',
			AllChannels: () => 'Inventory.Filter.AllChannels',
			AllLocations: () => 'Inventory.Filter.AllLocations',
			AllStatuses: () => 'Inventory.Filter.AllStatuses',
			AllTypes: () => 'Inventory.Filter.AllTypes'
		},
		NotTracked: () => 'Inventory.NotTracked',
		ReorderSettings: () => 'Inventory.ReorderSettings',
		ViewMovements: () => 'Inventory.ViewMovements',
		Adjust: () => 'Inventory.Adjust',
		AdjustSuccess: () => 'Inventory.AdjustSuccess',
		AdjustNoChanges: () => 'Inventory.AdjustNoChanges',
		AdjustDeltaHint: () => 'Inventory.AdjustDeltaHint',
		EditProduct: () => 'Inventory.EditProduct',
		Settings: {
			Title: () => 'Inventory.Settings.Title',
			Description: () => 'Inventory.Settings.Description',
			Enabled: () => 'Inventory.Settings.Enabled',
			EnabledDescription: () => 'Inventory.Settings.EnabledDescription',
			DeductOnOrderComplete: () => 'Inventory.Settings.DeductOnOrderComplete',
			DeductOnOrderCompleteDescription: () => 'Inventory.Settings.DeductOnOrderCompleteDescription',
			BlockOversell: () => 'Inventory.Settings.BlockOversell',
			BlockOversellDescription: () => 'Inventory.Settings.BlockOversellDescription',
			RestockOnReturn: () => 'Inventory.Settings.RestockOnReturn',
			RestockOnReturnDescription: () => 'Inventory.Settings.RestockOnReturnDescription',
			HideOutOfStock: () => 'Inventory.Settings.HideOutOfStock',
			HideOutOfStockDescription: () => 'Inventory.Settings.HideOutOfStockDescription',
			Saved: () => 'Inventory.Settings.Saved',
			Locations: {
				Title: () => 'Inventory.Settings.Locations.Title',
				Description: () => 'Inventory.Settings.Locations.Description',
				Column: {
					Name: () => 'Inventory.Settings.Locations.Column.Name',
					SalesChannels: () => 'Inventory.Settings.Locations.Column.SalesChannels'
				},
				CreateTitle: () => 'Inventory.Settings.Locations.CreateTitle',
				CreateSuccess: () => 'Inventory.Settings.Locations.CreateSuccess',
				EditTitle: () => 'Inventory.Settings.Locations.EditTitle',
				EditSuccess: () => 'Inventory.Settings.Locations.EditSuccess',
				NamePlaceholder: () => 'Inventory.Settings.Locations.NamePlaceholder',
				LinkedChannels: () => 'Inventory.Settings.Locations.LinkedChannels',
				LinkedChannelsHint: () => 'Inventory.Settings.Locations.LinkedChannelsHint',
				NoLinkedChannels: () => 'Inventory.Settings.Locations.NoLinkedChannels',
				InitializeStock: () => 'Inventory.Settings.Locations.InitializeStock',
				InitializeStockDescription: () => 'Inventory.Settings.Locations.InitializeStockDescription',
				InitializeStockSuccess: () => 'Inventory.Settings.Locations.InitializeStockSuccess',
				InitializeStockProgress: () => 'Inventory.Settings.Locations.InitializeStockProgress',
				InitializeStockProgressLabel: () => 'Inventory.Settings.Locations.InitializeStockProgressLabel',
				InitializeStockError: () => 'Inventory.Settings.Locations.InitializeStockError',
				InitializeStockRetry: () => 'Inventory.Settings.Locations.InitializeStockRetry',
				AdminOnly: () => 'Inventory.Settings.Locations.AdminOnly'
			}
		},
		Status: {
			IN_STOCK: () => 'Inventory.Status.IN_STOCK',
			LOW_STOCK: () => 'Inventory.Status.LOW_STOCK',
			OUT_OF_STOCK: () => 'Inventory.Status.OUT_OF_STOCK'
		},
		MovementType: {
			ADJUSTMENT: () => 'Inventory.MovementType.ADJUSTMENT',
			RECEIPT: () => 'Inventory.MovementType.RECEIPT',
			TRANSFER_IN: () => 'Inventory.MovementType.TRANSFER_IN',
			TRANSFER_OUT: () => 'Inventory.MovementType.TRANSFER_OUT',
			ORDER_DEDUCTION: () => 'Inventory.MovementType.ORDER_DEDUCTION',
			ORDER_RETURN: () => 'Inventory.MovementType.ORDER_RETURN'
		},
		TransferStatus: {
			DRAFT: () => 'Inventory.TransferStatus.DRAFT',
			IN_TRANSIT: () => 'Inventory.TransferStatus.IN_TRANSIT',
			RECEIVED: () => 'Inventory.TransferStatus.RECEIVED',
			CANCELLED: () => 'Inventory.TransferStatus.CANCELLED'
		},
		PurchaseOrderStatus: {
			DRAFT: () => 'Inventory.PurchaseOrderStatus.DRAFT',
			ORDERED: () => 'Inventory.PurchaseOrderStatus.ORDERED',
			PARTIALLY_RECEIVED: () => 'Inventory.PurchaseOrderStatus.PARTIALLY_RECEIVED',
			RECEIVED: () => 'Inventory.PurchaseOrderStatus.RECEIVED',
			CANCELLED: () => 'Inventory.PurchaseOrderStatus.CANCELLED'
		},
		CreateSupplier: () => 'Inventory.CreateSupplier',
		EditSupplier: () => 'Inventory.EditSupplier',
		EditSupplierSuccess: () => 'Inventory.EditSupplierSuccess',
		SuppliersEmptyTitle: () => 'Inventory.SuppliersEmptyTitle',
		SuppliersEmptyDescription: () => 'Inventory.SuppliersEmptyDescription',
		CreateTransfer: () => 'Inventory.CreateTransfer',
		CreatePurchaseOrder: () => 'Inventory.CreatePurchaseOrder',
		PurchaseCurrencyHint: () => 'Inventory.PurchaseCurrencyHint',
		PurchaseCurrencyDefaultHint: () => 'Inventory.PurchaseCurrencyDefaultHint',
		PurchaseCurrencyRequired: () => 'Inventory.PurchaseCurrencyRequired',
		ShipTransfer: () => 'Inventory.ShipTransfer',
		ReceiveTransfer: () => 'Inventory.ReceiveTransfer',
		CancelTransfer: () => 'Inventory.CancelTransfer',
		Transfer: () => 'Inventory.Transfer',
		Actions: () => 'Inventory.Actions',
		ReceivePurchaseOrder: () => 'Inventory.ReceivePurchaseOrder',
		ManageSuppliers: () => 'Inventory.ManageSuppliers',
		Replenish: () => 'Inventory.Replenish',
		ReplenishSuccess: () => 'Inventory.ReplenishSuccess',
		ReplenishNone: () => 'Inventory.ReplenishNone',
		MarkOrdered: () => 'Inventory.MarkOrdered',
		CancelOrder: () => 'Inventory.CancelOrder',
		PurchaseOrder: () => 'Inventory.PurchaseOrder',
		AddLine: () => 'Inventory.AddLine',
		NoLines: () => 'Inventory.NoLines',
		SelectSalesChannel: () => 'Inventory.SelectSalesChannel',
		SupplierDialog: {
			Title: () => 'Inventory.SupplierDialog.Title',
			Preferred: () => 'Inventory.SupplierDialog.Preferred',
			SetPreferred: () => 'Inventory.SupplierDialog.SetPreferred',
			AddSupplier: () => 'Inventory.SupplierDialog.AddSupplier',
			SelectSupplier: () => 'Inventory.SupplierDialog.SelectSupplier',
			Empty: () => 'Inventory.SupplierDialog.Empty',
			NoSuppliersYet: () => 'Inventory.SupplierDialog.NoSuppliersYet',
			NoSuppliersDescription: () => 'Inventory.SupplierDialog.NoSuppliersDescription',
			CreateSupplierAction: () => 'Inventory.SupplierDialog.CreateSupplierAction',
			SupplierProductCode: () => 'Inventory.SupplierDialog.SupplierProductCode',
			UpdateSuccess: () => 'Inventory.SupplierDialog.UpdateSuccess',
			AllSuppliersLinked: () => 'Inventory.SupplierDialog.AllSuppliersLinked',
			EditPrices: () => 'Inventory.SupplierDialog.EditPrices',
			MarginUnavailable: () => 'Inventory.SupplierDialog.MarginUnavailable',
			MarginCurrencyMismatch: () => 'Inventory.SupplierDialog.MarginCurrencyMismatch',
			MarginTaxNote: () => 'Inventory.SupplierDialog.MarginTaxNote',
			PurchasePriceTaxNote: () => 'Inventory.SupplierDialog.PurchasePriceTaxNote'
		}
	},
	Companies: {
		Title: () => 'Companies.Title',
		Anonymous: () => 'Companies.Anonymous',
		CreateTitle: () => 'Companies.CreateTitle',
		CreateSuccess: () => 'Companies.CreateSuccess',
		EditTitle: () => 'Companies.EditTitle',
		EditSuccess: () => 'Companies.EditSuccess',
		UpdateSuccess: () => 'Companies.UpdateSuccess',
		Delete: {
			Title: () => 'Companies.Delete.Title',
			Description: () => 'Companies.Delete.Description'
		},
		DeleteSuccess: () => 'Companies.DeleteSuccess',
		CardCount: () => 'Companies.CardCount',
		SettlementCount: () => 'Companies.SettlementCount',
		RecentSettlements: () => 'Companies.RecentSettlements',
		Cards: {
			Title: () => 'Companies.Cards.Title'
		},
		Detail: {
			Title: () => 'Companies.Detail.Title',
			General: () => 'Companies.Detail.General',
			ContactInfo: () => 'Companies.Detail.ContactInfo',
			Cards: () => 'Companies.Detail.Cards',
			Settlements: () => 'Companies.Detail.Settlements',
			RecentSettlements: () => 'Companies.Detail.RecentSettlements',
			AssignCard: () => 'Companies.Detail.AssignCard',
			AssignCardDescription: () => 'Companies.Detail.AssignCardDescription',
			AssignCardSuccess: () => 'Companies.Detail.AssignCardSuccess',
			UnassignCard: () => 'Companies.Detail.UnassignCard',
			UnassignCardConfirm: () => 'Companies.Detail.UnassignCardConfirm',
			UnassignCardSuccess: () => 'Companies.Detail.UnassignCardSuccess',
			CardNumberPlaceholder: () => 'Companies.Detail.CardNumberPlaceholder'
		},
		Column: {
			Name: () => 'Companies.Column.Name',
			Email: () => 'Companies.Column.Email',
			Phone: () => 'Companies.Column.Phone',
			ExternalId: () => 'Companies.Column.ExternalId',
			CardCount: () => 'Companies.Column.CardCount',
			SettlementCount: () => 'Companies.Column.SettlementCount',
			CreatedAt: () => 'Companies.Column.CreatedAt'
		},
		Field: {
			Name: () => 'Companies.Field.Name',
			Email: () => 'Companies.Field.Email',
			Phone: () => 'Companies.Field.Phone',
			ExternalId: () => 'Companies.Field.ExternalId'
		},
		Create: {
			BasicInfo: () => 'Companies.Create.BasicInfo',
			Description: () => 'Companies.Create.Description',
			NamePlaceholder: () => 'Companies.Create.NamePlaceholder',
			ExternalIdPlaceholder: () => 'Companies.Create.ExternalIdPlaceholder'
		},
		Edit: {
			BasicInfo: () => 'Companies.Edit.BasicInfo',
			Description: () => 'Companies.Edit.Description',
			NamePlaceholder: () => 'Companies.Edit.NamePlaceholder',
			EmailPlaceholder: () => 'Companies.Edit.EmailPlaceholder',
			PhonePlaceholder: () => 'Companies.Edit.PhonePlaceholder',
			OrgNumberPlaceholder: () => 'Companies.Edit.OrgNumberPlaceholder',
			ExternalIdPlaceholder: () => 'Companies.Edit.ExternalIdPlaceholder'
		}
	},
	Customers: {
		Title: () => 'Customers.Title',
		UnnamedCustomer: () => 'Customers.UnnamedCustomer',
		Anonymous: () => 'Customers.Anonymous',
		CreateTitle: () => 'Customers.CreateTitle',
		CreateSuccess: () => 'Customers.CreateSuccess',
		EditTitle: () => 'Customers.EditTitle',
		UpdateSuccess: () => 'Customers.UpdateSuccess',
		Detail: {
			Title: () => 'Customers.Detail.Title',
			General: () => 'Customers.Detail.General',
			ContactInfo: () => 'Customers.Detail.ContactInfo',
			Cards: () => 'Customers.Detail.Cards',
			AssignCard: () => 'Customers.Detail.AssignCard',
			AssignCardDescription: () => 'Customers.Detail.AssignCardDescription',
			AssignCardSuccess: () => 'Customers.Detail.AssignCardSuccess',
			UnassignCard: () => 'Customers.Detail.UnassignCard',
			UnassignCardConfirm: () => 'Customers.Detail.UnassignCardConfirm',
			UnassignCardSuccess: () => 'Customers.Detail.UnassignCardSuccess',
			CardNumberPlaceholder: () => 'Customers.Detail.CardNumberPlaceholder'
		},
		Column: {
			Name: () => 'Customers.Column.Name',
			Email: () => 'Customers.Column.Email',
			Phone: () => 'Customers.Column.Phone',
			ExternalId: () => 'Customers.Column.ExternalId',
			Cards: () => 'Customers.Column.Cards'
		},
		Field: {
			FirstName: () => 'Customers.Field.FirstName',
			LastName: () => 'Customers.Field.LastName',
			Phone: () => 'Customers.Field.Phone',
			SSN: () => 'Customers.Field.SSN'
		},
		Create: {
			BasicInfo: () => 'Customers.Create.BasicInfo',
			Description: () => 'Customers.Create.Description'
		},
		Edit: {
			BasicInfo: () => 'Customers.Edit.BasicInfo',
			Description: () => 'Customers.Edit.Description',
			FirstNamePlaceholder: () => 'Customers.Edit.FirstNamePlaceholder',
			LastNamePlaceholder: () => 'Customers.Edit.LastNamePlaceholder',
			EmailPlaceholder: () => 'Customers.Edit.EmailPlaceholder',
			PhonePlaceholder: () => 'Customers.Edit.PhonePlaceholder',
			SSNPlaceholder: () => 'Customers.Edit.SSNPlaceholder',
			ExternalIdPlaceholder: () => 'Customers.Edit.ExternalIdPlaceholder'
		},
		Cards: {
			Title: () => 'Customers.Cards.Title',
			Active: () => 'Customers.Cards.Active'
		}
	},
	BusinessCards: {
		Title: () => 'BusinessCards.Title',
		CreateTitle: () => 'BusinessCards.CreateTitle',
		CreateSuccess: () => 'BusinessCards.CreateSuccess',
		EditTitle: () => 'BusinessCards.EditTitle',
		EditSuccess: () => 'BusinessCards.EditSuccess',
		DeleteSuccess: () => 'BusinessCards.DeleteSuccess',
		Create: {
			NamePlaceholder: () => 'BusinessCards.Create.NamePlaceholder',
			CardNumberPlaceholder: () => 'BusinessCards.Create.CardNumberPlaceholder',
			SelectCompany: () => 'BusinessCards.Create.SelectCompany',
			SelectCustomer: () => 'BusinessCards.Create.SelectCustomer',
			PinTitle: () => 'BusinessCards.Create.PinTitle',
			PinDescription: () => 'BusinessCards.Create.PinDescription',
			GoToCard: () => 'BusinessCards.Create.GoToCard'
		},
		Delete: {
			Title: () => 'BusinessCards.Delete.Title',
			Description: () => 'BusinessCards.Delete.Description'
		},
		Detail: {
			Title: () => 'BusinessCards.Detail.Title',
			General: () => 'BusinessCards.Detail.General',
			CardDetails: () => 'BusinessCards.Detail.CardDetails',
			Security: () => 'BusinessCards.Detail.Security',
			ResetPin: () => 'BusinessCards.Detail.ResetPin',
			ResetPinDescription: () => 'BusinessCards.Detail.ResetPinDescription',
			ResetPinSuccess: () => 'BusinessCards.Detail.ResetPinSuccess',
			NewPin: () => 'BusinessCards.Detail.NewPin',
			PinViewOnce: () => 'BusinessCards.Detail.PinViewOnce',
			Customer: () => 'BusinessCards.Detail.Customer',
			Company: () => 'BusinessCards.Detail.Company',
			DangerZone: () => 'BusinessCards.Detail.DangerZone',
			DeleteCardDescription: () => 'BusinessCards.Detail.DeleteCardDescription'
		},
		Column: {
			Name: () => 'BusinessCards.Column.Name',
			CardNumber: () => 'BusinessCards.Column.CardNumber',
			Status: () => 'BusinessCards.Column.Status',
			Customer: () => 'BusinessCards.Column.Customer',
			ExternalId: () => 'BusinessCards.Column.ExternalId',
			CreatedAt: () => 'BusinessCards.Column.CreatedAt'
		},
		Status: () => 'BusinessCards.Status'
	},
	Promotions: {
		Title: () => 'Promotions.Title',
		Group: () => 'Promotions.Group',
		Groups: () => 'Promotions.Groups',
		SelectGroups: () => 'Promotions.SelectGroups',
		Column: {
			PromotionCount: () => 'Promotions.Column.PromotionCount'
		},
		CreateTitle: () => 'Promotions.CreateTitle',
		CreateSuccess: () => 'Promotions.CreateSuccess',
		EditTitle: () => 'Promotions.EditTitle',
		UpdateSuccess: () => 'Promotions.UpdateSuccess',
		NotFound: () => 'Promotions.NotFound',
		AdvancedFilters: () => 'Promotions.AdvancedFilters',
		ManagedExternally: () => 'Promotions.ManagedExternally',
		Create: {
			ApplyToAll: () => 'Promotions.Create.ApplyToAll',
			ApplyToGroups: () => 'Promotions.Create.ApplyToGroups',
			ApplyToCategories: () => 'Promotions.Create.ApplyToCategories',
			ApplyToProducts: () => 'Promotions.Create.ApplyToProducts',
			AppliesTo: () => 'Promotions.Create.AppliesTo',
			FixedAmount: () => 'Promotions.Create.FixedAmount',
			Percentage: () => 'Promotions.Create.Percentage',
			OverridePrice: () => 'Promotions.Create.OverridePrice',
			OverridePriceHelp: () => 'Promotions.Create.OverridePriceHelp',
			IncludeFeesHelp: () => 'Promotions.Create.IncludeFeesHelp',
			OverridePriceNoChannels: () => 'Promotions.Create.OverridePriceNoChannels',
			BasicInfo: () => 'Promotions.Create.BasicInfo',
			DaysOfWeek: () => 'Promotions.Create.DaysOfWeek',
			Discount: () => 'Promotions.Create.Discount',
			DiscountAmount: () => 'Promotions.Create.DiscountAmount',
			DiscountPercentage: () => 'Promotions.Create.DiscountPercentage',
			PercentageHelp: () => 'Promotions.Create.PercentageHelp',
			ItemCount: () => 'Promotions.Create.ItemCount',
			NamePlaceholder: () => 'Promotions.Create.NamePlaceholder',
			DisplayTitle: () => 'Promotions.Create.DisplayTitle',
			DisplayTitlePlaceholder: () => 'Promotions.Create.DisplayTitlePlaceholder',
			DisplayTitleHint: () => 'Promotions.Create.DisplayTitleHint',
			ProductGroup: () => 'Promotions.Create.ProductGroup',
			ProductGroups: () => 'Promotions.Create.ProductGroups',
			SlotKind: () => 'Promotions.Create.SlotKind',
			SlotKindGroup: () => 'Promotions.Create.SlotKindGroup',
			SlotKindCategory: () => 'Promotions.Create.SlotKindCategory',
			Categories: () => 'Promotions.Create.Categories',
			Products: () => 'Promotions.Create.Products',
			CustomerEligibility: () => 'Promotions.Create.CustomerEligibility',
			CustomerEligibilityHint: () => 'Promotions.Create.CustomerEligibilityHint',
			CustomerGroups: () => 'Promotions.Create.CustomerGroups',
			SelectCustomerGroups: () => 'Promotions.Create.SelectCustomerGroups',
			Customers: () => 'Promotions.Create.Customers',
			SelectCustomers: () => 'Promotions.Create.SelectCustomers',
			PromotionType: () => 'Promotions.Create.PromotionType',
			TypeDiscount: () => 'Promotions.Create.TypeDiscount',
			TypeBundle: () => 'Promotions.Create.TypeBundle',
			TypeBuyXGetY: () => 'Promotions.Create.TypeBuyXGetY',
			BundleGroups: () => 'Promotions.Create.BundleGroups',
			BundleGroupsHelp: () => 'Promotions.Create.BundleGroupsHelp',
			QualifyingGroups: () => 'Promotions.Create.QualifyingGroups',
			QualifyingGroupsHelp: () => 'Promotions.Create.QualifyingGroupsHelp',
			BenefitGroups: () => 'Promotions.Create.BenefitGroups',
			BenefitGroupsHelp: () => 'Promotions.Create.BenefitGroupsHelp',
			AddBundleGroup: () => 'Promotions.Create.AddBundleGroup',
			Schedule: () => 'Promotions.Create.Schedule',
			AddDay: () => 'Promotions.Create.AddDay',
			SelectDays: () => 'Promotions.Create.SelectDays',
			SelectProductGroups: () => 'Promotions.Create.SelectProductGroups',
			SelectCategories: () => 'Promotions.Create.SelectCategories',
			SelectProducts: () => 'Promotions.Create.SelectProducts',
			SelectSalesChannels: () => 'Promotions.Create.SelectSalesChannels',
			SalesChannelGroups: () => 'Promotions.Create.SalesChannelGroups',
			SelectSalesChannelGroups: () => 'Promotions.Create.SelectSalesChannelGroups',
			ApplicationRule: () => 'Promotions.Create.ApplicationRule',
			Description: () => 'Promotions.Create.Description',
			Rank: () => 'Promotions.Create.Rank',
			RankHint: () => 'Promotions.Create.RankHint',
			RankInUse: () => 'Promotions.Create.RankInUse',
			SellingUnit: () => 'Promotions.Create.SellingUnit',
			SellingUnitHelp: () => 'Promotions.Create.SellingUnitHelp',
			AllUnits: () => 'Promotions.Create.AllUnits',
			BaseUnit: () => 'Promotions.Create.BaseUnit',
			Validation: {
				NameRequired: () => 'Promotions.Create.Validation.NameRequired',
				PercentageRange: () => 'Promotions.Create.Validation.PercentageRange',
				PercentageRequired: () => 'Promotions.Create.Validation.PercentageRequired',
				BundleGroupsRequired: () => 'Promotions.Create.Validation.BundleGroupsRequired',
				BenefitGroupsRequired: () => 'Promotions.Create.Validation.BenefitGroupsRequired',
				QualifyingBenefitOverlap: () => 'Promotions.Create.Validation.QualifyingBenefitOverlap',
				OverridePriceRequired: () => 'Promotions.Create.Validation.OverridePriceRequired',
				ScopeTargetsRequired: () => 'Promotions.Create.Validation.ScopeTargetsRequired',
				RankRange: () => 'Promotions.Create.Validation.RankRange'
			}
		},
		Detail: {
			SalesChannels: () => 'Promotions.Detail.SalesChannels',
			DisplayTitle: () => 'Promotions.Detail.DisplayTitle',
			StartDate: () => 'Promotions.Detail.StartDate',
			EndDate: () => 'Promotions.Detail.EndDate',
			OverridePrice: () => 'Promotions.Detail.OverridePrice',
			IncludeFees: () => 'Promotions.Detail.IncludeFees',
			ApplyToAllProducts: () => 'Promotions.Detail.ApplyToAllProducts',
			ProductGroups: () => 'Promotions.Detail.ProductGroups',
			DiscountDefinition: () => 'Promotions.Detail.DiscountDefinition',
			ApplicationRule: () => 'Promotions.Detail.ApplicationRule',
			Prices: () => 'Promotions.Detail.Prices',
			Title: () => 'Promotions.Detail.Title',
			AppliesTo: () => 'Promotions.Detail.AppliesTo',
			SellingUnit: () => 'Promotions.Detail.SellingUnit',
			CustomerEligibility: () => 'Promotions.Detail.CustomerEligibility',
			AppliesToEveryone: () => 'Promotions.Detail.AppliesToEveryone',
			DaysOfWeek: () => 'Promotions.Detail.DaysOfWeek',
			Discount: () => 'Promotions.Detail.Discount',
			DiscountType: () => 'Promotions.Detail.DiscountType',
			DiscountValue: () => 'Promotions.Detail.DiscountValue',
			Schedule: () => 'Promotions.Detail.Schedule'
		},
		Edit: {
			Description: () => 'Promotions.Edit.Description'
		},
		Delete: {
			Title: () => 'Promotions.Delete.Title',
			Description: () => 'Promotions.Delete.Description',
			SuccessToast: () => 'Promotions.Delete.SuccessToast'
		}
	},
	Promotion: {
		Title: () => 'Promotion.Title',
		CreateTitle: () => 'Promotion.CreateTitle'
	},
	Marketing: {
		Title: () => 'Marketing.Title',
		Library: () => 'Marketing.Library',
		Campaigns: () => 'Marketing.Campaigns',
		Channels: () => 'Marketing.Channels',
		Messaging: () => 'Marketing.Messaging',
		Journeys: () => 'Marketing.Journeys',
		ContentNav: () => 'Marketing.ContentNav',
		LayoutNav: () => 'Marketing.LayoutNav',
		Channel: {
			Title: () => 'Marketing.Channel.Title',
			NewChannel: () => 'Marketing.Channel.NewChannel',
			NoChannels: () => 'Marketing.Channel.NoChannels',
			NoChannelsDescription: () => 'Marketing.Channel.NoChannelsDescription',
			CampaignCount: () => 'Marketing.Channel.CampaignCount',
			SalesChannelsHint: () => 'Marketing.Channel.SalesChannelsHint',
			PublishableKeysHint: () => 'Marketing.Channel.PublishableKeysHint',
			SurfacesHint: () => 'Marketing.Channel.SurfacesHint',
			DeleteConfirm: () => 'Marketing.Channel.DeleteConfirm',
			Field: {
				Name: () => 'Marketing.Channel.Field.Name',
				NamePlaceholder: () => 'Marketing.Channel.Field.NamePlaceholder',
				Description: () => 'Marketing.Channel.Field.Description',
				DescriptionPlaceholder: () => 'Marketing.Channel.Field.DescriptionPlaceholder',
				SalesChannels: () => 'Marketing.Channel.Field.SalesChannels',
				Surfaces: () => 'Marketing.Channel.Field.Surfaces',
				SurfacesPlaceholder: () => 'Marketing.Channel.Field.SurfacesPlaceholder',
				PublishableKeys: () => 'Marketing.Channel.Field.PublishableKeys',
				PublishableKeysPlaceholder: () => 'Marketing.Channel.Field.PublishableKeysPlaceholder'
			},
			Action: {
				Create: () => 'Marketing.Channel.Action.Create',
				Save: () => 'Marketing.Channel.Action.Save',
				Delete: () => 'Marketing.Channel.Action.Delete'
			}
		},
		Campaign: {
			Title: () => 'Marketing.Campaign.Title',
			NewCampaign: () => 'Marketing.Campaign.NewCampaign',
			NoCampaigns: () => 'Marketing.Campaign.NoCampaigns',
			NoCampaignsDescription: () => 'Marketing.Campaign.NoCampaignsDescription',
			ActiveNow: () => 'Marketing.Campaign.ActiveNow',
			Scheduled: () => 'Marketing.Campaign.Scheduled',
			Draft: () => 'Marketing.Campaign.Draft',
			Ended: () => 'Marketing.Campaign.Ended',
			StatusEnum: () => 'Marketing.Campaign.StatusEnum',
			WindowStatusEnum: () => 'Marketing.Campaign.WindowStatusEnum',
			ItemTypeEnum: () => 'Marketing.Campaign.ItemTypeEnum',
			Field: {
				Name: () => 'Marketing.Campaign.Field.Name',
				NamePlaceholder: () => 'Marketing.Campaign.Field.NamePlaceholder',
				Description: () => 'Marketing.Campaign.Field.Description',
				DescriptionPlaceholder: () => 'Marketing.Campaign.Field.DescriptionPlaceholder',
				Title: () => 'Marketing.Campaign.Field.Title',
				ItemTitlePlaceholder: () => 'Marketing.Campaign.Field.ItemTitlePlaceholder',
				ApiKey: () => 'Marketing.Campaign.Field.ApiKey',
				MarketingChannel: () => 'Marketing.Campaign.Field.MarketingChannel',
				Status: () => 'Marketing.Campaign.Field.Status',
				StartsAt: () => 'Marketing.Campaign.Field.StartsAt',
				EndsAt: () => 'Marketing.Campaign.Field.EndsAt',
				EndsAtOpenEnded: () => 'Marketing.Campaign.Field.EndsAtOpenEnded',
				Rank: () => 'Marketing.Campaign.Field.Rank',
				Items: () => 'Marketing.Campaign.Field.Items'
			},
			Action: {
				Publish: () => 'Marketing.Campaign.Action.Publish',
				Unpublish: () => 'Marketing.Campaign.Action.Unpublish',
				Save: () => 'Marketing.Campaign.Action.Save',
				Delete: () => 'Marketing.Campaign.Action.Delete',
				Duplicate: () => 'Marketing.Campaign.Action.Duplicate',
				AddItem: () => 'Marketing.Campaign.Action.AddItem',
				MoveUp: () => 'Marketing.Campaign.Action.MoveUp',
				MoveDown: () => 'Marketing.Campaign.Action.MoveDown'
			},
			Validation: {
				StartsAtRequired: () => 'Marketing.Campaign.Validation.StartsAtRequired',
				EndsAtAfterStartsAt: () => 'Marketing.Campaign.Validation.EndsAtAfterStartsAt'
			},
			Item: {
				NoItems: () => 'Marketing.Campaign.Item.NoItems',
				NoItemsDescription: () => 'Marketing.Campaign.Item.NoItemsDescription'
			},
			Link: {
				TypeEnum: () => 'Marketing.Campaign.Link.TypeEnum',
				BrowserUrl: () => 'Marketing.Campaign.Link.BrowserUrl',
				DeepLink: () => 'Marketing.Campaign.Link.DeepLink',
				ImageUrl: () => 'Marketing.Campaign.Link.ImageUrl',
				ImageSource: () => 'Marketing.Campaign.Link.ImageSource',
				ImageSourceHelp: () => 'Marketing.Campaign.Link.ImageSourceHelp',
				ImageSourceEnum: () => 'Marketing.Campaign.Link.ImageSourceEnum'
			},
			Help: {
				MarketingChannel: () => 'Marketing.Campaign.Help.MarketingChannel',
				Status: () => 'Marketing.Campaign.Help.Status',
				Schedule: () => 'Marketing.Campaign.Help.Schedule',
				StartsAt: () => 'Marketing.Campaign.Help.StartsAt',
				EndsAt: () => 'Marketing.Campaign.Help.EndsAt',
				Rank: () => 'Marketing.Campaign.Help.Rank',
				Items: () => 'Marketing.Campaign.Help.Items'
			},
			Preview: {
				Title: () => 'Marketing.Campaign.Preview.Title',
				Empty: () => 'Marketing.Campaign.Preview.Empty',
				Disclaimer: () => 'Marketing.Campaign.Preview.Disclaimer'
			},
			AdvancedOptions: () => 'Marketing.Campaign.AdvancedOptions',
			BannerTypeEnum: () => 'Marketing.Campaign.BannerTypeEnum',
			BannerText: () => 'Marketing.Campaign.BannerText',
			ListImages: () => 'Marketing.Campaign.ListImages',
			AddImage: () => 'Marketing.Campaign.AddImage',
			AddImages: () => 'Marketing.Campaign.AddImages',
			AddImagesCount: () => 'Marketing.Campaign.AddImagesCount',
			ThumbnailLinkTypeEnum: () => 'Marketing.Campaign.ThumbnailLinkTypeEnum',
			JoinAbove: () => 'Marketing.Campaign.JoinAbove',
			ShowTitle: () => 'Marketing.Campaign.ShowTitle',
			ShowTitleHelp: () => 'Marketing.Campaign.ShowTitleHelp',
			ListImageShape: () => 'Marketing.Campaign.ListImageShape',
			ListImageShapeEnum: () => 'Marketing.Campaign.ListImageShapeEnum',
			ListImageSize: () => 'Marketing.Campaign.ListImageSize',
			ListImageSizeHelp: () => 'Marketing.Campaign.ListImageSizeHelp',
			ListImageSizeEnum: () => 'Marketing.Campaign.ListImageSizeEnum',
			ModalCover: () => 'Marketing.Campaign.ModalCover',
			ContainerClassName: () => 'Marketing.Campaign.ContainerClassName',
			CustomInfo: () => 'Marketing.Campaign.CustomInfo',
			TapAction: () => 'Marketing.Campaign.TapAction',
			TapActionHelp: () => 'Marketing.Campaign.TapActionHelp',
			TapActionNavigate: () => 'Marketing.Campaign.TapActionNavigate',
			TapActionBuiltIn: () => 'Marketing.Campaign.TapActionBuiltIn',
			PromotionAction: () => 'Marketing.Campaign.PromotionAction',
			PromotionActionHelp: () => 'Marketing.Campaign.PromotionActionHelp',
			PromotionActionEnum: () => 'Marketing.Campaign.PromotionActionEnum'
		},
		Placement: {
			Title: () => 'Marketing.Placement.Title',
			Help: () => 'Marketing.Placement.Help',
			Add: () => 'Marketing.Placement.Add',
			Empty: () => 'Marketing.Placement.Empty',
			Count: () => 'Marketing.Placement.Count',
			Rank: () => 'Marketing.Placement.Rank',
			RankHelp: () => 'Marketing.Placement.RankHelp',
			Delete: () => 'Marketing.Placement.Delete',
			DeleteConfirm: () => 'Marketing.Placement.DeleteConfirm'
		},
		Layout: {
			Title: () => 'Marketing.Layout.Title',
			Help: () => 'Marketing.Layout.Help',
			AddCampaignZone: () => 'Marketing.Layout.AddCampaignZone',
			CampaignZone: () => 'Marketing.Layout.CampaignZone',
			CampaignZoneHint: () => 'Marketing.Layout.CampaignZoneHint',
			DrawerHint: () => 'Marketing.Layout.DrawerHint',
			UnsavedConfirm: () => 'Marketing.Layout.UnsavedConfirm',
			PreviewModeLayout: () => 'Marketing.Layout.PreviewModeLayout',
			PreviewModeLive: () => 'Marketing.Layout.PreviewModeLive',
			LivePreviewHint: () => 'Marketing.Layout.LivePreviewHint',
			CheckoutPreviewHint: () => 'Marketing.Layout.CheckoutPreviewHint'
		},
		Content: {
			Title: () => 'Marketing.Content.Title',
			NewContent: () => 'Marketing.Content.NewContent',
			NoContent: () => 'Marketing.Content.NoContent',
			NoContentDescription: () => 'Marketing.Content.NoContentDescription',
			NoMatches: () => 'Marketing.Content.NoMatches',
			NoMatchesDescription: () => 'Marketing.Content.NoMatchesDescription',
			ClearFilters: () => 'Marketing.Content.ClearFilters',
			ChannelFilter: () => 'Marketing.Content.ChannelFilter',
			TypeOption: () => 'Marketing.Content.TypeOption',
			BlockCount: () => 'Marketing.Content.BlockCount',
			LayoutCount: () => 'Marketing.Content.LayoutCount',
			NotInLayout: () => 'Marketing.Content.NotInLayout',
			DeleteConfirm: () => 'Marketing.Content.DeleteConfirm',
			DuplicateSuccess: () => 'Marketing.Content.DuplicateSuccess',
			Blocks: () => 'Marketing.Content.Blocks',
			BlocksHelp: () => 'Marketing.Content.BlocksHelp',
			SaveDraft: () => 'Marketing.Content.SaveDraft',
			SaveAndPublish: () => 'Marketing.Content.SaveAndPublish',
			SaveSuccess: () => 'Marketing.Content.SaveSuccess',
			PublishSuccess: () => 'Marketing.Content.PublishSuccess',
			UnpublishSuccess: () => 'Marketing.Content.UnpublishSuccess',
			UnsavedChanges: () => 'Marketing.Content.UnsavedChanges',
			DraftNotice: () => 'Marketing.Content.DraftNotice',
			ExpiredTitle: () => 'Marketing.Content.ExpiredTitle',
			ExpiredNotice: () => 'Marketing.Content.ExpiredNotice',
			ExpiredSaveConfirm: () => 'Marketing.Content.ExpiredSaveConfirm',
			SaveAnyway: () => 'Marketing.Content.SaveAnyway',
			ClearEndDate: () => 'Marketing.Content.ClearEndDate',
			RunToday: () => 'Marketing.Content.RunToday',
			NewFeedContent: () => 'Marketing.Content.NewFeedContent',
			NewFeedContentHint: () => 'Marketing.Content.NewFeedContentHint',
			NewCheckoutBackground: () => 'Marketing.Content.NewCheckoutBackground',
			NewCheckoutBackgroundHint: () => 'Marketing.Content.NewCheckoutBackgroundHint',
			Format: () => 'Marketing.Content.Format',
			BackgroundImage: () => 'Marketing.Content.BackgroundImage',
			BackgroundHelp: () => 'Marketing.Content.BackgroundHelp',
			BackgroundEmpty: () => 'Marketing.Content.BackgroundEmpty'
		},
		ContentLayout: {
			Title: () => 'Marketing.ContentLayout.Title',
			Help: () => 'Marketing.ContentLayout.Help',
			SelectChannel: () => 'Marketing.ContentLayout.SelectChannel',
			NoChannels: () => 'Marketing.ContentLayout.NoChannels',
			GoToChannels: () => 'Marketing.ContentLayout.GoToChannels',
			AvailableTitle: () => 'Marketing.ContentLayout.AvailableTitle',
			NoAvailable: () => 'Marketing.ContentLayout.NoAvailable',
			InLayoutTitle: () => 'Marketing.ContentLayout.InLayoutTitle',
			Empty: () => 'Marketing.ContentLayout.Empty',
			Add: () => 'Marketing.ContentLayout.Add',
			Remove: () => 'Marketing.ContentLayout.Remove',
			Save: () => 'Marketing.ContentLayout.Save',
			Saved: () => 'Marketing.ContentLayout.Saved',
			PreviewTitle: () => 'Marketing.ContentLayout.PreviewTitle',
			SingleContentWarning: () => 'Marketing.ContentLayout.SingleContentWarning',
			CheckoutHelp: () => 'Marketing.ContentLayout.CheckoutHelp',
			AvailableBackgroundsTitle: () => 'Marketing.ContentLayout.AvailableBackgroundsTitle',
			NoBackgrounds: () => 'Marketing.ContentLayout.NoBackgrounds',
			NewBackground: () => 'Marketing.ContentLayout.NewBackground',
			NewBackgroundTitle: () => 'Marketing.ContentLayout.NewBackgroundTitle',
			NewBackgroundDescription: () => 'Marketing.ContentLayout.NewBackgroundDescription',
			NewBackgroundCreate: () => 'Marketing.ContentLayout.NewBackgroundCreate',
			NewBackgroundCreated: () => 'Marketing.ContentLayout.NewBackgroundCreated',
			WrongFormatOnCheckout: () => 'Marketing.ContentLayout.WrongFormatOnCheckout',
			WrongFormatOnFeed: () => 'Marketing.ContentLayout.WrongFormatOnFeed',
			RemoveFlaggedToSave: () => 'Marketing.ContentLayout.RemoveFlaggedToSave'
		},
		Surface: {
			Label: () => 'Marketing.Surface.Label',
			CustomerAppFeed: () => 'Marketing.Surface.CustomerAppFeed',
			CheckoutScreen: () => 'Marketing.Surface.CheckoutScreen'
		},
		ScreenState: {
			Label: () => 'Marketing.ScreenState.Label',
			Hint: () => 'Marketing.ScreenState.Hint'
		},
		CheckoutPreview: {
			BagCheckTitle: () => 'Marketing.CheckoutPreview.BagCheckTitle',
			BagCheckBody: () => 'Marketing.CheckoutPreview.BagCheckBody',
			ClearedTitle: () => 'Marketing.CheckoutPreview.ClearedTitle',
			ClearedBody: () => 'Marketing.CheckoutPreview.ClearedBody',
			Disclaimer: () => 'Marketing.CheckoutPreview.Disclaimer',
			FallbackHint: () => 'Marketing.CheckoutPreview.FallbackHint'
		},
		LibraryPage: {
			NoAssets: () => 'Marketing.LibraryPage.NoAssets',
			NoAssetsDescription: () => 'Marketing.LibraryPage.NoAssetsDescription',
			Filename: () => 'Marketing.LibraryPage.Filename',
			TableView: () => 'Marketing.LibraryPage.TableView',
			GalleryView: () => 'Marketing.LibraryPage.GalleryView',
			Upload: () => 'Marketing.LibraryPage.Upload',
			SearchFilename: () => 'Marketing.LibraryPage.SearchFilename',
			ViewFullImage: () => 'Marketing.LibraryPage.ViewFullImage',
			CopyUrl: () => 'Marketing.LibraryPage.CopyUrl',
			CopiedUrl: () => 'Marketing.LibraryPage.CopiedUrl',
			DeleteAsset: () => 'Marketing.LibraryPage.DeleteAsset',
			DeleteAssetConfirm: () => 'Marketing.LibraryPage.DeleteAssetConfirm',
			UploadAssets: () => 'Marketing.LibraryPage.UploadAssets',
			UploadDropzone: () => 'Marketing.LibraryPage.UploadDropzone',
			ChooseFiles: () => 'Marketing.LibraryPage.ChooseFiles',
			Tags: () => 'Marketing.LibraryPage.Tags',
			UsedBy: () => 'Marketing.LibraryPage.UsedBy',
			UsageFilter: () => 'Marketing.LibraryPage.UsageFilter',
			UsageUnused: () => 'Marketing.LibraryPage.UsageUnused',
			UsageProduct: () => 'Marketing.LibraryPage.UsageProduct',
			UsageProductGroup: () => 'Marketing.LibraryPage.UsageProductGroup',
			UsageProductCategory: () => 'Marketing.LibraryPage.UsageProductCategory',
			UsageMarketingContent: () => 'Marketing.LibraryPage.UsageMarketingContent',
			UsageFeedLayout: () => 'Marketing.LibraryPage.UsageFeedLayout',
			ChannelFilter: () => 'Marketing.LibraryPage.ChannelFilter',
			ContentFilter: () => 'Marketing.LibraryPage.ContentFilter',
			ChannelNone: () => 'Marketing.LibraryPage.ChannelNone',
			ContentNone: () => 'Marketing.LibraryPage.ContentNone',
			TagsPlaceholder: () => 'Marketing.LibraryPage.TagsPlaceholder',
			Uploading: () => 'Marketing.LibraryPage.Uploading',
			EditTags: () => 'Marketing.LibraryPage.EditTags',
			NoTags: () => 'Marketing.LibraryPage.NoTags',
			ManageTags: () => 'Marketing.LibraryPage.ManageTags',
			ManageTagsEmpty: () => 'Marketing.LibraryPage.ManageTagsEmpty',
			ManageTagsAssetCount: () => 'Marketing.LibraryPage.ManageTagsAssetCount',
			CreateTag: () => 'Marketing.LibraryPage.CreateTag',
			CreateTagPlaceholder: () => 'Marketing.LibraryPage.CreateTagPlaceholder',
			CreateTagSuccess: () => 'Marketing.LibraryPage.CreateTagSuccess',
			RenameTag: () => 'Marketing.LibraryPage.RenameTag',
			RenameTagMergeConfirm: () => 'Marketing.LibraryPage.RenameTagMergeConfirm',
			RenameTagSuccess: () => 'Marketing.LibraryPage.RenameTagSuccess',
			RemoveTagConfirm: () => 'Marketing.LibraryPage.RemoveTagConfirm',
			RemoveTagSuccess: () => 'Marketing.LibraryPage.RemoveTagSuccess'
		}
	},
	Settings: {
		Title: () => 'Settings.Title',
		Sidebar: {
			Profile: () => 'Settings.Sidebar.Profile',
			Store: () => 'Settings.Sidebar.Store',
			Users: () => 'Settings.Sidebar.Users',
			SalesChannels: () => 'Settings.Sidebar.SalesChannels',
			PointOfSale: () => 'Settings.Sidebar.PointOfSale',
			ProductGroups: () => 'Settings.Sidebar.ProductGroups',
			Exports: () => 'Settings.Sidebar.Exports',
			Analytics: () => 'Settings.Sidebar.Analytics',
			Companies: () => 'Settings.Sidebar.Companies',
			CompanyCards: () => 'Settings.Sidebar.CompanyCards',
			Settlements: () => 'Settings.Sidebar.Settlements'
		},
		Profile: {
			Title: () => 'Settings.Profile.Title',
			EditTitle: () => 'Settings.Profile.EditTitle',
			PersonalInfo: () => 'Settings.Profile.PersonalInfo',
			Preferences: () => 'Settings.Profile.Preferences',
			NamePlaceholder: () => 'Settings.Profile.NamePlaceholder',
			EmailPlaceholder: () => 'Settings.Profile.EmailPlaceholder',
			UpdateSuccess: () => 'Settings.Profile.UpdateSuccess',
			Edit: {
				Description: () => 'Settings.Profile.Edit.Description'
			}
		},
		Users: {
			Title: () => 'Settings.Users.Title',
			InviteUser: () => 'Settings.Users.InviteUser',
			InviteTitle: () => 'Settings.Users.InviteTitle',
			InviteSuccess: () => 'Settings.Users.InviteSuccess',
			InviteSentTo: () => 'Settings.Users.InviteSentTo',
			SendInvite: () => 'Settings.Users.SendInvite',
			CopyInviteLink: () => 'Settings.Users.CopyInviteLink',
			DeleteUserDescription: () => 'Settings.Users.DeleteUserDescription',
			DeleteUserSuccess: () => 'Settings.Users.DeleteUserSuccess',
			EditTitle: () => 'Settings.Users.EditTitle',
			EditSuccess: () => 'Settings.Users.EditSuccess',
			DeleteInviteDescription: () => 'Settings.Users.DeleteInviteDescription',
			DeleteInviteSuccess: () => 'Settings.Users.DeleteInviteSuccess',
			Status: {
				Accepted: () => 'Settings.Users.Status.Accepted',
				Pending: () => 'Settings.Users.Status.Pending',
				Expired: () => 'Settings.Users.Status.Expired'
			},
			Type: {
				User: () => 'Settings.Users.Type.User',
				Invite: () => 'Settings.Users.Type.Invite'
			},
			Column: {
				Type: () => 'Settings.Users.Column.Type'
			},
			Role: {
				Admin: () => 'Settings.Users.Role.Admin',
				User: () => 'Settings.Users.Role.User'
			},
			Invite: {
				Description: () => 'Settings.Users.Invite.Description',
				EmailPlaceholder: () => 'Settings.Users.Invite.EmailPlaceholder',
				NamePlaceholder: () => 'Settings.Users.Invite.NamePlaceholder',
				UserInfo: () => 'Settings.Users.Invite.UserInfo',
				UserAlreadyExists: () => 'Settings.Users.Invite.UserAlreadyExists'
			},
			Detail: {
				Title: () => 'Settings.Users.Detail.Title',
				AdminOnly: () => 'Settings.Users.Detail.AdminOnly'
			},
			SignInCredentials: {
				Title: () => 'Settings.Users.SignInCredentials.Title',
				Description: () => 'Settings.Users.SignInCredentials.Description',
				SignInId: () => 'Settings.Users.SignInCredentials.SignInId',
				SignInIdPlaceholder: () => 'Settings.Users.SignInCredentials.SignInIdPlaceholder',
				SignInIdHint: () => 'Settings.Users.SignInCredentials.SignInIdHint',
				Pin: () => 'Settings.Users.SignInCredentials.Pin',
				PinSet: () => 'Settings.Users.SignInCredentials.PinSet',
				PinNotSet: () => 'Settings.Users.SignInCredentials.PinNotSet',
				NewPin: () => 'Settings.Users.SignInCredentials.NewPin',
				PinPlaceholder: () => 'Settings.Users.SignInCredentials.PinPlaceholder',
				ClearPin: () => 'Settings.Users.SignInCredentials.ClearPin',
				Save: () => 'Settings.Users.SignInCredentials.Save',
				SaveSuccess: () => 'Settings.Users.SignInCredentials.SaveSuccess',
				SignInIdNumeric: () => 'Settings.Users.SignInCredentials.SignInIdNumeric',
				SignInIdTaken: () => 'Settings.Users.SignInCredentials.SignInIdTaken',
				PinInvalid: () => 'Settings.Users.SignInCredentials.PinInvalid'
			}
		},
		SalesChannels: {
			Title: () => 'Settings.SalesChannels.Title',
			CreateTitle: () => 'Settings.SalesChannels.CreateTitle',
			CreateSuccess: () => 'Settings.SalesChannels.CreateSuccess',
			EditTitle: () => 'Settings.SalesChannels.EditTitle',
			EditSuccess: () => 'Settings.SalesChannels.EditSuccess',
			Column: {
				CountryCode: () => 'Settings.SalesChannels.Column.CountryCode',
				CurrencyCode: () => 'Settings.SalesChannels.Column.CurrencyCode',
				SalesChannelType: () => 'Settings.SalesChannels.Column.SalesChannelType',
				FulfillmentProvider: () => 'Settings.SalesChannels.Column.FulfillmentProvider',
				AccessKeys: () => 'Settings.SalesChannels.Column.AccessKeys',
				InventoryLocation: () => 'Settings.SalesChannels.Column.InventoryLocation',
				Group: () => 'Settings.SalesChannels.Column.Group'
			},
			InventoryLocationNone: () => 'Settings.SalesChannels.InventoryLocationNone',
			InventoryLocationOptionalHint: () => 'Settings.SalesChannels.InventoryLocationOptionalHint',
			SalesChannelTypeNone: () => 'Settings.SalesChannels.SalesChannelTypeNone',
			GroupNone: () => 'Settings.SalesChannels.GroupNone',
			GroupOptionalHint: () => 'Settings.SalesChannels.GroupOptionalHint',
			Advanced: () => 'Settings.SalesChannels.Advanced',
			TypeOptionalHint: () => 'Settings.SalesChannels.TypeOptionalHint',
			StorefrontUrl: () => 'Settings.SalesChannels.StorefrontUrl',
			StorefrontUrlHint: () => 'Settings.SalesChannels.StorefrontUrlHint',
			Groups: {
				Title: () => 'Settings.SalesChannels.Groups.Title',
				NavLabel: () => 'Settings.SalesChannels.Groups.NavLabel',
				CreateTitle: () => 'Settings.SalesChannels.Groups.CreateTitle',
				CreateSuccess: () => 'Settings.SalesChannels.Groups.CreateSuccess',
				EditTitle: () => 'Settings.SalesChannels.Groups.EditTitle',
				EditSuccess: () => 'Settings.SalesChannels.Groups.EditSuccess',
				NamePlaceholder: () => 'Settings.SalesChannels.Groups.NamePlaceholder',
				Column: {
					Name: () => 'Settings.SalesChannels.Groups.Column.Name',
					MemberCount: () => 'Settings.SalesChannels.Groups.Column.MemberCount'
				},
				Members: {
					Title: () => 'Settings.SalesChannels.Groups.Members.Title',
					Label: () => 'Settings.SalesChannels.Groups.Members.Label',
					Placeholder: () => 'Settings.SalesChannels.Groups.Members.Placeholder',
					Empty: () => 'Settings.SalesChannels.Groups.Members.Empty',
					Assigned: () => 'Settings.SalesChannels.Groups.Members.Assigned',
					FilterUnassigned: () => 'Settings.SalesChannels.Groups.Members.FilterUnassigned',
					SaveSuccess: () => 'Settings.SalesChannels.Groups.Members.SaveSuccess',
					MoveWarning: {
						Title: () => 'Settings.SalesChannels.Groups.Members.MoveWarning.Title',
						Description: () => 'Settings.SalesChannels.Groups.Members.MoveWarning.Description'
					}
				},
				Delete: {
					Title: () => 'Settings.SalesChannels.Groups.Delete.Title',
					Description: () => 'Settings.SalesChannels.Groups.Delete.Description',
					SuccessToast: () => 'Settings.SalesChannels.Groups.Delete.SuccessToast'
				}
			},
			Create: {
				BasicInfo: () => 'Settings.SalesChannels.Create.BasicInfo',
				Description: () => 'Settings.SalesChannels.Create.Description',
				NamePlaceholder: () => 'Settings.SalesChannels.Create.NamePlaceholder'
			},
			Edit: {
				ApiNotAvailable: () => 'Settings.SalesChannels.Edit.ApiNotAvailable',
				NotImplemented: () => 'Settings.SalesChannels.Edit.NotImplemented'
			},
			Detail: {
				Title: () => 'Settings.SalesChannels.Detail.Title',
				AccessKeys: () => 'Settings.SalesChannels.Detail.AccessKeys',
				CreateAccessKey: () => 'Settings.SalesChannels.Detail.CreateAccessKey',
				CreateAccessKeySuccess: () => 'Settings.SalesChannels.Detail.CreateAccessKeySuccess',
				PointOfSales: () => 'Settings.SalesChannels.Detail.PointOfSales',
				PointOfSalesDescription: () => 'Settings.SalesChannels.Detail.PointOfSalesDescription'
			},
			AccessKeyType: {
				Title: () => 'Settings.SalesChannels.AccessKeyType.Title',
				Publishable: () => 'Settings.SalesChannels.AccessKeyType.Publishable',
				PublishableDescription: () => 'Settings.SalesChannels.AccessKeyType.PublishableDescription',
				Api: () => 'Settings.SalesChannels.AccessKeyType.Api',
				ApiDescription: () => 'Settings.SalesChannels.AccessKeyType.ApiDescription'
			},
			TokenCreated: {
				Title: () => 'Settings.SalesChannels.TokenCreated.Title',
				Description: () => 'Settings.SalesChannels.TokenCreated.Description',
				Token: () => 'Settings.SalesChannels.TokenCreated.Token'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Settings.SalesChannels.AccessKeys.Column.Key'
				}
			}
		},
		AccessKeys: {
			Title: () => 'Settings.AccessKeys.Title',
			NavLabel: () => 'Settings.AccessKeys.NavLabel',
			Manage: () => 'Settings.AccessKeys.Manage',
			Create: () => 'Settings.AccessKeys.Create',
			EditTitle: () => 'Settings.AccessKeys.EditTitle',
			None: () => 'Settings.AccessKeys.None',
			SaveSuccess: () => 'Settings.AccessKeys.SaveSuccess',
			DeleteConfirm: () => 'Settings.AccessKeys.DeleteConfirm',
			DeleteSuccess: () => 'Settings.AccessKeys.DeleteSuccess',
			Column: {
				Key: () => 'Settings.AccessKeys.Column.Key',
				SalesChannels: () => 'Settings.AccessKeys.Column.SalesChannels',
				MarketingChannel: () => 'Settings.AccessKeys.Column.MarketingChannel'
			},
			Empty: {
				Title: () => 'Settings.AccessKeys.Empty.Title',
				Description: () => 'Settings.AccessKeys.Empty.Description'
			},
			Field: {
				SalesChannels: () => 'Settings.AccessKeys.Field.SalesChannels',
				SalesChannelsPlaceholder: () => 'Settings.AccessKeys.Field.SalesChannelsPlaceholder',
				SalesChannelsRequired: () => 'Settings.AccessKeys.Field.SalesChannelsRequired',
				MarketingChannel: () => 'Settings.AccessKeys.Field.MarketingChannel',
				MarketingChannelPlaceholder: () => 'Settings.AccessKeys.Field.MarketingChannelPlaceholder',
				DevelopmentMode: () => 'Settings.AccessKeys.Field.DevelopmentMode',
				DevelopmentModeHint: () => 'Settings.AccessKeys.Field.DevelopmentModeHint'
			}
		},
		SalesChannelTypes: {
			Title: () => 'Settings.SalesChannelTypes.Title',
			NavLabel: () => 'Settings.SalesChannelTypes.NavLabel',
			CreateTitle: () => 'Settings.SalesChannelTypes.CreateTitle',
			CreateSuccess: () => 'Settings.SalesChannelTypes.CreateSuccess',
			EditTitle: () => 'Settings.SalesChannelTypes.EditTitle',
			EditSuccess: () => 'Settings.SalesChannelTypes.EditSuccess',
			Column: {
				FulfillmentProvider: () => 'Settings.SalesChannelTypes.Column.FulfillmentProvider',
				PreauthorizationAmount: () => 'Settings.SalesChannelTypes.Column.PreauthorizationAmount',
				AllowCompletingUnderpaidOrders: () => 'Settings.SalesChannelTypes.Column.AllowCompletingUnderpaidOrders'
			},
			FulfillmentProviderNone: () => 'Settings.SalesChannelTypes.FulfillmentProviderNone',
			InvalidPreauthorizationAmount: () => 'Settings.SalesChannelTypes.InvalidPreauthorizationAmount',
			AllowCompletingUnderpaidOrdersHint: () => 'Settings.SalesChannelTypes.AllowCompletingUnderpaidOrdersHint',
			Create: {
				NamePlaceholder: () => 'Settings.SalesChannelTypes.Create.NamePlaceholder'
			}
		},
		UnitsOfMeasure: {
			Title: () => 'Settings.UnitsOfMeasure.Title',
			NavLabel: () => 'Settings.UnitsOfMeasure.NavLabel',
			Description: () => 'Settings.UnitsOfMeasure.Description',
			CreateTitle: () => 'Settings.UnitsOfMeasure.CreateTitle',
			CreateSuccess: () => 'Settings.UnitsOfMeasure.CreateSuccess',
			EditTitle: () => 'Settings.UnitsOfMeasure.EditTitle',
			EditSuccess: () => 'Settings.UnitsOfMeasure.EditSuccess',
			Column: {
				Code: () => 'Settings.UnitsOfMeasure.Column.Code',
				Name: () => 'Settings.UnitsOfMeasure.Column.Name',
				Quantity: () => 'Settings.UnitsOfMeasure.Column.Quantity',
				Default: () => 'Settings.UnitsOfMeasure.Column.Default'
			},
			Code: () => 'Settings.UnitsOfMeasure.Code',
			Name: () => 'Settings.UnitsOfMeasure.Name',
			Quantity: () => 'Settings.UnitsOfMeasure.Quantity',
			QuantityHint: () => 'Settings.UnitsOfMeasure.QuantityHint',
			DefaultEach: () => 'Settings.UnitsOfMeasure.DefaultEach',
			DefaultWeight: () => 'Settings.UnitsOfMeasure.DefaultWeight',
			DefaultEachBadge: () => 'Settings.UnitsOfMeasure.DefaultEachBadge',
			DefaultWeightBadge: () => 'Settings.UnitsOfMeasure.DefaultWeightBadge',
			CodePlaceholder: () => 'Settings.UnitsOfMeasure.CodePlaceholder',
			NamePlaceholder: () => 'Settings.UnitsOfMeasure.NamePlaceholder',
			ManagedBySync: () => 'Settings.UnitsOfMeasure.ManagedBySync',
			ManagedBySyncHint: () => 'Settings.UnitsOfMeasure.ManagedBySyncHint',
			InvalidCode: () => 'Settings.UnitsOfMeasure.InvalidCode',
			InvalidQuantity: () => 'Settings.UnitsOfMeasure.InvalidQuantity',
			InUse: () => 'Settings.UnitsOfMeasure.InUse',
			Delete: {
				Title: () => 'Settings.UnitsOfMeasure.Delete.Title',
				Description: () => 'Settings.UnitsOfMeasure.Delete.Description'
			}
		},
		PointOfSale: {
			Title: () => 'Settings.PointOfSale.Title',
			CreateTitle: () => 'Settings.PointOfSale.CreateTitle',
			CreateSuccess: () => 'Settings.PointOfSale.CreateSuccess',
			EditTitle: () => 'Settings.PointOfSale.EditTitle',
			EditSuccess: () => 'Settings.PointOfSale.EditSuccess',
			AllowedOperatingModesLabel: () => 'Settings.PointOfSale.AllowedOperatingModesLabel',
			SelectOperatingModes: () => 'Settings.PointOfSale.SelectOperatingModes',
			OperatingMode: () => 'Settings.PointOfSale.OperatingMode',
			LogStreamLevelLabel: () => 'Settings.PointOfSale.LogStreamLevelLabel',
			LogStreamLevel: () => 'Settings.PointOfSale.LogStreamLevel',
			LogStreamIdLabel: () => 'Settings.PointOfSale.LogStreamIdLabel',
			LogStreamIdPlaceholder: () => 'Settings.PointOfSale.LogStreamIdPlaceholder',
			LogStreamIdInvalidChars: () => 'Settings.PointOfSale.LogStreamIdInvalidChars',
			LogStreamIdTooLong: () => 'Settings.PointOfSale.LogStreamIdTooLong',
			ForcedOrientationLabel: () => 'Settings.PointOfSale.ForcedOrientationLabel',
			ForcedOrientationHint: () => 'Settings.PointOfSale.ForcedOrientationHint',
			ForcedOrientationAutomatic: () => 'Settings.PointOfSale.ForcedOrientationAutomatic',
			ForcedOrientation: () => 'Settings.PointOfSale.ForcedOrientation',
			SafeAreaInsetsLabel: () => 'Settings.PointOfSale.SafeAreaInsetsLabel',
			SafeAreaInsetsHint: () => 'Settings.PointOfSale.SafeAreaInsetsHint',
			SafeAreaInsetTop: () => 'Settings.PointOfSale.SafeAreaInsetTop',
			SafeAreaInsetRight: () => 'Settings.PointOfSale.SafeAreaInsetRight',
			SafeAreaInsetBottom: () => 'Settings.PointOfSale.SafeAreaInsetBottom',
			SafeAreaInsetLeft: () => 'Settings.PointOfSale.SafeAreaInsetLeft',
			Column: {
				Identifier: () => 'Settings.PointOfSale.Column.Identifier',
				AccessKeys: () => 'Settings.PointOfSale.Column.AccessKeys',
				Group: () => 'Settings.PointOfSale.Column.Group'
			},
			GroupNone: () => 'Settings.PointOfSale.GroupNone',
			GroupOptionalHint: () => 'Settings.PointOfSale.GroupOptionalHint',
			LinkSalesChannelButton: () => 'Settings.PointOfSale.LinkSalesChannelButton',
			LinkSalesChannelTitle: () => 'Settings.PointOfSale.LinkSalesChannelTitle',
			LinkSalesChannelDescription: () => 'Settings.PointOfSale.LinkSalesChannelDescription',
			LinkSalesChannelSuccess: () => 'Settings.PointOfSale.LinkSalesChannelSuccess',
			SelectSalesChannel: () => 'Settings.PointOfSale.SelectSalesChannel',
			NoUnlinkedSalesChannels: () => 'Settings.PointOfSale.NoUnlinkedSalesChannels',
			Create: {
				BasicInfo: () => 'Settings.PointOfSale.Create.BasicInfo',
				Description: () => 'Settings.PointOfSale.Create.Description',
				NamePlaceholder: () => 'Settings.PointOfSale.Create.NamePlaceholder',
				SelectSalesChannels: () => 'Settings.PointOfSale.Create.SelectSalesChannels',
				IdentifierPlaceholder: () => 'Settings.PointOfSale.Create.IdentifierPlaceholder'
			},
			Groups: {
				Title: () => 'Settings.PointOfSale.Groups.Title',
				NavLabel: () => 'Settings.PointOfSale.Groups.NavLabel',
				CreateTitle: () => 'Settings.PointOfSale.Groups.CreateTitle',
				CreateSuccess: () => 'Settings.PointOfSale.Groups.CreateSuccess',
				EditTitle: () => 'Settings.PointOfSale.Groups.EditTitle',
				EditSuccess: () => 'Settings.PointOfSale.Groups.EditSuccess',
				NamePlaceholder: () => 'Settings.PointOfSale.Groups.NamePlaceholder',
				Column: {
					Name: () => 'Settings.PointOfSale.Groups.Column.Name',
					MemberCount: () => 'Settings.PointOfSale.Groups.Column.MemberCount'
				},
				Members: {
					Title: () => 'Settings.PointOfSale.Groups.Members.Title',
					Label: () => 'Settings.PointOfSale.Groups.Members.Label',
					Placeholder: () => 'Settings.PointOfSale.Groups.Members.Placeholder',
					Empty: () => 'Settings.PointOfSale.Groups.Members.Empty',
					Assigned: () => 'Settings.PointOfSale.Groups.Members.Assigned',
					FilterUnassigned: () => 'Settings.PointOfSale.Groups.Members.FilterUnassigned',
					SaveSuccess: () => 'Settings.PointOfSale.Groups.Members.SaveSuccess',
					MoveWarning: {
						Title: () => 'Settings.PointOfSale.Groups.Members.MoveWarning.Title',
						Description: () => 'Settings.PointOfSale.Groups.Members.MoveWarning.Description'
					}
				},
				Delete: {
					Title: () => 'Settings.PointOfSale.Groups.Delete.Title',
					Description: () => 'Settings.PointOfSale.Groups.Delete.Description',
					SuccessToast: () => 'Settings.PointOfSale.Groups.Delete.SuccessToast'
				}
			},
			Detail: {
				Title: () => 'Settings.PointOfSale.Detail.Title',
				AccessKeys: () => 'Settings.PointOfSale.Detail.AccessKeys'
			},
			AccessKeys: {
				Column: {
					Key: () => 'Settings.PointOfSale.AccessKeys.Column.Key'
				}
			},
			ProductMenu: {
				Title: () => 'Settings.PointOfSale.ProductMenu.Title',
				Description: () => 'Settings.PointOfSale.ProductMenu.Description',
				EmptyTitle: () => 'Settings.PointOfSale.ProductMenu.EmptyTitle',
				EmptyDescription: () => 'Settings.PointOfSale.ProductMenu.EmptyDescription',
				EditHeader: () => 'Settings.PointOfSale.ProductMenu.EditHeader',
				EditDescription: () => 'Settings.PointOfSale.ProductMenu.EditDescription',
				AddPlaceholder: () => 'Settings.PointOfSale.ProductMenu.AddPlaceholder',
				NoGroupsSelected: () => 'Settings.PointOfSale.ProductMenu.NoGroupsSelected',
				IconLabel: () => 'Settings.PointOfSale.ProductMenu.IconLabel',
				IconPlaceholder: () => 'Settings.PointOfSale.ProductMenu.IconPlaceholder',
				IconNone: () => 'Settings.PointOfSale.ProductMenu.IconNone',
				IconUsesImageHint: () => 'Settings.PointOfSale.ProductMenu.IconUsesImageHint',
				IconNotUsedWhenIndividual: () => 'Settings.PointOfSale.ProductMenu.IconNotUsedWhenIndividual',
				ShowIndividually: () => 'Settings.PointOfSale.ProductMenu.ShowIndividually',
				ShowIndividuallyHint: () => 'Settings.PointOfSale.ProductMenu.ShowIndividuallyHint',
				ShownIndividuallyBadge: () => 'Settings.PointOfSale.ProductMenu.ShownIndividuallyBadge',
				SaveSuccess: () => 'Settings.PointOfSale.ProductMenu.SaveSuccess',
				Icons: {
					ShoppingBag: () => 'Settings.PointOfSale.ProductMenu.Icons.ShoppingBag',
					ShoppingCart: () => 'Settings.PointOfSale.ProductMenu.Icons.ShoppingCart',
					Coffee: () => 'Settings.PointOfSale.ProductMenu.Icons.Coffee',
					CupSoda: () => 'Settings.PointOfSale.ProductMenu.Icons.CupSoda',
					Utensils: () => 'Settings.PointOfSale.ProductMenu.Icons.Utensils',
					Pizza: () => 'Settings.PointOfSale.ProductMenu.Icons.Pizza',
					Sandwich: () => 'Settings.PointOfSale.ProductMenu.Icons.Sandwich',
					IceCream: () => 'Settings.PointOfSale.ProductMenu.Icons.IceCream',
					Beer: () => 'Settings.PointOfSale.ProductMenu.Icons.Beer',
					Wine: () => 'Settings.PointOfSale.ProductMenu.Icons.Wine',
					Bakery: () => 'Settings.PointOfSale.ProductMenu.Icons.Bakery',
					Gift: () => 'Settings.PointOfSale.ProductMenu.Icons.Gift'
				}
			}
		},
		Devices: {
			Title: () => 'Settings.Devices.Title',
			NavLabel: () => 'Settings.Devices.NavLabel',
			AccessKeysEmptyTitle: () => 'Settings.Devices.AccessKeysEmptyTitle',
			AccessKeysEmptyDescription: () => 'Settings.Devices.AccessKeysEmptyDescription',
			Identifier: () => 'Settings.Devices.Identifier',
			LinkedPointOfSale: () => 'Settings.Devices.LinkedPointOfSale',
			NotLinked: () => 'Settings.Devices.NotLinked',
			MarketingChannel: () => 'Settings.Devices.MarketingChannel',
			NoMarketingChannel: () => 'Settings.Devices.NoMarketingChannel',
			MarketingChannelDescription: () => 'Settings.Devices.MarketingChannelDescription',
			OperatingModes: () => 'Settings.Devices.OperatingModes',
			StatusColumn: () => 'Settings.Devices.StatusColumn',
			AccessKeysColumn: () => 'Settings.Devices.AccessKeysColumn',
			EmptyTitle: () => 'Settings.Devices.EmptyTitle',
			EmptyDescription: () => 'Settings.Devices.EmptyDescription',
			CreateTitle: () => 'Settings.Devices.CreateTitle',
			CreateSuccess: () => 'Settings.Devices.CreateSuccess',
			EditTitle: () => 'Settings.Devices.EditTitle',
			NamePlaceholder: () => 'Settings.Devices.NamePlaceholder',
			IdentifierPlaceholder: () => 'Settings.Devices.IdentifierPlaceholder',
			UpdateSuccess: () => 'Settings.Devices.UpdateSuccess',
			DeleteButton: () => 'Settings.Devices.DeleteButton',
			DeleteConfirmTitle: () => 'Settings.Devices.DeleteConfirmTitle',
			DeleteConfirmDescription: () => 'Settings.Devices.DeleteConfirmDescription',
			DeleteSuccess: () => 'Settings.Devices.DeleteSuccess',
			LinkButton: () => 'Settings.Devices.LinkButton',
			LinkTitle: () => 'Settings.Devices.LinkTitle',
			LinkDescription: () => 'Settings.Devices.LinkDescription',
			LinkSuccess: () => 'Settings.Devices.LinkSuccess',
			SelectPointOfSale: () => 'Settings.Devices.SelectPointOfSale',
			UnlinkButton: () => 'Settings.Devices.UnlinkButton',
			UnlinkConfirmTitle: () => 'Settings.Devices.UnlinkConfirmTitle',
			UnlinkConfirmDescription: () => 'Settings.Devices.UnlinkConfirmDescription',
			UnlinkSuccess: () => 'Settings.Devices.UnlinkSuccess',
			LinkedDevicesTitle: () => 'Settings.Devices.LinkedDevicesTitle',
			LinkedDevicesEmpty: () => 'Settings.Devices.LinkedDevicesEmpty',
			LinkDeviceButton: () => 'Settings.Devices.LinkDeviceButton',
			LinkDeviceDisabledHint: () => 'Settings.Devices.LinkDeviceDisabledHint',
			PointOfSaleOccupiedOption: () => 'Settings.Devices.PointOfSaleOccupiedOption',
			LinkDeviceTitle: () => 'Settings.Devices.LinkDeviceTitle',
			LinkDeviceDescription: () => 'Settings.Devices.LinkDeviceDescription',
			SelectDevice: () => 'Settings.Devices.SelectDevice',
			NoUnlinkedDevices: () => 'Settings.Devices.NoUnlinkedDevices',
			Config: {
				Default: () => 'Settings.Devices.Config.Default',
				Enabled: () => 'Settings.Devices.Config.Enabled',
				Disabled: () => 'Settings.Devices.Config.Disabled',
				GeneralSection: () => 'Settings.Devices.Config.GeneralSection',
				ScoSection: () => 'Settings.Devices.Config.ScoSection',
				SoundsSection: () => 'Settings.Devices.Config.SoundsSection',
				LoggingSection: () => 'Settings.Devices.Config.LoggingSection',
				DisplaySection: () => 'Settings.Devices.Config.DisplaySection',
				CheckoutSection: () => 'Settings.Devices.Config.CheckoutSection',
				DefaultPaymentMethod: () => 'Settings.Devices.Config.DefaultPaymentMethod',
				ForcedOrientation: () => 'Settings.Devices.Config.ForcedOrientation',
				ForcedFormFactor: () => 'Settings.Devices.Config.ForcedFormFactor',
				Language: () => 'Settings.Devices.Config.Language',
				ShowPrinterDisconnected: () => 'Settings.Devices.Config.ShowPrinterDisconnected',
				ProductListColumns: () => 'Settings.Devices.Config.ProductListColumns',
				BrowseEnabled: () => 'Settings.Devices.Config.BrowseEnabled',
				AdjustQuantity: () => 'Settings.Devices.Config.AdjustQuantity',
				ClearCart: () => 'Settings.Devices.Config.ClearCart',
				ItemDeletion: () => 'Settings.Devices.Config.ItemDeletion',
				OrderRestart: () => 'Settings.Devices.Config.OrderRestart',
				Permission: () => 'Settings.Devices.Config.Permission',
				SplitPercentHorizontal: () => 'Settings.Devices.Config.SplitPercentHorizontal',
				SplitPercentVertical: () => 'Settings.Devices.Config.SplitPercentVertical',
				ItemAddedSound: () => 'Settings.Devices.Config.ItemAddedSound',
				ProductNotFoundSound: () => 'Settings.Devices.Config.ProductNotFoundSound',
				AddToCartFailedSound: () => 'Settings.Devices.Config.AddToCartFailedSound',
				PaymentSuccessSound: () => 'Settings.Devices.Config.PaymentSuccessSound',
				PaymentFailedSound: () => 'Settings.Devices.Config.PaymentFailedSound',
				InactivityThresholdSeconds: () => 'Settings.Devices.Config.InactivityThresholdSeconds',
				AbandonCountdownSeconds: () => 'Settings.Devices.Config.AbandonCountdownSeconds',
				CoolerReadyTimeoutSeconds: () => 'Settings.Devices.Config.CoolerReadyTimeoutSeconds',
				CheckoutModeIdleTimeoutSeconds: () => 'Settings.Devices.Config.CheckoutModeIdleTimeoutSeconds',
				CheckoutModeTheme: () => 'Settings.Devices.Config.CheckoutModeTheme',
				CheckoutModeThemeHint: () => 'Settings.Devices.Config.CheckoutModeThemeHint',
				InvalidJson: () => 'Settings.Devices.Config.InvalidJson'
			}
		},
		DeviceStatus: {
			Title: () => 'Settings.DeviceStatus.Title',
			Online: () => 'Settings.DeviceStatus.Online',
			Offline: () => 'Settings.DeviceStatus.Offline',
			NeverReported: () => 'Settings.DeviceStatus.NeverReported',
			ReportedAt: () => 'Settings.DeviceStatus.ReportedAt',
			AppVersion: () => 'Settings.DeviceStatus.AppVersion',
			DisplayRuntimeVersion: () => 'Settings.DeviceStatus.DisplayRuntimeVersion',
			ConfiguredRuntimeVersion: () => 'Settings.DeviceStatus.ConfiguredRuntimeVersion',
			Platform: () => 'Settings.DeviceStatus.Platform',
			DeviceModel: () => 'Settings.DeviceStatus.DeviceModel',
			NetworkType: () => 'Settings.DeviceStatus.NetworkType',
			UpdateChannel: () => 'Settings.DeviceStatus.UpdateChannel',
			UpdateId: () => 'Settings.DeviceStatus.UpdateId',
			UpdateCreatedAt: () => 'Settings.DeviceStatus.UpdateCreatedAt',
			UpdatePending: () => 'Settings.DeviceStatus.UpdatePending',
			OperatingMode: () => 'Settings.DeviceStatus.OperatingMode',
			Health: () => 'Settings.DeviceStatus.Health',
			PrinterConnected: () => 'Settings.DeviceStatus.PrinterConnected',
			ScannerConnected: () => 'Settings.DeviceStatus.ScannerConnected',
			PaymentTerminalReachable: () => 'Settings.DeviceStatus.PaymentTerminalReachable',
			Connected: () => 'Settings.DeviceStatus.Connected',
			Disconnected: () => 'Settings.DeviceStatus.Disconnected',
			Unknown: () => 'Settings.DeviceStatus.Unknown',
			Environment: () => 'Settings.DeviceStatus.Environment',
			RefreshButton: () => 'Settings.DeviceStatus.RefreshButton',
			RefreshSuccess: () => 'Settings.DeviceStatus.RefreshSuccess',
			PushUpdateButton: () => 'Settings.DeviceStatus.PushUpdateButton',
			PushUpdateSuccess: () => 'Settings.DeviceStatus.PushUpdateSuccess',
			RestartAppButton: () => 'Settings.DeviceStatus.RestartAppButton',
			RestartAppSuccess: () => 'Settings.DeviceStatus.RestartAppSuccess',
			RestartAppConfirmTitle: () => 'Settings.DeviceStatus.RestartAppConfirmTitle',
			RestartAppConfirmDescription: () => 'Settings.DeviceStatus.RestartAppConfirmDescription',
			LockKioskButton: () => 'Settings.DeviceStatus.LockKioskButton',
			LockKioskSuccess: () => 'Settings.DeviceStatus.LockKioskSuccess',
			LockKioskOffline: () => 'Settings.DeviceStatus.LockKioskOffline',
			LockKioskConfirmTitle: () => 'Settings.DeviceStatus.LockKioskConfirmTitle',
			LockKioskConfirmDescription: () => 'Settings.DeviceStatus.LockKioskConfirmDescription',
			UnlockKioskButton: () => 'Settings.DeviceStatus.UnlockKioskButton',
			UnlockKioskSuccess: () => 'Settings.DeviceStatus.UnlockKioskSuccess',
			UnlockKioskConfirmTitle: () => 'Settings.DeviceStatus.UnlockKioskConfirmTitle',
			UnlockKioskConfirmDescription: () => 'Settings.DeviceStatus.UnlockKioskConfirmDescription',
			PushUpdateDrawer: {
				Title: () => 'Settings.DeviceStatus.PushUpdateDrawer.Title',
				Description: () => 'Settings.DeviceStatus.PushUpdateDrawer.Description',
				ChannelLabel: () => 'Settings.DeviceStatus.PushUpdateDrawer.ChannelLabel',
				ChannelPlaceholder: () => 'Settings.DeviceStatus.PushUpdateDrawer.ChannelPlaceholder',
				Submit: () => 'Settings.DeviceStatus.PushUpdateDrawer.Submit'
			},
			Enrollment: {
				Title: () => 'Settings.DeviceStatus.Enrollment.Title',
				NotEnrolled: () => 'Settings.DeviceStatus.Enrollment.NotEnrolled',
				DeviceModel: () => 'Settings.DeviceStatus.Enrollment.DeviceModel',
				Platform: () => 'Settings.DeviceStatus.Enrollment.Platform',
				AppVersion: () => 'Settings.DeviceStatus.Enrollment.AppVersion',
				EnrolledAt: () => 'Settings.DeviceStatus.Enrollment.EnrolledAt',
				Key: () => 'Settings.DeviceStatus.Enrollment.Key',
				EnrollButton: () => 'Settings.DeviceStatus.Enrollment.EnrollButton',
				RevokeButton: () => 'Settings.DeviceStatus.Enrollment.RevokeButton',
				RevokeConfirmTitle: () => 'Settings.DeviceStatus.Enrollment.RevokeConfirmTitle',
				RevokeConfirmDescription: () => 'Settings.DeviceStatus.Enrollment.RevokeConfirmDescription',
				RevokeSuccess: () => 'Settings.DeviceStatus.Enrollment.RevokeSuccess',
				EnrollDrawer: {
					Title: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.Title',
					Description: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.Description',
					CodeLabel: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.CodeLabel',
					CodePlaceholder: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.CodePlaceholder',
					LookupButton: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.LookupButton',
					LookupError: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.LookupError',
					ConfirmTitle: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.ConfirmTitle',
					ConfirmDescriptionWithCurrent: () =>
						'Settings.DeviceStatus.Enrollment.EnrollDrawer.ConfirmDescriptionWithCurrent',
					ConfirmDescription: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.ConfirmDescription',
					Submit: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.Submit',
					EnrollSuccess: () => 'Settings.DeviceStatus.Enrollment.EnrollDrawer.EnrollSuccess'
				}
			},
			Gms: {
				Title: () => 'Settings.DeviceStatus.Gms.Title',
				ProviderEloview: () => 'Settings.DeviceStatus.Gms.ProviderEloview',
				ProviderGms: () => 'Settings.DeviceStatus.Gms.ProviderGms',
				NotEnrolled: () => 'Settings.DeviceStatus.Gms.NotEnrolled',
				EnrollButton: () => 'Settings.DeviceStatus.Gms.EnrollButton',
				EnrollSuccess: () => 'Settings.DeviceStatus.Gms.EnrollSuccess',
				DeviceName: () => 'Settings.DeviceStatus.Gms.DeviceName',
				State: () => 'Settings.DeviceStatus.Gms.State',
				AppliedState: () => 'Settings.DeviceStatus.Gms.AppliedState',
				PolicyCompliant: () => 'Settings.DeviceStatus.Gms.PolicyCompliant',
				NonComplianceReasons: () => 'Settings.DeviceStatus.Gms.NonComplianceReasons',
				LastPolicySync: () => 'Settings.DeviceStatus.Gms.LastPolicySync',
				InstalledVersionCode: () => 'Settings.DeviceStatus.Gms.InstalledVersionCode',
				MinimumVersionCode: () => 'Settings.DeviceStatus.Gms.MinimumVersionCode',
				HardwareModel: () => 'Settings.DeviceStatus.Gms.HardwareModel',
				AndroidVersion: () => 'Settings.DeviceStatus.Gms.AndroidVersion',
				NoBoundDevice: () => 'Settings.DeviceStatus.Gms.NoBoundDevice',
				Yes: () => 'Settings.DeviceStatus.Gms.Yes',
				No: () => 'Settings.DeviceStatus.Gms.No',
				VersionUnpinned: () => 'Settings.DeviceStatus.Gms.VersionUnpinned',
				ApplyVersionButton: () => 'Settings.DeviceStatus.Gms.ApplyVersionButton',
				ApplyVersionSuccess: () => 'Settings.DeviceStatus.Gms.ApplyVersionSuccess',
				WifiNetworks: () => 'Settings.DeviceStatus.Gms.WifiNetworks',
				WifiAddNetwork: () => 'Settings.DeviceStatus.Gms.WifiAddNetwork',
				WifiSsid: () => 'Settings.DeviceStatus.Gms.WifiSsid',
				WifiPassword: () => 'Settings.DeviceStatus.Gms.WifiPassword',
				WifiSecurityOpen: () => 'Settings.DeviceStatus.Gms.WifiSecurityOpen',
				WifiSecurityWpaPsk: () => 'Settings.DeviceStatus.Gms.WifiSecurityWpaPsk',
				WifiHidden: () => 'Settings.DeviceStatus.Gms.WifiHidden',
				WifiRemove: () => 'Settings.DeviceStatus.Gms.WifiRemove',
				WifiSaveSuccess: () => 'Settings.DeviceStatus.Gms.WifiSaveSuccess',
				WifiEmpty: () => 'Settings.DeviceStatus.Gms.WifiEmpty',
				WifiPasswordKeepHint: () => 'Settings.DeviceStatus.Gms.WifiPasswordKeepHint',
				PlayTrack: () => 'Settings.DeviceStatus.Gms.PlayTrack',
				TrackProduction: () => 'Settings.DeviceStatus.Gms.TrackProduction',
				ApplyTrackSuccess: () => 'Settings.DeviceStatus.Gms.ApplyTrackSuccess',
				PolicyPreset: () => 'Settings.DeviceStatus.Gms.PolicyPreset',
				ApplyPresetSuccess: () => 'Settings.DeviceStatus.Gms.ApplyPresetSuccess',
				PolicyPresets: {
					ELO: () => 'Settings.DeviceStatus.Gms.PolicyPresets.ELO',
					ZEBRA: () => 'Settings.DeviceStatus.Gms.PolicyPresets.ZEBRA',
					MANAGED_APP: () => 'Settings.DeviceStatus.Gms.PolicyPresets.MANAGED_APP',
					DEBUGGING: () => 'Settings.DeviceStatus.Gms.PolicyPresets.DEBUGGING'
				},
				RebootButton: () => 'Settings.DeviceStatus.Gms.RebootButton',
				RebootSuccess: () => 'Settings.DeviceStatus.Gms.RebootSuccess',
				RebootConfirmTitle: () => 'Settings.DeviceStatus.Gms.RebootConfirmTitle',
				RebootConfirmDescription: () => 'Settings.DeviceStatus.Gms.RebootConfirmDescription',
				UnenrollButton: () => 'Settings.DeviceStatus.Gms.UnenrollButton',
				UnenrollSuccess: () => 'Settings.DeviceStatus.Gms.UnenrollSuccess',
				UnenrollConfirmTitle: () => 'Settings.DeviceStatus.Gms.UnenrollConfirmTitle',
				UnenrollConfirmDescription: () => 'Settings.DeviceStatus.Gms.UnenrollConfirmDescription',
				PolicyOverridesLabel: () => 'Settings.DeviceStatus.Gms.PolicyOverridesLabel',
				PolicyOverridesHint: () => 'Settings.DeviceStatus.Gms.PolicyOverridesHint',
				PolicyOverridesInvalidJson: () => 'Settings.DeviceStatus.Gms.PolicyOverridesInvalidJson',
				SaveOverridesButton: () => 'Settings.DeviceStatus.Gms.SaveOverridesButton',
				ResetOverridesButton: () => 'Settings.DeviceStatus.Gms.ResetOverridesButton',
				SaveOverridesSuccess: () => 'Settings.DeviceStatus.Gms.SaveOverridesSuccess',
				EnrollDrawer: {
					Title: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.Title',
					Description: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.Description',
					WifiSsidLabel: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.WifiSsidLabel',
					WifiPasswordLabel: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.WifiPasswordLabel',
					PolicyPresetLabel: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.PolicyPresetLabel',
					Submit: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.Submit',
					QrExpiresAt: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.QrExpiresAt',
					Done: () => 'Settings.DeviceStatus.Gms.EnrollDrawer.Done'
				}
			}
		},
		Exports: {
			Title: () => 'Settings.Exports.Title',
			Description: () => 'Settings.Exports.Description',
			Export: () => 'Settings.Exports.Export',
			PricerTitle: () => 'Settings.Exports.PricerTitle',
			PricerSuccess: () => 'Settings.Exports.PricerSuccess',
			SalesChannel: () => 'Settings.Exports.SalesChannel',
			VismaTitle: () => 'Settings.Exports.VismaTitle',
			VismaSuccess: () => 'Settings.Exports.VismaSuccess',
			DigiScaleTitle: () => 'Settings.Exports.DigiScaleTitle',
			DigiScaleSuccess: () => 'Settings.Exports.DigiScaleSuccess',
			SalesChannelUUIDs: () => 'Settings.Exports.SalesChannelUUIDs',
			GroupUUIDs: () => 'Settings.Exports.GroupUUIDs',
			SAFTTitle: () => 'Settings.Exports.SAFTTitle',
			SAFTSuccess: () => 'Settings.Exports.SAFTSuccess',
			SAFTCashRegister: () => 'Settings.Exports.SAFTCashRegister',
			SAFTFinancial: () => 'Settings.Exports.SAFTFinancial'
		},
		Integrations: {
			Title: () => 'Settings.Integrations.Title',
			Description: () => 'Settings.Integrations.Description',
			Teya: {
				Name: () => 'Settings.Integrations.Teya.Name',
				Description: () => 'Settings.Integrations.Teya.Description',
				StatusConnected: () => 'Settings.Integrations.Teya.StatusConnected',
				StatusDisconnected: () => 'Settings.Integrations.Teya.StatusDisconnected',
				StatusError: () => 'Settings.Integrations.Teya.StatusError',
				Connect: () => 'Settings.Integrations.Teya.Connect',
				Reconnect: () => 'Settings.Integrations.Teya.Reconnect',
				Disconnect: () => 'Settings.Integrations.Teya.Disconnect',
				Connecting: () => 'Settings.Integrations.Teya.Connecting',
				ConnectedAt: () => 'Settings.Integrations.Teya.ConnectedAt',
				Unavailable: () => 'Settings.Integrations.Teya.Unavailable',
				ConnectSuccess: () => 'Settings.Integrations.Teya.ConnectSuccess',
				DisconnectSuccess: () => 'Settings.Integrations.Teya.DisconnectSuccess',
				DisconnectConfirm: () => 'Settings.Integrations.Teya.DisconnectConfirm',
				ConnectError: () => 'Settings.Integrations.Teya.ConnectError',
				PopupBlocked: () => 'Settings.Integrations.Teya.PopupBlocked',
				ConfigureStoreTerminals: () => 'Settings.Integrations.Teya.ConfigureStoreTerminals',
				SelectStore: () => 'Settings.Integrations.Teya.SelectStore',
				SelectTerminal: () => 'Settings.Integrations.Teya.SelectTerminal',
				SelectStoreFirst: () => 'Settings.Integrations.Teya.SelectStoreFirst',
				NoStores: () => 'Settings.Integrations.Teya.NoStores',
				NoTerminals: () => 'Settings.Integrations.Teya.NoTerminals',
				ReconnectToConfigure: () => 'Settings.Integrations.Teya.ReconnectToConfigure'
			},
			Rapyd: {
				SerialPlaceholder: () => 'Settings.Integrations.Rapyd.SerialPlaceholder',
				Register: () => 'Settings.Integrations.Rapyd.Register',
				Repair: () => 'Settings.Integrations.Rapyd.Repair',
				WaitingForPairing: () => 'Settings.Integrations.Rapyd.WaitingForPairing',
				Paired: () => 'Settings.Integrations.Rapyd.Paired',
				SerialTooShort: () => 'Settings.Integrations.Rapyd.SerialTooShort',
				RegisterError: () => 'Settings.Integrations.Rapyd.RegisterError',
				ApiKeyRequiredFirst: () => 'Settings.Integrations.Rapyd.ApiKeyRequiredFirst'
			},
			Providers: {
				teya: {
					Name: () => 'Settings.Integrations.Providers.teya.Name',
					Description: () => 'Settings.Integrations.Providers.teya.Description'
				},
				nets: {
					Name: () => 'Settings.Integrations.Providers.nets.Name',
					Description: () => 'Settings.Integrations.Providers.nets.Description'
				},
				'verifone-ecom': {
					Name: () => "Settings.Integrations.Providers.'verifone-ecom'.Name",
					Description: () => "Settings.Integrations.Providers.'verifone-ecom'.Description"
				},
				'rapyd-cloudlink': {
					Name: () => "Settings.Integrations.Providers.'rapyd-cloudlink'.Name",
					Description: () => "Settings.Integrations.Providers.'rapyd-cloudlink'.Description"
				},
				'verifone-pos-cloud': {
					Name: () => "Settings.Integrations.Providers.'verifone-pos-cloud'.Name",
					Description: () => "Settings.Integrations.Providers.'verifone-pos-cloud'.Description"
				},
				struct: {
					Name: () => 'Settings.Integrations.Providers.struct.Name',
					Description: () => 'Settings.Integrations.Providers.struct.Description'
				}
			},
			Fields: {
				storeId: () => 'Settings.Integrations.Fields.storeId',
				terminalId: () => 'Settings.Integrations.Fields.terminalId',
				eposInstanceId: () => 'Settings.Integrations.Fields.eposInstanceId',
				environment: () => 'Settings.Integrations.Fields.environment',
				merchantId: () => 'Settings.Integrations.Fields.merchantId',
				username: () => 'Settings.Integrations.Fields.username',
				password: () => 'Settings.Integrations.Fields.password',
				organizationId: () => 'Settings.Integrations.Fields.organizationId',
				entityId: () => 'Settings.Integrations.Fields.entityId',
				apiKey: () => 'Settings.Integrations.Fields.apiKey',
				apiUrl: () => 'Settings.Integrations.Fields.apiUrl',
				incomingWebhookEnabled: () => 'Settings.Integrations.Fields.incomingWebhookEnabled',
				incomingWebhookApiKey: () => 'Settings.Integrations.Fields.incomingWebhookApiKey',
				secret: () => 'Settings.Integrations.Fields.secret',
				contractId: () => 'Settings.Integrations.Fields.contractId',
				serialNumber: () => 'Settings.Integrations.Fields.serialNumber',
				deviceToken: () => 'Settings.Integrations.Fields.deviceToken',
				authMode: () => 'Settings.Integrations.Fields.authMode',
				clientId: () => 'Settings.Integrations.Fields.clientId',
				clientSecret: () => 'Settings.Integrations.Fields.clientSecret',
				tokenUrl: () => 'Settings.Integrations.Fields.tokenUrl',
				baseUrl: () => 'Settings.Integrations.Fields.baseUrl',
				poiId: () => 'Settings.Integrations.Fields.poiId',
				saleId: () => 'Settings.Integrations.Fields.saleId',
				operatorId: () => 'Settings.Integrations.Fields.operatorId',
				scope: () => 'Settings.Integrations.Fields.scope',
				siteEntityId: () => 'Settings.Integrations.Fields.siteEntityId',
				terminalSimulator: () => 'Settings.Integrations.Fields.terminalSimulator'
			},
			Config: {
				Back: () => 'Settings.Integrations.Config.Back',
				Global: () => 'Settings.Integrations.Config.Global',
				GlobalDescription: () => 'Settings.Integrations.Config.GlobalDescription',
				Overrides: () => 'Settings.Integrations.Config.Overrides',
				OverridesDescriptionSalesChannel: () => 'Settings.Integrations.Config.OverridesDescriptionSalesChannel',
				OverridesDescriptionPointOfSale: () => 'Settings.Integrations.Config.OverridesDescriptionPointOfSale',
				AddOverride: () => 'Settings.Integrations.Config.AddOverride',
				NoOverrides: () => 'Settings.Integrations.Config.NoOverrides',
				OverrideCount: () => 'Settings.Integrations.Config.OverrideCount',
				Configure: () => 'Settings.Integrations.Config.Configure',
				Save: () => 'Settings.Integrations.Config.Save',
				Saved: () => 'Settings.Integrations.Config.Saved',
				SaveError: () => 'Settings.Integrations.Config.SaveError',
				TargetSalesChannel: () => 'Settings.Integrations.Config.TargetSalesChannel',
				TargetPointOfSale: () => 'Settings.Integrations.Config.TargetPointOfSale',
				SelectTarget: () => 'Settings.Integrations.Config.SelectTarget',
				Edit: () => 'Settings.Integrations.Config.Edit',
				Delete: () => 'Settings.Integrations.Config.Delete',
				DeleteOverride: () => 'Settings.Integrations.Config.DeleteOverride',
				DeleteOverrideConfirm: () => 'Settings.Integrations.Config.DeleteOverrideConfirm',
				EditOverride: () => 'Settings.Integrations.Config.EditOverride',
				SecretSet: () => 'Settings.Integrations.Config.SecretSet',
				SecretUnset: () => 'Settings.Integrations.Config.SecretUnset',
				SecretPlaceholderSet: () => 'Settings.Integrations.Config.SecretPlaceholderSet',
				SecretPlaceholderUnset: () => 'Settings.Integrations.Config.SecretPlaceholderUnset'
			}
		},
		Billing: {
			Title: () => 'Settings.Billing.Title',
			NavLabel: () => 'Settings.Billing.NavLabel',
			Description: () => 'Settings.Billing.Description',
			EmptyTitle: () => 'Settings.Billing.EmptyTitle',
			EmptyDescription: () => 'Settings.Billing.EmptyDescription',
			EmptyContactPrefix: () => 'Settings.Billing.EmptyContactPrefix',
			EmptyContactLink: () => 'Settings.Billing.EmptyContactLink',
			EmptyContactSuffix: () => 'Settings.Billing.EmptyContactSuffix',
			PlanHeading: () => 'Settings.Billing.PlanHeading',
			Note: () => 'Settings.Billing.Note',
			PlanDetails: () => 'Settings.Billing.PlanDetails',
			AdditionalFees: () => 'Settings.Billing.AdditionalFees',
			Amount: () => 'Settings.Billing.Amount',
			Interval: () => 'Settings.Billing.Interval',
			Monthly: () => 'Settings.Billing.Monthly',
			Yearly: () => 'Settings.Billing.Yearly',
			OneTime: () => 'Settings.Billing.OneTime',
			Net: () => 'Settings.Billing.Net',
			Vat: () => 'Settings.Billing.Vat',
			VatRate: () => 'Settings.Billing.VatRate',
			Total: () => 'Settings.Billing.Total',
			TotalsHeading: () => 'Settings.Billing.TotalsHeading',
			MonthlyTotal: () => 'Settings.Billing.MonthlyTotal',
			YearlyTotal: () => 'Settings.Billing.YearlyTotal',
			OneTimeTotal: () => 'Settings.Billing.OneTimeTotal',
			AgreementHeading: () => 'Settings.Billing.AgreementHeading',
			SelfServeIntro: () => 'Settings.Billing.SelfServeIntro',
			PolicyPrivacy: () => 'Settings.Billing.PolicyPrivacy',
			PolicyTerms: () => 'Settings.Billing.PolicyTerms',
			PolicyServices: () => 'Settings.Billing.PolicyServices',
			PolicyDpa: () => 'Settings.Billing.PolicyDpa',
			PolicySupport: () => 'Settings.Billing.PolicySupport',
			PolicyEula: () => 'Settings.Billing.PolicyEula',
			EnterpriseNote: () => 'Settings.Billing.EnterpriseNote',
			EnterpriseServicesLink: () => 'Settings.Billing.EnterpriseServicesLink',
			EnterpriseRefLabel: () => 'Settings.Billing.EnterpriseRefLabel',
			StartDate: () => 'Settings.Billing.StartDate',
			Status: () => 'Settings.Billing.Status',
			StatusAccepted: () => 'Settings.Billing.StatusAccepted',
			StatusPending: () => 'Settings.Billing.StatusPending',
			AcceptedBy: () => 'Settings.Billing.AcceptedBy',
			Accept: () => 'Settings.Billing.Accept',
			AcceptConfirmTitle: () => 'Settings.Billing.AcceptConfirmTitle',
			AcceptConfirmDescription: () => 'Settings.Billing.AcceptConfirmDescription',
			AcceptConfirmAction: () => 'Settings.Billing.AcceptConfirmAction',
			AcceptSuccess: () => 'Settings.Billing.AcceptSuccess',
			AcceptError: () => 'Settings.Billing.AcceptError',
			LoadError: () => 'Settings.Billing.LoadError'
		}
	},
	PointOfSale: {
		Title: () => 'PointOfSale.Title'
	},
	Profile: {
		Title: () => 'Profile.Title'
	},
	SalesChannels: {
		Title: () => 'SalesChannels.Title'
	},
	Store: {
		Title: () => 'Store.Title'
	},
	Users: {
		Title: () => 'Users.Title'
	},
	CompanyCards: {
		Title: () => 'CompanyCards.Title',
		CreateTitle: () => 'CompanyCards.CreateTitle',
		CreateSuccess: () => 'CompanyCards.CreateSuccess',
		EditTitle: () => 'CompanyCards.EditTitle',
		UpdateSuccess: () => 'CompanyCards.UpdateSuccess',
		DeleteWarning: () => 'CompanyCards.DeleteWarning',
		Status: () => 'CompanyCards.Status',
		Column: {
			Name: () => 'CompanyCards.Column.Name',
			CardNumber: () => 'CompanyCards.Column.CardNumber',
			Status: () => 'CompanyCards.Column.Status',
			Company: () => 'CompanyCards.Column.Company',
			Customer: () => 'CompanyCards.Column.Customer',
			Employee: () => 'CompanyCards.Column.Employee',
			ExternalId: () => 'CompanyCards.Column.ExternalId',
			CreatedAt: () => 'CompanyCards.Column.CreatedAt'
		},
		Detail: {
			Title: () => 'CompanyCards.Detail.Title',
			Transactions: () => 'CompanyCards.Detail.Transactions',
			ResetPin: {
				Title: () => 'CompanyCards.Detail.ResetPin.Title',
				Description: () => 'CompanyCards.Detail.ResetPin.Description',
				Action: () => 'CompanyCards.Detail.ResetPin.Action'
			},
			ResetPinSuccess: () => 'CompanyCards.Detail.ResetPinSuccess'
		},
		Edit: {
			BasicInfo: () => 'CompanyCards.Edit.BasicInfo',
			Description: () => 'CompanyCards.Edit.Description',
			NamePlaceholder: () => 'CompanyCards.Edit.NamePlaceholder',
			SelectCompany: () => 'CompanyCards.Edit.SelectCompany',
			SelectEmployee: () => 'CompanyCards.Edit.SelectEmployee',
			ExternalIdPlaceholder: () => 'CompanyCards.Edit.ExternalIdPlaceholder'
		}
	},
	Settlements: {
		Title: () => 'Settlements.Title',
		CreateTitle: () => 'Settlements.CreateTitle',
		CreateSuccess: () => 'Settlements.CreateSuccess',
		MarkSettled: () => 'Settlements.MarkSettled',
		MarkSettledSuccess: () => 'Settlements.MarkSettledSuccess',
		Column: {
			Company: () => 'Settlements.Column.Company',
			Period: () => 'Settlements.Column.Period',
			TotalAmount: () => 'Settlements.Column.TotalAmount',
			TransactionCount: () => 'Settlements.Column.TransactionCount',
			SettledAt: () => 'Settlements.Column.SettledAt',
			CreatedAt: () => 'Settlements.Column.CreatedAt'
		},
		Detail: {
			Title: () => 'Settlements.Detail.Title',
			Transactions: () => 'Settlements.Detail.Transactions',
			Period: () => 'Settlements.Detail.Period',
			TotalAmount: () => 'Settlements.Detail.TotalAmount',
			Status: () => 'Settlements.Detail.Status',
			Settled: () => 'Settlements.Detail.Settled',
			NotSettled: () => 'Settlements.Detail.NotSettled'
		},
		Create: {
			Title: () => 'Settlements.Create.Title',
			Period: () => 'Settlements.Create.Period',
			Description: () => 'Settlements.Create.Description',
			PeriodStart: () => 'Settlements.Create.PeriodStart',
			PeriodEnd: () => 'Settlements.Create.PeriodEnd'
		}
	},
	Analytics: {
		Title: () => 'Analytics.Title',
		Overview: () => 'Analytics.Overview',
		Insights: () => 'Analytics.Insights',
		SalesAnalytics: () => 'Analytics.SalesAnalytics',
		SalesAnalyticsDescription: () => 'Analytics.SalesAnalyticsDescription',
		UserAnalytics: () => 'Analytics.UserAnalytics',
		UserAnalyticsDescription: () => 'Analytics.UserAnalyticsDescription',
		Basket: () => 'Analytics.Basket',
		ActiveUsers: () => 'Analytics.ActiveUsers',
		NewSignups: () => 'Analytics.NewSignups',
		ChurnedUsers: () => 'Analytics.ChurnedUsers',
		ActiveUsersOverTime: () => 'Analytics.ActiveUsersOverTime',
		NewSignupsOverTime: () => 'Analytics.NewSignupsOverTime',
		ChurnedUsersOverTime: () => 'Analytics.ChurnedUsersOverTime',
		DeltaNew: () => 'Analytics.DeltaNew',
		Revenue: () => 'Analytics.Revenue',
		Orders: () => 'Analytics.Orders',
		Growth: () => 'Analytics.Growth',
		TotalRevenue: () => 'Analytics.TotalRevenue',
		AverageOrderValue: () => 'Analytics.AverageOrderValue',
		Refunds: () => 'Analytics.Refunds',
		RevenueOverTime: () => 'Analytics.RevenueOverTime',
		TopProducts: () => 'Analytics.TopProducts',
		TopProductsByRevenue: () => 'Analytics.TopProductsByRevenue',
		TopProductsByQuantity: () => 'Analytics.TopProductsByQuantity',
		PaymentMethods: () => 'Analytics.PaymentMethods',
		RevenueByCategory: () => 'Analytics.RevenueByCategory',
		SalesByChannel: () => 'Analytics.SalesByChannel',
		HourlyDistribution: () => 'Analytics.HourlyDistribution',
		Day: () => 'Analytics.Day',
		Week: () => 'Analytics.Week',
		Month: () => 'Analytics.Month',
		Quarter: () => 'Analytics.Quarter',
		Year: () => 'Analytics.Year',
		NoData: () => 'Analytics.NoData',
		VsDate: () => 'Analytics.VsDate',
		VsDateRange: () => 'Analytics.VsDateRange',
		InProgress: () => 'Analytics.InProgress',
		ComparePreviousPeriod: () => 'Analytics.ComparePreviousPeriod',
		CompareSamePeriodLastYear: () => 'Analytics.CompareSamePeriodLastYear',
		CompareSpecific: {
			Day: () => 'Analytics.CompareSpecific.Day',
			Week: () => 'Analytics.CompareSpecific.Week',
			Month: () => 'Analytics.CompareSpecific.Month',
			Quarter: () => 'Analytics.CompareSpecific.Quarter',
			Year: () => 'Analytics.CompareSpecific.Year'
		},
		CompareNone: () => 'Analytics.CompareNone',
		AllChannels: () => 'Analytics.AllChannels',
		ChannelGroupOption: () => 'Analytics.ChannelGroupOption',
		CompareToChannel: () => 'Analytics.CompareToChannel',
		CompareToChannelNone: () => 'Analytics.CompareToChannelNone',
		ComparisonModePeriod: () => 'Analytics.ComparisonModePeriod',
		ComparisonModeChannel: () => 'Analytics.ComparisonModeChannel',
		CompareByPeriod: () => 'Analytics.CompareByPeriod',
		CompareByChannel: () => 'Analytics.CompareByChannel',
		PeriodLabel: () => 'Analytics.PeriodLabel',
		CompareBy: () => 'Analytics.CompareBy',
		ChannelsPageOf: () => 'Analytics.ChannelsPageOf',
		QuarterLabel: () => 'Analytics.QuarterLabel',
		JumpToPeriod: () => 'Analytics.JumpToPeriod',
		CurrentPeriod: () => 'Analytics.CurrentPeriod',
		IntervalLabel: () => 'Analytics.IntervalLabel',
		Reports: {
			Title: () => 'Analytics.Reports.Title',
			Description: () => 'Analytics.Reports.Description',
			SalesGroup: () => 'Analytics.Reports.SalesGroup',
			ViewReport: () => 'Analytics.Reports.ViewReport',
			Export: () => 'Analytics.Reports.Export',
			Rows: () => 'Analytics.Reports.Rows',
			RowsOption: {
				Hour: () => 'Analytics.Reports.RowsOption.Hour',
				Day: () => 'Analytics.Reports.RowsOption.Day',
				Week: () => 'Analytics.Reports.RowsOption.Week',
				Month: () => 'Analytics.Reports.RowsOption.Month',
				Product: () => 'Analytics.Reports.RowsOption.Product'
			},
			ColumnsPicker: () => 'Analytics.Reports.ColumnsPicker',
			GroupBy: () => 'Analytics.Reports.GroupBy',
			GroupByOption: {
				Hour: () => 'Analytics.Reports.GroupByOption.Hour',
				Day: () => 'Analytics.Reports.GroupByOption.Day',
				Week: () => 'Analytics.Reports.GroupByOption.Week',
				Month: () => 'Analytics.Reports.GroupByOption.Month'
			},
			Total: () => 'Analytics.Reports.Total',
			Revenue: {
				Title: () => 'Analytics.Reports.Revenue.Title',
				Description: () => 'Analytics.Reports.Revenue.Description'
			},
			Products: {
				Title: () => 'Analytics.Reports.Products.Title',
				Description: () => 'Analytics.Reports.Products.Description',
				FilterProducts: () => 'Analytics.Reports.Products.FilterProducts',
				GrossSalesNote: () => 'Analytics.Reports.Products.GrossSalesNote'
			},
			Columns: {
				Period: () => 'Analytics.Reports.Columns.Period',
				Orders: () => 'Analytics.Reports.Columns.Orders',
				Revenue: () => 'Analytics.Reports.Columns.Revenue',
				Refunds: () => 'Analytics.Reports.Columns.Refunds',
				AverageOrderValue: () => 'Analytics.Reports.Columns.AverageOrderValue',
				Product: () => 'Analytics.Reports.Columns.Product',
				Quantity: () => 'Analytics.Reports.Columns.Quantity',
				GrossSales: () => 'Analytics.Reports.Columns.GrossSales',
				Share: () => 'Analytics.Reports.Columns.Share'
			}
		},
		ChartLabels: {
			Revenue: () => 'Analytics.ChartLabels.Revenue',
			Orders: () => 'Analytics.ChartLabels.Orders',
			Hour: () => 'Analytics.ChartLabels.Hour',
			Quantity: () => 'Analytics.ChartLabels.Quantity'
		},
		BasketAnalysis: {
			Title: () => 'Analytics.BasketAnalysis.Title',
			Description: () => 'Analytics.BasketAnalysis.Description',
			AvgItemsPerOrder: () => 'Analytics.BasketAnalysis.AvgItemsPerOrder',
			AvgUniqueProductsPerOrder: () => 'Analytics.BasketAnalysis.AvgUniqueProductsPerOrder',
			OrdersAnalyzed: () => 'Analytics.BasketAnalysis.OrdersAnalyzed',
			ProductPairs: () => 'Analytics.BasketAnalysis.ProductPairs',
			CategoryAffinity: () => 'Analytics.BasketAnalysis.CategoryAffinity',
			AnchorProduct: () => 'Analytics.BasketAnalysis.AnchorProduct',
			AnchorProductPlaceholder: () => 'Analytics.BasketAnalysis.AnchorProductPlaceholder',
			AllProducts: () => 'Analytics.BasketAnalysis.AllProducts',
			Products: () => 'Analytics.BasketAnalysis.Products',
			ProductsPlaceholder: () => 'Analytics.BasketAnalysis.ProductsPlaceholder',
			ExcludeProductsPlaceholder: () => 'Analytics.BasketAnalysis.ExcludeProductsPlaceholder',
			AllProductsFilter: () => 'Analytics.BasketAnalysis.AllProductsFilter',
			Categories: () => 'Analytics.BasketAnalysis.Categories',
			CategoriesPlaceholder: () => 'Analytics.BasketAnalysis.CategoriesPlaceholder',
			ExcludeCategoriesPlaceholder: () => 'Analytics.BasketAnalysis.ExcludeCategoriesPlaceholder',
			AllCategoriesFilter: () => 'Analytics.BasketAnalysis.AllCategoriesFilter',
			SalesChannel: () => 'Analytics.BasketAnalysis.SalesChannel',
			AllSalesChannels: () => 'Analytics.BasketAnalysis.AllSalesChannels',
			SalesChannelsSelected: () => 'Analytics.BasketAnalysis.SalesChannelsSelected',
			SalesChannelSearchPlaceholder: () => 'Analytics.BasketAnalysis.SalesChannelSearchPlaceholder',
			PointOfSale: () => 'Analytics.BasketAnalysis.PointOfSale',
			AllPointsOfSale: () => 'Analytics.BasketAnalysis.AllPointsOfSale',
			MinSupport: () => 'Analytics.BasketAnalysis.MinSupport',
			ProductA: () => 'Analytics.BasketAnalysis.ProductA',
			ProductB: () => 'Analytics.BasketAnalysis.ProductB',
			CategoryA: () => 'Analytics.BasketAnalysis.CategoryA',
			CategoryB: () => 'Analytics.BasketAnalysis.CategoryB',
			CoOccurrence: () => 'Analytics.BasketAnalysis.CoOccurrence',
			Support: () => 'Analytics.BasketAnalysis.Support',
			Confidence: () => 'Analytics.BasketAnalysis.Confidence',
			Lift: () => 'Analytics.BasketAnalysis.Lift',
			SupportTooltip: () => 'Analytics.BasketAnalysis.SupportTooltip',
			ConfidenceTooltip: () => 'Analytics.BasketAnalysis.ConfidenceTooltip',
			LiftTooltip: () => 'Analytics.BasketAnalysis.LiftTooltip',
			NoProductPairs: () => 'Analytics.BasketAnalysis.NoProductPairs',
			NoCategoryPairs: () => 'Analytics.BasketAnalysis.NoCategoryPairs',
			NoAnchorPairs: () => 'Analytics.BasketAnalysis.NoAnchorPairs',
			MetricPercent: () => 'Analytics.BasketAnalysis.MetricPercent'
		}
	}
}

export const locales = {
	en,
	da,
	is,
	nb,
	sv
}
